module.exports={
"label_emailtocloudcc_department":`分部`,
"label.wei.weiresearch":`微投票`,
"message.error.appsecret.null":`秘鑰密碼不能為空！`,
"label.file.orderbylastmodifydate":`按上次修改日期排序`,
"label.minus":`-減`,
"label.horizontalbar":`水平條`,
"label.emailobject.emailsentfailed":`郵件發送失敗！`,
"assignedresource.check":`此服務資源已指派到此服務預約，請勿重複添加。`,
"label.finish":`完成`,
"label.document.history":`下載歷史`,
"label.customfields.number.numberLengthHelpText":`1.輸入數字的長度和小數位數。例如，輸入長度為 8，小數位數為 2，可接受的最大值位數即為12345678.90""`,
"label.standard.buttonandlink.info":`改寫標準按鈕和連結更改了CloudCC URL 以及對該URL所有調用（例如 CloudCC頁面、瀏覽器快捷方式或外部系統）的含義。您可以使用 CloudCC的自訂頁面取代標準按鈕或連結的CloudCC URL。`,
"front-epwechat-module-v1-contacts-desc":`開啟後，會在CloudCC系統內增加企業微信聯絡人物件，會將企業微信中的客戶資訊同步至該物件中`,
"label.mr.caption.contact.result":`查重合併：查詢聯絡人重複數據的結果`,
"label.ems.selectaccount":`選擇帳號`,
"label.group.no.activity":`沒有匹配的活動小組。`,
"label.call.for":`邀請人`,
"label.newreportguide":`新建報表嚮導`,
"component.telerecord.label.name":`姓名`,
"vue.add.dashboard.component":`添加{titleName}組件`,
"label.chatter.sendEmailToGroupMember.check.V":`檢視投票`,
"UG.ST.002":`確定`,
"label.setting.intergrationmanage":`整合應用管理`,
"label.field.apiname.validate":`請輸入0-6之間的一位數`,
"label.emailmerge.list.deletefolder":`刪除檔夾`,
"vue_label_pool_received":`已領取`,
"label_emailtocloudcc_step1_case1":`Email to Case`,
"message.sumlength":`長度與小數位數之和不能超出18位`,
"vue_label_approve_reassignapproval":`{name}將審批重新指派至{people}`,
"label.specify.time":`時間： 2016年06月21日 13:00`,
"vue_label_report_sortdown":`按降冪排列`,
"chatter.login.now":`正在上傳中...`,
"label.import.page2.notsuited":`未映射`,
"label.please.fill.out":`請填寫`,
"label.recordtype.edit.description":`從可用值"列表中選擇某一項，並將其添加到"所選值"列表中，以便將其作為此記錄類型的選項列表值。請注意，從選項列表中刪除某一項不會從任何現有記錄中刪除此項。最後，為該記錄類型選擇預設選項列表值"`,
"label.customer.tab.new":`新建自訂選項卡`,
"label.sameas":`同`,
"front-filter-module-v1-filter-a-week-ago":`一週前`,
"label.processsetting.disable.process.failed":`禁用進程失敗！`,
"label.summaryreport.2018.step4":`步驟4：選擇報表標準`,
"label.secrecyinfo":`保密訊息-請勿散佈`,
"label.custom.page.component.general.settings":`組件一般設置`,
"label.ccpeak.folder":`未歸檔類文件夾`,
"vue_label_homepage_select_button_operation":`選擇按鈕操作項`,
"message.pleaseinputrightdistance":`請填寫正確的間隔天數`,
"label.mobile.phone.required.short":`為必填項`,
"vue_label_account_equityseructure":`股權結構圖`,
"label.file.library.error1":`這個檔案已存在於此文件庫中。`,
"fliter.nextmonth":`下個月`,
"label.mr.descreption.oneGroupNote2":`組企業訊息，共有`,
"label.allfolderdashboard":`所有儀表板文件夾`,
"lable.opppdt.selPdt.bykeywords":`按關鍵字`,
"setup_layout_label_selectedfield":`選取欄位`,
"label.file.preview.convert.firstpage.failure":`預覽時發生錯誤，請點擊預覽詳情或下載查看`,
"vue_label_systemSettings_companie":`公司設定`,
"label.loginhis.recently":`最近登入記錄`,
"label.permission.visualpagepermission.edit":`自訂頁面分配`,
"label.ccservice.validate.email":`物件API為{0}下的{1}欄位對應值為{2} 格式有誤，請輸入正確的電子郵件地址！`,
"label.sms.companyname.gm":`創明網路簡訊接口`,
"lable.opppdt.addpdt.table.discount":`折扣(%off)`,
"Lead.Scoring.Setting.LevelSetting":`商機熱度設定`,
"message.duplication.label.duplicationremark":`是對新建或編輯記錄儲存時查詢重複數據的操作`,
"label.file.preview.error":`預覽時發生錯誤，請下載查看`,
"label.imgfield.type.input":`輸入圖片`,
"label.file.share.email.content1":`文件名稱：#filename`,
"vue_label_notice_batchedit_fail":`id為{0}的數據更新失敗，失敗原因為{1}`,
"label.reportsSubscriptionPage.schedulereport.monthly.week.four":`第四個星期`,
"label.view.sortview.printview":`列印視圖`,
"label.projectManagement.Addposttask":`添加後置工作`,
"vue_label_commonobjects_view_fail":`設定預設視圖失敗`,
"label.dayinweek":`個星期的`,
"label.layout.notexist":`配置不存在`,
"label.brief.total":`記錄{total}條`,
"label.dashboardSetup.tz.bb":`跳轉到報表`,
"label_emailtocloudcc_select3":`請選擇記錄所有人`,
"label.input.least.string":`請輸入至少 {0} 個字元`,
"label.app.step2":`步驟 2. 輸入詳細訊息`,
"lable.account.LastWeek":`上星期`,
"label.notifications":`通知`,
"label.tabpage.viewname":`視圖名稱`,
"label.knowledge.language.italian":`義大利語`,
"label.sendmail.step2.introduce":`請選擇要使用的電子郵件範本。`,
"label_enable_or_no":`按照服務區域統計`,
"pagecreator_button_save":`儲存`,
"template.chart.cplb":`產品類別`,
"label.knowledge.publish":`不符合要求不能發佈`,
"label.name.required":`名稱為必填項。`,
"component.chatter.label.myfans":`我的追蹤者`,
"label.rejectoperate":`拒絕操作`,
"label.report.action.addtodashboard3":`選擇儀表板`,
"label.icon.101":`課本`,
"label.data.exp.su.ok":`系統正在匯出`,
"label.appupload.component.type.layout":`版面配置`,
"template.chart.yscb":`預算成本`,
"label.tabularreport.selectorder":`確定各報表列的顯示排序`,
"email.title.one":`找回密碼`,
"label.case.copy.link":`複製網頁連結`,
"label.mr.descreption.oneGroupReData4":`組，還剩餘`,
"label.newprocess5.error.des":`只能輸入數字`,
"label.partnerCloud.loginButton":`登入按鈕`,
"label.interfaceconstraint.adminonly":`只有系統管理員可以使用此介面`,
"label.campaign.channel.input.date":`2.請為您的營銷渠道設置有效期:`,
"label.clientwebsiteentranceprofile":`客戶網站入口 設定檔`,
"UG.opportunity.011":`匯入交易`,
"label.page.copy.value.paste.template":`將合併欄位值複製並粘貼到以下範本。`,
"label.notselect":`未選中`,
"label.weixin.input.password":`請輸入密碼`,
"label.email.select.template":`選擇範本`,
"label_chatter_ok":`確認`,
"permissionService.error":`權限集指派失敗，請檢查應用許可是否過期或者指派達到上限`,
"label.webtocloudcc.sorry":`抱歉,網頁出現了異常，請重試或聯繫管理員！`,
"UG.opportunity.007":`聯絡人角色`,
"label.manageAll.forapproval":`待審批`,
"label.imgfield.type.ref":`公式圖片`,
"label.profile.setcustomtab":`自訂選項卡設置`,
"label.tabpage.datatyoez":`資料類型`,
"label.partnerCloud.basicSetting.editPersonal":`允許夥伴雲使用者編輯個人資訊`,
"label.mr.caption.account":`查重合併：查詢客戶重複數據的條件`,
"message.serviceterritoryMe.time.violation":`派遣時間違規:有班組成員`,
"pagecreator_page_message_publish_success":`頁面發佈成功`,
"label.field.formula.timezonetip":`注意處理日期時間類型函數的多時區支援。在公式中使用SYSDATE等系統函數來獲取當前時間時，應採用其對應的支援多時區的函數代替，例如CURRENT_DATE。`,
"label.marketseamemset.specialuser":`特殊成員`,
"label.staticresource.message":`靜態資源詳細訊息`,
"label.workflow.rulecondition":`規則條件`,
"component_salesperformance_label_nodata":`添加您的機會，然後返回此處查看業績圖。`,
"label.customfields.textarea.tip":`允許使用者輸入多行文本，最多可輸入 4000 個字元。`,
"font-evaluate-module-v1-template":``,
"label.step3.total5":`第3步，共5步`,
"label.customfields.formula.percent.tip":`計算百分比，並自動向數字添加百分號`,
"label.sortdesc":`遞減`,
"lable.PowerProcess.edit":`權利過程編輯`,
"label.dongshifang.description":`配置東時方簡訊接口訊息，滿足您組織的簡訊收發業務需求。`,
"label.chatter.addressee":`收件人`,
"vue_label_systemSettings_obj2":`對象管理器`,
"label.selectreporttype.tip":`選擇希望包括在報表中的數據類型`,
"label.version.enterprise":`企業版`,
"label.area.add":`添加區域`,
"label.h5.bookmarked":``,
"label.step5.total7":`第5步，共7步`,
"front-lightning-module-v1-title-quotation":`報價單預覽`,
"label.search.onlymyrecords":`限於我擁有的項目`,
"vue_label_commonobjects_noduplication":`與{記錄}中{欄位}重復`,
"label.customerpage.edit":`編輯自訂頁面選項卡`,
"message.please.choose.user":`請選擇使用者`,
"label.approval.his.currentactor":`當前審批人`,
"label.field.duplicate.error.msg3":`最多建立三個獨有屬性欄位`,
"label.page_url":`頁面連結`,
"label.permission.goback":`返回權限集概述`,
"vue_label_commonobjects_view_kanban_notice2":`要查看所有記錄，請使用列表或並列視圖`,
"label.group.no.recent.searchs":`沒有匹配的最近查看小組。`,
"label.event.fiducial.point":`準點`,
"label.integrations.mailchimp.addtolist":`將CloudCC中的商機和聯絡人添加到Mailchimp 收件人列表中`,
"label.workflow.configrule.introduce":`輸入規則名、備註和觸發工作流程規則的條件。在下一個步驟中，將工作流程操作與此工作流程規則關聯起來。`,
"label.icon.161":`皮箱`,
"label.recordtype.enable":`啟用`,
"label_mailboxes_limit":`信箱數量超過上限`,
"label.notification.time3":`{0}小時前`,
"label.setsharerule.step2":`第二步：選擇要共享的條件`,
"vue_label_homepage_somecomponents":`警告！添加組件後高度超出導致顯示不全，請刪除部分組件`,
"label.icon.63":`地下井`,
"label.use.standard.sharerules":`使用標準共享規則`,
"label.button.step2.select.required.field":`步驟2：選擇必填欄位`,
"lable.Confirm.collect.potential.customers":`確認領取商機{name}`,
"label.version.sum.custompage":`個自訂頁面`,
"label.file.ccchat.changefile":`更改文件`,
"label.mobile.phone.phone.call":`撥打電話`,
"label.appupload.managed.img":`受管`,
"vue_label_chatter_comment":`評論`,
"label.central.european.time":`中歐時間`,
"label.three.quarter":`第三季度`,
"label.service.newBuildDialog.filter.editor":`篩選編輯器`,
"pagecreator_systemstyle_funcpath":`/構建器/品牌化樣式庫`,
"label_chatter_collect":`收藏`,
"label.custom.page.component.window.settings":`組件視窗設置`,
"component_chatter_file_label_title":`文件上傳`,
"label.marketsea.button.discard":`廢棄`,
"label.Batch.input":`批次輸入`,
"vue_label_campaign_market_members":`現有行銷活動成員`,
"label.salescloud.salesdashboard":`銷售看板`,
"message.summaryconditionrepeated":`彙總條件重複，請重新選擇！`,
"label.tianyancha.h5.companycode":`公司代碼`,
"label.quickbooks.description":`配置QuickBooks帳號訊息，追蹤您的在線發票支付情況`,
"label.colombia.time":`哥倫比亞時間`,
"label.usermanage.unknown.license":`未知的許可證書，無法建立使用者，請聯繫系統管理員！`,
"label.operatedata.selectoperateandobject":`選擇操作(匯入或者匯出)並選擇物件`,
"message.setup.field.picklist.valuerepeated":`列表值不能出現重複，請重新輸入！`,
"label.editerror.list":`未編輯數據列表`,
"pagecreator_page_message_save_success":`頁面儲存成功`,
"label.icon.154":`電腦`,
"label.emailsync.setting":`個人信箱設定`,
"label.startuploadfile.step2":`步驟 3.單擊“開始上傳”按鈕，上傳文件`,
"label.dashboard.notmeet.conditions":`沒有符合條件的訊息，尚未配置儀表板！`,
"label.temp.del.conf":`確認要刪除嗎？`,
"label.sms.authkey":`認證密碼`,
"lable.oppt.jieduan.choosejieduan":`選擇已結束階段`,
"label.tabpage.viewNamez":`請輸入視圖名稱`,
"label.totalQuotation":`報價單總計`,
"label.tabpage.hoursagoz":`小時前`,
"label.receiveadminnews":`接收  管理員新聞簡報`,
"label.field.is.lookup":`欄位是否關聯查找欄位`,
"label.any_changes":`此一處的任何更改也將更新在下方的頁尾`,
"lable.products.to.assets":`確定將產品轉資產?`,
"label.dashboard.compare":`比較`,
"vue_label_chatter_notice1":`刪除小組後將刪除小組中的所有訊息，但不會刪除小組文件`,
"label_tabpage_exitz":`退出`,
"label.potentialcustomerflow":`商機流程`,
"label.longtext":`長文本區`,
"october":`十月`,
"label.customer.email":`信件`,
"label.partnerCloud.productSet.addChildren":`新增子級`,
"label.defaultline.cannot.greater":`預設行數不能超過30行`,
"front-detail-module-v1-view-report":`檢視報表`,
"label.knowledge.setting.hint.sixteen":`儲存知識繼續傳播`,
"label.page.use.merged.field":`使用合併欄位`,
"label.salescloud.salescloud.continuerecover":`?如果繼續，將執行刪除程序且不可恢復：`,
"front-project-module-v1-from-template-create":`從範本建立`,
"label.exportall":`匯出全部`,
"label.weixin.recalculate.shared.results":`重新計算共享規則結果`,
"label.components.isTemplate":`是否是範本資料`,
"label_emailsync_status":`使用者信箱狀態統計`,
"label.file.library.delete":`您確定要刪除 {librayrname}嗎？`,
"label.integrations.username":`使用者帳號`,
"front-lightningset-module-v1-detail-page-report-chart":`詳情頁報表圖表`,
"label_tabular":`列表式`,
"label.approverecords":`審批記錄`,
"vue_label_helpcenter_topic":`lightning版本使用與幫助`,
"label.h5.date.none":`-無-`,
"lable.outlook.mcto.allrecord":`所有記錄`,
"label.readandwrite":`讀/寫`,
"label.allfold":`全部摺疊`,
"AD":`地址`,
"message.custom.field.donotdelete.reporttype":`該欄位被報表類型所引用`,
"label.escalation.setup.newaction.title":`編輯升級操作`,
"label.dashboard.snapshot.settings":`儀表板快照設置`,
"label.attendance.inner":`內勤`,
"chatter.ns":`新消息`,
"label.validate.nowork":`錯誤：無效欄位，請重新選擇錯誤位置`,
"label.custom.EmptyCanvas":`清空畫布`,
"label.service.miniProgram.fillImageOrder":`請填寫輪播圖順序`,
"label.icon.16":`維修`,
"label.selected":`已選中`,
"component_chatter_link_label_name":`連結名稱`,
"label.reportsSubscriptionPage.schedulereport.starttime":`開始時間`,
"label.file.uploadNewVersion":`上傳新版本`,
"chatter.group.theMembership":`成員關係`,
"label.knowledge.recommended.articles":``,
"label.appupload.install.parentobj":`所屬物件`,
"label.file.recent":`最近`,
"vue_label_helpcenter_quote":`報價表示貴公司產品和服務的建議價格。您可以從機會及其產品中建立報價。<br>在詳細訊息右上角，通過按鈕可以從機會同步報價單，或將報價單同步到機會下。當報價與機會同步時，對報價行任何更改都會與機會產品同步，反之亦然。每個機會可以有多個關聯的報價，其中任何一個報價都能與機會同步。<br>在詳細訊息右上角，可以將報價單產生pdf並預覽，且可直接進行列印、下載或儲存操作。`,
"message.error.field.default":`預設值必須是正整數`,
"label.campaignmember.main.importmember.contacts.desc":`將文件中的數據匯入到這個市場活動聯絡人中`,
"vue_label_calendar_show_only_this_calendar":`僅顯示此日曆`,
"vue_label_quot_syncfrom":`從機會同步`,
"label.data.expnode.e_desc2":`2、按範本匯出：使用者可以選擇範本進行資料匯出。`,
"label.login.verification.mfa.desc1":`您必須先在智能設備上安裝一個MFA應用程式，才能繼續進行操作。在智能設備上支援MFA的常用應用程式有洋蔥，Google Authenticator。`,
"label.jiandangfenpei.desc":`分配設定檔對當前自訂頁面的存取權限。系統管理員可以存取所有自訂頁面。`,
"label_tabpage_thisrecord":`此記錄`,
"lable.SalesCommitmentKanBan.totalPaymentAmount":`累計收款額`,
"message.error.object.notvalidcurrency":`無效的幣種`,
"label.edit.discount":`編輯折扣`,
"label.setup.mobile.offlinecache.setenable":`啟用行動端離線功能`,
"UG.ST.005":`我知道了，不用再顯示此頁面，下次直接進入。`,
"label.assignedapprover":`已分配審批者`,
"template.chart.htlx":`合約類型`,
"scope":`在範圍內`,
"label.workmate.search":`搜尋同事`,
"message.validation.isnotdigits":`輸入正確的數字`,
"label.ccpeak.use.class.time.page":`如果是自訂頁面調用該類別，需調用PageClsInvoker類中的invoker()方法`,
"setup_mainpage_label_welcome27":`CloudCC 雲平台提供系統內所有物件數據的匯入、匯出、數據批次刪除、批次轉移等功能。`,
"front-epwechat-module-v1-epwechat-integrate":`企業微信整合`,
"label.file.publiclink":`公用連結`,
"front-epwechat-module-v1-input-name":`請輸入企業名稱`,
"lable.Number.of.columns":`列數`,
"message.error.dev.service.duplicateparameter":`服務參數重複！`,
"label.projectManagement.percent.complete":`完成百分比`,
"label.chatter.nextSevenday":`未來7天`,
"chatter.feed.myfollowers":`我的追蹤者`,
"label.bacchtransfer.pleaseselecttouser":`請選擇轉移到使用者`,
"label_partner_workspace_member_memo":`選定的設定檔、權限集的所有使用者都可以存取此夥伴雲。`,
"label.marketsea.chosen.member":`已選成員`,
"label.marketsea.assignment.setup":`指派設定`,
"label.myaccount":`我的客戶`,
"label.schedulejob.setup.schedule.executedate":`執行時間`,
"label.uploadaccessory":`附件上傳`,
"Homepage.News.004":`暫無新聞`,
"label.marketsea.name":`公海池名稱`,
"label.pending.task":`待辦任務`,
"label.report.details":`詳細訊息`,
"UG.homepage.008":`瞭解目前業務狀態（銷售簡報，排行榜，銷售漏斗等），查看可能存在問題的機會，預測未來業績達成情況，即時受理和分派重要事項，做出明智決策。`,
"label.h5.similar.opportunity.clear.all":`清除所有`,
"label.tabpage.noz":`否`,
"label.report.recent.all.reports":`所有報表`,
"vue_label_lead_to_score":`點擊評分，為當前視圖內商機進行評分。`,
"vue_label_normal_receivable_sf":`收款計劃`,
"label.layout.edittabdistribute":`編輯選項卡配置`,
"label.validate.function.funcFormat.PRIORVALUE":`PRIORVALUE(field)`,
"label.salescloud.field.editoptionlist":`選項列表編輯`,
"APPIntegration.Dropbox.01":`從Dropbox中選擇文件`,
"label.campaign.channel.step2":`步驟2：營銷渠道商機欄位預設值設置`,
"label_partner_new_function":`功能說明`,
"vue_label_chat_no_search_results":`無搜尋結果`,
"vue_label_commonobjects_detail_visitstate":`拜候狀態`,
"label.sendemail.send.testemail":`這是一封測試信件，如果您能收到這封信件，證明您可以使用這個信箱發送郵件。`,
"label.attendance.clear.position":`清除地標`,
"chatter.write.n":`編寫註釋...`,
"label_chatter_sendmail":`發送電子郵件`,
"label.remindertime":`提醒時間`,
"label.app.elegantgray":`淡雅灰`,
"label.tabpage.ownedz":`共有`,
"label.select.approval":`選擇審批人`,
"UG.Lead.007":`Google同步`,
"chatter.emailSetUp":`我的CCChat提醒設置`,
"label.default.censor":`預設審查人`,
"vue_label_notice_uploadavatar_success":`上傳頭像成功`,
"label.sms.title":`簡訊接口訊息`,
"front-console-choose-contact":``,
"label.field.edit.des":`最大評分控制著星星圖標顯示的數量，最大的評分為100`,
"label.pw.big.letter":`大寫字母`,
"label.select.time.dimension":`請選擇時間維度`,
"UG_Campaign_004":`匯入行銷活動`,
"label.dashboard.summary":`度量`,
"label.ems.yahoo":`雅虎`,
"label.leadscore.rule.name":`評分規則名稱`,
"vue_label_calendar_object_name":`物件名稱`,
"label.icon.69":`機器`,
"label.reporttotal":`總計`,
"lable.SalesCommitmentKanBan.theActualContract":`實際簽約額`,
"label.project.member.data":`此使用者已是當前項目下成員！`,
"label.cloudccclass.list.viewremark":`查看使用說明`,
"label.deleteObject.isNotAdministrator":`不是系統管理員，不能刪除物件。`,
"lable.edit.queue.nameandemail":`佇列名稱和電子郵件地址`,
"label.recordtype.tabname":`記錄類型`,
"label.file.is.ok":`是否確定`,
"label.knowledge.language.german":`德語`,
"label.layout.realityapprover":`實際審批者`,
"label.ems.with7day":`7天以內`,
"label.autoRegister.changepwd.setpwd.setpwd.button":`設置`,
"label.weixin.edit.polls":`修改投票`,
"label.layout.mobile.default.tab":`選擇手機預設打開的選項卡`,
"vue_label_report_deletegroupcolumn":`刪除組列`,
"label.group.archived.success":`歸檔成功`,
"label.customfields.formula.returntype":`公式的返回類型`,
"label.file.followers":`追蹤者`,
"label.textmessage.new.templates.message1":`簡訊範本名稱不能為空！`,
"label.selected.field.length":`已選欄位不能超過10個`,
"ObjectDetailed_ViewKeyInformation_Layout":`編輯關鍵訊息`,
"label.paging.totalofpage":`共{0}頁`,
"label.ccchat.message.new.error41":`要同更多人會話，嘗試使用小組`,
"message.recordtype.detail.noselectlist":`沒有可以顯示的選項列表`,
"label.conditiontag.lookup.title":`在下面選擇要添加的選項列表值`,
"label_partner_setup":`夥伴雲設置`,
"front-epwechat-module-v1-android-packname":`Android應用包名：`,
"lable.custom.Current.CY":`當前自訂年度`,
"label.newprocess2.desc":`如果折扣大於0.3%時，評估為真。`,
"label.operatedata.selectobjectfields":`選擇匯出物件的欄位`,
"report_reportdatasource_label":`報表數據源`,
"label.chosesubject.others":`其他活動`,
"label.list.desc2":`Web to CloudCC頁面分成兩種：PC版和行動版。PC版可用於電腦存取，行動版用於手機存取，例如微信。`,
"vue_group_several_groups":`{totalSize}個小組`,
"label.page.button.linkurl":`按鈕和連結URL`,
"show.week":`顯示週末`,
"label.gotocalendar.new":`到日曆中建立事件`,
"button.reset.advancedsearch":`清除進階搜尋條件`,
"label.h5.chatter.feedandcomnum":`發帖和留言`,
"lable.opppdt.addpdt.table.unitprice":`銷售價格`,
"label.dataimport.validate":`選擇要執行的驗證`,
"label.lead.score":`商機評分`,
"vue_label_help_product":`產品與價格手冊`,
"label.role.select":`已選定角色`,
"lable.opppdt.selPdt.searchproduct":`查找產品`,
"component_event_label_newevent":`*狀態`,
"front-invoice-online-payment-setup-configure-button":``,
"label.stdashbord.xsld.business.img2":`可能性為1%-99%階段的總金額`,
"label.event.moveup.2week":`提前 2 星期`,
"label.partnerCloud.priceOfManual.allCustomer":`全部客戶`,
"lable.account.dep":`單擊“新建”按鈕定義一個新的會計年度`,
"label.dataimport.insertdata.error.null.update":`該記錄中的$schemefield_name$值為空,無法進行更新操作，該記錄已忽略匯入。`,
"label_component_helper_businesschange_0activity":`30天內沒有任何活動`,
"lable.account.NextbbDays":`未來60天`,
"label_scope_length":`範圍長度`,
"label.customfields.operation":`來運行資料匯出操作。`,
"serviceappointment.save.workorder":`請選擇工作訂單行項目關聯的工作訂單`,
"label.field.update.hide.editor":`隱藏公式編輯器`,
"button.partner.new":`新建夥伴雲`,
"label.stdashbord.xsld.business.oppdetails":`業務情況詳細表`,
"message.pleasewaitingnextversion":`此功能將在下一版本推出，敬請期待！`,
"label_tabpage_potentialcustomersz":`商機`,
"label_emailtocloudcc_step2":`步驟2`,
"label.weixin.username":`姓名`,
"label.quickbooks.viewlist.type":`類型`,
"front-kefu-moudle-v1-Select-seats":`選擇工作人員`,
"label.customsetting.manage":`管理`,
"label.tabpage.field":`欄位`,
"label.custom.page.button.icon.URL":`按鈕圖標URL`,
"font-evaluate-module-v1-evaluation-link":``,
"vue_label_salesfunnel_notice3":`可能性為1%-99%的機會總個數`,
"front-email-payment-describe":``,
"label.productsales.today.noevttskaddevt":`今天沒有未處理的事件或者到期的工作，您也可以點擊右上角的“ ”添加事件！`,
"component.setup.iframe.label.memo":`點擊設定圖示，輸入嵌入的URL地址。`,
"front-email-payment-select-country":``,
"label.ems.starred":`標星郵件`,
"component_setup_label_object":`物件`,
"label.query.detail.viewpartneruser":`查看合作夥伴使用者`,
"this.year":`本年`,
"serviceresource.isactive.notactive":`此服務資源未啟用`,
"label.marketing.message.recipientisnull":`收件人不能為空`,
"label.unfold":`展開`,
"label.service.assetBOM.view.tip":`請聯繫管理員，您不具有檢視資產BOM的權限`,
"label.validate.function.funcExplain.ISCHANGED":`檢查欄位值是否不同於上一個值，如果不同，則返回TRUE。否則返回FALSE`,
"label.validate.function.funcExplain.NOW":`返回表示當前時刻的日期時間`,
"label.phoenix.islands.time":`菲尼克斯群島時間`,
"vue_label_checkduplicate_complete_filter_rules":`請填寫完整篩選條件`,
"vue_label_report_rowcount":`行計數`,
"chatter.p":`個人`,
"label.umeng.activity.distributetask":`已為您指派工作`,
"UG_quota_05":`與機會雙向同步`,
"june":`六月`,
"label.reportsSubscriptionPage.schedulereport.monthly.day.tuesday":`星期二`,
"vue_label_commonobjects_view_chart_upto5":`最多展示5個分組`,
"vue_label_opportunity_contactrole_searchallcontacts":`在全部聯絡人中搜尋`,
"label.custom.field.task.notice":`任務通知`,
"label.weixin.insert.address":`插入位置`,
"label.attachementNew.desc":`將附件歸檔至文檔，且該附件不能被刪除`,
"setup_mainpage_label_welcome18":`CloudCC 的企業級權限設定使您在處理數據和模組時可以控制各使用者的使用權限。基於角色的權限設定還包括使用者職位、組、角色、數據共享規則、欄位級安全控制，實現企業不同人員、部門之間的數據共享。`,
"front-kefu-instance-noarea":``,
"label.please.ChooseMax":`請最多選擇{0}個產品選項。`,
"label.businesschance":`業務機會`,
"label.verticalline-group":`垂直列-分組`,
"label.ordering.platform":`訂貨平台`,
"label.product.pricebooks.ples":`請選擇價格手冊`,
"vue_label_norm_addcomponent":`添加組件`,
"label.ServiceCloud.Installation.address":`安裝地址`,
"vue_label_report_groupcolumn":`組列`,
"label.ccchat.person.invite.notallsucc":`{0}個電子郵件地址被儲存，但未發送。要發送邀請，校正以下錯誤並單擊發送。`,
"label.customfields.optionlist.tip":`允許使用者從定義的列表中選擇值。`,
"UG.activity.07":`建立一個工作`,
"label.reportsSubscriptionPage.schedulereport.monthly.week.last":`最後一個星期`,
"label.permission.accessname":`權限組名稱`,
"lable.custom.year.stadate":`自訂年度開始日期`,
"label.ems.inputmails":`接收郵件伺服器（I）`,
"label.cpq.quote.transfer.order.already":`該報價單已經轉成訂單，請刪除原訂單後再重新產生訂單`,
"label.sendletter.status":`市場活動成員狀態`,
"vue_label_commonobjects_view_save_as_view":`另存為視圖`,
"message.mobilechooseatmostfive":`最多選取五個欄位`,
"label.errormessage.batchedit.nopermission":`沒有您具有編輯的數據記錄。`,
"label.dataoperate.tip":`請選擇將要進行的操作，並選擇將要操作的物件`,
"label.enableoperate":`可用操作`,
"label.ems.usernamepassword.error":`信箱地址或密碼錯誤。`,
"label.campaignmember.selectmember.deletemember":`中刪除成員`,
"label.Tab":`選項卡`,
"label.emailobject.template.message1":`請選擇一個欄位，然後點擊“插入”。後跟“>”的標籤表示還有更多的可用欄位。`,
"label.approvalstep3.tip":`指定記錄進入此步驟的使用者。可選項，可以選擇是否允許批准代理也可以批准這些請求`,
"label.inusing":`已啟用`,
"label.edit.select.tre":`複選框列表`,
"label.appointmentconfirmail.wizard.title1":`{0} 你好`,
"label.partnerCloud.financeSetting.setAlipay":`設定支付寶支付`,
"lable.edit.queue.avobj":`可用物件`,
"vue_label_checkduplicate_verify_all_characters":`驗證全部字元`,
"label.huntingzone":`搜尋範圍`,
"label.request.approved":`該請求已被審批，請勿重複審批`,
"label.sharerule.msgerror":`伺服器內部錯誤消息`,
"front-epwechat-module-v1-tick-unbound":`請勾選同意並接受以上解除綁定資訊`,
"label.console.step6":`步驟 6.選擇列表配置`,
"label.multilang.micropost.vote":`{0}票`,
"message.error.appid.null":`秘鑰不能為空！`,
"lable.product.delq":`刪除問題`,
"label.h5.approval.leixing":`審批類型`,
"label.edit.field.select.style1":`平鋪顯示`,
"label.passwordPolicy.setup.alpandnum":`必須混合使用字母和數字`,
"label.ems.close2":`關閉`,
"label.report.reporttypetitle":`報表類型`,
"label.umeng.approval.approvalsuccess":`審批已提交`,
"label.page.showamount":`每頁顯示記錄數：`,
"label.copy.asset.successfully":`複製資產BOM成功`,
"vue_label_homepage_bigscreen_dark":`深色`,
"vue_label_email_selected_members":`已選成員`,
"label.file.preview":`預覽`,
"label.partner.new.step3.name":`名稱`,
"label.forecast.settings.periods.ago":`個週期前`,
"label.evaluation.praise":``,
"label.cloudccsite.edit":`編輯站點`,
"label.knowledgebase.advanced.filtering":`進階篩選`,
"label.knowledgebase.framework":`框架`,
"vue_label_pool_ownedpool":`所屬公海池`,
"label.exchange.sync.setting.license":`啟用此功能後，部分組織數據可能會以內部部署或基於雲端的形式，儲存到 Microsoft Exchange 伺服器，並通過 Microsoft Exchange 伺服器進行處理。 CloudCC.com 對 Exchange或 Office 365 等第三方應用程式或系統的隱私和安全實踐概不負責。`,
"front-console-conversation-btn2":``,
"label.projectManagement.thelastone":`已經是最後一條了`,
"message.duplication.confirmscript.mergeoperation":`通過所選值將這些記錄合併到一個記錄中。注意：合併操作將無法撤消，是否繼續執行記錄合併操作?`,
"lable.outlook.detail.nosyn":`不同步`,
"label.iscopy":`是否允許拷貝`,
"message.matrixReportSetupStage.row":`請選擇【指定行標題】小計依據，兩個小計依據至少選擇一個。`,
"label.forecast.forehistory.possibility":`可能性`,
"label.timetrigger.validate":`輸入值必須是正整數，當滿足該工作流程的依賴觸發時間時，系統將自動執行其下的工作流程操作`,
"member.name.choice.field":`成員名稱為必選欄位哦！`,
"label.undone_external page":`這是無法復原的，所以請確定。此一表單不用於任何登入頁面，但可能在其他地方使用。例如，您可能已經使用嵌入代碼將其插入外部頁面。`,
"UG_Lead_012":`匯入線索`,
"component_chatter_label_fans":`追蹤者`,
"label.systeminfo":`系統訊息`,
"label.mr.descreption.oneGroupNote1":`請至少勾選兩條數據，點擊按鈕【加載選中的訊息】，進入數據合併頁面。當前是第`,
"label.wtd.changefields.selfields":`選擇要包含在 web to cloudcc頁面中的欄位：`,
"message.error.fileinfoid.null":`fileinfoid不能為空！文件訊息id`,
"label_tabpage_cownerz":`更改擁有者`,
"setup_layout_button_save":`儲存`,
"Dashboard.View.Createdbyme":`我建立的儀表板`,
"label.escalation.setup.detail.order":`順序號`,
"button.partner.start":`開始使用`,
"label.htyj.remark1":`您當前的版本不支援合約物件`,
"component.event.label.person":`被指派人`,
"label.appointmentconfirmail.wizard.subtitle3":`地點`,
"label.emailtocloudcc.filed.username":`信箱使用者名`,
"label.vlidaterule.remark":`通過指定錯誤條件和相應錯誤消息，定義驗證規則；使用者可以更正錯誤，然後重試`,
"message.duplication.label.insertoption":`新建時操作`,
"front-web-module-v1-detail-comment-toast":``,
"label.import.page2.notsuitedfiledwillbenotimport":`註：系統不會匯入您未映射的欄位`,
"label.h5.similar.opportunity.enable":`啟用類似業務機會`,
"label.allunfold":`全部展開`,
"component_setup_iframe_label_inputurl":`輸入URL地址`,
"label.manage.all":`管理全部`,
"label.mobile.side.tab.cs":`常用功能`,
"label.datamanage.contact.information":`聯絡人訊息`,
"lable.outlook.edit.sel":`選擇值...`,
"label.imgfield.type.url.tip2":`例如：http://www.cloudcc.com/images/logo.png&cimgSize=50,50。`,
"setup.layout.label.areasetup":`設定區域屬性`,
"label.date":`日期`,
"vue_label_commonobjects_detail_openfilter":`展開篩選器`,
"label.loginip.pagecue":`輸入有效IP地址範圍，指定具有此設定檔的使用者可以從哪些地址登錄。`,
"vue_label_email_not_valid":`您輸入的不是有效的信箱`,
"label.page.step5.add.application":`步驟5：添加到自訂應用程式`,
"label.dashboard.donot.delete":`當前儀表板檔夾下存在儀表板，不能被刪除！`,
"label.visitAPPexchange":`存取 Appexchange（新視窗）`,
"label.generate.location":`產生客戶經緯度數據`,
"lable.quote.syncing.syncingbutton":`同步`,
"label.pw.error.text":`兩次輸入密碼不一致!`,
"label_partner_setup_Enable":``,
"label.file.preview.unav":`預覽不可用`,
"label.sms.tip":`來自網路`,
"setup.mainpage.label.welcome21":`CloudCC 雲平臺提供使用者自訂郵件範本功能。方便使用者統一使用，提高工作效率。`,
"label.trigger.for.example":`例如：在客戶的update觸發器中更新業務機會，在業務機會的update觸發器中更新客戶同時又觸發客戶的update觸發器，如果在觸發器中不加條件控制，那麼系統最多允許執行3次這樣的循環調用！`,
"setup.layout.button.layoutprop":`配置屬性`,
"component.chatter.label.fans":`追蹤者`,
"lable.PowerProcess.event.edit":`重大事件編輯`,
"label.detailintro":`明細說明`,
"vue_label_report_nosearchresults":`搜尋無結果`,
"error.name.repeat":`名稱不能重複`,
"label.emailEncoding":`郵件編碼`,
"label.partnerCloud.financeSetting.enableAccount":`啟用回饋金帳戶`,
"label_emailtocloudcc_clear":`清空`,
"setup_mainpage_label_welcome12":`使用者通過點擊滑鼠，無需編寫程式，按照系統提示步驟，便可以完成報表定義。系統有列表式報表、匯總報表、矩陣式報表可供選擇。同時提供所有欄位的顯示選擇。去除不必要的欄位訊息。同時包括、條狀、折線、環狀、漏斗、圓餅等多類圖形顯示。讓使用者一目了然。`,
"lable.SalesCommitmentKanBan.contractStartDate":`合約開始日期`,
"front-starter-v1-potential-customer-tips-success":`啟動商機公池海成功`,
"UG_Forcast_02":`預測是對指定階段預期銷售的估算，預測模式可幫助您確定一段時間內的產品需求和銷售收入情況。管理者可以使用預測來設定目標並衡量團隊的進展情況。機構的整體預測可按銷售代表來反映所有銷售的概要情況（不論銷售處於從管道階段到關閉階段之間的何種完成階段）。`,
"label.escalation.setup.detail.ruleentries":`規則項目`,
"lable.SalesCommitmentKanBan.allComplete":`總完成額`,
"label.appupload.install.apicanuse":`api名稱可用`,
"label.organiza.field":`組織欄位`,
"button.partner.workspace.manage":`管理`,
"lable.PowerProcess.setevent":`設定重大事件`,
"label.emailobject.groupemail.msg2":`缺少電子郵件地址，這將導致此封郵件無法發送給該收件人。`,
"label.h5.orderbyname":`按姓名排序`,
"vue_label_salesadvance_opportunities":`商機數`,
"label.appointment.disable.cancel":`禁用取消預約`,
"label.trigger.folder.edit":`觸發器頁面：編輯文件夾`,
"label.customfields.new.step2.opration.unique.info.v2":`將ABC"和"abc"視為不同值(區分大小寫)"`,
"label.icon.40":`定位`,
"label.eventmenuandlink":`事件按鈕和連結`,
"label.service.gantt.candidate":`候選人`,
"label.top.userphoto":`使用者頭像`,
"label.appointmentconfirmail.wizard.btn2":`取消會議`,
"label.print":`列印`,
"saveandreturn":`儲存並返回`,
"lable.account.CurrentandNextCY":`當前和下一個日曆年度`,
"label.group.no.recent1":`您尚未查看任何啟用的小組。`,
"lable.Asset.conversion":`轉資產時根據訂單產品上“資產轉換”的方式產生資產。`,
"label.emailtocloudcc.button.sure":`確認`,
"label.Path.List":`進程列表`,
"label.please.rule.name":`請輸入規則名稱`,
"label.knowledge.category.hint.six":`可用分類組`,
"setup_mainpage_label_welcome28":`操作指導： 點擊本頁左側選單 → 管理設定 → 數據管理 → 數據匯入匯出、批次轉移、批次刪除。`,
"vue_label_commonobjects_view_chart_editchart":`編輯圖表`,
"label.permission.detail.app.object":``,
"label.multilang.totalpage":`共`,
"label.marketsea.button.return":`退回`,
"Click.to.load.more":`點擊加載更多`,
"label.validate.globalvariable":`全局變數`,
"label.marketsea.iseditseabymanager":`允許管理員更改所屬公海池`,
"label.price.yuan":`價格（元）`,
"label.service.resource.uesr.tip":`選擇使用者建立服務資源，資源類型不能選擇班組。`,
"vue_label_help_viewusageguide":`查看lightning版本使用指南`,
"label.autoRegister.changepwd.setpwd.too.long":`太長`,
"label.campagin.roi.fwsl":`存取數量`,
"label.campaign.mobile":`行動端`,
"UG.Lead.012":`匯入線索`,
"link.recordtype.detail.backtoobject":`返回自訂物件`,
"front-kefu-moudle-callcentrt-hasclose":``,
"label.category.5":`IT 高科技`,
"label.import.page1.selectwayofdealdata":`選擇處理數據的方式`,
"chatter.emailReceiveEmail":`接收CCChat提醒`,
"vue_label_file_manage_lib_members":`管理文件庫成員`,
"label.appupload.upload.overview":`概述`,
"label.service.miniProgram.inputNumber":`請填寫0-999的數字`,
"label.emailtemplate.finishdetailinfo":`完成郵件範本的詳細訊息`,
"label.weixin.fmu.before.day":`提前 {0} 天`,
"label.integrations.login":`登錄`,
"label.dashboard.setUpHomePage":`已設置顯示的主頁`,
"label_partner_common_webSit":`域名`,
"front-epwechat-module-v1-unbound-user":`未綁定使用者清單`,
"label.partnerCloud.basicSetting.offline":`啟用線下支付`,
"label.start.loginip":`IP開始地址`,
"label.projectManagement.delete.subtasks":``,
"label.message.batchapp":`批次審批`,
"message.duplication.label.ruletitle":`查重過濾器規則`,
"label.all_networks":`全部網路`,
"label.select_columns":`選擇您希望表單送出時所顯示的列`,
"vue_label_notice_uploadavatar_exceed":`上傳頭像圖片大小不能超過2MB`,
"message.error.get.failed":`獲取訊息失敗！`,
"label.quickbooks.viewlist.duedate":`到期日期`,
"label.ccchat.topic.search":`搜尋主題`,
"label.forecast.shre.manager":`分配經理`,
"label.reportsSubscriptionPage.schedulereport.monthly.day.thursday":`星期四`,
"lable.product.pricebooks.copy":`從現有價格手冊複製`,
"label.instrumentPanel.minLabelname":`該值必須是正數且要小於斷點1值`,
"front-market-form-createdsecond":``,
"label.submission_detail":`送出詳情`,
"label.customfields.checkbox.tip":`允許使用者選擇真"（選取）或"假"（不選取）值。"`,
"label.escalation.setup.list.description":`當具有條件的個案超過規定時間仍未處理，您可以通過升級規則定義自動操作。升級個案時，您可以選擇自動通知使用者、將個案重新分配給另一個使用者。`,
"UG.Forcast.05":`預測設定：步驟{0}/{1}`,
"label.data.import":`數據匯入`,
"label.upload.error.cause":`上傳失敗，原因為`,
"label.search.change.remark":`應用於前臺左側欄搜尋部分所顯示的物件設置`,
"serviceappointment.edit.status.limitwithstatus":`服務預約的狀態無法從{0}更改至{1}`,
"label.department.operation":`操作`,
"label.textmessage.vonage.message3":`要查找API密鑰和API機密，您可以登錄Vonage API帳戶，然後轉到帳戶名下的“設定”。要查找Vonage API帳戶中的電話號碼，可以轉到“產品”下的“號碼”，然後單擊“您的號碼”以查看您擁有的所有電話號碼。`,
"label.privacystatement.dialog":`隱私聲明 （新視窗）`,
"label.datamanage.import.leadfield":`在下表中，選擇匯入文件中應匯入到每個商機的欄位。完成操作後，點擊下一步：`,
"label.appupload.upload.install.failar":`安裝失敗。`,
"label.viewall":`查看全部`,
"label.sendemail.chat.addComentsfavoritesubject":`CloudCC CCChat 回覆收藏的微貼`,
"lable.custom.dp":`此頁允許您定義自訂年度。`,
"label.mobile.more.share":`與同事或組共用`,
"lable.name.cannot.be.empty":`名不能為空`,
"label.autoRegister.changepwd.setpwd.password":`您的密碼`,
"label.multipleactivity.aevents":`個事件`,
"label.many.dayline.lastday":`前一天`,
"lable.Please.bind.the.QuickBooks.record.first":`請先綁定quickbooks記錄`,
"vue_no_related_dashboards":`無相關儀表板`,
"label.newdashboardpage.name":`儀表板名稱`,
"vue_label_commonobjects_detail_network":`關係網`,
"label.tianyancha.reginstitute":`登記機關`,
"label.the.lower.bound.of.each.level.must.be.equal.to.the.upper.bound.of.the.upper.level.":`分塊定價每1層的下界必須等於上1層的上界。`,
"label.chat.file.upload.info":`上傳文件`,
"label.appexchange.vlidaterule":`驗證規則`,
"label.salescloud.salesdashboard.current.business":`當前商機`,
"label.app.step4.homeisfrist":`主頁必須是第一個選項卡且不能移除！`,
"label.weixin.micro.research.optionname":`微調研選項名稱`,
"label.paging.totalofnbsp":`共{0}條`,
"label.opportunity.perm.title":`請求存取權限`,
"front-kefu-moudle-v1-zhyzcw-reinput":`租戶驗證錯誤，請重新輸入`,
"label.unsaved_changes":`如果您繼續操作的話，未儲存的修改將會遺失。`,
"label_partner_all_description":`描述`,
"lable.account.Next.CQ":`下一個日曆季度`,
"chatter.feed.menutype.feed.me":`涉及我的更新`,
"label.sourcetranstemp":`原始翻譯範本：空翻譯範本，可以製作一門新的語言文件`,
"label.apply.newuser.validate":`CloudCC新使用者註冊，驗證碼：`,
"label.user.password.error":`使用者名密碼錯誤，或無效的使用者！`,
"label.there.is.no.quotation.line.item.in.this.quotation.line.group.at.present.":`該報價行組目前沒有報價行項目，請點選“新增產品”按鈕新增產品。`,
"lable.PowerProcess.time.filed":`基於{detailInterestType}的日期時間欄位`,
"label.file.default.value.is.integer":`只能輸入整數`,
"label.processsetting.please.select.field":`請選擇欄位`,
"label.app.step3.introduce":`自訂應用程式圖標檔大小必須小於20K。為獲得最佳效果，圖像尺寸最大值應為寬300像素，高55像素。其他尺寸的圖像，系統會調整其大小，可能會失真。另外，只有儲存後，新圖才能生效。`,
"button_partner_save":`儲存`,
"label.marketingmanagement":`市場營銷`,
"label.isEnableVisualpage_new.leftlist":`可用的自訂頁面`,
"label.salescloud.teamrole.optionlist.choose.correct":`列表中存在相同的項，請更正`,
"System_ChangeUser_Info_001":`更改所有人成功，您沒有查看此記錄的權限，點擊後返回到上一個頁面。`,
"front-console-no-contact":``,
"component.assistant.label.overduetask":`機會包含逾期工作`,
"label.roleofpartner":`合作夥伴角色`,
"label.appointmentconfirmpage.wizard.subtitle4-1":`您與{0}`,
"front-template-V1-Please-select-a-picture":`請選擇圖檔`,
"lable.SalesCommitmentKanBan.allsignedCommitmentRate":`總簽約承諾率`,
"label.h5.similar.opportunity.step2.conment":`在3與10欄位或相關列表之間選擇以在查找類似業務機會時互相匹配`,
"label.projectManagement.alert.frequency.will.not.work":`當您選擇“否”時，提醒頻率將無法生效!`,
"vue_label_fllscreen":`全螢幕查看`,
"label.customfields.selectcontainfieldlayout":`選擇應包含該欄位的頁面配置`,
"label.appointment.wizard.subtitle1-4":`45分鐘`,
"label.tianyancha.businessverify.unagree":`不同意`,
"label.unique":`獨有`,
"setup_mainpage_label_welcome10":`操作指導： 點擊本頁左側選單 → 應用程式設定 → 建立 → 物件 → 物件名 → 自訂配置。`,
"vue_label_account_subsidiary":`子公司`,
"label.dataimport.format.error":`格式錯誤，請使用MM/DD/YYYY或者YYYY-MM-DD的格式。`,
"label.email.new":`建立郵件`,
"label.log.descri":`操作詳述`,
"vue_label_dashboard_componentname":`請輸入組件名稱`,
"label.weixin.quick.reply":`快速回覆`,
"label.productsales.payment.badversion":`您當前的版本不支援合約物件無法查看銷售收款業績`,
"label.position":`位置`,
"label.Annex.Conditions":`添加附加條件的邏輯篩選器 （例如：1 And 2 Or 3 ）`,
"label_tabpage_endz":`結束`,
"label.setup.mobile.bottombutton.prompt":`提示：該設定點擊儲存後，將覆蓋使用者在行動端自訂的一級頁面設定。`,
"lable.Edit.template":`編輯服務報告範本`,
"vue_label_report_onlydisplay2000":`僅顯示2000條數據`,
"label.salescloud.salesdashboard.sign.account.top5":`簽約大客戶top5`,
"label.weixin.ontime":`準點`,
"font-evaluate-module-v1-disappoint":``,
"chatter.sel.addre":`至多可以選擇5個收件人!`,
"label.mobile.phone.month.summary":`本月總結`,
"label.partnerCloud.priceOfManual.selected":`選定客戶`,
"label.south.georgia.time":`南喬治亞標準時間`,
"label.create.ccdocument":`新增附件`,
"label.chatter.to":`到`,
"label.ems.minute":`分鐘`,
"label.mobile.phone.submit.tome":`提交給我的報告`,
"label.approvalstep1":`步驟 1：輸入名稱和說明`,
"label.h5.similar.opportunity.last.months9":`最近6-9個月`,
"Opportunity_Detailed_Phase_Label_003":`更改階段`,
"lable.PowerProcess.time.input":`請輸入時間`,
"label.stdashbord.xsld.business.yqzsr":`預期總收入`,
"label.icon.64":`探照燈`,
"label.data.choses.i_desc":`根據您的需要，選擇匯入單個物件的資料。`,
"label.integrations.mainlandchinaleads":`中國大陸商機`,
"vue_label_notice_savemenu_success":`選單儲存成功`,
"front-kefu-moudle-v1-xzhxzxkf-online":`選擇環信線上客服`,
"label_chatter_name":`名稱`,
"label.Viewon_Linkedin":`在LinkedIn上檢視`,
"lable.PowerProcess.chioce.event":`請選擇重大事件`,
"component.chatter.file.label.maxsize":`文件最大為20M`,
"label.validate.function.funcExplain.SECOND":`返回日期/時間欄位中的秒數`,
"label.data.downpage.i.title.num4":`4、如果您要匯入的物件中具有查找欄位和主詳欄位，則該欄位對應的值必須是ID，否則無效。`,
"label.icon.139":`貨幣`,
"label.app.step4.atleastone":`主頁選項卡不能被移除！`,
"label.weixin.input.telephone":`請輸入手機號`,
"label.setup.mobile.bottombutton.remark":`各組織可根據業務場景設定組織級的一級頁面初始設定。`,
"label.file.searchs":`搜尋文件`,
"vue_label_email_there_is_no_draft_yet":`暫時沒有草稿哦`,
"front-kefu-moudle-v1-bind-seats":`綁定工作人員`,
"label.customfields.lookupmuti.tip":`建立一個將此物件連結到另一物件的關係。 關係欄位允許使用者單擊查找圖標，以從彈出列表中選擇多個值。 另一對像是列表中值的來源。`,
"label.integrations.password":`密碼`,
"label.data.newtemplate.t_conditions":`範本條件`,
"message.error.repeatsubmit":`此提交存在重複提交或同一頁面打開多個視窗修改的情況，若是後者，請在最新打開的視窗中提交。`,
"label.umeng.approval.approvalreassign":`#obj批准被重新指派#objname`,
"lable.edit.queue.selobj":`錯誤：佇列中必須至少有一個所選物件`,
"label.compact.layout.frame":`版面配置框架`,
"label.sms.companyname.dsf.infor":`東時方簡訊接口訊息`,
"template.report.individual.case.source":`個案來源`,
"pagecreator.button.pcpage":`PC端`,
"vue_label_commonobject_selectdatatime":`選擇日期時間`,
"label.icon.181":`檔案`,
"label.loginip.setup.please":`請指定IP範圍`,
"vue_label_dashboard_?secondarygroup":`請選擇二級分組`,
"lable.outlook.mcto.pleasedes":`請輸入您不願有關聯的電子郵件網域，並用逗號隔開。`,
"DetailedInfo_Activity_EmailMessage_01":`{0} 已為 {1}發送一封電子郵件`,
"label.sendmail.step4":`步驟4：您已提交電子郵件進行處理`,
"label.monitorsys.delete.source":`操作描述`,
"label.monitorsys.log.datetime":`下載搜尋範圍內的系統重點操作審計日誌(Excel.xls文件)`,
"component_chatter_label_myfans":`我的追蹤者`,
"label.tianyancha.h5.registereddate":`註冊時間`,
"label.multilang.feedtrack.operatecreate":`已建立一條{0}記錄：`,
"label.console.step6.no":`選擇列表佈置`,
"four":`四`,
"message.confirmsetpwdforuser":`是否為使用者重新設置密碼？`,
"label.cape.verde.time":`佛德角時間`,
"label.queue.new":`新建佇列`,
"label.cloudccsite.start":`啟用站點主頁`,
"label.data.exp.way":`匯出方式`,
"label.lock.record.donot.delete":`已鎖定記錄不允許刪除`,
"label_emailtocloudcc_filed_type":`類型`,
"frame_personinfo_label_minipic":`縮圖`,
"label.checkfield.choosetab":`選擇查重欄位`,
"component.setup.tabs.label.default":`預設頁`,
"page.404.button.toknowmore":`瞭解更多`,
"vue_label_SMS_message_sent_cannot_be_empty":`發送的通知內容不能為空哦`,
"label.lookupreplaceselectvalue":`查找並取代選項列表值`,
"pagecreator_layout_button_new":`新建配置`,
"label.mobile.more.upload":`上傳新版本`,
"front-kefu-moudle-v1-Connection-failure":`關聯失敗`,
"label.version.support.unlimited":`支援不受限`,
"message.error.notmarketseamember":`不是該公海池成員`,
"label.taskandincident":`任務和事件`,
"label.report.export.print.title":`打印報表視圖`,
"label.file.publicview.error2":`公用連結訊息有誤，請使用新的公用連結`,
"label_chatter_cancel":`取消`,
"front-web-module-v1-detail-comment-satisfied":``,
"label.knowledge.delete.topic":`刪除只被該知識文章使用的話題出錯`,
"label.forecast.forehistory.all":`全部`,
"label.displaybutton":`顯示的按鈕`,
"label.icon.148":`機器人`,
"label_tabpage_ok":`確定`,
"label.checkfield.merge.mainrecord":`主記錄`,
"label.notification.arketsea.restored":`{5}恢復了{2}{0}：{1}`,
"setup.mainpage.label.welcome31":`操作指導： 點擊本頁左側選單 → 管理設定 → 建立 → 應用程式`,
"front-kefu-moudle-v1-jtrrt-connect":``,
"vue_label_calendar_please_select":`請選擇顯示的欄位`,
"setup.layout.label.pagename":`版面配置名稱`,
"template.chart.schdywjhz":`行銷活動機會值`,
"label.access_report":`誰可以檢視本報表？`,
"label.assignment.layout.section.optional":`可選`,
"label_chatter_recently":`最近`,
"lable.chat.advanced.setting":`進階設定`,
"label.knowledge.category.hint.eight":`分類組`,
"message.error.facebookuid.null":``,
"label.step5.total6":`第5步，共6步`,
"label.is.cancel.delete":`是否取消刪除`,
"setup_mainpage_label_welcome11":`自訂報表`,
"label.answers":`回應`,
"label.approvalstep1.tip":`為新批准步驟輸入名稱、說明和步驟號。`,
"template.chart.htjeph":`合約金額排行`,
"label.campaigns.onsiteregistration":`現場註冊`,
"front-epwechat-module-v1-input-agentid":`請輸入agentId`,
"label.emailobject.wizard.desc2":`追蹤電子郵件是否被打開及打開次數`,
"label.multilang.chatterdetial.vote":`{0}票`,
"label.customsetting.manage.value":`自訂數據`,
"front-electronic-export-listCount":``,
"label.dashboard.create.prompt":`列表型報表不可建立儀表板`,
"label_tabpage_askz":`你想提問什麼`,
"label.ems.sentmail":`發件箱`,
"label.reportlist.untop":`取消固定`,
"label.owner.h5.plzchose":`請選擇所有人後再點擊確定按鈕`,
"label.callcenter.addup.10.pieces":``,
"label.ccdocument.save":`儲存文檔`,
"label.productcannotnull":`產品不能為空`,
"label_tabpage_enabletomobile":`是否啟用到行動裝置端`,
"lable.account.CYAgo":`兩個日曆年度之前`,
"lable.Select.the.returned.high.seas.pool":`選擇退回的公海池`,
"tuesday":`星期二`,
"label.partnerCloud.basicSetting.partnerPayment":`啟用夥伴帳戶`,
"label.validate.function.funcExplain.WEEKDAY":`返回星期幾，1代表星期日，7代表星期六`,
"label.query.detail.manageexuser":`管理外部賬戶`,
"vue_label_systemSettings_environment":`環境`,
"component_setup_tabs_label_delete":`刪除`,
"label.weixin.delete.ccchat":`確定要刪除這條微貼嗎?`,
"label.lanxin.title":`藍信-H5微應用`,
"label.layout.editcondition.morethanten":`查詢條件不能超過10個`,
"label.project.hit.fourteen":`里程碑更新通知`,
"label.createby":`建立人`,
"label.moreoperation":`更多操作`,
"label.lock.tip":`鎖定記錄以免進行編輯`,
"label.check.input.condition.three":``,
"label.quote.dingjia":`定價`,
"label.currentuseremail":`當前使用者的電子郵箱地址`,
"UG_homepage_004":`自動化`,
"chatter.link":`連結`,
"label.new.zealand.standard.time":`紐西蘭夏令時`,
"APPIntegration.Dropbox.setting.02":`禁用`,
"label.version.searchandmerge":``,
"label.allmenus.showmsg.nomenu":`沒有找到您要搜尋的選單！`,
"front-template-V1-Enable-disable":`啟用|禁用`,
"label.marketing.setting4":`註冊成功返回網址預設值`,
"UG.Forcast.07":`允許預測`,
"vue_label_systemSettings_correlation":`相關列表展示方式`,
"label.cloudccsite.remark.length":`站點描述不能超過255個字元`,
"label.favorite":`收藏此頁`,
"template.report.converted.leads":`已轉換商機`,
"label.campaignmember.main.description":`使用此頁面管理此市場活動的成員。可以添加新成員或更新現有成員的市場活動成員狀態。`,
"label.salescloud.teamrole.account.organization":`小組成員對此客戶的存取級別可能高於您組織預設的客戶存取設定`,
"label.permission.modifyAppPermission.canselectapp":`可選應用程式`,
"front-epwechat-module-v1-self":`設定自建應用`,
"message.duplication.label.matchexactletters":`精確匹配`,
"label.appointmentdetail.wizard.title18":`週五時間規劃`,
"label.area":`區域`,
"label.sso.saml.sp.username":`使用者名稱`,
"lable.outlook.new":`新建Exchange Sync配置`,
"label.custom.field.close.conversion":`關閉-已轉換`,
"lable.outlook.detail.tmaping":`任務欄位映射`,
"label.emailobject.emaildetail.nextactivity.event":`添加事件`,
"vue_label_commonobjects_detail_date":`結束日期不得小於開始日期`,
"vue_label_email_mark?as":`標記為`,
"label.guestgroup":`客戶小組`,
"label_emailtocloudcc_filed_server":`伺服器`,
"label.icon.186":`諮詢`,
"label.department.user.edit":`編輯`,
"label.custom.page.component.button.settings":`組件按鈕設置`,
"label.partnerCloud.orderingPlatform.nextProduct":`是否儲存目前配置的產品，並進行下一個產品的配置？`,
"vue_label_appstore_cloud_platform":`cloud官方平臺`,
"label.page.previous":`上一頁`,
"label.direct.dashboard.week.report":`新建工作週報`,
"label.ServiceCloud.prompt.warning":`持股比例`,
"label.emailtocloudcc.position":`職位`,
"vue_label_email_please_enter_the_message_content":`請輸入郵件內容`,
"labal_About_to_jump":`即將跳轉`,
"label_profile_mobile_setup_stand":`標準主頁`,
"label.visualpage.component.n3":`3.參數. 參數寫在args屬性中,args`,
"vue_label_report_operationmode":`報表運行方式`,
"label.reportsSubscription.select.attached.file":`請選擇附加文件的類型！`,
"label.afghanistan.time":`阿富汗時間`,
"label.vlidaterule.formulatrue":`如果公式結果為真，則顯示“錯誤訊息”區中定義的文本`,
"label.ccchat.person.invite.erroremail":`電子郵件地址格式不正確。`,
"label.viewDashboard":`轉到儀表板列表`,
"label.at":`於`,
"label.notification.arketsea.beforeretrieve":`您的{0}：{1}即將被回收至{2}，剩餘時間{6}天`,
"label.field.update.show.editor":`顯示公式編輯器`,
"label.weixin.polls.time":`投票時間`,
"vue_label_commonobjects_detail_activity_nostarttime":`無開始時間`,
"label.direct.dashboard.me.not.approval70":`我提交的未終審項目`,
"label.data.setok.t_desc3":`，進行操作。`,
"label.view.edit.search.describe":`輸入關鍵詞后搜尋`,
"label.importsourcefiletip":`在匯入之前，請確保文件符合以下條件：<span><ul><li>1.為每種您要匯入的語言建立包含名稱和翻譯的文件。</li><li>2.每個文件頂部必須包含語言屬性(不支援中文匯入)。語言屬性如：Language`,
"UG.Case.01":`個案`,
"label.weixin.report.filters":`篩選器`,
"vue_label_homepage_profilehomepageassignment":`設定檔主頁指派`,
"label_tabpage_editview":`編輯視圖`,
"label.tabpage.allpotentialcustomers":`所有商機`,
"label.sendemail.send.standbyemail":`(備用發件箱)`,
"errormessage.email.atleastonereceiver.z":`請至少選擇或者填寫一條收件人地址`,
"workflow.action.tasks.assignortype.ownertype":`擁有者類型`,
"label.list.userinterface.new.page.setup":`新版介面`,
"chatter.seladress":`請至少選擇一個收件人`,
"Pagelayout_Setup_004":`最多只能配置4個欄位`,
"label.mobile.home.page.tenbig.opp":`未來30天十大業務機會`,
"label.wtd.changefields.newpc":`產生PC版頁面`,
"label.opportunity.perm.remark":`這是專有業務機會，請和業務機會擁有者”owneridccname“聯繫<br>以取得存取權限。`,
"label.data.exp.tempdes":`範本描述`,
"label.appointment.wizard.subtitle2-1":`從`,
"lable.currencyManage.button.manageexchangeRate":`管理過期匯率`,
"label.file.viewinfo":`查看文件詳細訊息`,
"label.integrations.mailchimp.export.failed":`匯出數據失敗，請檢查您的網路連接，稍後再試`,
"pagecreator_page_button_edit":`編輯`,
"label.icon.86":`公文包`,
"label.exchange.sync.reset":`重置同步`,
"label.customfields.lookupfilter":`可以建立一個篩選器以限制使用者在查找欄位中可用的記錄`,
"label.component.hotdeal.nopermission":`請聯繫CloudCC管理員，獲取機會相關數據`,
"label.address.province":`省`,
"lable.PowerProcess.3digit.input":`不能超過三位數`,
"label.asset":`資產`,
"label.passwordPolicy.setup.nopwdremember":`不記錄`,
"front-electronic-signature-setting-intro2":``,
"pagecreator.page.button.new":`建立頁面`,
"label.tabpage.step2":`第二步：指定過濾條件`,
"label_switch_two_column_or_responsive_layout":`切換二列或響應式配置`,
"label.batchDelete":`批次刪除`,
"chatter.edit.ct":`編輯您的聯繫方式`,
"UG_ST_003":`您沒有建立{0}的權限，請聯繫管理員，點擊確定則直接進入{0}介面。`,
"label.timzone.tip.info2":`使用SimpleDateFormat來對Date進行格式化時，應給SimpleDateFormat類別實例設置時區，例如：SimpleDateFormat myDateFormat`,
"label.ems.firstsynchistory":`首次同步多久的郵件`,
"label.currency.invalid":`無效幣種`,
"label.mask.custom":`自訂`,
"lable.opppdt.addpdt.title":`選擇產品`,
"label.appointment.wizard.subtitle3-3":`週三`,
"label.weixin.report.criteria":`分組條件`,
"label.appupload.upload.install.uninstall":`無法安裝`,
"label.compact.layout.frame.split":`並列顯示`,
"label.email.attach.complete.info":`上傳完成後，文件將顯示在下面的附件列表中`,
"label.Receivables":`收款計劃`,
"label.linkedin.title.setting":`LinkedIn集成訊息`,
"label.companynotice":`公司公告`,
"label.emailobject.discard":`取消`,
"label.selected.searchfield":`已選搜尋結果欄位`,
"front-electronic-signature-explainDocusign":``,
"chatter.link.name":`連結名稱`,
"label.low":`低`,
"label.verticalline":`垂直列`,
"label.approval.isallowed.reject.label":`單一數據審批時是否允許拒絕`,
"label.emailtocloudcc.button.enable":`啟用`,
"label.dashboardSetup.showdw.d5":`整數單位`,
"label.usermanage.not.authority":`您沒有足夠的權限執行此操作`,
"label.customobjects.track.introduce0":`此頁面允許您選擇要在{0}“欄位追蹤”相關列表中追蹤的欄位。無論何時使用者修改以下所選的任何欄位，舊欄位值和新欄位值，以及日期、時間、更改特性和進行更改的使用者都將添加到“欄位追蹤”相關列表中`,
"canlendarmonth":`日曆月`,
"vue_label_dashboard_minimum":`請輸入最小值`,
"label.salescloud.optionlist.inputname.linealone":`在下面添加一個或多個選項列表值，每個值應單獨占一行`,
"message.error.organuzation.information.null":`組織訊息不存在`,
"label.tabpage.maxfilez":`文件最大為`,
"message.validation.apiname":`必須以字母開頭，只能包含大小寫字母，數字，底線，最大長度50，最小2位`,
"report.type.label.contractPayment":`合約和收款`,
"label.limiting.choose.three.files":`當前限制選擇 3 個文件，本次選擇了`,
"label.reportTypeFocus":`報表類型焦點`,
"Report_Delete_Confirm_Title":`請確認`,
"front-gantt-module-reorder-milestones":``,
"front-starter-v1-customer-tips-success":`啟動客戶公池海成功`,
"label.tabpage.isdeleteview":`您確定是否刪除此視圖？`,
"label.favorite.title":`CloudCC雲平臺`,
"page.layout.sysinfo":`系統訊息`,
"label.tabpage.pleaseSelectz":`請選擇`,
"label.smsnotice":`簡訊通知`,
"label.forecast.customforecast.foretype.Pipeline":`Pipeline`,
"label.rejectbehaviour":`拒絕行為`,
"label.searchlayout.view.example.new":`查看示例（新視窗）`,
"vue_label_homepage_notice2":`您可以手動指派主頁配置,從而使員工更容易有效地完成其日常工作`,
"label.import.index.chooseidorother":`3、可以選擇使用id或名稱相符記錄與填寫查找欄位。若需獲取對應記錄id等訊息，可建立報表，並將記錄名稱與記錄id設定為群組資料欄，再將報表匯出。`,
"label.westem.european.summer.time":`西歐時間`,
"label.brackets":`括弧`,
"asset.serialnumber.unique":`資產序列號已存在，請勿重複添加。`,
"label.callcenter.access.keyID":``,
"label.calendar.month.view":`月視圖`,
"label.realdelete":`徹底刪除`,
"label.partnerCloud.orderingPlatform.amountPaid:":`待支付金額：`,
"label.reportTypName":`報表類型名稱`,
"lable.newtabpage.opensearchresult":`展開搜尋結果`,
"front-kefu-moudle-v1-Session-duration":``,
"label.import.index.ignore":`忽略`,
"label.customfields.url.tip":`允許使用者輸入任何有效的網址。如果使用者單擊該欄位，將根據使用者選擇的模式在瀏覽器的新視窗或當前視窗中打開該 URL。系統預設在瀏覽器的新視窗中打開該URL。`,
"label.projectManagement.editMilestone":`編輯里程碑`,
"front-gantt-module-v1-project-gantt-list":``,
"label.validate.remark":`通過防止使用者儲存錯誤數據，驗證規則可以改進數據品質。您可以定義一個或多個驗證規則，其中包括錯誤條件以及相應的錯誤消息。驗證規則在儲存記錄時執行。如果滿足錯誤條件，則中止儲存，並顯示錯誤訊息。`,
"front-kefu-moudle-v1-sjgsbzq-reinput":`手機格式不正確，請重新輸入`,
"label.channel.name":`通路名稱`,
"label.weixin.cloudcc.user.message":`CloudCC使用者訊息`,
"label.icon.59":`車間`,
"label.ccpeak.function":`方法`,
"lable.opppdt.selPdt.leastten.fields":`請至多選擇五個欄位`,
"label.deadline":`截止時間`,
"label.product.sel":`價格手冊選擇`,
"vue_label_helpcenter_detail2":`所有活動：顯示您擁有存取權限的所有活動，即使您未參與。<br>    您也可以根據日期範圍和活動類型篩選您想要查看的活動記錄。<br>4、動態<br>    所有可以查看到本條記錄的人員都可以在該記錄的“動態”欄目下進行留言發帖，而且您也可以查看關於該條記錄的所有訊息變更、最新活動，以及其他人員對該記錄的留言帖子。該欄目方便您<br>    和同事之間進行網上的工作交流和合作，有助與提高團隊合作和工作效率。<br>發表帖子<br>    步驟1:點擊發帖欄，輸入發帖內容<br>    步驟2:根據需要，點擊文件/連結按鈕，添加文件/連結<br>    步驟3:點擊”共用“，完成發帖。<br>查看帖子<br>    帖子發表成功後，您可以在下方看到剛剛發表的微貼。微貼由以下幾部分組成：頭像、人員姓名、微貼內容及互動方式（點讚/評論/編輯/刪除帖子）。<br>帖子的排序和查找<br>    點擊“排序”右側的下拉列表，可以更改帖子的排序方式。<br>    “最新活動”排序：按微貼的最新互動時間排列；<br>    “最新發表”排列：按微貼的發表時間排列；<br>    查看不同類型的微貼<br>    純文本微貼：直接在微貼發表區就可瀏覽全部內容；<br>    含有文件的微貼：點擊文件的下載按鈕，可以將文件下載到本地進行查看；<br>    含有連結的微貼：點擊微貼中的連結，即可打開；<br>評論和點讚微貼<br>    發表評論<br>    步驟1:點擊每條微貼下方的“評論”<br>    步驟2:在打開的文本框中輸入評論內容<br>    步驟3:根據需要添加評論的文件/連結<br>    步驟4:點擊文本框下的“評論”，完成操作<br>    刪除評論<br>    評論的發表人可以刪除評論內容。點擊評論右側的按鈕，在下拉框中選擇“刪除”。`,
"pagecreator_layout_button_mergecell":`合併單元格`,
"Lead_Scoring_Setting_Rule_Setup_Active":`是否啟動`,
"label.query.detail.loginbypartneruser":`以使用者身份登錄夥伴雲網站`,
"label.view.selectrenderfields":`選擇要顯示的欄位`,
"label.code.add":`添加二維碼連結訊息`,
"label.appointmentconfirmpage.wizard.title1":`會議已預約`,
"label.timzone.tip.title":`日期時間類型數據多時區支援。在使用new Date()或者Calendar處理日期時，應注意處理相應的多時區問題。另外，TimeUtil工具類別中提供了很多支援多時區的工具方法。`,
"label.tag.addtags.visibility":`可視性`,
"label.appointmentconfirmpage.wizard.title3":`您確定要取消現有預約並建立一個新的預約嗎？`,
"lable.outlook.detail.oldest":`最舊`,
"label.account.custom.quarter.timeerror":`自訂季度開始日期或自訂季度結束日期在歷史自訂季度時間段內，請檢查後重新設定！`,
"label.sendsms.idea":`尊敬的`,
"label.manageAll.pagenum2":`當前已經是最後一頁了`,
"serviceterritory.isactive.notactive":`此服務區域未啟用`,
"label.userinfo.newpwd.notnull":`新密碼不能為空！`,
"vue_label_dashboard_nolinkagedashboard":`暫無可聯動儀表板`,
"message.cannotdeleteapproval":`無法刪除審批流程`,
"label.wtd.detail.m":`行動版`,
"label.app.step4.introduce":`選擇要包括在此自訂應用程式中的選項卡。`,
"label.ccchat.error.permission":`無權限`,
"UG_opportunity_009":`或者`,
"label.Receivables.TheActualAmountOfMoney":`實際收款金額`,
"label.callcenter.no.search":`沒有相關查詢到訊息`,
"label.user.introduce":`使用者`,
"message.datalocked.addpdt":`該業務機會已鎖定，不能再添加產品。`,
"label.sendsms.step1":`步驟1：指定簡訊接受者`,
"label.brief.contracts":`合約數`,
"label.setup.mini.swap":`輪播圖設定`,
"label.emailobject.wizard.desc1":`關聯您的個人信箱，在此發送郵件並自動同步到記錄`,
"label.login.verification.mfa.desc2":`如果您因為某些原因（如手機遺失或誤刪除MFA應用等）無法進行驗證，可以通過管理員解除MFA綁定`,
"label.notification.receiveSms.message":`您有一條來自{!fromaddress}的簡訊，請點擊查看`,
"label.emailmerge.mergeFolder.publicfolder":`未歸檔公用郵件合併範本`,
"label.password.update.false":`密碼修改失敗，請聯繫系統管理員！`,
"label_tabpage_systemz":`個項目`,
"label.dataimport.objectid.null":`物件ID為空，系統不允許匯入`,
"label.currency.type":`幣種類型`,
"component_setup_button_appurl":`本系統URL`,
"label.appointmentconfirmail.wizard.title2":`您已經成功預約了{0}`,
"lable.product.please.enter":`請輸入`,
"label.escalation.setup.title":`個案升級規則`,
"label.create_failure":`表單建立失敗`,
"label.weixin.brand.model":`廠牌型號`,
"label.layout.nameoftestobj2":`測試物件二名稱`,
"vue_label_filters_number":`每個報表支援最多10個篩選器。`,
"label.file.following":`正在追蹤`,
"vue_label_account_all_contracts":`轉移客戶擁有者的所有合約`,
"label.service.please.select.cycle.type":`請選擇週期類型`,
"label.weixin.weipoll.optionname":`微投票選項名稱`,
"label.data.newtemplate.null":`無`,
"message.passwordPolicy.validate.complexReq1":`錯誤：密碼必須是數字和字母的組合`,
"label.forecast.shre.editmanager":`編輯經理`,
"label.emailtemplate.tip":`以下列出了選定檔夾中的所有電子郵件範本。 單擊"新建"按鈕可以建立新的文本或HTML電子郵件範本。您可以在發送郵件時使用這些電子郵件範本。單擊角色連結可查看更詳盡的訊息`,
"label.tag.manage.button":`管理標籤`,
"label.changepw":`修改密碼`,
"label.sso.saml.sp.idsource.nameid":`身份在“主題”聲明NameIdentifier元素中`,
"label.salescloud.teamrole.addmember":`?添加機會小組成員 CloudCC`,
"label.h5.similar.opportunity.last.months6":`最近3-6個月`,
"message.save.opportunity.role.save.failed":`聯絡人角色儲存失敗`,
"vue_label_report_formulainformation":`公式訊息`,
"label.area.assignuser.remark":`將使用者分配給區域`,
"label.multilang.viewlist.total":`共計選中{0}條記錄`,
"label.newprocessstep4":`步驟 4: 選擇電子郵件通知範本`,
"label.permission.objectpermission.open":`開啟`,
"label.service.gantt.close.list":`關閉列表`,
"label.standarduserfield":`標準使用者欄位`,
"vue_label_commonobjects_detail_the_administrator":`該記錄已鎖定，請聯繫管理員。`,
"label.exchange.sync.account":`Exchange 服務帳戶憑據`,
"label.mr.title.button.back":`返回，重新設置查詢條件`,
"label.notsetup.operation":`行條件錯誤，未設置運算符！`,
"label.notifications_center":`通知中心`,
"label.event.moveup.5hour":`提前 5 小時`,
"report_label_pleaseinput":`請輸入搜尋內容`,
"label.batchadd.newbatchpage.errorlist":`條數據添加失敗`,
"label.quickbooks.invoices":`發票`,
"chatter.feed.usingchatter":`啟用CCChat後，可以對人員和記錄進行追蹤，可以進行張貼。`,
"label.all.marketing.activities":`行銷活動擁有者`,
"label.lookup.finish":`查找自動完成`,
"label.weixin.unbind":`解除綁定`,
"front-console-closeTime":``,
"label.service.rest.time":`剩餘時間`,
"label.mr.descreption.condition1":`請輸入查詢重複數據的範圍和規則，點擊【查詢重複數據】按鈕，得到符合條件的重複數據。`,
"label.group.new":`建立小組`,
"vue_label_SMS_sending_please_wait":`發送中，請稍後`,
"label.Standardobj.tab":`標準物件選項卡`,
"label_chatter_pastEvents":`過去活動`,
"label.chatter.priority":`優先級`,
"select.nullvalue":`--無--`,
"setup_layout_group_pagecomponent":`頁面元素`,
"label.dataimport.dataerror.check":`數據錯誤，請仔細檢查本條數據`,
"label.permission.detail.app.pagesetting.tip":`執行自訂頁面權限的設置`,
"label.knowledge.language.polish":`波蘭語`,
"label.project.hit.two":`子工作到期提醒`,
"label.customerapp":`自訂應用程式`,
"label.reportsSubscriptionPage.condition.value":`值`,
"label.tabpage.no2z":`否2`,
"lable.system.administrator":`抱歉，您無權進行此操作，請聯繫系統管理員`,
"homepage.layout.buttion":`版面配置分配`,
"label.notification.event.overlapEvent":`被指派人已在{begintime}-{endtime}安排了{subject}，是否繼續建立？`,
"label.customfields":`自訂欄位`,
"label.data.downpage.e.title":`匯出數據的步驟:`,
"label.notification.serviceappointment.remove":``,
"label.campagin.roi.zhuangtai":`市場活動狀態`,
"label.applt.updown":`下載小程式二維碼`,
"label.customfields.new.step1.tip":`指定自訂欄位所要包含的訊息類型`,
"label.staticresource.upload.limit":`只能上傳以下格式中的文件:png、jpg、gif、js、css、zip.`,
"chatter.edit.user.p":`更改使用者頭像`,
"label.icon.32":`電腦`,
"vue_label_homepage_notice_cantset":`未給該設定檔配置設定檔主頁，無法修改設定檔的預設主頁`,
"front-epwechat-module-v1-agree-unbound":`同意並接受以上解除綁定資訊`,
"label.version.chatter.cooperation":`同事圈`,
"label.customer.tab.step1.selectstyle":`請選擇選項卡樣式`,
"label.select.an.asset":`請選擇一個資產`,
"label.search.sizer.field":`搜尋篩選器欄位`,
"label.emailmerge.mergeFolder.lastone":`請至少選擇一個範本!`,
"label_tabpage_step2":`第二步：指定過濾條件`,
"label.version.lead.automatic.allocation":`商機自動分配`,
"label.projectManagement.update.succeeded":`更新成功`,
"label_tabpage_bar":`條`,
"label.appupload.component.type.tab":`選項卡`,
"label.pigeonhole.sel.f":`選擇要歸檔的文件夾`,
"homepage.components.status":`組件狀態`,
"label.currency.edit.new":`幣種編輯：新幣種`,
"label.input.new.password":`請輸入正確的新密碼`,
"chatter.group.membersName":`成員名`,
"label.myinfo.modify":`編輯我的訊息`,
"label_tabpage_next":`下一步`,
"vue_label_homepage_card_closedopportunities":`已逾期的機會`,
"label.permission.edit":`編輯屬性`,
"message.error.searchfield.objid.null":`查詢欄位所需的物件id不能為空`,
"label.partnerCloud.productSet":`產品設定`,
"label.emailtocloudcc.filed.emailto":`Email to`,
"label.service.miniProgram.uploadingImage":`請上傳輪播圖圖片`,
"label.sso.saml.idp.description1":`連接的應用程式`,
"label.event.moveup.10minutes":`提前 10 分鐘`,
"label.quote.createby":`準備者`,
"label.workflow.baseontimeoparate":`依賴於時間的工作流程操作`,
"label.searchall.r":`重新搜尋`,
"vue_label_homepage_differentprofiles":`為不同的設定檔指派不同的主頁`,
"label.campaign.channel.step1":`步驟1：基本訊息`,
"label.event.moveup.2hour":`提前 2 小時`,
"font-evaluate-module-v1-cancle-reply":``,
"message.datalocked.delete":`記錄已鎖定:您試圖刪除的記錄已鎖定。如果必須執行此操作，請與您的管理員聯繫。`,
"label.sso.listOfKey":`密鑰列表`,
"label_chatter_newtask":`新建工作`,
"label_emailsync_form_seversetting":`設定`,
"label.partner.new.function":`功能說明`,
"vue_label_notice_homepage_pleaceentername":`請輸入主頁名稱`,
"message.please.choose.opportunity":`請選擇機會`,
"label_file_use_most_user":`使用存儲空間最多的使用者`,
"label.htyj.remark2":`無法查看合約業績`,
"label.formula.message":`當公式評估為假時提交的失敗提示訊息`,
"UG_Case_04":`個案指派`,
"label.displaycolumn":`顯示列`,
"vue_label_campaign_selected_member_status":`更新為選定成員狀態`,
"label.workflow.operate":`工作流程操作`,
"label_chatter_mail":`信件`,
"label.setup.mini.setting":`小程式後台設定`,
"vue_label_chat_invitetojoin":`你邀請“{invite}”加入了群聊`,
"setup.object.field.dependency.label.linkedfieldvalue":`相依欄位值`,
"vue_label_email_update_template":`更新範本`,
"label.email.template.private.mail":`專用郵件範本檔案夾`,
"lable.Confirm .potential.customers":`確認回收商機{name}`,
"vue_label_leadpool":`商機公海池`,
"label.ems.hostorpost.error":`伺服器或埠號配置錯誤，請檢查。`,
"label.search.saveok":`儲存成功`,
"label.custom.field.cannot.maping":`無法多次映射到此欄位`,
"label.projectManagement.dispatched":`已派遣`,
"time":`時間`,
"label.choose_socialnetwork":`選擇一個社交網路開始`,
"label.vlidaterule.checkedtrue":`如果是複選框欄位時直接這樣判斷，不需要加雙引號`,
"label.appointmentconfirmail.wizard.btn1":`重新預約`,
"front-kefu-moudle-v1-maxchars-input":`最多輸入{0}個字元`,
"setup.mainpage.label.welcome10":`操作指導： 點擊本頁左側選單 → 應用程式設定 → 建立 → 物件 → 物件名 → 自訂配置。`,
"label.ems.company.setup.title":`公司發件箱設置`,
"label.channel":`營銷渠道`,
"label.textmessage.groupsms":`群發簡訊`,
"label.asset.deleted.successfully":`刪除資產BOM成功`,
"label.knowledgebase.new.workspace":`建立工作區`,
"label.ServiceCloud.diliweizhi":`地理位置`,
"label.private_me":`僅對擁有者（本人）`,
"label.service.miniProgram.imageLink":`輪播圖連結`,
"label.area.assigned":`已分配的使用者`,
"label.weixin..xsld.name":`業務機會名稱`,
"label.campaign.matchway.select.name":`姓名`,
"label.installedsoft":`已安裝的軟體包`,
"label.projectManagement.spare.time":`空餘時間`,
"label.user.select.custom.text.sendemail":`選擇自訂的文本格式直接發送郵件`,
"label_chatter_chatter":`CCChat`,
"label.approveorrefuse":`進行審批`,
"startdate.enddate.time.illegal":`開始日期應小於等於結束日期。`,
"label.project.hit.eight":`每天項目工作提醒`,
"message.duplication.label.uncheck":`不校驗`,
"label.allocation.role":`分配使用者`,
"label.sendemail.lead.scoreinfo":`?尊敬的#userName:\r\n 系統已經使用商機評分規則，對您所選擇的商機視圖“#viewlabel”上所有的商機評分完畢，耗時#timestr,\r\n 請您登陸系統，打開視圖進行查看。 \r\n 請注意：\r\n 如果沒有看到商機評分分值，您可以編輯視圖，添加”商機評分“到要顯示的欄位上查看評分的結果。 \r\n 感謝您的使用！ \r\n #orgName\r\n`,
"lable.oppt.jieduan.closejieduan":`結束此業務機會`,
"label.ems.verify":`驗證`,
"message.error.startdate":`開始日期必須小於結束日期`,
"label.campaignmember.main.deletelead":`刪除成員-現有商機`,
"label.partnerCloud.financeSetting.account":`啟用後，會新增夥伴賬戶與帳戶流水物件，合作夥伴使用者在下單時可以使用CloudCC系統內的帳戶支付。`,
"message.datalocked":`記錄已鎖定:<br>    您試圖編輯的記錄已鎖定。如果必須執行此操作，請與您的管理員聯繫。`,
"lable.opppdt.selPbk.pricebook":`價格手冊`,
"label.knowledgebase.restore.article":`還原文章？`,
"label.object.batchadd":`批次新增{objName}`,
"label.what_happen":`訪客送出此一表單後所看到的頁面`,
"label.roleandunderling":`角色和下屬`,
"label.knowledge.language.russian":`俄語`,
"front-electronic-signature-explain-first":``,
"component.sendmail.label.subject":`主題`,
"month":`月`,
"label_chatter_save":`儲存`,
"label.view.sortview.sectiontitle":`視圖將按照選擇的順序輸出。`,
"label.mobile.home.page.major.project":`重點項目`,
"label.weixin.input.filename":`請填寫文件名`,
"label.pagelayout.remark":`使用此頁面可建立各種頁面配置以顯示`,
"label.service.miniProgram.store":`品牌故事`,
"label.recordtype.edit.selected":`所選值`,
"message.selectgroupcondition":`請選擇分組條件`,
"label.y.axis.cannot.empty":`Y軸不能為空！`,
"label.textmessage.vonage.connected.count":`計為已聯繫`,
"setup.layout.label.readonly":`唯讀`,
"front-kefu-moudle-service-agent":``,
"message.login.mfaverification.page.invalid":`頁面失效，請重新刷新頁面`,
"label.central.standard.time":`中央標準時間`,
"label.processnoticepic":`審批過程注意圖像`,
"vue_label_helpcenter_calendar1.2":`日曆項目顯示規則：日曆項目會顯示在日曆網格中，日曆項目所在的格子區域代表著此條記錄所處的時間範圍。日、星期、可用性視圖中會在時間刻度頂部顯示跨度超過24小時的日曆項目。月視圖中一個網格中如果有多個日曆項目，可以點擊“ 更多”查看。日曆項目左或右側邊呈半圓，代表所在格子的前一天或後一天都沒有此記錄。日曆項目左或右側邊呈直角圓，代表所在格子的前一天或後一天還有此記錄。 <br>快速定位日曆視圖的日期：您可以通過選擇日曆頁面右側的小日曆上的時間去定位左側日曆視圖顯示的日期範圍。您也可以單擊日曆頁面右上方“<”和“>”圖示快速切換日期。如果您的日曆視圖所處的時間不是當前時間，您可以單擊日曆頁面右上方“今天”圖示快速切換回今天。 <br> 列表視圖<br>從日曆視圖切換至列表視圖：單擊日曆視圖右上方“日曆”圖示，選擇“表格”，即可切換至事件列表視圖。 <br>列表視圖的使用：要同時查看特定事件或多個事件，打開表視圖??。列表視圖中有預設的列表視圖，單擊列表視圖左上角“下拉按鈕”圖示，即可展示所有您具有存取權限的列表視圖。您還可以通過自訂事件列表視圖，以滿足您的需求。 <br>2、我的日曆和其他日曆<br> 我的日曆<br>我的日曆包含我的事件日曆和物件日曆。 <br>我的事件日曆：在日曆視圖上顯示被指派人是您的所有事件記錄。我的事件日曆不能移除、編輯或更改顏色。您可以將“我的事件日曆”共享給您的同事。`,
"label.approval.end":`流程結束`,
"vue_label_report_notice_cannotdelete":`該文件夾內有報表不能刪除`,
"label.sso.saml.idp.loginurl":`身分識別提供者登入URL`,
"label.emailtocloudcc.filed.port":`埠`,
"label.directdashboard.righttitle":`銷售分析儀表板`,
"label.knowledge.case.suggest.article":`在個案中建議相關文章`,
"label.version.maxcount":`，已超出上限！`,
"label.weixin..xsld.yjqyrq":`預計簽約日期`,
"front-project-module-v1-unmarket-is-template":`取消範本標記`,
"label.mobile.quickcreate.default.map":`簽到`,
"chatter.click.p":`單擊預覽`,
"label.chat.topic.all.topic":`所有主題`,
"label.channel.head":`通路負責人`,
"lable.edit.queue.emaildes":`輸入發送通知時（例如已將個案放入佇列時）要使用的佇列名稱和電子郵件地址。電子郵件地址可以是單個地址，也可以是通訊組列表。向佇列指派物件時，將只通知佇列成員。`,
"label.tag.filter":`標籤過濾`,
"label_chatter_filterTimeLine":`篩選時間軸`,
"label.dashboard.show.value":`顯示值`,
"vue_label_normal_solution_sf":`解決方案`,
"label.customfields.location.tip":`允許使用者定義位置。包括經度和維度組件，可用於計算距離。`,
"label.weixin.copyright":`Copyright© 2008-2022 CloudCC.com, inc. 北京神州雲動科技股份有限公司版權所有。`,
"label.icon.33":`電腦`,
"label.mr.title.opportunityName":`業務機會名稱`,
"template.report.sales.month":`本月銷售情況`,
"chatter.group.lookingForPeople":`查找人員...`,
"label_tabpage_userz":`使用者`,
"label.reportsSubscriptionPage.email.formatselection":`請選擇你想要郵件的報表形式`,
"lable.product.plist":`價目表價格`,
"label.multilang.activity.monthline":`第{0}周`,
"label.ccchat.whose.name.contains2":`的任何活動小組的成員`,
"label.mobile.phone.day.report":`日報`,
"label.processsetting.set.files":`設定欄位`,
"label.systemlog.s":`成功`,
"label.tabpage.uploadsz":`上傳`,
"serviceterritory.member.time.conflict":`在此時間範圍內，服務資源已成為其他服務區域成員`,
"label_chatter_startDate":`開始日期`,
"label.search.at.least.two":`搜尋詞不能少於兩個字元`,
"label.approval.ressign.project":`待分配項目`,
"lable.custom.Previous.CY":`上一個自訂年度`,
"label_chatter_link":`連結`,
"label.weixin.group.name":`名稱`,
"label.partnerCloud.basicSetting.domainName":`該操作不可逆，且初始化後不可修改網域名，是否確定？`,
"lable.SalesCommitmentKanBan.targetContract":`目標簽約額`,
"label.currency.new":`新公司幣種`,
"message.passwordPolicy.validate.complexReq3":`錯誤：密碼必須是數字、大小寫字母的組合和符號`,
"label.icon.127":`醫生`,
"label.customfields.fieldname.tip":`欄位名"供內部用於API整合`,
"chatter.feed.menutype.feed":`摘要`,
"label.home.standard.dashboard.role":`您沒有角色訊息，不能查看銷售承諾看板。`,
"label.customfields.fielddependency.button":`單擊該按鈕可在依賴選項列表中包括所選值或從中排除這些值`,
"label.recentprojects":`最近存取的記錄`,
"label.appupload.logo.introduce":`AppExchange軟體包圖標文件大小必須小於20K。為獲得最佳效果，建議圖像尺寸為寬60像素，高60像素。其它尺寸的圖像，系統會調整其大小，可能會失真。另外，只有儲存後，新圖才能生效。`,
"label.integrations.northamericanleads":`北美商機`,
"label.sms.balance":`餘額(元)`,
"label.ccchat.message.num":`給您發了一條消息`,
"label.embed_website":`僅需將以下代碼複製並黏貼在您的頁面HTML代碼中，即可嵌入本表單。`,
"label.trigger.check.error":`觸發器語法檢查失敗`,
"label.bmap.baidu.maps":`百度地圖`,
"label.nextapproverauto":`下一個審批者的自動確定方式`,
"label.customfields.date.tip":`允許使用者輸入日期或從彈出式日曆中選擇日期。`,
"button.partner.back":`返回`,
"label.layout.editcondition.tip":`選擇要作為查找條件的欄位。請注意，此處最多可選擇10個欄位`,
"label.stacked.area":`堆疊圖形-區域`,
"font-evaluate-module-v1-case-closed":``,
"label_emailsync_status_log":`關聯記錄`,
"label.version.area.and.sales":`區域管理和銷售團隊`,
"label.service.booking.sessions":`服務預約時段`,
"label.untransfile":`未翻譯的語言檔`,
"label.textmessage.sentfail":`發送失敗`,
"label.emailtemplate.detailinfo":`郵件範本詳細訊息`,
"setup_mainpage_label_welcome13":`操作指導： 點擊頂部選單 → 報表 → 建立 。`,
"label.ccchat.error.nullid":`ID不能為空`,
"label.partnerCloud.partnerAccount.rebate":`回饋金收入`,
"label.appupload.component.type.scheme":`欄位`,
"front-kefu-moudle-phonein":``,
"label.emailmerge.list.description":`郵件合併範本為Microsoft Word 文檔，其中的合併欄位引用Cloudcc欄位。單擊'新建範本'可上傳新的郵件合併範本`,
"vue_label_commonobjects_detail_select_first":`請先選擇相關項`,
"label_emailsync_form_action":`操作`,
"label.customfieldrelation":`自訂欄位和關係`,
"label.ems.other.msg":`請聯繫Cloudcc管理員(<a href`,
"label.appointment.wizard.subtitle4-3-4":`1小時`,
"label.service.miniProgram.isOpen":``,
"equal":`等於`,
"label.partnerCloud.financeSetting.merchantInformation":`獲取路徑：商戶平台-帳戶中心-商戶資訊`,
"vue_label_calendar_displayed_field_name":`顯示的欄位名稱`,
"UG_opportunity_002":`定義您的銷售周期 配置階段`,
"label.tag.addtags.button1":`確定`,
"label.explain":`說明`,
"label.icon.166":`亭子`,
"label.exchange.sync.setting.use":`啟用 Exchange Sync`,
"label.chatter.assignPerson":`被指派人`,
"lable.PowerProcess.event.condition":`重大事件條件`,
"label.addattachment.step1":`步驟 1.選擇文件`,
"label.account.fiscal.quarter.timeerror":`會計季度開始日期或會計季度結束日期在歷史會計季度時間段內，請檢查後重新設定！`,
"label.URL":`URL路徑`,
"label.icon.134":`數據`,
"label.forecast.customforecast.foredis.sq":`數千`,
"label.custom.field.number.decimal":`數字位數不對`,
"label.version.history.track.error":`您的版本目前僅支援選擇<`,
"label.log.os":`操作系統`,
"label.partner.workspace.tab.option":`可選選項卡`,
"label.partnerCloud.partnerAccount.accountWater":`帳戶流水`,
"setup_layout_label_norelatedlist":`暫無相關列表`,
"label.import.page1.nextstep":`下一步`,
"label.emailobject.view.attached":`有附件`,
"label.SalesCommitmentKanBan.allTask":`總任務額`,
"label.eastem.daylight.time":`東部夏令時`,
"label.create_engaging":`建立一個吸引人的帖子，與世界聯繫。`,
"label.area.adduser":`添加或刪除使用者`,
"label.timezone.importtimezone.user":`使用當前使用者時區時間`,
"label.passwordPolicy.setup.pwdremember1":`記住1個密碼`,
"label.query.detail.openpartneruser":`啟用合作夥伴使用者`,
"label.senduser":`發件人`,
"Pagelayout_Setup_001":`選擇要在懸停版面配置上顯示的相關列表`,
"label.mobile.parameter.setup":`行動端參數配置`,
"message.device.not.bound.mfa":`未綁定的MFA設備`,
"setup.layout.label.buttonarea":`按鈕區域`,
"chatter.email.reply.like":`對我喜歡的帖子回覆時`,
"label.chatter.day":`天`,
"label.sendemail.chat.addComentspraisesubject":`CloudCC CCChat 回覆喜歡的微貼`,
"label.field.remark2":`頁面上顯示的欄位。`,
"label.ggReleaseRange.release":`發布範圍`,
"lebel.alreadyback":`已調回`,
"label.appupload.install.appname":`應用程式名稱`,
"label.selectnewadeckertag":`選擇新階層架構欄位的標籤`,
"label.cliententrancewebsiteadmin":`客戶入口網站管理員`,
"label.checkbox.checked":`選中的`,
"UG.Case.03":`個案自動升級`,
"vue_label_dashboard_group":`請選擇一級分組`,
"label.import.index.preparedata":`準備您要匯入的數據`,
"vue_label_member_notice1":`您可以上傳JPG、GIF或PNG文件，最大文件大小為2M`,
"message.modify.success":`修改成功。`,
"label.userquotas":`定額`,
"label.appointmentpage.wizard.subtitle3-1":`姓名`,
"label.import.index.maxdata2":`2、匯入之前，請先確保匯入其相關的所有記錄。例如：如果您當前匯入的物件與聯絡人之間存在查找關係，請先匯入這些聯絡人，然後再匯入您的數據。若需獲取對應記錄id等訊息，可建立報表，並將記錄名稱與記錄id設定為組列，再將報表匯出。`,
"label.pc.sectionpart":`PC部分`,
"template.chart.wcldqzkh":`未處理的商機`,
"label.save.the.block.pricing.information.of.the.current.price.manual":`是否儲存目前價格手冊的分塊定價資訊？`,
"label.partnerCloud.financeSetting.payments":`允許訂單線上付款`,
"lable.account.ThisWeek":`本星期`,
"label.validate.function.funcFormat.RIGHT":`RIGHT(text, num_chars)`,
"label.app.select.bgcolor":`選擇背景色`,
"label.planned.work":`計劃的作業`,
"label.passwordPolicy.setup.nolimit":`無限制`,
"label.vlidaterule.s":`如果您禁用使用者使用的幣種，則使用者的幣種將被設置為公司幣種.`,
"label.paging.totalofrecords":`共X條記錄`,
"label.customobjects.behaviour":`行為`,
"vue_label_ccchat_notice_deletecommentsuccess":`刪除評論成功`,
"label.lock.record.dele":`當前記錄已鎖定，不允許刪除！`,
"label.data.expnode.e.desc3":`3、範本製作：使用者可以根據需求將所需匯出的欄位及條件製作成範本，方便下次使用。`,
"label.button.step3.create.page":`步驟3：產生頁面`,
"label.sharer":`共享者`,
"label.service.cycle.type":`週期類型`,
"lable.SalesCommitmentKanBan.allreceivingCommitmentRate":`總收款承諾率`,
"label.formuladate":`日期格式：yyyy-MM-DD hh:mm:ss或MM/DD/YYYY hh:mm:ss 比如: 2007-12-25 12:25:30或12/25/2007 12:25:30 ,也可以使用today()，或now();`,
"front-template-V1-addImg":`新增圖檔`,
"label.basecontrol":`基本權限`,
"label.forecast.settings.lable1":`預測數據加總`,
"message.error.file.null":``,
"label.multiply":`*乘`,
"message.duplication.label.targetobject":`目標物件`,
"label.addattachment":`添加附件`,
"vue_label_dashboard_notice_editcertification":`確認編輯組件{name}嗎？`,
"label.notification.tip2":`您現在沒有新通知`,
"lable.quote.syncingfrom.firstsync":`初步同步： 業務機會同步至報價單`,
"label.createtasktip":`建立一個任務以關聯一個或多個工作流程規則、審批流程或權利過程。 如果更改任務，任何修改都將應用到與之相關聯的所有規則、審批或權利過程。`,
"label.leave":`離開`,
"front-invoice-online-payment-setup-china":``,
"label.appointment.wizard.subtitle4-1-2":`30分鐘`,
"label.projectManagement.the.person.not.be.informed":`當您選擇否時，將無法通知負責人!`,
"label.campagin.roi.name":`市場活動名稱`,
"label.import.page1.newcreate":`建立`,
"label.data.downpage.i.title.num2":`2、開始匯入之前，請確保您要匯入文件中的欄位名稱和 CloudCC 系統中物件欄位名稱的相符。`,
"label.callcenter.call.in":``,
"label.weixin.activity.phone":`活動: 電話`,
"label.forecast.customforecast.type.role":`按角色`,
"label.moscow.standard.time":`莫斯科標準時間`,
"label.profile.setcustomobjectrecordtype":`自訂物件記錄類型設置`,
"lable.edit.queue.new":`新建佇列`,
"label.newAPPexchange":`新建應用程式...`,
"message.custom.field.donotdelete.fieldupdate":`該欄位被其他工作流程或審批流程下的欄位更新所引用`,
"label.chatter.state":`狀態`,
"label.subject_line":``,
"template.report.folder.active":`活動和行為分析`,
"label.icon.114":`房子`,
"label.assignment.setup.newentries.step3":`步驟 3：選擇要分配的使用者`,
"label.salescloud.salesdashboard.sales.behavior.rankings":`個人-行為一覽`,
"label.weixin.optiontwo":`選項二`,
"label.sso.saml.idp.config.sp":`服務供應商`,
"System_TimeField_Description":`允許使用者輸入當地時間。例如，"2:40 PM"、"14:40"和"14:40:00" 。皆為此欄位的有效時間。`,
"label.knowledgebase.draft":`草稿`,
"label.chat.topic.no.more.suggestions":`無其他建議`,
"label.quote.product":`產品`,
"label.cryptographictext":`加密文本`,
"label.custom.unlock":`解鎖`,
"label.assignment.setup.newentries.step2":`步驟 2：選擇此規則項目的條件`,
"label.tabularreport.selectline":`選擇要在報表中包含的列`,
"label.exchange.sync.state.contact.m2":`在最後 60 分鐘同步的記錄：`,
"label.codeType":`碼類型`,
"saturday":`星期六`,
"label.mask.type":`遮罩類型`,
"label.schedulejob.setup.schedule.Monthly":`每月`,
"label.import.page2.totalfiled{{20}}，{{4}}notsuited":`文件中共{{20}}個欄位，剩餘{{20}}個未映射`,
"label.projectManagement.delete.item":`刪除該項目，將刪除項目和項目關聯的所有訊息，且數據無法恢復，是否確認刪除`,
"label.page.general.us.and.western.europe":`通用美語和西歐語言`,
"label.reportsSubscription.status":`已訂閱`,
"label.discount.baifenbi":`折扣（%）`,
"font-evaluate-module-v1-web-page-evaluation-settings":``,
"message.error.searchwork":`搜尋詞不能少於兩個字。`,
"label.weixin.option.setting":`選項設置（最多設置10個選項）`,
"label.lead.score.prompt1":`針對單個商機系統可在新建，編輯商機時自動評分，但針對批次匯入或者通過接口建立的商機需使用批次評分手工進行。`,
"label.exception.must.try.throw":`異常必須在語句塊中拋出！`,
"label.activity.plan":`計劃`,
"label.partnerCloud.productSet.editor":`編輯選項`,
"label.mobile.quickcreate.default.signinnew":`簽到`,
"label.summaryreport.2018.step6.new":`步驟6：選擇圖表類型和報表突出顯示`,
"vue_label_homepage_owner":`我的主頁`,
"vue_label_dashboard_editfoldersuccessfully":`編輯文件夾成功`,
"label.quickbooks.view.overdueinvoices":`逾期的Invoices`,
"label.emailtocloudcc.redmessage4":`請輸入埠訊息`,
"label.tabpage.equalz":`等於`,
"lable.quote.syncing.firstsync":`初步同步： 報價單同步至業務機會`,
"label.download.CloudCCAPP":`下載CloudCC App`,
"label.icon.6":`貨幣`,
"label.list.serial.number":`序號`,
"label.profile.setstandardobjectrecordtype":`標準物件記錄類型設置`,
"label.customize.memory.function.sorting.error":`查詢時間過長導致頁面超時，可能是由於您啟用了視圖表頭排序記憶功能，請前往個人設定並禁用該功能重試。`,
"message.view.addtoallusers":`相關人員可視`,
"label.globaloperation.operationtype.record.phone":`記錄電話`,
"lable.opppdt.selPdt.searchresult":`查詢結果`,
"label.import":`匯入`,
"label.service.gantt.work.based.resources":`基於工時的資源`,
"label_partner_template_detailimage":`詳圖`,
"label.cpq.product.feature.option.count":`產品選項最小數量不能大於產品選項最大數量`,
"label.chatter.newtask":`建立工作`,
"font-trade-module-v1-invoice-total-price":``,
"setup_mainpage_label_welcome29":`標準的API 與第三方產品集成`,
"label.data.exportall.all.btn":`匯出全部數據`,
"front-epwechat-module-v1-unbound-WeChat":`解除綁定企業微信`,
"label.salescloud.salesdashboard.performance.rankings":`整體-銷售合約業績排行榜`,
"label.import.page1.newcreateandupdate":`更新並建立`,
"component.chatter.post.button.file":`添加附件`,
"label.partnerCloud.orderingPlatform.createOrder":`建立訂單`,
"label.lookup.multiple.data":`檢索到的數據有多條，請手動選擇`,
"button.partner.save":`儲存`,
"label.service.add.timeslot":`添加時段`,
"label.campaign.matchway.select.email":`電子郵箱`,
"front-sales-button-fromQB":``,
"label.icon.108":`箭頭`,
"lable.outlook.edit.efmapping":`編輯欄位映射`,
"label_tabpage_refreshz":`重新整理`,
"chatter.follow.cancel":`取消追蹤`,
"label.totals.sum":`統計總數`,
"label.noRequest":`無要求`,
"vue_label_homepage_fixedcomponent":`請選擇標準組件`,
"label.knowledge.delete.case":`刪除個案文章出錯`,
"label.weixin..xsld.yjwc":`預期收入`,
"label.customcomponent.page.index.console.btn":`開發人員控制台`,
"label.sendsms.batch":`批次發送簡訊`,
"vue_label_chat_onlychosechat":`只能選擇使用群策的使用者聊天`,
"label.tabpage.page":`頁`,
"label.cyen.note":`幣種啟用。請注意，啟用幣種之後將不可逆。`,
"label.weixin.againsend":`重新發送`,
"label.processnumber":`步驟號`,
"label.emailobject.to":`收件人：`,
"label.event.today":`今天的事件`,
"label.dashboard.dispalyPosition":`顯示位置`,
"message.error.recalculate.dupoperate":`重計算正在進行中，請勿頻繁操作！`,
"vue_label_email_linkrecordsuccess":`關聯記錄成功`,
"label.updateoutboundnews":`更新出站消息`,
"label_emailtocloudcc_exists2":`此信箱已經設定為Email to Case，請勿重覆設定`,
"label.tag.addtags.button2":`取消`,
"label.stdashbord.xsld.business.role":`該角色取自預測階層架構中已啟用使用者的角色`,
"label.commonnew":`普通新建`,
"label.validate.remark2":`使用示例：`,
"label.reportsSubscriptionPage.condition.checkbox":`在此報表上添加條件`,
"label.globalselect":`全局選項列表值集`,
"label.partnerCloud.partnerAccount.available":`可用額度`,
"label_tabpage_nothingz":`無`,
"label.version.webtolead":`We to Lead`,
"label.projectManagement.heat.map":`熱圖`,
"message.error.pleasecorrectdata":`請審查下列所有錯誤消息以糾正數據。`,
"label.hight.tip":`不啟用進階篩選時，不同篩選，各個條件之間是“與”，也就是滿足1與2共同的特徵的記錄`,
"label.workflow.estimatecondition3":`每次建立或編輯記錄時`,
"AssetRelationship.time.limit.error":`起始日期應小於等於截止日期`,
"label.multilang.workflow.dayinmonth":`每隔{0}個月的第{1}天`,
"label.reportsSubscriptionPage.schedulereport.daily":`每天`,
"label.emailtocloudcc.step1.name":`選擇功能`,
"label.follow_up":`跟進郵件`,
"label.price.list.price.cannot.be.empty":`價目表價格不可為空`,
"label.chatter.link":`連結`,
"label.ccpeak.condition.return.record":`按條件返回記錄，支援常用的where條件。`,
"pagecreator.layout.message.canntdelete":`當前配置不允許刪除`,
"label.compact.layout.main":`主要關鍵訊息配置`,
"label.testandupdate":`檢查更新`,
"button_partner_cancel":`取消`,
"label.activity":`活動`,
"label.knowledge.setting.hint.fourteen":`您已準備進行撰寫！`,
"vue_label_commonobjects_view_open_from_list":`從列表中打開,以開始使用`,
"front-electronic-export-intro":``,
"label.chosen.all":`全部欄位`,
"label.file.extension":`文件擴展名`,
"vue_label_systemSettings_server_miniprogram":`服務小程式`,
"label.weixin.no.pending.wdgz.qin.today":`親，今天沒有工作安排`,
"label_tabpage_issuez":`問題`,
"label.staticresource.tip":`使用靜態資源上傳您想在自訂頁面中引用的內容，包括.zip、圖像、樣式表、JavaScript程序和其他文件。`,
"label.approvalstep":`審批步驟`,
"label.china.standard.time":`中國標準時間`,
"label.appexchange.download.tiaoguo":`跳過`,
"label.callcenter.link.Amazon.connect":``,
"vue.dashboard.notRequired.notConformToTheRules":`有必填項未填寫或不符合規則，不可提交！`,
"label.appointment.wizard.title1":`請設定您的空閒時間`,
"label.chat.remove.bookmark":`取消收藏`,
"label.tabpage.advancedsearch":`進階搜尋`,
"batch.ranf.f":`批次轉移操作失敗！`,
"label.appointment.wizard.subtitle4-1-4":`1小時`,
"label.brief.account":`客戶`,
"component.chatter.link.label.url":`連結URL`,
"label_emailtocloudcc_redmessage8":`參數錯誤，請聯繫管理員`,
"label.object.create.two.number.field":`每個物件最多可以建兩個自訂自動編號欄位`,
"label.salecommit.not.roleinformation":`您沒有角色訊息，不能查看銷售承諾看板。`,
"label.defautline.cannot.less":`預設行數不能少於1行`,
"label.selectedproducts":`已選產品數`,
"label.productsales.today.notskadd":`今天沒有到期的工作，您也可以點擊右上角的“ ”添加工作！`,
"lable.account.year.stadate":`會計年度開始日期`,
"label.mobile.phone.month.plan2":`本月計劃`,
"label.ccpeakfolder":`類文件夾`,
"setup_mainpage_label_welcome21":`CloudCC 雲平台提供使用者自訂郵件範本功能。方便使用者統一使用，提高工作效率。`,
"label.modify.layout":`編輯配置`,
"report.label.folder":`文件夾`,
"label.tianyancha.businessverify.rewritename":`回填客戶名`,
"lable.currencyAdv.dao":`到`,
"label.mobilelayout":`行動端配置`,
"label.the.current.model.is.enabled.and.cannot.be.edited.":`當前模型已啟用，不可編輯。`,
"label_partner_all_disable":`禁用`,
"label.ownerapproverfield":`擁有者 的審批者欄位`,
"label.emailobject.template.message4":`當前郵件正文中插入的欄位存在空值，建議編輯後重新發送！`,
"label.productsales.today.notsk":`今天沒有到期的工作！`,
"label.multilang.document.upload.success":`成功上傳了{0}個文件,失敗了{1}個文件`,
"label.manageAll.sta3":`審批拒絕`,
"vue_label_calendar_week_view":`日曆-星期視圖`,
"setup_layout_label_nocustompage":`暫無自訂頁面`,
"label.weixin.wdyj.jxdcl":`個人-績效達成率`,
"label.donot.update":`您沒有更改權限！`,
"setup.mainpage.label.welcome14":`工作流定製、批准過程管理`,
"UG_Campaign_002":`規劃、執行並監控行銷活動的效果。`,
"label.layout2":`配置二`,
"label.app.looup":`查找應用程式`,
"label.projectManagement.selectitem":`請選擇項目`,
"label.field.relating.rule":`查找欄位關聯規則`,
"vue_label_commonobjects_detail_selectname":`請先選擇名稱`,
"front-email-payment-Invoice-select-pay":``,
"label.customfields.formula.numberexample":`Fahrenheit（華氏度）`,
"component_event_label_enddate":`*結束時間`,
"label.partnerCloud.partnerAccount.lineOfCredit":`信用額度`,
"label.chatter.newpost":`最新帖子`,
"label.report_dashboard":`本報表將存於您的所有報表中。您可以新增該報表至儀表板。`,
"label.assigned":`被分配人`,
"Homepage_News_002":`當前新聞組件服務不可用`,
"label.approval.select.relatedobj":`選擇相關項必須選擇一個類型`,
"label.service.miniProgram.isTop":`是否置頂`,
"message.error.object.datatoolang":`數據長度太長，最長{!length}個字元。`,
"label.importsourcetip":`匯入用於將匯出的文件修改後，再匯入到系統中。如果還未匯出，請轉到匯出頁面匯出。`,
"label.select.deadlineplease.deadline":`請選擇截止時間`,
"vue_label_account_equityrelationship":`股權關係`,
"label.account.Calendar.month":`日曆月`,
"label.appointment.wizard.subtitle3-4":`週四`,
"font-evaluate-module-v1-smaller-500":``,
"label.reportsSubscriptionPage.email.tome":`只發送給我`,
"label.ccchat.person.invite.existpers":`已經在追蹤：`,
"label.appointment.wizard.subtitle1-3":`30分鐘`,
"front-kefu-moudle-connected":``,
"label.campaignmember.main.duplicatelist.tip":`系統將根據此處的設置，啟用進行商機和市場活動成員除重。`,
"label.visualpage.such.tags.double":`等標籤一定成對出現`,
"label.sendsms.batch.step2.introduce":`按簡訊範本發送：請選擇要使用的按簡訊範本。`,
"Account_News_Setting_002":`使用下面的客戶設置為貴組織指定預設的客戶行為`,
"message.encryptchange.alert":`您即將把{{!fieldapi}}從“加密欄位(存儲加密)”轉換成“加密文本(顯示加密)”，轉換成功後，此欄位將以明文形式存儲在數據庫中，顯示時根據設定檔設置可為明文顯示或加密顯示，欄位可搜尋。\\r此操作不可逆轉，請確認是否繼續進行?`,
"label.mainpageset.description":`根據實際使用場景配置組織級主頁<br>你可將與企業業務無關的組件從預設配置中禁用或關閉。<br>啟用：啟用的模塊顯示在所有成員的主頁中。<br>禁用：禁用的模塊不顯示在所有成員的主頁中，也不支援顯示在行動端“配置我的主頁”列表中。<br>關閉：預設不顯示在組織內所有成員的主頁中，使用者可以通過行動端“配置我的主頁”來開啟模塊。`,
"label_tabpage_linknamez":`連結名稱`,
"label.companyname":`北京神州雲動科技有限公司`,
"label.currency.current":`當前公司幣種`,
"label.campaignmember.main.duplicatelist.html.title":`掃碼除重設置`,
"label.sendsms.batch.step3.plan":`交付日期計劃`,
"label.profile":`設定檔`,
"label.canceluploadfile.step":`單擊“取消上傳”按鈕，則取消上方區域顯示的所有文件`,
"message.newreport":`新建報表`,
"label.service.newBuildDialog.date.selection":`日期選擇`,
"label.lookup":`查找`,
"label.file.editinfo":`編輯文件詳細訊息`,
"component_assistant_label_nodata":`今天無事項，請稍後檢查。`,
"label.tianyancha.businessverify.msg4":`本功能使用第三方數據查詢介面提供的服務，目前免費使用，但 CloudCC不確保後續第三方是否繼續免費。如果第三方收費，則 CloudCC 有權向使用者收費或者使用者停止使用此功能。`,
"label.noequal":`!=不等於`,
"vue_label_metric_column":`表必須擁有至少 1 個評測列。`,
"label_reportType_chose_and_form":`選擇報表數據源及報表格式`,
"vue_label_pool_reasondescription":`{0}原因描述`,
"label.isusing":`是否啟用`,
"label.passwordPolicy.setup.pwdremember5":`記住5個密碼`,
"label.cancel":`取消`,
"vue_label_helpcenter_detail1.1":`    在lightning版本的數據詳情頁中，可以查看單條記錄的基本訊息、相關的活動、動態，在模組右上角展開或收起對應訊息。還可以通過相關列表查看、管理與該記錄相關聯的數據。<br>1、查看、管理單條數據<br>通過右上角按鈕，可以對數據進行編輯、複製、刪除，或是為其他人員共用數據的權限。<br>查看使用者的詳細訊息，且可以在頁面上直接對部分欄位進行編輯，更改數據的擁有者或記錄類型。<br>通過相關列表，查看、管理與該記錄相關聯的數據。在文件相關列表中，上傳記錄的文件，或是通過點擊文件名稱來下載查看對應文件。<br>2、相關列表<br>通過相關列表快速連接，使用浮動視窗查看最多10條相關記錄。點擊後進入列表視圖，查看全部相關記錄，還可進行內聯編輯。<br>在下方使用卡片式查看與管理相關記錄。<br>3、活動<br>    在記錄的詳情頁面，Lightning版本不顯示“未處理活動”或“活動歷史記錄”這兩個相關列表。而顯示活動時間線。<br>活動時間線顯示內容<br>    活動時間線可以顯示當前記錄下從未來到過去的所有活動。已逾期的工作和即將到來的工作、事件在活動時間線“已逾期和即將到來”模組中展示。過去或現在的已結束的工作、事件、記錄電話、電子郵件、簡訊會在對應的月份展示。<br>快速更改工作狀態：勾選“已逾期和即將到來”模組中的工作前的複選框，單擊重新整理按鈕即可快速更改工作狀態為“已結束”。<br>    未重新整理前，取消勾選則工作狀態不改變。<br>    優先級高的工作在活動時間線中會用“紅旗”圖示標記。<br>活動時間線的顯示順序<br>    按照工作的到期日期、記錄電話的到期日期、事件的開始日期、郵件的收發日期、簡訊的收發日期倒序排列。如果以上日期相同時，會按照記錄建立的時間倒序排列。<br>活動時間線篩選器<br>    使用活動時間線中篩選器，以縮小可視事項的範圍、重點關注重要事項並查找目標事項。時間線的篩選器包括日期範圍、要顯示活動、活動類型三種類型的篩選。<br>    要顯示的活動：所有活動、我的活動<br>    在活動時間線篩選器中，此選項可以縮小活動的顯示範圍。<br>    我的活動：顯示您參與的活動，不論作為擁有者或參與者。例如，您是發送電子郵件或組織活動的擁有者。例如，在您是電子郵件副本或密件副本欄位的收件人時，即表示您參與活動。<br>    `,
"registration.page.preview":`註冊頁面預覽`,
"label.quickbooks.search":`搜尋`,
"label.setup.mobile.bottombutton.tab.show":`底部Tab顯示`,
"lable.want.to.delete.tem":`確定刪除{currentTelmplateName}服務報告範本嗎`,
"label.multilang.fielddtrack.dealkey":`將{0}從{1}更改至{2}：`,
"vue_label_pool_return":`退回`,
"vue_label_calendar_failed_to_share_calendar":`共用日曆失敗`,
"label.less":`<小於`,
"label.email.form.html":`HTML`,
"label.tag.nodata":`無標籤數據`,
"label.setarticlecon":`指定項目條件`,
"label.searchlayout.displayrow":`顯示的列`,
"label.change.task":`切換到任務視圖`,
"lable.quote.editqtpdt.title":`編輯報價單明細`,
"label.appointment.wizard.subtitle4-4":`最長可以提前預約的時間`,
"label.custom.page.button.css":`按鈕CSS`,
"label.input.documentmessage":`輸入詳細訊息`,
"vue_label_commonobjects_detail_email_address":`收件人地址`,
"label.chatter.filterTimeLine":`篩選時間線`,
"label.must.select.twoorthree.records":`必須選擇兩個或三個要合併的記錄`,
"label.mobile.setup":`手機端設置`,
"vue_label_commonobjects_detail_key_field":`關鍵欄位`,
"label.chatter.relateitem":`相關項`,
"label.customobjects.tip":`一旦建立自訂物件，便可以建立自訂選項卡、自訂相關列表、報表和儀表板，以便使用者對自訂物件數據進行交互操作。 您也可以通過 CloudCC.com API 存取自訂物件數據。`,
"label.sso.saml.idp.config":`身分識別提供者設定`,
"label.knowledgebase.affect.article.version":`更改是否會影響本文章的現有翻譯？如果這樣，您可以將之前的翻譯標記為“過期”。這樣，您可以產生需要翻譯供應商更新的文章清單。`,
"message.error.record":`未找到相應的記錄！`,
"message.duplication.label.fieldname":`目標欄位`,
"setup.layout.button.cancel":`取消`,
"label_radar_map_function":`利用雷達圖與多個指標，衡量聯絡人在銷售決策鏈中的作用`,
"label.campagin.roi.fss":`發送數`,
"label.emailobject.template.giveup":`放棄`,
"label.apiname.exists":`Api名稱已經存在`,
"message.failtoreaddata":`讀取數據失敗`,
"label.file.versionedit":`內容修改者`,
"template.report.lost.business.opportunity":`丟單的機會`,
"label.ccchat.group.allowgd":`允許小組歸檔`,
"label.fieldaccesslimit":`欄位可存取性`,
"label_target_model":`目標模型`,
"message.validation.isnoturl":`輸入正確的URL`,
"servicecrew.member.time.conflict":`在此時間範圍內，服務資源已成為其他服務班組成員`,
"label.knowledgebase.delete.details":`將刪除任何指派詳細資訊。`,
"vue_label_normal_bottom":`置底`,
"label.custombutton.editerror":`編輯失敗`,
"label.dashboardSetup.showdw.d6":`自動`,
"message.error.field.decimalPlaces":`小數位數輸入格式有誤`,
"label.tabpage.busoppnamez":`機會名`,
"label.insertfield.intro":`請選擇一個欄位，然後點擊“插入”。後跟“>”的標籤表示還有更多的可用欄位。`,
"setup.layout.label.nocustompage":`暫無自訂頁面`,
"front-gantt-module-project-has-only":``,
"label.weixin.fmu.am":`上午{0}`,
"label.emailsync.status.connectaccounts":`關聯信箱帳號`,
"label.customcomponent.check.name.same":`名稱已存在`,
"label.validate.function.funcFormat.HOUR":`HOUR(date)`,
"label.approvepagelayout4":`複製上一行配置`,
"label.knowledge.category.hint.nine":`啟用分類組`,
"label.report.sorting.column":`排序列`,
"label.hours":`時`,
"label.email.clearAllemail":`是否清空所有該信箱同步的郵件`,
"font-evaluate-module-v1-satisfaction":``,
"label.service.hide.more.info":`隱藏更多訊息`,
"label.area.list.intro":`在這裡您可以操作區域訊息`,
"label.sendemail.chat.addPostat":`尊敬的#name:\n\n 您好！ #userName發的微貼中提及了您。`,
"label.data.newtemplate.e_seltype.desc":`資料匯出方式有兩種：</li><li class="titledesc1">1.CSV格式（預設）</li><li class="titledesc1">2.壓縮格式。匯出方式的壓縮格式分為兩種：</li><li class="titledesc1">2.1.自動產生壓縮檔案密碼，自動產生的密碼將在資料匯出成功後發送到使用者信箱</li><li class="titledesc1">2.2.手動輸入壓縮檔案密碼 ，手動輸入的密碼不會發送到使用者信箱，所以需要使用者牢記自己輸入的密碼，若不輸入，則預設沒有密碼`,
"message.passwordPolicy.validate.minlengths":`錯誤：密碼長度不得少於`,
"message.save":`確定要儲存嗎？`,
"label.marketsea.notfollowdays1":`獲取後`,
"label.app.step1":`步驟 1. 選擇類型`,
"message.error.pageid.null":``,
"label.weixin.input.lookupfield":`輸入關鍵字查找匹配的微投票`,
"label.whChatAccount":`微信帳號`,
"label.tabpage.groupingitem":`分組項目`,
"label.callboard.introduce":`以下列出了您公司的所有公告。`,
"label.financial.services.seminar":`金融理財研討會`,
"label.data.file.i_title.num1":`1.匯入的文件必須是CSV格式的文件，CSV文件必須包含標題，沒有標題不能匯入。`,
"label.visualpage.filename.exist":`文件名稱已經存在`,
"front-kefu-moudle-v1-new-chats":`建立工作人員`,
"label.console.step5.tab":`開啟選項卡`,
"vue_label_opportunity_contactrole_edit":`管理聯絡人角色`,
"label.projectManagement.delete.return":`已經是最後一條數據，刪除後將返回上一頁`,
"registration.page.designs":`註冊頁面外觀設定`,
"label.console.step6.heigth":`高度`,
"label.objectRelationshipAtLeast":`具有至少一個相關記錄`,
"label.knowledge.delete.viewstat":`刪除知識文章瀏覽數據出錯`,
"label.direct.dashboard.month.report":`新建工作月報`,
"label_tabpage_lookatmorez":`查看更多`,
"label.setup.rights.management":`權利管理`,
"label.campaign.channel.clear.img":`清除圖片`,
"label.calendar":`日曆`,
"label.biaoqingfaxian.username":`帳號`,
"label.weixin.wdyj.jxht":`個人-銷售績效-合約`,
"label.emailtocloudcc.exists1":`此信箱已經設定為Email to Lead，請勿重複設定`,
"label.emailtocloudcc.filed.password":`信箱密碼`,
"label.what_create":`您想要建立哪種表單？`,
"vue_label_report_onlydisplaypart":``,
"label.up":`向上`,
"label.addattachment.edit":`編輯附件`,
"label.ccchat.message.search.desc5":`搜尋詞不能少於2個字元`,
"label.chose.nonotice":`請先選擇不再提醒的記錄`,
"UG_activity_06":`想跟進客戶`,
"label.set_contactsmarketing":`設為市場聯絡人`,
"pagecreator.layout.button.horizontal":`橫向拆分`,
"label.brief.opportunity2":`機會`,
"label.ems.nomsg":`未設置`,
"label.fieldupdate.tip":`定義欄位更新，包括與工作流程規則、審批流程或權利過程關聯的物件 ，要更新的欄位，以及要更新的值。注意，要更新的欄位可以位於相關物件上。只顯示選定類型的欄位。`,
"label.sso.saml.sp.federationid":`聯盟ID`,
"label.import.page2.suited":`已映射`,
"message.error.appexchange.integrity":`請確保上傳軟體包中組件的完整性！`,
"label.fielddatatype":`欄位數據類型`,
"message.approval.cannotsubmit.detail2":`當前記錄必須滿足下面項目條件之一或者經公式評估為真，否則無法提交待審批，請修改後重新提交即可。`,
"vue_label_commonobjects_detail_cloud_as_a_user":`以使用者身份登入夥伴雲`,
"label.summaryreport.selectlinetogroup":`選擇報表分組所依據的列`,
"label.tabpage.norecordtypez":`不可用記錄類型`,
"label.icon.141":`貨幣`,
"label.addattachment.step3.intruduce":`如果正在上傳，這將取消正在進行的上傳`,
"label.trigger.recursive.call.three":`觸發器可以循環調用，循環次數限制為三次，如果超過三次系統將會出現錯誤提示！`,
"maintenanceplan.workorder.type.asset.workorder":`工作訂單產生方式請選擇“每個資產產生一個工作訂單”`,
"label.emailtocloudcc.select1":`請選擇`,
"label.system.log":`系統配置審計日誌`,
"vue_homepage_dashboard_not_support_fullscreen":`抱歉，您的瀏覽器不支援使用全螢幕`,
"label.projectManagement.nodata.resource":`還沒參與到任何項目中。在成員中新增‘我‘的項目資訊，即可檢視團隊成員的時間指派了`,
"label.exchange.sync.state.contact":`聯絡人`,
"label.field.type":`欄位類型`,
"label.selected.object":`已選物件`,
"label.customfields.new.step2":`步驟2.輸入詳細訊息`,
"label.monitorsys.delete.style":`操作類型`,
"label.projectcondition":`項目條件`,
"potential.customers.field.default":`商機欄位預設值設定`,
"message.password.nosame":`兩次輸入的密碼不一致，重新輸入！`,
"label.validate.function.funcExplain.MONTH":`返回月份，是1(一月)與12(十二月)之間的一個數字`,
"label.project.user.project.count":``,
"chatter.to":`更改至`,
"vue_label_commonobjects_detail_activity_owntask":`擁有工作`,
"label.generate.mobile.page":`已完成產生行動端頁面`,
"label.escalation.setup.newentries.step1":`步驟1：設置處理此規則項目的順序`,
"label.email_footer":`郵件頁尾`,
"label_partner_workspace_member_profile":`可選設定檔`,
"label.loginhis.between":`開始時間距離結束時間不能超過2個月`,
"label.user.verficationcode.error":`驗證碼不正確`,
"label.email_notifications":`發送送出電子郵件通知`,
"APPIntegration_Dropbox_01":`從Dropbox中選擇文件`,
"label.projectManagement.Selectweek":`選擇週`,
"wednesday":`星期三`,
"message.atleastonereceiver":`至少要有一個接收人`,
"label.applt.link.text":`我們已經將貴公司和入口網頁小程式綁定，複製專屬於貴公司的小程式入口網頁網站位址，將位址放置到公司公眾號選單的小程式路徑的跳轉連結中，客戶可以點選公眾號選單使用小程式。 （公眾號自訂選單<跳轉小程式<小程式路徑）`,
"label.wait.for.a.moment":`設定中，請稍等……`,
"vue_label_chatter_only_group_members_look":`只有小組成員才有權限查看，您可以嘗試申請加入小組`,
"label.knowledgebase.last.release":`上次發布`,
"component.setup.label.pagesize":`每頁顯示條數`,
"label.paging.totalofpages":`共{0}頁`,
"label.globaloperation.successmessage":`成功消息`,
"label.logout":`退出`,
"label.partner.common.enable":`啟用夥伴雲`,
"label.permission.objectpermission.goback":`返回權限集物件列表`,
"label.approvalstep5.required":`必填`,
"component_chatter_label_to":`到`,
"message.please.choose.role":`請選擇角色`,
"maintenanceasset.servicecontract.contractlineitem.illegal":`您必須選擇與維護計劃關聯的服務合約下的合約行項目。`,
"label.projectManagement.Resource.usage.view":`資源使用視圖`,
"label.smsmainbody":`簡訊正文`,
"label.ccchat.error.nullname":`名稱不能為空`,
"label.appupload.upload.version":`版本號`,
"label.data.setok.t_desc2":`返回到數據範本頁面`,
"vue_label_pool_allocationstatus":`指派狀態`,
"label.tianyancha.orgapprovedinstitute":`核准機構`,
"label.quickbooks.searchlist.startdate":`開始日期`,
"label.setapp":`應用程式設置`,
"chatter.about":`關於我`,
"label.layoutname":`版面配置名稱`,
"label.icon.160":`地球`,
"label.tabpage.Rolesz":`角色和下屬`,
"label.console.step5.introduce":`選擇以下如何顯示`,
"label.customfields.totalsummary.gettogetherfield":`要加總的欄位`,
"message.appexchange.addtopackage.profile":`一個軟體包中最多只允許添加一個設定檔組件!`,
"vue_label_file_user_header_pic":`頭像`,
"font-trade-module-v1-invoice-detail-price":``,
"homepage.components.three":`步驟3：填寫自訂組件顯示內容`,
"nine":`九`,
"label.marketsea.button.restore":`恢復`,
"label.forecast.editshrepage.desc2":`個別共用只能用於授予對數據更廣的存取權限，而不用於限制存取權限`,
"label.cloudccsite.list":`站點`,
"label.icon.35":`雲`,
"vue_label_pricebook_price":`添加標準價格`,
"label.version.sum.addressfield":`個人訊息`,
"label.projectManagement.Gotomilestone":`轉到里程碑`,
"label.dataimport.name.length":`出現錯誤：name長度過長。`,
"label_alculation_method":`計算方式`,
"label.uploadfile":`上傳文件`,
"label.ems.otheraccount":`其他帳號`,
"vue_label_commonobjects_detail_group_opportunitystrategy":`確定加入該機會群策嗎`,
"message.error.chatter.img.nodata":`圖像文件不存在，無法進行頭像截取！`,
"component.chatter.file.button.files":`選擇文件`,
"label.salescloud.teamrole.optionlist.choose.null":`角色名稱不能為空`,
"label.yourexportsuc":`已處理您的匯出請求，請查看您的電子郵件。`,
"pagecreator_systemstyle_label_modifycolor":`編輯顏色`,
"label_partner_setup_title":`設置`,
"label.chat.topic.topic":`主題`,
"file.error.nottype":`錯誤:無效的類型,可以上傳的文件類型是txt、doc、excel、ppt、pdf、jpg、jpeg!`,
"label.all_time":`全部時間`,
"homepage_componet_approval_label":`審批中心`,
"label.partnerCloud.financeSetting.merchantNumber":`微信支付商戶號`,
"label.user.resetpw":`重置密碼`,
"label.exchange.sync1":`在 Microsoft? Exchange 中為使用者設置帶有模擬權限的服務帳戶後，輸入服務帳戶憑據，以允許 CloudCC 與 Exchange 伺服器通訊。`,
"label.import.index.editfield":`編輯欄位映射`,
"and":`與`,
"label.partnerCloud.cloudInfrastructure":`夥伴雲基礎設定`,
"label.escalation.setup.newentries.createdate":`根據建立個案的時間`,
"Pagelayout.Setup.002":`您已經選擇了3個相關列表，再次選擇的話將影響版面配置`,
"label.customfields.file.tip":`允許使用者上傳1-N個文件`,
"label.tianyancha.businessverify.accname":`客戶名稱實時查詢`,
"label.Additional.Conditions":`按照地址統計`,
"label.emailtocloudcc.filed.type":`類型`,
"vue_label_homepage_fixedcomponents":`標準組件`,
"label.visualpage.delerror":`刪除失敗，請稍後再試`,
"label.tabpage.filetypez":`文件類型`,
"label.emailobject.search.input":`請輸入搜尋內容`,
"label.createprocessstep2":`步驟 2: 指定項目條件`,
"label.weixin.inhead":`處理中`,
"component.recdetail.label.title":`詳細訊息`,
"label.weixin.telephone":`手機號`,
"label.web.link":`網頁連結`,
"label.partnerCloud.paySuccess":`支付成功`,
"label.case.adress.link":`網頁客戶服務入口網頁位址`,
"label.emailobject.view.connectopp":``,
"front-kefu-moudle-think-again":``,
"label.Button":`按鈕`,
"chatter.pt.most":`最大文件大小為20M。`,
"label.service.newBuildDialog.numberdays.horizontal":`水平日期之前的天數`,
"label.ems.relatedobj":`關聯記錄`,
"label.notification.insert.approval":``,
"label.setting.codeSet":`代碼集`,
"vue_label_report_rowlevelformula":`行級公式`,
"label.validate.function.funcFormat.TIMENOW":`TIMENOW()`,
"label.copyright":`© 2008-2022 CloudCC Inc.公司版權所有。保留所有權利。顧客服務熱線：400-642-2008`,
"component.setup.button.save":`儲存`,
"label.emailsync.button.sure":`確認`,
"label.multilang.dupicatecheck.getdatalist":`第{0}組重複數據,共有{1}條記錄：`,
"label.ccchat.person.invite.tochat":`邀請人員到同事圈`,
"label_partner_all_maxNum":`夥伴雲的最大數據：`,
"label.checkfield":`查重欄位設置`,
"label.sales.dashboard.income":`收入目標`,
"label.setup":`設置`,
"label.dashboardSetup.center":`中`,
"lable.quote.syncing.finished":`已完成同步。`,
"vue_label_helpcenter_dashboard1":`    為了幫助您更加直觀地顯示統計數據，CloudCC銷售雲Lightning儀表板為您提供了強大的圖表製作能力。<br>    CloudCC銷售雲Lightning版本儀表板具有以下幾個特點<br>能夠使用不同的數據源：既可以選擇物件下某個視圖內原始數據作為數據源，也可以選擇報表處理過後的數據作為數據源<br>多達13種圖表模板供你選擇：支援銷售漏斗、指針儀表、圓餅圖、二級分組柱狀圖等<br>自由拖曳更改圖表大小和位置：儀表板可以通過擺放不同圖表的位置和大小來區分重要數據和輔助數據，這些完全由您決定<br>儀表板全局篩選：儀表板支援通過時間範圍和使用者來篩選設定了篩選欄位的內置圖表數據<br>數據快取：儀表板圖表數據在首次建立時即可快取數據，減少二次連線時間。<br>組件穿透：可以通過點擊組件跳轉到對應的報表詳情或物件相應視圖內記錄列表<br>組件聯動：同一儀表板內，組件可以設定和自己同一數據源的其他組件來和自己聯動，通過點擊組件內數據區，能夠讓設定的其他組件根據這個數據區的篩選條件來重新統計數據<br>1、建立儀表板<br>    作為銷售代表或者銷售部門的管理人員，可通過製作儀表板來展示您的銷售數據，CloudCC銷售雲Lightning版本提供了豐富的能力來製作儀表板<br>    注意：Lightning版本的儀表板和舊版本的儀表板的數據不互通。<br>    點擊“儀表板”選項卡，點擊“建立儀表板”，填寫儀表板名稱並選擇您希望將此儀表板儲存到哪個文件夾。即可進入一個新的儀表板。<br>    `,
"label.layout.availabletab.trackrecord":`追蹤記錄`,
"label.campaignmember.main.deletecontact":`刪除成員-現有聯絡人`,
"lable.outlook.mcto.emaltoc":`當電子郵件發送到CloudCC.com時`,
"label.setup.mobile.offlinecache.savesuccess":`行動端離線緩存設置儲存成功`,
"label.timezone.default":`預設時區`,
"label.noRules.have.been.enabled":`還沒有已啟用規則`,
"label.ccchat.person.invite.existsend":`您輸入的部分電子郵件地址匹配現有使用者。`,
"label.work":`工作`,
"actualstarttime.actualendtime.time.illegal":`服務預約的實際開始時間應小於等於實際結束時間。`,
"lable.product.stsp":`設置標準價格`,
"vue_label_normal_account_sf":`客戶`,
"label.finishpic":`已產生的圖表`,
"label.h5.similar.opportunity.step3":`步驟3.選擇為類似業務機會顯示的欄位`,
"label.relateobjDefault":`預設相關記錄`,
"label.customcomponent.check.tag.endwith":`組件必須以&lt;/cc:component&gt;標籤結尾`,
"label.related.organization":`相關機會`,
"label.recordtype.edit.selectvalue.orderby":`選項列表值排序`,
"vue_label_homepage_enter_name":`請輸入名稱`,
"label.permission.group":`權限組`,
"label.emailobject.send":`發送`,
"label.ralateuser":`相關使用者`,
"label.validate.function.funcFormat.ADDMONTHS":`ADDMONTHS(date,num)`,
"label.tablayoutedit.remark2":`選擇要在前臺選項卡頁面顯示的欄位`,
"setup_mainpage_label_welcome3":`CloudCC 雲平台中建立表單依靠自訂資料庫（物件）來實現，使用者定義物件是一些資料庫表格，用於儲存貴組織特有的數據。無需任何程式開發的情況下，還可輕鬆建立表與表間的關係。`,
"label.user.notallowed.login.scope":`您不在允許登錄時間範圍內或您的登錄IP受到限制。`,
"label.tel.ten.case":`您最多可輸入10個要發送通知的手機號碼，每個手機號碼之間用`,
"front-kefu-moudle-v1-user-info":`使用者資訊`,
"label.aboutme":`關於我`,
"label.setfieldediting.tip":`定義審批步驟時，可以向不同的使用者分配審批請求。其中一個選項是為了使用使用者欄位自動傳送這些請求。如果要將此選項用於任何審批步驟，請從下面的選項列表中選擇一個欄位。而且，當記錄在審批流程中時，它總是鎖定的-- 只有管理員可以對其進行編輯。但是，您也可以選擇允許當前分配的審批者來編輯該記錄。`,
"label.existing_dashboard":`新增到已有儀表板`,
"label.sendemail.spotsign":`尊敬的#name:您所邀約的#activity活動的客人#customer已經成功簽到來現場,請知曉。`,
"UG_solution_01":`提供解決方案`,
"label.tianyancha.estiblishtime":`成立時間`,
"label.pc.lightningpage":`輕量級應用(Beta)`,
"label.saveAndSync":`儲存並同步`,
"label.state.end":`已結束`,
"label.sendemail.queue.assigninfo":`佇列：[#queueName] 指派了 #objectName ：#recordName`,
"label.approvalprocessname":`審批流程名稱`,
"label.view.conditions.message":`按{!conditions}篩選`,
"label.partnerCloud.financeSetting.alipayCorporate":`支付寶企業帳戶`,
"label.forecast.detailforecast.de":`的`,
"label.savepayset.failure.nopay":`請先配置至少一個線上支付賬戶`,
"label.step1.total6":`第1步，共6步`,
"label.appointment.wizard.subtitle4-1-3":`45分鐘`,
"label.emailobject.markasread":``,
"message.error.orgid.null":`orgid不能為空！`,
"label.emailtemplate.mergefield":`合併欄位值`,
"label.weixin.recent.list":`最近查看列表`,
"label.emailsync.form.email":`信箱`,
"label.funnel":`漏斗`,
"label.logintime.clear":`清除時間`,
"label.chatter.followed":`已關注`,
"label.ccpeak.function.field.spack":`函數中的欄位兩邊必須有空格`,
"label.setup.mobile.offlinecache.remark":`啟用該功能後，組織內的成員可以在行動端無網路狀態新建、查看、編輯、刪除記錄`,
"label.product.function":`產品功能`,
"label.icon.14":`錘子`,
"message.report.nodata":`報表未返回數據`,
"label.please.ChooseMin":`請最少選擇{0}個產品選項。`,
"label.tabpage.releaseTourz":`發佈導覽`,
"vue_label_chat_opportunity":`機會群策`,
"vue_label_chatter_refucecertification":`確定拒絕"{name}"成為小組成員嗎`,
"label.version.unlimited":`不限`,
"label.processsetting.enable.prompt":`啟用後，設定的路徑會在lightning版本對應的詳情頁中。也可先儲存設定，稍後再啟用。`,
"label.page.display.property":`顯示屬性`,
"label.service.appointmentList.thisOption":`未勾選`,
"label.register.date":`註冊日期`,
"label.brief.contract.amount":`合約金額`,
"setup.object.field.dependency.label.actionfieldnotnull":`請先選擇一個控制欄位的值進行設定`,
"UG_homepage_009":`存取CRM`,
"label.icon.98":`文件夾`,
"label.weixin.datacount":`數據合計`,
"label.mobile.hasbind":``,
"label.emailtemplate.choosemorecontacts":`請選擇您要發送給的更多人`,
"setup_layout_button_deleteitem":`移除選中項`,
"vue_label_account_collection_plan":`未處理的收款計劃`,
"label_chatter_maturiyDate":`到期日期`,
"label.emailtocloudcc.license":`使用者許可`,
"vue_label_checkduplicate_complete_check_rules":`請填寫完整檢查重複規則`,
"chatter.up.type":`您可以上傳JPG、GIF或PNG文件。`,
"label.attendance.nocheckout":`未簽退`,
"label.setup.mobile.offlinecache.remark2":`選取的選項卡將作為預設離線緩存選項卡在全組織人員的移動端啟用，每個使用者可以根據不同的場景需求在行動端設置關閉組織設置的選項卡離線緩存，或切換啟用其他需要的選項卡`,
"template.report.count.marketing.activities":`行銷活動總計`,
"label.multilingual.tip4":`禁用多語言將會根據公司位址把公司預設語言為中文或者英文，並且將所有使用者的語言設定為公司預設語言`,
"label.settings_area":``,
"label_assessment_content":`考核內容`,
"label.top":`頂部`,
"UG.Account.06":`建立一個客戶`,
"label.emailtocloudcc.step1.case2":`配置後，該信箱收到的郵件均可自動產生個案，並根據寄件匣相符聯絡人與客戶，將個案掛在對應的客戶與聯絡人之上，方便Case服務的受理與追蹤。`,
"label.forecast.forehistory.best.remark":`超常發揮備註`,
"label.project.problem.date":`問題日期必須在所屬里程碑或項目的日期範圍內。`,
"label.forecast.customforecast.foredis.wzs":`完整數`,
"message.setup.field.name.value.notexists":`輸入的小組角色列表值不存在，請重新輸入！`,
"label.salescloud.teamrole.opportunity.organization":`小組成員對此業務機會的存取級別可能高於您組織預設的業務機會存取設置`,
"label.sms.message.input":`請輸入簡訊內容`,
"label.document.type.not.allow":`該文檔類型不支援！`,
"label.customfields.totalsummary.tip":`在相關列表中顯示欄位的彙總值、最小值或最大值的唯讀欄位，或在相關列表中列出的所有記錄的記錄數。`,
"label.tabpage.filesizez":`文件大小`,
"label.import.page2.filedname":`文件名`,
"label.same.analyze":`我的撞單分析`,
"label.service.gantt.refreshData":`重新整理頁面後更新資料`,
"label.sendsms.batch.step2.sendbycontext":`按自訂簡訊內容發送`,
"UG_Account_05":`聯絡人架構圖`,
"label_emailtocloudcc_step1total3":`第1步，共3步`,
"label.weixin.no.history":`暫無歷史記錄`,
"label.datamanage.queryfield.error":`查詢欄位出錯`,
"label.emailmerge.mergeFolder.emailmerge":`郵件範本合併`,
"label.workflow.estimatecondition":`評估條件`,
"label.autonumberfield.wrong":`請輸入0-{0}中的一個數字`,
"label.data.setok.t.desc1":`如果需要用此範本匯出數據，請點擊`,
"label.data.downpage.i.title":`匯入數據的步驟:`,
"label.data.downpage.i_list.desc2":`匯入資料後，您會收到一封郵件，提醒您是否匯入成功。`,
"label.opportunity.jieduan":`當前階段`,
"vue_label_commonobjects_view_sumby":`匯總方式`,
"label.knowledge.setting.hint.three":`我們將幫您準備並運行。以下是您需要完成的設定：`,
"page.activity.history":`活動歷史`,
"label.cancelQuoteLineGroup":`取消報價行組`,
"label.addattachment.batch.step3":`步驟 3.單擊“完成”按鈕，返回上一頁`,
"label.chat.topic.follow":`追蹤`,
"label.import.page1.uploadcsvfiled":`拖拽或點擊上傳CSV文件`,
"label.batchtransfer.datetype.tip":`對於日期欄位，採用如下格式輸入值：`,
"vue_label_systemSettings_application_util":`應用程式管理器`,
"label.partner.workspace.member.selectedpermission":`已選權限集`,
"label.service.appointmentList.plansToEnd":`計劃結束`,
"label.industrialandcommercialverification.contactinformation":`購買或咨詢請聯繫 400-642-2008`,
"chatter.del.p":`刪除此帖子`,
"label.forecast.customforecast.replacefirst":`被我優先`,
"Lead.Scoring.Setting.Rule.Setup.RuleName":`評分規則名稱`,
"label.weixin.appr.applicant":`發起人`,
"component_event_label_calendar":`查看日曆`,
"step":`步驟`,
"label.attendance.setting.position.alert":`內勤必須設置地標`,
"label.end":`已結束`,
"label.mobile.change.owner.success":`已變更為新擁有者`,
"label.chinese":`中文`,
"label.textmessage.vonage.account":`賬戶訊息`,
"front-console-no-related-contact":``,
"label.dashboardSetup.seltype":`可選擇的組件類型`,
"chatter.follow.user":`追蹤該使用者`,
"label.textmessage.sentsuccess":`發送成功`,
"label.australian.gentral.standard.time":`中央夏令時（南澳大利亞）`,
"label.validate.function.funcFormat.AND":`AND(logical1,logical2,...)`,
"lable.SalesCommitmentKanBan.contract":`簽約`,
"label.processsetting.basic.settings":`基本設定`,
"label.escalation.setup.newentries.ifcondtions":`如果滿足以下條件，則運行此規則`,
"label.lookup.nofound.data":`值不存在，或與篩選條件不相符。`,
"vue_label_commonobjects_view_chart_chartname":`圖表名稱`,
"label.dashboard.show.percent":`顯示%`,
"label.sso.saml.sp.userid":`使用者ID`,
"label_tabpage_minutesagoz":`分鐘前`,
"vue_label_chatter_comment_content":`請輸入評論內容`,
"label.campaign.channel.step6.mobilepc":`產生行動版加電腦版頁面`,
"vue_label_homepage_editprofilepage":`編輯名稱`,
"label.tabpage.crecordtypez":`更改記錄類型`,
"label.social.posts.type.null":`帖子類型不能為空`,
"label.projectManagement.groupbyuser":`按使用者分組`,
"vue_label_email_new_template":`另存為新範本`,
"label.ems.close":`取消`,
"label.ccdocument.noauthority.folder":`你沒有操作該檔夾的權限！`,
"message.filterconditionerror":`<strong>錯誤：</strong> 您的篩選器引用了錯誤的篩選條件：`,
"label.User.Interface":`使用者介面`,
"label_tabpage_greaterz":`大於`,
"vue_label_CCChat_unfollow":`取消關注`,
"label.selectandcontinue":`選擇並繼續`,
"vue_label_commonobjects_detail_influence":`影響力`,
"label.total.have.priority":`的優先`,
"label.manageAll.sta4":`調回`,
"label.setup.mobile.offlinecache.setup":`行動端離線緩存設置`,
"vue_label_chatter_cancel_adding":`取消添加`,
"vue_label_lead_select_existing":`選擇現有`,
"front-epwechat-module-v1-contacts-sync":`企業微信聯絡人同步`,
"label.appupload.component.type.recordtype":`記錄類型`,
"label.layout.hint":`暫不支援在目前頁面檢視效果，請在儲存後，到前台頁面檢視`,
"label.change":`更改`,
"setup_layout_label_detailpage":`詳細頁面`,
"label.imgfield.use.tip":`img(docid,width,height),該函數是輸出圖片所用的，docid為文檔id,width設置圖片的寬度(Integer類型,可以為空)，height設置圖片的高度(Integer類型,可以為空)。`,
"pagecreator.systemstyle.button.edit":`編輯樣式`,
"label.delete_externalpage":`你要刪除的' '無法撤回，請再次確定。表單不用於任何登入頁面，但可能在其他地方使用。例如，您可能已經使用嵌入代碼將其插入外部頁面。`,
"font-evaluate-module-v1-open-case":``,
"label_not_adjust":`無調整`,
"vue_label_title_ordernow":`立即訂購`,
"label.notification.serviceappointment.allocation":``,
"label.objectRelationshipDescription2":`的報表。通過選擇一個與它有關係的物件，可以定義其他物件中的哪些相關記錄將返回到報表結果中。`,
"vue_label_calendar_notice_createfail":`建立日曆失敗`,
"label.ems.step1":`步驟1`,
"label.ems.password":`密碼`,
"label.icon.143":`存錢罐`,
"label.select.year":`選擇年度`,
"label.termsforusage.dialog":`使用條款 （新視窗）`,
"label.tag.addtags.create":`新增`,
"label.emailobject.groupemail.msg4":`無電子郵件地址，導致此封郵件無法發送給該收件人`,
"label.version.sum.autonumberfield":`個自動編號欄位`,
"label.projectManagement.unallocated.time":`未指派時間`,
"PageLayout.Search.MultiSearch.002":`搜尋欄位展開顯示（單欄位搜尋）`,
"label.icon.150":`VR`,
"label.SMS.edit":`簡訊通知編輯`,
"Opportunity.Detailed.Phase.Label.003":`更改階段`,
"vue_label_helpcenter_all":`1、全局搜尋<br>全局搜尋是一個幫助您快速查找的所需內容的工具。<br>在頁面頂部導航欄的搜尋輸入框中輸入關鍵字。輸入過程中系統會根據您的輸入內容即時為您推薦相關的內容；<br>點擊“搜尋”或者直接按鍵盤回車鍵，即打開搜尋結果頁；<br>在搜尋結果頁中您可以通過篩選左側的物件，來查看該物件下的搜尋結果列表。結果列表中為您推薦最多10條記錄，您可以點擊“查看更多”，進入此物件的列表頁查看更多的搜尋結果；<br>註：系統預設對“報價單”、“客戶”、“商機”、“機會”、“行銷活動”、“合約”、“產品”、“服務請求單”、“工作”和“事件”這十個物件進行搜尋。<br>2、快速建立<br>    點擊導航欄的“ ”，在下拉視窗中可以選擇您要建立的物件。<br>3、個人中心<br>    點擊導航欄右側的頭像，打開個人中心視窗。為您提供以下功能：<br>快速進入個人設定頁、批次匯入和回收桶的入口；<br>如果您處於試用期，點擊“立即訂購”可快速進入cloudcc訂購頁面；<br>點擊某個版本，可以快速切換；<br>退出登錄。<br>4、選單<br>    在選單欄中為您推薦了一些選單物件，您可以點擊某個選單，快速進入頁面。您也可以查看全部選單和設定要展示在選單欄中的常用選單。<br>全部選單：點擊“更多”，在下拉框底部點擊“全部選單”； <br>自訂我的選單：點擊選單右側的按鈕，打開自訂選單視窗，在全部選單中設定您需要展示在選單欄中的常用選單。<br>5、應用啟動中心<br>    點擊選單欄右側的圖示，可以快速切換到系統管理員為您配置到其他應用程式服務。<br>註：應用程式為一系列功能模組（如商機管理、機會、合約管理等）的集合，可用來滿足特定的業務需要`,
"label.summaryreport.2018.step5.new":`步驟5：選擇報表標準`,
"label.weixin.id":`編號`,
"chatter.pu.mess":`個發貼和留言`,
"label.weixin.lookup.record":`查找記錄`,
"label.ServiceCloud.statistics.by.address":`按地址統計時暫無資源分佈數量!`,
"label.jixiaoswitchoff":``,
"label.savealipay.failure":`儲存支付寶商戶訊息失敗`,
"template.chart.khdqfb":`客戶地區分佈`,
"front-email-payment-immediate-payment":``,
"label.dashboard.unit5":`單位：億`,
"label.tabpage.greaterz":`大於`,
"vue_label_calendar_stop_sharing_calendar":`停止共用日曆`,
"label.projectManagement.allhours":`全部(小時)`,
"label.currency":`幣別`,
"label_vue_create_edit_obj_create_event_dialog_title":`待辦事項重複提示`,
"front-template-V1-templateSetting":`範本設定`,
"label.dashboard.away.condition":``,
"label.replacelayout":`取代頁面配置`,
"label.permission.detail.system.setting.tip":`執行應用到應用程式的操作，如“修改所有數據的權限”`,
"label.customfield.delete.prompt":`自訂欄位標籤`,
"label.add":`添加`,
"label.deputationalsoapprove":`委派代理也可以批准此請求`,
"label.leave_nosave":`離開後，目前資料將不被儲存。`,
"label.tianyancha.title":`天眼查`,
"vue_label_pool_restore":`恢復`,
"chatter.feed.menutype.feed.markcom":`已收藏的微貼`,
"label.query.data.error":`查詢相關列表數據失敗`,
"label.pc.ui.2018.unpin":`取消置頂`,
"label.partner.template.memo":`簡述`,
"label.weixin.cannot.gain.userinformation":`無法獲取使用者的訊息`,
"label.stdashbord.xsld.department":`部門`,
"label.service.ganttBaiduMap.scheduled.starttime":`計劃開始時間`,
"label.documentforms":`文檔`,
"label.operator.insert":`插入運算符`,
"label.processsetting.select.five.fields":`最多可選擇5個欄位`,
"label.weixin.password":`密碼`,
"vue_label_chatter_share_followers":`與關注人員共用`,
"label.brief.baifang":`簽到拜訪`,
"label.emailobject.track.unopen":`沒有打開`,
"label.sendmail.immediately":`立即發送`,
"label.partnerCloud.payTheAmount":`支付金額`,
"label.integrations.mailchimp.connect":`將CloudCC連接到您的帳戶`,
"label.datamove.record.sucessfully":`條記錄轉移成功！`,
"lable.outlook.edit.allocation":`分配使用者和設定檔`,
"label.chosesubject.talk":`約會談`,
"label.escalation.setup.entrydetail.escalation.time":`升級時間`,
"label.projectManagement.must.be.less.than.24.hours":`必須小於24小時`,
"setup_mainpage_label_welcome15":`CloudCC 雲平台工作流規則可以自動化您的銷售、市場等各種物件的支援過程。根據預先定義的一組規則，可以將記錄自動指派給使用者，或從一個使用者轉換到另一個使用者。工作流管理的主要好處是，通過在更新記錄時消除許多不必要的操作來提高工作效率，通過標準化工作方法、減少操作成本來提高業務處理水平，優化控制流程。支援任意物件的無限極審批，同時可以觸發提醒郵件、簡訊提醒、工作、欄位更新等功能。`,
"label.mobile.phone.week.plan2":`本週計劃`,
"label.add.newAsset":`建立資產`,
"vue_label_salesadvance_losts":`流失數`,
"vue_label_report_editcolumn":`編輯列`,
"vue_label_homepage_assignedtasks":`已指派工作`,
"label.posting_from":`發佈者`,
"year":`年`,
"label.autoRegister.changepwd.setpwd.tip.letter":`至少有一個字母`,
"label.version.nonsupport.feature.staticresource":`暫不支援此功能！請等待功能升級後使用！`,
"label.toleadmyclientandlinkman":`匯入我的客戶和聯絡人`,
"label.appupload.install.processcrash":`處理衝突`,
"label.profile.setstandardtab":`標準選項卡設置`,
"template.chart.khhyfx":`客戶行業分析`,
"label.reportTypcrtC":`關聯物件（C） 請點擊選擇關聯物件`,
"vue_label_report_mayormaynothave":`上級物件可能有或沒有相關此物件記錄`,
"label.service.gantt.plan.recommendation":`計劃已推薦`,
"label.version.sum.lookupfield":`個查找欄位`,
"label.builder":`頁面構建器`,
"label.sharerule.remark":`指定此記錄的共享。您可與使用者，角色、角色及下屬、區域、區域及下級區域所對應的使用者共享此記錄及相關數據。個別共享只能用於授予對數據更廣的存取權限，而不用於限制存取權限`,
"vue_label_email_benn_added":`該信箱已添加`,
"label.version.allow.sum":`，已達到上限！如有需要，請升級CloudCC版本！`,
"label.icon.130":`貨幣`,
"label.custom.new":`建立`,
"label.see_allfields":`檢視全部欄位`,
"front-marketing-module-v1-share-poster":`分享海報`,
"label.service.one":`您的篩選器引用了未定義的篩選條件:`,
"lable.outlook.edit.alprec":`始終首選CloudCC.com`,
"Account_News_Setting_001":`客戶設置`,
"label.mr.caption.opportunity.result":`查重合併：查詢業務機會重複數據的結果`,
"label.forbidden":`禁用`,
"label.query.detail.openpartner":`作為合作夥伴啟用`,
"label.session_date":`會話日期`,
"label.forecast.customforecast.submit.deyuce":`的預測`,
"label.emailtocloudcc.filed.server":`伺服器`,
"label.emailtocloudcc.tip2":`刪除後將無法通過此信箱實現Email to CloudCC功能，確認刪除？`,
"pagecreator_layout_message_delete_fail":`配置刪除失敗`,
"front-lightning-module-v1-dashborad-export-PDF":`匯出PDF`,
"lable.quote.syncing.syncingto":`報價單明細已同步到業務機會產品。`,
"message.error.view.lastview.update":`不能刪除最後一個公共列表視圖</br>您不能將所有使用者皆可視的最後一個列表視圖改成僅個人可視<br><br>`,
"label.weixin.select.one":`至少選擇一項`,
"label.projectManagement.Pleaseenterprojectname":`請輸入項目名稱...`,
"label.data.downpage.e_list.desc1":`此頁面顯示的數據為匯出成功的檔，請您根據郵件中提示的訊息及時下載您匯出的檔。`,
"label_tabpage_notexceed25":`選擇的記錄不能超過25條`,
"label.campaign.channel.step5.remark":`您已經完成了您的註冊頁面的設置`,
"label.setup.mobile.bottombutton.profile.prompt":`提示：客製的設定檔底部選單會覆蓋公司底部選單統一設定`,
"label.stdashbord.xsld.business.knx":`可能性`,
"label.setemailtip":`建立一個電子郵件通知 以關聯一個或多個工作流程規則、審批流程。 如果更改電子郵件通知 ，任何修改都將應用到與之相關聯的所有規則、審批。`,
"report.button.go":`前往`,
"lable.the.united.arab.emirates":`記錄已被領取`,
"label.writer. name.file":`請填寫報價檔案名稱`,
"label.validate.function.funcExplain.ADDMONTHS":`在輸入的date（日期欄位）上加上num（月數）使其返回一個新的日期。在原先月份天數等於當月最後一天 或者 新的日期的月份天數少於原先輸入的日期月份天數時，將會返回一個月份天數為當月最後一天新日期。`,
"vue_label_chatter_enter_shared_content":`請輸入共用內容`,
"message.lookup.condition":`搜尋條件必須輸入一個以上字元`,
"vue_label_commonobjects_detail_customers":`永久禁用外部使用者的客戶將禁止所有與客戶關聯的外部使用者，同時從與他們關聯的所有社區、組、小組、權限集和共用規則中刪除。同時，將永久刪除與該賬戶關聯的角色和組，同時不會出現在回收桶中。是否確定？`,
"label.emailobject.view.all":`全部`,
"vue_label_file_size_limit_new":`附件大小超過{size}M，上傳失敗`,
"front-gantt-module-please-reorder-milestones":``,
"label.escalation.setup.entrydetail.escalation.assingTemplate":`電子郵件`,
"label.namespaceprefix":`名稱空間首碼`,
"label.ems.delete.success":`刪除成功`,
"label.partnerCloud.financeSetting.setWechatPay":`設定微信支付`,
"front-epwechat-module-v1-input-token":`請輸入Token`,
"setup_object_field_dependency_button_setdependency":`設置欄位相依`,
"chatter.group.request01":`個請求`,
"message.error.field.number.length":`長度輸入格式有誤`,
"label.tabpage.lessz":`小於`,
"vue_label_notice_uploadavatar_format":`上傳頭像圖片只能是JPG/PNG/GIF格式`,
"label.project.hit.thirteen":`每天里程碑提醒`,
"frame_personinfo_label_usethisimage":`我們會在應用程式周圍使用此縮圖的變形圖。`,
"label.startuploadfile.step":`否則沒有成功上傳的文件會顯示在上方區域並有提示訊息，需要將其全部清除，方可重新選擇文件`,
"component_assistant_label_overduetask":`機會包含逾期工作`,
"label.partnerCloud.financeSetting.information":`如何設定支付寶簽約資訊`,
"label.appupload.install.package.component":`軟體包組件`,
"label.emailobject.emaildetail.nextactivity.task":``,
"vue_label_chatter_edit_post":``,
"label.appupload.upload.logo":`圖標`,
"label.role.selecteduser":`已選中使用者`,
"label.letter.assign":`指定邀請函內容`,
"label.forecast.shrepage.title":`預測共享詳細訊息`,
"lable.Generate.service.appointment":`工作訂單行項目產生的服務預約`,
"label.productsales.nodata":`沒有數據`,
"vue_label_email_Please_select_at_least_one_email":`請至少選擇一封郵件`,
"label.data.downpage.i_title.num4":`4、如果您要匯入的物件中具有對應欄位和主詳欄位，則該欄位對應的值必須是ID，否則無效。`,
"label.new.exchagecurrency":`新匯率`,
"label.layout.listtip":`下表顯示不同設定檔的版面配置分配`,
"label.icon.2":`錢包`,
"label.chat.topic.delete.prompt3":`是否確認刪除此主題？`,
"UG_Lead_008":`名片掃碼`,
"label.multilang.databatchadd.fail":`{0}條數據添加失敗：`,
"front-kefu-moudle-v1-chzx-confirm":`確定要刪除工作人員嗎？`,
"label.import.page1.matchlabel":`相符{{$store.state.labelName}}方式`,
"label.dashboardSetup.showdw.d3":`百萬`,
"label.version.ifnecessary":`如有需要，請升級CloudCC版本！`,
"label.confirm.delete.default.tab":`確認要刪除預設登錄選項卡嗎？`,
"label.emailtemplate.mergefields.tip":`設計電子郵件的內容時可向內容中添加合併欄位取代文本。當郵件被使用時，系統會取代成文本。例如{!Contact.name}，使用電子郵件時，正文中會變成聯絡人的姓名`,
"vue_label_chatter_decline_members_join":`拒絕成員加入小組`,
"label.role.no":`無角色`,
"label.service.gantt.resources":`的資源`,
"label.knowledge.language.simplified":`簡體中文`,
"label.eidt.queue.length.cannot.than":`名稱長度不能超過50`,
"label.mobile.quickcreate.default.tasks":`工作`,
"label.discount.yuan":`折扣（元）`,
"message.error.delete.pending":`記錄正在審批中，不能刪除<br>單擊<a href`,
"chatter.show.mostnews":`顯示更多消息`,
"label.optionlist":`選項列表`,
"template.chart.cpdj":`產品定價`,
"label.user.usernamepassword.error":`用戶名或密碼錯誤`,
"label.file.sharetype.check":`查看者`,
"label.completed.generated.page":`已完成產生電腦端頁面`,
"label.martrixcross":`矩陣交叉`,
"label_tabpage_entercusnamez":`請輸入客戶名`,
"lable.account.NextwDays":`未來30天`,
"label.list.userinterface.dashboard.hint":`新的儀表板圖表支援在手機、平板等終端上顯示，並且能快速呈現。`,
"message.fieldtrack.operatecreate":`已建立`,
"label.service.gantt.available.plan":`可被計劃的時間空檔：`,
"label.activity.setting":`活動設置`,
"label.tag.manage.record":`記錄數`,
"label.customcomponent.page.edit.title":`編輯自訂組件`,
"label.import.index.creationrecord":`建立記錄`,
"label.tabpage.printz":`列印`,
"label.appointment.wizard.subtitle4-1-5":`1.5小時`,
"label.partnerCloud.orderingPlatform.discountUnit":`折扣單位元：`,
"label.weixin.micro.message.profile.associated":`微信公眾號與公司設定檔關係`,
"label.cpq.opportunity.pricebook.change":`該機會已關聯主報價單，價格手冊不可更改`,
"vue_label_opportunity_business_opportunity":`結果為已結束且贏得客戶的機會中，包含與當前機會有一個或多個相同欄位的記錄。`,
"message.standardreport":`標準報表`,
"vue_label_account_outstanding_business":`轉移其他人所有未處理機會`,
"vue_label_commonobjects_detail_field":`選擇篩選欄位`,
"pagecreator_page_button_delete":`刪除`,
"label.leadconvers.permisson":`沒有{!objectname}的{!operator}權限，請聯繫系統管理員!`,
"vue_label_systemSettings_customcode":`自訂代碼`,
"button.partner.cancel":`取消`,
"label.whChatBindingState":`微信帳號綁定狀態`,
"label.appointmentconfirmail.wizard.subtitle6":`電話號碼`,
"label.recycle.dis.tip2":`使用者可通過點擊清空您的回收桶或清空貴組織的回收桶按鈕對回收桶進行清空操作，執行清空回收桶操作需要一定的時間，系統將在操作執行完成後，發送郵件通知。`,
"batch.transfer.succ":`批次轉移數據成功的條數為：`,
"label.chat.add.bookmark":`收藏`,
"label.mr.object.contact":`聯絡人`,
"component_setup_label_parentobject":`上級物件`,
"label.reportsSubscriptionPage.schedulereport.weekly.tuesday":`星期二`,
"vue_label_report_list":`選擇要顯示在列表標題的欄位`,
"label.checkbox.false":`否`,
"label.chatter.followers":`被關注`,
"label.mr.loadReDate":`加載選中的訊息`,
"label.versiontype.Essential":`基礎版`,
"front-project-module-v1-input-actual_working_hours":`請輸入報工工時`,
"label.visualpage.staticresource.p2":`2.注意. 支援的靜態資源文件類型有png、jpg、gif、js、css`,
"label.query.clone.detail.choose":`請選擇需要複製的明細記錄`,
"component.assistant.label.30daysnoact":`30天沒有任何活動`,
"label.tianyancha.businessverify.relation":`已映射`,
"vue_label_email_havent_received_the_email_yet":`暫時沒有收到郵件哦`,
"label.isEnableVisualpage_new.title":`啟用自訂頁面存取`,
"lable.SalesCommitmentKanBan.allContractAmount":`總簽約額`,
"label.searchall":`搜尋全部`,
"label.h5.similar.opportunity.select.all":`選擇全部`,
"label.area.tree.intro":`在這裡您可以直觀的查看區域和區域之間的關係`,
"label.select.up.three.fields":`注意：最多選擇三個欄位`,
"label.leadscore.doing":`正在評分中，請不要重複評分`,
"message.choosereportobj":`請選擇報表物件`,
"button_partner_start":`開始使用`,
"label.quote.print":`列印報價單`,
"label.workflowoperateselect":`步驟3：指定工作流程操作`,
"label.greate":`>大於`,
"lable.setting.qrcodeOrbarcode.rule":`二維碼/條碼規則設定`,
"label.partnerCloud.orderingPlatform.discounts":`折扣計劃`,
"label.ems.save2draft":`存草稿箱`,
"vue_label_homepage_editname":`編輯主頁名稱`,
"label.ccdocument.save.error":`儲存失敗,錯誤代碼為`,
"label.samoa.standard.time":`薩摩亞群島標準時間`,
"label.tianyancha.businessverify.msg7":`三：資料服務範圍：`,
"vue_label_commonobjects_view_up_to_data":`該操作最多支援200條數據`,
"label.manage":`管理`,
"label.tooltip":`報表類型已使用，不能編輯物件關係！`,
"vue_label_calendar_edit_calendar":`編輯日曆`,
"label.attendance.keywords":`請輸入關鍵詞`,
"label.otherinfo":`其它訊息`,
"System_TAB_SeeViewAmount":`查看總數`,
"label.recordtype.remark":`描述`,
"label.object.cannot.delete":`無法完成物件的刪除嘗試，因為它與同其他物件的以下關係相關聯`,
"label.setup.mobile.bottombutton.saveprompt":`請選擇4個一級頁面`,
"label.department.lastpage":`已經是最後一頁了`,
"label.emailtemplate.mergefield.use":`將合併欄位值複製並粘貼到郵件正文`,
"vue_label_salesfunnel_notice8":`成功由本階段轉換為下一階段的比例`,
"lable.opppdt.addpdt.table.product":`產品`,
"vue_label_helpcenter_report2.2":`步驟2：選擇您如何匯總列：總和、平均、最大值、最小值。 <br>對報表中的數據進行升、降冪排列<br>單擊預覽報表表頭中的任意欄位旁的“↑”或“↓”標誌，。報表中的數據將按照這個欄位的升、降冪進行排列。 <br>?顯示或隱藏詳細訊息行<br>在進行分組後，通過預覽報表右上方的“詳細訊息行”開關，您可以顯示或隱藏詳細訊息行。 “詳細訊息行”開關預設關閉。 <br>開啟或關閉自動更新預覽<br>通過預覽報表右上方的“自動更新預覽”開關，您可以開啟或關閉自動更新預覽。開啟後，您的每一步操作對數據產生的影響將會在預覽報表中自動展示。 想要篩選報表記錄，單擊篩選器<br>篩選器分為標準篩選器和欄位篩選器。 <br>其中標準篩選器包含“角色”篩選器、“向我顯示”篩選器和“日期”篩選器。 <br>A.“角色”篩選器，通過當前角色和直屬下屬角色劃分數據，單擊角色名稱可切換不同角色。 <br>?B.“向我顯示”篩選器，通過“向我顯示”和“向擁有者顯示”劃分數據，“向我顯示”展示的是擁有者是當前使用者的數據，“向擁有者顯示”展示的是當前使用者具有查看權限的所有數據。 <br>C.“日期範圍”篩選器，通過日期劃分一段時間範圍內的數據，例如“建立日期”、“結束日期”。 <br>其中欄位篩選器包含欄位篩選器和進階篩選器。 <br>`,
"label.validate.function.funcFormat.YEAR":`YEAR(date)`,
"label.service.gantt.timeScale":`選擇在甘特圖中顯示的時間刻度`,
"label.data.dataexptemplate.desc1":`1、資料匯出的檔有兩種方式，一種是CSV格式，另一種是壓縮格式。預設為CSV格式。`,
"template.chart.btjbkhqk":`不同級別客戶情況`,
"label.role.assign.select":`從<b>已選中使用者</b>列表中移除一個使用者會將該使用者分配給上面選擇的角色。`,
"label.event.lookupmulti.assigner":`被指派人`,
"label.appexchange.fieldupdata":`工作流程欄位更新`,
"label.lookup.page.notexists":`頁面不存在`,
"label.appupload.install.error.choice3":`合併衝突的組件，合併為同一個組件`,
"vue_label_commonobjects_detail_team":`管理小組`,
"label.approvereqiest":`審批請求`,
"message.error.id.replace":`未查詢到{0}對應的日曆訊息`,
"font-evaluate-module-v1-general":``,
"vue_label_report_whatweek":`星期幾`,
"vue_label_chatter_img_upload":`您可以上傳JPG、GIF或PNG文件，最大文件大小為2M`,
"label.checkbox":`複選框`,
"label.visualpage.component.n5":`5.實例. 調用: &lt:component:c1 args`,
"chatter.updat":`上傳時間`,
"label.ems.emailaccount":`信箱帳號`,
"label.autoRegister.changepwd.setpwd.tip1":`設置密碼為CloudCC帳戶`,
"label.import.step1.matchway":`相符{labelNameshow}方式`,
"label.manageAll.sel.one4":`我拒絕過的項目`,
"label.tabpage.lookatmorez":`查看更多`,
"label_tabpage_addadvancedoptions":`添加進階選項`,
"message.validation.accept":`輸入合法的格式`,
"label.handlingnooperate":`數據正在處理中，請不要進行其它操作，否則將會處理失敗。`,
"label.mobile.buttom.homepage":`主頁`,
"lable.account.LastaDays":`過去7天`,
"label.user.notexists":`使用者不存在！`,
"front-electronic-signature-isclose":``,
"label.optional.groups":`可選報價行組`,
"pagecreator.layout.label.layoutname":`配置名稱`,
"label.error404":`您存取的頁面不存在<br />請您稍後再來...`,
"label.eventtrigger":`事件觸發器`,
"label.projectManagement.next.page":`後一頁`,
"vue_label_SMS_chosen":`已選擇`,
"label.part.cannot.empty":`段不能為空！`,
"label.call.center.jilu":`通話記錄`,
"front-kefu-moudle-v1-tenant-reinput":`請輸入租戶ID`,
"label.projectManagement.you.want.to.delete.this.data":`確認要刪除這條數據嗎`,
"label.projectManagement.nocharge":`不計費`,
"System_TAB_SeeViewPageAmount":`查看頁數`,
"label.password.query.error":`使用者查詢出現錯誤`,
"message.chooseatleastone":`請至少選擇一個值`,
"label.sortasc":`遞增`,
"label.stdashbord.xsld.business.jinezhb":`金額占比`,
"label.attendance.add":`添加考勤`,
"vue_label_account_invoices":`轉移客戶擁有者的全部發票`,
"label_delete _model":`刪除模型會同時刪除相關目標數據，且不可撤回。確認刪除麼？`,
"label.folder.sort。discreption":`文件夾將按照選擇的順序輸出。`,
"label.partnerCloud.financeSetting.merchantPlatform":`獲取路徑：商戶平台-帳戶中心-API安全-API密鑰`,
"label.equal":`=等於`,
"lable.PowerProcess.Workorder":`工作訂單`,
"front-docusign-setting-error-tips":``,
"template.report.lead.status":`商機狀態`,
"label.create.remark":`新增備註`,
"font-evaluate-module-v1-one-points":``,
"label.validate.function.funcExplain.DATETIMEVALUE":`返回年，月，日以及GMT時間（日期/時間 欄位）`,
"label.report.select.group.mode":`選擇分組方式`,
"label.h5.editmydetails":`編輯個人訊息`,
"front-epwechat-module-v1-authorize":`授權回調域：`,
"label.tabpage.kanban":`看板設定`,
"label.emailobject.emaildetail.button.addtocontact":`添加到聯繫人`,
"lable.opppdt.selPbk.description":`為此業務機會選擇價格手冊。您只能從單個價格手冊添加產品。更改已選取價格手冊將從該業務機會中刪除全部現有的產品。`,
"component.event.button.save":`儲存`,
"vue_label_homepage_homepage_assigned_success":`主頁指派成功`,
"message.duplication.label.blankmatch":`空值是否匹配`,
"label.icon.24":`急救箱`,
"label.mobile.same":``,
"label.file.library.managemembers.addmember":`添加成員`,
"chatter.sp":`顯示微貼`,
"label.user.notlogin.range":`不在登錄時間範圍內！`,
"label.step3.total7":`第3步，共7步`,
"label.user.fullname":`全名`,
"label.button.menubar":`選單欄`,
"#label.importfilestep3":`步驟三：選擇並上傳您的文件#`,
"label.appointment.wizard.subtitle6":`描述`,
"message.lostnextapprover":`此提交需要相關使用者欄位確定的下一位審批人,此值為空。詳情，請與您的管理員聯繫。`,
"label.sso.saml.sp.logoutUrl":`身分識別提供者單一登出URL`,
"label.weixin.isgoon":`您的會員訊息已存在，如繼續，以前綁定此手機號的微信號將不能使用愛馬社微信公眾號。是否繼續？`,
"vue_label_notice_homepage1":`請輸入12位之內的正確的目標值`,
"label.umeng.activity.event.will":`即將在`,
"label.insertURL":`插入URL`,
"label.partnerCloud.orderingPlatform.administrator":`無可用價格手冊，請聯繫系統管理員`,
"vue_label_systemSettings_emailtemplate":`電子郵件模版`,
"template.dashboard.market.analysis":`行銷活動分析`,
"message.deleteapproval.tip":`您只可以刪除與其沒有數據記錄關聯的審批流程。`,
"pagecreator_page_message_delete":`是否刪除當前所選頁面？`,
"component.telerecord.label.message":`留言`,
"front-email-payment-Invoice-preview-opening":``,
"noless":`大於或等於`,
"label_emailtocloudcc_button_back":`取消`,
"lable.Please.select.a.template":`請選擇現有範本`,
"front-lightning-module-v1-details-page-chart-relevant":`· 當所選報表的相關物件中包含當前物件，可以將報表中的資料根據目前記錄進行進一步篩選；可以選擇是否允許使用者手動重新整理報表中的快取資料`,
"label.object.page.head":`頁首`,
"label.notification.time1":`剛剛`,
"label.weixin.optionnine":`選項九`,
"label.approval.content.tolang":`輸入內容過長，請重新輸入！`,
"label.leadconvers":`商機轉換`,
"label.compact.layout.frame.tabseq":`顯示TAB頁面順序：`,
"label.permission":`權限集`,
"vue_label_notice_new_success":`建立成功`,
"label.money":`貨幣`,
"label.ccchat.person.invite.unsuppem":`您輸入的電子郵件地址對{0}不支援`,
"message.profile.del":`此設定檔為系統管理員設定檔，不能刪除！`,
"vue_label_report_savelocation":`儲存位置`,
"label.knowledgebase.select.lighting.target":`請選擇lighting目標`,
"label.visualpage.labelname":`頁面標籤名`,
"label.notification.ccchat2":`【點讚使用者名】讚了您的微貼`,
"label.htyj.wanchenglv":`完成率`,
"label.weixin.report.generatedchart":`已產生圖表`,
"label.customer.tab.please.label":`請輸入選項卡標籤`,
"label.template.lookup":`查看範本`,
"label.attendance.setting.wucha":`誤差200米以內`,
"vue_label_opportunity_product_addproduct":`添加產品`,
"label.data.setok.t.desc3":`，進行操作。`,
"label.emailobject.template.public":`公開`,
"label.setsubmit":`提交設置`,
"chatter.feed.menutype.feed.companycom":`所有微貼`,
"label.Generate.Document":`產生文檔`,
"label.knowledge.setting.hint.six":`通過數據分類組織文章`,
"label.dashboard.show.total":`顯示總數`,
"attachment.select.warning.001":`勾選了歸檔的附件，歸檔按鈕不可用， 請重新選擇附件。`,
"message.schedulejob.error.delete":`刪除Job庫的過程中發生錯誤。`,
"setup.layout.group.pagecomponent":`頁面元素`,
"label_partner_new_step3_meno":`不確定輸入什麼？別擔心，您隨後可以隨時進行更改。`,
"label.partnerCloud.orderingPlatform.mutex":`互斥`,
"label.subtotalrely":`小計依據`,
"label.file.library.selectFile2Lib":`新增檔案`,
"label.lock.record":`已鎖定記錄（`,
"label.multilang.addcustomreporttypestage2.description":`此數據源將產生有關{0}的報表。通過選擇一個與它有關係的物件,
可以定義其他物件中的哪些相關記錄將返回到數據源結果中。`,
"message.duplication.errorinscript.greaterthan10":`最多只可選擇10個要合併的記錄!`,
"label.encd":`顯示加密`,
"UG.Account.03":`主動檢查重複客戶並合併`,
"label.salescloud.teamrole.main2":`主要`,
"label.email.to":`收件人`,
"label.members.sign.notify":``,
"template.report.individual.case.priority":`個案優先級`,
"vue_label_report_selectfolder":`選擇文件夾`,
"label_partner_all":`全部夥伴雲`,
"lable.custom.year":`自訂年度`,
"label.ispigeonhole":`附件歸檔`,
"label.campaignmember.selectmember.steptotal":`第2步，共2步`,
"label.userphoto.save":`儲存`,
"label.knowledgebase.published.version.online":`已發布版本仍將在線，直到您發布此一草稿。`,
"template.report.customer.level.statistics":`客戶級別統計`,
"label.mobile.phone.day.plan":`明日計劃`,
"label.icon.95":`教學`,
"label.recordphone":`記錄電話`,
"lable.currencyManage.unEnabledadvcurrency.discripation":`如果禁用進階貨幣管理，將無法使用過期匯率。業務機會、業務機會產品和這兩個物件相關的報表的貨幣將不再映射特定日期範圍內的匯率。所有的貨幣欄位都將使用固定匯率。`,
"label.service.gantt.is.candidate":`的候選人`,
"label.ruleofchecktask":`任務驗證規則`,
"label.whole.page.show":`整頁顯示`,
"label.validate.function.funcFormat.ISNULL":`ISNULL(expression)`,
"label.ccdocument.template.set":`範本套紅功能`,
"label.icon.103":`日程`,
"lable.no.products.to.assets":`沒有可以轉換為資產的產品`,
"label.fristname":`名字`,
"label.appointmentconfirmail.wizard.subtitle5":`發起者/組織者`,
"label.partner.workspace.myspace":`我的工作區`,
"label.tabpage.optionsz":`選項`,
"component_chatter_link_button_save":`發表`,
"label.validate.function.funcFormat.NOW":`NOW()`,
"label.discountPlanEditor":`折扣計劃編輯器`,
"label.weixin.fmu.pm":`下午{0}`,
"front-gantt-module-milestone-sorting":``,
"label.partnerCloud.maximumNumber":`夥伴站點的最大數量：`,
"label.mobile.place.record.interval.setup":``,
"label.visiblelinenumber":`可視行數`,
"front-kefu-moudle-nopower-calluser":``,
"label.field":`欄位`,
"label.projectManagement.groupbydate":``,
"label_vue_create_edit_obj_create_event_dialog_desc_deal_field":`安排了`,
"label.operation.monitoring.history":`作業監控歷史`,
"label.data.dataexpalltype.all_desc1":`1、匯出全部的壓縮文件密碼可以自動產生，或手動輸入。自動產生的密碼將在資料匯出成功後發送到使用者郵箱。手動輸入的密碼不會發送到使用者郵箱，所以需要使用者牢記自己輸入的密碼，若不輸入，則預設沒有密碼。`,
"front-web-module-v1-detail-comment-proposal":``,
"label_partner_workspace_member_selectedpermission":`已選權限集`,
"vue_label_helpcenter_view1":`在lighting版本的視圖中，您可以直觀、靈活地查看、管理擁有存取權限的數據。通過視圖，可以實現數據分類查看、以多種方式展示數據、新增、修改、刪除數據等基本功能，還可以便捷的查看報表、圖表，以便對數據進一步分析。<br>1、管理視圖<br>在視圖的左上角下拉選單中，選擇想要查看的視圖，並可通過固定設定選擇預設視圖。<br>使用列表視圖控制選單，可以建立、編輯、刪除視圖，或是進行排序。同時，使用右上方的篩選器功能，也可以快速的編輯、建立視圖。<br>2、通過多種視圖查看數據<br>可以通過不同的方式查看數據。在右上角切換列表、看板、並列三種方式來查看數據。<br>在列表視圖下，部分類型的欄位支援直接對單條或多條數據進行修改。雙擊需要編輯的單元格，或點擊編輯按鈕，可以直接彈出視窗對數據進行編輯。若要編輯多條數據，只需先選擇多條數據，再在編輯的彈出視窗中選擇“應用於所選數據”。 <br>在列表視圖中，可以在左上角直接編輯要展示的列，在表頭處點擊表頭進行排序，或通過下拉浮窗選擇要鎖定的列。<br>設定看板視圖後，可以分組查看數據，並查看每個分組的匯總值。在看板視圖設定中，可以編輯看板視圖的分組依據、匯總依據與匯總方式，同時也可以選擇最多四個欄位來展示。通過拖曳方式可以快速更改數據的分組。<br>在並列視圖下，可以快速切換查看每條數據的詳細訊息。<br>3、快速分析銷售數據<br>在視圖右上角，可以打開視圖內圖表，對視圖內數據進行簡單可視化分析。同時可以查看視圖數據相關的儀表板與報表列表，進行進一步分析。<br>點擊右上角的圖表按鈕，可以查看、建立、編輯利用視圖數據建立的簡易圖表，或是查看當前視圖相關的儀表板。<br>步驟1：單擊右上角圖表按鈕，展開頁面內圖表，可以根據權限查看並管理現有圖表，並查看視圖數據相關的儀表板列表。<br>步驟2：點擊設定按鈕，可以根據權限建立、編輯、刪除圖表。可以建立垂直柱狀圖、水平柱狀圖、圓餅圖與漏斗圖四種樣式的圖表。<br>點擊報表按鈕，可以查看當前視圖相關的報表。<br>4、在視圖中管理數據<br>在視圖內，根據您的權限，通過視圖右上方的按鈕，或是每條數據旁，可以對數據進行新增、編輯、刪除、更改擁有者等操作。<br>利用標籤來協助您的數據管理。通過右側按鈕展開標籤管理列表，可以以標籤為依據對視圖內數據進行篩選。點擊管理標籤後，還可維護管理您的標籤庫。選中數據後使用右上角的添加標籤按鈕，還可批次為數據增加標籤。`,
"component.task.label.priority":`優先級`,
"label.datamanage.field.error":`查詢物件欄位出現錯誤`,
"label.console.step3":`步驟 3. 選擇控制台標誌的圖像源`,
"label.ems.emailsyncsetup":`信件同步設置`,
"label_tabpage_placeenterz":`請輸入`,
"label.getontocolumn":`轉至列：`,
"label.file.down.e":`目前檔案類型不允許下載`,
"vue_label_notificationcenter_unreadonly":`只顯示未讀`,
"label.login.access.change":`更改`,
"label.globaloperation.operationtype.send_e-mail":`發送電子郵件`,
"label.dashboard.refresh.hint":`重新整理儀表板會重新運行所有來源報表，因此會佔用一些時間，是否繼續？`,
"front-kefu-moudle-open-free":``,
"label.lanxin.setting.appsecret":`AppSecret`,
"label.payment.manage.order":`管理訂購`,
"label.chatter.maturiyDate":`到期日期`,
"message.mobilechooseatmostthree":`手機前臺選項卡最多選取三個欄位`,
"label.customfields.formula.tip":`根據您定義的公式表達式派生其值的唯讀欄位。任何來源欄位有所更改，該公式欄位均將更新。`,
"lable.PowerProcess.start.time":`請選擇開始時間`,
"label.mr.title.button.group2":`組重複數據，共有`,
"label.atlantic.standard.time":`大西洋標準時間`,
"label.account.LengthofTime":`持續時間`,
"label.ccchat.message.search.desc2":`的消息`,
"label.pigeonhole.desc":`附件歸檔只針對未歸檔的附件有效，對已歸檔的附件無效。<br/>附件一旦歸檔，將不可刪除。`,
"label.partnerCloud.orderingPlatform.sure":`切換{alias}會清空購物車，是否確認？`,
"label.default.value.is.positive.integer":`預設值值必須是正整數！`,
"label.partnerCloud.selectOne":`至少選擇一個選單`,
"label.dashboard.more.condition":`更多條件`,
"component.event.label.enddate":`*結束時間`,
"label.forecast.settings.type":`預測類型`,
"com.cloudcc.login.error.message.licensenotstart":`許可未開始`,
"lable.list.queue":`佇列`,
"label.mobile.app.isdisablum":`是否禁止簽到時從手機相冊選擇照片`,
"label.service.gantt.filter":`在使用技能篩選時，僅擁有選定技能的資源才會顯示到甘特圖上`,
"label.potentialcustomeronline":`在線商機`,
"label.campaignmember.main.deletecontactdesc":`一次從市場活動批次刪除全部聯絡人`,
"label.list.desc1":`通過 web to cloudcc 功能，產生web頁面，通過web存取捕獲數據到cloudcc系統。`,
"label.generatepage.title.desc3":`名稱必須是唯一的，並且名稱必須以字母開頭，只能包含大小寫字母，數字，下劃線，且長度不能大於30。`,
"label.emailtocloudcc.step2total3":`第2步，共3步`,
"label.movablemenu":`活動按鈕`,
"label.partnerCloud.partnerAccount.topUp":`儲值`,
"label.data.standobject":`標準物件`,
"label.frequency":`頻率`,
"label.schedulejob.setup.schedule.end":`結束`,
"label.chat.topic.following":`正在追蹤`,
"label.martrixreport.2018.step2":`步驟2：選擇要匯總的訊息`,
"label.event.moveup.11hour":`提前 11 小時`,
"label.forecast.customforecast.directorcommit":`直接下屬的承諾額`,
"vue_label_homepage_card_view":`卡片視圖`,
"vue_labenl_applauncher_notice_closecertification":`關閉後將會導致數據遺失，是否確認關閉`,
"component_setup_button_weburl":`外部URL`,
"label_emailtocloudcc_button_addemailaddress":`添加企業信箱`,
"vue_label_campaign_added_campaign_members":`添加行銷活動成員成功`,
"label_tabpage_rtemptyz":`記錄類型不能為空`,
"label.martrixreport.2018.step5":`步驟5：選擇圖表類型和報表突出顯示`,
"label.moverecord":`轉移記錄`,
"pagecreator_layout_label_layoutdesc":`配置描述`,
"label.knowledge.setting.data.nine":`是，我要刪除此一類別組及其類別`,
"label.icon.90":`人`,
"label.weixin.micro.research.name":`微調研名稱`,
"label.ccchat.micropost.allowedit":`允許使用者編輯帖子和留言`,
"vue_label_homepage_fixed_components":`標準組件`,
"label.version.document":`文檔庫`,
"label_assessment":`考核（機會-金額）`,
"label.appupload.component.type.lookuplayout":`搜尋配置`,
"label_chatter_loadmore":`加載更多`,
"component_setup_tabs_label_memo":`設置Tab標籤名稱`,
"label.icon.167":`指南針`,
"vue_label_chatter_enter_content_sharing":`請輸入共用內容和分享小組`,
"vue_label_notice_modify_success":`修改成功`,
"label.sharerules":`共用規則`,
"label.field.api.exists":`欄位API已存在`,
"label.icon.83":`粉刷`,
"label.file":`文件`,
"vue_label_report_foldernameisrequired":`文件夾名稱是必填項`,
"label.emailobject.wizard.btn2":`已關聯，去發郵件`,
"label.data.downpage.i_title.num3":`3、匯入之前，請先確保匯入其相關的所有記錄。例如：如果您當前匯入的物件與聯絡人之間存在對應關係，請先匯入這些聯絡人，然後再匯入您的數據。`,
"label.email.original.content":`原文內容`,
"vue_label_campaign_add_to_campaign":`添加到行銷活動`,
"label.dashboard.new":`新建儀表板`,
"label.console.detail":`查看控制台`,
"label.view.desc":`日期欄位等於時可以使用“昨天”，“今天”，“明天”，“上個月”，“本月”，“下個月”，“上星期”，“本星期”，“下星期” 或 “YYYY-MM-DD、MM/DD/YYYY”格式。`,
"label.emailobject.template.insert.continue":`繼續添加`,
"label.notification.appointment.overlapEvent":`該時段已被預約，請重新選擇`,
"label.console.step6.top":`固定到頂部。列表始終可視。`,
"label.data.file.the_trigger":`執行觸發器`,
"message.report.error.operation":`操作失敗,請重新設置報表！`,
"vue_label_helpcenter_detail3":`<br>    點讚和取消點讚<br>    您可以對微貼或微貼的評論進行點讚。點讚後可以查看該帖子的點讚人數，也可以取消點讚。<br>編輯和刪除帖子<br>    帖子的發表人可以重新編輯或者刪除帖子。<br>    步驟1:點擊帖子右側的按鈕，在下拉框中選擇編輯或刪除<br>    步驟2:打開編輯/確定刪除的彈窗<br>    步驟3:點擊儲存/確定，完成操作<br>5、審批歷史<br>提交待審批<br>    當建立一條新紀錄、撤回審批請求或者審批被最終拒絕後，會出現“提交待審批”按鈕。<br>    步驟1:點擊“提交待審批”。系統會判定該條記錄和提交操作人是否滿足審批流程設定的項目和初始提交人條件，如果以上條件都滿足，則提交成功。<br>    如果審批流程配置中下一個審批步驟需要手動選擇審批人，則“提交待審批”後執行步驟2。<br>    步驟2:選擇下一個審批人，完成提交操作。<br>審批歷史<br>    A.提交前：<br>    點擊“審批流程預覽”，系統會判斷該條記錄和提交操作人是否滿足審批流程設定的項目和初始提交人條件，如果以上條件都滿足，則展示審批流程。<br>    B.提交後：<br>    在審批歷史中您不僅可以查看該記錄的審批歷史步驟和當前的審批狀態，還可以預覽接下來的審批流程。<br>撤回批准請求<br>    如果該審批流程設定了可以撤回審批請求，則在您提交之後可以隨時撤回。<br>    步驟1:點擊記錄詳情頁的“撤回批准請求”<br>    步驟2:打開撤回批准請求頁面，點擊“撤回批准請求”，完成操作`,
"Opportunity_Detailed_Phase_Label_004":`天`,
"PageLayout_Search_MultiSearch_001":`您最多只能選擇不超過3個欄位。`,
"vue_label_systemSettings_set_business":``,
"label.compact.layout.frame.select":`請選擇版面配置框架`,
"label.tabpage.rolez":`角色`,
"label.weixin.appr.currentauditor":`被分配人`,
"label.knowledgebase.verification.status":`驗證狀態`,
"UG_Case_05":`建立個案`,
"label.service.marking.completed":`標記已完成`,
"label.notification.ccchat1":`【發出@的使用者名】提及了您`,
"label.knowledgebase.no.action.available":`無操作可用`,
"label.tabpage.newlybuildz":`建立自訂報表數據源`,
"label.appupload.install.error.choice2":`重新命名與軟體包中衝突的本地組件`,
"label_tabpage_as":`如`,
"Opportunity.Detailed.Phase.Label.Popup.001":`進入日期`,
"vue_label_homepage_singlepage":`單個頁面最多添加10個組件`,
"font-evaluate-module-v1-fair-and-bad":``,
"label.partnerCloud.orderingPlatform.orderInformation":`訂單資訊確認`,
"label.custom.lead.conversion.notice":`商機轉換通知`,
"label.re.upload":`重新上傳`,
"label.knowledgebase.top.window":`最上層視窗`,
"label.h5.allmarkedasread":`全部標記為已讀`,
"vue_label_SMS_open_record_from_start_activation":`從列表中打開記錄，以開始啟用。`,
"label.customer.tab.step2":`步驟2：添加到設定檔`,
"label.campaign.channel.input.owner.select2":`此營銷渠道邀約人`,
"component.task.button.save":`儲存`,
"front-kefu-moudle-v1-phone-type":``,
"label.wedge-shapearrows":`楔形尾箭頭`,
"vue_label_homepage_todaysevent":`今日事件`,
"label.data.exp.way.sel":`選擇匯出方式`,
"label.setting.intergrationlist.status1":`目前尚未安裝此集成`,
"button_partner_workspace_disable":`取消啟用`,
"label.customfields.reference":`可能會被公式、選項列表、查找等其它欄位所引用。`,
"label.publicgroups.new":`新建公用小組`,
"label.data.setok.e_desc3":`下載您匯出的數據。`,
"vue_label_commonobjects_view_chart_countmode":`合計方式`,
"label.service.appointmentList.earliest.allowedStart":`最早允許的開始時間`,
"label.data.choses.e.desc":`根據您的需要，可以選擇匯出全部數據或選擇匯出單個物件的數據。`,
"label.multilang.common.fieldlist.fieldremark":`應用於在{0}頁面上顯示的欄位。`,
"label.umeng.activity.event":`事件`,
"label.project.hit.ten":`問題更新通知`,
"label.c_d_least":`每個 C" 記錄必須至少有一個相關 "D" 記錄。"`,
"label.emailobject.wizard.btn1":`關聯個人信箱`,
"lable.product.pricebooks.info":`價格手冊詳細訊息`,
"component_telerecord_label_message":`留言`,
"lable.total.of.estimates":`共計0個估算`,
"label.stdashbord.xsld.business.oppcounts":`機會數量`,
"vue_label_commonobject_duplicatewith":`與{0}中{1}重復`,
"label.setpicandreport":`圖表設置`,
"label.category.2":`通用`,
"label.emailtocloudcc.reauthorization":`重新授權`,
"label.chatter.vote":`投票`,
"label_emailtocloudcc_edit":`編輯`,
"label.pleaseinput":`輸入`,
"vue_label_homepage_user_particular_application":`使用者使用特定應用程式時的主頁，這些指派會覆蓋標準主頁`,
"label.allianceID":`聯盟ID`,
"label.h5.homepage.cannot.applied.mobile.terminal":``,
"label.appointmentpage.wizard.notif2":`請填寫姓名`,
"label_emailsync_status_email":`操作信箱`,
"label.icon.179":`人`,
"UG_Contract_03":`建立合約`,
"label.cy.new":`新幣種`,
"label.version.setup.controllist":`後台設置控制列表`,
"label.vlidaterule":`驗證規則`,
"label.customer.tab.name":`選項卡名`,
"label.recentview.seloption1":`我最近查看的`,
"vue_label_report_notice_nameisrequired":`報表名稱為必填項`,
"label.createapproveprocessstep":`<li>1.閱讀幫助主题</li><li>2.建立電子郵件範本</li><li>3.建立簡訊範本</li><li>4.使用跳轉起點嚮導或標準嚮導建立審批流程</li><li>5.將批准歷程紀錄"相關列表添加到全部版面配置</li><li>6.啟用流程，部署给用户</li>`,
"label.gotocalendar":`去日曆`,
"label.import.page1.pleaseselectobj":`請先選擇物件`,
"label_tabpage_messagez":`請輸入留言`,
"vue_label_homepage_profilepage":`設定檔主頁`,
"label.tabpage.choose":`選擇`,
"label.campaignmember.setup.lead.field":`商機欄位`,
"label.setalipay.null":`配置支付寶必填訊息為空`,
"label.custom.Current.and.NextCQ":`當前和下一個自訂季度`,
"label.knowledgebase.needto.publish.articles":`還原已歸檔文章會建立草稿版本。您將需要發布文章嗎，以使其可用。`,
"pagecreator.layout.message.save.success":`配置儲存成功`,
"homepage.componet.approval.label":`審批中心`,
"label.last_submission":`最後送出時間`,
"lable.outlook.detail.prefo":`首選Exchange`,
"label.projectManagement.new.subtask":`建立子工作`,
"label.service.appointmentList.checkThe":`勾選`,
"message.error.searchlayoutselectdefields":`無法刪除，並且必須是搜尋配置中的第一個欄位。`,
"label.ems.normal":`正常`,
"vue_label_notice_pleaseselectobject":`請選擇物件`,
"component.sendmail.button.send":`發送`,
"label.relevant.records":`相關記錄`,
"label.weixin.login.CloudCC":`登錄到 CloudCC`,
"label.tag.addtags.private":`私用`,
"label.appointment.disable.remark":`非常抱歉，此功能已經被禁用。如果您想重新或者取消預約，請由郵件：{信箱地址}與您的負責人聯繫`,
"label.campaignmember.main.addMember1":`添加成員`,
"message.error.objectnofound":`物件未定義;`,
"label.employeenum":`員工編號`,
"label.search.applyfilter":`應用篩選`,
"label.version.history.track.nonsupport":`僅僅無限版本支援欄位跟追蹤歷史功能。`,
"label.ccpeak.direction.for.use.time":`CloudCC 平臺定時類使用說明[2.0版本]`,
"label.ems.settings":`設置`,
"label_tabpage_arecordtypez":`可用記錄類型`,
"vue_label_pool_assign1":`{0}{1}`,
"label.customcomponent.direction.for.use":`平臺自訂組件使用說明[2.0版本]`,
"label.appupload.appname":`軟體包名稱`,
"label.cpq.order.status.no.active":`只有啟動狀態的訂單才能產生合約`,
"label.dashboard.maxlength":`請輸入至多255個字元`,
"label.customize.memory.function.sorting.title2":`表頭排序記憶`,
"label.report.chose.obj":`選擇物件關係與報表數據源`,
"label.partner.step3":`步驟3：基本訊息`,
"message.report.type.error.fail":`報表類型錯誤！`,
"pagecreator.page.message.publish.fail":`頁面發佈失敗`,
"label.minimun":`最小值`,
"label.state":`狀態`,
"label.customcomponent.referencetype":`引用類型`,
"label.nameandemailtemplate":`在下面的框中輸入過程名，然後選擇一個電子郵件範本，通知審批者（可選）.`,
"label.customobjects.track.introduce":`此頁面允許您選擇要在`,
"label.campaign.matchway.label":`匹配方式：`,
"label.redistribution":`重新分配`,
"label.groupmanage":`組織管理`,
"label.icon.157":`攝像頭`,
"label.quickbooks.viewlist.total":`總計`,
"label.file.copy.file.fail":`複製失敗，請手動複製`,
"label.outline.selectfield":`概要選中的欄位：`,
"label.datetime.maxsize":`查詢的週期不能大於3個月`,
"label.dashboard.CustomDashboardMyHomePage":`自訂我的主頁儀表板`,
"label.data.customobject":`自訂物件`,
"vue_label_SMS_noselected":`未選擇記錄`,
"label_tabpage_value":`值`,
"label.quote.qianming":`簽名`,
"label.view.source":`原始代碼查看`,
"label_popup_infoz":`提示`,
"label.emailtocloudcc.redmessage8":`參數錯誤，請聯繫管理員`,
"label.tianyancha.Search.business":`搜尋工商註冊訊息`,
"vue_label_systemSettings_server":`服務`,
"vue_label_homepage_dashboard_components":`儀表板組件`,
"label.search.listview":`列表視圖`,
"label.service.gantt.distribution.success":`指派成功`,
"label.icon.4":`錢包`,
"label.partnerCloud.orderingPlatform.calculate":`計算價格`,
"label.forecast.edittotal.ycyx":`預測優先`,
"vue_label_commonobjects_detail_to_precise_search":`前往精準搜尋`,
"label.order.number":`序號`,
"setup.mainpage.label.welcome7":`操作指導： 點擊本頁左側選單 → 應用程式設定 → 建立 → 物件 → 物件名 → 自訂欄位。`,
"label.weixin.user.binding":`使用者綁定`,
"label.custom.canvas.size":`畫布大小`,
"label.projectManagement.recent.projects":`最近的項目`,
"vue_label_helpcenter_lead":`通過Cloud CC追蹤管理您的商機。利用配置好的規則對商機進行評分、指派，並在合適的時機將商機轉化為客戶、聯絡人，與對應的機會。<br>評分<br>在視圖的右上角，通過批次評分按鈕，為該視圖中的商機進行評分。<br>指派<br>在建立或編輯商機時，在頁面下方選擇指派，即可按照已有規則將商機指派給對應的人員處理。<br>轉化<br>在合適的時機，可以通過點擊詳情頁面中右上角的轉化按鈕，將商機轉化為客戶、聯絡人，同時可以建立對應的機會與工作，方便繼續跟進交易機會。`,
"label.enabledprocess":`已啟用的審批流程`,
"label.emailobject.noemail":`尚無任何郵件，快去發一封吧！`,
"label.validate.remark3":`根據另一個欄位值有條件的決定欄位是否必須`,
"vue_label_salesadvance_retention":`滯留`,
"label.product.managep":`管理價格手冊`,
"font-evaluate-module-v1-not-report":``,
"label.emailmerge.mergepage.step1":`1.選擇要合併的記錄:`,
"front-epwechat-module-v1-epwechat-describe":`CloudCC提供整合企業微信的能力，結合企業微信強大的功能與輕量化的H5版本CloudCC系統，<br />幫助您便捷的管理客戶關係，運營私域流量，提升企業營收能力。`,
"label.partner.template.detailimage":`詳圖`,
"label.recycle.clearall":`清空貴組織的回收桶`,
"chatter.error.nottype":`錯誤:無效的類型,可以上傳的文件類型是JPG、GID、PNG!`,
"pagecreator.button.cancel":`取消`,
"front-market-form-quired-ziduan":``,
"vue_label_report_columnname":`列名稱`,
"message.notdelete.type":`無法刪除此記錄類型，因為以下設定檔使用此記錄類型作為預設值。`,
"label.ccpeak.folder.all.time":`所有定時類文件夾`,
"label.quickbooks.searchlist.total3":`搜尋到有{0}個尚未關聯的估算記錄，共計金額為{1}`,
"label.forecast.detailforecast.quantity":`數量預測`,
"label.knowledge.language.british":`英式英語`,
"label.vlidaterule.example.messagelocation":`該錯誤訊息可出現在頁首或頁中某一特定欄位的下面`,
"front-kefu-moudle-chf-success":``,
"vue_label_jihui_yi":`機會1`,
"label.import.step1.null":`無可選項`,
"label.console.step5.tab.subtab":`作為次選單`,
"batch.edit.permission":`無編輯權限`,
"label.weixin.fmu.before.min":`提前 {0} 分鐘`,
"chatter.up.file":`上傳文件可能花費一些時間，這取決於文件大小。請等待上傳文檔。`,
"setup.layout.group.field":`欄位`,
"label.chat.unlike":`取消讚`,
"vue_label_dashboard_updatefrequency":`更新頻率`,
"label.trigger.folder.new":`觸發器頁面：新建文件夾`,
"label.process.des.app":`若要查看當前記錄的詳細訊息，請點右側連結進入。`,
"vue_label_pool_assignselect":`選擇指派成員`,
"label.lookup.user":`查找人員`,
"label.mobilescreentablayoutedit.remark2":`選擇要在手機前臺選項卡頁面篩選裡顯示的欄位`,
"label.data.exp.objtemp":`您將按以下條件製作匯出此物件的範本`,
"label.weixin.moreselect.error":`只能選擇10條記錄`,
"label.icon.25":`包紮`,
"lable.sample.text":`示例文本`,
"label.most.setup.obj":`最多可設置10個物件`,
"label.weixin.coming":`未來`,
"label.editdescription":`編輯備註`,
"label.multipleactivity.multiple":`多個使用者`,
"label.sso.saml.idp.entityid":`實體ID`,
"label.SMS.pho.filed":`電話欄位`,
"message.serviceabsence.violation":`活動成員`,
"label.forecast.settings.type.clist":`使用產品系列`,
"label.state.noend":`未結束`,
"label.sourcetemp":`原始翻譯範本`,
"vue_label_chatter_name_link":`請填寫名稱和連結`,
"label.emailobject.attach":`添加附件`,
"label.everyother":`每隔`,
"label.title":`CloudCC.com`,
"vue_label_chat_haventactivate":`尚未開通聊天帳號，是否立即開通帳號？`,
"pagecreator_layout_button_delete":`刪除配置`,
"label.transfer.temporarily":`調用`,
"label.service.dispatchingUnits.search.services":`搜尋服務預約`,
"customer.message.fail.chat":``,
"label.apiname.toolong":`Api名稱過長`,
"label.empty.filter":`清空篩選`,
"label_tabpage_personalCenterz":`個系統`,
"label.minutes":`分`,
"label.multipleactivity.atasks":`個任務`,
"label_tabpage_deleteview":`刪除視圖`,
"pagecreator_layout_message_save_success":`配置儲存成功`,
"label.reportlineorder":`報表列順序`,
"label.total.forecast.have.priority":`的任何預測優先,但是接受其他下屬的預測優先`,
"label.custom.quarter.subtitle":`自訂季度`,
"label.icon.79":`印刷`,
"label.hiddenoperate":`隱藏操作`,
"label.project.hit.six":`項目工作指派通知`,
"label.visualpageaction.errordesc":`您沒有足夠的權限執行所請求的操作。如果需要存取，請聯繫記錄所有人或管理員。`,
"label.chat.unmute":`取消免打擾`,
"label.zhaiyao":`摘要`,
"vue_label_commonobjects_detail_bcc":`密送`,
"label.customcomponent.page.index.table.version":`API版本`,
"UG.quota.06":`建立報價`,
"label.icon.152":`機器人`,
"label.partnerCloud.partnerAccount.account":``,
"label.file.sharewith":`共享者`,
"label.data.dataexptemplate.desc2":`2、匯出方式的壓縮格式分為兩種：一種是自動產成壓縮檔密碼，自動產成的密碼將在資料匯出成功後發送到使用者郵箱；另一種是手動輸入壓縮檔密碼，手動輸入的密碼不會發送到使用者郵箱，所以需要使用者牢記自己輸入的密碼，若不輸入，則預設沒有密碼。`,
"vue_label_dashboard_newfoldersuccessfully":`建立文件夾成功`,
"label.campaignmember.main.importmember":`批次匯入市場活動成員`,
"label.htyj.completed":`已完成`,
"label.reportTypeLabel":`報表標籤`,
"label.customer.tab.label":`選項卡標籤`,
"label.dashboard.component":`組件`,
"label.safetystatement.dialog":`安全聲明 （新視窗）`,
"label.forecast.settings.data":`預測日期`,
"label.knowledgebase.modifiedby":`修改人`,
"label.batchadd.remark":`可以增加多條記錄`,
"button.partner.delete":`刪除`,
"Pagelayout_Setup_005":`名稱必須放在第一個位置`,
"label.forecast.edit.wcpxl":`無產品系列`,
"lable.PowerProcess.seq.input":`請輸入順序`,
"pagecreator.layout.message.delete.fail":`配置刪除失敗`,
"label.emailobject.edit":`編輯`,
"label.weixin.million":`萬元`,
"setup.mainpage.button.manageobject":`物件管理`,
"label.weixin.participants.perfect.information":`是否要求參與者完善訊息`,
"vue_label_campaign_campaign_members":`添加行銷活動成員`,
"label.ccchat.person.invite.emplaceholder":`輸入電子郵件地址，用分號隔開`,
"label.mobile.phone.new":`新增`,
"font-evaluate-module-v1-small-program-evaluation-settings":``,
"UG.opportunity.005":`多銷售流程`,
"vue_label_report_polymerization":`加總`,
"label.multilang.lookfiltercondition.fieldtypenotmate":`第{0}行條件錯誤,欄位類型不匹配！`,
"label.knowledgebase.delete.draft":`刪除草稿？`,
"label.mr.descreption.condition3":`規則-是否完全匹配：勾選此選項，按欄位的相同數據查詢重複數據。勾選此選項後，按前幾個字元輸入將失效。`,
"Lead.Auto.Scoring.Setting":`商機自動評分設定`,
"label.marketing.channel.default":``,
"front-project-module-v1-select-projecttemplate":`選擇項目範本`,
"front-email-payment-select-area":``,
"lable.PowerProcess.message":`權利過程訊息`,
"label.weixin.free.get.captcha":`免費獲取驗證碼`,
"label.projectManagement.please.select.task.or.question":`請選擇工作/問題`,
"label.pacific.daylight.time":`太平洋夏令時`,
"label.sendsms.batch.step1.introduce":`選擇以下視圖之一(其中包含此簡訊的接收者)。`,
"label.same.analyze.account.name":`客戶名稱`,
"Homepage.Contract.FieldMissed.DoesntSupport":`合約物件中找不到欄位 "qdrq" 和"htje" ，數據無法顯示。`,
"label.partnerCloud.orderingPlatform.noProduct":`目前該產品沒有產品選項需要配置`,
"label.totalsummary":`累計彙總`,
"label.partner.workspace.tab":`選項卡`,
"label.entitlement.process.name.unique":`名稱已存在，請重新填寫`,
"report.label.norole":`您沒有此權限，請聯繫系統管理員！`,
"label.password.old.error":`輸入的舊密碼不正確`,
"lable.account.quarter.stadate":`會計季度起始日`,
"label.salescloud.contactrole.choose.correct":`選擇了重複的聯絡人，請更正`,
"label.schedulejob.setup.schedule.day":`日`,
"label.communalusergroup":`公共使用者組`,
"label.Display.Fields":`服務預約列表上要顯示的欄位`,
"label.marketsea":`公海池`,
"label_partner_setup_address":`夥伴雲地址`,
"label.industrialandcommercialverification.label.url":`URL`,
"lable.data.exp.newtemp":`資料匯出及範本製作`,
"label.pc.ui.2018":`縱向選單`,
"label.version.free":`免費版`,
"label.dataimport.contact.length":`出現錯誤：聯絡人姓名長度過長。`,
"label.cy.vlidate":`幣種啟用之後將不可逆，您確認啟用幣種管理功能？`,
"label.recycle.all":`全部回收桶`,
"label.message.changeaccount.isnot":`聯絡人已啟用了合作夥伴使用者，無法更改客戶訊息`,
"label.searchlayout.exactsearch":`提示：勾選搜尋欄位後方的覆選框，則該欄位進行精確搜尋`,
"label.file.size.limit":`注意：允許最大文件為10M`,
"label.mobileapp.modelsetting1":`行動端推薦功能模組設定`,
"template.report.overall.sales.opportunities":`整體銷售期（按機會類型）`,
"label.password.update.success":`密碼修改成功！`,
"label.import.page3.gobackhome":`回到主頁`,
"label.phone":`電話`,
"label.detail.vlidaterule":`查看驗證規則`,
"label.weixin.input.usernames":`請輸入用戶名`,
"label.icon.85":`變壓器`,
"vue_label_systemSettings_partner":`夥伴`,
"label.processsetting.new.process":`建立進程`,
"Lead_Scoring_Setting_Rule_Setup_01":`商機評分規則列表`,
"setup.layout.component.area":`區域`,
"label.createnewpwdinformuser":`產生新密碼並立即通知使用者`,
"label.pwinfo":`密碼訊息`,
"label.imgfield.type.url":`引用圖片`,
"label.attendance.sxccheckincy":`市場活動成員簽到`,
"lable.PowerProcess.condition.input":`請選擇條件`,
"label.partnerCloud.partnerAccount.topUpFailure":`儲值失敗`,
"label.document.size.too.long":`文檔大小超過了`,
"label.link":`存取連結`,
"label.partnerproduct.sort.repeat":`產品系列名稱重複`,
"label.data.setok.e_desc2":`匯出數據列表頁面`,
"front-project-module-v1-plase-input-project-name":`請輸入項目名稱`,
"label.export":`匯&nbsp;&nbsp;出`,
"label.icon.45":`鍋爐`,
"label.autoRegister.changepwd.title":`設置您的登入密碼`,
"label_clear_adjust":`清除調整`,
"front-kefu-moudle-return-visit":``,
"label.ems.compose":`寫郵件`,
"Pagelayout_Setup_002":`您已經選擇了3個相關列表，再次選擇的話將影響版面配置`,
"label.service.gantt.skill.screening":`使用技能篩選`,
"label.partnerCloud.basicSetting.enable":`你將關閉夥伴雲啟用狀態，系統將自動禁用貴組織夥伴雲登入與建立修改功能！`,
"label.workbanch.setup.description":`您可以設置以下視圖是否在我的工作臺中顯示。`,
"label.category.1":`全部`,
"label.foldername":`文件夾名稱`,
"label.forecast.settings.shuliang":`預測數量`,
"label.emailmerge.newtemplate.word":`請上傳word文檔!`,
"message.error.type":`type不能為空，需要傳public公共類型或人員private！`,
"label.manualallocation":`手動分配`,
"label.addattachment.step2":`步驟 3.單擊“上傳文件”按鈕，上傳文件`,
"label.company":`公司`,
"label_emailsync_status_export":`匯出為Excel_csv格式文件`,
"label.eventreminder":`事件提醒`,
"label.emailtemplate.lookup":`查看郵件範本`,
"label.customsetting.touse.getCustomSetting":`查詢“階層架構”類型的自訂設置數據,返回對應apiName和權限（id為設定檔id或使用者id）的單條數據 Map map`,
"label.projectManagement.Resourceuse":`資源使用`,
"label.appointment.wizard.subtitle4":``,
"label.donot.close.your.browser":`在此過程中,請不要單擊其他連結或關閉您的Web瀏覽器`,
"label.multilang.customforcast.target":`{0}的目標：`,
"setup_layout_label_newarea":`新建區域`,
"component.timeline.button.more":`更多步驟`,
"label.appointmentdetail.wizard.title3":`持續時間`,
"label.help.new.features.pc":`PC端新功能操作指南`,
"label.mr.record":`記錄`,
"label.trigger.wgd":`未歸檔觸發器`,
"label.icon.72":`工具箱`,
"setup.layout.label.detailpage":`詳細頁面`,
"frame.personinfo.label.usethisimage":`我們會在應用程式周圍使用此縮圖的變形圖。`,
"label.multilingual.confirm.open":`是否確認啟用，啟用後將可以使用多語種。`,
"label.recordcreater":`記錄建立人`,
"label.afterfinish":`完成後，單擊儲存並新建"以建立更多自訂欄位；如果已完成建立操作，單擊"儲存""`,
"label.companyinformation":`公司訊息`,
"step1":`第1步`,
"label.sales.page.dashboard.add":`添加主頁儀表板`,
"label.processsetting.process.enabled.failed":`刪除進程失敗！`,
"label.document.history.date":`日期`,
"label.linkedin.title":`LinkedIn-H5微應用`,
"label.foldervisitlimit1":``,
"april":`四月`,
"label_emailsync_form_disconnect":`取消關聯`,
"label.appointment.wizard.subtitle4-2-6":`2天`,
"vue_label_notice_follow_success":`關注成功`,
"label.startuploadfile.success":`當單擊“開始上傳”按鈕後，如果進度條達到100%，則說明文件上傳成功，並且會在上方區域消失`,
"message.accesstoken.acquisition.failed":`存取令牌獲取失敗！`,
"label.quickbooks.fieldlabel.fistname":`名字`,
"label.appointment.wizard.subtitle1-5":`1小時`,
"2018UI.Homepage.DataNoAccess.Info":`此條記錄您沒有權限存取，點擊返回上一步。`,
"label.batchaddattachments":`批次添加附件`,
"label.ems.next":`下一步`,
"label.quote.zhekou":`折扣`,
"lable.product.notdel":`的刪除,因為它仍與其它價格手冊中的記錄相關聯。關聯記錄如下 。`,
"label.ems.action":`操作`,
"message.error.chart.type":`圖表類型不能為空！`,
"label.conditiontag.lookup.value":`值`,
"label.chatter.allactivity":`所有活動`,
"label.summaryreport":`彙總報表`,
"label.textmessage.vonage.action":`操作`,
"label.ccpeak.must.result":`必須as別名才能從結果中取出`,
"label.data.newtemplate.savetemp.desc":`請認真填寫範本名稱和範本描述，方便您的使用。`,
"label.projectManagement.search.for.users":`搜尋使用者`,
"component.milestones.label.title":`里程碑`,
"vue_label_applauncher_description_accountpool":`使用客戶公海池，便捷管理組織內的客戶跟進狀態，激勵人員完成成交。`,
"label.import.index.startimport":`開始匯入`,
"page.field.masterinput2":`主從錄入`,
"label.mobile.change.owner.permission":`新擁有者必須對此類型記錄有讀取權限`,
"label_partner_common_enable":`啟用夥伴雲`,
"label.log.browser":`瀏覽器`,
"label.app.step4":`步驟 4. 選擇選項卡`,
"lable.quote.syncing.opportunity":`業務機會`,
"label.forecast.customforecast.foredis.jqz":`精確值`,
"label.forecast.forecastroleuserpage.title":`預測經理分配`,
"label.starting.quarter":`起始季度`,
"label-combination-record":`記錄{index}`,
"label.here":`此處`,
"label.weixin.underfind.error":`未知錯誤`,
"label.cloudccclass.list.tip.time":`允許開發人員在Cloudcc.com平臺上開發定時類,這些定時類可以用於定時程式`,
"label.data.setok.t_desc1":`如果需要用此範本匯出數據，請點擊`,
"label.service.gantt.break.rules":`違反規則`,
"label.weixin.no.pending.ywjh.qin":`親，未來30天沒有業務機會數據`,
"label.view.atleastone":`選項列表至少有一個值`,
"label.attendance.sxccheckin":`市場活動現場簽到`,
"label.custom.split":`拆分`,
"front-kefu-moudle-v1-yesorno-delete-templete":`確定要刪除這個範本嗎？`,
"label_chatter_theme":`主題`,
"label.partner.new.step1":`步驟1：選擇您喜歡的範本`,
"vue_label_commonobjects_view_settings":`看板視圖設定`,
"UG_Contract_02":`合約是各方之間的書面協議。許多公司使用合約定義與其他公司從事業務往來的條款。使用 CloudCC 建立您與您的客戶和機會已有的合約，並為其提供文檔。通過批準流程，追蹤合約。使用工作流提醒，以提醒您合約展期。`,
"label.setup.mobilesetup.isenableh5newandedit":`行動端是否啟用H5建立編輯`,
"label.attendance.edit":`修改考勤`,
"label.service.miniProgram.fillImageLink":`請填寫輪播圖連結`,
"label.b.c.without":`B" 記錄可能有或沒有相關 "C" 記錄。"`,
"label.sso.key":`授權碼`,
"label.star_click":`點擊清零`,
"vue_label_SMS_name_or_phone_number_lookup":`記錄名稱搜尋`,
"label.case.copre.text":`您也可以下載專屬於貴公司的網頁入口網頁二維碼，將二維碼放到官網或設備上，客戶可以掃描二維碼使用網頁版客戶入口網頁。`,
"label.salescloud.forbidden.confirm":`是否繼續要禁用小組銷售？`,
"vue_label_chat_conformactivation":`確認開通`,
"label.emailtocloudcc.redmessage9":`資料庫錯誤，請聯繫管理員`,
"label.sahreto":`共享給`,
"label.recordtype.sort":`記錄類型按儲存的順序顯示`,
"label.allreport":`所有報表`,
"front-gantt-module-drag-and-drop-subtask":``,
"label.permission.objlist.nopermission":`無存取權限`,
"label_file_num":`數量`,
"chatter.mostword":`最多可輸入500個文字,請刪減後再發表`,
"label.h5.chatter.comment":`評論正文`,
"vue_label_calendar_notice_havecreated":`您已建立日曆`,
"label.tabpage.loadz":`頁面連線中，請稍後...`,
"chatter.w.p":`工作電話`,
"label.chat.topic.name.desc":`您僅能更改主題名稱的大小寫和間隔`,
"label_partner_template_name":`範本名稱`,
"label.mobile.phone.required.examines.people":`批閱人為必填項`,
"message.error.view.notexists":`視圖不存在</br>視圖可能已經被別人修改,單擊<a href`,
"label.custom_time":`自訂時間`,
"label_partner_workspace_member_all":`全部`,
"lable.custom.year.name":`自訂年度名稱`,
"label.account.previous.M":`上月`,
"vue_label_commonobjects_detail_locking":`鎖定`,
"label.brief.lead":`商機`,
"label.linkedin.setting.appsecret":`秘鑰密碼`,
"label.query.detail.closepartner":`禁用合作夥伴`,
"label.isEnableVisualpage_new.rightlist":`已啟用的自訂頁面`,
"front-epwechat-module-v1-unbound-item3":`#NAME?`,
"label.exchange.sync.setting.info":`在 Microsoft? Exchange 中為使用者設置帶有模擬權限的服務帳戶後，輸入服務帳戶憑據，以允許 CloudCC 與 Exchange 伺服器通訊。如果已儲存服務帳戶憑據但使用者仍無法同步記錄，確保您已正確設置 Exchange Sync。`,
"label.emailobject.groupemail.fail.title":`CloudCC批次發送郵件失敗信箱`,
"label.the.upper.bound.of.each.level.of.edit.discount.must.be.greater.than.the.lower.bound.":`編輯折扣每1層的上界必須大於下界。`,
"label.visualpage.list.vpname":`自訂頁面名稱`,
"label.mask.length.error.message":`加密文本欄位長度不能超過255`,
"label.h5.approval.actorname":`發起人`,
"label.knowledgebase.view.translation":`檢視翻譯`,
"label.ems.edit":`編輯`,
"vue_label_commonobjects_view_reset_width":`重置列寬`,
"label.version.feature.controllist":`功能控制列表`,
"label.setuppagelayout":`版面配置`,
"vue_label_commonobjects_view_new_view":`建立視圖`,
"label_tabpage_queuez":`佇列`,
"label.direct.dashboard.wait.me.approval":`待我審批的項目`,
"message.report.error.noRelatedField":`報表沒有找到關聯欄位，可能已刪除，請聯繫系統管理員。`,
"label.ccchat.person.invite.notme":`您無法發送邀請到您自己的電子郵件地址。`,
"label.weixin.jieduan.finish":`將當前階段標記為已完成`,
"vue_label_commonobjects_detail_?enter_subject":`請輸入主題`,
"label_starting_month":`起始月份`,
"label.address_linetwo":`位址第二行`,
"message.error.select.contiguous.item":`選擇的相關項已經與`,
"vue_label_pricebook_enterbookname":`請輸入價格手冊名稱`,
"label.cycleworkflowoperate":`週期性的工作流程操作`,
"label.ems.withoneday":`當天`,
"component.todaytask.label.notask":`今天沒有到期工作-趁有時間，去喝杯咖啡吧。`,
"label.tianyancha.id":`公司ID`,
"label.user.illegal.login":`非法登錄！`,
"label.withgathercondition":`按匯總條件`,
"label.foldervisitlimit":`存取權限`,
"label.ccchat.search.conversation":`搜尋此會話`,
"lable.annual.project.report":``,
"template.chart.qzkhzhfx":`商機轉化分析`,
"label.my":`我的`,
"label.sendsms.batch.chosetemplate":`批次發送簡訊：範本選擇或編輯簡訊內容`,
"label.callcenter.enterprise.number":``,
"label_last_modified_by_time":`最後修改人&時間`,
"message.fieldtrack.operaterecord":`將 <b>operatefield</b>從<b>operateold</b>更改至<b>operatenew</b>`,
"label.mobile.more.openin":`打開方式`,
"label.multilingual.tip2":`您可以啟用和禁用多語言`,
"label.datamanage.lead.novalue":`注意：本次匯入操作沒有給“商機名稱”欄位賦值，聯絡人記錄將不會被匯入！`,
"label.custom.revoke":`撤銷`,
"label_chatter_leaveword":`留言`,
"vue_label_ccchat_group_deletedgroup":`該小組已被刪除`,
"label.tabpage.operationz":`欄位，操作不能為空`,
"label.user.organization.permit.overdue":`您的組織許可證書已過期，請聯繫管理員！`,
"label.log.datetimeoruser.value":`請輸入查詢時間、用戶名!`,
"lable.product.stsp.noavailable":`沒有可用的標準價格`,
"label.appservice.cannot.delete.app":`無法刪除自訂應用程式。某些設定檔正在使用此自訂應用程式作為預設應用程式。`,
"component.event.label.newevent":`建立事件`,
"label.view.sortview.exportview":`匯出視圖`,
"label.uploadfilemaxsize":`文件上傳允許最大值為`,
"label.event.weekview":`周視圖`,
"label.conversion_rate":`轉換率`,
"label.partnerCloud.partnerAccount.useWechat":`使用微信掃碼支付`,
"UG_Forcast_05":`預測設置：步驟{0}/{1}`,
"label.service.gantt.jobresour":`僅顯示工作資源`,
"vue_label_campaign_fromopprotunities":`來源{dsrjine}個進行的機會`,
"label.app.skyblue":`天空藍`,
"label.chinacloudcc":`中國雲計算`,
"label.connectOtherFinalNumber":`到達物件極限<br />您最多可以將四個物件關聯到自訂報表類型。`,
"label.redistributionrequest":`重新分配批准請求`,
"label.knowledge.category.button.one":`新增子分類`,
"label.campagin.pcandmo":`PC和移動端`,
"label.project.milestone.date":`里程碑日期必須在所屬項目的日期範圍內。`,
"assetbom.transfer.notpermission":`請聯繫管理員，您不具有遷移資產BOM的權限`,
"label.marketing.setting1":`行銷活動營銷渠道`,
"label.select.file":`選擇文件`,
"message.error.object.contactadministrators":``,
"label.custom.quarter.title":`自訂季度`,
"label.knowledge.case.settings":`個案設定`,
"front-service-cloud-transfer-title":``,
"label.group.search.searchthisfeed":`請輸入搜尋內容`,
"label.report.action.addtodashboard5":`添加到新的儀表板`,
"label.mobile.side.tab.remark2":`設置側滑欄時，您可將最常用的項目放在靠前的位置；通話記錄、選單項僅可用於CloudCC行動端Android版本`,
"contain":`包含`,
"label.select.template":`選擇範本`,
"label.addattachment.step3.weixin":`步驟 3.單擊“完成”按鈕，返回上一頁`,
"lable.Order.successfully":`訂單產品轉資產成功`,
"label.user.title":`職務`,
"label.weixin.check.agreement":`請勾選相關協議`,
"label.SMS.pfi":`手機號碼欄位`,
"label.weixin.micro.research":`微調研`,
"label.projectManagement.assigned.work":`指派的工作`,
"label.document.login.error":`登錄失敗，請再次嘗試重新登錄。`,
"label.mobile.phone.examines.people":`批閱人`,
"label.safetyset":`安全性設置`,
"label_function_tip":`中國大陸使用者暫不支援此功能，感謝您的理解！`,
"label.app.sort":`應用程式排序`,
"component.sendmail.label.cc":`副本`,
"label.titlename":`標題`,
"label.event.moveup.3day":`提前 3 天`,
"label.condition":`條件`,
"label.description.message":`備註字數不能超過500`,
"label.ems.detailedsettings":`詳細配置`,
"label.repeat.condition.field.prompt":`請在“按鈕前幾字元”欄位處填寫一個數字！`,
"label.validate.function.funcExplain.OR":`檢查任何參數是否為真，並返回TRUE 或 FALSE。僅當所有參數均為假時才返回 FALSE`,
"label.salecommit.allow.prediction.query":`您沒有在[設置]>[我的個人訊息]>[個人訊息]中勾選允許預測選項，不能查看銷售承諾看板。`,
"front-kefu-moudle-soft-phone":``,
"label.view":`視圖`,
"front-gantt-module-quick-create-task":``,
"label.all_forms":`全部表單`,
"front-lightning-module-v1-dashborad-statistical-dimension":`統計維度`,
"label.forecast.settings.data.chanpin":`產品日期`,
"label.appointment.wizard.subtitle4-2-7":`3天`,
"front-web-module-v1-detail-comment-please":``,
"label_chatter_nextSevenday":`未來7天`,
"homepage.components.desctiption":`此頁面允許您建立或編輯在主頁配置上顯示的組件。`,
"label.customcomponent.page.index.table.namespace":`命名空間首碼`,
"label_emailtocloudcc_exists":`信箱已存在`,
"label_tabpage_save":`儲存`,
"label.mergeRechecking":``,
"vue_label_helpcenter_view2":`在並列視圖下，可以快速切換查看每條數據的詳細訊息。 <br>3、快速分析銷售數據<br>在視圖右上角，可以打開視圖內圖表，對視圖內數據進行簡單可視化分析。同時可以查看視圖數據相關的儀表板與報表列表，進行進一步分析。 <br> 點擊右上角的圖表按鈕，可以查看、建立、編輯利用視圖數據建立的簡易圖表，或是查看當前視圖相關的儀表板。 <br>步驟1：單擊右上角圖表按鈕，展開頁面內圖表，可以根據權限查看並管理現有圖表，並查看視圖數據相關的儀表板列表。 <br>步驟2：點擊設定按鈕，可以根據權限建立、編輯、刪除圖表。可以建立垂直柱狀圖、水平柱狀圖、餅圖與漏斗圖四種樣式的圖表。 <br> 點擊報表按鈕，可以查看當前視圖相關的報表。 <br>4、在視圖中管理數據<br> 在視圖內，根據您的權限，通過視圖右上方的按鈕，或是每條數據旁，可以對數據進行新增、編輯、刪除、更改擁有者等操作。 <br> 利用標籤來協助您的數據管理。通過右側按鈕展開標籤管理列表，可以以標籤為依據對視圖內數據進行篩選。點擊管理標籤後，還可維護管理您的標籤庫。選中數據後使用右上角的添加標籤按鈕，還可批次為數據增加標籤。`,
"label.app.ismobile":`應用到移動端顯示`,
"chatter.group.changeTheGroupPicture":`更改小組頭像`,
"label.mr.descreption.reDataList2":`條記錄中共查詢到滿足條件的重複數據`,
"vue_label_chatter_agree_join":`同意加入`,
"label.planned.nextrun":`下次計劃運行`,
"Homepage.News.003":`暫無客戶數據，無法顯示新聞，您建立客戶之後即可在此顯示客戶新聞`,
"label.summaryreport.selectpictype":`選擇圖表類型和其他圖表選項`,
"label.app":`應用程式`,
"label.trigger.name":`觸發器名稱`,
"vue_label_email_private_template":`私有範本`,
"label.appointmentpage.wizard.subtitle1":`請選擇日期和具體時間 邀請者的時區是{0}`,
"label.partnerCloud.orderingPlatform.payment":`訂單付款`,
"label.stdashbord.xsld.title":`銷售漏斗`,
"vue_label_pool_poolname":`公海池名稱`,
"label.ServiceCloud.fuwuyuyue.distributionMap":`服務預約分佈圖`,
"front-lightning-module-v1-dashborad-target-value":`目標值`,
"label.reportsSubscriptionPage.email.keywords":`輸入關鍵字後搜尋`,
"label.appointmentconfirmail.wizard.subtitle1":`事件名稱`,
"label.limited_scanning":`入場券僅限於需要現場掃描登記的場景`,
"label.weixin.nomore":`沒有更多了`,
"february":`二月`,
"label.view.filterbyowner":`按擁有者過濾`,
"label.contentType":`文檔擴展名`,
"label.customobjdel.master.hsiang":`物件中有主詳關係欄位，不能刪除。`,
"lable.Removal.succeeded":`移除成功`,
"label.weixin.end.incorrect":`結束日期格式不正確`,
"label.email.cc.recipients":`副本收件人`,
"label.taskevent.list":`任務事件列表`,
"label.formula":`公式`,
"label.h5.new.errorheader":`檢查此頁面上的錯誤`,
"label.emailobject.template.private":`私有`,
"label.visualpage.component.n4":`4.變量. 可以直接使用變量， 注意不要有單引號即可`,
"label.newemailnotice.step1":`步驟 1：選擇物件`,
"label.chatter.file":`文件`,
"vue_label_checkduplicate_rules":`設定檢查重複規則`,
"label.appointment.wizard.subtitle1-6":`1.5小時`,
"label.customReportType":`自訂報表類型`,
"vue_label_email_with_accessories":``,
"label_efine_assessment_cycle":`定義考核週期`,
"label_emailtocloudcc_button_sure":`確認`,
"label.forecast.userenablepage.isusing":`已啟用使用者`,
"lable.goal.description":`目標描述`,
"message.error.serviceresource.relatedrecordid":`每個使用者只能被添加為一條{0}類型的服務資源`,
"label.weixin.addbus.information":`添加車輛訊息`,
"label.emailtocloudcc.button.view":`查看`,
"label.detail.workflow":`查看工作流程`,
"label.standardfilter":`標準篩選器`,
"label.mobile.phone.results":`業績`,
"chatter.feed.unavailabled":`未啟用`,
"label.view.sortview":`視圖排序`,
"label.availabilityobject.wizard.title":`空閒時間`,
"Main_Menu_Mobiledownload":`可用於`,
"chatter.sticker":`已追蹤`,
"label.workflow.intruduce":`通過建立工作流程規則配置組織的工作流程。每個工作流程規則包括：`,
"label.customfields.richtext.tip":`允許使用者輸入格式化文本、添加圖片和連結。`,
"label.new.cy.select":`從選項列表中選取新幣種`,
"template.chart.schdzqzkhzhqk":`行銷活動中商機轉化情況`,
"label.forecast.customforecast.cpxl":`產品系列`,
"front-electronic-signature-open-service":``,
"label.datamanage.import.field":`匯入欄位`,
"chatter.email.sendMessageToMe":`發送給我一個消息時`,
"message.cannotusebefore":`記住，您不能使用此審批流程，直到它被啟用為止。`,
"label.textmessage.vonage.api.secret":`API機密`,
"label_chatter_newEvent":`新建事件`,
"label.ji.year":`{a}年`,
"label.sendmail.step2":`步驟 2：選擇電子郵件範本`,
"label.console.step5.record":`開啟紀錄`,
"label.customfields.totalsummary.gettogetherfield.isnull":`請選擇要加總的欄位`,
"vue_label_commonobjects_detail_current_recorder":`新擁有者也將成為與此項目相關記錄的擁有者，而這些記錄由當前記錄人所有`,
"label.SMS":`簡訊通知`,
"label.reconfigure.bundle":`重新配置捆綁包`,
"front-kefu-select-region":``,
"chatter.feed.deletefeeds":`是否確定刪除該帖子及其註釋?`,
"label.customsetting.manage.introduce.h":`如果自訂設置為階層架構，您可以為使用者、設定檔添加數據。例如，您可能希望根據是否是特定使用者、特定設定檔亦或是普通使用者在運行應用程式來顯示不同的值。`,
"label.product.name":`產品名稱`,
"vue_label_commonobjects_view_saveas":`另存為`,
"label.group.my.archived":`我的已歸檔小組`,
"vue_label_pool_coflictmethods":`抵觸當前銷售方式`,
"label.appupload.upload":`上傳`,
"lable.SalesCommitmentKanBan.signedTaskRate":`簽約任務率`,
"label.dashboardStandard":`標準儀表板`,
"label.niboer.time":`尼泊爾時間`,
"label.emailtocloudcc.filed.email":`信箱`,
"market.name.social.post":`社交帖子`,
"evaluation.detail.notfound":`評價詳情未找到`,
"label.layoutoftestobj":`測試物件 配置`,
"label.example":`示例`,
"label.campaign.channel.step6.remark6":`請存取這裡`,
"chatter.emailLike":`喜歡`,
"label.knowledge.category.button.two":`編輯分類`,
"label.alluser":`全部使用者`,
"addadvancedconditions":`添加進階選項`,
"message.selectgsummarycondition":`請選擇彙總條件`,
"message.duplication.label.sectionremar2":`注意：所有相關記錄包括的任何備註、附件和活動都將與新的合併後記錄相關聯。`,
"vue_label_helpcenter_product&pricebook":`產品是您銷售所有項目和服務及其標準價格的基礎目錄。價格手冊可讓您為特定使用者建立產品及關聯列表價格的自訂集合。`,
"message.duplication.label.isprofile":`是否通過權限`,
"component_setup_label_milestonesfield":`里程碑欄位`,
"setup_layout_label_required":`必填`,
"component_chatter_label_title":`最新微貼`,
"label.assignment.setup.detail.order":`順序號`,
"vue_label_pool_unassigned":`未指派`,
"UG_Lead_007":`Google同步`,
"label.knowledge.record":`不存在相關數據`,
"label_tabpage_filetypez":`文件類型`,
"label.ccpeak.if.error.message":`如果返回錯誤消息：使用`,
"label.intialsubmitter":`初始提交人`,
"label.wei.icon":`圖標`,
"label.mask.show.last.4":`遮罩顯示最後4位`,
"lable.PowerProcess.time.trigger":`時間觸發器(分鐘)`,
"july":`七月`,
"label.usestandardwizard":`使用標準設置嚮導`,
"label.two.quarter":`第二季度`,
"label.size":`大小`,
"label.integrations.mailchimp.massage4":`未配置Mailchimp。請前往集成設置授權Mailchimp。`,
"label_emailtocloudcc_step2total3":`第2步，共3步`,
"vue_label_chat_customer_group_strategy":`客戶群策`,
"label.searchvalue":`查找值`,
"label.sendemail.birthday.title":`生日提醒`,
"label.projectManagement.planned.days":`計劃天數(天)`,
"label.service.gantt.workhours":`基於工時`,
"label.notification.approval5":`代理審批：【提交人】正在請求批准【物件】`,
"label.service.miniProgram.bindAddressDesc":`CloudCC標準客戶服務入口網站小程式地址：`,
"chatter.error.wt":`錯誤: 不正確的文件類型!`,
"vue_label_calendar_my_calendar":`我的日曆`,
"label.customername":`客戶名稱`,
"label.salescloud.salesdashboard.huikuan.rankings":`整體-銷售收款業績排行榜`,
"message.query.opportunity.contactrole.error":`查詢機會聯絡人預設角色失敗,請聯繫管理員`,
"noequal":`不等於`,
"label.document.searchcustominfo":`輸入關鍵字查找匹配的文檔`,
"label.account.PreviousFQ":`上一個會計季度`,
"label.file.f":`文件`,
"label.dashboard":`儀表板`,
"label.report.folder":`報表文件夾`,
"batch.edit.permission.list":`無編輯權限數據列表`,
"label.file.orderbyowner":`按擁有者排序`,
"label.exchange.sync.account.password":`服務帳戶密碼：`,
"pagecreator.button.publish":`發佈`,
"label.modify":`編輯`,
"label.exchange.sync4":`狀態`,
"label.remark.information":`備註訊息`,
"label.service.without.major.event":`沒有要顯示的重大事件`,
"label.knowledgebase.release.status":`發布狀態`,
"label.tabpage.ok":`確定`,
"label_screening_assessment_content":`篩選考核內容`,
"label_partner":`夥伴雲`,
"label.user.detail":`查看使用者`,
"front-kefu-moudle-or-this":``,
"label.unselect.object":`可選物件`,
"label.quote.contactfax":`傳真`,
"label.weixin.appmanage.alert":`按下{0}可從我的應用移除, 按下{1}可添加到我的應用`,
"vue_label_dashboard_thisfolder":`添加公用儀表板至此文件夾`,
"label.delete":`刪除`,
"label.appexchange.installedpage.message1":`在 CloudCC.com AppExchange上，您可以瀏覽、下載應用程式直接安裝到您的 cloudcc.com環境中。`,
"label.mobile.phone.required.summary":`總結為必填項`,
"label.batchadd.newbatchpage.addtr":`最多只能添加30條記錄`,
"label.partnerCloud.partnerAccount.lockLine":`鎖定額度`,
"label.emailsync.status.connectstatus":`關聯狀態`,
"label.campaignmember.main.importmember.lead":`匯入成員-現有商機`,
"message.username.isnull":`用戶名不能為空！`,
"label.forecast.tree.enableuser":`啟用使用者`,
"label.multilang.view.viewmessage":`此視圖已應用到行動裝置,最多選擇10個欄位,現已有{0}個：`,
"friday":`星期五`,
"label.sendemail.activity.neweventtitle":`新事件通知`,
"label.page.addtabto.user":`將選項卡附加到使用者的現有個人自訂設置`,
"front-kefu-moudle-v1-connect-phone":``,
"label.wei.pollis":`投票為`,
"lable.opppdt.editPdt.title":`編輯業務機會產品`,
"label.permission.objectpermission.recordfenpei":`記錄類型分配`,
"pagecreator.layout.message.delete.success":`配置刪除成功`,
"label.dataimport.isdupecatcher":`執行查重過濾器`,
"label.deletelayout.tip":`要刪除頁面配置，您必須選擇另一個頁面配置來取代它。`,
"label.projectManagement.No.matching.data":`暫無相符數據`,
"pagecreator_page_message_delete_success":`頁面刪除成功`,
"label_tabpage_equalz":`等於`,
"label.ems.emailsetup":`信件設置`,
"label.decimaldigits":`小數位數`,
"component.chatter.button.delete":`刪除`,
"label.isallowreport":`是否允許報表`,
"label.view.appliedMobile.message":`勾選此項，步驟3.選擇要顯示的欄位最多選6個`,
"label.must.positive.integer":`必須是正整數`,
"label.preview.print.template":`預覽列印範本`,
"label.schedulejob.setup.schedule.start":`開始`,
"UG.Case.04":`個案指派`,
"vue_label_pool_move1":`{1}{2}`,
"label.list.userinterface.enableHoverDetails":`啟用懸停詳細訊息`,
"vue_label_email_alltemplates":`全部範本`,
"label_report_chose_obj":`選擇物件關係與報表數據來源`,
"label.partnerCloud.productSet.del":`刪除選項`,
"label.quote.shrdz":`收貨人地址`,
"page.approval.history":`審批歷史`,
"lable.outlook.detail.prefc":`首選CloudCC.com`,
"label.translation.unable.display.view":`無法顯示視圖`,
"label.encrypt.change":`加密欄位轉換`,
"button.partner.workspace.login.logo.upload":`上傳圖片`,
"label.batchadd.mustinput2":`的為必填項，如果必填項不填寫則該記錄不被儲存`,
"label.dataimport.update.error.check":`更新數據發生錯誤，請仔細檢查本條數據`,
"label.staticresource.name.already.exists":`靜態資源唯一名稱已經存在！`,
"label.appupload.upload.install.success":`安裝成功`,
"label.conditiontag.lookup.true":`真`,
"label.quickbooks.viewlist.customer":`客戶`,
"label.field.edit.change2":`最大評分至少為1`,
"label.fianalrejectoperate":`最終拒絕操作`,
"label.ccpeak.wgd":`未歸檔的類`,
"label.reportsSubscriptionPage.condition.emailreport":`總結 報表`,
"label.detailinf":`詳情`,
"label.eastem.standard.time":`東部標準時間`,
"chatter.group.manager":`管理員`,
"label.manage_columns":`管理表頭`,
"label.daylight.time":`夏令時`,
"label.weixin.mycar.information":`我的車輛訊息`,
"label.ccpeak.help":`類 幫助`,
"lable.outlook.detail.match":`匹配條件`,
"label.version.nonsupport.approval":`暫不支援審批流程！`,
"label.custom-tailor":`客戶定製`,
"label.showoperate":`顯示操作`,
"label.view_edit":`檢視並編輯`,
"label.lead.score.prompt2":`請選擇需要給商機評分的範圍，點擊【商機評分】 按鈕，系統將會按照當前啟動的評分規則給所選擇的商機評分。`,
"label.datamanage.savetemplate.error":`儲存範本失敗！`,
"label.source":`來源`,
"label.multilang.customfieldsetup.reference":`此欄位被{0}處引用：`,
"chatter.poll.option7":`選項7`,
"label.login.access.day":`天`,
"label.icon.66":`器材`,
"label.tabpage.kanbansetup":`看板設定`,
"label_emailtocloudcc_step1_lead2":`配置後，該信箱收到的郵件均可自動產生商機記錄，確保不遺漏任何商機。`,
"label.partnerCloud.partnerAccount.numericValue":`儲值金額必須為數字值`,
"label.permission.detail.app.object.tip":`存取物件和欄位的權限以及選項卡可用性的設置`,
"label.emailobject.template.subject":`主題：`,
"template.report.month.customer":`本月的客戶`,
"label.weixin.formerly":`過去`,
"label.contract":`合約`,
"label.help":`幫助`,
"vue_label_homepage_setdefault":`設為預設主頁`,
"label.icon.52":`發電`,
"label.customfields.file.count":`文件個數`,
"UG_Account_07":`匯入客戶`,
"label.addattachment.ntko":`在線編輯`,
"label.service.ganttBaiduMap.assign.service":`指派服務預約給他`,
"vue_label_file_my_file":`我的文件`,
"label.custom.page.hide":`隱藏`,
"label.addexistoperate":`添加已有的操作`,
"label.already.startdate":`已開始時間`,
"label.partnerCloud.financeSetting.alipay":`需開通企業支付寶帳號，僅支援以企業對公帳戶作為收款帳戶。交易手續約由支付寶公司向收款方收取。`,
"label.dashboard.summary.editPageFooter":`編輯頁腳`,
"label.category.8":`消費品`,
"label.forecast.customforecast.foretype.best":`超常發揮`,
"message.validation.isnull":`輸入一個值`,
"label.savewxpay.failure":`儲存微信支付商戶訊息失敗`,
"label.file.stop.sharing.desc1":`停止於`,
"label.opportunity.setting.showstage。read.info":`勾選後機會階段將不可手動編輯`,
"UG_Campaign_003":`建立行銷活動`,
"label.edit.field.select.showoptions":`顯示所有選項`,
"message.inputplatformpwd":`輸入平台管理員密碼`,
"vue_label_systemSettings_mobel_set":``,
"label.projectManagement.thefirstone":`已經是第一條了`,
"label.data.newtemplate":`製作資料匯出範本`,
"label.monitorsys.delete.log":`系統重點操作審計日誌`,
"label.template":`範本`,
"Lead.Auto.Scoring.Setting.001":`商機在儲存或者編輯時自動評分。 （不包括批次匯入與介面建立）`,
"label.operatesuccess":`操作成功`,
"label.send":`發送`,
"chatter.yp":`隱藏微貼`,
"label.overall_responses":`整體回應情況`,
"vue_label_systemSettings_server_report":`服務報告`,
"label.icon.113":`房子`,
"label.partnerCloud.basicSetting.domainSet":`設定網域名`,
"label.login.access.text":`要幫助解決支援的問題，您可以授予您的管理員作為您登入和存取您的資料權限。`,
"vue_label_report_addrowlevelformula":`添加行級公式`,
"message.duplication.label.mergeTitle":`合併我的`,
"label.event.add":`添加事件`,
"vue_label_homepage_bigscreen_light":`淺色`,
"setup.chatter.enabled":`未啟用， 請聯繫管理員啟用微貼。`,
"label.inputreceiver":`您最多可輸入5個要發送通知的電子郵件地址，每個電子郵件地址之間用;"相隔。"`,
"label.custom.page.custom.page":`自訂頁面`,
"label.data.exp.csv":`CSV格式`,
"label.searchlayout.view.example":`查看示例`,
"label_tabpage_fullscreenz":`全螢幕`,
"label.tabpage.last":`上一步`,
"lable.outlook.mcto.accepemail":`我的可接受電子郵件地址`,
"front-electronic-signature-isopen":``,
"vue_label_commonobjects_detail_earlier":`查看更早以前`,
"label.name.cannot.greater.str":`名稱不能超過255個字元`,
"label.weixin.activity.email":`活動: 電子郵件`,
"label.tabpage.unequalz":`不等於`,
"label_calendar_year":`日曆年度`,
"label.appupload.upload.installor":`安裝者`,
"label.jixiaoswitchon":`展開績效`,
"label.user.congratulations.send.finish":`祝賀您，已完成批次發送電子郵件申請操作。`,
"label.customsetting.touse.getListCustomSetting2":`查詢“列表”類型的自訂設置數據,返回對應apiName和Name的單條數據 Map map`,
"label.recordtype.masterrecordtype.selectedTip":`不能將主記錄類型分配給已為其分配了其它記錄類型的設定檔.`,
"label.tippage.li3":`使基於已刪除報表的任何儀表板組件失效`,
"label.weixin.no.name":`無主題`,
"label.tabpage.viewz":`列印當前視圖`,
"label.create_contacts":`建立聯絡人清單`,
"vue_label_homepage_operationitem":`請選擇按鈕操作項`,
"label.pc.ui.2018.switch.version":`版本切換`,
"label.salescloud.teamrole.main":`是否主要聯絡人`,
"label.reportsSubscription.format.report":`格式化報表 (Excel 格式 .xlsx)`,
"label.forecast.customforecast.total":`總額`,
"label.quickbooks.fieldlabel.lastname":`姓氏`,
"label.appointment.wizard.title2":`會議詳情`,
"label.project.template.one":`從項目範本建立項目可能需要2到3分鐘，請您耐心等待`,
"label.timetrigger.workflow":`該工作流已啟用時`,
"label.projectManagement.creator":`建立者`,
"label.customfields.formula.selectreturnfieldtype":`請選擇公式的返回欄位`,
"label.list.userinterface.dashboard.enable":`啟用新的儀表板組件`,
"label.email.delete.html.format":`這將刪除所有HTML格式，是否確認？`,
"label.appupload.install.modifyapi":`修改衝突api名稱：`,
"label.chat.add.topics":`添加主題`,
"label.savepartner.fail":`儲存夥伴雲設定失敗`,
"label.pc.query.new":`查看您最新的`,
"message.duplication.label.editfiltertitle":`編輯查重過濾`,
"label.task":`任務`,
"label.emailobject.emaildetail.title.toaddress":`發送給：`,
"label.setup.mobile.bottombutton.select":`選擇需要顯示在行動端的4個一級頁面`,
"label.loginip.pagecue.invalido":`無效的Internet地址`,
"label_tabpage_listshow":`列表顯示`,
"component.newrecords.label.10records":`10條記錄`,
"label_chatter_file":`文件`,
"pagecreator.systemstyle.label.detailcolor":`明細文字顏色`,
"label.forecast.userenablepage.title":`預測使用者`,
"front-project-module-v1-actual_working_hours":`報工工時`,
"vue_label_systemSettings_Security":`安全性控制`,
"label.processsetting.two.select.key.fields":`第二步：為進程中的每個步驟選擇關鍵欄位，並提供指導`,
"label.page.display1":`記錄`,
"label.appointmentpage.wizard.subtitle1.2":`邀請者的時區是{0}`,
"label.ggReleaseRange.searchTeam":`搜尋公用小組`,
"chatter.group.searchGroup":`搜尋小組`,
"label_card_type":`卡片式`,
"label.appupload.managed.tip":`被受管，意味著您只能編輯某些屬性。`,
"label.changemyshow":`更改我的顯示`,
"label.custom.CustomQuarter":`自訂季度`,
"label.tobedelete":`將刪除的`,
"label.newPage.unuse":`您的頁面遺失了。`,
"label.product.pricebooks":`價格手冊`,
"label.mobile.layout":`行動版面配置`,
"label.multilang.file.items":`{0}個項目：`,
"label.app.step4.tabused":`選定的選項卡`,
"label_ccchat_create_account":`開通帳號`,
"message.startusingprocess":`在啟用此審批流程後，您就無法添加或刪除批准步驟。某些批准步驟屬性也將無法編輯。是否繼續？`,
"vue_label_email_please_add_a_theme":`請先添加主題後再另存為範本`,
"label.please.create.a.target.record.first.":`請先建立一項目標記錄。`,
"label.processsetting.set.objandfile":`第一步：選擇您要設定進程的物件與欄位`,
"label.newreport.group.data":`個分組`,
"label.notcreatenew":`請勿在轉換時建立新業務機會.`,
"lable.custom.CurrentandPreviousCY":`當前和上一個自訂年度`,
"front-epwechat-module-v1-input-androidschema":`請輸入Android schema`,
"label.projectManagement.unfinished.quantity":`未完成數量`,
"label.visualpage.idandname":`頁面id和name命名為：`,
"label.approvingprojects":`待審批的項目`,
"label.partnerCloud.financeSetting.weChat":`需開通微信服務號，並與騰訊公司簽約收款服務；交易手續約由騰訊公司向收款方收取。`,
"label.quickbooks.viewlist.view":`查看`,
"label.knowledge.category.hint.ten":`未啟用分類組`,
"report_type_label_productPricebooks":`產品和價格手冊`,
"label.fenbeitong.description":`勾選啟用分貝通出差申請單，可協助員工進行出差申請及出差費用的報銷`,
"label.ccchat.upload.change":`發生什麼更改？（可選）`,
"label.emailsync.status.log":`關聯記錄`,
"label.addnew":`添加新的`,
"UG_contact_05":`建立一個聯絡人`,
"label.appupload.componet.queryerror":`查詢組件的過程中出錯，請聯繫管理員。`,
"label.salescloud.setting":`小組銷售設置`,
"label.recurrencetimetriggeroperate":`週期性時間觸發器操作`,
"label.event.moveup.4day":`提前 4 天`,
"No.Hisitory.Activity":`暫無歷史活動`,
"label.validate.function.funcFormat.MINUTE":`MINUTE(date)`,
"label.recentview.seloption3":`我最近修改的`,
"label.login.access.nopermission":`--無存取權限--`,
"label.taskmenuandlink":`任務按鈕和連結`,
"label.forecast.customforecast.foredis.sbw":`數百萬`,
"lable.PowerProcess.created.event":`建立重大事件`,
"label.stdashbord.xsld.funnelchat":`銷售漏斗圖`,
"label.step1.total7":`第1步，共7步`,
"label.sendsms.batch.chosepersion":`批次發送簡訊：選擇簡訊接收者`,
"Lead.Scoring.Setting.Rule.Setup.Value":`分值`,
"label.ccdocument.isdel.folder":`是否要刪除該文件夾？`,
"label.discard_change":``,
"label.knowledgebase.assign":`指派`,
"PersonalInfo_LoginHistory_001":`瀏覽器驗證信箱註冊連結`,
"label.globalselect.deletedvlaue":`已刪除全局值集`,
"label.ems.lookup2":`查找`,
"label.dataimport.system.unable.determine":`，系統無法確定遺失了哪`,
"label.weixin.invitation.consultant":`邀約顧問`,
"label.salescloud.salesdashboard.phone.rankings":`電話排行榜`,
"label.knowledgebase.plan.release":`計劃發布`,
"label.integrations.first.half":``,
"label.icon.123":`急救箱`,
"label.leadscore.isactivity":`是否啟動`,
"front-epwechat-module-v1-corpid":`企業微信ID（Corpld）`,
"label.createnewcustomer":`建立新客戶`,
"front-lightning-module-v1-details-page-chart-tittle":`可以在記錄詳情頁中增加圖表模組，插入最多10個報表圖表。例如，您可以為客戶物件中，記錄類型為代理商的記錄新增報表圖表模組，將代理商訂單產品銷售金額統計、代理商季度銷售額報表的圖表新增至模組內，並使用客戶名稱進行篩選，在代理商客戶的詳情頁直接檢視相關資料。`,
"label.customobjects.fieldsrelation":`自訂欄位和對應關係`,
"label.dashboardSetup.left":`左`,
"label.mobile.app.sectionpart":`行動端部分`,
"setup.mainpage.label.welcome25":`操作指導： 點擊本頁左側選單 → 管理設定 → 安全性控制 → 共用設定。`,
"label.custombutton.edit.error":`錯誤：該名稱已使用或先前使用過，請選擇其它名稱。`,
"label.icon.48":`排風扇`,
"label.tabularreport.step2":`步驟 2：選擇報表列`,
"label.reportsSubscriptionPage.schedulereport.monthly.week.two":`第二個星期`,
"UG_quota_01":`管理客戶報價`,
"label.customcomponent.btn.usewhere":`用於何處?`,
"label.quickbooks.searchresault.email":`信箱`,
"label.emailobject.appointment.urltext2":`選擇一個合適的時間`,
"label.tianyancha.field.relation.error":`請先設置天眼查欄位與客戶欄位的映射關係`,
"APPIntegration_Social_facebookerror":`必須是一個合法的facebook.com的URL`,
"label.notification.arketsea.transfer":`{5}將{0}：{1}由{2}轉移{3}`,
"lable.SalesCommitmentKanBan.allreceivingTaskRate":`總收款任務率`,
"UG.Account.04":`被動查詢客戶過濾`,
"this.week":`本週`,
"label.email.track.attachment.num.control1":`當前上傳的文件個數超過10個，無法上傳。`,
"label.exchange.sync.state.event":`事件`,
"vue_label_systemSettings_websitesetting":`網站設定`,
"vue_label_file_replace_reason":`取代原因`,
"label.version.feature":`功能`,
"E":`電子郵件`,
"label.escalation.setup.entrydetail.escalation.notifyTemplate":`通知範本`,
"label.chosesubject.meet":`會議`,
"UG.ST.003":`您沒有建立{0}的權限，請聯繫管理員，點擊確定則直接進入{0}介面。`,
"label.authorization.failure":`授權失敗，請重新授權`,
"label.newprocessstep3":`步驟 3: 指定審批者欄位和記錄可編輯性屬性`,
"lable.outlook.mcto.mostrecord":`帶有最多活動的記錄`,
"vue_label_normal_select":`選中`,
"label.partner.workspace.login.buttontext":`按鈕文本`,
"template.chart.ydschdtj":`月度行銷活動統計`,
"label.ServiceCloud.zichanmingcheng":`資產名稱`,
"label.productsales.oppor.nooverdue":`非常棒，暫時沒有逾期的機會`,
"label.appointment.wizard.subtitle3-5":`週五`,
"label.payment.the.current.version":`當前版本`,
"label.reportlist.top":`固定到頂部`,
"label.emailobject.emaildetail.prompt":`提示`,
"label.weixin.endst":`結束時間須晚於開始時間`,
"report_label_knowcreatehighlevelreport":`了解高級報表製作`,
"label.quickbooks.view.openestimates":`進行中的估算`,
"label.url.cannot.empty":`URL不能為空！`,
"label.emailnoticetemplate":`電子郵件通知範本`,
"calendar.tips.task":``,
"label_partner_all_operate":`操作`,
"message.duplication.label.cancelbutton":`取消`,
"vue_label_SMS_addcontact":`添加聯絡人`,
"label.martrixreport.setsumfield2":`選擇將在您的矩陣報表中用作彙總列的欄位`,
"approval_request_email_body":`您好，請求您批准以下項目：\n 單擊以下連結：\n`,
"label.emailobject.emaildetail.field.record":`記錄`,
"label.tab.page":`頁面`,
"label_tabpage_prepagez":`每頁顯示`,
"label.iran.daylight.time":`伊朗標準時間`,
"label.event.nextweek":`下周`,
"fliter.lastmonth":`上個月`,
"label.group.no.recent.search":`沒有匹配的最近查看小組。`,
"label.h5.act.confirm":`確定`,
"label_tabpage_mypotentialcustomers":`我的商機`,
"label.tabpage.queuez":`佇列`,
"label.batch.edit.description":`選擇要編輯的欄位,至少選擇一個欄位,至多選擇五個欄位。`,
"label.batchadd.newbatchpage.deltr":`至少保留一行`,
"label.industrialandcommercialverification.instructions2":`您當前使用的免費版，介面單日查詢上限1萬次。如果您需要擴充查詢次數，建議購買服務。購買服務後，向廠商獲取token在本頁面進行配置，廠商為您提供對應的付費服務。`,
"label.rejectrequestbehaviour":`執行此步驟的所有拒絕操作<strong>和</strong>所有最終拒絕操作。（最終拒絕）`,
"label.batchCopy":`批次複製`,
"label.service.two":`有些篩選條件進行了定義，但未在\"進階篩選條件\"中被引用.`,
"label.data.import.setup.detail.remark":`如果勾選下列選項後，則在資料匯入時執行`,
"vue_label_file_delete_lib":`刪除文件庫`,
"label.integerdigit":`小數點左邊的數字的位數`,
"label.profile.standardobjcontrol":`標準物件權限`,
"label.reportrecords":`條記錄`,
"label.noplan":`您未來七天沒有日程安排`,
"label.visualpage.ytype":`儀表板`,
"label.branch":`；`,
"label.knowledgebase.new.article":`建立文章`,
"label.Addressbook":`通訊錄`,
"label.delete.reward.groups":`刪除報價行組`,
"label.appexchange.uninstallpage.message1":`永久刪除此軟體包中的所有組件（列示如下）`,
"chatter.group.everyone":`全部使用者`,
"label.cooperation":`協作`,
"label.uploadfail":`上傳失敗`,
"to":`到`,
"button_partner_delete":`刪除`,
"attachment_select_warning_001":`勾選了歸檔的附件，歸檔按鈕不可用， 請重新選擇附件。`,
"label.step4.total4":`第4步，共4步`,
"label.login.access.avalid":`今天失效`,
"label.defaultview2":`預設視圖`,
"vue_label_commonobjects_detail_style":`購買風格`,
"label.selectfield":`選擇欄位`,
"label.report.select.column.collect":`選擇要彙總的列`,
"lable.currencyAdv.newdaterate.existeddate":`該時間已存在`,
"pagecreator_systemstyle_button_new":`新建樣式`,
"label.ccchat.person.invite":`同事邀請`,
"label.sendemail.recycle.clear":`清空回收桶操作`,
"label.usermanage.view.notexist":`視圖不存在`,
"setup_chatter_enabled":`未啟用， 請聯繫管理員啟用微貼。`,
"UG.Contract.01":`管理合約`,
"label.martrixreport.2018.step4":`步驟4：選擇報表標準`,
"message.errorinscript":`執行腳本出現問題！`,
"label.knowledgebase.modification.date":`修改日期`,
"label.projectManagement.the.maximum.number.of.fees.is.10":`費用最多輸入10位`,
"label.list.isActiveNewApproval":`是否啟用新首頁批准頁面`,
"label.mobile.main.page.icon.setup":`行動端桌面圖標設置`,
"label.select.customer":`選擇客戶`,
"label.sharerule":`共享設定`,
"label.fiscal.FY":`會計年度`,
"label.appupload.component.type.customfield":`自訂欄位`,
"label.emailobject.emailsend.sendindividually":`分別發送`,
"label.new_formname":`建立表單名稱`,
"label.appointment.wizard.notif1":`結束時間不應早於開始時間`,
"front-console-conversation-evaluate-desc":``,
"homepage.components.lasttime":`最後修改時間`,
"vue_label_commonobjects_view_chart_deletechart":`刪除圖表`,
"label.multilang.document.upload.fail":`成功上傳了{0}個文件,失敗了{1}個文件`,
"UG_contact_03":`在一個地方追蹤聯絡人 銷售訊號`,
"label.marketsea.istoseafromother":`允許其他公海池轉入`,
"label.datamanage":`數據管理`,
"label.globaloperation.operationtype.create.data":`建立記錄`,
"label.customer.tab.step2.see":`選項卡可視性`,
"label.wtd.changefields.desc":`使用者提交表單後，將看到網站中指定的返回URL，如“十分感謝”頁面。`,
"label.ems.eamilinfo":`信箱訊息`,
"label.recordtypeselect.new":`新記錄類型`,
"vue_label_report_output":`公式輸出類型`,
"label.emailnotice":`電子郵件通知`,
"label.icon.196":`衛生紙`,
"label.emailsync.status.disabel":`禁用`,
"label.tabpage.isdeleterecord":`是否刪除已選中記錄`,
"message.selectoneoftypes":`請選擇以下類型之一`,
"label.import.index.createid":`建立ID`,
"vue_label_systemSettings_social2":`社交媒體帳號設定`,
"label.ccpeak.sel.time":`此文件夾中的定時類別`,
"label.data.downpage.i_list.desc1":`在匯入的過程中，因為資料格式不正確，或者因為觸發器或驗證規則校驗失敗，而未成功匯入的資料，都會產生csv文件顯示在當前頁面。而成功匯入的資料，則不會在當前頁面顯示。`,
"label_adjust_forecast":`調整預測`,
"vue_label_normal_lead_sf":`商機`,
"vue_label_report_notice1":`報表中包含未儲存的更改，如果關閉報表，將遺失這些更改，點擊下方"儲存並關閉"按鈕，即可儲存更改。`,
"label.notfiledpublicreport":`未歸檔公用報表`,
"one":`一`,
"UG.Lead.008":`名片掃碼`,
"label.archived":`已歸檔`,
"label.standardabstractfield":`標準摘要欄位`,
"vue_label_notice_add_fail":`添加失敗`,
"label.sendemail.registIMUser.addresserror":`信件收件人地址錯誤`,
"label.ccdocument.toolbar.switch":`工具欄切換`,
"first":`第一個`,
"label.icon.147":`鼠標`,
"vue_label_jihui_er":`機會2`,
"label.ccchat.micropost.isedit":`帖子和留言修改`,
"label.department.next":`下一頁`,
"front-kefu-moudle-confirm-disable-phone-user":``,
"label.reportsSubscription.time.meets.subscription.frequency":`開始結束日期不滿足訂閱頻率！`,
"lable.account.NextpDays":`未來120天`,
"UG_opportunity_007":`聯絡人角色`,
"label.encrypt":`加密`,
"label.knowledge.category.hint.three":`刪除或替代現有的類別組即刪除了所有與文章相關聯的類別。`,
"label.customcomponent.usewhere.info":`以下是所有對此組件的引用。單擊引用標籤查看定義。`,
"vue_label_import_addandupdate":`添加並更新`,
"label.email.all.members":`通過電子郵件發送所有小組成員`,
"component_task_button_save":`儲存`,
"label.file.deleted.unavailable.desc":`此文件已被刪除，不存在或無法被預覽`,
"label.emailsync.status.viewlog":`查看記錄`,
"label.marketsea.othersetup":`其他設定`,
"label.data.exp.newtemppage":`範本製作頁面`,
"vue_label_lead_score_successsful":`評分成功`,
"label.sendemail.activity.newtask":`尊敬的#belongtoidccname您好：\r\n 您的同事#createbyidccname於#createdate給您指派了一個新的工作，內容如下：\r\n 主題：#subject\r\n 到期日期：#expireDate\ r\n 相關項：#relatedstr\r\n 內容：#remark\r\n 具體詳情，請存取此連結：\r\n #path\r\n #orgNameCRM系統`,
"component.event.label.soon":`立即`,
"label.forecast.shrepage.getlist":`返回預測階層架構`,
"UG.solution.02":`解決方案是解決客戶遇到的相關問題的機構內部解決方案。`,
"label.weixin.data.approval":`記錄正在審批中`,
"label.build.pagelist":`頁面構建器頁面列表`,
"label.customsetting.type.hiberarchy":`階層架構`,
"label.forecast.ccfh":``,
"label.Current.Window":`現有視窗`,
"label.appointmentdetail.wizard.title20":`週日時間規劃`,
"label.emailaddress":`郵件地址`,
"label.qetting_notifications":`沒有收到我們的郵件? 請確保您已經將CloudCC電子郵件位址新增到您的白名單中，並允許匯出通知。`,
"Homepage.News.001":`新聞`,
"label.runreport":`運行報表`,
"label.customer.tab.step3":`步驟3： 添加到自訂應用程式`,
"label.dashboard.snapshot.refresh":`重新整理`,
"label.approvepagelayout3":`配置佈局`,
"vue_label_SMS_send_messages":`發送簡訊`,
"label.executestate.old":`已執行`,
"label.approvalstep3":`步驟 3: 選擇分配的審批者`,
"label.step3.total6":`第3步，共6步`,
"front-kefu-moudle-v1-delete-templete":`刪除範本`,
"label.data.downpage.e.title.num3":`3、使用者可以根據自己的需求製作匯出範本，在匯出數據時選擇  按範本匯出  ，可便捷匯出操作。`,
"label.attendance.outer":`外勤`,
"setup_layout_button_selectall":`全選`,
"chatter.photo.img":`最大文件大小為2M。`,
"front-dynamiclayout-module-v1-required":`{required}欄位已被設定為必填欄位`,
"label.mytask":`我的任務`,
"label.edit.customerinfo":`更新公司設定檔`,
"label.processsetting.process.explain":`通過設定與使用進程，使使用者專注於最重要的事項，在恰當的時間顯示關鍵字與小提示，幫助使用者完成流程。`,
"label.emailobject.subject":`主 題`,
"label.mobileapp.scansetting.message":`根據實際使用場景選擇是否將掃描的名片以圖片格式儲存到記錄的相關列表“備註與附件”中。<br>啟用：勾選後，儲存記錄的同時，名片自動儲存到記錄的附件裡。<br>禁用：勾選後，只儲存記錄。`,
"front-epwechat-module-v1-android-autograph":`Android應用簽名：`,
"label_component_helper_potentialcustom":`今天為你指派的商機`,
"label.projectManagement.nodata.week.work":`快來添加工作以便更好地完成本週的工作吧`,
"label_tabpage_rolez":`角色`,
"label.importsourcestep4":`步驟三：匯入您的文件`,
"label.icon.50":`指南針`,
"lable.service.prompt":`無法建立欄位，欄位個數已超出限制`,
"label.campaign.channel.input.page":`指定網頁，一般可設置活動主頁為感謝頁面`,
"UG.homepage.001":`用更少的時間贏得更多的交易`,
"label.step4.total6":`第4步，共6步`,
"label.partner.required":`錯誤：域名不能為空`,
"label.tag.manage.title":`管理標籤-{0}`,
"label.data.downpage.i_title.num1":`1、系統只支援通用的CSV格式。`,
"label.custom.quarter.end":`自訂季度結束日期`,
"label.layout.distribute":`版面配置分配`,
"label.version.allsms":`群發簡訊`,
"label.tolead":`匯入`,
"label.texttemplate.usemergefields":`簡訊範本中使用合併欄位`,
"label.emailobject.sure":`確定`,
"lable_setup_mobilesetup_isenbaleh5newandedit":`行動端是否啟用H5新建編輯`,
"label.tabpage.messagez":`請輸入留言`,
"label.mobile.phone.write.day.report":`寫日報`,
"label.data.setok.e.desc2":`匯出數據列表頁面`,
"label.emailsync.message":`提示`,
"label.sales.page.mubiao":`目標達成`,
"label.ccdocument.list":`查看您最新的文檔`,
"label.tabpage.userGuidez":`使用者指南`,
"label.report.fields":`報表可用的欄位`,
"vue_label_checkduplicate_at_same_time":`同時滿足全部`,
"label.sms.phone":`簡訊網關客服電話`,
"UG_ST_004":`您沒有數據管理-》數據匯入的權限，請聯繫管理員，點擊確定後直接進入{0}介面。`,
"label.mobile.nobindmobile":``,
"label.partnerCloud.basicSetting.intro":`CloudCC支援您為不同類型的合作夥伴建立多個站點，分別配置登入頁面、可用選單、使用權限，滿足公司的各種業務需求。例如，零售商可以為地方代理商、廣告合作商建立不同的站點。`,
"label.trigger.targetobject":`目標物件`,
"label.ems.emailsyncperiod":`信箱同步時間間隔`,
"lable.Transformation.mode":`轉化方式`,
"label.emailobject.new.template":`建立範本`,
"label.System.Setting":`系統設定`,
"label.emailtocloudcc.button.addemailaddress":`添加企業信箱`,
"lable.a.total.of.invoices":`共計0個invoice`,
"label.multilang.customforcast.forecasthistory":`{0}的預測歷史：`,
"label.role":`角色`,
"advancedconditions":`進階篩選條件`,
"label.tabpage.beginz":`開始`,
"label.campagin.roi.khzhsl":`客戶轉換數量`,
"chatter.poll.option5":`選項5`,
"label.weixin.horse.club.registered":`愛馬社使用者註冊`,
"frame_personinfo_label_resizeimage":`要調整您的縮圖，請拖放並調整設定檔照片上方的虛線。`,
"label.file.share.select.warning":`已對其設置過共享！`,
"label.event.this.week":`本週的事件`,
"label.data.import.object.label":`物件標籤`,
"label.visualpage.folder":`未歸檔頁面檔夾`,
"vue_label_report_saveandclose":`儲存並關閉`,
"label.newdashboardpage.saveto":`儲存到`,
"label.partnerCloud.financeSetting.developerIDTwo":`開發者ID`,
"lable.PowerProcess.created.ago.please":`在建立過程前，請`,
"label.chatter.myfollowers":`我的追蹤者`,
"label.campaignmember.main.duplicatelist.title":`市場活動成員：掃碼除重設置`,
"label.group.no.recent2":`查找小組已加入`,
"label.icon.110":`書`,
"label.merge.my.account":`合併我的客戶`,
"setup.layout.button.quicksave":`快速儲存`,
"pagecreator.page.message.canntdelete":`當前頁面不允許刪除`,
"label.report.printable.view":`可列印視圖`,
"ccchat_fieldtrack_fieldchange":`從 {0} 更改為 {1}`,
"label.email.bcc":`密件副本`,
"label.sso.saml.sp.idpcert":`身分識別提供者證書`,
"label.step2.total2":`第2步，共2步`,
"lable.product.pricebooks.isn":`已啟用的價格手冊`,
"labal.emailtemplate.namemassage":`郵件範本的唯一名稱已存在，請重新編輯`,
"only.one.field":`只能選擇一個欄位`,
"label.weixin.appr.audittime":`審批時間`,
"pagecreator.page.button.delete":`刪除`,
"front-kefu-moudle-v1-Session-start-time":``,
"label_chatter_state":`狀態`,
"vue_label_systemSettings_lightningcustom":`Lighting自訂UI`,
"label.searchs":`搜尋`,
"label.mobile.phone.not.read":`未批閱`,
"label_chatter_allweather":`全天候`,
"label.enter.number":`請輸入0到6之間的整數`,
"front-epwechat-module-v1-addressbook-desc":`開啟同步後，可自動將企業微信通訊錄中的人員與部門同步至CloudCC的使用者與角色`,
"label.emailfield":`郵件欄位`,
"pagecreator_button_next":`下一步`,
"label.more.select.merge.records":`最多只可選擇三個要合併的記錄`,
"lable.edit.queue.selobjct":`選擇的物件`,
"label.reportsSubscription.editsubscribe":`編輯訂閱`,
"label.selectfieldtoautotransmit":`選擇用於自動傳送批准的欄位`,
"label.ccpeak.need.topass":`需要傳入`,
"label.checkfield.merge":`合併`,
"front-lighting-module-v1-detail-file-downlaodInfo":`記錄已鎖定，不支援下載檔案，請聯繫管理者解鎖。`,
"vue.please.enter.a.chart.name":`請輸入圖表名稱`,
"label.data.dataexptemplate.desc3":`3、匯出方式只針對匯出資料有效，對於匯出範本無效。匯出範本的文件格式是CSV格式。`,
"label.setup.mobile.homepageshortcuts.setting":`行動端主頁快捷功能設定`,
"label.ems.connect.success":`信箱檢測成功`,
"label.applet.text":``,
"label.knowledgebase.parent.window":`父視窗`,
"label_file_size":`佔用空間`,
"label.allocation.department":`指派使用者`,
"label.browser":`瀏覽器`,
"label.reportsSubscriptionPage.schedulereport.weekly.wednesday":`星期三`,
"label.integrations.description1":`匯出當前視圖的全部數據`,
"label.project360":`項目360`,
"label.choose_formtype":`選擇您的表單類型`,
"label_emailsync_status_connectstatus":`關聯狀態`,
"label.bmap.beijing.city":`北京市`,
"label.mask.encryption.scheme":`加密格式`,
"label.imgfield.type":`圖片類型`,
"label.person.target.responsible":`選擇目標負責人`,
"label.appexchange.installedpage.installdate":`安裝日期`,
"label.partnerCloud.orderingPlatform.partnerUsers":`該功能僅供合作夥伴使用者使用`,
"label.profile.customfieldsafety":`自訂欄位級安全性`,
"label.no.target.models.available.":`無可用目標模型。請先建立目標模型，也可聯繫系統管理員。`,
"label.process.execute.tip":`已處理您的請求，批次審批需要一定的時間，系統在處理完成後將會發郵件告知您。`,
"label.app.step2.introduce":`填充下面的欄位定義自訂應用程式。`,
"label.loginip.cue":`未指定登入IP範圍。允許來自任意Ip地址的使用者登錄。`,
"label.step1.select.tablayout":`步驟1：選擇選項卡配置`,
"mainpage.setup.chosecomponent.leastone":`至少需一個組件放在主頁上。`,
"label.custom.quarter.name":`自訂季度名稱`,
"chatter.ptup.link":`張貼連結`,
"label.compact.layout.frame.error2":`詳細訊息和相關列表必須在左屏`,
"vue_label_salesfunnel_notice7":`可能性為100%的機會總個數/可能性為0%或100%的機會總個數`,
"label.multilang.datamanage.dataimport.lostmsg":`標題的長度是&nbsp;{0}&nbsp;,但是數據的長度是&nbsp;{1}&nbsp;,系統無法確定遺失了哪&nbsp;{2}&nbsp;個欄位。`,
"label.owner.notnull":`擁有者不能為空`,
"label.logintime.pagecue.invalidt":`開始時間不能大於結束時間`,
"vue_label_file_checked_num_limit":`選擇的文件個數超過限制`,
"front-email-payment-repayments":``,
"template.report.today.prospects":`今天的商機`,
"label.weixin.appr.status":`審批狀態`,
"label.knowledge.language.japanese":`日語`,
"label.event.reminder.lead.time":`事件的提醒提前期`,
"lable.custom.dep":`單擊“建立”按鈕定義一個新的自訂年度`,
"Dashboard_View_Createdbyme":`我建立的儀表板`,
"label.file.upload.fail":`文件上傳失敗`,
"label.manager":`經理`,
"label.stdashbord.xsld.business.jine":`金額`,
"label.tag.manage.tag":`標籤`,
"chatter.nlk":`不喜歡`,
"label.file.search.people":`搜尋人員`,
"message.error.domain.format":`域名只能由英文和數字組成`,
"label.firstisdefault":`將第一個值作為預設值`,
"label.discount":`折扣`,
"label.mobile.phone.have.read":`已批閱`,
"label.field_selected":`該欄位已選擇`,
"label.payment.renew.now":`立即續約`,
"label.multilang.lookfiltercondition.notsetup":`第{0}行條件錯誤,未設置運算符！`,
"label.projectManagement.Selectionday":`選擇日`,
"label.user.organization.permit.licensenotstart":`您的組織許可未到啟用時間,請在許可啟用後重試`,
"label.download.save.attachment":`下載並儲存至附件`,
"lable.outlook.mcto.must":`必須是電子郵件格式`,
"vue_label_notice_unfollow_success":`取消關注成功`,
"label.taskinfo":`任務訊息`,
"label.other.SMS":`其它手機號碼`,
"label_partner_workspace_login_logo":`頁首標誌`,
"label.weixin.data.lock":`記錄被鎖定`,
"label.Yaxis":`Y 軸`,
"lable.edit.queue.selobjdes":`選擇要指派給此佇列的物件。隨後這些物件的單個記錄可以歸此佇列所有。`,
"label.campagin.roi.dcfezb":`到場份額占比`,
"label.marketseamemset.maximum":`最大數量`,
"label.owner":`擁有者`,
"label.reportsubscribe.error.noview":`請在“以下列使用者視角運行報表”中選擇運行報表的視角`,
"label.icon.133":`文件夾`,
"vue_label_file_share_files":`共用文件`,
"label.searchlayoutfilterfields.remark":`選擇要在選項卡搜尋或前台左側欄搜尋時顯示的篩選條件欄位`,
"vue_label_help_contract":`合約與收款計劃`,
"component.chatter.button.message":`留言`,
"label.marketsea.recyclereminddays2":`天提醒（需小於獲取後未跟進天數）`,
"label.webtocloudcc.input.information":`請填寫該訊息！`,
"vue_label_chatter_exit_group":`退出小組`,
"vue_label_lead_notcreatetask":`不建立工作`,
"front-lightning-module-v1-dashborad-date-dimension":`日期維度`,
"setup.layout.label.fieldlist":`可用欄位`,
"label.leadscore.charname":`欄位名`,
"label.forecast.customforecast.mybest":`我的超常發揮`,
"setup_mainpage_label_welcome24":`CloudCC 雲平台提供系統內所有物件數據的安全性存取設定，可以通過設定各種規則、條件進行數據共享和存取權限的控制。`,
"label.queue":`佇列`,
"label.icon.159":`芯片`,
"label.path":`要引用路徑`,
"label.app.message.failtoget":`獲取應用程式列表失敗`,
"label.returntoprocess":`返回審批流程列表`,
"vue_label_commonobjects_detail_more_data":`沒有更多數據`,
"label.number":`數量`,
"label.product.find":`查找價格手冊`,
"label.legend":`圖例`,
"label.partner.workspace.member.profile":`可選設定檔`,
"label.service.gantt.sum.appointments":`已完成的服務預約數量/所有服務預約數量`,
"label.partnerCloud.financeSetting.paymentAllowed":`允許線上支付儲值`,
"label.integrations.upgrate":``,
"label.timzone.tip.info3":`使用Calendar類別處理日期時，應給Calendar實例設置時區，獲取Calendar物件的方法可任選以下兩種，Calendar cal`,
"label.ems.addaccount2":`添加信箱帳號`,
"label.partneruser":`合作夥伴使用者`,
"label.validate.globalvariable.user.roleId":`角色 ID`,
"pagecreator.layout.button.mergecell":`合併單元格`,
"label.evacuantvalue":`排除的值`,
"label.setup.mini.msg":`品牌故事/通知設定`,
"label.icon.178":`人`,
"vue_label_pricebook_notice_cantbedeleted":`價格手冊項目無法刪除，因為已有記錄應用到該價格手冊，您可以改為將價格手冊項目標記為未啟用。`,
"vue_label_appstore_application_recommendation":`熱門應用推薦`,
"label.version.createlimit":`您當前CloudCC版本是 {0}， 允許建立 {1} 個{2}，已達到上限！如有需要，請升級CloudCC版本！`,
"message.duplication.label.sectionremar1":`請選擇要在合併後的記錄中保留的值。亮網底顯示的行表明欄位中包含衝突的數據。所選的主記錄將保留唯讀和隱藏欄位值。`,
"label.icon.1":`雲`,
"label.salescloud.salesdashboard.sales.performance":`整體-銷售合約業績`,
"System_AddressFieldType_Post":`郵編`,
"setup_object_field_dependency_label_mustone":`請至少設置一個依賴欄位的值`,
"label.appointmentdetail.wizard.title6":`地點`,
"label.layout.testobj2":`測試物件二`,
"label.searchlayout.dupcacher.field":`點擊選項卡下的查重合併連結顯示的查重欄位。`,
"label.attendance.persons.title":`請選擇考勤適用的人員`,
"template.report.product.sales":`產品銷量`,
"label.editCustomReportType":`編輯自訂報表類型`,
"label.multilang.ui.setup.profile.alltime":`所有時間均為{0}`,
"label.service.dispatchingUnits.noservice.booking":`無服務預約`,
"label.validate.remark4":`確保數字位於某一特定的範圍內，例如折扣大於30%`,
"front-kefu-moudle-v1-Waiting-time":``,
"label.weipagelayout.remark":`應用於微信小網頁及手機版顯示的配置`,
"vue_label_wang_er":`王二`,
"label.pw.text":`請為{user}輸入密碼，請確保包含至少`,
"message.error.user.data.null":`使用者訊息不能為空！`,
"chatter.like.p":`喜歡此帖子`,
"label.page.double.column.style.cloudcc":`雙列樣式在嵌入內容的同一個頁面上提供最常用的CloudCC功能，如“搜尋”和“最近項目”。`,
"label.h5.iscloseaccount":`是否確認註銷`,
"label.dataimport.insertdata.id.error":`格式錯誤，請使用數字和字母的組合。`,
"label_tabpage_sum":`共計`,
"front-epwechat-module-v1-addressbook-sync":`通訊錄同步`,
"label.setup.mobile.offlinecache.mostsave":`平台可設置預設啟用的行動端離線選項卡最多為10個`,
"label.weixin.quickcreate":`快速新建`,
"label.forecast.edittotal.de.mubiao":`的目標`,
"label.icon.144":`保障`,
"label.icon.155":`圖片`,
"label.In.the.search":`搜尋中`,
"message.validation.isnotdateISO":`輸入合法日期 (ISO)`,
"label.service.appointmentList.send.successfully":`查看詳情`,
"label.dynamicpage.error.exist":`動態版面配置數據不存在`,
"vue_label_SMS_otherpeople":`等{0}人`,
"label.cloudccsite.url":`站點URL`,
"label.tabpage.contactsz":`聯絡人`,
"vue_label_commonobject_notice_clickthename":`如需要下載已上傳文件，請點擊文件名稱`,
"vue_label_file_new_lib":``,
"label.chatter.card":`卡片`,
"chatter.feed.menutype.user.allusercom":`所有人員`,
"label.exchange.sync2":`設定`,
"template.report.year.income":`本年收入`,
"label.partner.template.detail":`功能說明`,
"label.setup.service.template":`服務報告範本`,
"label.dataimport.insertdata.id.length":`格式錯誤,長度小於20位，請仔細檢查本條記錄並修改。`,
"label.partnerCloud.financeSetting.collaborator":`合作者身份`,
"label.processskipwizard":`審批流程跳轉起點嚮導`,
"label.weixin.inputbusnumber":`請輸入車牌號`,
"label.dashboardSetup.d1":`斷點1值`,
"template.report.conversions.number.industry":`商機轉換數（按行業統計）`,
"vue_label_chat_group_chat":`群聊`,
"label.file.publicview.error":`此文件已被刪除、不存在或無法預覽`,
"label.customfields.location.locationHelpText":`請輸入位置名稱，如“總公司”。請具描述性和特定性，而且請記住，一個記錄可能有多個地址，如“西海岸銷售辦公室”和“東海岸銷售辦公室”。`,
"message.duplication.label.blankmatchtip":`設置空值是否參與匹配，預設是false`,
"message.appexchange.addtopackage":`請選擇一個或多個組件以添加到此軟體包！`,
"label.ems.return2query":`返回添加帳號查詢頁面`,
"label_model_name":`模型名稱`,
"label.apiname.retainapi":`name為系統保留名稱，請使用其他欄位Api名稱！`,
"lable.Cancel.the.search":`取消搜尋`,
"label.custom.viewport":`視角`,
"label.weixin.polls.type":`投票類型`,
"label.opportunity.setting.showstage.label":`自動推進`,
"label_component_helper_businesschange_expiredtask":`機會包含逾期工作`,
"label.operator":`運算符`,
"label.ccpeak.use.class.time.listmap":`通過傳入List<Map>集合存取`,
"component_timeline_label_past":`過去活動`,
"label.mobile.phone.submit":`我提交的報告`,
"message.recordtype.new.subtip":`為新記錄類型輸入名稱和備註。新記錄類型將包括以下所選現有記錄類型中的全部選項列表值。儲存新記錄類型後，您將可以自訂選項列表值。`,
"UG_product_05":`匯入產品`,
"label.validate.globalvariable.user.id":`使用者 ID`,
"label.umeng.activity.distribute":`您指派給`,
"label.weixin.avote":`發起投票`,
"label.weixin.already.sign":`已簽到過`,
"label.emailmerge.mergepage.generator":`產生`,
"label.batchtransfer.transferto":`轉移到`,
"label.tianyancha.industry":`行業`,
"label.addattachment.name":`文件名`,
"label.customfields.formula.date.tip":`計算日期，例如，通過在其它日期上加上或減去一定的天數`,
"label.partnerCloud.orderingPlatform.noPayment":`暫不付款`,
"label.emailobject.failedtosend":`發送失敗`,
"label.knowledge.setting.data.three":`最多{count}條資料分類組資料`,
"label.weixin.input.maxlength.langtext":`請在此輸入，最多可輸入32000字元`,
"vue_label_calendar_delete_calendar":`刪除日曆`,
"vue_label_commonobjects_detail_filter":``,
"setup.layout.group.custompage":`自訂頁面`,
"component_sendmail_label_subject":`主題`,
"label_tabpage_maxfilez":`文件最大為`,
"label.logintime.pagecue":`選擇具有此設定檔的使用者可以登錄的日期和時間。請注意，所有時間都採用指定時區的確切時間。即使使用者在不同時區，登錄時間也會採用這些確切時間。`,
"label.salescloud.salesdashboard.datetime":`預計簽約時間`,
"label.format":`格式`,
"label.newfoundland.daylight.time":`紐芬蘭夏令時`,
"front-kefu-moudle-v1-messagetemplate.finishdetailinfo":`將合併欄位值複製並黏貼到簡訊正文`,
"message.chooseatleastoneforshare":`請至少選擇一個共用使用者`,
"label.multilang.datamanage.importobjfield":`第 {0} 列`,
"label.denglu":`登錄`,
"label.popup.infoz":`提示`,
"label.schedulejob.setup.schedule.onday":`在每月`,
"label.appointmentdetail.wizard.title16":`週三時間規劃`,
"label.userphoto.dragtoadjust":`拖曳以調整大小和調整縮圖`,
"label.product.series":`產品系列`,
"message.view.kanban.not.set.group.summary.field":`視圖看板未設置分組匯總欄位`,
"page.un.activities":`未處理活動`,
"label.exchange.sync3":`組態`,
"label.login.activityExpired":`使用者活躍度已過期，請聯繫系統管理員。`,
"component_chatter_file_button_files":`選擇文件`,
"message.onlydelete.type":`只能刪除不活動的記錄類型。禁用記錄類型以允許刪除。`,
"message.recordtype.selectlayouttouse":`選擇要使用的版面配置`,
"label.knowledgebase.unable.restore.draft":`您無法恢復已刪除的草稿。`,
"label.shangqing.name":`商情`,
"label.weixin.target.payment":`目標收款`,
"label.chatter.sendEmailToGroupMember.check":`檢視帖子`,
"front-kefu-moudle-v1-input-single-login-area":``,
"vue_label_zhang_yi":`張一`,
"label.icon.190":`吹風機`,
"label.quickbooks.fieldlabel.company":`客戶名稱`,
"vue_label_email_are_you_sure_to_delete":`是否確認刪除郵件`,
"Pagelayout.Setup.005":`名稱必須放在第一個位置`,
"label.object.name.two":`物件名2`,
"label.tabpage.completez":`將選中 狀態標記為完成`,
"label.setup.mobile.bottombutton.saveerror":`行動端一級頁面設定儲存失敗`,
"label.report.action.addtodashboard8":`選擇儀表板文件夾`,
"label.data.downpage.i_list.desc3":`使用者下載後，可以在文件最後一列查看匯入失敗的具體原因。`,
"label.layout":`配置`,
"label.marketsea.button.assign":`指派`,
"UG.solution.03":`建立解決方案`,
"label.ccchat.person.invited":`邀請同事`,
"label.ccchat.person.invite.address":`收件人`,
"label.displaytype1":`詳細訊息頁面連結`,
"label.tianyancha.h5.ziranrengudong":`自然人股東`,
"lable.SalesCommitmentKanBan.targetReceipts":`目標收款額`,
"message.error.getitems.type":`getItems:type不能為空`,
"label.addattachment.list":`已上傳下列文件`,
"label.datamanage.export.false":`匯出時出現錯誤`,
"pagecreator.systemstyle.label.buttonfontcolor":`按鈕文字`,
"label.emailtocloudcc.redmessage1":`請輸入正確的電子信箱地址`,
"label.weixin.polls.closed":`投票已截止,截止時間`,
"label.icon.165":`帽子`,
"vue_label_report_detailsonly":`僅限詳細訊息`,
"component.salesperformance.label.100finish":`已結束`,
"november":`十一月`,
"label.data.file.generatejwd":`執行根據地址產生經緯度服務`,
"label.salescloud.opportunity.access":`業務機會存取權限`,
"label.isremider.remider":`提醒`,
"vue_label_total":`總量`,
"label.email.prompt.using.lightning.link":`系統通知中的郵件連結使用lightning版本的連結`,
"label.knowledgebase.cancel.attached.articles":`取消附加文章`,
"label.version.custom.xslc":`可自訂銷售流程`,
"component_setup_button_save":`儲存`,
"label.ems.cc":`添加副本`,
"label.edit.user":`更新使用者`,
"label.emailtocloudcc.select2":`請選擇類型`,
"label.industrialandcommercialverification.fieldnumber":`映射欄位：4個`,
"label.ccchat.havenot.joined.group":`您沒有加入任何活動小組`,
"pagecreator_page_label_pagename":`頁面名稱`,
"setup.layout.button.save":`儲存`,
"label.campaignmember.main.updatestatus":`批次更新市場活動成員狀態`,
"label.tab.web.edit":`編輯 Web 選項卡`,
"label.ring_chart":`環形圖`,
"label.usermanage.resetpwd.error":`重置密碼失敗，不存在的使用者`,
"label.Xaxisscope":`X 軸範圍`,
"label.app.new":`新建應用程式`,
"message.modifythereport":`儀表板使用此報表。如修改可能會導致引用此報表的儀表板失效。`,
"label.component.helper.businesschange.0activity":`30天內沒有任何活動`,
"label.weixin.fmu.noon":`中午{0}`,
"label.enter.rule.name":`輸入規則名稱`,
"lable.Confirm.recovery.potential.customers":`確認恢復商機{name}`,
"lable.PowerProcess.type.created":`您想要建立什麼類型的權利過程？`,
"front-lightning-module-v1-dashbord-rectangle-size":`矩形大小`,
"label.projectManagement.new.service.appointment":`新增服務預約`,
"label.multilang.totalpage2":`共`,
"pagecreator.systemstyle.label.styledesc":`樣式描述`,
"chatter.up":`上傳中`,
"2018UI_Homepage_DataDeleted_Info":`數據已經刪除，點擊返回上一步。`,
"label.knowledge.draft.recordid":`草稿id不能為空`,
"vue_label_pool_recyclecertification":`{0}{1}{2}{3}`,
"label.setting.intergrationlist.viewall":`查看所有集成`,
"vue_label_file_num_limit_tip":`文件個數超出預設，如果需要取代文件，請先刪除已上傳的文件`,
"vue_label_commonobjects_view_refreshat":`已在{timeInterval}前重新整理`,
"laebe.data.exp.save.success":`如果需要用此範本匯出數據，請您返回到按範本匯出按鈕進行操作。`,
"label.mr.caption.contact":`查重合併：查詢聯絡人重複數據的條件`,
"label.webtocloudcc.submit.error":`提交失敗`,
"label.multilang.datadelete.delmessage":`已鎖定記錄（{0}條）不允許刪除：`,
"label.quickbooks.searchlist.total2":`搜尋到有{0}個尚未關聯的付款記錄，共計金額為{1}`,
"label.createnew":`新建...`,
"component.milestones.label.choicestate":`確認此狀態`,
"lable.outlook.edit.exist":`欄位名已存在，請輸入唯一欄位名。`,
"vue_label_dashboard_eachother":``,
"label.new.role":`新建角色`,
"message.error.operationType":`調用服務時發現操作符未定義;`,
"label.fenbeitong.name":`分貝通`,
"label.choose.person":`請選擇需要發送的人員`,
"label.attendance.thanks":`感謝您的參與！`,
"label.invoice.message.statusupdatefailed":`Invoice狀態更新失敗`,
"template.chart.yzhqzkhlyfx":`已轉換商機來源分析`,
"chatter.feed.menutype.user.alluser":`所有人員`,
"UG_Forcast_04":`開始試用`,
"label.appupload.upload.tips.profile":`注意：此軟體包中已添加“設定檔”組件，無法再次添加(一個軟體包中最多只允許添加一個設定檔組件)。`,
"lable.PowerProcess.leave.the.process":`{describeName}退出過程`,
"template.report.sales.cycle.opportunities":`銷售週期持續時間（按機會類型統計）`,
"vue_label_calendar_please_fill_in_the_calendar":`請填寫日曆名稱`,
"label.salescloud.unit.wanyuan":`單位（元）`,
"label.fileAPI":`文檔唯一名稱`,
"label.weixin.link":`關聯`,
"label.service.seconds":`流失率`,
"label.encd.visible":`加密欄位值可視`,
"label.tianyancha.regstatus":`經營狀態`,
"label.event.moveup.18hour":`提前 18 小時`,
"label.upper.bound":`上界`,
"label.please.insertURL":`請輸入要插入的URL`,
"label.approval.notallowed.reject":`不允許拒絕`,
"label.permission.fieldpermission":`欄位權限設置`,
"label.customcomponent.page.index.title":`自訂組件`,
"label.quickbooks.viewlist.number":`編號`,
"lable.list.queue.sendemail":`向成員發送電子郵件`,
"label.productsales.today.noevtadd":`今天沒有未處理的事件，您也可以點擊右上角的“ ”添加事件！`,
"label.report.line.daixuan":`待選報表列`,
"label.reportsSubscription.select.start.endtime":`請選擇開始時間結束時間！`,
"template.chart.schdyscb":`行銷活動預算成本`,
"label.sendemail.chat.addPostatsubject":`CloudCC CCChat 微貼裡提及我`,
"label.RelatedList":`相關列表`,
"label.knowledgebase.delete.translation.associated.with.draft":`現有草稿翻譯將連結到主語言文章的上一個發布版本。如果沒有發布版本，將刪除任何譯稿。`,
"vue_label_chatter_submitted_review":`您已經提交加入申請，請等待管理員審核`,
"label.layout.list2":`列表二`,
"label.manage.area":`管理區域`,
"label.manageapproveprocess":`管理審批流程`,
"workflow.action.tasks.assignortype.created":`建立人`,
"label.custombutton.nonsupport.operation":`當前版本不支援操作標準按鈕和連結`,
"label.ip":`IP地址`,
"label.chat.topic.desc.error.info":`主題描述不能超過1000個字元。嘗試使用更短的主題說明。`,
"label_tabpage_cue":`訊息提示`,
"label.integrations.mailchimp1":``,
"label.email.track.required":`必填訊息`,
"label.set.case":`請先設定個案擁有者`,
"label.weixin.newspaper.coverage.number":`保險單編號`,
"vue_label_approve_submitreason":`提交原因`,
"message.oppdt.noenabledpricebook":`沒有啟用的價格手冊!`,
"label.partner.workspace.setup":`設置`,
"label.version.nonsupport.feature":`暫不支援此功能！如有需要，請升級CloudCC版本！`,
"com.cloudcc.login.error.message.licenseexpired":`許可已過期`,
"label.emailsync.form.signin":`登錄`,
"label.campaign.channel.input.to.chooselanguage":`請選擇語言`,
"label.tabpage.gotit":`知道了`,
"front-console-no-contact-tip":``,
"label.approval.apiname":`API和受管軟體包使用的唯一名稱。名稱必須以字母開首，僅使用字母數字字元和下劃線。名稱不能以下劃線結尾或有兩條連續的下劃線`,
"label_emailtocloudcc_filed_ssl":`安全連接`,
"component_sendmail_label_fromuser":`發件人`,
"front-kefu-moudle-v1-new-online-chats":`建立線上工作人員`,
"label.searchlayout.merge.duplicated.results":`是否啟用查重合併`,
"label.weixin.input.maxlength.remark":`請在此輸入，最多可輸入500字元`,
"component.telerecord.label.related":`相關項`,
"label.note":`註釋`,
"message.duplication.label.nletters":`個字元`,
"label.productsales.payment.phb":`收款排行榜`,
"label.forecast.editshrepage.desc":`Forecast:指定此記錄的共享。您可與單個使用者、特定角色的使用者或者特定角色下方角色的所有使用者共享此記錄及相關數據。`,
"vue.dashboard.setPenetrationSuccessful":`設定穿透成功！`,
"label.tabpage.noOperationz":`此內容為固定項，不可操作！`,
"label.email.jump":`跳轉至第三方連結 ???`,
"label.appointmentpage.wizard.btn1":`確認預定`,
"label.umeng.approval.pass":`#approver已通過#obj申請`,
"label.project.hit.twelve":`里程碑到期提醒`,
"two":`二`,
"label.approvedinfo":`審批訊息`,
"label.import.step1.choosecsv":`請選擇csv文件`,
"vue.please.select.the.expansion.method":`請選擇展開方式`,
"UG.homepage.005":`銷售智能`,
"Account.News.Setting.003":`一般設定`,
"label.quickbooks.button.actions":`操作`,
"lable.list.queue.email":`佇列電子郵件`,
"label.name.lastname":`姓氏`,
"message.confirm":`您確定嗎？`,
"Opportunity.Detailed.Phase.Label.Popup.002":`離開日期`,
"label.knowledge.setting.title":`知識庫設定`,
"label.helptocreateprocess":`的有效和無效審批流程。要建立一個審批流程，單擊建立新的審批流程"，然後選擇"使用跳轉起點嚮導"僅幾個步驟就可以設置您的審批流程。或者，選擇"使用標準嚮導"配置所有審批選項。"`,
"label.batcheditor.remark":`可以對多條記錄進行編輯`,
"label.page":`頁`,
"label.newfolder":`建立新文件夾`,
"label.version.interceptor.api":`接口API`,
"label.sms.toaddress":`收到一封簡訊`,
"front-kefu-moudle-noopen-callcenter":``,
"label.data.exp.zip":`壓縮格式`,
"lable.account.LastcDays":`過去60天`,
"label.import.index.starttime":`開始時間`,
"label.dashboardall":`所有儀表板`,
"label.create_socialpost":``,
"label.searchlayoutedit.remark":`選擇當點擊前台左側欄搜尋或選項卡搜尋時，查詢顯示的欄位及按鈕`,
"message.servicecrew.violation":`資源指派違規:服務資源在此時段為服務班組成員`,
"label.email.attrach.file":`附加文件`,
"report.label.folderandreport":`報表和文件夾`,
"label.list.userinterface.sales.setup":`系統銷售主頁設置`,
"label.martrixreport.2018.step1":`步驟1：選擇用於計算匯總訊息的分組方式`,
"label.campaignmember.selectmember.memberstatus":`市場活動成員狀態`,
"label.textmessage.vonage.api.key":`API密鑰`,
"label.tabpage.next":`下一步`,
"UG_Lead_006":`網站訪客`,
"label.salescloud.salesdashboard.visit.rankings":`拜訪排行榜`,
"label.myevent":`我的事件`,
"label.activity.history":`歷史`,
"label_tabpage_kanban":`看板設置`,
"label.weixin.allapp":`全部應用`,
"label.query.clone.detail.choose.choosed":`已選明細物件`,
"message.error.view.errvalid":`錯誤： 視圖唯一名稱欄位只能包含線和字母數字字元。 它必須是唯一的，以字母開頭，不包括空格，不得以底線結尾，且不得包含兩個連續底線`,
"label.customfields.searchrelation.dependobject.tip":`選擇此物件相關的另一個物件`,
"label.appointment.wizard.subtitle4-4-3":`三週`,
"label.setup.mobile.offlinecache.saveerror":`行動端離線快取設定儲存失敗`,
"label.planned.started":`已開始`,
"label.page.step4.of.step5":`第4步，共5步`,
"label.tabpage.value":`值`,
"label.reportlist.allfolder":`全部文件夾`,
"label.callcenter.sure.disable.center":``,
"vue_label_commonobjects_detail_activity_tocalendar":`去日曆`,
"label.setup.mobile.bottombutton.recovery.default":`恢復預設`,
"label.appointmentdetail.wizard.title15":`週二時間規劃`,
"label.icon.15":`維修單`,
"component_sendmail_label_touser":`收件人`,
"template.report.all.owner":`商機擁有者`,
"front-Partner-email-tips":``,
"vue_label_systemSettings_mobelhomepagesetting":`行動端主頁設定`,
"label.service.newBuildDialog.aswellas":`以及`,
"label.name":`名稱`,
"label.tag.search.taglist":`標籤列表`,
"label.partnerCloud.priceOfManual.theOnly":`建議為每個合作夥伴客戶設定唯一的價格手冊。若設定了多個價格手冊，夥伴下單時需選擇本單使用的價格手冊。若未設定手冊，會使用標準價格手冊。`,
"label.knowledge.field.update":`已更改{1}從{2}到{3}`,
"label.emailobject.save":`儲存`,
"label.top.changeVersion":`横向選單`,
"label.recordtype.edit.unselected":`可用值`,
"label.knowledgebase.additional.articles":`附加文章`,
"label.lead.score.confirm":`請選擇需要給商機評分的範圍，點擊【商機評分】 按鈕，系統將會按照當前啟動的評分規則給所選擇的商機評分，<br><br>評分過程可能需要花費較長的時間，一旦評分完成，您會收到一份確認郵件。<br><br>`,
"label.projectManagement.pleaseselectadate":`請選擇日期`,
"label.appointment.wizard.subtitle5":`會議名稱`,
"label_setup_failed":`設定失敗`,
"label.chatter.collect":`收藏`,
"label.appointment.cancelappointment":`取消預約`,
"front-console-response":``,
"message.delete":`確定要刪除嗎?`,
"label.dataimport.type.selected":`請選擇匯入類型`,
"label.new.target":`建立目標`,
"vue_label_report_autoupdatepreview":``,
"label.knowledgebase.guidance":`指導`,
"label.chatter.mail":`郵件`,
"label.login.verification.scan.code.acquisition":`掃碼獲取：`,
"label.customsetting.changefieldtype":`更改欄位類型`,
"label.data.dataexpalltype.all_desc2":`2、匯出全部的數據較多，需要一定的時間。匯出完成後，系統將為您發送一封匯出成功的郵件。`,
"label.opportunity.contactisnull":`客戶訊息為空，無法顯示`,
"pagecreator_layout_button_upload":`上傳配置`,
"label.dashboard.noRecord":`暫無記錄`,
"label.SMS.template":`簡訊範本名`,
"label.c.d.without":`C" 記錄可能有或沒有相關 "D" 記錄。"`,
"UG.Case.05":`建立個案`,
"front-epwechat-module-v1-edit-selfapp":`編輯自建應用`,
"label.role.createrole.tip":`您可以依照顯示在本頁上的現有角色階層架構繼續建構。 要插入新角色，單擊<b>添加角色</b>。`,
"label.grouping":`分組`,
"vue_label_email_upload_new_file":`上傳新文件`,
"label.notification.event3":`您的事件即將在【開始時間】開始`,
"labe_benchmark_objects":`基準物件`,
"component.chatter.button.collect":`收藏`,
"front-QBtoCC-sinchronies":``,
"message.submitpage.sms":`祝賀您！簡訊發送請求成功！`,
"label.imgfield.width":`寬度`,
"label.send_email":`發送送出郵件通知給`,
"label.queue.list":`佇列列表`,
"label.tabpage.fieldoptions":`記錄類型欄位，選項列表欄位和選項列表（多選）欄位，建議最多輸入10個關鍵字，用英文逗號隔開實現或關係，如：“北京,上海,廣州”。`,
"component.chatter.post.button.save":`發表`,
"chatter.group.groupDescriptionInformation":`組描述訊息`,
"label_setup_mobilesetup_isenableh5newandedit":`行動端是否啟用H5新建編輯`,
"lable.Confirm.recallpotential.customers":`確認回收{num}個商機`,
"label.knowledge.setting.hint.seven":`從以下名稱中選擇並授予寫入權限，以貢獻自己的微薄之力。`,
"label.emailtocloudcc.redmessage2":`請輸入正確的信箱密碼`,
"message.validation.equalTo":`入相同的值`,
"vue_label_help_golbal":`全局導航`,
"vue_label_chatter_delete_group_title":`刪除小組`,
"label.user.login.success":`登錄成功。`,
"label.chatham.standard.time":`查薩姆夏令時`,
"label.vlidaterule.example.percent":`折扣百分比不能超過30%`,
"label.group.field":`指定分組欄位`,
"label.trigger.operation.sharetab":`觸發器操作共用表：`,
"label.mobile.phone.write.month.report":`寫月報`,
"label.statusofconvers":`已轉換狀態`,
"label.version.emailtemplate.track":`電子郵件範本`,
"label.customobjects.onlytrackforupdate":`僅追蹤更改`,
"label_tabpage_enterviewname":`第一步：請輸入視圖名稱`,
"label.processsetting.three.enable":`第三步：啟用`,
"label.service.show.more.info":`顯示更多訊息`,
"front-epwechat-module-v1-input-iosschema":`請輸入iOS schema`,
"label.dataimport.datatype.error":`數據類型錯誤，請仔細檢查數據和標題是否一一對應`,
"label.staticresource":`靜態資源`,
"label.weixin.customize":`個性化`,
"label.product.edit.sel":`編輯所選`,
"label.appointmentpage.wizard.notif5":`無效手機號碼格式`,
"label.marketsea.basicsetup":`基礎設定`,
"label.workflow.supplyintruduce":`1.引發應用工作流程規則的條件<br/>2.當某個記錄同條件相匹配時執行的即時操作。例如，在建立了新業務機會後，cloudcc可以自動向客戶小組發送電子郵件進行通知<br/>3.依據時間的操作在記錄同條件相匹配時會排成佇列，然後根據時間觸發器執行`,
"label_report_line_tuozhuai":`請拖拽或雙擊鼠標選擇報表列並調整列順序`,
"label.add.new.rule":`新增產生規則`,
"label.marketing.setting2":`渠道設定`,
"vue_label_chatter_delete_some_group":`確定要刪除小組"{groupInfoList}"嗎`,
"label.appupload.uploading.wait":`請稍等`,
"label.linecondition.error":`行條件錯誤，欄位類型不匹配！`,
"chatter.group.request":`請求`,
"label.recordtype.tabname.remark":`使用此頁面建立並維護貴組織的記錄類型。可根據記錄類型顯示不同的版面配置和選項列表值。要使用記錄類型，請將“記錄類型”欄位添加到版面配置上`,
"setup_mainpage_label_welcome4":`操作指導： 點擊本頁左側選單 → 應用程式設定 → 建立 → 物件。`,
"vue_label_salesadvance":`銷售階段推進`,
"vue_label_campaign_of_existing_campaign_members":`請設定現有行銷活動成員狀態`,
"label.report.object.detail.no.permission":`報表類型變更或已被移動，請聯繫系統管理者。`,
"label.weixin.untreated":`未處理`,
"label.service.miniProgram.bindSetOwnerDesc":``,
"label.autoassigntoapprover":`自動分配至審批者。`,
"label.marketseamemset.containself":`包含自建記錄`,
"vue_label_report_drill":`鑽取`,
"label.order.products.to.assets":`訂單產品轉資產`,
"label.recordtype.list":`現有記錄類型`,
"lable.outlook.detail.conflict":`衝突行為`,
"pagecreator.page.label.layoutpreview":`配置預覽`,
"front-kefu-moudle-v1-zxltyhxzc-buyuser":`工作人員聊天由環信支援，請先購買環信帳號`,
"label.convers":`轉換`,
"serviceappointment.worktype.isnot.father.worktype":`此服務預約必須選擇其父級記錄關聯的工作類型`,
"lable.tianyancha.h5.relatedcom":`相關公司`,
"label.reportsSubscriptionPage.schedulereport":`安排報表時間`,
"label.workbanch.setup.showinworkbanch":`是否在我的工作台中顯示`,
"label_emailsync_connectaccount":`關聯信箱帳號`,
"label.usermanage.license.not.qualified":``,
"component_setup_label_displayfield":`顯示欄位`,
"setup_layout_label_buttonarea":`按鈕區域`,
"label.weixin.input.content":`請輸入內容`,
"label.operatedata.importsuc":`匯入成功，請打開物件查看匯入的情況`,
"label_tabpage_yes1z":`是1`,
"front-electronic-signature-describe":``,
"label.event.this.month":`本月的事件`,
"label.document.replaces":`取代`,
"label.email.cc":`副本`,
"chatter.feed.sticker":`微貼追蹤`,
"vue_label_commonobjects_view_chart_notice_pleaseaddchart":`請添加圖表`,
"label.cpq.main.quote.transfer.order":`只有主報價單才可以產生訂單`,
"label.partnerCloud.partnerAccount.topUpSuccess":`儲值成功`,
"label.appexchange.uninstallpage.uninstall":`移除`,
"label.campagin.roi.channel":`營銷渠道`,
"label.multilang.versioncontrol.checkversion":`您目前CloudCC版本是{0}允許建立{1}個{2},已達到上限！如有需要,請升級CloudCC版本！`,
"label.emailobject.my.template":`僅顯示我的範本`,
"label.edittimetrigger":`編輯時間觸發器`,
"label.setup.mobile.homepageshortcuts.saveerror":`行動端主頁快捷功能設定儲存失敗`,
"label.address.street":`街道訊息`,
"label.workflow.estimatecondition2":`僅當建立記錄時`,
"label.wei.expiresdate":`截至時間`,
"label.quickbooks.viewlist.date":`日期`,
"label.page.select.field.type":`選擇欄位類型`,
"label.tabpage.mypotentialcustomers":`我的商機`,
"label.file.library.editlib":`編輯文件庫詳細資料`,
"label.weixin.message.operateexception":`訊息提示`,
"label.visualpage.staticresource.p1":`1.調用方式. 通過引入靜態資源按鈕引入選擇的靜態資源`,
"label.icon.175":`機票`,
"chatter.edit.r":`編寫回覆...`,
"label.examinationandapproval.flow":`審批流程`,
"label.mr.descreption.reDataList5":`組數據。`,
"label.edit.field.select.showstyle":`顯示樣式`,
"label.reportsSubscriptionPage.condition.and":`並且`,
"label.please.associations":`請選擇關聯物件`,
"label.service.dispatchingUnits.displays.service.appointments":`顯示未與區域關聯的服務預約`,
"label.addcurrent":`添加現有`,
"label.search.change":`可搜尋物件設置`,
"message.schedulejob.error.modify":`基於配置的時間表,給定的作業將永遠不會觸發,請檢查數據後重新提交。`,
"label.chatter.sendEmailToGroupMember.subject.L":`{0}在小組{1}發布了全員連結`,
"label.weixin.micro.oldid":`微信公眾號原始ID`,
"label.employees.only.invitation.code":`系統將為員工產生唯一邀約碼，員工可使用此碼進行邀約，並可計入個人績效。請注意，商機擁有者將是當前行銷活動擁有者或者營銷通路邀約人。您可以通過商機指派規則進行重新指派，關於指派規則`,
"lable.PowerProcess.event.msg":`您可以在權利過程中添加每個步驟（重大事件）以時間為基礎的工作流操作。例如，您可以設定操作，以在重大事件過期前一小時向個案擁有者發送電子郵件，或者在首次回復重大事件完成時對自動更新特定個案欄位`,
"label.file.share.email.content2":`共享訊息：共享給您當前文件的#sharerole權限`,
"label.querydetailservice.datalayout.notexist":`記錄對應的配置不存在`,
"label.group.items":`分組項目`,
"label.istouse":`是否可供使用`,
"front-electronic-signature-explain":``,
"label.partner.template.thumbnail":`縮略圖`,
"registration.page.selected.fields":`註冊頁面必選欄位選擇`,
"label.reportTypeCategoryLabel":`數據源`,
"vue_label_email_You_have_not_activated_the_mailbox":`您還未啟用信箱`,
"lable.SalesCommitmentKanBan.taskCompletionRate":`任務完成比例`,
"label.forecast.detailforecast.program":`預測項目`,
"label.page.display":`每頁顯示`,
"label.passwordPolicy.setup.minute":`分鐘`,
"label.emailtocloudcc.step1total3":`第1步，共3步`,
"label.file.title":`標題`,
"label.callcenter.private.key":``,
"com.cloudcc.login.error.message.loginerror":`使用者名或密碼錯誤`,
"UG_Lead_004":`Web表單`,
"label_tabpage_recordsz":`記錄`,
"label.shangqing.discovery":`商情發現`,
"vue_label_notice_change_success":`更改成功`,
"label.ems.other":`其他`,
"loading":`數據加載中`,
"label.committedtoapprove":`已經提交的批准請求`,
"label.category.4":`金融`,
"template.report.folder.customer.situation":`客戶情況分析`,
"label.quickbooks.searchresault.phone":`電話`,
"label.ccpeak.ccobj.save":`要將CCobject儲存到數據庫，調用方法`,
"label.knowledge.delete.linked":`刪除關聯文章出錯`,
"label.forecast.settings.future2":`未來2個週期`,
"message.error.displaytype.detail":`顯示類型不能為空，日：day，月：month，星期：week，可用性：availability！`,
"front-template-V1-search-template-name":`輸入物件名，快速搜尋`,
"label.sendsms.batch.step3.introduce":`儲存每條簡訊的活動`,
"UG.Forcast.08":`上一步`,
"label.inputnameandintro":`輸入名稱和說明`,
"label.redistributioned":`已重新分配`,
"label.service.dispatchingUnits.left.right.total":`當前{left}-{right}條數據，共{totalCount}條數據`,
"label.projectManagement.Pleaseentertheactualworkinghours":`請輸入實際工作時長`,
"label.exporttemplate":`匯出範本`,
"label.data.downpage":`數據下載頁面`,
"message.please.choose.contact":`請選擇聯絡人`,
"message.error.dataformat.error":`數據格式錯誤`,
"label.customsetting.changefieldtype.losevalue":`更改為所選數據類型將會遺失該欄位中的所有現有數據。`,
"label.sendemail.chat.chattype":`主貼類型：`,
"label.ccdocument.upload.error":`上傳文檔出錯了！`,
"label.quickbooks.view.all":`全部`,
"label.data.downpage.e_title":`匯出數據的步驟:`,
"lable.data.lock":`數據已鎖定，操作請先解鎖。`,
"label.locked":`已鎖定`,
"label.customfields.beforedeletedata":`在刪除該自訂欄位之前，建議通過單擊設置"|"數據管理"|"`,
"label.productsales.oppor.noapproach":`暫無預計簽約日期<30 天的機會`,
"label.input.notmore.than.number":`請輸入一個小於或等於 {0} 的數字`,
"label.list.userinterface.isenable":`啟用內聯編輯`,
"label.listofshare":``,
"label.emailsync.status.role":`角色`,
"label.staticresource.useful.realtion":`使用此靜態資源的位置`,
"label.sharerule.tip":`此頁顯示貴組織的共享設置。這些設置指定每個使用者對於其他每個人的數據所擁有的存取權限級別。`,
"label.qrcodelogin.message.expired":`二維碼已失效`,
"label.marketing.setting3":`行銷活動營銷通路設定`,
"vue_label_statistical_field":`統計欄位`,
"message.view.addtomyhomepage":`添加到首頁工作臺`,
"label.customfields.percent.tip":`允許使用者輸入百分比數字（例如，10"），並自動向數字添加百分號。"`,
"component_newrecords_label_10records":`10條記錄`,
"Lead_Scoring_Warning_001":`針對單個商機系統可在新建，編輯商機時自動評分，但針對批次匯入或者通過接口建立的商機需使用批次評分手工進行。`,
"label.project.planing":``,
"label.data.exp.pwdverif":`密碼只允許是字母或數字`,
"coderules.notEnable":`請聯繫管理員開啟產生二維碼或條形碼的規則`,
"label.weixin.wdyj.jxhk":`個人-銷售績效-收款`,
"label.data.expnode.e_desc3":`3、範本製作：使用者可以根據需求將所需匯出的欄位及條件製作成範本，方便下次使用。`,
"chatter.group.join":`加入`,
"vue_label_systemSettings_monitoring":`監控`,
"front-kefu-moudle-v1-yesorno-delete-folder":`確定要刪除這個檔案夾嗎？`,
"label.exchange.sync.state.info":`檢查系統狀態,確保記錄在Exchange和 CloudCC 之間同步的。`,
"lable.outlook.mcto.emaildes":`輸入您用於發送電子郵件商機和聯絡人的所有電子郵件地址，用逗號隔開。只有從您下麵指定的電子郵件地址發送的電子郵件可添加到相關記錄的活動歷史。`,
"label.ems.save":`儲存`,
"vue_label_dashboard_maximumvalue":`請輸入顯示最大數值`,
"label.passwordPolicy.setup.norestriction":`無要求`,
"label.multilang.customforcast.total":`{0}的累計`,
"label_partner_all_memo":`列表顯示貴組織中的全部夥伴雲。單擊URL可將您直接跳轉到登錄頁。`,
"Account.News.Setting.002":`使用下面的客戶設定為貴組織指定預設的客戶行為`,
"label.essential":`必需`,
"label.nonotice":`不再提醒`,
"vue_label_calendar_calendar_deleted_successfully":`刪除日曆成功`,
"message.huanxinagent.disable":`工作人員未啟用`,
"label.goto":`轉至`,
"label.chat.topic.add.favorite":`添加到收藏夾`,
"label.trigger.targetobj":`目標物件`,
"label.form_fields":`表單欄位`,
"this.month":`本月`,
"vue_label_homepage_select_view":`選擇視圖`,
"label.weixin.input.subject":`請填寫主題`,
"label.ems.emailType":`信箱類型`,
"vue_label_file_safe_type_file":`請確認文件不包含敏感訊息。請考慮與特定使用者或記錄共用文件`,
"label.version.case.automatic.upgrade":`Case 自動升級及分配`,
"label.input.invalid.credit.card.number":`請輸入一個合法的信用卡號碼`,
"component_timeline_label_future":`後續步驟`,
"label.emailtemplate.cannotsupporthtml":`目前不支援HTML類型`,
"label.appupload.install.error.info2":`{1}  “{0}”           與現有組件衝突。`,
"label.custom.field.maping":`映射到此欄位`,
"encd":`加密文本(顯示加密)`,
"label.service.newBuildDialog.filter.logic":`篩選器邏輯`,
"label.customerinfo":`公司設定檔`,
"vue_label_applauncher_notice_activepoolsuccess":`啟用公海池成功`,
"label.partner.workspace.member.choicepermission":`選擇權限集`,
"front-gantt-module-this-task-of-other-tasks":``,
"label_chatter_publish":`發表`,
"label.forecast.settings.mrfw":`預設範圍起點`,
"label.Named.Filter":`命名篩選器`,
"label.department.email":`信箱地址`,
"label.updatingfield":`要更新的欄位`,
"label_partner_template_detail":`功能說明`,
"front-epwechat-module-v1-unbound-item":`#NAME?`,
"vue_label_file_lib_name":``,
"label.notification.arketsea.distribution":`{5}將{2}{0}：{1}指派給了您`,
"vue_label_norm_removecomponent":`刪除組件`,
"component.event.label.begindate":`*開始時間`,
"chatter.note":`個收到註釋`,
"label.forecast.settings.type.all":`使用整體預測`,
"label.compact.layout.frame.full":`全螢幕顯示`,
"label.approvalstep3intro":`使用下面的選項，指定批准請求應分配給的使用者`,
"label.notification.approval6":`【被委派人名稱】替您批准【提交人】請求的【物件】【物件名稱】審批申請。`,
"setup.object.field.dependency.label.actionfieldvalue":`控制欄位值`,
"label.multilang.page2":`頁`,
"vue_label_email_submitted":`提交通過`,
"label.Standard.button":`標準按鈕`,
"vue_label_report_emailchoose":`電子郵件選項`,
"page.field.masterinput.list":`主從錄入數據列表`,
"label.martrixdown":`矩陣下移`,
"vue_label_helpcenter_opportunity":`在視圖的右上角，點擊銷售漏斗圖示，可以跳轉查看銷售漏斗。<br>通過直覺的進度條，追蹤每個機會的進度，並且可以通過點擊按鈕，標記完成當前階段，或是調整當前階段。如果推進機會的時候遇到了阻礙，還可以通過展開進度條來查看當前階段下更應關注的訊息與一些溫馨提示。<br>通過機會小組相關列表，可以將該條機會數據共用給其他本無查看權限的人員，方便協同工作。<br>在機會下的聯絡人角色相關列表上，快速為對應客戶中的聯絡人添加機會中的角色，再通過關係網，查看相關的聯絡人上下級關係，同時通過雷達圖評估聯絡人在當前機會下的價值，追蹤跟進情況，定位關鍵人物，查看聯絡人的。角色、拜訪狀態、關係程度、購買風格與拜訪次數<br>通過機會產品相關列表，可以為該機會添加同一價格手冊中的產品，並編輯產品的售價、個數。`,
"label.sso.ssoKeyMan":`單點登錄密鑰管理`,
"label.forecast.edit.desc":`設置某使用者在以下期間的定額`,
"label.weixin.newspaper.coverage.time":`保險時間`,
"label.pleaseselectpro":`請選擇產品`,
"label.bottonandlink":`按鈕和連結`,
"label.donot.know.error":`發生未知的錯誤，請聯繫管理員處理`,
"label.account_noordab":`您的帳號有0個自訂報表，2個儀表板。`,
"label.partnerCloud.orderingPlatform.toPay":`帳戶支付`,
"label.many.dayline.nextday":`後一天`,
"lable.showmorerecords":`顯示更多記錄`,
"front-lightning-module-v1-details-page-chart-record-type":`請選擇記錄類型`,
"label.ccpeak.query.record":`查詢記錄：`,
"pagecreator.systemstyle.message.save.fail":`樣式儲存失敗`,
"label.weixin.share.file":`分享文件`,
"errormessage.email.relatedorreceivermusthaveone.z":`收件人和相關項至少選擇一項`,
"chatter.save.f":`儲存失敗`,
"button.partner.create":`建立`,
"label.marketseamemset.lead.title2":`請設定影響所有成員擁有商機的數量上限，限制與公海池無關`,
"label.service.major.event.new":`建立重大事件`,
"label.version.custom.site":`自訂網站`,
"label.permission.visualpagepermission":`分配的自訂頁面`,
"lable.product.zongjia":`總價`,
"label.viewchart":`查看圖表`,
"label.alaska.daylight.time":`阿拉斯加夏令時`,
"front-kefu-moudle-v1-rgdyhcwzx-reply":`讓更多使用者成為工作人員以服務更多連接者，提高客服滿意度。`,
"component_assistant_label_todaylead":`今天指派給您的商機`,
"label.sendemail.chat.addComentsfavorite":`尊敬的#name:\n\n ;您好！ #userName回覆了您收藏的微貼。`,
"label.smstemplate.tip":`以下列出了選定文件夾中的所有簡訊範本。 單擊建立"按鈕可以建立新的文本或HTML簡訊範本。您可以在發送簡訊時使用這些簡訊範本。單擊角色連結可查看更詳盡的訊息"`,
"label.documentname":`文檔名稱`,
"label.icon.162":`風景`,
"label.salescloud.wanyuan":`元`,
"label.view.desc1":`記錄類型欄位，選項列表欄位和選項列表（多選）欄位，建議最多輸入10個關鍵字，用英文逗號隔開實現或關係，如：“北京,上海,廣州”。`,
"label.searchlayout.lookup.newfield":`在“查找”對話框中點擊新建按鈕顯示的欄位。`,
"label.emailobject.bcc":`密 送：`,
"label.manageAll.pagenum1":`當前已經是第一頁了`,
"vue_label_appstore_crm_used_companies":`上市公司都在用的crm`,
"label.document.replace":`取代`,
"label.assignment.setup.newrule.title":`新建個案分配規則`,
"component.chatter.label.mygroup":`我的小組`,
"lable.currencyAdv.exchangedate":`日期範圍`,
"label.quickbooks.button.viewinqb":`在QuickBooks查看`,
"UG.homepage.004":`自動化`,
"label.currencyName":`幣種名稱`,
"Homepage_News_001":`新聞`,
"front-lightning-module-v1-details-page-chart-refresh-button":`顯示重新整理按鈕`,
"label.list.projectSetting.isenable":`啟用項目定時器(包括：里程碑、工作、子工作、問題)`,
"setup.layout.message.relatedlistbutton":`選擇在相關列表上顯示的標準按鈕。`,
"vue_label_homepage_homepageassignment":`應用程式主頁指派`,
"label.pending":`待處理`,
"component.timeline.label.today":`今天`,
"front-kefu-moudle-free-hasexpire":``,
"homepage.layout.customlayout":`自訂主頁配置`,
"label.service.miniProgram.content":`請填寫內容`,
"label.defaultline.must.int":`預設行數隻能是正整數`,
"label.mirror_issues":`如果表單不能反映您所檢視內容，請閱讀關於如何排除常見顯示問題的幫助文章。`,
"label.edit.select.two":`單選框列表`,
"label.emailmerge.mergeFolder.tip":`合併範本需要一定的時間,在合併過程中,請不要單擊其他連結或關閉您的Web瀏覽器或刷新頁面!`,
"label.ServiceCloud.zichan.distributionMap":`資產分佈圖`,
"label.selectfile":`選擇檔`,
"vue_label_account_equitymanage":`管理股權關係`,
"label.email.clearAll":`清空所有`,
"label.selecting.parent.assets":`選擇父資產`,
"component.setup.tabs.label.delete":`刪除`,
"label.visualpage.top.must.is":`頁面頭第一行必須是：`,
"label.SalesCommitmentDashboard":`銷售承諾儀表板`,
"chatter.group.changeTheRole":`更改角色`,
"label.dataimport.insertdata.error":`插入新數據發生錯誤，請仔細檢查本條數據`,
"label.partner":`夥伴雲`,
"label.process.async.execute.tip":`您的審批操作已經進入處理佇列，請稍後，若審批失敗，會郵件通知您。`,
"label.service.newBuildDialog.additional.conditions":`附加條件`,
"label.name_copy":`您將複製本表單。請命名表單副本。`,
"label.integrations.install":`授權`,
"label.edit.ccpeakfolder.time":`定時類：編輯檔夾`,
"label.knowledgebase.filing.time":`歸檔時間`,
"vue_label_chatter_success_exit_group":`退出小組成功`,
"font.market.module.v1.save.name":`請填寫會議名稱`,
"label.a.b.without":`A" 記錄可能有或沒有相關 "B" 記錄。"`,
"label.chat.topic.desc":`描述`,
"label.field.editoptionlist.introduce":`在下邊輸入選項列表值的名稱， 選取此複選框，以使用此值作為預設值`,
"label.versiontype.Enterprise":`企業版`,
"message.selectrulecondition":`請指定規則條件！`,
"label.custombutton.unknown.operation":`未知的操作`,
"label.pricecannotnull":`價格不能為空`,
"component_salesperformance_label_target":`目標`,
"pagecreator.page.message.delete.success":`頁面刪除成功`,
"label.help.new.features":`新功能操作指南`,
"label.weixin.vehicle.owner.information":`車主訊息`,
"label.exchange.sync.state.user.info":`檢查使用者的同步狀態，確保使用者記錄在 Exhange 和 CloudCC 之間同步。如果使用者在 Exchange 和 CloudCC 之間同步時遇到問題，您可以重置使用者的同步過程。重置可清理僅 CloudCC for Exchange 使用的訊息，且不會從您的 Microsoft Exchange 伺服器或 CloudCC 中刪除數據。`,
"label.batcheditor":`批次編輯`,
"report.label.knowcreatehighlevelreport":`瞭解進階報表製作`,
"label.dataimport.title.length":`標題的長度是`,
"label_model_description":`模型描述`,
"label.tabpage.ctbtsftcz":`點擊後面搜尋選擇內容`,
"label.channel.activity.member.owner":`通路活動成員擁有者`,
"label.ems.serverinfo":`伺服器訊息`,
"tjinvilid":`條件不合`,
"label.nameofreport":`報表名`,
"label.ifapproverreject":`如果審批者拒絕此請求會怎樣？`,
"label.wtd.changefields.title.desc2":`如果需要移動端 web to cloudcc 的記錄關聯商機，則需要在當前物件上建立查找商機的欄位，且欄位API為lead_wtd"。"`,
"label_emailsync_form_connecttime":`關聯時間`,
"label.visualpage":`自訂頁面`,
"label.customlink":`自訂連結`,
"label.lead.score.doing.remark":`已處理您的請求，商機評分需要一定的時間，系統在處理完成後將會發信通知您。`,
"label.h5.act.details":`活動詳情`,
"label.profile.setrecordtype":`記錄類型設置`,
"label.processsetting.process.enabled.successfully":`啟用進程成功！`,
"label.campaign.url.overtime":`該連結已過期`,
"label.structureChart.notFiled":`未填寫`,
"label.h5.chatter.something":`您是不是要說點什麼`,
"label.pm":`下午`,
"template.chart.rwlx":`工作類型`,
"label.icon.42":`雲`,
"label.project.hit.one":`子工作指派通知`,
"label.martrixreport.2018.step3":`步驟3：選擇報表列`,
"label.wtd.changefields.newmo":`產生行動版頁面`,
"label.downloadTheTemplate":`下載範本`,
"label_chatter_assignPerson":`被指派人`,
"label_emailtocloudcc_license":`使用者許可`,
"label.willdeletedlayout":`要刪除的頁面配置`,
"label.projectManagement.delete.question":``,
"lable_setup_mobilesetup_isEnableValidationRulesForScan":`名片掃描是否啟用驗證規則`,
"label.salescloud.opportunity.addandedit.contactrole.note":`?注意：雙擊空白聯絡人，可以新增一條空白記錄`,
"label.step6.total6":`第6步，共6步`,
"label.knowledge.setting.hint.one":`Knowledge允許客戶和客服人員充分利用豐富翔實的Knowledge文章。`,
"label.usefieldautoassign":`使用標準或自訂階層架構欄位自動分配審批者：`,
"label.partnerCloud.orderingPlatform.orderAmount":`訂單金額：`,
"chatter.fieldtrack.operateupdate":`已更改一條`,
"chatter.del.com":`刪除此評論`,
"report.reportdatasource.label":`報表數據源`,
"label.text":`文本`,
"label.marketsea.select.member":`可選成員`,
"label.typeofreceivers":`收件人類型`,
"label.knowledgebase.affect.existing.translations":`是，我的更改會影響現有翻譯。標記為“過期”。`,
"label.marketing.invitationmail":`歡迎您參加我們的活動，您的邀請函連結為：`,
"label.version.quotation.management":`報價管理`,
"label.dataimport.insertdata.error.unique":`插入新數據時，$fieldName$違反了唯一性約束`,
"label.emailmerge.list.newtemplate":`新建範本`,
"label.salescloud.salescloud.allteam":`?機會上的所有小組`,
"vue_label_commonobjects_detail_record_changes":`欄位記錄變更`,
"label.file.delete.info":`刪除文件`,
"vue_label_calendar_name":`日曆名稱`,
"label.version.support":`支援`,
"label.event":`事件`,
"label.searchlayout.lookup.searchdialog":`在“查找”欄位上點擊查找連結彈出的“查找”對話框。`,
"label.data.downpage.e_list.desc2":`匯出數據成功後，您會收到一封郵件，提醒您匯出數據成功。`,
"label.partnerCloud.productSet.delIsTrue":`確認刪除該條產品?`,
"label.tianyancha.businessverify.msg2":`本《協議》是您（下稱“使用者”）與CloudCC 之間關於使用工商數據驗證功能所訂立的協議。本《協議》描述CloudCC 與使用者之間關於工商數據驗證功能的使用及服務相關方面的權利義務，本《協議》可由Cloud CC隨時更新，更新後的協議條款一旦公佈即代替原來的協議條款，恕不再另行通知。`,
"label.customobjects.cancleselectallfield":`取消選擇全部欄位`,
"image.up.maxsize":`上傳的文件過大,請不要超過2M。`,
"label.icon.8":`檔案`,
"label.donot.delete":`您沒有刪除權限！`,
"label.version.profile.and.layoutpage":`設定檔和版面配置`,
"chatter.coll.s":`停止收藏此帖子`,
"label.icon.163":`地球`,
"label_chatter_myfollowers":`我的追蹤者`,
"label.multilang.customforecast.refuse":`拒絕{0}的任何預測優先,但是接受其他下屬的預測優先`,
"label.tabpage.findz":`查找`,
"label.smstemplate.detailinfo":`簡訊範本詳細訊息`,
"label.knowledge.setting.hint.nineteen":`開始吧`,
"label.mr.tip":`請把第{0}行的規則填寫完整.`,
"label.icon.132":`保障`,
"label.customobjects.track.introduce2":`“欄位追蹤”相關列表中追蹤的欄位。無論何時使用者修改以下所選的任何欄位，舊欄位值和新欄位值，以及日期、時間、更改特性和進行更改的使用者都將添加到“欄位追蹤”相關列表中`,
"label_emailtocloudcc_redmessage5":`狀態未知，請聯繫管理員`,
"label.must.select.field":`行條件錯誤，必須選擇一個欄位！`,
"label.tag.manage.modifiedby":`最後修改人`,
"label.translation.start1":`選擇一種語言（若您是多種語言的譯員）。`,
"label.ccchat.topic.searchs":`搜尋主題`,
"label.mask.custom.example":`{AAAA}{****}{AAAA} 表示從第5個字元到第8個字元進行加密顯示`,
"setup_object_field_dependency_label_addtolist":`添加選中值`,
"label.view.total.record":`共計選中0條記錄`,
"label.service.without.right":`沒有關聯權利`,
"template.chart.wxqzkhyy":`無效商機原因`,
"vue_label_dashboard_pleaseenterabreakpoint1value":`請輸入斷點1值`,
"message.pleaseinputmouthdistance":`請正確填寫間隔月`,
"label.forgetPsd.tip":`忘記密碼，聯繫管理員`,
"label.projectManagement.planned":`已計劃`,
"lable.Product.conversion.asset.operation":`產品轉換資產操作`,
"label.search_forms":`搜尋表單`,
"label.sendemail.chat.addPostmainPagesubject":`CloudCC CCChat 主頁留言`,
"label_tabpage_viewNamez":`請輸入視圖名稱`,
"label_chatter_addresser":`發件人`,
"Opportunity_Detailed_Phase_Change_Text_001":`更改機會階段`,
"label.what":`第`,
"vue_label_systemSettings_set_android":``,
"label.sell":`銷售`,
"template.report.folder.case":`個案分析`,
"label.customfields.profilefieldsafety":`設定檔的欄位級安全性`,
"label.industrialandcommercialverification.label.token":`Token`,
"label.finished":`已完成`,
"label.sendmail.step3.introduce1":`當前已選取`,
"vue_label_calendar_other_calendars":`其他日曆`,
"label.donot.know.validate.field":`未知的校驗欄位`,
"label.exportdetail":`匯出詳細訊息`,
"label.step.filter":`指定篩選條件`,
"label.campaignmember.main.hasMember":`現有成員`,
"label.updown.suess":`下載成功`,
"label.ems.browse":`查找`,
"front-email-payment-Invoice-login-account-describe":``,
"label.copyCustomReportType":`複製自訂報表類型`,
"label.visualpage.write.class":`在頁面中編寫Class代碼，代碼的語法與Java相同`,
"label.setsharerule.tip":``,
"label.report.action.addtodashboard9":`儀表板列表頁`,
"label.cloudccsite.remark":`站點描述`,
"label_tabpage_noz":`否`,
"chatter.up.limit":`上傳的文件過大,請不要超過`,
"label.leadmarketsea.grouplist.title":`商機公海池分組設定`,
"label.pc.user.help":`使用者指南`,
"label.partnerCloud.orderingPlatform.relyOn":`依賴`,
"label.appointmentpage.wizard.subtitle2":`選擇時間`,
"label.deleteoneormore":`刪除一個或多個`,
"january":`一月`,
"label.delete.profile":`刪除設定檔`,
"label.appointment.wizard.subtitle1-7":`2小時`,
"label.icon.188":`化妝品`,
"vue_label_file_already_in_lib":`已存在於此文件庫中`,
"label.icon.151":`VR`,
"label.withvalue":`按值`,
"label.tianyancha.businseeverify.opererror":`開啟工商數據失敗,請重新嘗試或聯繫系統管理員！`,
"label.tabpage.individual":`單項選擇`,
"label.layout.editdistribute":`編輯版面配置分配`,
"label.smstemplate.lookup":`查看簡訊範本`,
"pagecreator.systemstyle.button.delete":`刪除樣式`,
"label.customer.tab.step2.same.option1":`預設打開`,
"label.knowledgebase.no.results.knowledge":`Knowledge 中沒有""的結果`,
"label.data.exp.newtemporexp":`選擇資料匯出方式或製作範本`,
"vue_label_chatter_refuse_join":`拒絕加入`,
"Homepage.News.002":`當前新聞組件服務不可用`,
"label.log.requesttype":`請求方式`,
"vue_label_dashboard_generatefromreport":`從報表產生`,
"label.knowledge.create.version":`建立版本`,
"label.emailtocloudcc.description2":`關聯您的企業信箱`,
"label.partnerCloud.partnerAccount.recharge":`儲值金額要在0.1到 {upperlimit} 之間`,
"label.customobjects":`自訂物件`,
"label.schedulableprg.endtime":`結束日期必須大於系統當前日期`,
"message.error.viewreport.confirmdelete":`存在使用當前視圖/報表作為數據源的圖表，是否連同圖表一起刪除`,
"label.marketing.social.seting":`社交媒體設定`,
"chatter.follow.stop":`停止追蹤該使用者`,
"label.notification.arketsea.return":`{5}將{0}：{1}退回至{2}`,
"label.conditionsofnextapprover":`您所選擇的審批請求中有一個或多個要求指定下一個審批者。使用下面的查找框指定下一個審批者。`,
"label.partner.all.state":`狀態`,
"mobel_web_closed":`已關閉`,
"label.icon.65":`器材`,
"label.stdashbord.xsld.business.jinehj":`金額合計`,
"label.selectobject":`選擇物件`,
"label.account.CurrentFQ":`當前會計季度`,
"label.workflow.estimaterule":`評估規則`,
"label.list.userinterface.shownewrecordssetup":`最新記錄設置`,
"label.tianyancha.businessverify.msg3":`一：費用：`,
"label.weixin..xsld.jieduan":`階段`,
"label.first.quarter":`第一季度`,
"Opportunity.Detailed.Phase.Label.002":`當前狀態已停留{0}天`,
"label_tabpage_page":`頁`,
"label_emailsync_status_time":`時間`,
"label.pleaseselectaapprover":`請選擇一個審批者`,
"label.emailtocloudcc.redmessage5":`狀態未知，請聯繫管理員`,
"label.four.quarter":`第四季度`,
"label_chatter_relateList":`相關列表`,
"label.customfields.new.step2.opration.exid.info":`將此欄位設置為針對外部系統的唯一記錄標識符`,
"label.projectManagement.nodata.overdue.tasks":`太棒了，沒有逾期的工作`,
"label.sendemail.activity.task.statuscompleted":`尊敬的#createbyidccname您好：\r\n 你於#createdate指派給#belongtoidccname工作，工作具體訊息如下：\r\n 主題：#subject\r\n 到期日期：#expireDate\r\n 相關項：#relatedstr\r\n 內容：#remark\r\n 具體詳情，請存取此連結：\r\n #path\r\n #belongtoidccname已標識為完成，請知曉。 \r\n #orgNameCRM系統`,
"label.sso.saml.idp.config.issuer":`頒發人`,
"label.cannot.delete":`條）不允許刪除`,
"label.pigeonhole.sel_f":`選擇要歸檔的文件夾`,
"label.customfields.text.tip":`允許使用者輸入任何字母和數字組合。`,
"message.error.user.service.common":`操作失敗，聯繫系統管理員獲取支援！`,
"label.datamanage.account.information":`客戶訊息`,
"vue_label_homepage_deleteprofilepage":`刪除設定檔主頁`,
"label.sendmail.step3.introduce3":`位收件人接收此簡訊。`,
"label.pc.ui.2018.recentitem":`最近項目`,
"label.report.loading":`拼命連線中`,
"vue_label_globalsearch_adjustment":`調整方式`,
"label_report_line_yixuan":`已選報表列`,
"label.h5.similar.opportunity.only.view":`只顯示`,
"label.marketactivitymember":`市場活動成員`,
"label.recycle.execute.tip":`已處理您的請求，清空回收桶需要一定的時間，系統在處理完成後將會發郵件告知您。`,
"label.permission.detail.system.setting":`系統權限設置`,
"label.RecordType":`記錄類型`,
"label.custom.error.between":`自訂年度開始日期或自訂年度結束日期在歷史自訂年度時間段內，請檢查後重新設定！`,
"vue_label_dashboard_selectview":`選擇視圖`,
"label.tianyancha.businessverify.cancel":`取消啟用工商數據驗證`,
"label.partnerCloud.financeSetting.MD5":`MD5密鑰`,
"label.multilang.messagedetail.new.error":`我們找不到任何姓名帶有{0}的Chat使用者：`,
"label.callcenter.pleaseenter.private.key":``,
"label.umeng.activity.youdistribute":`您指派給`,
"label.weixin.nickname":`暱稱`,
"label.customerinfo.mailusername":`發件郵箱用戶名`,
"label.partnerCloud.orderingPlatform.discountPlan":`折扣計劃名稱：`,
"lable.account.year":`會計年度`,
"T":`時間`,
"System.Email.Template.Title":`歡迎您使用CloudCC CRM平臺`,
"label.login.type":`登錄類型`,
"label.notification.evaluation":`{0}在個案{1}留下了{2}的評價`,
"label.turntolist":`轉至列表`,
"label.sort":`排序`,
"vue_label_commonobject_notice_clickcross":`如果需要取代已上傳的文件，請點擊【X】按鈕後重新上傳`,
"label.Select.maximumecords.operate":`最多選擇200條記錄進行操作`,
"label.submission_rate":`送出率`,
"label.datadelete.record.sucessfully":`條記錄刪除成功！`,
"label.version.standard.dashboard":`儀表板`,
"label.task.postunsolve":`逾期未完成任務`,
"label.Receivables.name":`收款計劃名稱`,
"label_tabpage_noOperationz":`此內容為固定項，不可操作！`,
"label.attendance.onrecord":`至少選擇一條記錄`,
"label.partner.error2":`錯誤：域名只能由英文或數字組成`,
"label.account.map":`客戶地圖`,
"label.dashboardSetup.reference.legend":`參考圖例`,
"label.Yaxisscope":`Y 軸範圍`,
"label.hierarchy.tree.tip":`基於在每個選項卡裏的自查找欄位中選擇一條記錄建立的階層級架構圖表。階層架構顯示如下：`,
"label.permission.objlist.columnsize":`總欄位數`,
"label.setup.mobile.bottombutton.savesuccess":`行動端一級頁面設定儲存成功`,
"label.mobile.side.tab.selected":`已選取`,
"label.partner.donotdel.cause":`的刪除操作，因為它與以下合作夥伴使用者相關聯`,
"label.ccchat.message.new.error4":`提示：`,
"vue_label_systemSettings_setorganization":`設定組織應用程式，為各職能人群設定不同應用程式選單`,
"label.umeng.approval.approvalmes4obj1":`請您即時審批。`,
"UG_opportunity_010":`建立一個交易`,
"label.tag.addtags.public":`公用`,
"System.TAB.SeeViewPageAmount":`查看頁數`,
"label.filterconditions":`篩選條件`,
"front-personalEmailBox-module-v12-clear-not-associated":`取消關聯將會清空該信箱中所有未關聯相關項的郵件，是否確認取消關聯`,
"label.assign":`指派`,
"label.layout.clone.tip":`可選擇一個現有配置進行複製`,
"label.choose.relatedlist":`選擇要轉移的相關列表`,
"label_chatter_recordcall":`已記錄呼叫`,
"label.product.proofOne":`請在{0}處，最多選擇{1}個產品選項。`,
"label.layout.availablefield.relatedlist":`可用欄位/相關列表`,
"label.campaignmember.main.updateleadstatus":`更新狀態-現有商機`,
"label.custom.buttonandlink":`自訂按鈕或連結`,
"label.view.manage":`視圖管理`,
"label.search.exp":`選擇您希望為其啟用以下功能的物件並單擊“儲存”:`,
"vue_label_appstore_apply_to":`適用於`,
"label.dashboard.message.refreshfail":`儀表板重新整理失敗`,
"UG_Case_02":`個案可讓您響應並解決客戶問題。個案在 Cloud CC中是功能強大的記錄，不僅可以追蹤客戶問題，而且也可以顯示完整的客戶視圖。`,
"label.project.hit.three":`每天子工作提醒`,
"label.tianyancha.businessverify.tip":`勾選了啟用工商數據驗證，使用者輸入企業客戶資料時，可協助使用者輸入正確的客戶工商註冊訊息。`,
"label_emailsync_status_disconnect":`取消關聯`,
"label.rule.disabled.successfully":`規則禁用成功`,
"label.custombutton.queryerror":`查詢失敗，請重新操作`,
"label.customfields.deletecannotresume":`對應的數據將被永久性的刪除，不能恢復，請謹慎操作。`,
"label.account.current.M":`本月`,
"label.under.approve.data":`正在審批的記錄（`,
"vue_label_title_remainingdays":`剩餘天數`,
"label.partnerCloud.orderingPlatform.refundable":`本單可用回饋金`,
"label.lookup.iscover":`編輯是否允許同步`,
"label.recordtype.detail.selectlist":`可用於編輯的選項列表`,
"label.sso.isActiveYes":`是`,
"label.service.appointmentList.canceltheSuccess":`取消成功`,
"label.escalation.setup.newentries.createfirst":`根據建立個案的時間，並在首次修改個案後禁用`,
"label.new.ccpeakfolder":`類：新建檔夾`,
"lable.currencyAdv.exchagecurrency.after":`之後`,
"label.majoranddetailrelation":`主-詳細訊息關係`,
"label.appointment.wizard.subtitle4-2-1":`1小時`,
"label.projectManagement.working.hours":`工作時間`,
"label.forecast.customforecast.button.forehistory":`預測歷史`,
"label.mymasterplate":`我的範本`,
"component.setup.tabs.label.memo":`設定Tab標籤名稱`,
"label.customfields.longtextarea.tip":`允許使用者輸入多行文本，最多可輸入 32000 個字元,並且每個物件最多只支援10個此類型的欄位。`,
"label.service.miniProgram.fillJumpLink":`請填寫跳轉連結`,
"label.british.summer.time":`格林威治時間`,
"label.nogreate":`<`,
"label.assignment.setup.detail.sameuser":`相同使用者`,
"mesage.error.profile.delate.user":`無法刪除設定檔，因為當前為設定檔分配了使用者。`,
"label.tabpage.cownerz":`更改擁有者`,
"label.multilang.dupicatecheck.processedcount":`重複數據,已處理{0}組,還剩餘{1}組數據未處理。`,
"vue_label_report_notice_leavecertification":`您是否確認離開此頁面-您輸入的數據可能不會被儲存`,
"label.master.required":`從記錄有必填項未填`,
"label.chatter.follow":`關注`,
"label.dataimport.insertdata.error.repeat":`該記錄和原數據庫中數據重複，該記錄已忽略匯入。`,
"label.sms.cgid":`通道組編號`,
"label.knowledge.article.rator":`由於衝突我們無法歸檔一篇文章。`,
"label.datamanage.object.field":`物件欄位`,
"label.forecast.editshrepage.quanxian":`共享權限存取級別`,
"label.weixin.interactive.log":`交互式日誌`,
"label.batchedit.remark":`可以對多條記錄進行編輯`,
"label.user.permissions.message":`沒有權限設置使用者訊息。`,
"label.mobile.phone.month":`月份`,
"chatter.sel.u":`選擇要@的人或直接輸入@[用戶名]`,
"label.service.gantt.assigned.work":`被分配工作`,
"UG_ST_001":`提示`,
"label.edit.select.one":`下拉列表`,
"label.forecast.shrepage.desc0":`此頁面將列出對{0}具有共享存取的使用者、角色及區域。`,
"label.multilingual.confirm.close":`是否確認禁用，禁用後將無法使用多語種，使用者語種將被修改為公司預設語種。`,
"label.setting.intergrationlist.integration":`集成`,
"label.leadscore.rule.list":`商機評分規則列表`,
"component_telerecord_button_save":`儲存`,
"label.weixin.save.log":`儲存日誌`,
"label.validate.function.funcExplain.DAY":`返回一個月中的某一天，是 1 與 31 之間的一個數字`,
"label.appointmentdetail.wizard.title1":`會議名稱`,
"label.multilang.feedtrack.dealkey":`將{0}從{1}更改至{2}：`,
"label.optional.features":`可選功能`,
"vue_label_email_no_email":`無電子信箱`,
"label.sendemail.chat.messagecontent":`消息的內容：`,
"label.tabpage.lessequalz":`小於或等於`,
"setup.layout.label.setupfield":`設定欄位屬性`,
"label.approved.receiveApprovalEmail.option1":`如果我是審批者或委派審批者`,
"label.chatter.relateList":`相關列表`,
"component.sendmail.label.fromuser":`發件人`,
"label.projectManagement.problem.status":`問題狀態`,
"label.weixin.fmu.before.hour":`提前 {0} 小時`,
"chatter.feed.menutype.feed.mark":`我收藏的微貼`,
"label.addQuoteLineGroup":`添加報價行組`,
"label.report.action.addtodashboard6":`添加`,
"label.url":`URL路徑`,
"lable.account.CurrentandPreviousCQ":`當前和上一個日曆季度`,
"label.tabpage.emptyz":`清空`,
"less":`小於`,
"label.h5.selectmostphotos":`最多只能選擇9張照片`,
"UG.activity.04":`Outlook/Gmail信箱 記錄郵件`,
"template.chart.qbhtje":`全部合約金額`,
"label.tabpage.endz":`結束`,
"label.partner.workspace.member":`成員`,
"label.filter.error.filedvaluetoolong":`錯誤：欄位值超出最大限制。`,
"label.months":`月的`,
"button.partner.workspace.disable":`取消啟用`,
"label.visualpage.checkpinyin.grammar":`請檢查拼寫語法。`,
"label.dashboardSetup.geshihua":`格式化`,
"label.belongto":`屬於`,
"label.upload.cannot.empty":`上傳文檔不能為空！`,
"label.number.MaxCheck":`{0}最大數量為{1}，請修改數量後再點選儲存。`,
"pagecreator.page.message.save.fail":`頁面儲存失敗`,
"label.edit.SMS":`編輯簡訊通知`,
"UG_Lead_002":`有很多方法可以為您的產品或服務識別“商機”。`,
"label.quickcreate.active.quickcreate":`啟用快速新建`,
"label.recordtypeselect.tip":`若要在將來跳過此頁，請在個人設置頁上更改記錄類型設置。`,
"label.form_content":`表單內容`,
"workflow.action.tasks.assignortype.related":`相關使用者`,
"vue_label_allsearch_set_more_items":`您可以在搜尋框左側的下拉框中設定更多的搜尋項來繼續查找`,
"label.tianyancha.businessverify.title":`工商驗證`,
"label.errormessage.batchedit.norecord":`沒有數據。`,
"label.permission.appname":`應用程式名稱`,
"label.report.action.addtodashboard7":`取消`,
"label.generated.transfer.product":`轉資產時根據產品上“資產轉換”的方式產生資產。`,
"vue_label_commonobjects_detail_you":`您`,
"label.user.captcha":`使用者驗證碼驗證`,
"label.notification.event4":`您指派給【被指派人】的事件即將在【開始時間】開始`,
"label.version.setup":`後臺設置`,
"setup.object.layout.message.selectedlayoutandrecordtype":`請選擇配置和記錄類型`,
"label.role.add":`添加角色`,
"label.versiontype.Unlimited":`無限版`,
"label.partnerCloud.financeSetting.developerID":`請輸入開發者ID`,
"front-invoice-online-payment-setup-global":``,
"vue_label_commonobjects_view_basis":`分類依據`,
"label.decimaldigits.tip":`小數點右邊的數字的位數`,
"vue_label_commonobjects_detail_selected":`標記為選中階段`,
"label.data.export.page":`進入資料匯出頁面`,
"message.error.serviceresource.servicecrewid":`每個服務班組只能被添加為一條班組類型的服務資源記錄`,
"label.loginttime.alltime":`所有時間均為`,
"label.requiredinfo":`必填訊息`,
"label.forecast.edit.di":`第`,
"vue_label_calendar_failed_to_remove_calendar":`移除日曆失敗`,
"pagecreator_systemstyle_button_delete":`刪除樣式`,
"label.import.page3.continueimport":`繼續匯入`,
"label.page.width":`整頁寬度`,
"label.campaignmember.selectmember.addmember":`中添加成員`,
"label.finalreject":`最終拒絕`,
"label.isend":`是否結束`,
"front-console-conversation":``,
"label.mr.theLastGroupOfThisPage":`這已經是此頁的最後一組。請點擊【返回查看重複數據列表】，查看重複數據。`,
"label.data.dataexpalltype.all_desc":`匯出當前使用者所有有權查看的物件的資料。`,
"label_emailtocloudcc_redmessage7":`後台配置錯誤，請聯繫管理員`,
"label.forecast.shrepage.classdes.all":`完全存取權限 - 使用者可以查看和覆蓋預測數據。使用者還可將共享存取權限擴展到其他使用者。`,
"market.contacts":`市場聯絡人`,
"label.weixin.polls.voter":`投票參與者列表`,
"template.report.industry.distribution.customers":`客戶的行業分佈`,
"front-electronic-signature-setup":``,
"vue_label_chatter_removecertification":`確定要移除小組成員"{name}"嗎`,
"label.appointment.wizard.subtitle1-2":`15分鐘`,
"label.sso.saml.idp.config.custattr":`自訂屬性`,
"label_tabpage_totalTeamz":`共有小組`,
"lable.outlook.detail.assigned":`已分配的使用者和設定檔`,
"label.department.user.delete":`刪除`,
"label.customcomponent.check.label.same":`標籤名已存在`,
"label.partner.error1":`錯誤：域名長度過長`,
"label.escalation.setup.entrydetail.escalation.notify":`通知`,
"component_todaytask_label_choicestate":`選擇狀態`,
"label.customfields.fielddependency.new.step1":`<b>步驟1：</b> 選擇一個控制欄位和一個相依欄位。完成時單擊“繼續”`,
"chatter.group.anyoneCanSeeTheUpdateAndJoin":`任何人可視並可申請加入這個小組`,
"label.custom.pixel":`像素`,
"label.quicksave":`快速儲存`,
"label.approved.persion":`委派的審批者`,
"lable.info.queue.member":`佇列成員`,
"label.addattachment.step2.weixin":`步驟 2.單擊“上傳檔”按鈕，上傳檔`,
"label.forecast.customforecast.title":`預測`,
"mainpage_setup_chosecomponent_leastone":`至少需一個組件放在主頁上。`,
"label.appointmentconfirmpage.wizard.title2":`關於本次預約的詳細日程已經發送到你的信箱`,
"label.useallselectedapprover":`要求所有選定審批者的 <strong>一致</strong>批准。`,
"label.ccpeak.current.line.return":`會從當前行返回，不再向下執行！`,
"label_new_target_model":`建立目標模型`,
"label.saving":`儲存中...`,
"label.mobile.phone.write":`寫`,
"label.applt.updown.text":`您也可以下載專屬於貴公司的小程式入口網頁二維碼，將二維碼放到網頁或公眾號文章內，客戶可以掃描二維碼使用小程式。`,
"label.partner.common.manageSetup":`夥伴雲管理設置`,
"label.quickbooks.new":`新建客戶`,
"message.error.color":`color不能為空！`,
"label.project.template.two":`每個物件的每個記錄類型下只能有一套配置！`,
"label.approval.input.des1":`逐級審批 ，最大層級為：`,
"label.x.axis.cannot.empty":`X軸不能為空！`,
"label.solomon.isiands.time":`所羅門群島時間`,
"label.login.access.duedate":`存取權限持續時間`,
"label.service.dispatch.booking.order":`指派服務預約`,
"label_shareme_forecast":`共用給我的預測`,
"label.custom.page.cuspage.height":`頁面高度（像素）`,
"label.quote.line.group.":`確定刪除{groupName}報價行組嗎？刪除後，該組內的報價行將會被一起刪除。`,
"label.data.downpage.i_title.num6":`建議您在匯入數據之前，先匯入一個包含5條記錄的測試文件，以確保所準備的匯入文件正確無誤。`,
"label.\u2019s":`的`,
"label.version.contact.management":`合約管理`,
"label.document.history.user":`使用者`,
"vue_labenl_commonobjects_opportunity_product_edit_notice1":`請輸入正確的金額數字，最多兩位小數。`,
"label.weixin.target.contract.jine":`目標合約金額`,
"lable.common":`共￥0`,
"front-kefu-moudle-sendemail-success":``,
"label.service.no.operation.time":`當前記錄沒有關聯操作時間！`,
"label.info":`訊息`,
"label.ccchat.zw":`中午`,
"label.assignment.setup.newentries.title":`編輯規則項目`,
"label.weixin.report.timeline":`時間軸`,
"UG.quota.04":`列印報價單`,
"label.social.user.exception":`social使用者訊息異常`,
"label.import.index.failed":`失敗`,
"label.common.settings":`通用設定`,
"label.nullvalue":`空值`,
"PageLayout_Search_MultiSearch_002":`搜尋欄位展開顯示（單欄位搜尋）`,
"message.myselfreport":`我的個人自訂報表`,
"label.productsales.today.noevttskaddtsk":`今天沒有未處理的事件或者到期的工作，您也可以點擊右上角的“ ”添加工作！`,
"lable.oppdt.noconditionrecrods":`沒有符合條件的記錄.`,
"label.campaignmember.selectmember.deletelead":`行銷活動：從商機中刪除成員`,
"label.marketingactivity":`市場活動`,
"vue_label_pool_self-built":`自建`,
"message.textareamaxlength":`長度不能超過4000`,
"label.valadate.must.value":`必須輸入一個值`,
"label.tabpage.groupsVisiblez":``,
"component.button.cancel":`取消`,
"label.emailobject.list.inbox":`收件匣`,
"label.app.step1.error.labelexist":`錯誤：標籤已存在`,
"front-calendar-V1-Unable-to-display":`因有大於等於一個記錄的結束欄位早於開始欄位，所以記錄無法在月曆中顯示。`,
"label.forecast.settings.prompt1":`必須至少選一個預測選項：收入或數量。`,
"front-kefu-moudle-callout-missphone":``,
"label.tabpage.editz":`編輯`,
"vue_label_chatter_label_new_team":`建立小組`,
"label.version.formulafield":`公式欄位`,
"label.partner.step1":`步驟1：選擇範本`,
"label.weixin.perfect.url":`完善訊息URL`,
"label.appointmentconfirmail.wizard.subtitle4":`描述`,
"label.step7.total7":`第7步，共7步`,
"setup.object.layout.label.selectedprofile":`已選設定檔`,
"label.payments.paytip5":`請輸入正確的數量`,
"label.visualpage.open.type":`為開放式自訂頁面類型`,
"lable.Sort.field.tips":`通過選擇要排序的欄位，自訂相關清單中的記錄順序。您可以按對象中的任何數字或日期欄位進行排序。`,
"label.nosharerules":`未指定共用規則。`,
"label.service.miniProgram.bindSetOwner":`設定個案擁有者`,
"report_label_highlevelreport":`高級報表可以幫您建立最多4個物件關聯的報表`,
"S":`文本`,
"label.lastmodifyby":`最後修改人`,
"label.customerinfo.mailaddress":`發件郵箱地址`,
"vue_label_pool_converted":`已轉換`,
"UG.ST.004":`您沒有數據管理-》數據匯入的權限，請聯繫管理員，點擊確定後直接進入{0}介面。`,
"label.view.application.mobile.terminal.filed":`此視圖已應用到移動端，欄位最多選10個，現已有`,
"chatter.feed.limitentity500":`您最多可以追蹤500個人員和記錄`,
"label.starttime":`開始時間`,
"chatter.emailToMe":`出現以下情況時發送CCChat提醒給我`,
"label.custom.Current.and.PreviousCQ":`當前和上一個自訂季度`,
"label.my.logout":`我的`,
"label.quickbooks.searchlist.enddate":`結束日期`,
"label.ccservice.validate.length":`物件API為{0}下的{1}欄位對應值為{2} 長度超出，請重新設定！`,
"label.integrations.installed":`已授權`,
"label.integrations.mailchimplist":`Mailchimp 列表`,
"label.checkfield.matchothers":`匹配其他記錄`,
"label.umeng.activity.event.distributewillbegin":`您指派給#name的事件#event即將在#time後開始`,
"pool.notice.gotolightning":`若需使用此功能，請前往Lightning版本。`,
"label.batchtransfer.pleaseselecttransferreddata":`請選擇需要轉移數據`,
"label.mr.title.mailingAddress":`郵寄地址`,
"vue_label_approve_no_response":`未響應`,
"component.event.label.title":`即將進行的事件`,
"label.mobile.setup.confirm":`您正在更改移動端的預設選項卡圖標的位置訊息，更改成功後所有以前在選項卡上的配置的移動端選項卡圖標都將被清除，除非您重新在選項卡上設置移動端圖標，否則系統預設從您設置的目錄裡面隨機選擇。`,
"label.tianyancha.approvaltime":`核准時間`,
"label.download_merge_file":`下載合併檔案`,
"label_display_quota":``,
"label.publishreadonly":`公用唯讀`,
"label.campagin.roi.query.roi":`市場活動ROI`,
"label.dashboardSetup.lookup":`查找儀表板`,
"vue_label_notificationcenter_nomessages":`沒有未讀通知`,
"label.create.object":`新建物件`,
"label.social.campaign.null":`行銷活動資訊不能為空`,
"label.console.step6.left":`固定到左側。列表始終可視。`,
"label.line":`列`,
"label.bottonandlink.introduce":`下面是按鈕和連結列表。要添加按鈕或連結，請編輯版面配置。<br/>按鈕可以顯示在詳細訊息頁、相關列表和列表視圖上：<br/>1.要自訂詳細訊息頁上的按鈕或連結，請編輯頁面配置。<br/>2.要自訂相關列表上的按鈕或連結，請在版面配置上相關列表出現的位置編輯相關列表的屬性。<br/>3.要自訂列表視圖上的按鈕或連結，請在“搜尋配置”中編輯列表視圖配置。<br/>`,
"label.layout.list1":`列表一`,
"label.mr.title.customerName":`客戶名稱`,
"label.user.text":`正文`,
"label.nolastestrecord":`暫無最新記錄`,
"label.emailobject.appointment.urltext1":`這裡是我的日程安排，請您`,
"label.chat.topic.my.favorites":`我的收藏夾`,
"label.select.dashboar.cd0":`分組欄位不能為空`,
"label.data.downpage.e_title.num2":`2、若選擇匯出單個物件的資料，則需要選擇資料匯出方式。資料匯出方式有：自訂匯出，按範本匯出，匯出範本。`,
"message.error.user.service.login.unconn":`伺服器錯誤，稍候`,
"label.escalation.setup.newentries.title":`編輯規則項目`,
"label.import.step1.above2000":`執行觸發器時，最多單次匯入2000條記錄。請拆分為多個文件，分次匯入。`,
"label.ccchat.person.allowinvite":`允許同事邀請`,
"label.input.number.between":`請輸入一個 {0} 和 {1} 之間的數字`,
"label.forecast.shrepage.wpfmanager":`委派的預測經理`,
"label_server_is_time_out":`伺服器超時，稍後再試。`,
"label.indochina.standard.time":`印度標準時間`,
"label.cpq.quote.sync.opportunity.failure":`只有主報價單才能和機會同步，請勾選主報價單複選框，再開始同步`,
"label.emailobject.send100emails":`非常抱歉，每天只能發送100封郵件，請重新選擇！`,
"label.dashboard.snapshot.end":`截止`,
"label.jiandangfenpei.rightlist":`已分配的設定檔`,
"label.input.string.length.between":`請輸入一個長度在 {0} 和 {1} 之間的字元串`,
"label.multilang.lookfiltercondition.select":`第{0}行條件錯誤,必須選擇一個欄位！`,
"label.datamanage.lead.namenull":`注意：如果沒有給“商機名稱”欄位賦值，記錄將不會被匯入！`,
"label.forecast.detailforecast.button.saveandfresh":`儲存並刷新`,
"label.venezuela.time":`委內瑞拉時間`,
"label.same.analyze.miaoshu1":`如果還需要更多規則，請使用“`,
"label.twomb":``,
"label.event.moveup.7hour":`提前 7 小時`,
"label.weixin.forgot.password":`忘記了密碼？`,
"label.import.page1.diledsizelimited":`2、上傳文件最大為100M`,
"label.file.foldername":`資料夾名稱`,
"label.multilingual.open":`多語言管理已啟用`,
"label.dashboard.snapshot.refresh.failed":`儀表板快照重新整理失敗`,
"label.marketsea.memberfieldselectone":`查看欄位與成員可查看欄位請至少選擇一個欄位`,
"label.trigger.createdate":`建立時間`,
"label.ccpeak.operation.sharetab":`操作共享表：`,
"label.partner.message.admin.access":`只有系統管理員可以登錄`,
"label.emailsync.status.email":`操作信箱`,
"chatter.error":`錯誤:請先選擇要上傳的文件!`,
"label.role.viewinlist":`以列表視圖顯示`,
"label.tag.addtags.title":`標籤`,
"setup.mainpage.label.welcome6":`使用者無需任何編程知識、無需代碼開發的情況下，便可在 CloudCC 系統的所有物件中都可以建立各種類型的欄位，欄位類型包括：查找關係、單項選擇欄位、雙項選擇、公式、自動編號、URL、電話、傳真、電子郵件、複選框、日期、時間、數字、文本、文本區、選項列表（單選/多選）、幣別等。`,
"label.delete.rule.successfully":`刪除規則成功`,
"label.field.duplicate.error.msg6":`欄位值重覆。已存在記錄：`,
"label.stdashbord.xsld.business.jhzsl":`機會總數量`,
"label.compact.layout":`關鍵訊息配置`,
"label.checkfield.merge.introduce":`請選擇要在合併後的記錄中保留的值。`,
"earlieststarttime.duedate.time.illegal":`服務預約的最早允許開始時間應小於等於到期日期。`,
"label.dataimport.validate.prompt":`驗證規則提示`,
"message.setuptip":`建立後，可刪除`,
"template.report.customer.collection.statistics":`客戶收款統計`,
"vue_label_homepage_dashboardcomponents":`編輯儀表板組件`,
"setup.mainpage.label.welcome30":`CloudCC 平臺是真正的雲計算平臺，平臺開放的屬性、標準的集成方式、靈活的定制適用於各行各業、整合第三方軟體，實現企業管理數據的即時統一，最大限度地滿足客戶全面深入的管理需要。 CloudCC 平臺能夠與任何企業應用程式或系統集成，包括SAP、金蝶、用友等第三方軟體。採用靈活的SOA架構下標準 Web Service方式，不存在任何破壞性、技術依賴或廠商鎖定。`,
"label.SMS.new.det":`建立一個簡訊通知 以關聯一個或多個工作流程規則、審批流程。 如果更改簡訊通知 ，任何修改都將應用到與之相關聯的所有規則、審批。`,
"lable.product.page.previous":`返回上一頁`,
"label.recordtype.labelname":`記錄類型標籤`,
"message.error.system.service.failure":`服務執行失敗，聯繫系統管理員！`,
"label.visualpagefolder":`頁面文件夾`,
"label.username":`使用者帳號`,
"label.data.downpage.i.title.num5":`5、請審核資料的準確性。`,
"label.permission.manage":`管理分配`,
"label_emailsync_status_user":`使用者`,
"label.weixin.voting.least.two":`投票選項至少有兩個`,
"label.tabpage.thisrecord":`此記錄`,
"label.icon.119":`黑板`,
"label.partner.common.webSit":`域名`,
"label.email.form.html2":`【切換為"僅文本"】`,
"label.appupload.upload.noversion":`無已上傳的版本`,
"label.appointmentpage.wizard.subtitle1_2":`邀請者的時區是{0}`,
"MR":`查找多選`,
"label.partnerCloud.orderingPlatform.availableBalance":`帳戶可用餘額`,
"label.schedulejob.setup.schedule.st3":`第三個`,
"label.reportsSubscriptionPage.email.general":`簡略`,
"label.setsharerule.step4":`第四步：選擇權限`,
"front-epwechat-module-v1-info-desc":`需要您從企業微信背景獲取並填入以下資訊`,
"message.duplication.label.isactive":`是否啟用`,
"pagecreator_systemstyle_label_linkcolor":`連結顏色`,
"label.import.page1.alertfiledsize":`上傳文件大小不能超過100MB!`,
"tomorrow":`明天`,
"label.publicdashboard":`未歸檔公用儀表板`,
"label.knowledgebase.same.taborworkspace":`相同頁籤或工作區`,
"homepage.layout":`主頁配置`,
"label.emailobject.trackemailopening":`郵件追蹤`,
"label.unlock.tip":`取消鎖定可以進行編輯`,
"lable.account.NextzDays":`未來90天`,
"vue_label_report_throw":`丟棄`,
"label.icon.102":`日程`,
"label.payments.paytip2":`您已升級為付費版，點擊確定將關閉該視窗並重新整理您的CRM系統。`,
"label.customfields.email.tip":`允許使用者輸入電子郵件地址，對其進行驗證以確保格式正確。如果對於一個聯絡人和商機指定了此欄位，則使用者單擊“發送電子郵件”時可以選擇地址。注意，自訂電子郵件地址無法用於批次電子郵件。`,
"label.test_visitors":`測試連接者檢視表單時的展示樣式`,
"label.workflow.immediatelyoperate":`即時工作流程操作`,
"label.approvalstep4.tip":`批准頁面是審批者實際批准或拒絕請求的地方。使用下面的選項，選擇要在此頁面上顯示的欄位。`,
"label.ccchat.person.invite.failsend":`以下邀請發送失敗，請聯絡管理員。`,
"label.import.index.obj":`物件`,
"label.multilang.leadscore.countnum":`{0}次：`,
"label.report.error.typefind":`通過分組訊息沒有找到報表類型`,
"label.validate.function.funcFormat.SUBSTITUTE":`SUBSTITUTE(text, old_text, new_text)`,
"label_tabpage_unpacketz":`無可用分組數據！`,
"lable.Create.new.template":`建立新服務報表模版`,
"label.knowledgebase.display.error":`顯示{a}個錯誤`,
"label.emailobject.template.message2":`當前郵件正文中插入的欄位與已關聯的記錄不相符，可能會造成取值失敗。`,
"label.productsales.today.taskcomplete":`設置為完成`,
"label.emailobject.selectone":`請至少選擇一條記錄作為郵件的收件人`,
"button_partner_workspace_saveas_memo":`將當前夥伴雲另存為“範本”。`,
"vue_label_help_detail":`記錄詳情`,
"label.tabpage.minutesagoz":`分鐘前`,
"label_tabpage_characterz":`起始字元`,
"message.error.accesstoken.null":``,
"label.textMessageObject.send100":`非常抱歉，每天只能發送100封簡訊，請重新選擇！`,
"vue_label_commonobjects_detail_record_call":`建立記錄電話`,
"label.campaignmember.main.addlead":`添加成員-現有商機`,
"setup_mainpage_label_welcome30":`CloudCC 平台是真正的雲計算平台，平台開放的屬性、標準的集成方式、靈活的訂製適用於各行各業、整合第三方軟體，實現企業管理數據的即時統一，最大限度地滿足客戶全面深入的管理需要。 CloudCC 平台能夠與任何企業應用程式或系統集成，包括SAP、金蝶、用友等第三方軟體。採用靈活的SOA架構下標準 Web Service方式，不存在任何破壞性、技術依賴或廠商鎖定。`,
"label.file.library.deleteprompt":`刪除文檔庫成員{0} ？`,
"label.wtd.changefields.title":`Web to CloudCC 設置`,
"label.sendmail.step1":`步驟 1：指定要包括的收件人`,
"label.cpq.newquote.createorder.checkbox.selected":`建立報價單時建立訂單複選框不能勾選`,
"label.emailtocloudcc.name":`名稱`,
"message.error.object.nullbinding":`binding為空`,
"B":`複選框`,
"label.pc.endtime":`您的許可證距離到期已經不足30天了,為了不耽誤您的正常使用請及時續費。`,
"label.visualpage.section.start":`在起始處以標籤`,
"label.partnerCloud.basicSetting.available":`網域名可用`,
"label.data.exportall.all_desc":`匯出當前使用者所有有權查看的物件的資料。`,
"label.editor.layout":`編輯搜尋配置`,
"label.send.chatter":`發微貼`,
"label.h5.chatter.reply":`快速回覆`,
"component_chatter_post_button_file":`添加附件`,
"label.emailobject.emaildetail.button.reply":`回覆`,
"label.eidt.queue.title.desc":`名稱必須是唯一的，並且名稱必須以字母開頭，只能包含大小寫字母，數字，下劃線，且長度不能大於40。`,
"label.campaign.channel.input.url":`5.請設置使用者註冊之後能看到的訊息，可以是一個感謝頁面、活動宣傳單或者入場券：`,
"label.compact.layout.assign.tip":`此表顯示不同記錄類型的關鍵訊息配置指派。`,
"vue_label_fall":`下降`,
"label.trigger.save.failed":`儲存失敗，數據不能為空`,
"label.appupload.upload.tips.report":`注意：我的個人自訂報表"和"未歸檔公用報表"中的報表、舊報表不能添加到軟體包，也不能顯示在此列表中。"`,
"label.tianyancha.businessverify.rewriteall":`回填全部數據`,
"label.campaign.channel.step6.remark4":`請注意，商機所有人將是當前市場活動所有人或者營銷渠道邀約人，`,
"front-kefu-moudle-called-num":``,
"label.approvalstep4":`步驟4:選擇要在批准版面配置上顯示的欄位`,
"label.login.verification.please.scan":`請使用智慧手機上的MFA應用程式進行掃碼`,
"label.invoice.message.statusupdated":`Invoice狀態已更新`,
"label.pc.ui.2018.subject":`主題`,
"label.area.notexist.userinfo":`不存在的使用者組`,
"label.newuser":`新建使用者`,
"label.chat.micropost.share":`共享帖子`,
"label.locatedupcurrentvalue":`位於當前值的上方的值`,
"vue_label_systemSettings_course":`Lighting進程設定`,
"chatter.group.public":`公用`,
"label.reportsSubscription.entrance":`訂閱`,
"front-kefu-moudle-v1-online-at":`線上工作人員`,
"label.rejectbehaviourselect":`<strong>只</strong>執行此步驟的拒絕操作並將批准請求發回到最近的審批者。 （返回1 步）`,
"vue_label_commonobjects_view_currentviewset":`要取消當前預設視圖的設定，可將其他視圖設為預設視圖`,
"lable.currencyAdv.and":`和`,
"label.appexchange.installedpage.publish":`發佈者`,
"label.tab.profile.ismobile":`應用於行動端`,
"label.data.setok.t.desc2":`返回到數據範本頁面`,
"label.email_required":`電子郵件為必填項`,
"label.tabpage.fullscreenz":`全螢幕`,
"chatter.sticker.set":`微貼追蹤設置`,
"label.mobile.phone.year":`年份`,
"label.projectManagement.next.page.before":`前一頁`,
"pagecreator_button_pcpage":`PC端`,
"label.dashboard.xsld.percent":`佔比`,
"label.ccpeak.service.checkerror":`語法檢查失敗`,
"label.icon.26":`文件夾`,
"label_partner_common_webSit_memo":`貴組織中夥伴雲的預設域名為：`,
"label.unselectfile":`未選擇檔`,
"label.take.notice":`注意`,
"message.error.filename.null":`fileName不能為空！`,
"vue_label_SMS_nophone":`無電話號碼`,
"label.area.assignuser":`分配使用者`,
"label.icon.176":`提示`,
"label.icon.21":`貨幣`,
"message.error.system.service.deletedeny":`數據被關聯,無法刪除！`,
"label.compact.layout.main.tip":`選擇當此物件的記錄在cloudcc中以列表項出現時要使用的關鍵訊息配置。`,
"label.emailtocloudcc.delete":`刪除`,
"label.dashboardSetup.showdw.d2":`千萬`,
"front-kefu-moudle-hqyyjlsb-admin":``,
"label.partnerCloud.basicSetting.userCounts":`合作夥伴角色數量`,
"front-kefu-moudle-calling-num":``,
"label.alldocument":`所有文檔`,
"coderules.nullvalue1":`產生失敗,請給產生規則中使用的【{0}】錄入值`,
"lable.automatically.shared":`自動共享`,
"label.batchadd.newbatchpage.save.emptyselect":`存在必填項目未填寫，請檢查`,
"vue_label_homepage_card_30dayswithout":`30天未聯繫的機會`,
"label.multilang.dupicatecheck.onegroupnote":`請至少勾選兩條數據，點擊按鈕【連線選中的訊息】，進入數據合併頁面。當前是第{0}組企業訊息，
 共有{1}條記錄。`,
"UG.activity.03":`預約日程`,
"label.pc.oldpage":`舊版介面`,
"label.exchange.sync.state.task.m2":`在最後 60 分鐘同步的記錄：`,
"label.setmovable":`活動設置`,
"label.sendemail.send.loginfail":`登錄郵箱失敗，請重新設置郵件訊息`,
"label.copy.quote.lines":`複製報價行`,
"label.copying.reward.to.groups":`複製到報價行組`,
"label.ems.connect.error":`伺服器連接失敗，請檢查。`,
"lable.account.Tomorrow":`明天`,
"label.manageAll.sta2":`審批通過`,
"label.create_form":``,
"label.ems.saveDetail.error.msg":`儲存失敗，請檢查郵箱帳號、密碼等訊息。`,
"label.service.gantt.distribution.recommendation":`指派已推薦`,
"label.email.track.attachment.size.control2":`當前上傳的文件大小超過10M，無法上傳。`,
"lable.product.pricebooks.add":`添加到價格手冊`,
"label.login.time":`登入時間`,
"label.tabpage.yes1z":`是1`,
"label.SalesCommitmentKanBan":`銷售承諾看板`,
"label_partner_workspace_myspace":`我的工作區`,
"chatter.like":`個收到喜歡`,
"lable.PowerProcess.number.input":`請輸入整數`,
"chatter.coll":`收藏`,
"label.campaign.channel.img.remark":`註：圖片大小不能超過2M`,
"label.field.duplicate.error.msg7":`重覆的數據`,
"vue_label_pool_discard":`廢棄`,
"label.service.gantt.total.planned.duration":`服務預約的計劃持續時間總和`,
"label.weixin.click.loadmore":`點擊加載更多`,
"label.help.new.features.yd":`行動端新介面操作指南`,
"label":`標籤`,
"label.quickbooks.viewlist.total1":`共計{0}個invoice，共{1}`,
"front-kefu-moudle-v1-input-publicKey":``,
"label.approval.allowed.reject":`允許拒絕`,
"label.visualpage.folder.notdel":`此檔夾中含有檔，不允許被刪除。`,
"label.projectManagement.charging":`計費`,
"label.ccservice.validate":`物件API為{0}下的{1}欄位對應值為{2}格式有誤，請輸入正確的數字！`,
"message.unbind.mfadevice.no.permission":`您無權限解除MFA設備綁定，請聯繫管理員`,
"label.partner.new.step3.meno":`不確定輸入什麼？別擔心，您隨後可以隨時進行更改。`,
"label.import.page3.importsucceedtip":`成功開始匯入，匯入結束後會發送郵件到您綁定的信箱`,
"label.customsetting.visible.protect":`已保護`,
"label.publishreadandwrite":`公用讀/寫`,
"vue_label_file_add_most_once":`單次最多添加`,
"label.salescloud.teamrole.optionlist.group":`將角色分配至業務機會小組成員和客戶小組成員`,
"label.appointment.wizard.subtitle7":`地點`,
"label.task.dateminus":`減`,
"label.data.exp.zippwd":`手動輸入壓縮文件密碼`,
"UG_Forcast_09":`下一步`,
"message.duplication.label.allselectlink":`[全選]`,
"label.file.ccchat.selectfromcloudcc":`從CloudCC中選擇一個文件`,
"label.ems.addaccount3":`添加帳號`,
"front-epwechat-module-v1-schedule-sync":`日程同步`,
"label.h5.manage":`管理應用`,
"setup.layout.label.nobutton":`暫無可選按鈕`,
"label_component_hotdeal":`熱門交易`,
"template.dashboard.contract.analysis":`合約和收款分析`,
"vue_label_dashboard_editcomponent":`編輯組件`,
"label.quotationInformation":`報價單訊息`,
"label.data.file.validation_rules":`執行驗證規則`,
"label.ccpeak.construction.shareobj":`構造一個物件的共享表物件，需傳入物件API名稱及共享標誌：`,
"label.wei.pollinformation":`微投票基本訊息`,
"label.quickbooks.viewlist.total3":`共計{0}個付款，共{1}`,
"label.paging.totalofpagesnoid":`共{0}頁`,
"label.unlock":`解除鎖定`,
"front-invoice-online-payment-information":``,
"label.permission.systempermission":`分配的系統權限`,
"message.error.object":`調用服務時發現物件未定義;`,
"font-trade-module-v1-invoice-intro":``,
"label.userinfo.pwdexpired":`當前密碼已到期。基於安全原因，您現在必須更改密碼。`,
"label.userphoto.photo":`相片`,
"label.tabularreport.filterrecord":`選擇確定要顯示哪些記錄所使用的條件`,
"label.partnerCloud.orderingPlatform.rechargeIt":`您的帳戶餘額不足，請儲值`,
"label.icon.120":`電腦`,
"label.projectManagement.select.new.type":`選擇建立類型`,
"vue_label_commonobjects_detail_customer_details":`正在連線客戶詳情`,
"label.ems.status":`狀態`,
"label.validate.function.description":`在驗證規則中可以使用符合java語法的任意涵數，表達式需要返回一個布爾值；<br>還可以使用CloudCC提供的特定函數：isNew(),isChanged(欄位Api名稱__c),priorValue(欄位Api名稱__c),priorValue()返回object類型，需要轉換成對應的欄位類型`,
"label.escalation.setup.newaction.step2":`步驟2：選擇要向其自動分配個案的使用者`,
"label.forecast.customforecast.searchforecast":`查找預測`,
"label.the.upper.bound.of.each.level.of.block.pricing.must.be.greater.than.the.lower.bound.":`分塊定價每1層的上界必須大於下界。`,
"vue_label_commonobjects_view_notice_deletefailreason":`id為{0}的數據刪除失敗，失敗原因為{1};`,
"page.field.masterinput.remark":`對於已啟用的主從錄入，應用於前台選項卡新建記錄時，所錄入的相關列表記錄`,
"lable.SalesCommitmentKanBan.contractName":`合約名稱`,
"front-gantt-module-add-milestone":``,
"label.callcenter.save.error":`請不要重複儲存`,
"label.workflow.selectobj":`步驟 1：選擇物件`,
"label.validate.function.category.all":`-- 所有函數類別 --`,
"label.multilang.uploadifupage.select":`您共選擇了{0}個文件：`,
"label.weixin.dragsort":`拖動我的應用中的圖標,可重新排序`,
"N":`數字`,
"label.knowledge.article.translation.completed":`文章翻譯完成`,
"label.weixin.myapp":`我的應用`,
"label.icon.138":`貨幣`,
"vue_label_chat_create_discussion_now":`立即建立討論`,
"label.knowledge.recover.article":`恢復文章`,
"label.ccpeak.use.class.time.map":`通過傳入Map集合存取`,
"front-email-payment-error-tips":``,
"label.service.gantt.ziyuan":`僅限為`,
"label.upload.error":`失敗了`,
"label.staticresource.upload.error":`上傳靜態資源出錯！`,
"com.cloudcc.login.error.message.loginfail":``,
"pagecreator_button_back":`上一步`,
"label_tabpage_skip":`跳至`,
"label.pw.old":`請輸入舊密碼`,
"pagecreator.layout.label.modifylayout":`配置編輯器`,
"vue_label_chatter_share_group":`與小組共用`,
"label.app.edit":`編輯應用程式`,
"label.user.Email.repeat":`錯誤：信箱與現有工作人員信箱重複`,
"label.field.quilt":`此欄位被`,
"label.projectManagement.Groupuser":`按使用者分組`,
"label.deleteall":`全部刪除`,
"label.appexchange.download.tiaoguo.mes":`跳過安裝以下衝突組件：`,
"label.sendemail.recycle.operatehello":`#username 您好:\r\n`,
"label.emailmerge.mergeFolder.max20templates":`至多可以選擇20個範本!`,
"label.campaignmember.main.deleteleaddesc":`一次從市場活動批次刪除全部商機`,
"Opportunity_Detailed_Phase_Label_Popup_003":`停留天數`,
"vue_label_file_no_title":`暫無標題`,
"label.data.dataexpalltype.all.desc":`匯出當前使用者所有有權查看的物件的資料。`,
"label.dashboard.unit2":`單位：百萬`,
"label.list.userinterface.isrelatedlist":`啟用相關列表懸停`,
"label.role.tree":`您的組織角色階層架構如下：`,
"label.campagin.roi.zcsl":`註冊數量`,
"message.error.forecast.setupchange":`找不到您嘗試存取的數據。這可能是因為其他使用者刪除了該數據或是發生了更改。`,
"label.sendemail.changeowner.dataname":`文檔名稱為:#dataname的文件`,
"label.salescloud.opportunity.contactrole.optionlist":`業務機會聯絡人角色選項列表值`,
"setup_mainpage_label_welcome1":`需要相應權限`,
"UG_activity_02":`指派工作`,
"label.tabpage.erraddressz":`信箱地址格式錯誤,請正確輸入信箱地址。`,
"label.weixin.nicheng":`微信暱稱`,
"label.forecast.settings.mrsz":`預設預測數字`,
"label.campaign.channel.download.size3":`小尺寸：300*300像素`,
"label.icon.73":`機床`,
"label.ServiceCloud.suoxuchanpin":`所需產品`,
"label.escalation.setup.newrule.description":`輸入規則名，然後選取"已啟用"複選框，將此規則用於自動個案升級。啟用此規則將禁用當前的個案升級規則。`,
"label.data.import.setup.whichfield.cloudccid":`CloudccID`,
"label.validate.function.funcExplain.PRIORVALUE":`返回object類型，需要轉換成對應的欄位類型`,
"Lead.Scoring.Warning.001":`針對單個商機系統可在建立，編輯商機時自動評分，但針對批次匯入或者通過介面建立的商機需使用批次評分手工進行。`,
"label.tianyancha.businessverify.msg9":`本《協議》的解釋權歸北京神州雲動科技股份有限公司。`,
"label.compact.layout.tip":`關鍵訊息配置用於在詳情頁面中展示記錄詳情的關鍵欄位。`,
"label.visualpage.btype":`報表`,
"label.textmessage.vonage.settings":`設定`,
"label.field.not.exites":`不存在！`,
"label.payment.switch.version":`正在切換版本`,
"label.ems.hour":`小時`,
"label.weixin.cannot.edit":`該文件類型無法編輯！`,
"chatter.pt.limit":`最大文件大小為`,
"label.quote.detailinfo.add":`添加報價單明細`,
"component.setup.label.displayfield":`顯示欄位`,
"vue_label_report_reportfolder":`報表所在文件夾`,
"label.gbkencoding":`簡體中文(GBK)`,
"front-kefu-moudle-v1-Transfer-to":``,
"label.file.stop.sharing.desc2":`共享`,
"label.textmessage.messageCannoutuse":`目前不可用，請聯繫系統管理員啟用簡訊功能`,
"component_newrecords_label_type":`存儲類別`,
"label.validate.function.funcFormat.ISNEW":`ISNEW()`,
"lable.product.pricebooks.new":`新建價格手冊`,
"vue_label_newfile":`建立文件`,
"label.reportTypcrtB":`關聯物件（B） 請點擊選擇關聯物件`,
"label.knowledgebase.type":`分類`,
"label.report.select.format":`選擇報表格式`,
"component.todaytask.label.title":`今天的工作`,
"message.undelete":`確定要取消刪除嗎？`,
"label.ccdocument.trace.retention":`痕跡保留功能`,
"label.publicgroup.tip":`公開的小組是使用者的集合。它可包含各個使用者、其他小組、特定角色或範圍內的使用者。`,
"label.forecast.settings.lable2":`預測摘要預設視圖`,
"label.projectManagement.positive.integer":`請輸入0-24之間的正整數`,
"label.projectManagement.one.work.list":`至少填寫一條工作清單！`,
"label.or":`||或`,
"label.projectManagement.no.person.in.charge":`暫無負責人`,
"vue_label_commonobjects_detail_an_email":`發送一封電子郵件`,
"front-electronic-signature-field-mapping":``,
"label.marketsea.name.error":`公海池名稱不能為空`,
"component.setup.button.appurl":`本系統URL`,
"label.mr.title.button.group1":`第`,
"chatter.contact":`聯繫方式`,
"vue_label_pool_hasfixed":`有固定合作通路`,
"lable.list.queue.des":`佇列使使用者組可以更有效地管理共享的工作量。佇列是可以將記錄由路由到以等待使用者組成員處理的位置。記錄保留在佇列中，直到使用者同意處理它們或者將它們轉移到另一個佇列。可以指定每個佇列支援的一組物件，也可以指定允許從佇列檢索記錄的一組使用者。`,
"label.reportsSubscriptionPage.condition":`設定條件`,
"label.transwork":`翻譯工作台`,
"label.batch.batchopration.resel":`請重新選擇要轉移的數據，點“OK”按鈕將跳轉到視圖列表頁面。`,
"label.cloudccsite.new":`新建站點`,
"label.button.select.page.required.field":`選擇頁面中的必填欄位`,
"label.pagelayout":`版面配置`,
"label.weixin.trace.record":`追蹤記錄`,
"label.emailtocloudcc.clear":`清空`,
"label.checkfield.find":`查找重複`,
"message.view.count.title0":`當前頁面匯總`,
"label.reportsSubscriptionPage.schedulereport.frequency":`頻率`,
"setup.mainpage.label.welcome5":`自訂欄位`,
"label.implementation.details":`執行詳細情況`,
"label.attendance.history":`考勤歷史`,
"label.is.pigeonhole":`是否歸檔文件`,
"lable.account.CurrentandPreviousFYt":`當前和前兩個會計年度`,
"label.forecast.customforecast.tab.opportunity":`銷售機會子選項卡`,
"label.version.business.track":`商機追蹤`,
"label.profilelayoutedit.selectrecordtype.tip":`為此使用者設定檔選擇記錄類型。您需要將該記錄類型欄位添加到與此設定檔關聯的頁面配置上，這樣才能將其顯示在就詳細訊息頁面和編輯頁面上。`,
"label.campagin.roi.zclzb":`註冊量占比`,
"label.validate.function.funcFormat.WEEKDAY":`WEEKDAY(date)`,
"label.view.sort.message":`按{!sort}排序`,
"page.field.masterinput.sort":`主從錄入按儲存的順序顯示`,
"label.selected.field":`已選搜尋欄位`,
"label.product.proofTwo":`請在{0}處，最少選擇{1}個產品選項。`,
"vue_label_report_filtercondition":`篩選條件`,
"label.forecast.shrepage.desc1":`此頁面將列出對`,
"label.file.copy.link":`連結複製`,
"vue_label_chat_movedto":`{name}將{label}更改至{newField}`,
"label.layout.new.built":`新建部分`,
"label_tabpage_crecordtypez":`更改記錄類型`,
"label.report.searchcustominfo":`輸入用來查找匹配自訂報表的關鍵字`,
"chatter.feed.menutype.user":`人員`,
"label.recordtypeselect":`選擇記錄類型`,
"label.partner.new.step3":`步驟3：輸入名稱和URL`,
"label.newCustomReportType":`新建自訂報表類型`,
"label.service.gantt.day.timescale":`日視圖上顯示的時間刻度：`,
"label.displaytype3":`列表按鈕`,
"label.weixin.discharge.rate":`排氣量`,
"label.weixin.menu.message":`選單訊息`,
"label.mask.show.all.characters":`遮罩顯示所有字元`,
"label.quickbooks.fieldlabel.billingaddress":`發票地址`,
"Dashboard.View.All":`所有儀表板`,
"setup_mainpage_label_welcome22":`操作指導： 點擊本頁左側選單 → 管理設定 → 通訊範本 → 電子郵件範本。`,
"chatter.group.groupInformation":`小組訊息`,
"front-epwechat-module-v1-input-secret":`請輸入Secret`,
"lable.Set.value.prompt":`或者，篩選在相關清單中顯示的記錄。選擇複選框，或選項清單欄位和您想要篩選的值。如果您手動輸入值，請使用逗號將其隔開。`,
"label.appupload.upload.from":`由`,
"label.weixin.postunsolve":`逾期`,
"label.cooperation.all":`全部協作`,
"lable.PowerProcess.close.time":`基於{detailInterestType}的關閉時間`,
"lable.opppdt.selPdt.leastone.fields":`請至少選擇一個欄位`,
"label.emailtocloudcc.help":`請輸入正確的電子信箱密碼或授權碼。如果您的電子信箱伺服端需要開啟IMAP/SMTP服務才可由第三方客戶端登錄，您必須先登錄電子信箱進入設定確保此服務已開啟，並複製相應授權碼輸入至此密碼框。`,
"label.attendance.offwork.time":`下班時間`,
"front-gantt-module-v1-project-gantt":``,
"label.chuangming.description":`配置創明簡訊接口訊息，滿足您組織的簡訊收發業務需求。`,
"label.custom.lead.notice.account.name":`您好！有商機通過轉換，指定您為客戶，聯絡人及業務機會的擁有者，客戶名稱：`,
"label.emailobject.failedtosend1":`發送失敗原因：信箱認證失效，請重新關聯個人信箱！`,
"vue_label_ccchat_notice_updaterecordsuccess":`已更新此記錄`,
"label.dayinmonth":`個月的`,
"label.sendemail.chat.follow":`尊敬的#name:\n\n 您好！ #userName追蹤了您。`,
"label.emailsync.form.emialpassword":`密碼`,
"component_task_label_subject":`主題`,
"label.projectManagement.please.enter.a.positive.integer":`請輸入正整數`,
"lable.account.NexteDays":`未來7天`,
"label.appupload.upload.managed":`最多只能建立一個受管軟體包！`,
"label.data.dataexpalltype.all.desc1":`1、匯出全部的壓縮文件密碼可以自動產生，或手動輸入。自動產生的密碼將在資料匯出成功後發送到使用者信箱。手動輸入的密碼不會發送到使用者信箱，所以需要使用者牢記自己輸入的密碼，若不輸入，則預設沒有密碼。`,
"label.step1.total3":`第1步，共3步`,
"label.escalation.setup.detail.section":`規則詳細訊息`,
"front-gantt-module-drag-task-sorting":``,
"label.isEnableVisualpage.new.title":`啟用自訂頁面存取`,
"label_tabpage_yesz":`是`,
"label.emailobject.emaildetail.button.replyall":`回覆全部`,
"label.knowledge.setting.data.one":`不能再繼續新增子類別`,
"label.manageAll.sel.one3":`我批准過的項目`,
"UG_contact_01":`如何充分利用您的聯絡人?`,
"font-trade-module-v1-invoice-name":``,
"label.central.daylight.time":`中央夏令時`,
"label.chatter.pastThirtyday":`過去30天`,
"vue_label_commonobjects_detail_activity_ownevent":`擁有事件`,
"label.user.modify":`編輯使用者`,
"label.uploadTemplate":`上傳範本`,
"setup_mainpage_label_welcome14":`工作流制定、審批流程管理`,
"label.workmate":`同事`,
"label.displaycolumns":`顯示的欄位`,
"label.emailnoticeintro":`電子郵件通知是觸發工作流程規則時發送的電子郵件。`,
"label.knowledge.category.button.five":`刪除分類`,
"template.report.business.opportunities.type":`按類型統計的機會`,
"vue_labenl_applauncher_moreapp":`更多應用程式`,
"label.captcha.expired":`驗證碼過期，請重新領取`,
"template.chart.bnqzkhslmb":`本年商機數量目標`,
"chatter.up.user.pic":`上傳設定檔照片`,
"label.timezone.importtimezone.gmt":`使用格林威治標準時間`,
"label.step.type":`選擇搜尋的成員類型`,
"Dashboard.View.RecentlyView":`最近查看`,
"label.reportinthisfolder":`此文件夾中的報表`,
"label.product.vies":`產品視圖`,
"pagecreator_systemstyle_message_delete_fail":`樣式刪除失敗`,
"label.multipleactivity.singleUser":`單個使用者`,
"vue_label_email_enter_subject":`輸入主題`,
"label_tabpage_alltabs":`全部選項卡`,
"label.publicgroup.groupname":`小組名`,
"template.report.sales.performance":`銷售人員業績`,
"label.newWindow":`新視窗`,
"label.forecast.editopp.forecastedit":`預測編輯`,
"label.data.import.setup.whichfield":`您希望將解決方案上的哪個欄位用於匹配？`,
"label.noadd_dashboard":`請勿新增到儀錶盤`,
"label.subtotal":`小計`,
"front-email-payment-weichat":``,
"label.attendance.position.alert":`請先選擇標註`,
"chatter.follow.me":`追蹤我的`,
"label.mobile.more.details":`編輯文件詳細訊息`,
"Dashboard_SelectBoardToDisplay":`請選擇打開儀表板選項卡顯示的儀表板`,
"front-gantt-module-v1-search-project":``,
"label.paging.totalofpagereport":` 共{0}頁({1}條)`,
"label.from.phone":`發訊人手機號`,
"lable.Signatory":`簽署人：`,
"label.campagin.roi.query.roi2":`市場活動營銷渠道ROI`,
"label.tabpage.selectcontentz":`請選擇內容`,
"label.multilang.lookfiltercondition.valuetypenotmate":`第{0}行條件錯誤,值類型不匹配！`,
"label.interfaceconstraint.disabled":`此介面已被禁用，請聯繫系統管理員`,
"third":`第三個`,
"label.quickbooks.viewlist.status":`狀態`,
"label.emailtocloudcc.select3":`請選擇記錄擁有者`,
"label.projectManagement.week.work":`我本週的工作`,
"vue_label_pool_nodemand":`沒有需求`,
"label.version.two.developapi":`二次開發API`,
"label.icon.82":`打印機`,
"label.batchadd.newbatchpage.suclist":`條數據添加成功`,
"label.checkfield.chooseatlast":`請至少選擇兩個`,
"label.quotation.deleteTip":`請選擇需要刪除的報價行。`,
"label.generatepage.title.desc2":`點儲存按鈕後，產生web頁面及可以存取的 web URL連結。`,
"label.licence.total":`許可證總數`,
"Y":`查找關係`,
"label.wuzibiekesitan.time":`烏茲別克時間`,
"label.component.hotdeal.nodata":`無機會相關數據`,
"label.data.exp.save":`儲存範本`,
"label.appupload.upload.tips.dashboard":`注意：我的個人儀表板"和"未歸檔公用儀表板"中的儀表板不能添加到軟體包，也不能顯示在此列表中。關聯的舊報表不會上傳。"`,
"lable.PowerProcess.new.PowerProcess":`建立權利過程`,
"label.loginhis.search.download":`考慮到登入歷史較多，搜尋下載的時候只允許下載2個月內的歷史記錄`,
"label.tabpage.deleteview":`刪除視圖`,
"label.chatter.recently":`最近`,
"label.industrialandcommercialverification.title":`工商驗證`,
"message.nextapproverlost":`指定的下一個審批人為空。`,
"front-kefu-moudle-v1-mfsysy-time":`免費試用剩餘天數`,
"label.role.assign.tip":`選定<b>可選使用者</b>列表中顯示的使用者指派給角色`,
"label.addattachment.step2.intruduce":`重複步驟1和步驟2的操作，添加多個文件`,
"vue_label_pool_returnreasondiscription":`退回原因描述`,
"label.weixin.report.range":`持續時間`,
"label.wei.weiresearchtab":`微投票選項`,
"vue_label_report_setdrill":`設定鑽取`,
"page_404_button_back":`返回上一步`,
"label.customfields.autonumber.tip":`系統使用您定義的顯示格式產生的序列編號。該編號對於每條新記錄會自動遞增。`,
"label.ccpeak.return.allrecords":`返回所有記錄。`,
"label.ccchat.notmember.active.group2":`您不是名稱中含有`,
"label.uniquename":`唯一名稱`,
"label.emailtocloudcc.filed.ssl":`安全連接`,
"chatter.emailFollowMe":`追蹤我的時候`,
"label.allrightsreserved.allrightsreserved.customerServiceHotline":`公司版權所有。保留所有權利。客戶服務熱線`,
"label.projectManagement.actualworkinghours":`實際工作時長`,
"label.quickbooks.fieldlabel.taxresale":`稅收轉售`,
"label.icon.12":`維修`,
"label.data.exp.dataexptemp":`資料匯出範本`,
"component_setup_tabs_label_add":`新增`,
"label.appointmentdetail.wizard.title10":``,
"label.multilingual.close":`多語言管理未啟用`,
"message.error.username.notexist":`未知的用戶名，重新輸入！`,
"label.batchadd.newbatchpage.des2":`若欄位為自動編號類型，則無需輸入，儲存時系統將會為其自動產生編號`,
"vue_label_SMS_search":`搜尋商機或聯絡人`,
"label.appupload.successWithUrl":`現在可以使用以下安裝URL來安裝軟體包。`,
"UG_Forcast_06":`請選擇允許預測的使用者`,
"vue_label_dashboard_secondarygroup":`請選擇二級分組`,
"label.weixin..xsld.total":`漏斗總值`,
"label.setup.mobile.bottombutton.recovery.default.fail":`恢復預設失敗`,
"label.addrecurrencetimetrigger":`添加週期性時間觸發器`,
"label.emailsync.connectaccount":`關聯信箱帳號`,
"label_fiscal_years":`會計年度`,
"label.icon.164":`大巴車`,
"label.batchadd.mustinput":`帶`,
"message.newtabpage.nokeywords":`請輸入至少一個字元長度的關鍵字或使用進階搜尋條件!`,
"label.login.verification.mfa.desc3":`如果您的帳號已被多人共享使用，那麼當您成功綁定MFA之後，其他未綁定MFA的人將無法登錄。解決方法是讓其他人也安裝MFA應用程式並掃瞄此頁的二維碼，或者儲存此二維碼圖片供其他人後續進行掃碼。但從安全最佳實踐來看，我們建議您取消多人共享帳號。`,
"label.partnerCloud.basicSetting.initialize":`初始化後，您無法修改您的夥伴雲網域名。`,
"label.address.county":`縣`,
"label.validate.function.funcFormat.TODAY":`TODAY()`,
"label.sso.addAKey":`添加密鑰`,
"label.myusergroup":`我的使用者組`,
"label.import.index.time-consuming":`耗時`,
"label_tabpage_systems":`共有*個系統`,
"batch.sendemail.s":`， 郵件發送成功。`,
"label.appointment.wizard.subtitle4-1-1":`15分鐘`,
"label.projectManagement.delete.milestone":`刪除該里程碑，將刪除里程碑和里程碑關聯的所有訊息，且數據無法恢復，是否確認刪除`,
"label.umeng.chatter.praise":`讚了您的雲貼`,
"font-evaluate-module-v1-evdetails":``,
"label.group.filter.resources.and":`選擇篩選資源的方式，且(AND)的關係`,
"label_emailtocloudcc_description":`將您企業的信箱，如sales@company.com, info@company.com, support@company.com添加於此，系統將自動根據所收郵件產生商機或個案記錄，確保及時跟進來信客戶`,
"label.chat.topic.delete.prompt2":`請注意，其他社區中同一名稱的主題將不會被刪除。`,
"message.error.group.authorization":`您沒有權限設定此小組`,
"label.attendance.wz":`地點`,
"vue_label_activity_notice_logacal_success":`您已記錄電話`,
"label.emailtocloudcc.step1.case1":`Email to Case`,
"label.h5.chatter.praisenum":`收到的讚`,
"label_time_statistics_basis":`時間統計依據`,
"label.onlyadmincanedit":`<strong>只</strong>管理員可在審批流程中編輯記錄。`,
"label.fieldtoolongmassage":`欄位`,
"label.sales.team.shared":`機會小組共享`,
"label_emailsync_status_department":`部門`,
"label.mobile.quickcreate.default.sellingfunnel":`銷售漏斗`,
"label.tabpage.closez":`關閉`,
"homepage.components.two":`步驟2：選擇自訂組件顯示位置`,
"label.everyday":`每天`,
"lable.Product.to.asset.BOM":`產品轉資產BOM`,
"label.appointment.wizard.subtitle4-3":`被邀請者可以選擇開始會議的間隔`,
"label.customobjects.standardfieldslist":`標準欄位列表`,
"label.customfields.suretodelete":`是，我要刪除該自訂欄位。`,
"component.chatter.label.to":`到`,
"label.emailsync.form.seversetting":`設定`,
"label.service.gantt.enabled.resources":`已啟用的資源`,
"label.tianyancha.h5.weibo":`微博`,
"template.chart.dddje":`丟單的金額`,
"label.pc.trigger.apiname":`Api Name已存在,請重試`,
"label.icon.34":`設置`,
"label.schedulejob.setup.schedule.prgname":`程序名稱`,
"label.weixin.free.registration":`免費註冊。`,
"label.placeholder":`請輸入搜尋關鍵字`,
"label.emailobject.manage.template":`管理郵件範本`,
"label.knowledge.article.existsdata":`存在其他數據，不符合要求`,
"label.campaign.channel.lookup.ticket":`查看入場券`,
"label.searchlayout.relation.searchfield":`搜尋相關列表的搜尋篩選器欄位。`,
"label.recordid.cannot.empty":`記錄ID不能為空`,
"label_partner_workspace_member_choice":`選擇設定檔`,
"vue_label_campaign_amount":`收入金額`,
"label.niue.time":`紐威島時間`,
"front-homepageobject-module-v1-workload-ranking":``,
"message.error.datainvalid":`錯誤：無效數據。`,
"vue_label_helpcenter_salesfunnel":`使用新版本的銷售漏斗，分析機會的跟進情況，為您的銷售過程提供數據參考。<br>在左上角將記錄根據角色或擁有者等條件篩選，查看對應條件下的全部可視機會，並進行分析。點擊銷售漏斗圖的階段，查看該階段下的全部記錄。`,
"vue_label_transferownernotice":`與此項目相關的記錄的擁有者也將一同更改`,
"label.monitorsys.operator":`操作人`,
"label.please.codeNorm":`請選擇碼標準`,
"label.campaign.channel.step6.remark2":`啟用員工邀約功能`,
"market.potential.customers":`市場商機`,
"label.customfields.phone.tip":`允許使用者輸入任何電話號碼。自動將其轉換為電話號碼格式。`,
"label.currency.edit":`幣種編輯：更改公司幣種`,
"label.emailobject.emaildetail.button.markasunread":`標記為未讀`,
"label_partner_template_memo":`簡述`,
"label.chat.message.search.all":`搜尋所有消息`,
"label_tabpage_hoursagoz":`小時前`,
"label.customcomponent.developer.help":`自訂組件開發者 幫助`,
"setup_mainpage_label_welcome":`歡迎進入 CloudCC PAAS 平台，平台主體功能如下。`,
"label.h5.similar.opportunity.list":`結果包括具有一個或多個與您的業務機會相同的欄位的已結束贏得客戶業務機會。把業務機會設為書籤將把他們添加到您的業務機會詳細訊息頁面上的類似業務機會相關列表。`,
"vue_label_record_count":`記錄計數`,
"label.icon.29":`演示`,
"pagecreator.page.label.pagelayout":`版面配置`,
"label.ggReleaseRange.searchRole":`搜尋角色`,
"label.campagin.member.field.setup":`市場活動成員欄位設置`,
"augest":`八月`,
"label.salescloud.massloss.content":`禁用小組銷售將刪除使用者的預設業務機會小組和業務機會上面的所有現有小組，且不可恢復。`,
"label.customfields.new.step2.opration.unique.info":`不允許重複值`,
"vue_label_email_optional_members":`可選成員`,
"label.emailobject.attachment.download":`下載`,
"label.recordamount":`記錄數`,
"front-kefu-moudle-call-recorder":``,
"label.more.info":`詳細訊息`,
"vue_label_commonobjects_view_secondsbefore":`{seconds}秒前`,
"label.emailsync.status.action":`操作`,
"label.customfields.totalsummary.collectedfields":`彙總的物件`,
"label.knowledge.setting.hint.two":`注意：在您啟用Knowledge，您無法將其禁用。`,
"label.login.access.yujidao":`預計到`,
"label.assignment.setup.detail.description":`建立規則項目以根據其中指定的條件將記錄自動分配給使用者。`,
"message.error.marketsea.null":`公海池不存在`,
"lable.account.Current.CY":`當前日曆年度`,
"vue_label_salesadvance_lost":`流失`,
"label.file.ownedbyme":`由我所有`,
"label.component.helper.nodata":`目前，無注意事項，請稍候檢查`,
"label.weixin.appr.pending.auditor":`待審批人`,
"UG_opportunity_004":`多業務類型`,
"label.leadscore.setup":`商機評分設置`,
"label.addtimetrigger":`添加時間觸發器`,
"label.mr.title.match":`是否完全匹配`,
"label.projectManagement.Newmilestone":`建立里程碑`,
"label.preview":`預覽`,
"label.tabpage.issuez":`問題`,
"label.img.max.size":`上傳圖片過大，圖片最大不應超過500K。請重新上傳。`,
"label.mainpageset":`主頁組件配置`,
"label.user.login.false.lock":``,
"UG_solution_02":`解決方案是解決客戶遇到的相關問題的機構內部解決方案。`,
"vue_label_approve_put_away":``,
"label.profile.existing":`現有設定檔`,
"label.ems.logininfo":`登錄訊息`,
"label.weixin.location.service":`支援定位服務的物件`,
"label.multilang.datamoveaction.totaldata":`共有{0}條符合條件的記錄,每次最多可轉移100條！`,
"label.ccdocument.cannot.update.set":`該文檔不屬於Word、Excel、PPT類型的文件,不能上傳到範本套紅文件夾裡面！`,
"vue_label_fliter_addfliter":`添加篩選器`,
"label.custom.page.or.trigger":`（自訂頁面或觸發器）`,
"label.tag.filter1":`同時滿足所有選中標籤`,
"UG.homepage.006":`通過問捲調查、即時聊天、郵件、工單對社交媒體帖子甚至銷售活動（如商機、服務支援和活動）來360度瞭解您的客戶活動。`,
"SCORE":`評分`,
"label.file.library.managemembers2":`管理文檔庫成員`,
"label.email.template.public.SMS":`公用簡訊範本檔案夾`,
"label.leadscore.donot":`無法進行商機評分`,
"label.gaode.map":``,
"pagecreator_button_preview":`預覽`,
"UG_contact_04":`或者`,
"label.ccchat.person.invite.eminfo":`{0}已邀請您加入CloudCC同事圈上的{1} - 貴公司的專用協作空間！使用同事圈與您的同事聊天、為您的項目建立小組，以及共享文件。`,
"setup_object_field_dependency_label_actionfieldvalue":`控制欄位值`,
"lable.Product.options":`產品選項`,
"front-electronic-signature-add-autofill-field":``,
"label.customfields.totalsummary.selectcollectedfields":`選擇要彙總的物件`,
"label.projectManagement.the.maximum.contract.amount.is.10.digits":`合約金額最多輸入10位`,
"label.forecast.shrepage.pagetitle":`使用者，角色及區域共享`,
"label.login.access.mark":`要幫助解決支援的問題，您可以授予您的管理員作為您登錄和存取您的數據權限.`,
"lable.outlook.edit.zdyout":`自訂Exchange欄位映射`,
"label.approveoperate":`審批操作`,
"label.tabpage.linknamez":`連結名稱`,
"label.report.error.deletehavedashboard":`此報表已建立儀表板，不能刪除`,
"label.summaryreport.2018.step1":`步驟1：選擇匯總訊息的分組方式`,
"label.campaignmember.main.leadtomember.title":`欄位對應`,
"label.select.dashboar.type":`請選擇儀表板類型！`,
"message.setup.field.picklist.valueexists":`該選項列表值已存在`,
"label.loading":`數據加載中...`,
"label.payments.paytip1":`您的系統版本不是試用版，請點擊“確定”進行重新整理，或者重新登錄。`,
"label.view.appliedMobile":`是否應用到移動端`,
"label.multilang.forcast.financialyear":`第{0}會計年度`,
"front-web-module-v1-detail-comment-opinion":``,
"UG_Forcast_10":`完成`,
"label.optionlistset":`選項列表選項`,
"label.visualpage_list.vpname":`自訂頁面名稱`,
"vue_label_calendar_failed_to_delete_calendar":`刪除日曆失敗`,
"label.json.string.null":`空`,
"message.serviceappo.time.violation2":`服務預約允許時間違規:服務預約的已計劃結束時間大於服務預約的到期日期`,
"label.productsales.today.noevttsk":`今天沒有未處理的事件或者到期的工作`,
"label_tabpage_emptyz":`清空`,
"front-kefu-moudle-no-create":``,
"label.wedge.shaped.tail.arrow.cannot.empty":`楔形尾箭頭不能為空！`,
"label.continue.shopping":`繼續選購`,
"label.turntomain":`跳到主內容`,
"component.assistant.label.nodata":`今天無事項，請稍後檢查。`,
"label.payments.paytip4":`請輸入正確的數量！`,
"label.appupload.upload.versionName":`版本名稱`,
"label.chatter.endData":`結束日期`,
"front-kefu-moudle-buytr-tip":``,
"label.repw":`重複密碼`,
"label.tabularreport.intro":`列表式報表是一種最簡單且最快速的列示數據的方式`,
"label.selectoperatetype":`選擇操作類型`,
"setup.layout.label.required":`必填`,
"label.default.designee":`預設被指派人`,
"label.ccdocument.cannotdel.folder":`該文件夾下面有文件存在，該文件夾不可刪除！`,
"label.escalation.setup.newentries.inputentries":`輸入規則項目`,
"label.emailobject.addnewtemplate":`建立新範本`,
"label_chatter_content":`內容`,
"label.htyj.mubiao":`目標`,
"label.reportsSubscriptionPage.schedulereport.weekly.friday":`星期五`,
"label_tabpage_fieldoptions":`記錄類型欄位，選項列表欄位和選項列表（多選）欄位，建議最多輸入10個關鍵字，用英文逗號隔開實現或關係，如：“北京,上海,廣州”。`,
"label.mobiletablayoutedit.remark2":`選擇要在手機前台選項卡頁面顯示的欄位`,
"label.sendemail.chat.addComentsat":`尊敬的#name:\n\n 您好！ #userName發的微貼的留言裡提及了您。`,
"Z":`公式`,
"label.multilang.batchdeleteaction.movesuccess":`共有{0}條記錄刪除成功！`,
"label.textmessage.vonage.message2":`通過設定Nexmo API帳戶，使用者能夠在CloudCC平臺上存取Vonage API帳戶以發送和接收文本通知。`,
"label.file.use.document":`儲存空間使用情況`,
"UG.Lead.011":`建立一個線索`,
"label.view.name":`視圖名稱`,
"label.data.downtemplate":`下載範本`,
"vue_label_appstore_get_now":`立即獲取`,
"label.controlfield":`控制欄位`,
"label.dataimport.type.insert":`插入`,
"label.customfields.multiselect.tip":`允許使用者從定義的列表中選擇多個值。`,
"label.weixin.approval.qxzjl":`請選擇記錄`,
"component.salesperformance.label.70finish":`已結束-未處理（>70%）`,
"Lead_Auto_Scoring_Setting":`商機自動評分設定`,
"pagecreator_layout_message_canntdelete":`當前配置不允許刪除`,
"vue_label_report_exprotpage":`匯出頁數：第{page}頁`,
"label.campaign.channel.step4":`步驟4：營銷渠道註冊頁面必填欄位設置`,
"label.app.launcher":`應用程式啟動器`,
"vue_label_campaign_selectedmember":`已選擇{member}個行銷活動成員`,
"label.mobile.quickcreate.default.approvals":`待審批`,
"label.view.step4":`步驟4.限制可視性`,
"label.exchange.sync.state.user":`使用者同步狀態`,
"label.forecast.customforecast.tab.forecast":`預測子選項卡`,
"label.theUserLoginForTheFirstTime":`使用者首次登錄`,
"label.workflowoperate.tip":`指定在滿足規則條件時要觸發的工作流程操作`,
"font-evaluate-module-v1-ten-points":``,
"label.knowledge.delete":`刪除知識出錯`,
"front-console-see-contacts":``,
"label.h5.similar.opportunity.add.to.favorites":`添加到書籤`,
"front-epwechat-module-v1-install-app":`在企業微信中安裝應用`,
"setup_layout_message_relatedlistbutton":`選擇在相關列表上顯示的標準按鈕。`,
"label.salescloud.massloss.title":`可能導致大量數據遺失`,
"front-console-conversation-btn1":``,
"label.custom.canvasScale":`畫布比例`,
"label.lead.score.doing":`正在進行商機評分`,
"message.approval.step.validation.invalid.number":`輸入正確的數字`,
"chatter.lk":`喜歡`,
"label.dashboardSetup.showmaxval":`顯示最大數值`,
"label.keywords":`關鍵字`,
"vue_label_helpcenter_SMS":`開啟簡訊功能<br>如果您購買的CRM系統的countrycode是USA，那貴組織系統內有簡訊的功能。組織管理員可在後台集成應用中vonage網關中輸入貴組織在vonage系統內購買的電話號碼，即可在銷售雲應用程式的選單中使用簡訊功能。<br>簡訊收發箱<br>簡訊收發箱分為兩部分，左側為有簡訊往來的商機或聯絡人記錄，單擊某條記錄後右側顯示收發詳情。您可以查看自己以及自己下級的記錄。<br>群發簡訊<br>可以在簡訊選單、商機或聯絡人列表、行銷活動成員上的發送簡訊的按鈕群發簡訊。您只能給CRM內的商機或聯絡人發送簡訊，編輯好簡訊後選擇“發送”，則不管收件人的數量是多少都產生一條群發記錄，或者選擇“分別發送”，分別發送的簡訊支援顯示簡訊模版中插入的合併欄位。`,
"label.emailobject.createnewavailability":`建立日程預約連結`,
"front-kefu-moudle-buytr-send-email":``,
"front-kefu-moudle-v1-Put-away-the-chat":``,
"label.marketseamemset.lead.maxuser":`成員最大商機數`,
"label.forecast.forecastroleuserpage.shre.manager":`只有管理員才能共享該預測`,
"label.file.noselect":`未選擇任何檔`,
"label.notification.task3":`您指派給【被指派人】的工作狀態被修改為【新狀態】`,
"label.dependfield":`相依欄位`,
"lable.SalesCommitmentKanBan.receipts":`收款`,
"label_partner_workspace_member_search":`搜尋`,
"label.share.originally.posted":`初始張貼者`,
"label.autonumber":`自動編號`,
"label.view.sortview.name":`視圖名稱`,
"label.h5.add.activity":`添加活動`,
"label.textmessage.vonage.phone.number":`電話號碼`,
"label.partnerCloud.financeSetting.enterApiKey":`請輸入API密鑰`,
"label.industrialandcommercialverification.enablestatus":`啟用狀態`,
"label.reportTypeFocusD1":`指定哪種記錄(行)類型將成為由此報表類型產生的報表的焦點。`,
"vue_label_report_four-levelseriesobjecttree":`四級串聯式物件樹`,
"label.mobile.default.catalogue":`預設目錄`,
"label.partnerCloud.partnerAccount.again":`再次儲值`,
"label.summaryreport.step2.new":`步驟 2：選擇彙總訊息的分組方式`,
"label.tabpage.cancel":`取消`,
"label.multilang.datamovelist.datamove":`將多個{0}從一個使用者轉移到另一個使用者：`,
"label.conferloginandvisitlimit":`授予登錄存取權限`,
"vue_label_help_viewhelpcenter":`查看CloudCC幫助中心`,
"label.leadscore.norule":`沒有評分規則，請先建立評分規則或者啟動已經建立的評分規則`,
"label.tabpage.exitz":`退出`,
"label.DeploymentStatus":`開發狀態`,
"label.layout.saving":`配置儲存中...`,
"label.emailobject.emaildetail.field.object":`物件`,
"label.customfields.searchrelation.fieldtag.tip":`輸入要在顯示視圖、頁面配置視圖、報表視圖和列表視圖上使用的標籤`,
"message.huanxin.bindtenant.notfound":`使用者未綁定工作人員`,
"label.referpersonalias":`提交人別名`,
"label.icon.31":`電腦`,
"label.appupload.upload.install.thispackage":`此軟體包`,
"label.appointment.wizard.subtitle1-1":`自訂`,
"pagecreator_page_message_save_fail":`頁面儲存失敗`,
"label.lastset":`最後按`,
"label.version.support.limited":`支援受限`,
"vue_label_homepage_kanban":`看板`,
"label.layout.editsearchdistribute":`編輯頁面搜尋配置`,
"template.dashboard.customer.analysis":`客戶分析`,
"label.continue_editing":``,
"label.version.sum.customtab":`個自訂選項卡`,
"label.validate.function.funcExplain.TIMEVALUE":`返回日期/時間欄位中的時間部分（時分秒）`,
"label.import.page1.selectobjfromdata":`選擇要匯入數據的物件`,
"label.partnerCloud.basicSetting.success":`初始化成功`,
"label.customfields.fielddependency.cannotcreat":`不能建立依賴關係，您選擇的欄位直接或間接依賴它本身`,
"label.umeng.activity.youhaveatask":`您有1個新工作`,
"label.file.folder.create":`新增資料夾`,
"vue_label_campaign_member_status":`成員狀態`,
"lable.opppdt.addpdt.table.date":`日期`,
"label_partner_workspace_login_buttontext":`按鈕文本`,
"label_other_mistakes":`其它錯誤`,
"label.must.be.configured":`必須配置`,
"label.customize.memory.function.sorting.enable":`啟用視圖表頭排序記憶`,
"setup.layout.label.areaname":`區功能變數名稱稱`,
"label_chatter_pastThirtyday":`過去30天`,
"setup_mainpage_label_welcome25":`操作指導： 點擊本頁左側選單 → 管理設定 → 安全性控制 → 共享設定。`,
"label.ccchat.person.invite.succsend":`加入同事圈的邀請被發送到`,
"label.select.time.range":`請選擇時間範圍`,
"label.partnerCloud.orderingPlatform.djustQuantity":`將產品新增至購物車，並在購物車中調整數量並檢視價格`,
"label.manageAll.sta1":`審批中`,
"label.cy.select":`請選擇幣種`,
"chatter.lam":`留言`,
"label.partner.setup.title":`設置`,
"component.setup.label.displaybutton":`顯示按鈕`,
"component.salesperformance.label.target":`目標`,
"label.campagin.channel":`請輸入註冊渠道的值`,
"label.validate.function.funcFormat.ISCHANGED":`ISCHANGED(field)`,
"UG.homepage.009":`存取CRM`,
"label.file.item":``,
"label.file.library.addmembprompt":`已經是管理成員，不要重覆添加`,
"label.bmap.releasePosition":`發帖位置`,
"setup_object_layout_label_selectedprofile":`已選設定檔`,
"label_emailsync_message":`提示`,
"label.view_submissions":``,
"lable.tianyancha.repeated":`重複選擇`,
"label.import.index.introduce":`通過簡單的三步，將您的數據匯入到系統中`,
"label.time.operation.new":`新建定時作業`,
"label.projectManagement.Pleaseentersettlementtype":`請輸入結算類型`,
"label.icon.169":`觀光車`,
"vue_label_commonobjects_detail_related_listview":`列表展示`,
"label.view.step1":`步驟1.輸入視圖名稱`,
"label.summaryreport.intro":`彙總報表同時列示數據小計和其他彙總訊息`,
"vue_label_file_input_correct_name":`請填寫正確的名稱`,
"System_Email_Template_Title":`歡迎您使用CloudCC CRM平台`,
"label.tianyancha.province":`省份縮寫`,
"label.deleteall.sure":`確定要全部刪除嗎`,
"label.passwordPolicy.setup.uppercasealpandnum":`必須包含大小寫字母及數字`,
"front-lightning-module-v1-details-page-chart-select":`選擇物件與展示方式`,
"setup_mainpage_label_welcome8":`拖曳式介面定制`,
"lable.outlook.edit.lastupc":`最後更新的聯絡人`,
"label.weixin.registered":`註冊`,
"vue_label_file_history_version":`歷史版本`,
"vue_label_campaign_earned":`待收入金額`,
"label.staticresource.useful.realtion.tip":`以下是所有對此靜態資源的頁面引用`,
"vue_label_file_libraray":`文件庫`,
"label.department.phone":`手機號碼`,
"label.emailtemplate.edit":`編輯郵件範本`,
"label.processsetting.key.information.tips":`關鍵訊息與小提示`,
"label.summaryreport.step7":`步驟 7：選擇圖表類型和報表突出顯示`,
"label.chat.topic.remove.favorite":`從收藏夾刪除`,
"label.campagin.roi.ksrq":`開始日期`,
"label.data.downpage.e_title.e_btn":`進入匯出頁面，開始匯出`,
"label.approvaldatamove.dname":`當前審批者`,
"lable.Partial.attributes":`部分屬性`,
"template.report.enabled.products":`已啟用的產品`,
"lable.outlook.detail.cto":`CloudCC.com 到 Exchange`,
"label.sendemail.activity.newtasktitle":`新工作通知`,
"label.validate.function.funcFormat.DAY":`DAY(date)`,
"label.log.datetime.value":`請輸入查詢時間!`,
"label.import.index.updaterecord":`更新記錄`,
"label.registration.page.invitation":`註冊頁面邀約`,
"pagecreator_systemstyle_label_detailcolor":`明細文字顏色`,
"label.tabname.cannot.empty":`選項卡名不能為空！`,
"label.data.newtemplate.savetemp":`您可以勾選另存為範本，將此次資料匯出所選擇的欄位及條件作為資料匯出範本，儲存到範本頁面。請認真填寫範本名稱和範本描述,方便日後使用。`,
"label.ems.body":`正文`,
"enc":`加密文本(存儲加密)`,
"label.profile.mobile.setup.commonSaler":`普通銷售`,
"label.continueselectproduct":`繼續選擇產品`,
"label.event.new":`新建事件`,
"label.renametabandtaglib":`重命名選項卡和標籤`,
"label.qrcodelogin.message.exception":`伺服端異常，請聯繫管理員`,
"label.service.gantt.locationToGantt":`甘特表`,
"label.mr.theLastGroup":`這已經是最後一組。請點擊【返回查看重複數據列表】，查看重複數據。`,
"label.report.export.format.content":`導出當前報表表頭、分組與詳細信息。詳細信息最大導出`,
"label.version.accountandcontact":`客戶和聯絡人`,
"label.partnerCloud.financeSetting.enterMd5Key":`請輸入MD5密鑰`,
"label.login.access.quater":`周`,
"vue_label_commonobjects_view_searchthisview":`搜尋此列表`,
"label.import.step1.allobj":`全部物件`,
"front-efficient-project-management":`項目雲提供從項目啟動、計劃、執行、控制和結束的全生命週期管理，根據企業需求優化項目管理流程，幫助您高效管理項目。`,
"label.includedvalue":`包括的值`,
"label.service.newBuildDialog.past.days":`過去天數`,
"vue_label_report_sortup":`按升冪排列`,
"label.appointment.wizard.subtitle3-2":`週二`,
"label.dashboard.trend":`趨勢`,
"label.schedulejob.setup.schedule.st2":`第二個`,
"label.view.sortview.number":`記錄數目`,
"lable.Please.enable.order":`訂單未啟用，請先啟用訂單`,
"label.datamanage.immediately.import":`立即匯入`,
"label.delete.condition":`清除`,
"label.dashboard.chooseDispalyOnTheHomePage":`選擇顯示的主頁`,
"asset.accountid.contactid.required":`每個資產都需要關聯客戶或聯絡人。`,
"label.mask.character":`遮罩字元`,
"lable.account.Previous.FY":`上一個會計年度`,
"chatter.attachment":`附加文件`,
"label.view_only":`僅檢視`,
"label.tianyancha.name":`企業名稱`,
"label.service.gantt.avg.traveltime":`服務預約的平均出行時間`,
"vue_label_pool_move":`轉移`,
"label.import.index.beforeexport":`2、匯入之前，請先確保匯入其相關的所有記錄。例如：如果您正在匯入聯絡人記錄，且要填寫客戶欄位（是一個查找欄位），則需先建立好所填寫的客戶記錄，然後再匯入聯絡人記錄，並在客戶欄位中填入對應客戶的名稱或id。`,
"label.view.delete":`刪除視圖`,
"template.detail.info.link":`詳細訊息連結`,
"label.sendemail.send.setfail":`設置信箱訊息失敗，請正確配置信箱訊息`,
"label_emailtocloudcc_redmessage11":`SMTP認證失敗，請檢查電子郵件地址與密碼是否正確`,
"label.campaigns.memberalert":`請至少選擇一個成員`,
"label.schedulejob.setup.schedule.frequency":`頻率`,
"component.newrecords.label.all":`查看全部`,
"label.mr.caption.opportunity":`查重合併：查詢業務機會重複數據的條件`,
"chatter.group.onlyMembers":`僅成員可視這個小組。小組所有人有權添加小組成員。`,
"label.recordtype.edit.selectvalue.show":`選項列表值按儲存的順序顯示`,
"message.textmaxlength":`長度不能超過255`,
"label.reportsSubscriptionPage.visibility":`以下列使用者視角運行報表`,
"label.umeng.chatter.addcoments":`您的雲貼有1條新回覆`,
"chatter.up.f":`上傳失敗,未知錯誤。`,
"label.icon.146":`鍵盤`,
"lable.custom.CY.Ago":`兩個自訂年度之前`,
"label.tabpage.step3":`步驟3 選擇展示欄位`,
"label.checkfield.introduce":`設置物件中可以檢查重複的欄位，在數據列表中可根據設置的欄位查看重複數據`,
"label.tag.addtags":`添加標籤`,
"label.service.newBuildDialog.characterlimit":`名稱超出25個字元限制`,
"font-evaluate-module-v1-evquestions":``,
"label.knowledge.only.update.draft":`只能更新草稿文章`,
"label.partnerCloud.basicSetting.defaultCounts":`新增合作夥伴客戶時建立的預設角色數量`,
"label.chat.topic.delete":`刪除`,
"label.workflow.contentcondition":`條件符合`,
"vue_label_commonobjects_view_sortby":`按{field}排序`,
"label.passwordPolicy.setup.pwdremember24":`記住{0}個密碼`,
"front-kefu-moudle-free-account":``,
"label.marketsea.isautorecycle":`啟用自動回收`,
"label.addattachment.view":`查看文件`,
"vue_label_helpcenter_contact":`在詳細訊息中，點擊聯絡人旁邊的樹狀圖按鈕，可以查看聯絡人階層架構圖，瞭解相關聯絡人的上下級關係，並查看每個聯絡人的部分欄位訊息。`,
"label.taskevent":`任務事件`,
"label.industrialandcommercialverification.message":`今日免費查詢次數已用完`,
"label.object.already.delete":`物件已刪除。`,
"label.project.hit.four":`子工作更新通知`,
"label.taskpagelayout":`任務版面配置`,
"label.version.sum.locationfield":`個地址欄位`,
"front-sales-button-toQB":``,
"label.app.oceanblue":`深海藍`,
"label.operating":`操作中...`,
"label.customfields.formula.dateexample":`Reminder Date（提醒日期）`,
"label.happen_delete":`刪除表單有什麼影響？`,
"label.service.appointmentList.plansToStart":`計劃開始`,
"label.persmets.operate.licence":`許可`,
"label.mobile.quickcreate.default.activities":`日程事件`,
"label.australian.eastem.standard.time":`東部標準時間（昆士蘭）`,
"label.emailobject.remove":`刪除`,
"label.weixin.vote":`參與投票`,
"label.reportsSubscriptionPage.condition.aggregate":`合計`,
"front-kefu-moudle-has-unbind":``,
"chatter.group.newGroup":`新建小組`,
"label.tabpage.systems":`共有*個系統`,
"label.textmessage.vonage.connect":`連接到Vonage`,
"label.campaign.channel.input.ticket":`發送入場券`,
"label.ccpeak.query.sharetab":`查詢共享表`,
"label.reporttype":`報表類型`,
"message.duplication.label.isprofiletip":`如果勾選，查重時會校驗當前使用者所能看到的數據.否則,校驗所有數據`,
"label.tianyancha.businessverify.xieyi":`使用者許可協議`,
"font-evaluate-module-v1-select-person":``,
"vue_label_chatter_all_groups":`所有小組`,
"label.recordtype.profile.setdefault":`設置預設`,
"label.mr.descreption.nocondition":`沒有符合條件的重複數據。`,
"label.tabpage.askz":`你想提問什麼`,
"label.marketsea.selectMember":`選擇成員`,
"template.report.stage.possibility.analysis":`階段可能性分析`,
"label.data.selectderivedobject":`選擇需要匯出的物件`,
"label.customfields.formula.explain":`說明：目前支援數字、百分比等欄位的四則運算，以及查找欄位的帶值。示例：數字類型公式jine*knxing&nbsp;&nbsp;&nbsp;&nbsp;查找欄位帶值：khmc__r.dianhua`,
"vue_label_notice_change_fail":`更改失敗`,
"label.customobjects.trackoldandnewvalues":`追蹤舊值和新值`,
"label.h5.leftprompt":`您有編輯的內容未發送是否確認離開？`,
"label.select.field":`可選欄位`,
"label.customobjects.layoutedit":`版面配置分配`,
"label.false":`假`,
"UG_Forcast_07":`允許預測`,
"vue_label_chatter_team_member":`小組成員`,
"label.tabpage.retypez":`更改記錄的記錄類型時，現有選項列表值不會自動更改。我們建議在相同的地方更新記錄上的現有選項列表值。`,
"front-epwechat-module-v1-single-desc":`通過企業微信單一登入到CloudCC的其他終端，快速在各端之間切換`,
"label.closeandconverted":`關閉-已轉換`,
"label.service.confirmed":`已確認`,
"label.partner.workspace.member.cloudcc":`Cloudcc 設定檔`,
"label.star.click":`點擊清零`,
"label.icon.135":`貨幣`,
"button_partner_workspace_login_logo_upload":`上傳圖片`,
"message.error.sql.constraint.recordnotsingle":`設置外部ID未成功！原因:原來的數據中該欄位有重複數據`,
"label.ccchat.person.invite.errorpwd":`使用至少8個字元並且包含數字和字元的組合`,
"label_tabpage_isdeleterecord":`是否刪除已選中記錄`,
"label.weixin.prompt.message":`提示訊息`,
"vue_label_chatter_view_original_post":`查看原始帖子`,
"label.multilingual.tip3":`啟用多語言可以允許組織內每個使用者配置您啟用的語言種類`,
"label.dataimport.error.datetime":`出現錯誤：日期時間`,
"label_tabpage_addcondition":`添加條件`,
"label.query.detail.manageexcludeuser":`管理外部使用者`,
"label.tianyancha.creditcode":`統一社會信用代碼`,
"label.cy.enter":`輸入貴公司使用的幣種轉化成新幣種的兌換率`,
"label.textmessage.vonage.message1":`通過對接Vonage，使用者可以在CloudCC平臺上收發簡訊。但是在這之前使用者需要註冊Vonage賬戶並購買電話號碼。`,
"front-marketing-module-v1-share-invitation":`分享員工邀約`,
"label.file.items":`個項目，按存取時間排序`,
"label.otherwise":`否則`,
"label.permission.detail.system":`系統`,
"message.success.task.emailsend":`儲存發送電子郵件訊息成功`,
"label.the.reward.group":`報價行組`,
"setup.layout.label.relatedlistsetup":`相關列表設定`,
"label.empty":`清空`,
"label.weixin.cloudcc.user.binding":`CloudCC使用者綁定`,
"label.file.what.change":`發送什麼更改（可選）`,
"label.search":`搜尋`,
"label.mobile":`手機`,
"template.report.month.potential.customer":`本月的商機`,
"lable.setup.mobilesetup.isEnableValidationRulesForScan":`名片掃描是否啟用驗證規則`,
"lable.outlook.list.des":`Exchange Sync 配置定義要應用到特定使用者組的CloudCC for Exchange 的設置。`,
"label.appupload.install.error.info":`{0}“{1}”已被{2}使用，請重新命名現有{0}。`,
"label.tabpage.addoptionsz":`添加選項`,
"label.arabian.standard.time":`阿拉伯標準時間`,
"label.thefirst":`第一列`,
"label_partner_workspace_login_footertext":`頁尾文本`,
"lable.Disabled.successfully":`禁用成功`,
"label.confirm.del":`正在審批中的記錄，請確認刪除。`,
"vue_label_normal_reregister":`重新登錄`,
"label_file_img":`圖片`,
"label.salescloud.salesdashboard.sales.behavior":`銷售行為`,
"label.startdate":`開始日期`,
"label.field.duplicate.error.msg5":`請查看下列所有錯誤消息並改正後重試。`,
"setup.main2018.label.managesetup":`管理設定`,
"label.forecast.editshrepage.title":`新建共用`,
"UG.solution.01":`提供解決方案`,
"label.knowledgebase.data.recovery.successfully":`{a}條資料恢復成功`,
"label.pc.ui.2018.myccchat":`我的CCChat`,
"label.attachement":`備註及附件`,
"message.mobilechooseatmostten":`最多選取十個欄位`,
"label.campagin.roi.bhzeywjh":`總業務機會數`,
"label.autoresponserule":`自動響應規則`,
"label.attendance.yuyue":`您未預約，是否需要現場註冊？`,
"label.insert":`插入`,
"label.service.ganttBaiduMap.shutDown":`確認關閉？`,
"label.icon.194":`電視`,
"message.serviceterritory.violation":`區域違規:資源區域不相符服務預約的服務區域`,
"label.appointment.disable.function":`禁用功能`,
"lable.currencyManage.manageexchangeRate.dis":`要管理您公司的過期匯率，請單擊管理過期匯率"。過期匯率適用於業務機會、業務機會產品和這兩個物件相關的報表。"`,
"vue_label_file_upload_tip_newmsg":`建議上傳文件小於{size}MB，否則可能導致頁面連線緩慢`,
"label.event.next.week":`未來一週的事件`,
"label.datamanage.import.contactfield":`在下表中，選擇匯入文件中應匯入到每個聯絡人的欄位。完成操作後，點擊下一步：`,
"label.projectManagement.time.allocated":`已指派時間`,
"label_tabpage_isdeleteview":`您確定是否刪除此視圖？`,
"label.pc.ui.2018.search":`請輸入搜尋內容`,
"label.role.createrolelevel":`建立角色階層次架構`,
"label.tabpage.editview":`編輯視圖`,
"label_partner_common_manageSetup":`夥伴雲管理設置`,
"label.service.gantt.noservice.resource":`選擇的服務區域下沒找到任何可用的服務資源`,
"message.numbertoolarge":`數字太大`,
"label.sendsms.success":`簡訊發送成功`,
"UG.opportunity.009":`或者`,
"label.ccpeak.construction.dataobj":`構造一個數據物件，需傳入物件API名稱：`,
"front-lighting-module-v1-detail-file-uploadInfo":`記錄已鎖定，不支援上傳檔案，請聯繫管理者解鎖。`,
"label.import.page2.newnotmatchfiled":`文件中共{{?csvfiledlength?}}個欄位，剩餘{{this.csvfiledlength?-?this.selectlength}}個未映射`,
"label.ems.inputmailss":`接收郵件伺服器`,
"label.knowledgebase.data.published.successfully":`{a}條資料發布成功`,
"label_emailtocloudcc_position":`職位`,
"label.data.exp.customexp":`自訂匯出`,
"component_chatter_post_button_user":`添加人員`,
"label.new.visualpagefolder":`自訂頁面：新建檔夾`,
"label.forecast.shrepage.classdes":`存取權限級別說明`,
"label.task.overdue.unfinished":`逾期未完成任務`,
"label.ccchat.micropost.isedit.setting.info":`帖子或留言的作者、記錄擁有者、CCChat 版主和此社區的版主均具備修改該文本的權限。`,
"label.recordname":`記錄名`,
"label.posted_your":`並發佈在您的`,
"label.globaloperation.operationtype.custom.page":`自訂頁面`,
"label_tabpage_busoppnamez":`機會名`,
"front-epwechat-module-v1-schedule-desc":`同步企業微信日程與CloudCC事件`,
"label.escalation.setup.newentries.lastmodifydate":`根據上次修改個案時間`,
"setup_layout_label_nofield":`暫無可選欄位`,
"label.sendemail.registIMUser.logininfo":`您可以登錄的夥伴雲門戶如下：<br>`,
"label.weixin..xsld.kehu":`客戶`,
"label.display_thank":``,
"label.group.no.my.group":`沒有匹配的我的小組。`,
"label.partnerCloud.newBuildSite.enterDomain":`請輸入網域名`,
"label.step1.total2":`第1步，共2步`,
"label.ccpeak.delete.record":`刪除記錄：`,
"label.customer.tab.step1.introduce":`為此新自訂選項卡選擇自訂物件並輸入其它詳細訊息`,
"label_tabpage_newInterfacez":`新版介面`,
"setup.mainpage.label.manageuser":`管理使用者`,
"label.partnerCloud.partnerAccount.completed":`已完成支付？`,
"label.projectManagement.kanban":`工作看板`,
"label.operate":`操作`,
"label.service.dispatchingUnits.selected.time.range":`顯示選定時間範圍內的服務預約`,
"component_setup_label_pagesize":`每頁顯示條數`,
"font-evaluate-module-v1-email-evaluation-settings":``,
"label.service.dispatchingUnits.skills":`技能`,
"label.editrecurrencetimetrigger":`編輯週期性時間觸發器`,
"vue_label_file_edit_lib":`編輯文件庫`,
"label.campaignmember.selectmember.deleteconc":`行銷活動：從聯絡人中刪除成員`,
"label.reportsSubscriptionPage.schedulereport.monthly.day.monday":`星期一`,
"front-detail-module-v1-by":`截至`,
"label.mobile.home.page.date.signed":`預計簽約日期`,
"label.apply.send.success":`發送成功！`,
"label.app.choseimg":`選擇徽標`,
"label.customsetting.visible":`可視性`,
"label.sendemail.activity.task.distributetaskcompleted":`您指派給#belongtoidccname的工作已經標示為完成`,
"label.dashboard.snapshot.refreshing":`正在重新整理`,
"label.document.name.already.exists":`文檔唯一名稱已經存在！`,
"label.ccchat.person.invite.needlastname":`輸入您的姓`,
"pagecreator_page_button_copy":`複製`,
"label.appointmentpage.wizard.subtitle1-2":`上一週`,
"label.validate.function.funcFormat.MILLISECOND":`MILLISECOND(date)`,
"label.profile.allowtocreateview":`建立視圖`,
"message.error.recordid":`記錄id不能為空`,
"lable.SalesCommitmentKanBan.returnToTheSuperiorRole":`返回上級角色`,
"label.translation.start3":`如有必要，選擇一個物件。例如，工作流程任務有物件（帳戶、聯絡人等等）來篩選翻譯術語。`,
"label.ccpeak.send.email":`發郵件通知：`,
"vue_label_commonobjects_detail_activity_noexpirationdate":`無到期日期`,
"label.permission.objectpermission.objpermission":``,
"label.version.custom.report":`標準報表（自訂頁面）`,
"label.title.qrcodeOrbarcode":`產生條碼/二維碼規則`,
"label.emailtocloudcc.step2.name":`配置郵件歸屬`,
"label.reportsSubscription.edited.successfully":`報表訂閱編輯成功！`,
"label_tabpage_kanbansetup":`看板設置`,
"label.tianyancha.regcapital":`註冊資金`,
"front-epwechat-module-v1-web-single":`web單一登入：`,
"label.visualpage.display.top":`顯示頁頭，false-不顯示頁頭`,
"label.customfields.fielddependency.selectcell":`從下表中至少選擇一個單元格。`,
"label.paging.addmember.totalofpages":`共{0}條`,
"label.email.saveing":`數據儲存中`,
"label.userinfo.doublepwd.notnull":`重複密碼不能為空！`,
"label.appointment.wizard.subtitle4-4-2":`兩週`,
"label.chatter.BCC":`密件副本`,
"label.emailtocloudcc.description":`將您企業的信箱，如sales@company.com, info@company.com, support@company.com添加於此，系統將自動根據所收郵件產生商機或個案記錄，確保即時跟進來信客戶`,
"label.sendemail.send.atlastone":`收件人至少有一個`,
"label.mobile.phone.subordinate":`是否包含下屬`,
"label.data.choses.e_desc":`根據您的需要，可以選擇匯出全部資料或選擇匯出單個物件的資料。`,
"chatter.new":`消息`,
"vue_label_help_back":`返回上一級`,
"label.skipwizardintro":`跳轉起點嚮導在幾分鐘內就可以為您建立一個一步的審批流程.`,
"label.weixin.fmu.before.week":`提前 {0} 周`,
"label.sendemail.chat.praiseFeedsubject":`CloudCC CCChat 喜歡您的微貼`,
"lable.currencyAdv.andafterdate":`和 之後的日期`,
"label.sometoprocess":`如果只有某些類型的記錄能夠進入此審批流程，請在下面輸入條件。例如，只有總部員工的費用報表應該使用此審批流程。`,
"label.campaignmember.main.updateleaddesc":`一次更新所有現有商機的狀態`,
"label_partner_common_roleSetup":`夥伴雲角色和使用者設置`,
"label.console.step5.no":`選擇如何顯示記錄`,
"label.salescloud.teamrole.optionlist.account":`將客戶小組成員添加到`,
"Report.Delete.Confirm.Title":`請確認`,
"label.onclick":`單擊`,
"label.weixin.input.identifying.code":`請輸入驗證碼`,
"label.knowledge.translate":`只有為草稿或者已發佈的主版本知識文章可以被翻譯`,
"label.log.ip":`IP`,
"front-electronic-export-goResult":``,
"label.escalation.setup.newaction.otheremail.otheremail":`其它電子郵件`,
"label.icon.104":`日程`,
"label.partnerCloud.exceedTwo":`上傳頭像圖檔大小不能超過2MB!`,
"label_tabpage_thevalurofz":`的值`,
"front-lightning-module-v1-details-page-chart-maximum":`最多輸入50個字元`,
"label.data.downpage.i.title.num6":`建議您在匯入數據之前，先匯入一個包含5條記錄的測試文件，以確保所準備的匯入文件正確無誤。`,
"label.ccpeak.update.record":`修改記錄：`,
"label.dataimportandexport":`數據匯入匯出`,
"label.tabpage.notexceed25":`選擇的記錄不能超過25條`,
"label.starting":`進行中`,
"label.knowledge.language.spanish":`西班牙語`,
"label_emailtocloudcc_set":`設定信箱訊息`,
"message.oneormoreneedsreport":`儀表板使用此報表。請先刪除引用此報表的儀表板組件，然後重試。`,
"label.attendance.xccheckin":`現場簽到`,
"label.emailmerge.editfolder.title":`郵件合併範本文件夾`,
"template.report.year.customer":`本年商機`,
"label.partner.common.webSit.memo":`貴組織中夥伴雲的預設域名為：`,
"label.partnerCloud.financeSetting.onlinePayment":`線上支付`,
"Pagelayout.Setup.001":`選擇要在懸停版面配置上顯示的相關列表`,
"front-kefu-moudle-time-length":``,
"label.deleteObject":`物件已刪除。`,
"label.setup.mobile.homepageshortcuts.select":`選擇需要顯示在主頁頂部區域的4個快捷功能`,
"setup.mainpage.label.welcome26":`數據管理 - 批處理功能`,
"label.ServiceCloud.yuyuebainhao":`服務預約編號`,
"label.emailobject.emaildetail.button.addtolead":`添加到商機`,
"label.event.single.view":`單人視圖`,
"lable.product.pricebooks.ustand":``,
"label.emailtocloudcc.department":`分部`,
"component_assistant_label_30daysnoact":`30天沒有任何活動`,
"label.weixin.no.pending.qzkh.qin":`親，目前沒有商機數據`,
"label.vlidaterule.formula":`錯誤條件公式`,
"label.tianyancha.h5.contact":`聯繫訊息`,
"label.button":`按鈕`,
"message.checkemail":`<strong>錯誤：</strong> 電子郵件輸入有誤，請檢查`,
"lable.account.previous.CY":`上一個日曆年度`,
"label.icon.13":`維修`,
"chatter.coll.c":`取消收藏`,
"label.knowledge.category.hint.four":`數據類別指派`,
"label.tianyancha.phonenumber":`聯繫方式`,
"label.tablayoutedit.remark":`選擇要在前台選項卡頁面顯示的欄位及自訂頁面`,
"label.shareusers":`共享使用者`,
"label.endtime":`結束時間`,
"label.length":`長度`,
"label.umeng.activity.event.begin":`後開始`,
"label.tabpage.alltabs":`全部選單`,
"label.exact.query":`精確查詢`,
"label.weixin.skip":`跳轉`,
"label.ems.cancel":`取消`,
"label.trigger":`觸發器`,
"label.exchange.sync.setting":`Exchange Sync 設置`,
"label.product.pricebooks.name":`價格手冊名稱`,
"label.relation.list.total":`共計選中`,
"label.step2.total7":`第2步，共7步`,
"label.martrixreport.2018.step6.new":`步驟6：選擇圖表類型和報表突出顯示`,
"label.standard.buttonandlink.override":`覆蓋`,
"front-console-conversation-btn4":``,
"vue_label_dashboard_range":`範圍`,
"label.app.sort.show":`應用程式將按照儲存的順序顯示`,
"label.salescloud.teamrole.choose.correct":`選擇了重複的使用者，請更正`,
"label.schedule_post":`發布帖子`,
"front-kefu-moudle-server-request-num":``,
"label.h5.logout":`註銷登錄`,
"label.weixin.horse.club.member.message":`愛馬社會員訊息`,
"label.field.addoptionlist.introduce":`在下邊添加一個或多個選項列表值，每個值應單獨占一行`,
"setup_layout_label_setupfield":`設置欄位屬性`,
"label.chatter.nextStep":`後續步驟`,
"label.quickbooks.searchlist.total1":`搜尋到有{0}個尚未關聯的發票記錄，共計金額為{1}`,
"label.tianyancha.h5.regcapital":`註冊資本`,
"label.icon.184":`諮詢`,
"label.dashboard.message.refreshtoomush":`儀表板快照重新整理太頻繁，請稍後重新整理`,
"label.umeng.approval.reject":`#approver已拒絕#obj申請`,
"label.h5.chatter.newmessage":`輸入新消息`,
"message.error.relationid":`relationid不能為空！`,
"label.setup.mobile.offlinecache.selectdefault":`選擇預設啟用的離線選項卡`,
"label.setup.mobile.homepageshortcuts.saveprompt":`請選擇4個快捷功能`,
"label.projectManagement.Selectmonth":`選擇月`,
"label.version.ultimate":`旗艦版`,
"label.validate.remark5":`強制日期欄位為正確的時間順序，例如開始日期必須小於結束日期`,
"label.version.nowis":`您當前CloudCC版本是`,
"front-kefu-moudle-CRM-set":``,
"label.mr.title.customerAddress":`客戶地址`,
"label_emailtocloudcc_step1_name":`選擇功能`,
"label.time.operation.edit":`修改定時作業`,
"label_tabpage_operationz":`欄位，操作不能為空`,
"label.translation.start4":`雙擊翻譯列來輸入新值。`,
"vue_label_systemSettings_request":`批次轉移批准請求`,
"label.maintenance.notice":`例行維護通知`,
"label.customfields.txet.textlength.tip":`在下面輸入文本欄位的最大長度，文本欄位長度不能大於255`,
"label.ccdocument.select.template.open":`請選擇範本進行打開`,
"vue_label_display_date_field":`顯示日期欄位`,
"label_partner_workspace_tab":`選項卡`,
"lable.account.LasthDays":`過去120天`,
"chatter.using.sticker":`啟用微貼追蹤`,
"message.save.dataerror":`錯誤：數據長度過長或其他問題引起的儲存錯誤，請修改數據後重新儲存。`,
"vue_label_commonobjects_view_chart_newchart":`建立圖表`,
"label.chat.micropost.a.group":`小組`,
"lable.currencyManage.advcurrencyunEnabled":`進階貨幣管理未啟用`,
"label.appexchange.workflow":`工作流程規則`,
"vue_label_calendar_show_details_and_add_events":`顯示詳細訊息並添加事件`,
"label.salescloud.optionlist.inputname":`在下面輸入選項列表值得名稱`,
"label.dashboard.folder":`儀表板文件夾`,
"label.knowledgebase.permanently.remove.articles":`刪除已歸檔文章會將其和所有關聯版本從知識庫中永久移除。`,
"label.emailtocloudcc.titel":`Email to CloudCC`,
"label.visualpage.sel":`此文件夾中的自訂頁面`,
"label.planned.all.work":`所有計劃的作業`,
"label.weixin.agree.agreement":`同意相關協議`,
"label.forecast.customforecast.qsn":`起始年`,
"label.appupload.managed":`受管`,
"template.report.folder.sale.index":`銷售指標分析`,
"UG_opportunity_011":`匯入交易`,
"label.validate.function.funcFormat.SECOND":`SECOND(date)`,
"UG_homepage_005":`銷售智能`,
"label.clicktoreturn":`點此返回`,
"label.collectionofview":`的視圖集`,
"com.cloudcc.login.error.message.nonuser":`使用者不存在`,
"vue_label_systemSettings_emailsetting":`信箱設定`,
"vue_label_email_mark_as":`標記為`,
"label.tabpage.customernamez":`客戶名`,
"label.appupload.install.apicannotsame":`新的api名稱不能與原值相同`,
"label.task.all.undealt":`所有未處理任務`,
"front-lightning-module-v1-dashborad-statistical-indicators":`統計指標`,
"UG.quota.02":`報價是客戶及供貨商之間關於在指定的時間以指定的價格對指定商品進行交易的法律條款。`,
"label.approve":`批准`,
"vue_label_calendar_remove_calendar":`移除日曆`,
"label.mr.title.contactName":`聯絡人姓名`,
"label.projectManagement.resource":`資源管理`,
"label.rejectbehaviour1":`允許批准人手動選擇返回到第幾步驟。（返回之前第N步）`,
"label.publicgroup.relationship":`小組成員關係`,
"Lead.Scoring.DetailedPage.Popup.Title":`潛在客戶洞察`,
"label.owner.edit":`編輯所有權`,
"label.campaign.channel.ticket.mark":`註：將二維碼通過手機截圖儲存到相簿或者將二維碼儲存到手機，憑此二維碼進場參加活動。`,
"label.opportunity.setting.showstage.info":`行動端詳情頁是否顯示機會階段快捷操作區`,
"label.emailobject.wizard.desc3":`使用電子郵件範本，節省更多時間`,
"label.cpq.quote.no.product.add":`報價單目前沒有新增產品，請新增產品後再產生訂單`,
"label.customer.tab":`自訂選項卡`,
"Opportunity_Detailed_Phase_Label_Popup_002":`離開日期`,
"component_telerecord_label_name":`姓名`,
"label_component_helper_nodata":`目前，無注意事項，請稍候檢查`,
"label.dashboardSetup.d2":`斷點2值`,
"setup.mainpage.label.welcome4":`操作指導： 點擊本頁左側選單 → 應用程式設定 → 建立 → 物件。`,
"label.step4.total5":`第4步，共5步`,
"label.payment.the.remaining.days":`您的帳號有效期還剩{0}天`,
"label.encoding":`編碼`,
"label.setting.intergrationlist.status2":`目前已安裝此集成`,
"label.new":`新建`,
"label.search.searchsetup":`搜尋設置`,
"label_tabpage_printz":`列印`,
"report.type.label.customService":`客戶支援`,
"label.notification.addEmailObject.message":`您有一封信來自{!fromaddress}的郵件，請點擊查看`,
"label.icon.68":`機器`,
"UG.Lead.003":`社交`,
"label_mobile_default_field_service_home":`服務雲首頁`,
"label.select.one.group":`請至少選擇一個報價行組!`,
"front-kefu-moudle-trkey-nopower":``,
"label.chatter.cancel":`取消`,
"label.weixin.report.optiondisplay":`報表選項顯示`,
"front-kefu-moudle-v1-System-version":``,
"lable.product.pricebooks.editall":`編輯全部`,
"label.group.no.recent3":`或`,
"label.knowledge.article.delete":`刪除知識文章出錯`,
"label.relateobj":`相關項`,
"workflow.action.tasks.assignortype.type":`類型`,
"label.layout.selectedfields":`選取欄位`,
"label.role.assign.operate":`要將其他使用者指派給此角色：<br><ul><li>從下拉列表中選擇，以顯示可用使用者。</li><li>從左側選擇一個使用者並將其添加到<b>已選中使用者</b>列表。</li></ul>`,
"label.field.insert":`插入欄位`,
"label.icon.11":`人`,
"label.group.no.recent4":`建立一個小組。`,
"front-epwechat-module-v1-input-corpid":`請輸入Corpld`,
"setup_object_field_dependency_label_actionfieldnotnull":`請先選擇一個控制欄位的值進行設置`,
"setup.mainpage.label.welcome19":`操作指導： 點擊本頁左側選單 → 管理設定 → 管理使用者 → 使用者、角色、設定檔`,
"label.escalation.setup.list.rulename":`規則名稱`,
"label.ems.addaccount":`立即添加帳號`,
"label.reportsSubscription.details.only":`僅限詳細訊息 (Excel 格式 .xlsx)`,
"vue_label_commonobjects_view_groupby":`分組依據`,
"label.email.form.text":`僅文本`,
"label.weixin.loginname":`登錄名`,
"label.forecast.settings.sr":`收入`,
"label.chatter.sendEmailToGroupMember.subject.F":`{0}在小組{1}發布了全員帖子`,
"label.ccchat.enter.subject":`請填寫投票主題`,
"label.customer.tab.introduce":`自訂物件選項卡的外觀和功能與通過系統提供的標準選項卡類似`,
"message.login.mfaverification.wrong":`安全碼錯誤！`,
"component.newrecords.label.name":`名稱`,
"label.salescloud.opportunity.addandedit.contactrole":`?添加和編輯聯絡人角色`,
"label_emailtocloudcc_button_next":`下一步`,
"label.console.step5":`步驟 5.選擇如何顯示記錄`,
"setup.main2018.label.norole":`您沒有系統管理相關權限`,
"template.chart.ywjhqd":`機會階段`,
"label.instrumentPanel.breakpointOneLabelname":`該值要大於最小值`,
"label.qrcode":`二維碼`,
"label_tabpage_no2z":`否2`,
"label.log.search.date.range":`查詢週期不能大於{c}個月！`,
"label.console.step7":`步驟 7.分配設定檔`,
"label.australian.central.standard.time":`中央標準時間（北領地）`,
"label_tabpage_deleteviewfailed":`視圖刪除失敗`,
"vue_label_commonobjects_view_searchview":`搜尋視圖`,
"message.error.object.notexists":`物件不存在`,
"label.tablecell":`單元格`,
"vue_label_notice_edit_success":`編輯成功`,
"label.customer.language":`預設語言`,
"label.csrf":`啟用csrf安全防護`,
"label.forecast.customforecast.submit.zhi":`至`,
"label.sso.saml.idp.config.desc2":`單擊啟用身分識別提供者可以啟用您的CloudCC.com組織作為身分識別提供者。`,
"label.export_data":`匯出資料`,
"component.todaytask.label.all":`查看全部`,
"label.h5.chatter.record":`追蹤記錄`,
"front-vew-email-verification":`檢視電子郵件，並驗證帳戶。如您所知，您僅可在確認郵件後重新登入。`,
"laber.marketsea.del.error":`公海池被占用，無法刪除`,
"vue_label_notice_homepage_entername":`請輸入修改名稱`,
"UG.Forcast.01":`預測`,
"front-email-payment-tips":``,
"setup.mainpage.label.welcome2":`自定製資料庫（物件）`,
"APPIntegration.Social.facebookerror":`必須是一個合法的facebook.com的URL`,
"label.profile.mobile.setup.stand":`標準主頁`,
"label.custom.CY":`自訂年度`,
"label.knowledgebase.publishing.conditions":`{a}條資料發布失敗,不符合發布條件不能發布！`,
"label.tianyancha.description":`啟用天眼查工商數據驗證，使用者輸入企業客戶資料時，可協助使用者輸入正確的客戶工商註冊訊息。此服務有天眼查提供，支援中國大陸註冊的工商企業數據。`,
"label.appexchange.uninstallpage.title":`移除此軟體包會導致：`,
"label.currencyRate":`兌換率`,
"setup_layout_label_areashow":`區功能變數名稱稱顯示位置`,
"label.setup.case.setting":`小程式產生個案`,
"vue_label_commonobjects_view_fixed_at_most":`最多只能固定三列`,
"template.report.month.income":`本月收入`,
"label.sms.companyname":`公司名稱`,
"label.sendemail.registIMUser.waitmessage":`您暫時沒有可以登錄的夥伴雲門戶，稍後請等待管理員通知，存取指定的地址即可進入登錄頁面。請使用上述用戶名、密碼登錄即可。`,
"label.custom.field.task.object":`您好！現有一項任務指派給您，任務主題：`,
"message.pleaseselectdayinweek":`請選擇星期中的一天`,
"label.chat.topic.favorites":`收藏夾`,
"UG.Campaign.004":`匯入行銷活動`,
"label.approval.preview":`審批流程預覽`,
"label.knowledgebase.assign.articles.to.people.or.queues":`選擇目標語言，然後將文章指派給人員或佇列。翻譯匯出通常指派給一個佇列，內部翻譯的文章通常指派給一個人。`,
"pagecreator_systemstyle_message_save_success":`樣式儲存成功`,
"label.outline":`概要`,
"label.read.only.field":`唯讀欄位`,
"front-gantt-module-v1-early-warning":``,
"label.file.ccchat.selectfrompc":`從您的電腦上選擇一個文件`,
"vue_label_systemSettings_social":`社交媒體`,
"label_report_year_last_year":`去年同期比較`,
"lable.PowerProcess.Meet.the.conditions":`需要滿足以下條件：`,
"label.changemydisplay.list.title":`更改我的顯示`,
"UG_Forcast_03":`啟動規劃並執行業務策略。<br> 祝您預測愉快！`,
"label.sendemail.chat.sendmessage":`尊敬的#name:\n\n 您好！ #userName給您發了一條消息。`,
"label.huanxinconfig.secretid.lost":`secretid不能為空`,
"label.icon.49":`發電`,
"chatter.feed.button.publish":`發表`,
"label.power":`^乘方`,
"label.partnerCloud.financeSetting.informationThree":`3.進入密鑰管理介面後，點選【mapi網關產品密鑰】，獲取合作夥伴身份和MD5密鑰。`,
"label.emailtocloudcc.step1.lead2":`配置後，該信箱收到的郵件均可自動產生商機記錄，確保不遺漏任何商機。`,
"label.knowledgebase.delete.draft.succeeded":`刪除草稿成功`,
"label.dashboardSetup.title":`組件編輯器`,
"label.trigger.operation.email.template.map":`返回範本訊息，郵件標題：m.get("subject");郵件內容：m.get("context");郵件類型是否文本：m.get("istext")`,
"label.dependencesearchfilter":`相關查詢篩選器`,
"label.selected.search.length":`已選搜尋欄位不能超過10個`,
"label.profile.commonusercontrol":`普通使用者權限`,
"lable.Microsoft.YaHei":`微軟雅黑`,
"label.appupload.component.type.app":`應用程式`,
"label.customsetting.manage.position":`位置`,
"vue_label_systemSettings_bindweb":`綁定網站`,
"label.loginservice.license.notexist":`許可證不存在`,
"label.icon.43":`鈴鐺`,
"UG_homepage_003":`360度視圖`,
"label.file_format":`檔案格式`,
"label.reportsSubscriptionPage.schedulereport.monthly.day.sunday":`星期日`,
"vue_label_chatter_post_has_delete":`帖子已被刪除`,
"report_label_searchresult":`搜尋結果`,
"label.tabpage.justsz":`剛剛`,
"Lead_Scoring_Setting_LevelSetting":`商機熱度設定`,
"setup.object.field.dependency.label.selectedfieldvalue":`已選欄位值`,
"label.search.morelistview":`更多列表視圖`,
"vue_label_homepage_won":`已贏單`,
"label.notification.last30days":`近30天`,
"vue_label_helpcenter_pool":`使用客戶與商機公海池，管理您的銷售數據。<br>設定公海池<br>在後台建立公海池，設定公海池的管理員與成員，並配置逾期自動回收規則，便於管理您團隊內部的機會跟進情況，鼓勵團隊成員積極跟進。<br>手動管理數據<br>公海池管理員可以在公海池內進行記錄的指派、回收、廢棄、轉移等操作，統一管理公海池內的記錄；<br>公海池成員可以在公海池中領取未指派的記錄，或是查看自己負責的記錄。`,
"label.emailsync.status.export":`匯出為Excel_csv格式文件`,
"label.service.miniProgram.slideshowTitle":`輪播圖`,
"label.service.miniProgram.slideshowName":`輪播圖名稱`,
"label.fieldupdate.selectobj":`為此欄位更新選擇物件並單擊下一步"。欄位更新只能與相同類型的工作流規則和審批流程相關聯。"`,
"label.ccpeak.take.notice.sharetab":`注意：共享表的表達式中欄位不需要加__c"！"`,
"label.log.startdate.after.endate":`開始時間不能大於結束時間！`,
"label.rememberme":`記住用戶名`,
"label.partner.all.maxNum":`夥伴雲的最大數據：`,
"component.setup.iframe.label.inputurl":`輸入URL地址`,
"label.h5.systemmessage":`系統消息`,
"label.delete.date":`刪除日期`,
"front-email-payment-select-month-tips":``,
"front-kefu-moudle-bind-userinfo":``,
"label.appointment.wizard.notif2":`您需要在建立日程預約前先設定好一個預約的時間長度`,
"label.custom.field.maping.number":`商機數字位數不能多於映射欄位位數`,
"label.event.dayview":`日視圖`,
"label.replace":`取代`,
"label.knowledgebase.search.knowledge.articles":`搜尋知識文章`,
"component_event_label_soon":`立即`,
"label.imgfield.upload":`上傳圖片`,
"message.printable.view":`可列印視圖`,
"vue_label_notice_uploadavatar_notice1":`上傳頭像圖片大小不能超過2MB`,
"label.visualpage.developer.help":`自訂頁面開發者 幫助`,
"label.validate.function.funcFormat.IF":`IF(logical_test, value_if_true, value_if_false)`,
"label.sso.saml.sp.description1":`單一登入設定`,
"vue_label_calendar_step_1":`第一步：命名物件日曆`,
"component.telerecord.button.save":`儲存`,
"setup_mainpage_button_manageobject":`物件管理`,
"label.marketingactivityinfluence":`市場活動影響`,
"label.quote.bjjsxx":`報價接受訊息`,
"label.appupload.upload.install.retry":`重新安裝`,
"label.layout.assignrules":`分配規則`,
"UG.Lead.006":`網站訪客`,
"label.workmate.searchs":`搜尋同事`,
"label.visualpage_list.no":`無自訂頁面存取權限`,
"label.service.miniProgram.slideshowintroduce":`輪播圖名稱只是作為辨別多個廣告項目之用，並不顯示在廣告中`,
"label.multilang.messagedetail.search.desc":`我們無法找到含有{0}的訊息：`,
"label.mobile.phone.read.note":`請在此輸入備註`,
"label.passwordPolicy.setup.isUsingGotp":`啟用登錄二次校驗`,
"message.datetypeerror":`<strong>錯誤：</strong> 日期輸入不正確`,
"label.searchlayout.listview.button":`列表視圖中顯示的按鈕。`,
"label.sectionpart":`部分`,
"label.partnerCloud.basicSetting.userSetting":`角色和使用者設定`,
"System_Data_Import_Warning_MaxCount":`您的組織每次只能匯入數據{0}條，現在已經超出，請調整後再次匯入。`,
"label.datamove.qualified.record":`條符合條件的記錄，每次最多可轉移100條！`,
"component_task_label_priority":`優先級`,
"vue_label_report_me":`我`,
"label.college.duplicate.option":`選項不可重複!`,
"label.pw.letter":`字母`,
"label.file.sharedwithme":`與我共享`,
"label.translation":`翻譯`,
"lable.currencyAdv.exchagecurrency.before":`之前`,
"label.file.share":`共享`,
"label.page.next":`下一頁`,
"label.autoRegister.changepwd.setpwd.notmatch":`兩次密碼不一致`,
"label.tabpage.include":`已包含`,
"front-email-payment-thanks":``,
"vue_label_help_helponthispage":`該頁面上的幫助`,
"label.approvepagelayout":`審批版面配置`,
"vue_lightning_help_zero_distance_communication":`通過啟動線上支援請求節省時間，與CloudCC服務專家零距離溝通`,
"vue_label_normal_case_sf":`個案`,
"label.report.line.tuozhuai":`請拖拽或雙擊滑鼠選擇報表列並調整列順序`,
"template.dashboard.management":`經營管理`,
"label.customcomponent.params.info.n1":`使用component標籤中的args屬性的值args為json格式, 如: args`,
"lable.SalesCommitmentKanBan.signedCommitmentRate":`簽約承諾率`,
"label.add.status":`添加狀態`,
"label.loss.customers":`已結束/客戶流失`,
"vue_label_chatter_involving_me":``,
"label.update.input":`請修正輸入`,
"label.import.step1.commonobj":`常用物件`,
"label.appupload.upload.tips.document":`注意："我的個人文件夾"和"範本套紅文件夾"中的文檔不能添加到軟體包，也不能顯示在此列表中。`,
"label.appupload.install.complete":`完成`,
"label.console.edit":`編輯控制臺`,
"setup.object.field.dependency.label.removefromlist":`移除選中值`,
"label.textmessage.groupsms.no.phone":`無手機號`,
"label.account.Current.and.NextFQ":`當前和下一個會計季度`,
"label.sso.saml.sp.idtype.userid":`聲明包含來自使用者物件的使用者ID`,
"label.data.import.setup.operate.update":`更新現有記錄，不插入任何新記錄`,
"front-kefu-moudle-v1-jcaws-call-serve":``,
"label.version.bacheditordel":`批次編輯/刪除/轉移`,
"lable.even.higher":`更高`,
"label.datetime.error":`日期格式不正確`,
"vue_label_commonobjects_detail_customer_hierarchy":`客戶層級結構`,
"label.startuploadfile":`開始上傳`,
"label.appointment.wizard.subtitle3-1":`週一`,
"label.weixin.relevance":`關聯的業務機會`,
"label.datamanage.field.mapping.information":`欄位映射設置`,
"label.brief.lastweek":`上週`,
"label.nextstep":`下一步`,
"label.listtoshow":`以下顯示了一個列表，列示了`,
"label.partner.ishave":`錯誤：域名已存在`,
"label.service.miniProgram.name":`請填寫名稱`,
"label.view.filterbyaddition":`按附加欄位過濾 (可選):`,
"label.projectManagement.nodata.task":`還沒有工作的記錄，快來添加工作訊息吧`,
"label.chooseemailtemplate":`選擇電子郵件範本`,
"label.page.step4.add.profile":`步驟4：添加到設定檔`,
"label.ems.mailtype":`信箱類型`,
"label.weixin.no.pending.projects.vg":`非常棒，暫無待審批項目`,
"label.tabpage.saveviewfailed":`視圖儲存失敗`,
"label.chat.file.upload.cancel":`取消上傳`,
"com.cloudcc.login.error.message.notenabled":`使用者未啟用`,
"label.data.import.setup.operate.insertandupdate":`更新現有記錄並插入新記錄`,
"label_target_type":`目標類型`,
"label.notification.event2":`您指派給【被指派人】的事件被查看`,
"chatter.feed.menutype.feed.news":`我追蹤的內容`,
"label.import.page1.suitedwayofcustomer":`相符客戶方式`,
"label.import.page2.CloudCCfiled":`CloudCC欄位`,
"label.custom.quarter.start":`自訂季度開始日期`,
"label.page.including.tab":`包括選項卡`,
"label.mobile.phone.day.plan2":`今日計劃`,
"template.report.lead.conversion.statistics":`商機轉換統計`,
"label.show.type":`顯示類型`,
"label.weixin.no.pending.wdgz.qin.week":`親，本週沒有工作安排`,
"2018UI.Homepage.DataDeleted.Info":`數據已經刪除，點擊返回上一步。`,
"label.vlidaterule.message":`錯誤訊息`,
"label.approval.remark":`審批意見`,
"label.field.duplicate1":`獨有`,
"label.batchtransfer":`批次轉移`,
"label.quickbooks.view.allinvoices":`全部Invoices`,
"vue_label_commonobjects_detail_lead_selectedstatus":`標記為選中狀態`,
"label_home_page_source":`請選擇數據源`,
"front-kefu-moudle-v1-opencall-please":``,
"setup_layout_label_asc":`升序`,
"label.use_tikect":`使用入場券？`,
"label.tag.setup":`標籤設定`,
"label.existinglayout":`已存在的版面配置`,
"label.productsales.today.noevt":`今天沒有未處理的事件！`,
"message.error.view.date.validerr":`輸入合法的日期格式(YYYY-MM-DD、MM/DD/YYYY)或特殊日期字元`,
"label.mr.descreption.oneGroupReData3":`重複數據，已處理`,
"label.tianyancha.businessverify.msg1":`啟用工商數據驗證功能，使用者應認真閱讀、充分理解本《使用者許可協議》(下稱協議）中各條款，包括免除北京神州雲動客戶股份有限公司責任（下稱CloudCC)的免責條款及對使用者的權利限制條款。請您審慎閱讀並選擇接受或不接受本《協議》。`,
"label.custom.CQ":`自訂季度`,
"label.version.custom.dashboard":`標準儀表板（自訂頁面）`,
"vue_label_commonobjects_detail_dragtoupload":`將文件拖到此處，或<em>點擊上傳</em>`,
"label.tabpage.addadvancedoptions":`添加進階選項`,
"front-kefu-moudle-v1-Launch-page":``,
"label.emailobject.tabname":`郵件`,
"label.weixin.addmore":`添加更多`,
"message.error.view.operator.validerr":`不支援的操作符`,
"label.another_page":`重定向到另一頁面`,
"label.reportTypeFocusD2":``,
"label.icon.47":`氣壓表`,
"label.task.today":`今天的任務`,
"label.service.gantt.weekend.highlight":`強調顯示週末`,
"label.customcomponent.referencetagname":`標籤名稱`,
"label.senderemail":`發件人電子郵箱地址`,
"label.defaultvalue":`預設值`,
"label_tabpage_Sdfez":`天前`,
"pagecreator.page.label.pagename":`頁面名稱`,
"vue_label_report_pagenumber":`範圍內的頁碼值`,
"label.emailsync.connectaccount.description":`將您的個人信箱添加於此，系統將自動根據郵件的收發地址相符系統中的商機、聯絡人，並將郵件內容同步至該記錄下，便於追蹤與客戶的溝通進度。`,
"label.schedulableprg.chooseweek":`請選擇每週下的星期日期`,
"lable.edit.queue.membercanuse":`可用成員`,
"lable.Quick.find":`快速查找`,
"label.daynuminmonth":`個月的第`,
"message.error.state":`state不能為空！`,
"label.introduction.the.form":``,
"label.batchtransfer.pleaseselectcomefromuser":`請選擇轉移自使用者`,
"front-dashboard-module-implemented":`已實現`,
"label.custombutton.newerror":`新建失敗`,
"label.version.allow.size":`，已超出上限！如有需要，請升級CloudCC版本！`,
"label.weixin.account.loginpage":`客戶安全登錄頁面`,
"message.pleaseselectfieldtype":`請選擇欄位類型`,
"component.setup.label.parentobject":`上級物件`,
"System.TAB.SeeViewAmount":`查看總數`,
"label.event.lastmonth":`上月`,
"label.taskrecordtype":`任務記錄類型`,
"label.layout.selectedpages":`選取頁面`,
"label.appointmentdetail.wizard.title19":`週六時間規劃`,
"label_chatter_endData":`結束日期`,
"label.appupload":`軟體包`,
"label.knowledgebase.article.link":`連結文章`,
"label.licence.enddate":`許可證到期時間`,
"chatter.fieldtrack.record":`記錄`,
"label.reportsSubscriptionPage.schedulereport.weekly":`每周`,
"label.forecast.editshrepage.title2":`編輯共用`,
"label.attendance.onwork.time":`上班時間`,
"label.appointment.wizard.subtitle1-8":`3小時`,
"pagecreator.layout.button.upload":`上傳配置`,
"label.input.notless.than.number":`請輸入一個大於或等於 {0} 的數字`,
"setup.mainpage.label.welcome13":`操作指導： 點擊頂部選單 → 報表 → 建立 。`,
"label.forecast.settings.data.opp":`業務機會關閉日期`,
"vue_label_display_checkbox_field":`顯示複選框欄位`,
"label.summaryreport.2018.step5":`步驟5：選擇圖表類型和報表突出顯示`,
"front-lightning-module-v1-dashborad-one-statistic":`請至少選擇一個統計值和統計類型`,
"label.home.standard.dashboard.forcase":`您沒有設置允許預測，不能查看銷售承諾看板。`,
"page.field.track":`欄位追蹤`,
"label.dataimport.format.datetime.error":`格式錯誤，請使用yyyy/MM/dd HH:mm:ss或者yyyy-MM-dd HH:mm:ss的格式。`,
"lable.opppdt.selPbk.title":`選擇價格手冊`,
"pagecreator_systemstyle_label_stylename":`樣式名稱`,
"label.projectManagement.nodata.project":`沒有找到相關數據，快來建立與我相關的項目吧`,
"label.start_below":`開始分享表單給聯絡人。您的表單已安全發布，可以在以下網址中使用。`,
"label.campaignmember.main.delete":`批次刪除市場活動成員`,
"label.modifyall":`修改全部`,
"label.homepage":`首頁`,
"vue_label_pool_adoptedbyme":`我領取的`,
"label.email.clearItem":`只清空未關聯相關項的郵件`,
"label.callcenter.login.Amazon.connect":``,
"label.import.page1.selectimportfiled":`選擇要匯入的文件`,
"message.error.id":`id不能為空！`,
"label.ggReleaseRange.searchUsers":`搜尋合作夥伴使用者`,
"label.changemypwd":`更改我的密碼`,
"label.ccpeak.reference.parameters":`可以直接引用的參數有：`,
"chatter.share.success.tip":`成功！您已將此帖子共享至`,
"label.message.checkfailed":`語法檢查失敗 ,該類名稱已被使用!`,
"label.shangqing.introduction":`對商機或客戶近期內發生的熱點事件進行整合分析，協助銷售更全面的瞭解客戶`,
"label.allemailnotice":`全部電子郵件通知`,
"vue_label_report_copy":`複製報表`,
"label.exchange.sync.state.setting":`配置設置`,
"label.merge.result.error1":`以下記錄處於被鎖定狀態，不允許進行 \"合併\" 操作`,
"label.process.des":`若要查看當前記錄的詳細訊息，請點左側連結進入。`,
"label.textmessage.vonage.create.lead.setting":`當收到未輸入在系統電話的簡訊時，建立新的商機`,
"label.views":`檢視量`,
"label.notification.tip1":`您現在沒有任何通知`,
"label.forecast.detailforecast.returnforecast":`返回預測`,
"label.knowledgebase.target.framework.name":`目標框架名稱`,
"label.brief.close.opportunities":`贏單機會數`,
"label.appointment.wizard.subtitle4-2":`最晚日程提醒時間`,
"vue_label_systemSettings_set_record":`設定記錄詳情相關清單的展示形式，可以切換卡片形式和清單式兩種`,
"pagecreator_page_message_publish_fail":`頁面發布失敗`,
"vue_label_homepage_name":`主頁名稱`,
"label.weixin.no.pending.wdgz.qin.month":`親，本月當前週沒有工作安排`,
"label.campagin.register.page":`市場活動成員註冊頁面`,
"label.campaign.channel.edit":`市場活動：編輯營銷管道`,
"label.folder":`文件夾`,
"label.umeng.chatter.follow":`追蹤了您`,
"label.sso.theKeyToEdit":`密鑰編輯`,
"label.deletelayout":`刪除頁面配置`,
"label.same.analyze.miaoshu":`以上條件關係為：“業務機會名稱” 或 “客戶名稱” 或 （“聯絡人手機” 與 “聯絡人電子郵件”）;`,
"label.ccpeak.sel":`此檔夾中的類別`,
"label.tabpage.addtoworkbench":`添加至首頁工作台`,
"label.forecast.shrepage.classdes.r":`唯讀 - 使用者可以查看預測數據。`,
"homepage.custompagename":`自訂主頁名稱`,
"label.sendemail.batchapprovalinfo":`#name 您好:\r\n 您執行的批次審批操作已成功,共審批成功#successnum條,審批失敗#errornum條。`,
"front-email-payment-Invoice-alipay-describe":``,
"setup.object.field.dependency.label.configured":`已配置內容`,
"label.potentialcustomers":`商機`,
"label.timetrigger.button":`添加時間觸發器按鈕在以下情況下不可用：`,
"label.category.10":`律師`,
"label.selectall":`全選`,
"message.field.id.not.null":`欄位ID不能為空`,
"CloudCCCRM.ST.Info.TypeIn.001":`請輸入`,
"label.author":`作者`,
"label.import.step1.csvonly":`1、只支援csv格式的文件，最多單次匯入{recordnumlimit}條記錄，若需執行觸發器，則最多匯入2000條，超出限制的記錄，系統會自動忽略。若需匯入更多數據，請先拆分為多個文件，分次匯入。`,
"label.assignment.setup.newrule.name":`規則名`,
"label.campaignmember.selectmember.chosestatusdesc":`請選擇要添加成員的市場活動，並制定他們的成員狀態。要建立新市場活動，必須退出此過程。`,
"label_tabpage_operation":`操作`,
"label_tabpage_datatyoez":`資料類型`,
"UG_product_04":`建立產品`,
"label_emailtocloudcc_step1_case2":`配置後，該信箱收到的郵件均可自動產生個案，並根據寄件者相符聯繫人與客戶，將個案掛在對應的客戶與聯繫人之上，方便Case服務的受理與追蹤。`,
"workflow.action.tasks.assignortype.role":`角色`,
"vue_label_notice_refreshi_success":`重新整理成功`,
"label.notification.arketsea.abandon":`{5}廢棄了{2}{0}：{1}`,
"label.icon.36":`電腦`,
"chatter.group.cancelToJoin":`取消加入`,
"label.publicgroups.edit":`編輯公用小組`,
"message.duplication.label.letternum":`匹配字元位數`,
"label.brief.lost.opportunities":`丟單機會數`,
"setup.layout.label.nofield":`暫無可選欄位`,
"label.dataimport.isSharingRule":`執行共享規則`,
"vue_label_opportunity_contactrole_synctocontacts":`將訊息同步到聯絡人上`,
"attachment_button_massdownload":`批次下載`,
"label.weixin.agreement.remark":`此微信服務是愛馬社對客戶出險諮詢服務的輔助工具，不作為保險公司理賠的最終依據，客戶理賠應以保險公司實際要求為準`,
"label.partnerCloud.basicSetting.introTwo":``,
"pagecreator_layout_funcpath":`/構建器/配置庫`,
"label.ccdocument.online.edit":`文檔在線編輯`,
"label.partner.setup.Enable":``,
"label.log.state":`操作狀態`,
"label.lower.bound":`下界`,
"label.timezone.isenable":`啟用使用者多時區，讓使用者設置自己的時區並且日期時間以使用者時區顯示`,
"label.martrixreport.setrowtitle":`指定列標題`,
"label.bottom":`底部`,
"label.multilang.ccchat.groupnotcontainsname":`您不是名稱中含有{0}的任何活動小組的成員`,
"label.step1.of.step5":`第1步，共5步`,
"message.report.error.FieldListIsAmbiguous":`報表的欄位中有公式欄位引用了下面這個欄位，導致了異常，請去掉這個公式欄位。公式引用的欄位：`,
"label.monitorsys.operator.ip":`IP`,
"ccchat.fieldtrack.fieldchange":`從 {0} 更改為 {1}`,
"label.report.export.print.content":`導出當前報表表頭，分組與前2000條數據`,
"message.thanksusing":`感謝使用 cloudCC.com！`,
"label.reportexport.allobject":`匯出所有物件`,
"label.projectManagement.working.hours.per.day":`每天工作小時數`,
"label.partnerCloud.financeSetting.enterCollaborator":`請輸入合作者身份`,
"label.defineReportRecords":`定義報表記錄集`,
"greate":`大於`,
"label.sure_discard":`您確定要放棄您的修改嗎？`,
"label.escalation.setup.newaction.notifyowner":`通知個案擁有者`,
"label.icon.28":`博士帽`,
"lable.PowerProcess.see.page":`是否確定要刪除“{name}”篩選器?`,
"message.error.object.relogin":`登錄失敗，請再次嘗試重新登錄`,
"label.chatter.activity":`活動`,
"label.query.clone.detail.choose.canChoose":`可選明細物件`,
"chatter.using.object":`啟用物件的微貼追蹤，以便使用者能追蹤該物件類型的記錄。選擇要追蹤的欄位，以便當這些欄位在使用者追蹤的記錄上發生更改時，使用者能看到微貼更新。`,
"UG.opportunity.001":`您如何監控您的銷售?`,
"label.ServiceCloud.fuwuziyuan.distributionMap":`服務資源分佈圖`,
"vue_label_email_current_email":`插入此範本將覆蓋當前郵件`,
"label.h5.approval.page.layout":`您可如下方式設置批准版面配置：<br>設置->建立->工作流程和審批->審批流程<br>選擇對應的審批流程，點擊審批流程名稱，<br>選擇編輯->批准版面配置<br>即可進行批准版面配置設置。`,
"component.hots.label.title":`熱門交易`,
"mail.foldername.notOnly":`該檔案已存在`,
"label.customer.tab.step1":`步驟1：輸入詳細訊息`,
"label.delete.persion":`刪除人`,
"chatter.changed0":`將{0}從{1}更改至{2}`,
"homepage.components.type":`組件類型`,
"label.norfolk.isiands.time":`諾福克時間`,
"label.product.pricebooks.view":`價格手冊視圖`,
"label.forecast.customforecast.director":`直接下屬`,
"label.emailtocloudcc.step3total3":`第3步，共3步`,
"label.cloudccsite.end":`禁用站點主頁`,
"label.login.verification.mfa.device":`驗證虛擬MFA設備`,
"chatter.follow":`我要追蹤`,
"label.month's":`月的`,
"label.sendmail.step1.introduce":`選擇以下視圖之一(其中包含此電子郵件的收件人)。`,
"label.shangqing.title":`商情設定`,
"label.rejectrecords":`拒絶記錄`,
"label.selectupdatevalue":`選擇要更改至的目標值`,
"vue_label_pricebook_disabled":`價格手冊已禁用`,
"component.chatter.label.title":`最新微貼`,
"label.partner.all.workspace":`工作區`,
"label.querydetailservice.delete.message":`數據被刪除或者不存在`,
"label.objectRelationshipWithout":`具有或沒有相關記錄`,
"nocontain":`不包含`,
"label.partnerCloud.financeSetting.accountSettings":`夥伴帳戶設定`,
"label.file.sharetype.owner":`擁有者`,
"label.open.multilingual":`啟用多語言`,
"label.searchresult.field":`搜尋結果欄位`,
"label.tabpage.selectdate":`選擇日期`,
"label.h5.logouting":`註銷`,
"label.quickbooks.fieldlabel.payment":`付款方式`,
"label.chatter.leaveword":`留言`,
"label.customfields.majoranddetailrelation.tip":`建立一個此物件（子級或詳細訊息"）與另一物件（父級或"主"）之間的特殊父子關係類型，其中：<br>●所有詳細訊息記錄的關係欄位必填。<br>●一旦關係欄位的值被保存，就無法更改。</li><br>●詳細訊息記錄的所有權和共享由主記錄確定。</li><br>●當使用者刪除主記錄時，將刪除所有詳細訊息記錄 。</li><br>●您可以在主記錄上建立累計彙總欄位以彙總詳細訊息記錄。</li><br>關係欄位允許使用者單擊查找圖標，以從彈出列表中選擇值。 主物件是列表中值的來源。"`,
"label.batchapproveorrefuse":`批次批准/拒絕批准請求`,
"label.copy.success":`複製成功`,
"vue_label_show_record_count":`顯示記錄計數`,
"label.ems.delete.false":`刪除失敗`,
"label.new.Product.Goals":`建立產品目標`,
"label_chatter_BCC":`密件副本`,
"label.knowledgebase.data.archived.successfully":`{a}條資料歸檔成功`,
"label.chuangming.title":`創明網路簡訊網關`,
"label.notification.arketsea.recovery":`您的{0}:{1} 已被{5}回收至{2}`,
"label.partnerCloud.orderingPlatform.paymentAmount":`支付金額：`,
"label.martrixreport.2018.step5.new":`步驟5：選擇報表標準`,
"label.testing":`檢測中...`,
"chatter.poll.option4":`選項4`,
"lable.outlook.detail.otc":`Exchange 到 CloudCC.com`,
"label.startuploadfile.batch.step2":`步驟 2.單擊“開始上傳”按鈕，上傳文件`,
"lable.outlook.edit.outdes":`請輸入已在 Exchange中建立的自訂欄位。在將此自訂 Exchange欄位映射到 cloudCC.com 欄位前，cloudCC.com 將在首次同步時驗證 Exchange 欄位是否存在。`,
"hour":`小時`,
"label.appointmentpage.wizard.notif4":`無效郵件格式`,
"label.import.index.state":`狀態`,
"label.integrations.mailchimp.massage6":`當前頁面中選中的數據將會匯出至您選中的Mailchimp列表中`,
"label.file.share.email.subject":`#sharedBy已在#orgname上與您共享了文件`,
"label.assignment.setup.newentries.noassignment":`不要重新分配擁有者`,
"label.dashboard.unit1":`單位：萬`,
"label.forecast.customforecast.foretype.commit":``,
"label.type":`類型`,
"label.partner.workspace.login.logo":`頁首標誌`,
"pagecreator_systemstyle_button_edit":`編輯樣式`,
"label.displaytype2":`詳細訊息頁面按鈕`,
"email.one":``,
"label.partnerCloud.orderingPlatform.unavailable":`無可用產品`,
"vue_label_email_save_the_signature_successfully":`儲存簽名成功`,
"label.reportsSubscriptionPage.email.detailed":`詳盡`,
"chatter.group.query":`查詢`,
"label.translation.unsupported.format":`不支援的格式，多語言匯入只支援property格式`,
"message.operateexception":`訊息提示（如有問題請與您的系統管理員聯繫）。`,
"label.sendemail.chat.praiseFeedcomment":`尊敬的#name:\n\n 您好！ #userName對您的留言(#href)點了喜歡。`,
"label.recycle.clearmy":`清空您的回收桶`,
"label_tabpage_choose":`選擇`,
"#label.importstep2tip":`如果您想上傳多個文件，您可以將所有的文件壓縮在一起匯入。#`,
"label.batchedit":`批次編輯`,
"label.integrations.mailchimp.export":`匯出至Mailchimp`,
"label.cloudccsite.name":`站點名稱`,
"serviceterritory.serviceappointment.iscontain.contain":`因為服務區域和服務預約關聯，因此無法刪除服務區域，您可以不啟用此服務區域`,
"label.sum":`總數`,
"setup.mainpage.label.welcome29":`標準的API 與第三方產品集成`,
"label.tabpage.nothingz":`無`,
"label.weixin.actual.contract.jine":`實際合約金額`,
"label.tabpage.emailaddressz":`發件人地址`,
"label.dashboard.unit4":`單位：千萬`,
"label.dashboard.data.labels":`資料標籤`,
"label.import.page2.oneonone":`一個CloudCC欄位只能和一個文件中欄位對應`,
"homepage.components.name":`組件名稱`,
"template.report.task.theme":`工作主題`,
"component.setup.label.setupsaveok":`組件設定儲存成功`,
"front-epwechat-module-v1-add-selfapp":`新增自建應用`,
"label.to.save.the.current.page.information.button.":`如需儲存當前頁面訊息，請點擊“快速儲存”按鈕。`,
"vue_label_file_not_support_preview":`該文件不支援預覽，請下載後查看`,
"label.object.reached.limit":`物件已達到限定個數`,
"label.partnerCloud.basicSetting.online":`啟用線上支付`,
"label.app.step1.error.nameexist":`公用小組名稱已存在`,
"label.workflowandapprove":`工作流程和審批`,
"label.recordtypeselect.change.tip":`更改記錄的記錄類型時，現有選項列表值不會自動更改。我們建議在相同的地方更新記錄上的現有選項列表值。`,
"label.summaryreport.step6":`步驟 6：選擇報表標準`,
"Pagelayout.Setup.004":`最多只能配置4個欄位`,
"label.file.attached":`附加`,
"front-invoice-online-payment-setup-configure":``,
"label.approvaldatamove.submitdate":`提交日期`,
"label.emailobject.time.from":`發件人：`,
"label.dataimport.insertdata.error.fieldrepeat.insert":`該記錄中的$schemefield_name$欄位在數據庫中已存在，不再進行插入，該記錄已忽略匯入。`,
"assetbom.copy.notpermission":`請聯繫管理員，您不具有複製資產BOM的權限`,
"lable.outlook.mcto.autoallocation":`自動將他們分配至相關的CloudCC.com記錄`,
"label.dataimport.but.datalength":`，但是數據的長度是`,
"label.setuserstocommit":`使用下面的選項，指定哪些使用者可以提交初始批准請求。`,
"component_telerecord_label_related":`相關項`,
"front-lighting-module-v1-detail-file-lockInfo":`記錄已鎖定，不支援新增檔案，請聯繫管理者解鎖。`,
"pagecreator_layout_button_edit":`編輯配置`,
"label.app.step3.tabcanuse":`可用選項卡`,
"label.ems.delete.sure":`確定要刪除這筆信箱帳號訊息?`,
"label.email.show":`顯示`,
"label.checkbox.unchecked":`未選中的`,
"message.error.operation":`操作失敗,請聯繫系統管理員！`,
"label.template.set.folder.only.upload.type.file":`範本套紅文件夾只能上傳Word、Excel、PPT類型的文件`,
"label.knowledgebase.select.publish.status":`請選擇發布狀態`,
"label.recordtype.tabname.edit":`為所選記錄類型輸入新名稱，然後單擊“儲存”`,
"label.tabpage.exportview":`匯出視圖`,
"label.dataimport.insert.sharetab":`插入共享表失敗。`,
"vue_label_dashboard_penetrateto":`穿透到`,
"label.weixin.group.member":`人員`,
"vue_label_systemSettings_customadd":`自訂擴充`,
"UG_Account_03":`主動查詢重覆客戶並合併`,
"label.singapore.standard.time":`新加坡時間`,
"label.weixin.captcha":`驗證碼`,
"Account_News_Setting_004":`啟用新聞`,
"label_emailtocloudcc_select1":`請選擇`,
"label_ring_ratio":`月增長比`,
"label.industrialandcommercialverification.button.save":`儲存`,
"label.approvalstep5.tip":`批准頁面是審批者實際批准或拒絕請求的地方。使用下面的選項，選擇要在此頁面上顯示的欄位的編輯屬性。`,
"label.import.page1.maxrecord{{30000}}":`1、您一次最多能匯入{{30000}}條記錄`,
"setup_object_layout_label_profileoptions":`可分配設定檔`,
"label.emailtemplate.type":`範本類型`,
"label.searchlayout.tab.field":`選項卡下顯示的欄位。`,
"chatter.news":`消息`,
"label.pw.small.letter":`小寫字母`,
"label.notification.group3":`您被拒絕加入公用小組`,
"label.ccchat.day.before.yesterday":`前天`,
"component.chatter.post.label.title":`張貼`,
"label.tianyancha.type":`法人類型`,
"label.detail.searchlayout":`查看搜尋配置`,
"vue_label_pool_deleteconfirm":`確認刪除選中的{1}條數據嗎?`,
"label.import.index.maxmb{{100}}，maxitem{{30000}}":`1、只支援csv格式的文件，最大支援{{100}}mb，最多單次匯入條{{30000}}條記錄；若超過限制，請先拆分為多個文件，分次匯入；`,
"label.h5.similar.opportunity.lookup":`查找類似業務機會`,
"template.report.customer.list.opportunity":`有更多機會的客戶清單`,
"component_setup_iframe_label_memo":`點擊設置圖標，輸入嵌入的URL地址。`,
"label.version.allemail":`群發電子郵件`,
"lable.product.editp":`編輯價格`,
"label.weixin.plate.number":`車牌號`,
"font-evaluate-module-v1-disabled-successfully":``,
"label.multilingual.tip1":`使用此一頁面定義您的組織使用的所有語言。`,
"label.japan.standard.time":`日本標準時間`,
"lable.product.notdel.use":`的刪除嘗試,因為它仍與以下記錄相關聯.這種情況下,建議您禁用。`,
"label.appointment.wizard.subtitle4-2-4":`4小時`,
"label.queue.edit":`編輯`,
"label.partnerCloud.financeSetting.informationTwo":`2.商家中心首頁點選【帳戶管理】-【商戶資訊管理】-【產看PIDIKEY】-【密鑰管理】。`,
"label.partnerCloud.partnerOrdering.permission":`夥伴訂貨使用權限`,
"vue_label_commonobjects_detail_company_hierarchy":`公司層級結構`,
"label.forecast.settings.sl":`數量`,
"label.partner.workspace.tab.memo":`選擇在此夥伴雲中可以使用的選項卡，可以選擇系統標準選項卡和自訂選項卡。`,
"label.mr.mainRecord":`主記錄`,
"setup_mainpage_label_welcome20":`郵件、簡訊範本`,
"front-email-payment-select-date-tips":``,
"label.dependencelisttag":`相關列表標籤`,
"label.umeng.activity.eventof":`的事件`,
"label.sales.dashboard.collection":`收款目標`,
"report_label_folder":`文件夾`,
"label.assignment.setup.newentries.step1":`步驟 1：設置此規則項目的順序`,
"label.quote.shrname":`收貨人姓名`,
"label.newreport.group.sum":`分組數統計`,
"label.number.MinCheck":`{0}最小數量為{1}，請修改數量後再點選儲存。`,
"label.chatter.save":`儲存`,
"vue_label_email_all_email_templates":`全部郵件範本`,
"message.summaryconditionnototal":`彙總條件不得選擇累計彙總欄位！`,
"label.callboard":`公告`,
"label.step2.total5":`第2步，共5步`,
"vue_label_homepage_custom_homepage_page":`自訂主頁`,
"label.data.newtemplate.e_seltype":`選擇資料匯出方式`,
"label.data.dataexpalltype.all.desc2":`2、匯出全部的數據較多，需要一定的時間。匯出完成後，系統將為您發送一封匯出成功的郵件。`,
"lable.account.CalenderYear":`日曆年度`,
"message.error.data":`傳遞的數據不能為空，請檢查傳遞的參數`,
"label.from_user":`來自使用者`,
"label.parentdepartment":`上級部門`,
"template.dashboard.product.analysis":`產品分析`,
"label.tabpage.unpacketz":`無可用分組數據！`,
"label.icon.107":`溝通`,
"label.monitorsys.operator.username":`使用者`,
"label.serchreport":`搜尋報表`,
"label.payment.upgrade":`升級`,
"setup_layout_button_ok":`確定`,
"label.please.select.channel":`請選擇通路負責人`,
"template.chart.txdrw":`提醒的工作`,
"chatter.group.accept":`接受`,
"pagecreator_systemstyle_message_canntdelete":`當前樣式不允許刪除`,
"label_tabpage_ctbtsftcz":`點擊後面搜尋選擇內容`,
"label.datamanage.select.accountfield":`（選擇匯入客户所對應的欄位）`,
"label.schedulejob.setup.list.title":`定時作業`,
"label.visualpage_list.title":`已啟用的自訂頁面存取`,
"label.mr.selectTwoData":`請選擇至少兩條待合併的數據。`,
"label.customer.tab.step2.different":`對每個設定檔應用不同的選項卡可視性`,
"label.mobile.side.tab.can":`可用`,
"label.log.url":`URI`,
"label.weixin.cloudccnumber.isgoon":`CloudCC帳號已綁定，如繼續，以前綁定此CloudCC帳號的微信號將不能使用微CloudCC系統。是否繼續？`,
"label.applet.to.case":`小程式版客戶服務入口網頁`,
"lable.outlook.detail.cmaping":`聯絡人欄位映射`,
"label.theUserActiveTime":`使用者活躍期`,
"label.event.moveup.9hour":`提前 9 小時`,
"vue_label_pool_other":`其他`,
"label.fieldname":`欄位名`,
"vue_label_notice_add_success":`添加成功`,
"label.conditiontag.lookup.insertbutton":`插入所選`,
"label.identifying":`標識`,
"label.tabpage.uploadingz":`上傳中`,
"label.view.introduce":`編輯視圖`,
"vue_label_dashboard_sortingmethod":`請選擇排序方式`,
"label.quote.number.introduce":``,
"front-kefu-moudle-which-missphone-case":``,
"label.sendemail.chat.response":`微貼回覆：`,
"label.productsales.refreshTime":`上次重新整理時間`,
"lable.SalesCommitmentKanBan.phase":`階段`,
"label.version.sum.object":`個物件`,
"label.defineReportStep2":`步驟2`,
"message.duplication.label.returnDuplications":`返回查重過濾器列表`,
"label.lookover":`查看`,
"label.quickbooks.button.copy2":`從CloudCC上同步至QuickBooks`,
"label.checkbox.true":`是`,
"label.profilename":`設定檔名稱`,
"label.finalapproveoperate":`最終批准操作`,
"label.SMS.detailed":`簡訊通知是觸發時工作流程規則發送的簡訊。`,
"label.lasttimemodifier":`上次修改人`,
"label.sso.summary":`彙總`,
"label.customfields.encd.tip":`允許使用者輸入任何字母和數字組合,並將他們以明文格式存儲,可加密格式顯示,可搜尋。`,
"vue_label_report_formulacolumn":`行級公式列`,
"vue_label_systemSettings_transfer":`批次轉移記錄`,
"lable.product.ecm":`行情輸入正確的金額`,
"label.partner.setup":`夥伴雲設置`,
"label.same.analyze.miaoshu2":`“功能`,
"label.mobile.phone.day.summary":`今日總結`,
"label.ccchat.person.error.illdomain":`錯誤：存在域格式填寫不正確`,
"label.knowledgebase.edit.as.draft":`作為草稿編輯`,
"message.duplication.label.newfilterule":`新建查重過濾器規則`,
"vue_label_salesfunnel_notice1":`機會匯總`,
"label.partnerCloud.partnerAccount.order":`訂單號：`,
"label.account.Current.and.PreviousFQ":`當前和上一個會計季度`,
"label.customfields.formula.dateandtimeexample":`Next（下一值）`,
"label.area.unassign":`未分配的使用者`,
"label.at.my":`我@的內容`,
"vue_label_calendar_notice_stopsharingfail":`停止共用失敗`,
"label.data.file.validation.rules":`執行驗證規則`,
"label.escalation.setup.entrydetail.escalation.hour":`小時`,
"vue_label_ccchat_notice_pleaseentercontent":`請輸入發帖內容和選項`,
"label.forecast.edit.error1":`錯誤：幣種無效`,
"label_emailtocloudcc_exists1":`此信箱已經設定為Email to Lead，請勿重覆設定`,
"label.trigger.send.email":`觸發器發郵件通知：`,
"label.setmysafetysignagain":``,
"label.callcenter.pleaseenter.access.keyID":``,
"chatter.poll.option10":`選項10`,
"vue_label_systemSettings_mobelbottonsetting2":`公司統一底部選單設定`,
"label.quickbooks.searchs":`搜尋`,
"label.section":`段`,
"label.customfields.fielddependency.new.tip":`建立一個相依關係，該關係將導致基於使用者在另一個欄位中選擇的值對選項列表或多選列表中的值進行動態篩選。<ul ><li>驅動篩選的欄位稱為控制欄位。具有至少一個值且小於300個值的標準和自訂複選框和選項列表可以是控制欄位</li><li>其值被篩選的欄位稱為相依欄位。自訂選項列表和多選列表可以是相依欄位。</li></ul>`,
"label.customobjects.track.introduce3":`請注意：僅追蹤更改部分顯示的欄位，在追蹤欄位值時，只顯示“已更改”`,
"front-kefu-moudle-all-hidden-phone":``,
"vue_label_calendar_share_calendar_with_others":`與他人共用日曆`,
"label.case.copre":`下載網頁版客戶服務入口網頁二維碼`,
"label.conditiontag.lookup.pagetitle":`選擇選項列表值`,
"UG.opportunity.004":`多業務類型`,
"label.event.moveup.1day":`提前 1 天`,
"label.industrialandcommercialverification.enablestatus1":`啟用工商數據驗證`,
"label.ccpeak.newrecord.getorpost":`新增記錄：使用CCObject物件，CCObject有兩個構造方法`,
"frame.personinfo.label.resizeimage":`要調整您的縮圖，請拖放並調整設定檔照片上方的虛線。`,
"label.optional.searchresultfield":`可選搜尋結果欄位`,
"UG.Contract.02":`合約是各方之間的書面協議。許多公司使用合約定義與其他公司從事業務往來的條款。使用 CloudCC 建立您與您的客戶和機會已有的合約，並為其提供文檔。通過批准流程，追蹤合約。使用工作流提醒，以提醒您合約展期。`,
"label.group.activity":`活動小組`,
"label.tabpage.characterz":`起始字元`,
"label.globalsearch.tip":`请输入搜尋內容`,
"label.campaign.channel.download.size2":`中尺寸：500*500像素`,
"label.step3.total4":`第3步，共4步`,
"label.partnerCloud.payForFailure":`支付失敗`,
"label.ggReleaseRange.editSuccess":`編輯成功`,
"label.summaryinforelyon":`彙總訊息依據`,
"label.productsales.htyj":`合約業績`,
"label.newpagelayout":`新版配置`,
"front-gantt-module-input-task-name":``,
"label.c_d_without":`C" 記錄可能有或沒有相關 "D" 記錄。"`,
"label.licence":`許可證`,
"setup.layout.button.selectall":`全選`,
"label.app.step1.error.appnameexist":`錯誤：應用程式名稱已存在`,
"label.cpq.quote.item.no.record":`只有訂單產品有記錄才能轉換為合約`,
"label.knowledgebase.noaffect.existing.translations":`否，我的更改不會影響現有翻譯。`,
"label.schedulejob.setup.schedule.editjob":`編輯排程工作`,
"lable.PowerProcess.Tips":`權利過程是包含所有步驟（重大事件）的可自訂時間線，支援客服等工作人員必須完成所有步驟，才能解決支援的個案或者工作訂單記錄。在設定完成後，可以將其應用到權利中。`,
"label.campaignmember.selectmember.step2":`步驟2：選擇要添加的成員`,
"vue_label_calendar_stopsharing":`是否確認停止共用日曆`,
"vue_label_notice_savemenu_fail":`選單儲存失敗`,
"message.error.getitems.id":`getItems:id不能為空`,
"label.return.currencylist":`返回列表：幣種管理`,
"label.wtd.detail.p":`PC版`,
"label.knowledgebase.publish.now":`現在發布`,
"label.appupload.install.explain":`安裝說明`,
"label.visualpage.folder.all":`所有頁面文件夾`,
"message.passwordPolicy.validate.complexReq2":`錯誤：密碼必須是數字和大小寫字母的組合`,
"label.umeng.chatter.at":`提及了您`,
"label.mobile.phone.month.report":`月報`,
"label.describableEditeSelectedFields":`選擇作為新建自訂報表時預設顯示在報表列的欄位`,
"component.event.label.subject":`主題`,
"label.knowledgebase.edit.draft":`編輯草稿？`,
"label.customer.tab.step1.selectoneobject":`選擇一個現有自訂物件`,
"label_partner_step2":`步驟2：確認範本`,
"label_starting_annual":`起始年度`,
"X":`文本區`,
"label.customer.tab.style":`選項卡樣式`,
"vue_label_commonobjects_detail_book":``,
"chatter.email.referredToMe":`在帖子裡提及我時（即@時）`,
"label.enable.both.barcode.qrcode":`同時啟用條碼 二維碼`,
"front-market-form-quired-choose":``,
"noinclude":`不包括`,
"label.sms.template.select":`請選擇簡訊範本`,
"label.weixin.optionten":`選項十`,
"message.duplication.label.matchlastletters":`後n個字元匹配`,
"label.webtocloudcc.submit.success":`提交成功`,
"label.sales.dashboard.number":`第`,
"label.custom.field":`將此自訂欄位`,
"label.dataimport.of.field":`個欄位。`,
"label.view.new":`建立新視圖`,
"UG_activity_03":`預約日程`,
"label.customfields.image.tip":`允許使用者上傳圖片`,
"label.startexport":`開始匯出`,
"vue_label_commonobjects_view_chart_verticalbar":`垂直柱狀圖`,
"label.ccchat.person.invite.allexist":`您邀請的每個人已經在使用同事圈`,
"label.fielddependence":`欄位相依性`,
"label.scan.tip":`使用IE7、IE8、Chrome或Firefox瀏覽器，建議使用1024×768以上解析度`,
"label.wei.weiactor":`微投票參與者`,
"label.service.miniProgram.quantity":`輪播記錄最多建立20條~`,
"vue_label_homepage_new_homepage_page":`新首頁`,
"label.apply.telphone.validate.error":`手機驗證碼錯誤。`,
"component.assistant.button.newevent":`建立事件`,
"System_TimeField_Format_Warning":`不是有效時間`,
"chatter.feed.publishfeed":`張貼`,
"label.setting.intergrationlist":`集成應用`,
"label.object.prefix":`物件首碼`,
"label.tippage.confirmed":`是，我希望刪除自訂報表類型及所有依賴報表`,
"label_emailsync_form_signin":`登錄`,
"label.delete.cancel":`取消刪除`,
"label.dashboard.myHomePage.des":`選擇要在您的每一個應用程式中顯示的儀表板。`,
"lable.account.FY.Ago":`兩個會計年度之前`,
"label.umeng.approval.reassign":`#approver已重新指派#obj申請`,
"label.data.exp.zippwd2":`自動產生壓縮檔密碼`,
"label.tabpage.contentz":`請輸入內容`,
"label.callcenter.batch.add.number":``,
"label.tabpage.deleteviewsuccess":`視圖刪除成功`,
"setup_layout_group_field":`欄位`,
"label.appupload.component.addobj.scheme.label.suoshu":`所屬物件`,
"front-project-module-v1-market-is-template":`標記為範本`,
"label.service.gantt.one.esource.types":`以及以下其中一種資源類型`,
"label.emailtocloudcc.search":`搜尋`,
"label.mobile.home.page.myyj":`我的業績`,
"vue_label_normal_invoice_sf":`發票`,
"label.permission.detail.app.fenpei.tip":`指定應用程式選單上面何種應用程式可視的設置`,
"label.login.access.month":`月`,
"label_tabpage_retypez":`更改記錄的記錄類型時，現有選項列表值不會自動更改。我們建議在相同的地方更新記錄上的現有選項列表值。`,
"label.ems.private.company.message":`私有雲版本不支援線上編輯公司信箱`,
"label.dataimport.length.check":`長度超過18位，請仔細檢查本條記錄並修改。`,
"label.batchtransfer.type1":`轉移不屬於現有客戶擁有者的未處理業務機會`,
"vue_label_calendar_are_you_sure_to_remove":`確定移除此日曆嗎`,
"label.icon.117":`書包`,
"vue_label_systemSettings_downloadapp":`下載移動程式`,
"label.approval.project":`待審批項目`,
"template.organization":`組織級`,
"label.weixin.return.research":`返回微調研訊息頁面`,
"label.ccchat.person.invite.addsay":`添加一條可選的訊息...`,
"UG.Case.02":`個案可讓您響應並解決客戶問題。個案在 Cloud CC中是功能強大的記錄，不僅可以追蹤客戶問題，而且也可以顯示完整的客戶視圖。`,
"label_emailtocloudcc_step1":`步驟1`,
"workflow.action.tasks.assignortype.owner":`擁有者`,
"label.data.import.page":`進入數據匯入頁面`,
"label.cache":`緩存`,
"label.custom.page.cuspage.width":`頁面寬度（像素）`,
"label.customcomponent.referencetag":`引用標籤`,
"label.tabpage.search":`搜尋`,
"label.knowledge.searcharticle.casefields":`用於查找推薦文章的個案欄位`,
"setup_layout_message_relatedlistfield":`選擇在相關列表上顯示的欄位，您也可以對選定欄位重新排序。`,
"label.relationobject.type":`相關物件類型`,
"UG_Account_02":`有些企業向其它企業提供服務，有些企業直接與終端使用者進行合作，有些則服務於NGO組織。`,
"UG_homepage_006":`通過問卷調查、即時聊天、郵件、工單對社交媒體貼文甚至銷售活動（如商機、服務支援和活動）來360度瞭解您的客戶活動。`,
"chatter.poll.option1":`選項1`,
"label.ccdocument.fieldforld":`文檔所屬文件夾名稱`,
"label.wei.result":`投票結果`,
"label.recentview.new":`最新`,
"label.martrixreport.setsumfield":`選擇將在您的矩陣報表中用作彙總行的欄位`,
"label.reportsSubscriptionPage.schedulereport.weekly.monday":`星期一`,
"label.marketsea.button.recycle":`回收`,
"label.standard.buttonandlink.info2":`請選擇用來取代此標準按鈕或連結的CloudCC URL的自訂頁面。`,
"label.reportsSubscription.select.two.months":`該頻率的日期範圍請選擇在兩個月之內!`,
"label.standard.buttonandlink.page":`標準CloudCC頁面`,
"vue_label_commonobjects_view_chart_horizontalbar":`水平柱狀圖`,
"label.Remove":`移除`,
"label.mobile.phone.receivable":`收款`,
"label.appupload.uploaddetail.goback":`返回軟體包列表`,
"label.select.role":`請選擇角色`,
"label.file.sharetype":`共享類型`,
"label.app.chosetab":`選擇選項卡`,
"label.case.other.phone":`其他手機號碼`,
"chatter.edit.cancel":`您的更改已取消。`,
"label.html":`HTML`,
"message.auth2cn.acquisition.failed":`auth2cn獲取失敗！`,
"message.error.system.service.permissiondeny":`對不起，您沒有被授權此服務，請聯繫系統管理員！`,
"label.chatter.mygroups":`我的小組`,
"label.umeng.approval.approvalpass":`#obj批准請求已通過#objname`,
"label.chatter.owner":`擁有者`,
"vue_label_commonobjects_view_kanban_view":`看板視圖`,
"message.please.choose.group.role":`請選擇小組角色`,
"label.icon.136":`貨幣`,
"label_tabpage_selectdate":`選擇日期`,
"chatter.emailInformation":`一般訊息`,
"front-lightning-module-v1-dashborad-bubble-size":`氣泡大小`,
"label.stdashbord.xsld.business.wan":`萬`,
"label.datamanage.field.notexist":`物件對應的欄位不存在`,
"UG.Forcast.04":`開始試用`,
"UG.contact.02":`通過多個通路吸引聯絡人 通話, 信箱 , 社交`,
"vue_label_pool_selecttransferinto":`選擇轉入的公海池`,
"label.quote.xingming":`姓名`,
"label.customerinfo.userlicencenum":`使用者許可證數`,
"label.group.no.my.archived":`找不到相符的已歸檔小組。`,
"label.weixin.add.activity.tel":`添加活動電話`,
"label.partner.setup.address":`夥伴雲地址`,
"label.data.file.i_title.num3":`3.系統會把將要匯入的資料文件預讀到伺服器，然後啟動後台批次處理匯入程序，匯入結果將以郵件方式通知使用者，您無需在此操作頁面等待。`,
"label_sum_up":`求和`,
"label.searchall.title":`全局搜尋`,
"label.bind.chooseone":`選擇擁有者`,
"label.campaign.channel.input.owner.select1":`當前市場活動所有人`,
"front-kefu-moudle-v1-Expand-chat":``,
"label.component.hotdeal":`熱門交易`,
"component_event_label_title":`即將進行的事件`,
"No.planed.activity":`暫無計劃中的活動`,
"label.searchlayout.result.field":`搜尋結果顯示的欄位。`,
"label.leadscore.value":`分值`,
"vue.dashboard.linkage.is.set.successfully":`設定聯動成功！`,
"PersonalInfo.LoginHistory.001":`瀏覽器驗證信箱註冊連結`,
"front-gantt-module-v1-problem-number":``,
"label.page.step5.of.step5":`第5步，共5步`,
"label.sendemail.chat.sendmessagesubject":`CloudCC CCChat 消息提醒`,
"label.Linkedin_accounts":`LinkedIn帳號`,
"label.qrcode.useful.life":`二維碼有效期`,
"deleterow":`刪除行`,
"label.forecast.settings.future1":`未來1個週期`,
"message.error.group.operation":`小組歸檔錯誤`,
"label_tabpage_loadz":`頁面加載中，請稍後...`,
"label.brackets.left":`(左括號`,
"label.source.code":`原始碼查看`,
"setup_layout_label_areasetup":`設置區域屬性`,
"component.assistant.label.todaylead":`今天指派給您的商機`,
"label.qrcode_signin":`二維碼僅限於需要現場掃描和登入的應用程式`,
"label.calendarshare":`日曆共用`,
"IMG":`圖片`,
"label.use.rule.when.both":`同時啟用條碼和二維碼規則時，使用此一規則`,
"label.ccpeak.addshare.record":`新增共享表記錄：見新增記錄。`,
"label.enable.email.tracking":`啟用電子郵件追蹤`,
"label.top.plsinput":`搜尋內容`,
"vue_label_helpcenter_case":`個案是客戶的問題、回饋意見或事件。支援工作人員可以檢閱個案以瞭解他們可以如何提供更好的服務。銷售代表可以使用個案來瞭解它們如何影響銷售流程。回應個案可讓客戶保持滿意並增強您的品牌價值。`,
"label.useonly":`專用`,
"label.displaytype":`顯示類型`,
"label.most.user.group":`使用者最多可加入100個使用者組。您已加入100個`,
"label.umeng.activity.yourevent":`您的事件`,
"label.forecast.shrepage.classdes.w":`讀 / 寫 - 使用者可以查看和覆蓋預測數據。`,
"label.defaultaccess":`預設存取權限`,
"label.partner.new.step2":`步驟2：確認範本`,
"component_setup_iframe_label_title":`自訂頁面`,
"label.sso.saml.sp.idenitytype":`SAML身份類型`,
"label.dashboard.this.folder":`此文件夾中的儀表板`,
"label.data.newtemplate.e.seltype.desc":`資料匯出方式有兩種：</li><li class`,
"label.forecast.customforecast.submit.tip1":`是否提交從`,
"label.version.workflow.and.approval":`工作流程和審批自動化`,
"label.tianyancha.tip":`輸入有誤，請重新輸入！`,
"label.report_details":`報表詳情`,
"template.report.folder.contract.product":`合約和產品分析`,
"label.all":`所有`,
"label.version.area.long.rich":`{0}個富文本或長文本區欄位`,
"label.enc":`儲存加密`,
"vue_label_pricebook_enterproductname":`請輸入產品名稱`,
"label.edit.quote.line":`編輯報價行`,
"label.edit":`編輯`,
"M":`主詳訊息關係`,
"front-kefu-phonenumber-exists":``,
"label.standardplatformuser":`標準平台使用者`,
"label.custom.page.configuration":`自訂頁面配置`,
"url.error.contact.null":`微服務地址為空`,
"label.sethelp":`幫助設置`,
"setup.mainpage.label.welcome23":`安全性設定`,
"label.sales.page.dashboard.fenxi":`銷售分析儀表板`,
"label.limit":`權限`,
"maintenanceasset.asset.contractlineitem.illegal":`您必須先在合約行項目上選擇資產，才能將合約行項目與維護資產關聯。`,
"UG.contact.04":`或者`,
"Opportunity.Detailed.Phase.Label.004":`天`,
"label.emailobject.receive":`收件人`,
"label.brief.new":`新增`,
"label.marketsea.button.adopt":`領取`,
"label.select.up.to.three.fields":`最多選擇三個欄位`,
"vue_label_allsearch_noresults":`我們已搜尋您常用的搜尋項，未找到與{userInput}相符的結果`,
"Report_CantDelete_Info":`{0}報表被{1}儀表板引用，不可刪除！`,
"label.chile.summer.time":`智利時間`,
"label.partnerCloud.menu.selectedMenu":`已選選單（勾選的選單將同時顯示於行動端）`,
"vue_label_report_onlysummary":`僅匯總`,
"front-template-V1-Applicable-object":`請選擇適用物件`,
"label.invoice.message.sendfailed":`Invoice發送失敗，請稍後重試`,
"front-kefu-moudle-v1-use-free":`免費試用`,
"label.rule.updated.successfully":`規則更新成功`,
"label.owner.lastone":`至少維護一個條件`,
"label.appointment.wizard.subtitle1":``,
"template.report.opportunities.closed.month":`本月關閉的機會`,
"label.tabpage.choosecontent":`請選擇值內容`,
"template.chart.jbnddxl":`近半年訂單銷量`,
"label.fieldsecurity.detail":`欄位安全性詳細訊息`,
"label.knowledgebase.data.deleted.successfully":`{a}條資料刪除成功`,
"label.sso.saml.idp.config.nameidfmt":`名稱ID格式`,
"label.emailobject.prompt":`提示`,
"label.marketsea.isgetbyself":`允許成員自行領取`,
"label.winxin.cancelprompt":`當前操作未儲存，是否確認退出`,
"label.appexchange.installedpage.message2":`應用程式和組件以軟體包的形式進行安裝。任何自訂的應用程式、選項卡、自訂物件、自訂頁面和觸發器開始都標記為“正在開發”，且不向使用者部署。這使您可以在部署之前先測試和自訂它們。您可以使用設置中的其他功能單獨部署組件，或者單擊部署以作為一個組件來進行部署。`,
"vue_label_import_importtype":`匯入類型`,
"label.data.importef.des":`匯入失敗的檔將在伺服器上保留48小時，48小時後將自動刪除。`,
"chatter.email.reply":`對我的帖子進行回覆時`,
"label.stdashbord.xsld.business.sdl":`失單率`,
"labal.emailtemplate.namemessage":`郵件範本的唯一名稱已存在，請重新編輯`,
"vue_label_email_Please_select_file":`請選擇文件`,
"label.event.modify":`編輯事件`,
"label.projectManagement.isnmber":`請輸入最多一位小數的數字`,
"lable.outlook.detail.emailst":`電子郵件設置`,
"label.partnerCloud.priceOfManual.isUsed":`該設定影響夥伴使用者訂貨時，是否可以使用該價格手冊。`,
"setup_mainpage_label_welcome26":`數據管理 - 批次處理功能`,
"label.file.version":`版本`,
"pagecreator_systemstyle_label_bordercolor":`邊框顏色`,
"label.approval.isallowed.reject.prompt":`單一數據審批時是否允許拒絕（批次審批始終可以拒絕）`,
"label.myinfo":`我的訊息`,
"front-template-V1-fontSize":`字號`,
"lable.outlook.edit.alpreo":`始終首選Exchange`,
"front-email-payment-card-number":``,
"label.cpq.quote.pricebook.no.change":`報價單的價格手冊一旦確定後，不可以再更改。如果使用新的價格手冊，請建立1條報價單記錄`,
"vue_label_file_size_limit_tip":`文件大小超過限制`,
"lable.PowerProcess.worktime":`權利過程工作時間`,
"label.monthly.month.report":`月度年增長與月增長報表`,
"front-kefu-moudle-v1-sydq-buyuser":`您的試用已到期，請購買環信帳號後使用`,
"label_tabpage_Rolesz":`角色和下屬`,
"chatter.f.n":`追蹤該記錄`,
"UG.Forcast.02":`預測是對指定階段預期銷售的估算，預測模式可幫助您確定一段時間內的產品需求和銷售收入情況。管理者可以使用預測來設定目標並衡量團隊的進展情況。機構的整體預測可按銷售代表來反映所有銷售的概要情況（不論銷售處於從管道階段到關閉階段之間的何種完成階段）。`,
"label.productsales.contract.phb":`合約排行榜`,
"label.umeng.insert.approval.submit":``,
"message.duplication.label.matchfirstletters":`前n個字元匹配`,
"label.partnerCloud.partnerAccount.toPay":`前往支付`,
"label.model.un":`型號：UN6786`,
"label.save.c1":`web to cloudcc 的名稱不能重複!`,
"week":`星期`,
"Pagelayout.Setup.003":`Name欄位必須選擇`,
"label.query.detail.openpartnermessage":`一旦將客戶作為合作夥伴啟用，它就會出現在isPartner欄位上篩選過的報表和列表視圖中。另外，合作夥伴使用者可以從與此客戶關聯的聯絡人進行建立。是否確定？`,
"label.validate.function.funcFormat.DATEVALUE":`DATEVALUE(date)`,
"label.apply.send.false":`發送失敗。`,
"label.recordtype.edit.selectvalue":`選項列表值`,
"label.chosesubject":`選擇主題`,
"label.validate.function.funcExplain.YEAR":`返回日期的年份，是 1900 與 9999 之間的一個數字`,
"component.chatter.button.more":`查看更多詳細訊息`,
"label.top.class.smallest":`階層最小是1`,
"label.startingvalue":`初始編號`,
"label.multi.layout.remark":`應用於前台主從錄入及批次新增時所顯示的配置`,
"label.role.availableuser":`可選使用者`,
"label.weixin.iebrowser":`您當前使用的瀏覽器版本為IE6，IE6是微軟2001年發佈，由於此瀏覽器版本過低，CloudCC系統是採用新技術開發，不保證所有功能正常使用，請及時下載更新您的瀏覽器。`,
"Homepage_News_004":`暫無新聞`,
"vue_label_normal_task_sf":`工作`,
"label.version.nonsupport.trigger":`暫不支援觸發器！`,
"pagecreator_page_label_pagelayout":`版面配置`,
"label_tabpage_step3":`第三步：選擇要顯示的欄位`,
"label.canOnlyUploadCSVFormatFile":`只能上傳csv格式文件。`,
"label.b.c.least":`每個 B" 記錄必須至少有一個相關 "C" 記錄。"`,
"label.list.userinterface.sales.enable":`銷售主頁排行榜查看數據啟用權限`,
"label.umeng.approval.approvalreject":`#obj批准請求被拒絕#objname`,
"vue_labenl_normal_notice_share_fail":`共用失敗`,
"label_emailtocloudcc_tip":`提示`,
"label.h5.touchselect":`?點擊選擇`,
"label.tabularreport":`列表式報表`,
"label.app.defaulttab":`預設選項卡`,
"label.validate.function.category.Datetime":`日期和時間`,
"vue_label_pricebook_editdetail":`編輯價格手冊項目`,
"vue_label_commonobjects_view_no_selected_record":`未選擇記錄`,
"chatter.changed":`將`,
"label.asset.bom.based":`根據訂單的產品結構產生資產BOM`,
"label.appointmentdetail.wizard.title8":`每隔多久開始`,
"label.area.query.user.error":`查詢區域對應的使用者數據失敗，區域ID為空。`,
"page.field.masterinput":`設置主從錄入`,
"chatter.selads":`選擇收件人`,
"label.data.exp.please.savebutton":`請勾選“另存為範本”。`,
"label.members.activity":`查看重大事件`,
"label.weixin.click.searchs":`點擊查找記錄`,
"label.input.least.two":`請輸入至少兩個字元`,
"label.marketing.seting":`市場雲設定`,
"label.approveprocess.tip":`審批是一個複雜的業務過程，它需要在實施前收集訊息併進行計劃。建議您在開始前遵從以下指導說明。`,
"front-email-payment-Invoice-login-account":``,
"label.selectmulti.mes":`所選收件人 過多。`,
"label.workflow.gotolist":`返回工作流程列表`,
"label.profile.fieldsafety":`欄位級安全性`,
"front-project-module-v1-no-selectemplat":`目前無可用範本`,
"label.sendemail.queue.assigntitle":`佇列指派物件記錄通知郵件`,
"label.approval.mobile.comments.placeholder":`請在此輸入備註，最多1000字`,
"vue_label_report_given":`特定`,
"vue_label_dashboard_groups":`請選擇分組`,
"label.service.gantt.popoverTip":`大約外出旅行距離/預計外出旅行時間`,
"label.mr.title.characters":`按前幾個字元`,
"label.passwordPolicy.setup.day":`天`,
"label_tabpage_personvisible":`相關人員可視`,
"ct":`多幣種`,
"label.chatter.newEvent":`建立事件`,
"vue_label_systemSettings_id":`登入身份`,
"label.page.preview.web.tab":`預覽Web 選項卡`,
"label_emailsync_button_sure":`確認`,
"front-template-V1-Modification-time":`修改時間`,
"vue_label_homepage_edit_fixed_components":`編輯標準組件`,
"label.apply":`應用`,
"Main.Menu.Mobiledownload":`可用於`,
"vue_label_salesfunnel_notice6":`可能性為100%的機會總金額`,
"label.chosesubject.sendemail":`發郵件`,
"label.changemydisplay.chagetab.des":`選擇要在您的每一個應用程式中顯示的選項卡。`,
"label.attendance.setting.checkUser":`已經存在其他的考勤中.`,
"label.list.projectSetting.setup":`項目管理設定`,
"label.app.introduce2":`您可以自訂現有應用程式以匹配您的工作方式，或通過對標準和自訂選項卡分組構建新應用程式`,
"label_emailsync_form_emialpassword":`密碼`,
"label.Lightning.Setting":`Lightning設定`,
"label.print.preview":`列印預覽`,
"label_vue_create_edit_obj_create_event_dialog_desc_alert":`您是否仍要在該時間段內建立本事件？`,
"label.mobile.phone.report.type":`報告類型`,
"lable.account.CalenderWeek":`日曆星期`,
"label_emailtocloudcc_step3total3":`第3步，共3步`,
"label_tabpage_emailaddressz":`發件人郵件地址`,
"label.data.is_woking":`正在操作`,
"label.knowledge.cancelattach.case":``,
"label.sendemail.chat.chatcontent":`主貼內容：`,
"label.timezone.set":`區域設置`,
"label_tabpage_uploadingz":`上傳中`,
"front-epwechat-module-v1-home-url":`主頁url：`,
"label.reportsSubscription.select.subscription.frequency":`請選擇訂閱頻率！`,
"label.validate.function":`函數`,
"label.partnerCloud.orderingPlatform.quantity":`購買數量`,
"label.compact.layout.chatter":`微帖`,
"label.sso.saml.sp.description2":`配置單一登入，以便從外部環境登錄CloudCC系統`,
"label.ccchat.message.new.error1":`我們找不到任何姓名帶有{0}的Chat使用者`,
"label.file.share.email.content3":`具體訊息請登錄Cloudcc CRM系統查看`,
"label.file.cancel.sharing":`取消共享`,
"label.changemydisplay.showalltabs.add":`添加選項卡到預設顯示`,
"label_chatter_incident":`事件`,
"label.file.folder.delete3":`您確定要刪除 {foldername}嗎？`,
"label_tabpage_delsuccessz":`刪除成功`,
"label.view_contact":`檢視聯絡人`,
"label.deactivate":`禁用`,
"label.Horizontal.Date":`按日期分組`,
"label.forecast.tree.title":`預測階層架構`,
"vue_label_dashboard_dategruop":`請選擇日期分組依據`,
"label.version.nonsupport.custompage":`暫不支援自訂頁面！`,
"label.tabpage.personvisible":`相關人員可視`,
"message.error.unknown":`未知的錯誤;`,
"label.down":`向下`,
"label.multilang.customforcast.financialyear":`第{0}會計年度`,
"label.dataimport.type.error":`類型錯誤，請仔細檢查本條記錄並修改。`,
"label.batchadd.newbatchpage.save.num":`數值格式不正確`,
"front-Dev-V12.2.8-calendar-endField":`結束欄位`,
"label.tabpage.rtemptyz":`記錄類型不能為空`,
"vue_label_dashboard_maximum":`請輸入最大值`,
"label.expiredate":`到期日期`,
"label_emailtocloudcc_button_view":`查看`,
"label.event.future":`未來的事件`,
"label.mobile.app.layout":`行動端配置`,
"label.emailobject.contacts":`個聯絡人`,
"label.approvalstep2.tip":`指定記錄在進入此步驟前是否滿足某些條件。`,
"label.usefollowtoset":`使用下麵的選項，指定批准請求應分配給的使用者。`,
"label.dashboard.summary.editPageHeader":`編輯頁首`,
"label_partner_workspace_tab_memo":`選擇在此夥伴雲中可以使用的選項卡，可以選擇系統標準選項卡和自訂選項卡。`,
"front-lightning-module-v1-details-page-chart-title-supports":`· 標題支援插入記錄名稱，格式為{recordname}，如：設定的名稱為{recordname}的機會總金額，目前記錄名稱為神州雲動，則在展示時名稱為“神州雲動的機會總金額”；`,
"label.enable.generate.location.service":`啟用根據客戶地址產生客戶經緯度數據服務`,
"label.loginsystem":`登入系統`,
"label.email.template.edit.template":`編輯範本`,
"vue_label_commonobjects_detail_share":`收入份額`,
"label.icon.142":`房子`,
"label.maintype":`主類型`,
"label.step2.total4":`第2步，共4步`,
"label.select.intended.tablayout":`選擇希望建立的 Web 選項卡的頁面配置`,
"label.custom.unit":`單位元`,
"label.mr.title.phone":`電話`,
"label.compact.layout.frame.showtype":`顯示方式：`,
"label.associations":`關聯物件`,
"label.potentialcustomers.name":`商機名稱`,
"label.edit.profile":`更新設定檔`,
"label.tabpage.allvisible":`所有使用者皆可視`,
"label.login.verification.confirmation.enabled":`確認啟用`,
"vue_label_norm_recordselected":`已選擇{selectNum}條數據`,
"label.partner.workspace.member.selectedprofile":`已選設定檔`,
"label.divide":`/除`,
"label.version.case.control":`Case 管理`,
"label.attendance.nocheckin":`未簽到`,
"vue_label_helpcenter_report2.1":`2、移除行分組：<br>&nbsp;&nbsp;&nbsp;&nbsp;A.在左側“組行”列表中找到想要移除的“行分組”欄位後，單擊欄位框上的“×”。<br>&nbsp;&nbsp;&nbsp;&nbsp;B.或在右側預覽報表的表頭中找到想要移除的“行分組”欄位後，單擊“下拉按鈕”，單擊“刪除組行”。 <br>&nbsp;&nbsp;&nbsp;&nbsp;移除列分組：<br>&nbsp;&nbsp;&nbsp;&nbsp;A.在左側“組列”列表中找到想要移除的“列分組”欄位後，單擊欄位框上的“×”。<br>&nbsp;&nbsp;&nbsp;&nbsp;B.或在右側預覽報表的表頭中找到想要移除的“列分組”欄位後，單擊下拉按鈕，單擊“刪除組列”。 <br>自訂日期粒度分組記錄<br>&nbsp;&nbsp;&nbsp;&nbsp;步驟1：在按日期欄位分組記錄後，您也可以自訂日期粒度。首先，選擇您想要作為報表分組依據的日期欄位。然後單擊預覽報表表頭中的這個欄位旁的“下拉按鈕”，單擊“日期分組依據”。 <br>&nbsp;&nbsp;&nbsp;&nbsp;步驟2：選擇您想要的分組方式：日、月、年、會計季度、會計年、自訂季度、自訂年。<br>在報表中匯總列<br>&nbsp;&nbsp;&nbsp;&nbsp;步驟1：在預覽報表的表頭中找到想要匯總的“列”後，單擊“下拉按鈕”，單擊“匯總”。 <br>&nbsp;&nbsp;&nbsp;&nbsp;步驟2：選擇您如何匯總列：總和、平均、最大值、最小值。<br>對報表中的數據進行升、降冪排列<br>&nbsp;&nbsp;&nbsp;&nbsp;單擊預覽報表表頭中的任意欄位旁的“↑”或“↓”標志，。報表中的數據將按照這個欄位的升、降冪進行排列。<br>顯示或隱藏詳細訊息行<br>&nbsp;&nbsp;&nbsp;&nbsp;在進行分組後，通過預覽報表右上方的“詳細訊息行”開關，您可以顯示或隱藏詳細訊息行。“詳細訊息行”開關預設關閉。<br>開啟或關閉自動更新預覽<br>&nbsp;&nbsp;&nbsp;&nbsp;通過預覽報表右上方的“自動更新預覽”開關，您可以開啟或關閉自動更新預覽。開啟後，您的每一步操作對數據產生的影響將會在預覽報表中自動展示。想要篩選報表記錄，單擊篩選器<br>&nbsp;&nbsp;&nbsp;&nbsp;篩選器分為標準篩選器和欄位篩選器。<br>&nbsp;&nbsp;&nbsp;&nbsp;其中標準篩選器包含“角色”篩選器、“向我顯示”篩選器和“日期”篩選器。<br>&nbsp;&nbsp;&nbsp;&nbsp;A.“角色”篩選器，通過當前角色和直屬下屬角色劃分數據，單擊角色名稱可切換不同角色。<br>&nbsp;&nbsp;&nbsp;&nbsp;B.“向我顯示”篩選器，通過“向我顯示”和“向擁有者顯示”劃分數據，“向我顯示”展示的是擁有者是當前使用者的數據，“向擁有者顯示”展示的是當前使用者具有查看權限的所有數據。<br>&nbsp;&nbsp;&nbsp;&nbsp;C.“日期範圍”篩選器，通過日期劃分一段時間範圍內的數據，例如“建立日期”、“結束日期”。 <br>&nbsp;&nbsp;&nbsp;&nbsp;其中欄位篩選器包含欄位篩選器和進階篩選器。<br>&nbsp;&nbsp;&nbsp;&nbsp;`,
"label.payment.renew":`續約`,
"vue_label_file_wrong_type":`文件上傳類型有誤,您現在上傳的文件格式是{type}!`,
"UG_opportunity_005":`多銷售流程`,
"label.knowledge.language.korean":`韓語`,
"label.customobjects.inputrecordtagandformat":`輸入記錄的標籤和格式`,
"label.h5.chatter.commentednum":`收到的回覆`,
"label.quickbooks.button.unlink":`取消關聯`,
"label.step5.total5":`第5步，共5步`,
"label.projectManagement.Selweek":`選擇週`,
"label.optional.searchfield":`可選搜尋欄位`,
"label.mobile.quickcreate.default.signin":`簽到`,
"label.visualpage.unable.parse":`無法解析的標記`,
"mesage.error.role.delete":`無法刪除角色，因為當前為角色分配了子角色。`,
"label.role.user":`角色中的使用者`,
"button_partner_workspace_saveas":`另存為`,
"label.file.no.public.link.created":`未建立公用連結`,
"label.login.access.shenyu":`餘下`,
"label.ccchat.group.section":`小組`,
"label.weixin.object.notnull":`主題不能為空`,
"label.accmarketsea.add.title":`客戶公海池建立`,
"label.sales.funnel.layout":`銷售漏斗配置`,
"pagecreator.page.button.edit":`編輯`,
"label_tabpage_entercontent":`請輸入內容`,
"component_event_label_begindate":`*開始時間`,
"label.file.versionhref":`跳轉到新版頁面&gt;&gt;`,
"label_chatter_send":`發送`,
"setup_layout_label_buttonlist":`按鈕選擇`,
"label.custom.Current.and.NexttCQ":`當前和未來三個自訂季度`,
"pagecreator_page_label_pagedesc":`頁面描述`,
"label.appupload.upload.uploader":`上傳人`,
"label.console.step5.tab.primary":`作為主選項卡`,
"vue_label_globalsearch_expandlist":`展開列表`,
"label.forecast.edit.userqu":`的目標`,
"label.step1.total5":`第1步，共5步`,
"label.multilang.dupicatecheck.onegroupredata":`查詢重複數據合併進度：共{0}組：`,
"vue_label_systemSettings_repeat":`管理重複`,
"label.mobile.side.tab.error1":`請選擇需要展示的常用功能、應用程式選項卡`,
"label.knowledgebase.reduction":`還原`,
"label.standard.buttonandlink.override.usedefault":`沒有覆蓋（使用預設）`,
"dateandtime":`日期/時間`,
"label.group.activate.info":`啟用小組`,
"label.triggertotask":`任務觸發器`,
"label.emailobject.save.template":`儲存為範本`,
"label.audit.objInfo":`審批詳情`,
"label.callcenter.successfully.logged.account":``,
"label_new_customer_target":`建立客戶目標`,
"label.campaign.channel.step5":`步驟5：營銷管道註冊頁面預覽與原代碼查看`,
"label.log.type":`操作類型`,
"front-template-V1-noTemplate":`目前切換對象下沒有可用範本`,
"label_report_line_daixuan":`待選報表列`,
"label.tianyancha.businessverify.relation.tip":`將天眼查返回的欄位回寫到客戶欄位上`,
"label.default.value":`將此值作為主選項列表的預設值`,
"label.weixin.campaign.attendance":`市場活動簽到`,
"message.duplication.label.check":`校驗`,
"label.salescloud.salescloud.yes2forbidden":`?是 ，禁用小組銷售`,
"lable.currencyAdv.exchagecurrency.rate":`匯率範圍`,
"lable.Hide.title":`隱藏標題`,
"label.finishedreport":`已產生的報表`,
"vue_label_account_business":`轉移客戶擁有者的已結束機會`,
"vue_label_pool_assigned":`已指派`,
"label.report.export.error":`匯出遇到異常，請重新操作。`,
"label.layout.availablefield":`可用欄位`,
"label.licence.remainder":`許可證剩餘數量`,
"label.approval.idea.required":`審批意見必填`,
"front-kefu-moudle-needhand-createcase":``,
"label.dashboard.snapshot.Data.change":`資料來源發生變化，請重新配置`,
"label.partner.workspace.login.footertext":`頁尾文本`,
"vue_label_chatter_upload_link_type":`已選擇上傳連結類型帖子`,
"front-dialog-module-v1-error-detail":`錯誤詳情`,
"label.emailobject.sendgroupemail":`批次發送郵件`,
"lable.newtabpage.allviews":`全部視圖`,
"label.khdd":`客戶地點`,
"vue_label_dashboard_sortfield":`排序欄位`,
"label.form.sample":`表單示例`,
"component_setup_button_cancel":`取消`,
"vue_label_salesfunnel_notice5":`可能性為1%-99%的機會金額*可能性`,
"pagecreator_systemstyle_label_modifystyle":`樣式編輯器`,
"UG_homepage_001":`在較少的時間贏得更多的交易`,
"label.campaign.pc":`電腦端`,
"label.visualpage.lightning":`lightning版本`,
"label.knowledge.category.hint.two":`建立類別組後，使用此頁面來選擇 Lightning 應使用的組。`,
"label.south.africa.standard.time":`南非標準時間`,
"label.service.gantt.reservation.number":`預約編號`,
"label.weixin.report.period":`時間段`,
"label.leadtomap.exp":`將組織的每個商機欄位映射到客戶、聯絡人或機會欄位。在轉換商機時將使用這些映射。`,
"label.currency.d":`可以將公司幣種更改為貴組織支援的另一種幣種。系統中以定義的所有貨幣兌換率將作相應修改以反映此次修改。`,
"label.forecast.detailforecast.oppyclb":`業務機會預測類別`,
"label.reportsSubscriptionPage.email.selected":`所選成員`,
"vue_label_homepage_componentname":`請輸入組件名稱`,
"lable.account.Previous.FYt":`前兩個會計年度`,
"label.appupload.success":`上傳完成`,
"label.customer.newtab":`新建自訂頁面選項卡`,
"label.value.notnull":`值不能為空`,
"label.case.miniprogram.layout":`小程序報修版面配置為從小程序端提交的服務請求單所使用的版面配置，此版面配置只能編輯，不能刪除。`,
"label.partnerCloud.partnerAccount.twoDecimal":`請輸入正確格式，可保留兩位小數`,
"UG.Lead.004":`Web表單`,
"label.umeng.activity.event.eventwillbeginnew":`事件通知:#event，開始時間#begintime`,
"label.projectManagement.subtasks":`子工作`,
"vue_label_checkduplicate_repeat_conditions":`判定重複條件`,
"label.subject":`主題`,
"label_search_otherusers_forecast":``,
"label_tabpage_namemandatory":`視圖名稱為必填內容`,
"label.timezone.importtimezone":`資料匯入日期時間欄位時區設置`,
"label.mobile.buttom.team.init":`群策使用者初始化`,
"label.checkfield.choosefield":`請選擇要進行查重的欄位`,
"label.b_c_least":`每個 B" 記錄必須至少有一個相關 "C" 記錄。"`,
"label.knowledge.setting.hint.five":`選擇Knowledge作者`,
"label.h5.similar.opportunity.step2":`步驟2.指定匹配條件`,
"label.page.style.imbedded.cloudcc":`使用整頁樣式可以最大限度的查看嵌入CloudCC.com視窗的螢幕內容。`,
"label.sendemail.marketactivity.invitecode":`行銷活動#campaignname的邀約碼`,
"label.block.pricing":`分塊定價`,
"message.error.field.number.zero":`長度輸入格式有誤,不能是0`,
"pagecreator.systemstyle.message.save.success":`樣式儲存成功`,
"pagecreator_systemstyle_label_styledesc":`樣式描述`,
"APPIntegration_Dropbox_setting_01":`啟用`,
"label_emailtocloudcc_redmessage2":`請輸入正確的信箱密碼`,
"label.user.special.operations":`運營專用，暫不能使用，請聯繫管理員！`,
"pagecreator_page_label_layoutpreview":`配置預覽`,
"APPIntegration_Dropbox_setting_03":`啟用Dropbox，讓您可直接在附件上從Dropbox裡面選擇文件。`,
"label.sure_leave":`您確定離開嗎`,
"label.applt.copylink":`複製小程式連結`,
"label_tabpage_allpotentialcustomers":`所有商機`,
"label.rulestrikedate":`規則觸發日期`,
"label_tabpage_justsz":`進階篩選條件`,
"label.customize.memory.function.sorting.title":`自訂我的清單記憶功能`,
"message.duplication.label.mergebutton":`合併`,
"chatter.group.cancelRequest":`取消申請`,
"label.campaign.channel.step6.remark":`如果註冊頁面已經確認，點擊產生按鈕，系統將為您產生註冊頁面`,
"label.appupload.upload.install.abort":`結束安裝`,
"label.emailobject.proposetimes":`日程預約`,
"label.probability.cannot.empty":`可能性不能為空，且必須是數字`,
"vue_label_homepage_editkanban":`編輯看板`,
"lable.Related.template":`相關範本`,
"label.cloudccclass.list.cls.time":`定時類`,
"component.task.label.enddate":`到期時間`,
"label.sendmail.step3":`步驟3：審核和確認`,
"label.projectManagement.Gridview":`網格視圖`,
"label.emailobject.time":`發件時間`,
"label.applt.address":`小程式客戶服務入口網頁位址`,
"label.searchfield":`搜尋欄位`,
"vue_label_calendar_please_enter_the_name":`請輸入名字`,
"label.list.userinterface.default.page.setup":`系統預設介面`,
"label.detail.2018":`詳細訊息`,
"label.webtocloudcc.success":`您的訊息已提交成功，十分感謝您的參與，我們將竭誠為您服務！`,
"component_telerecord_label_title":`記錄電話`,
"label.setting.sureDelete.rules":`確定刪除此一規則嗎？`,
"vue_label_email_current_theme":`插入此範本將覆蓋當前郵件主題`,
"lable.Order.product":`訂單產品`,
"UG_product_02":`產品參考銷售或採購的產品或服務。`,
"label.appexchange.task":`工作流程任務`,
"label.selectprocesscondition":`指定步驟條件`,
"label.mobile.quickcreate.default.scan":`掃一掃`,
"label.tabpage.prepagez":`每頁顯示`,
"label.query.error":`查詢出錯了`,
"label.tabularreport.2018.step1":`步驟 1：選擇報表列`,
"pagecreator.systemstyle.label.modifystyle":`樣式編輯器`,
"label.app.step3":`步驟 3. 選擇自訂應用程式標誌的圖像源`,
"label_tabpage_rowsz":`刪除行`,
"label.validate.function.funcExplain.SUBSTITUTE":`用new_text取代文本字元串中的old_text。要取代文本字元串中的指定文本時，使用SUBSTITUTE`,
"vue_label_checkduplicate_select_data_to_merge":`選擇數據進行合併`,
"vue_label_commonobjects_view_chart_displaymode":`展開方式`,
"label.industrialandcommercialverification.servicesetiings":`服務設置`,
"label.refresh":`刷新`,
"label.taskfield":`任務欄位`,
"label.notification.approval4":`【提交人】正在請求批准【物件】`,
"label.group.isusing":`啟用`,
"label.language.settings":`語言設定`,
"front-kefu-moudle-please-login":``,
"label.page.double.line.cloudcc":`雙行並包括CloudCC側欄`,
"folder.error.delete":`1.當前文件夾中含有報表，無法刪除！2.當前文件夾含有隱藏報表，無法刪除！隱藏報表是根據邏輯刪除物件（設定-建立-物件下已刪除的物件）建立的報表，因該物件未真正刪除所以隱藏此報表`,
"eight":`八`,
"label.marketseamemset.user":`成員`,
"label.recordnum":`記錄編號`,
"page.404.button.back":`返回上一步`,
"label.mobile.phone.month.plan":`下月計劃`,
"label.marketseamemset.account.title2":`請設定影響所有成員擁有客戶的數量上限，限制與公海池無關`,
"vue_label_chatter_current_avatar":`當前頭像`,
"label.mobile.side.tab.remark3":`按住Shift鍵單擊或者直接單擊拖動以選擇一系列相鄰的項目；按住Ctrl鍵單擊可選擇多個不相鄰的項目`,
"component.sendmail.label.touser":`收件人`,
"label.homeitems.noobject":`無主題`,
"template.report.overall.sales":`整體銷售期（按商機來源）`,
"label.partner.donotdel":`無法完成對`,
"label.service.miniProgram.bindCopyDesc":`將組織和貴公司的公眾號或小程序綁定後，一鍵複製跳轉地址，即可使用此地址擁有屬於貴公司的客戶服務門戶。`,
"UG_Contract_01":`管理合約`,
"UG_quota_06":`建立報價`,
"vue_label_report_deletereport":`刪除報表`,
"front-epwechat-module-v1-input-appname":`請輸入應用名稱`,
"label_tabpage_deleteviewsuccess":`視圖刪除成功`,
"component_chatter_label_mygroup":`我的小組`,
"label.campagin.roi.leixing":`市場活動類型`,
"label.dashboard.myHomepageDashboard":`我的主頁儀表板`,
"UG_solution_04":`匯入解決方案`,
"label.knowledge.setting.hint.four":`啟用Knowledge`,
"label.campaign.channel.add.field":`點擊按鈕，添加欄位`,
"label.eastem.european.time":`東歐時間`,
"label.partner.workspace.member.partner":`Cloudcc Partner設定檔`,
"label.campaignmember.main.backtocampaign":`回到市場活動`,
"label.reportsSubscriptionPage.schedulereport.monthly.time.absolute":`絕對`,
"label.task.unsolve":`所有未處理任務`,
"label.multilang.chatterservice.vote":`{0}票`,
"label.console":`控制台`,
"label.emailsync.message1":`取消關聯後將無法同步該信箱郵件內容至聯絡人、商機，確認取消？`,
"pagecreator.systemstyle.label.stylename":`樣式名稱`,
"setup_mainpage_label_welcome16":`操作指導： 點擊本頁左側選單 → 應用程式設定 → 建立 → 工作流、審批流程、工作、電子郵件通知、欄位更新等。`,
"message.duplication.label.editfilterule":`編輯查重過濾規則`,
"Account.News.Setting.004":`啟用新聞`,
"label_tabpage_saveviewsuccess":`視圖儲存成功`,
"label.forecast.forehistory.replacecommit":`承諾額替代`,
"pagecreator_button_cancel":`取消`,
"label.knowledge.article.nomatch":`我們無法歸檔此文章，因為存在關聯的草稿。刪除草稿，然後重試。`,
"vue_label_combined_field":`沒有可以用於合計的欄位`,
"label.batchadd.save.prompt":`條記錄`,
"label.tabpage.summaryway":`匯總方式`,
"label.check.input.condition.two":``,
"mail.apiCode.notOnly":`唯一名稱已經存在`,
"UG.quota.01":`管理客戶報價`,
"label.approved.receiveApprovalEmail.option3":`僅在我是委派批審批者時`,
"label.stdashbord.xsld.business.img5":`可能性為0%階段的總金額`,
"vue_label_chat_movedfromto":`{name}將{label}從{oldField}更改至{newField}`,
"label.customfields.new.step2.opration":`一般選項`,
"label.dashboardSetup.isurl":`是否添加連結`,
"label.forecast.settings.mrfwqj":`預設範圍期間`,
"label.campaign.channel.field":`欄位`,
"label.weixin.optionthree":`選項三`,
"label.safetystatement":`安全聲明`,
"label.useskipwizard":`使用跳轉起點嚮導`,
"label.projectManagement.completion":`完成情況`,
"label.customfields.fielddependency.new.step2":`<b>步骤2：</b>在下面的頁面上，編輯篩選規則，這些規則針對控制欄位中每個值控制出現在相依欄位中的值。`,
"setup.mainpage.label.welcome8":`拖拽式介面定制`,
"label.emailobject.list.outbox":`寄件匣`,
"label.app.default.login.tab":`預設登錄選項卡`,
"label.follow_emails":``,
"vue_label_homepage_application_page":`應用程式主頁`,
"label.confirm.template":`確認範本`,
"lable.product.not":`無法完成您對`,
"label.multilang.feedtrack.dispalyinfo":`您可以選擇最多{0}個字段：`,
"label.weixin.plz.inputsrhkey":`請輸入搜尋關鍵詞`,
"label.projectManagement.service.appointment":`服務預約`,
"label.list.userinterface.watermark.enable":`PC與APP主頁、視圖、記錄詳情、報表、儀表板開啟水印`,
"label.confirmDelete":`確定刪除這些數據嗎？`,
"label.sso.description":`使用者可根據使用者名和授權碼免登錄進入CloudCC系統。<br>進入系統URL：http://localhost:8080/ssologin.action?userName`,
"errormessage_email_atleastonereceiver_z":`請至少選擇或者填寫一條收件人地址`,
"C":`累計彙總`,
"label.service.major.event.edit":`編輯重大事件`,
"label.icon.9":`維修`,
"label.visualpage.notvalidate.check":`不是有效的自訂頁面，請參考幫助文檔檢查頁面拼寫。`,
"label.audit.todo.from":`來自:`,
"label.directboss":`直屬上司`,
"label.manageAll.selpage":`當前頁數`,
"label.console.step6.all":`全螢幕，取消固定。列表僅在選擇了導航選項卡時才可視`,
"vue_label_pool_expiredate":`到期時間`,
"lable.no.matching.record":`無相符記錄`,
"label.standard.redirecterror":`標準按鈕跳轉到自訂頁面失敗`,
"label.Platform.Setting":`平台設定`,
"lable.outlook.edit.havenewc":`具有最新活動的聯絡人`,
"label.partnerCloud.partnerAccount.choosePayment":`請選擇支付方式`,
"label.weixin.optionsix":`選項六`,
"lable.SalesCommitmentKanBan.allCommitments":`Pipeline`,
"page_404_button_toknowmore":`瞭解更多`,
"label.customfields.number.tip":`允許使用者輸入任何數字。將刪除前置零。`,
"label.import.index.processimport":`進行匯入`,
"label.quote.phone":`電話`,
"label.insert.approval":``,
"label.tabpage.printview":`列印視圖`,
"lable.product.price":`價格`,
"front-kefu-moudle-call-detail":``,
"label.umeng.approval.apply":`申請`,
"label.background.the.form":`表單背景`,
"chatter.f":`追蹤者`,
"label.quickbooks.searchresault.company":`客戶`,
"vue_label_systemSettings_platformutils":`平台工具`,
"front-quotation-v1-nofilles-tocreate":`請點選產生報價單按鈕，產生報價單後再發送。`,
"label.category.6":`醫療`,
"label.attendance.choose.positon":`選擇地標`,
"label.batchadd.newbatchpage.save.pho":`電話格式不正確`,
"UG.Account.01":`您的客戶是誰?`,
"label.marketseamemset.addspecialuser":`添加特殊成員`,
"label.query.detail.forbidpartneruser":`禁用合作夥伴使用者`,
"label.stdashbord.xsld.business.ydzhl":`贏單率`,
"vue_label_SMS_mymessagebox":`我的簡訊箱`,
"label.knowledgebase.data.publishing.failed":`{a}條資料發布失敗，請選擇狀態為草稿的文章進行發布`,
"label.wholestate":`整體狀態`,
"label.selectedline":`選定的列`,
"label.validate.function.funcExplain.LEFT":`返回從文本字元串左邊算起的指定數量的字元`,
"label.emailmerge.edittemplate.detail":`郵件合併範本訊息`,
"vue_label_checkduplicate_checkduplicate":`檢查重複`,
"label.knowledgebase.assign.articles":`指派文章`,
"label.tabpage.recordsz":`記錄`,
"label.field.img.validate.error":`$User後的變量名拼寫錯誤或非法的$User引用，請檢查拼寫！`,
"workorderlineitem.worktype.isnot.father.worktype":`此工作訂單行項目必須選擇其父級記錄關聯的工作類型`,
"label.ccchat.group.name.noexist":`您輸入的小組名稱不存在，請重新輸入`,
"label.weixin.sign.type":`簽到(退)類型錯誤`,
"label.nowvaluereplace":`取代為現有的`,
"report_label_report":`報表`,
"label.knowledge.setting.plus":`知識庫Plus設定`,
"label.event.moveup.2day":`提前 2 天`,
"label.translation.start":`開始使用翻譯工作台`,
"lable.PowerProcess.created.time":`基於{detailInterestType}的建立日期`,
"label.ems.step2":`步驟2`,
"label.tabpage.groupingemptyz":`分組項目不能為空`,
"pagecreator.layout.button.new":`建立配置`,
"label.tabpage.listshow":`列表顯示`,
"label.partnerCloud.productSet.optionName":`選項名稱`,
"label.service.without.cycle":`無週期`,
"label.chatter.sendEmailToGroupMember.subject.V":`{0}在小組{1}發布了全員投票`,
"label_target_model_dimension":`目標模型維度`,
"component.task.label.subject":`主題`,
"label.custom.field.login.query.information":`請進入系統瀏覽詳細訊息！`,
"label.validate.function.funcExplain.NOT":`將 FALSE 改為 TRUE 或將 TRUE 改為 FALSE`,
"pagecreator_layout_button_horizontal":`橫向拆分`,
"lable.Returned.to.successful":`退回成功`,
"label.campaign.channel.ticket.title":`入場券`,
"label.ruleName.supportMaximum.50Characters":`規則名稱最多支援50個字元`,
"label.email.track.attachment.size.control1":`當前郵件附件累計大小超過20M，無法繼續上傳。`,
"template.report.folder.opportunities":`機會分析`,
"label.knowledge.setting.data.eight":`您將要刪除{flzmc}類別組及其類別。該類別將無法用於指派給記錄。您有 15 天來取消刪除該類別組。 15 天後，它將被永久刪除，並且無法恢復。是否確定要刪除此一類別組及其類別？`,
"mail.id.notNull":`範本刪除時id不能為空`,
"vue_label_normal_product_sf":`產品`,
"vue_label_report_superiortothisrelationship":`上級物件到此物件關係`,
"label.leadscore.operation":`操作`,
"label.customfields.formula.percentexample":`Discount（折扣）`,
"component.setup.iframe.label.inputurlmemo":`請輸入要引入的頁面URL地址`,
"label.icon.177":`徽標`,
"label.tabpage.myz":`我的`,
"label.leadmarketsea.add.title":`建立商機公海池`,
"label.partnerCloud.partnerAccount.thePage":`第 {skippageNum} 頁`,
"label.visualpage.some.size":`代碼容量 : 最大支援300KB字元,約300000位元組`,
"label.setwxpay.null":`配置微信支付必填訊息為空`,
"label.icon.74":`機床`,
"font-evaluate-module-v1-evbad":``,
"System.TimeField.Format.Warning":`不是有效時間`,
"label.captcha":`驗證碼`,
"label.payment.assessment":`評估其他版本`,
"message.error.not.taskevent":`非工作事件物件`,
"font-evaluate-module-v1-evaluation":``,
"vue_label_commonobject_view_updatedago":`已在{timeInterval}重新整理`,
"label.sendemail.birthday.newevent":`尊敬的{!ownerName}：\r\n  3日後是{!objectLable}{!recordName}的生日。請您關注！\r\n                        {!orgName}`,
"label.laststep":`上一步`,
"message.duplication.label.matchoption":`匹配選項`,
"label.setupmultplerecordtype":`多記錄類型`,
"vue_label_account_unprocessed_oppprtunities":`未處理機會`,
"KeyInformationLayout.DefaultLayout.Name":`系統預設`,
"label.partner.all":`全部夥伴雲`,
"label.datamanage.export.error":`匯出失敗！`,
"label.standard.buttonandlink":`標準按鈕或連結`,
"label.reportsSubscriptionPage.email":`郵件報表`,
"message.nogrammarfaultinformula":`公式中沒有語法錯誤`,
"front-kefu-moudle-nofind-instance":``,
"label.is.delete.data":`您刪除的數據中包含審批中的記錄，確認要刪除嗎？`,
"label.partner.error":`錯誤：域名格式錯誤`,
"label.notification.time2":`{0}分鐘前`,
"label.ccchat.person.invite.needfirstname":`輸入您的名`,
"label.mr.title.URL":`網址`,
"chatter.norecord":`沒有可顯示的記錄。`,
"label.readwrite":`讀寫`,
"label.partnerCloud.orderingPlatform.orderPayment":`訂單支付`,
"label.accesslimittype":`存取權限級別`,
"label.preciew_tab":`在新標籤頁檢視連結`,
"label.attachment":`附件`,
"label_tabpage_helpNavigationz":`幫助和導覽`,
"label.dataimport.select":`勾選此訊息，匯入數據時執行`,
"chatter.en.info":`輸入訊息這樣大家可以更多的瞭解你`,
"label.ccservice.validate.date":`物件API為{0}下的{1}欄位對應值為{2} 格式有誤，請輸入正確的日期或時間格式！`,
"label.social.posts.send":`帖子發送失敗`,
"label.emailobject.time.to":`收件人：`,
"label.defineReportStep1":`步驟1`,
"savefail":`儲存失敗`,
"label.mr.descreption.title":`合併重複數據`,
"label.share.info.by":`為`,
"label.list":`列表`,
"label.event.select":`已選`,
"message.accountmap.cannotfind":`無法找到的客戶地址，請更新客戶地址`,
"label.choosefield":`審批頁面欄位`,
"label.forecast.settings.title":`預測設置`,
"label.setup.log.datetime":`下載搜尋時間範圍內的行為日誌（Excel.xls文件）`,
"button_partner_new":`新建夥伴雲`,
"label.umeng.approval.dlsp.reject":`#approvalname替您拒絕#actorname請求的#objAPIName#recordname審批申請`,
"label.tabpage.totalTeamz":`共有小組`,
"label.lead.score.prompt3":`評分過程可能需要花費較長的時間，一旦評分完成，您會收到一份確認郵件。`,
"label.schedulejob.setup.schedule.name":`任務名稱`,
"vue_label_report_advanced":``,
"label.emailsync.form.connecttime":`關聯時間`,
"front-gantt-module-v1-project-status":``,
"label.field.for.example":`例如`,
"label.marketsea.manager.notnull":`管理員不能為空`,
"label.click.here":`&lt&lt 點擊此處返回`,
"UG.solution.04":`匯入解決方案`,
"label.validate.function.funcExplain.IF":`檢查條件是否為真，如果條件為 TRUE 則返回一個值；如果條件為FALSE 則返回另一個值`,
"label.profile.settab":`選項卡設置`,
"front-email-payment-weichat-tips":``,
"label.task.next.week":`未來一週的任務`,
"label.operatedata.selectobjectfields.tip":`請選擇需要匯出的欄位，至少選擇一個欄位匯出。<font color`,
"label.recalculate.alert":`請選擇要重新計算的共享規則`,
"label.marketsea.noopportunitydays":`天未建立機會（需大於獲取後未跟進天數）`,
"label.chat.likeperson":`個人`,
"label.selectedFields":`可選取的欄位個數`,
"label.App":`應用程式`,
"label.file.type":`文件類型`,
"permissionService.error1":`應用許可數量不足`,
"front-detail-module-v1-chart-display":`圖表展示`,
"label.audit.status":`審批狀態`,
"UG.activity.05":`記錄電話`,
"label.connectOtherObject":`（點擊以關連另一個物件）`,
"lable.currencyManage.unEnabledadvcurrency":`禁用進階貨幣管理`,
"label.ccpeak.getthree.function":`有三個方法，還有`,
"label.weixin.new.weitoupiao":`新建一條微投票,在微信平台微活動中可以獲取投票訊息參與投票活動。`,
"label.tag.manage.prompt":`標籤已存在！`,
"label.goon":`繼續`,
"label.addworkflowoperate":`添加工作流程操作`,
"label.weixin.click.search":`點擊查找記錄`,
"vue_label_report_deletecolumn":`刪除列`,
"label.ordercondition":`排序條件`,
"message.error.group.notallow":`小組不允許歸檔`,
"label.unread":``,
"vue_label_report_notice_namerequired":`列名稱是必填項`,
"label.tabpage.entercontent":`請輸入內容`,
"label.schedulejob.setup.schedule.startdate":`開始日期`,
"component_assistant_button_newtask":`新建工作`,
"vue_label_report_notice_filter1":`當啟用進階篩選時，要手動將篩選條件，<br/>寫入下方進階篩選框中，格式如圖所示。`,
"value":`值`,
"label.icon.70":`維修`,
"label.knowledgebase.delete.draft.t":`刪除草稿`,
"label.setup.mini.bind":`綁定小程式`,
"component_timeline_button_more":`更多列表視圖`,
"label_emailtocloudcc_redmessage4":`請輸入埠訊息`,
"label.field.input.number":`請輸入正確的數字`,
"front-invoice-online-payment-setup-title":``,
"front-kefu-moudle-called-user":``,
"label.currency.disable":`禁用的幣種`,
"label.user.alias":`別名`,
"UG_quota_04":`列印報價單`,
"label.chatter.delete":`刪除`,
"label.addtocurrentcustomer":`附加到現有客戶`,
"message.error.recordid.null":`recordid不能為空！`,
"label.merge.records":`合併記錄`,
"report_label_norole":`您沒有此權限，請聯繫系統管理員`,
"label.pqrs":`。`,
"label.email.attach.button":`單擊"附加"按鈕`,
"label.tabpage.selrecordtypez":`選擇記錄類型`,
"label.ServiceCloud.purchase.date":`購買日期`,
"label.customreporttype.delete.prompt":`請刪除以下報表,在執行刪除操作`,
"label.brief.total.page":`共{total}頁`,
"label.reportsSubscription.unsubscribe":`取消訂閱`,
"label.ccpeak.take.notice.exp.order":`注意：exp和ordering條件中的欄位API名稱後一定要加__c""`,
"report_type_label_quote":`報價`,
"label.file.norecord":`沒有可顯示的項目。`,
"vue_label_checkduplicate_all_processed":`已處理完全部數據`,
"label.next":`下一步`,
"label.icon.10":`文件夾`,
"label.lanxin.title.setting":`集成訊息`,
"label.h5.chatter.business":`關聯的業務機會`,
"lable.are.you.sure.to.delete.this.view":`確認刪除該視圖嗎`,
"vue_group_no_operation_permission":`無操作權限`,
"label.knowledge.archive.article":`歸檔文章`,
"vue_label_lead_":`暫無已啟動的可用評分規則，請聯繫系統管理員`,
"label.fiscal.error.between":`會計年度開始日期或會計年度結束日期在歷史會計年度時間段內，請檢查後重新設定！`,
"label.stdashbord.xsld.business.qdzje":`贏單總金額`,
"label.calendar.day.view":`日視圖`,
"label.emailtocloudcc.tip":`提示`,
"label.schedulejob.setup.schedule.st1":`第一個`,
"label_tabpage_addtoworkbench":`添加至首頁工作台`,
"label.umeng.approval.waitapproval":`待批准`,
"label.justcheckingwebsite":`只驗證網站`,
"homepage.components":`主頁組件`,
"label.audit.remark":`審批備註`,
"label.searchs.labelname":`搜尋{fieldlabelName}`,
"label.remarkofreport":`報表備註`,
"label.weixin.isno":`是否`,
"label.currencyCode":`幣種代碼`,
"label.service.resources":`資源`,
"label.clone_form":`複製表單`,
"label.weixin.view.information":`顯示視圖訊息`,
"UG_activity_05":`記錄電話`,
"chatter.feed.menutype.user.recentuser":`最近查看的人員`,
"label.marketsea.notfollowdays2":`天未跟進`,
"label.tabpage.namemandatory":`視圖名稱為必填內容`,
"message.demo.nosupport":`將在下一版本中推出此功能。`,
"label.mail.merge.template":`正在進行郵件合併範本...`,
"label.sendemail.marketactivity.sign":`行銷活動簽到通知`,
"setup_layout_group_relatedlist":`相關列表`,
"label.pc.ui.2018.all.tabs":`全部選單`,
"label.field.lost.right.bracket":`缺失右括弧`,
"label.datamanage.contact.novalue":`注意：本次匯入操作沒有給“聯絡人姓名”欄位賦值，聯絡人記錄將不會被匯入！`,
"label.version.unlimited.edition":`無限版`,
"vue_label_dashboard_selectsortfield":`請選擇排序欄位`,
"label.partnerCloud.productSet.instructions":``,
"front-kefu-moudle-v1-canuse-obj":`可視物件`,
"thursday":`星期四`,
"label.nextapprover":`下一個審批人`,
"setup_mainpage_label_manageuser":`管理使用者`,
"label.saveandcontinue":`儲存並繼續`,
"label.top.userCenter":`個人中心`,
"component.chatter.file.button.save":`發表`,
"label_emailsync_setting":`個人信箱設定`,
"label.usableshareuser":`可用共享者`,
"label.customfields.optionlist.fieldvaluelist.letterrank":`按字母順序而不是輸入順序排序值， 所有值將以字母順序顯示`,
"label.list.button":`設定檔分配`,
"chatter.up.m":`上傳的文件過大,請不要超過20M。`,
"label.knowledgebase.filters":`{a}個篩選器`,
"label.sso.saml.sp.idtype.username":`聲明包含使用者的cloudcc使用者名稱`,
"vue_label_file_size_limit":`文件大小不超過{size}Mb`,
"label.appupload.install.error.choice4":`跳過衝突的組件，不安裝有衝突的組件`,
"label.currencyDecimalDigits":`小數位數`,
"label.weixin.customer.details":`客戶詳情`,
"component.timeline.label.7daysahead":`前7天`,
"label.sendsms.batch.step1":`步驟 1：指定要包括的訊息接收者`,
"label.brief.opportunity1":`機會`,
"label.datamanage.click.importbutton":`點擊 <b>立即匯入</b> 按鈕，數據將被匯入CloudCC系統`,
"label_filter_benchmark_objects":`篩選基準物件`,
"label.area.record.notexist":`記錄不存在`,
"label.event.overdue.unfinished":`逾期未完成事件`,
"label.file.publicview.errortype":`此文件類型不支援預覽`,
"label.setup.mobile.bottombutton.profile.setting":`定制設定檔底部選單`,
"label.campaignmember.main.addleaddesc":`一次將所有現有商機添加到這個市場活動`,
"vue_label_approve_actual_operator":`實際操作人`,
"label.version.essential":`基礎版`,
"lable.SalesCommitmentKanBan.commitments":`Pipeline`,
"label.chatter.pastEvents":`過去活動`,
"vue_label_calendar_choose_calendar_type":`選擇日曆類型`,
"label.service.dispatchingUnits.batch.send":`批次派遣`,
"chatter.poll.option8":`選項8`,
"label_tabpage_summaryway":`匯總方式`,
"front-kefu-moudle-trindex-copy-num":``,
"lable.quote.syncing.syncfinish":`同步完成`,
"label.home.task.finish":`已完成任務`,
"label.toleadfield":`映射商機欄位`,
"label.everyone":`全部人員`,
"label.multilang.databatchadd.success":`{0}條數據添加成功：`,
"label.quote.createdate":`建立日期`,
"email.template.nopermission":``,
"label.report.action.addtodashboard2":`添加儀表板`,
"label.campaign.name":`市場活動名稱`,
"label.check.input.condition":`語法錯誤，請檢查輸入的過濾條件`,
"front-epwechat-module-v1-upload-file":`上傳授信檔案：`,
"label.batchadd.newbatchpage.button.add":`增加一行`,
"label.partnerCloud.footer":`頁尾`,
"lable.Enter.template.name":`請輸入範本名稱`,
"label_tabpage_last":`上一步`,
"label.setup.mobile.bottombutton.setting":`行動端一級頁面設定`,
"label_emailtocloudcc_filed_emailto":`Email to`,
"label.data.downpage.e_title.num3":`3、使用者可以根據自己的需求製作匯出範本，在匯出數據時選擇 按範本匯出 ，可便捷匯出操作。`,
"startwith":`起始字元`,
"vue_label_normal_cancel":`取消`,
"label.reportTypcrtD":`關聯物件（D） 請點擊選擇關聯物件`,
"label.globalselect.disabledvalue":`無效值`,
"vue_label_commonobjects_view_notice_deletecertification":`確認刪除選中的{selectNum}條數據嗎？`,
"front-epwechat-module-v1-bound-role":`已綁定角色`,
"label.partnerCloud.financeSetting.gaofilter":`進階篩選條件 （例如：1 And 2 Or 3 ）`,
"label.quote.sprname":`收票人姓名`,
"lable.asset.successfully":`產品轉資產成功`,
"label.projectManagement.service.appointment.work.noedit":`服務預約工時不可編輯`,
"lable.tianyancha.h5.inputandsearch":`輸入關鍵字，檢索相關公司`,
"label.customcomponent.check.tag.firstrow":`第一行必須是`,
"label.knowledgebase.published.translations":`已發布翻譯也將歸檔，將刪除處於草稿狀態的翻譯。`,
"vue_label_wang_yi":`王一`,
"label.step3.total3":`第3步，共3步`,
"label.stdashbord.xsld.business.img6":`可能性為100%階段的個數/(可能性為100%階段的個數 可能性為0%階段的個數)`,
"component_button_cancel":`取消`,
"label.delete.false.not.exists":`刪除失敗，數據不存在`,
"label.appupload.install.error.choice1":`請勿安裝`,
"label.Days.After.Horizontal.Date":`水平日期之後天數`,
"setup_layout_button_additem":`添加選中項`,
"UG.contact.05":`建立一個聯絡人`,
"label.form.title":`表單標題`,
"label.horizontalbar-group":`水平條-分組`,
"component_sendmail_label_title":`發送郵件`,
"label.passwordPolicy.setup.neverexpires":`永不失效`,
"label.sso.saml.idp.config.desc1":`啟用CLoudCC.com作為身分識別提供者，您就可以在其他網站使用單一簽入，並定義支援單一簽入應用程式的適用服務供應商。您無需重新登錄就可以切換至不同的服務供應商。`,
"label.chat.topic.desc.null":`了解有關本主題的一些訊息？在右上角的下拉選單中，選擇編輯詳細訊息。`,
"label.movablecustomerfield":`活動自訂欄位`,
"label.trigger.folder":`未歸檔觸發器文件夾`,
"label.selectuploadfile":`請選擇上傳文件！`,
"front-email-payment-card-tips":``,
"label.tabpage.addcondition":`添加條件`,
"label.number.MinAndMaxCheck":`{0}最小數量為{1}，最大數量為{2}，請修改數量後再點選儲存。`,
"vue_label_dashboard_dashboard":`重命名儀表板成功`,
"label.objectDeleteList":`物件刪除列表`,
"lable.service.gantt.and":`且`,
"label.emailtocloudcc.step2":`步驟2`,
"label.chatter.postup":`張貼`,
"label.personalsetting":`個人設置`,
"message.please.choose.permission":`請選擇存取權限`,
"label.mobile.move":`行動端`,
"label.Choose":`選項`,
"label_chatter_vote":`投票`,
"label.weixin.user.select.one":`選擇一個使用者`,
"pagecreator.page.label.modifypage":`頁面編輯器`,
"label.select.partOrField":`選擇你想控制的部分或欄位`,
"vue_label_helpcenter_chat":`1、即時通信<br>群策可以代替企業微信等，讓您在處於CRM系統工作時即可與公司同事發送文本通知、文件等。當組織各部門需要建立部門討論群，部門領導即可在群策中發起群聊，添加部門成員進入群聊。<br>2、建立針對客戶、業務機記錄的群聊<br>打開客戶或機會記錄詳情頁，單擊右上角“群策”按鈕即可在群策中建立一個關於此條記錄的群聊，如果建立群聊的不是記錄擁有者，記錄擁有者也會被自動拉入到群聊中。其他人可以通過單擊記錄詳情頁右上角“群策”按鈕或被群主添加後進入群聊。<br>3、在群聊中追蹤記錄<br>根據4.2中的方式為客戶、機會記錄建立群聊，即可在群聊中通過發送卡片的方式追蹤記錄的動態。如果使用者對卡片上的記錄具有查看權限時，當點擊卡片時即可直接跳轉至對應物件的詳細訊息頁面。<br>在群聊中追蹤記錄欄位變化<br>當記錄配置了“欄位追蹤”相關列表，且配置了需要追蹤的欄位，當追蹤的欄位發生變化時，群聊中的群策小助手將會發送一張帶有欄位變更訊息的卡片至群中。<br>在群聊中追蹤記錄擁有者變化<br>當記錄擁有者發生變更時，群聊中的群策小助手將會發送一張帶有擁有者變更訊息的卡片至群中。<br>在群聊中追蹤活動<br>當建立了記錄群聊後，如果建立了關於此記錄的工作和事件時，群聊中的群策小助手將會發送一張帶有工作或事件基本訊息的卡片至群中。<br>在群聊中追蹤記錄相關列表的新增記錄<br>當建立了記錄群聊後，當記錄的相關列表記錄新增時，群聊中的群策小助手將會發送一張新增記錄的基本訊息的卡片至群中。例如：在客戶記錄的聯絡人相關列表中新增加一個聯絡人時，客戶群聊中會收到一個“建立聯絡人”的卡片，並且可以在卡片上看到新增記錄的基礎訊息。`,
"label.tianyancha.business":`工商訊息`,
"chatter.group.groupMembersToFind":`小組成員查找`,
"label.pc.ui.2018.pin.top":`置頂`,
"label.forecast.forehistory.submitor":`提交人`,
"vue_label_email_send_emails_separately":`分別發送郵件成功`,
"vue_label_homepage_select_display_field":`選擇展示欄位`,
"label.partnerCloud.partnerAccount.accountBalance":``,
"label.sendemail.template":`選擇郵件範本`,
"label.service.violated":`已違反`,
"label.manageAll.title":`審批中心`,
"label.forecast.settings.qy":`啟用預測共用`,
"label.detailofshare":`共享的詳細訊息`,
"label.multilang.passwordpolicy.chechlength":`錯誤：密碼長度不得少於{0}個字元：`,
"label.visualpage.filesave.error":`文件儲存失敗，請重試`,
"vue_label_campaign_please_select_member_status":`請選擇成員狀態`,
"homepage.components.sort":`組件排序`,
"label.brief.thismonth":`本月`,
"label_emailsync_connectaccount_description":`將您的個人信箱添加於此，系統將自動根據郵件的收發地址相符系統中的商機、聯繫人，並將郵件內容同步至該記錄下，便於追蹤與客戶的溝通進度。`,
"label.sms.csid":`簽名編號`,
"label.ccdocument.remark":`文檔描述`,
"label.forecast.customforecast.disdw":`顯示單位`,
"label_tabpage_field":`欄位`,
"label.logintime.all":`全天`,
"UG_Account_06":`建立一個客戶`,
"label.login":`登 錄`,
"label.dupicate.data.error":`查詢合併數據異常，請檢查!`,
"label.monitorsys.recent.logs":`預設列出最近的200條日誌`,
"message.chooseatleastonefield":`至少選擇一個欄位`,
"lable.PowerProcess.name1":`權利過程名稱`,
"label.processdetail":`處理定義詳細訊息`,
"label.upload.file.size.limit":`上傳文件大小不能超過 2MB!`,
"label.forecast.userenablepage.desc":`啟用預測的使用者出現於“已啟用使用者”列表中。要啟用可用的使用者，將它們添加到“已啟用使用者”列表中。要禁用使用者，刪除它們。`,
"label.visualpage.type.detailembed":`頁面類型為detailEmbed自訂頁面使用規範`,
"label.textmessage.vonage.configurations":`配置`,
"label.report.select.chart.and.item":`選擇圖表和突出顯示項`,
"label.data.downpage.i.title.num1":`1、系統只支援通用的CSV格式。`,
"label.mobileapp.scansetting":`行動端掃描模組設定`,
"chatter.emailFollow":`追蹤`,
"label.weixin.businformation":`車輛訊息`,
"label.import.index.recentrecord":`近期匯入記錄`,
"label.case.update":`變更`,
"label.isEnableVisualpage.new.desc":`選擇 可用的自訂頁面 添加到 已啟用的自訂頁面 列表中，儲存後，該設定檔可以存取已啟用的自訂頁面。`,
"label.emailobject.wizard.title":`關聯您的個人信箱`,
"vue_label_ccchat_notice_deletepostsuccess":`刪除帖子成功`,
"label.deleteQuoteLine":`刪除報價行`,
"label.integrations.export.failed.Mailchimp":``,
"label.increase":` 加`,
"label.setup.mobile.homepageshortcuts.setunable":`主頁不顯示該模組`,
"label.ccchat.person.invite.toolong":`您不能輸入超過255個字元的文本`,
"label.knowledge.setting.help":`幫助客戶自助`,
"label.is_pigeonhole":`是否歸檔文件`,
"message.atleastonecommitter":`至少要有一個提交人`,
"label.emailobject.wizard.desc4":`插入一個可預約時間，讓多人邀約更簡單`,
"APPIntegration_Dropbox_setting_02":`禁用`,
"template.report.open.opportunities":`未關閉的機會`,
"label.goonwork":`繼續工作`,
"label.isiands.time":`島時間`,
"label.enable.rules.enableOnlyOneqrcodeOrbarcode":`已啟用規則（每個物件僅支援啟用一個二維碼規則或條碼規則）`,
"label.summaryreport.2018.step2":`步驟2：選擇要匯總的訊息`,
"pagecreator.systemstyle.message.delete.success":`樣式刪除成功`,
"label.standarduser":`標準使用者`,
"label.reportsSubscription.succeeded":`報表訂閱成功！`,
"lable.Select.a.template":`選擇一個已有的服務報表模版作為您建立模版的基礎。`,
"label.file.library.addfile2libsuccess":`{0} 個文件已上傳！`,
"label.searchfield.instruction":`搜尋欄位是為了當全局搜尋或對單個物件進行查詢的欄位。如果預設不選，則按照已選搜尋結果欄位進行查詢`,
"U":`URL`,
"label.Time.slot.overlap":`一個或多個時段時間範圍存在重疊。請更新為不會重疊的時段。`,
"vue_label_chat_opportunity_details":`機會詳情`,
"label.knowledge.category.hint.seven":`已選分類組`,
"label.chatter.list":`列表`,
"front-email-payment-Invoice-preview":``,
"label_emailsync_message1":`取消關聯後將無法同步該信箱郵件內容至聯繫人、商機，確認取消？`,
"label.summaryreport.step5":`步驟 5：確定報表中各列的順序`,
"component_newrecords_label_name":`名稱`,
"label.appointment.wizard.subtitle4-4-5":`兩個月`,
"component_salesperformance_label_title":`銷售績效`,
"label.ccchat.person.invite.says":`說：`,
"label.fax":`傳真`,
"label.knowledge.modify.article":`修改文章`,
"label.componenteditor.Limit.number.components":`單個頁面最多添加15個組件`,
"label.multilang.forecast.shrepage.desc":`此頁面將列出對{0}具有共享訪問的使用者、角色及區域。`,
"label.chat.micropost.write.comment":`編寫留言`,
"Lead.Scoring.Setting.Rule.Setup.Active":`是否啟動`,
"label.ccpeakfolder.time":`定時類文件夾`,
"label.partnerCloud.financeSetting.filter":`篩選條件:`,
"label.knowledge.delete.topicassignment":`刪除話題指派出錯`,
"label.file.orderbyname":``,
"vue_label_chat_activelater":`稍後開通`,
"chatter.reply":`回覆`,
"label.setup.profile.accordtext":`顯示文字是`,
"label.encd.plaintext":`查看明文`,
"label.h5.approval.cannotreassignmark":`代理審批項目不允許重新指派，請重新選擇審批項`,
"label.version.area.lookup":`{0}個文本區或查找多選欄位`,
"approval.request.email.body":`以下事項待批准：\n 點擊下方連結批准：\n`,
"label.user.mass.emails.select":`批次發送電子郵件：範本選擇`,
"lable.quote.syncing.title":`同步  報價 和  業務機會`,
"vue_label_dashboard_dashboardaccess":`儀表板存取權限`,
"label_emailtocloudcc_filed_owner":`記錄所有人`,
"label.brief.page":`頁`,
"label.isEnableVisualpage_new.desc":`選擇 可用的自訂頁面 添加到 已啟用的自訂頁面 列表中，儲存後，該設定檔可以存取已啟用的自訂頁面。`,
"label.service.shift.view":`輪班視圖`,
"label.emailsync.addnewaccount":`添加新帳號`,
"label.forecast.settings.prompt":`禁用預測共享將刪除所有手動共享的存取。`,
"front-electronic-signature-explain-second":``,
"label.emailtocloudcc.redmessage3":`請輸入伺服器地址`,
"message.confirmgiveupedit":`如果您離開此頁，會遺失所有未儲存的更改。是否繼續？`,
"label.gantt.plan.success":`計劃成功`,
"label.monitorsys.type.error":`請選擇查詢類型!`,
"label.industrialandcommercialverification.button.setup":`設置`,
"today":`今天`,
"label.attendance.setting.position":`設置地標`,
"chatter.mynews":`我的消息`,
"label.recycle.dis.tip1":`系統將保留回收桶中的數據15天，記錄在放入回收桶15天後，將被永久刪除。`,
"label.icon.81":`製冷`,
"label.customer.tab.page.prompt":`請至少配置一個頁面！`,
"label.globalselect.use":`使用全局選項列表值集`,
"template.report.customer.sales.order":`不同級別客戶銷售訂單`,
"vue_label_dashboard_lastruntime":`最後運行時間`,
"label.edit.ccpeakfolder":`類：編輯文件夾`,
"vue_label_lead_be_converted":`已為已轉換狀態，不可轉換`,
"label.tabpage.filenamez":`文件名稱`,
"label.please.click.add.products.":`請點選“新增產品”，新增產品至報價單。`,
"label.followup_emails":`一旦訪客送出了表單，跟進電子郵件是一種快速、輕鬆地與他們聯繫的好方法`,
"label.indochina.time":`印度支那時間`,
"message.error.task.email":`郵件工作異常`,
"label.dynamic.copy":`同時複製動態配置規則`,
"label.log.d":`下載搜尋時間範圍內的審計日誌（Excel.csv文件） >>`,
"pagecreator_layout_label_layoutname":`配置名稱`,
"template.chart.htsktj":`合約收款統計`,
"label.appointment.wizard.subtitle4-2-5":`1天`,
"label.view_form":`檢視表單`,
"label.tablet":`平板`,
"label.campaignmember.main.addcontact":`添加成員-現有聯絡人`,
"message.get.userinfo.error":`獲取使用者訊息失敗`,
"label.department.username":`使用者名稱`,
"label.ems.verifysuccess":`驗證添加信箱帳號成功！`,
"label.batchedit.copyValue":`應用到本列`,
"label.trigger.triggerVersion":`版本`,
"label.mr.descreption.oneGroupReData5":`組數據未處理。`,
"label.appointmentconfirmpage.wizard.subtitle5":`描述`,
"label.weixin.inbetween":`多選`,
"label.salescloud.contactrole.relatelist.customnize":`此列表不可自訂`,
"label.data.exp.please.nameanddes":`請填寫範本名稱和範本描述。`,
"label_partner_workspace_login":`登錄頁面`,
"label.notification.approval7":`【被委派人名稱】替您拒絕【提交人】請求的【物件】【物件名稱】審批申請。`,
"message.send.posts.image.error":``,
"message.fieldtrack.operateupdate":`已更改`,
"label.sharerule.grantuselevelconstructureaccess":`授予使用階層架構的存取權限`,
"label.translation.setup":`多語言設定`,
"PageLayout.Search.MultiSearch.003":`您至少選擇一個欄位。`,
"label.ccchat.person.emaildomain":`公司電子郵件網域`,
"pagecreator.systemstyle.label.bordercolor":`邊框顏色`,
"label.submit":`提交`,
"UG.Lead.001":`如何引入線索?`,
"label.icon.172":`地圖`,
"label_chatter_owner":`擁有者`,
"vue_label_systemSettings_Currency":`幣別管理`,
"page.layout.binfo":`基本訊息`,
"label.version.date":`{0}個日期欄位`,
"label.data.is.woking":`正在操作`,
"label.customfields.searchrelation.dependobjectDefault.tip":`可選擇相關物件中的一條記錄作為本欄位的預設值`,
"label.partnerCloud.orderingPlatform.configuration":`配置產品`,
"lable.currencyManage.Enabledadvcurrency":`啟用進階貨幣管理`,
"label.event.moveup.3hour":`提前 3 小時`,
"label.reportexport.object":`匯出物件`,
"front-dialog-module-v1-requestid":`請求ID`,
"label.pw.symol":`符號`,
"label_group_field":`指定分組欄位`,
"label.recallapprove":`調回審批請求`,
"vue_label_pool_deal_done":`已成交`,
"label.shangqing.description":`這是關於商情的描述`,
"label.view.allcansee":`<b>所有使用者</b>皆可視`,
"chatter.poll.addOption":`添加更多選項`,
"label.icon.112":`餐飲`,
"label.ignorecase":`將ABC"和"abc"視為重複值（不區分大小寫）"`,
"label.email.track.edit":``,
"label_tabpage_erraddressz":`信箱地址格式錯誤,請正確輸入信箱地址。`,
"label_tabpage_viewz":`列印當前視圖`,
"component.timeline.label.future":`後續步驟`,
"label.b_c_without":`B" 記錄可能有或沒有相關 "C" 記錄。"`,
"label.version.autonumberfield":`自動編號欄位`,
"label.appointmentdetail.wizard.title5":`邀請連結`,
"label.weixin.addoption":`添加選項`,
"label.b.c":`B 到 C 關係`,
"chatter.group.complete":`完成`,
"label.must.numeric.value":`成本必須為數字值`,
"lable.edit.queue.memberdes":`要在此佇列添加成員，選擇一種成員類型，然後從“可用成員”選擇角色或使用者，並將其移動至“已選成員”。“如果佇列中的所有物件的共享模式是“公用讀/寫/轉移”，您將無需分配使用者到佇列，因為所有使用者已經可以存取這些物件的記錄。`,
"label.staticresource.chose.limit":`暫不支援使用此格式的檔，功能完善中，敬請期待.`,
"vue_label_commonobjects_view_kanban_unset":`請在看板視圖設定中選擇分組依據`,
"label.appexchange.download.merge.mes":`以下衝突組件通過合併安裝：`,
"label.sharerule.baseofowner":`基於記錄擁有者`,
"label.email.template.manage.SMS":`管理簡訊範本`,
"label.imgfield.example.tip":`審批狀態為審批通過"時顯示綠色圖片，否則顯示紅色圖片."`,
"template.report.potential.customer.industry":`商機行業`,
"component_hots_label_title":`熱門交易`,
"label_file_use_document":`存儲空間使用情況`,
"label.input.path":`輸入引用路徑`,
"label.partnerCloud.financialSetup":`夥伴財務設定`,
"label_tabpage_myz":`我的`,
"vue_label_pool_discard1":`{1}{2}`,
"label_emailtocloudcc_tip2":`刪除後將無法通過此信箱實現Email to CloudCC功能，確認刪除？`,
"label.customfields.fielddependency.sure":`控制欄位值不包括有依賴性的值。是否仍要儲存？`,
"label.project.task.date":`工作日期必須在所屬里程碑的日期範圍內。`,
"Report.CantDelete.Info":`{0}報表被{1}儀表板引用，不可刪除！`,
"label.assignment.setup.title":`分配規則`,
"image.pt.most.maxsize":`最大檔大小為2M。`,
"label.appupload.introduce":`軟體包包含如應用程式、物件、選項卡、觸發器、自訂頁面之類的組件。這些軟體包可以通過上傳張貼到Cloudcc.com AppExchange以公開共用。下麵的列表顯示您的組織建立的所有軟體包。要建立新軟體包，請單擊“新建”。`,
"label.import.page2.confirm":`確 定`,
"label.console.step2.introduce":`填充下麵的欄位定義控制臺。`,
"label.extendsfather":`從父`,
"front-homepageobject-module-v1-year":``,
"front-grasp-sales-opportunities":`CRM幫您精準掌握銷售機會，獲取更多商機，提供快速報價，完成更多交易，同時實現全通路營銷，持續提升企業ROI。`,
"label.tab.oldpage":`舊版本頁面`,
"label.service.miniProgram.intro":`簡介`,
"label.data.import.setup.operate.insert":`不更新現有記錄，只插入新記錄`,
"label.ccpeak.direction.for.use":`CloudCC 平台類使用說明[2.0版本]`,
"label.sendemail.chat.addComentsmyFeedsubject":`CloudCC CCChat 微貼回覆`,
"label.campaignmember.main.importmember.contacts":`匯入成員-現有聯絡人`,
"setup.mainpage.label.welcome20":`郵件、簡訊範本`,
"label.newbatcheditor.remark":`。針對不同數據記錄存在不同的紀錄類型，系统將預設使用第一條數據記錄類型的形式配置作為批次编輯的版面配置`,
"label.step4.total7":`第4步，共7步`,
"label.campagin.roi.tzhbl":`投資回報率`,
"label.emailmerge.mergepage.step3":`記錄活動`,
"label.marketsea.isrecyclecreatebyself":`是否回收自建客戶`,
"message.mobilechooseatmost.five":`手機前段選單最多選取五個欄位`,
"label.icon.171":`賓館`,
"label.saveandnext":`儲存並下一步`,
"label.import.page1.selectcodingtype":`選擇編碼類型`,
"label.searchlayout.displaybutton":`顯示的按鈕`,
"label.approvalstep5":`步驟5:選擇要在批准版面配置上顯示的欄位的編輯屬性`,
"label.passwordPolicy.setup.enforcePswHis":`強制密碼歷史`,
"vue_label_commonobjects_detail_contact_hierarchy":`聯絡人層級結構`,
"front-kefu-moudle-v1-trythjzx-intelligent":``,
"label.select.statistical.indicators":`請選擇統計指標`,
"label.callcenter.Tianrun.RONGTONG":``,
"label.file.library":`文件庫`,
"lable.completion.rate.color.setting":`完成率顏色設定`,
"label.name.firstname":`名字`,
"setup_layout_label_readonly":`唯讀`,
"label.chatter.recordcall":`已記錄呼叫`,
"label.service.appointmentList.service.empty":`服務預約為空`,
"component_milestones_label_choicestate":`確認此狀態`,
"label.approved.receiveApprovalEmail.option2":`僅在我是審批者時`,
"label.marketseamemset.account.title":`客戶公海池成員設定`,
"label.changemydisplay.list.custom":`自訂我的選項卡`,
"label.emailtemplate.selecttype":`選擇郵件範本類型`,
"component_timeline_label_title":`時間軸`,
"chatter.group.addRemoveMembers":`添加/刪除成員`,
"label.console.step6.width":`寬度`,
"pagecreator.systemstyle.message.delete.fail":`樣式刪除失敗`,
"label.partnerCloud.orderingPlatform.productPrice":`{productQuantity}種產品，共{totalCount}件，原價：{currency} {originalPrice}，優惠：{currency} {Reduction}`,
"label.h5.share":`分享`,
"label.schedulejob.setup.list.tip":`設置計劃執行的作業，以每週或每月為間隔自動執行`,
"message.intheapproving":`此記錄已經在審批流程中，無法再次提交。`,
"vue_label_commonobjects_detail_real_time":`加入後，該群策將顯示在您的群策列表，群策動態會即時推送給您。`,
"label.autoRegister.changepwd.setpwd.too.weak":`太短`,
"label.salescloud.forbiddenteamsales":`?禁用小組銷售`,
"component.chatter.link.label.title":`連結`,
"label.layout.editsearchdistribute.page":`選擇要包含到選項卡頁面的自訂頁面。`,
"label.dashboard.show.value.percent":`顯示值與顯示%請至少選一項`,
"label.everymonth":`每月`,
"label.campaign.channel.download.size1":`大尺寸：1000*1000像素`,
"permissionService.error2":`新增應用許可權限失敗`,
"button.partner.workspace.manage.memo":`管理您的夥伴雲，配置夥伴雲屬性。`,
"label.forecast.forehistory.commit.remark":`提交備註`,
"six":`六`,
"label.datamanage.donot.export.object":`不允許匯出的數據物件`,
"label.schedulejob.setup.schedule.execute":`執行`,
"lable.account.CurrentandPreviousCY":`當前和上一個日曆年度`,
"label.temp.SMS":`簡訊範本`,
"label_partner_all_state":`狀態`,
"label.editdocument":`編輯屬性`,
"front-epwechat-module-v1-ios-single":`iOS單一登入：`,
"lable.redo":`重做`,
"vue_label_SMS_alltemplates":`全部範本`,
"label.allfolderreport":`所有報表文件夾`,
"label.layout.alltab":`全部選項卡`,
"lable.account.Yesterday":`昨天`,
"label.formula.to.evaluate":`公式評估`,
"component_setup_label_setupsaveok":`組件設置儲存成功`,
"pagecreator_page_message_canntdelete":`當前頁面不允許刪除`,
"label.tab.message.failtotp":`選項卡置頂失敗`,
"label.h5.chatter.location":`插入位置`,
"vue_label_commonobjects_view_chart_gotodashboard":`轉至儀表板`,
"label.data.exp.conf":`確認要匯出數據嗎？`,
"label.currency.e":`貨幣類型編輯`,
"message.matrixReportSetupStage.column":`請選擇【指定列標題】小計依據，兩個小計依據至少選擇一個。`,
"font-evaluate-module-v1-have-comment":``,
"chatter.feed.dao":`到`,
"label.import.index.notice":`註：`,
"label.weixin.information":`詳細訊息`,
"label.multilingual.tip5":`多語言狀態不正確，請重新整理後嘗試！`,
"label.appointment.wizard.subtitle3-7":`週日`,
"label.emailobject.groupemail.fail.content":`尊敬的{0}:\r\n您好！批次發送電子郵件發送失敗的信箱地址為：{1} \r\nCloudCC`,
"vue_label_notice_uploadavatar_fail":`上傳頭像失敗`,
"chatter.group.myGroup":`我的組`,
"label.ccpeak.object.fieldapi.name":`為物件的欄位API名稱`,
"lable.activeCurrency":`啟用的幣別`,
"label.file.save.to.send":`儲存並發送郵件`,
"label.emailmerge.list.editfolder":`編輯文件夾`,
"label.Path.Setting":`進程設定`,
"label.validate.function.funcFormat.DATE":`DATE(year,month,day)`,
"message.objapiexists":`物件api已存在`,
"label.sendmail.batch.confirm":`批次發送電子郵件：確認`,
"message.approval.cannotsubmit.detail":``,
"setup.layout.button.deleteitem":`移除選中項`,
"label.end.loginipIP":`IP結束地址`,
"component_event_label_subject":`主題`,
"message.500":`發生伺服器內部錯誤`,
"label.wei.polltype":`類型`,
"vue_label_norm_duplicate":`副本`,
"label.addcycletrigger":`添加週期性觸發器`,
"DetailedInfo.Activity.EmailMessage.01":`{0} 已為 {1}發送一封電子郵件`,
"No.Activity":`暫無任何活動`,
"label.chat.topic.add.topic":`單擊添加主題`,
"label.schedulejob.setup.schedule.morning":`上午`,
"chatter.save.al":`您的更改已儲存。`,
"label.setsharerule.step3":`第三步：選擇共享給的角色`,
"label.tabpage.Sdfez":`天前`,
"label_submit_forecast":`提交預測`,
"label.version.sum.formulafield":`個公式欄位`,
"lable.weixin.you.invitation":`您所邀約的`,
"label.stacked.horizontalbar":`堆疊圖形-水準條`,
"label.file.anyone.can.link":`任何具有該連結的人員可以查看並下載文件。`,
"label.campaignmember.main.importmember.lead.desc":`將文件中的數據匯入到這個市場活動商機中`,
"UG_activity_01":`您如何追蹤記錄與您的客戶/團隊互動?`,
"label.reason":`原因`,
"label.version.free.createmax":`允許建立2000條記錄，已達到上限！`,
"label.brief.thisweek":`本週`,
"label.deleteobjinapprove":`請輸入註釋，從審批流程中刪除此物件`,
"calendar.tips.event":``,
"label.customerinfo.mailinfo":`公司發件郵箱訊息`,
"lable.electronic.signature":`電子簽名`,
"label_emailsync_addnewaccount":`添加新帳號`,
"label.layout.exampleoftesgobj":`測試物件示例`,
"label.happen_submit":`訪客送出此一表單後下一步是什麼`,
"label.forecast.customforecast.button.submit":`提交`,
"label_right_click_notice":``,
"font-trade-module-v1-invoice-no-price":``,
"lable.opppdt.selPdt.morecondtions":`更多篩選器`,
"label_invalid_token":`無效token`,
"label_chatter_postup":`張貼`,
"label.escalation.setup.newaction.step1":`步驟1：指定此升級規則的時間條件`,
"label.sendmail.step3.dealoption2":`儲存每封郵件的活動`,
"front-kefu-moudle-v1-yesornoBatch-delete-templete":`確定要批次刪除範本？`,
"vue_label_appstore_enter_website":`進入官網`,
"label.when":`發佈時間`,
"label.linellae":`線條`,
"label_chatter_detailinfo":`詳細訊息`,
"lable.SalesCommitmentKanBan.receivingTaskRate":`收款任務率`,
"vue_label_homepage_dashboard_deleted":`儀表板已被刪除`,
"pagecreator.layout.button.vertical":`縱向拆分`,
"label.redistribution1":`最多可選擇5人`,
"pagecreator_page_label_modifypage":`頁面編輯器`,
"label.Service.Cloud.Setting":`服務雲設定`,
"setup_layout_label_pagename":`版面配置名稱`,
"label.ems.send":`發送`,
"vue_label_commonobjects_view_kanban_notice1":`看板視圖只顯示前200條記錄`,
"lable.outlook.detail.maping":`欄位映射`,
"vue_label_pool_abandonorrestore":`{1}{2}`,
"label.mobile.side.tab":`行動端側滑欄設置`,
"label.trigger.operation.email.template.param":`傳遞參數：語言、郵件範本ID、記錄ID`,
"front-objectTemplate-V1-Select-a-template":`選擇一個已有的模版作為您建立模版的基礎。`,
"label.email.template.delete.template":`是否確定要刪除此一範本？`,
"label.reportsSubscription.cancel":`取消`,
"lable.quote.syncingfrom.firstsync.description":`業務機會產品 將替代報價單明細`,
"label.weixin.no.pending.xsld.qin":`親，目前沒有銷售漏斗數據`,
"template.dashboard.sales.indicators":`銷售指標`,
"label.field.new":`為使用者提供評價和評分操作。`,
"label.generatepage.title.desc1":`根據選取的欄位，產生行動版或PC版的 HTML 代碼。使用者可根據需要對代碼進行修改。`,
"template.report.source.potential.customers":`商機來源`,
"label.mr.title.queryData":`查詢重複數據`,
"button_partner_workspace_enable":`啟用夥伴雲`,
"V":`自動編號`,
"label.icon.19":`文件夾`,
"vue_label_report_summaryformula":`匯總公式`,
"label.appointment.wizard.subtitle2":``,
"label.stdashbord.xsld.business.bjdzhl":`本階段轉化率`,
"label.forecast.forehistory.deopportunity":`的業務機會`,
"chatter.email.referredToMeLeaveMessage":`在留言裡提及我時（即@時）`,
"label.dategrouprelyon":`日期分組依據`,
"label.sendmail.batch.finish":`批次發送電子郵件：完成`,
"label.weixin.allexpired":`所有逾期`,
"label.dashboardSetup.showdw.d4":`萬`,
"message.duplication.label.masterRecord":`主記錄`,
"vue_label_calendar_availability":`可用性`,
"vue_label_chat_approval_message":`審批通知`,
"vue_label_zhang_er":`張二`,
"label.select.options":`請選擇選項。`,
"label.israel.daylight.time":`以色列標準時間`,
"front-sales-search-QB":``,
"vue_label_account_change_customer":`更改客戶擁有者`,
"label.integrations.mailchimp2":`查閱有關Mailchimp和CloudCC CRM的更多訊息`,
"lable.product.pricebooks.onisu":`未啟用的價格手冊`,
"front-electronic-signature-backfill-field":``,
"label.document.myself.folder":`我的個人文件夾`,
"label.event.moveup.10hour":`提前 10 小時`,
"report.label.report":`報表`,
"label.validate.function.funcFormat.CONTAINS":`CONTAINS(text, compare_text)`,
"label.usermanage.query.false":`查詢失敗，使用者不存在`,
"front-epwechat-module-v1-input-EncodingAESKey":`請輸入EncodingAESKey`,
"label.event.multi.view":`多人視圖`,
"label.h5.similar.opportunity.setup":`類似業務機會設置`,
"label.setting.intergrationlist.button.install":`安裝`,
"label.event.monthview":`月視圖`,
"label.version.weixin":`微信版`,
"label_emailtocloudcc_redmessage6":`IMAP/SMTP認證失敗，請檢查電子郵件地址與密碼是否正確`,
"UG.homepage.003":`360度視圖`,
"vue_label_calendar_shared_calendar":`共用日曆`,
"label.select.hope.merge.num1.record":`請選擇希望合併到一條記錄中的記錄(每次最多三個)`,
"label.createnewprocess":`建立新的審批流程`,
"font-trade-module-v1-invoice-status":``,
"label.customerinfo.introduce":`公司設定檔訊息`,
"label.objectname":`物件名`,
"label.chosen.field":`已選欄位`,
"label_target_name":`目標模型名稱:`,
"label.appointment.wizard.subtitle4-4-4":`一個月`,
"label.emailobject.groupemail.msg1":`無電子郵件地址`,
"label_component_hotdeal_nopermission":`要查看機會相關數據，請聯繫您的CloudCC管理員`,
"label.appointmentdetail.wizard.title13":`描述`,
"front-web-module-v1-detail-comment-title":``,
"label.visualpage.component.n1":`1.調用方式. &lt;component:Name /> Name為組件的具體名稱`,
"lable.outlook.mcto.erecord":`最早的記錄`,
"label.weixin.del.log":`清除日誌`,
"setup_mainpage_label_welcome23":`安全性設定`,
"label.selectreportline":`請選擇報表列`,
"label.chatter.following":`正在關注`,
"seven":`七`,
"message.error":`錯誤：`,
"label.mobile.phone.reporter":`報告人`,
"label.valadate.telphone.false":`手機號碼輸入有誤，請檢查`,
"label.linkedin.setting":`集成LinkedIn H5微應用`,
"label.mobile.side.tab.success":`行動端側滑欄設置儲存成功`,
"label.notification.approval3":`您的【物件】批准被【審批人】重新指派【重新審批人】`,
"label.channel.invites.employees":`此通路邀約員工`,
"label.assignment.setup.detail.assigner":`分配至`,
"label.campaignmember.main.updatecontactdesc":`一次更新所有現有聯絡人的狀態`,
"label.permission.detail.app.fenpei":`分配應用程式`,
"label.copydown":`向下複製`,
"label_emailsync_status_action":`操作`,
"lable.Please.switch":`請切換至橫版或縱版系統中使用此功能`,
"label_adjust_remark":`調整備註`,
"label.weixin.newspaper.coverage.list":`保險單`,
"label.datamanage.contact.field":`聯絡人欄位`,
"label.partner.workspace.login.headerfooter":`頁首和頁尾`,
"lable.account.quarter.ovdate":`會計季度結束日`,
"pagecreator.systemstyle.label.textcolor":`文字顏色`,
"label.industrialandcommercialverification.fieldmappingsettings":`欄位映射設置`,
"component_chatter_button_message":`留言`,
"label.partnerCloud.enterAddress":`請輸入位址`,
"label.email.template.recently.used":`最近使用`,
"component.event.label.calendar":`查看日曆`,
"label.setup.mobile.offlinecache.setting":`行動端離線緩存設置`,
"label.custom.PreviousCQ":`上一個自訂季度`,
"lable.total.of.payments":`共計0個付款`,
"label.ccpeak.use.class.time.trigger":`如果是觸發器調用該類別，可以直接使用CCService中的方法`,
"label_tabpage_addresswrongz":`信箱地址格式錯誤,請正確輸入信箱地址！`,
"vue_label_homepage_select_components":`選擇組件`,
"front-kefu-moudle-v1-secretID-reinput":`請輸入secretID`,
"label.ccdocument.select.template.red":`請選擇範本進行套紅`,
"vue_label_email_public_template":`公有模板`,
"label.eowechat.openid":`企業微信帳號`,
"label.user.ip.notlogin.range":`IP不在登錄範圍內！`,
"chatter.email.reply.collection":`對我收藏過的帖子回覆時`,
"label.integrations":`集成`,
"label.permission.modifyAppPermission.selectedapp":`已選應用程式`,
"label.privacystatement":`隱私聲明`,
"label.specificvalue":`特定值`,
"label.appointmentconfirmpage.wizard.subtitle2":`日期和時間`,
"label.message.ispartner.delete":`因為聯絡人已經與合作夥伴使用者有關聯，不能刪除客戶`,
"report_button_go":`前往`,
"label.h5.similar.opportunity":`類似業務機會`,
"UG_Lead_005":`信箱`,
"label.num.length.not.overstep":`數值長度不能超過18位`,
"label.profile.mobile.setup.CEOandDirector":`CEO及銷售總監`,
"label.addfield":`添加欄位`,
"template.dashboard.institutional.overview":`機構概覽`,
"label_tabpage_datefield":`日期欄位等於時可以使用“昨天”，“今天”，“明天”，“上個月”，“本月”，“下個月”，“上星期”，“本星期”，“下星期” 或“YYYY-MM-DD、MM/DD/YYYY”格式。`,
"label.category.7":`旅遊`,
"UG_contact_02":`通過多個渠道吸引聯絡人 通話`,
"chatter.feed.menutype.feed.mecom":`涉及我的更新`,
"vue_label_systemSettings_calltemplate":`通信模版`,
"approval_process_errore":`儲存過程中出現錯誤，請聯繫系統管理員`,
"label.tabpage.choosefilez":`選擇文件`,
"label.changemydisplay.chagetab.cusapp":`自訂應用程式`,
"clearadvancedoption":`清除進階選項`,
"front-epwechat-module-v1-binding-user":`已綁定使用者清單`,
"label.customfields.fielddependency.null":`未定義欄位相依性`,
"label.enterprise":`企業版`,
"font-evaluate-module-v1-five-points":``,
"lable.Synchronize.from.QuickBook":`從QuickBook上同步`,
"front-gantt-module-v1-task-number":``,
"label.currency.edit.newexchagecurrency":`過期匯率`,
"label.partnerCloud.partnerSite":`夥伴站點`,
"label_tabpage_unequalz":`不等於`,
"label.version.solutions":`解決方案`,
"label.setting.intergrationlist.button.installed":`已安裝`,
"label.h5.chatter.share":`分享文件`,
"front-epwechat-module-v1-unbound-item4":`#NAME?`,
"label.textmessage.vonage.accessibility.setting":`使用權限設定`,
"font-evaluate-module-v1-evaluation-set":``,
"message.servicecrew.time.violation2":`不在此時間工作`,
"label.processinfo":`審批過程訊息`,
"label.knowledgebase.last.modified":`上次修改`,
"label.to.phone":`收件人手機號`,
"label.baseoffirsttimereply":`基於<strong>首次</strong>回覆的批准或拒絶。`,
"label.projectManagement.startingEndingTime":`起止時間`,
"label.licence.enable":`啟用`,
"label.partnerCloud.basicSetting.cshua":``,
"APPIntegration.Dropbox.setting.03":`啟用Dropbox，讓您可直接在附件上從dropbox裡面選擇文件。`,
"label.account.contact":`客戶聯絡人架構圖`,
"label.many.dayline.tab":`標記`,
"label.weixin.input.username":`請輸入姓名`,
"label.logintime.pagecue.invalido":`結束時間也必須是全天`,
"label.icon.30":`書`,
"label_tabpage_advancedscreening":`進階搜尋`,
"lable.currencyManage.unEnabledadvcurrency.agree":`是的，我要禁用進階貨幣管理。`,
"label.tab.web.new":`新建 Web 選項卡`,
"label.bmap.tiananmen":`天安門`,
"label.disabled":`不可用`,
"error.currencyAdv.deleteprecodedate":`不能刪除貨幣代碼的上一個日期兌換率`,
"message.error.view.checkbox.validerr":`錯誤：使用真"`,
"UG_ST_006":`直接進入`,
"label.dongshifang.title":`東時方簡訊網關`,
"label.data.dataexpalltype.all.desc3":`3、匯出成功的數據將產生一個壓縮文件，使用者可以根據郵件中的文件訊息，在匯出成功的文件列表頁面下載您匯出的文件。`,
"vue_label_pool_returnreason":`退回原因`,
"label.list.userinterface.des":`使用下列設置修改貴組織的使用者界面：`,
"label.notification.approval2":`您的【物件】批准請求被【審批人】拒絕`,
"label.service.dispatchingUnits.the.level":`水平`,
"front-email-payment-Invoice-preview-tips":``,
"label.dashboard.isAvailableFieldOfComponentGroupInTheReport":`錯誤：組件中有一個或多個所選欄位無法繼續在報表中使用。 <br>使用儀表板組件編輯器選擇一個可用欄位。`,
"label.import.step2.chooseidorother":`2、可以選擇使用id或名稱相符記錄與填寫查找欄位。若需獲取對應記錄id等訊息，可建立報表，並將記錄名稱與記錄id設定為群組資料欄，再將報表匯出。`,
"label.customobjects.introduce":`自訂物件為數據庫表格，用於在 cloudcc 中存儲組織數據。 您可以使用自訂物件擴展 cloudcc 功能或構建新應用程式功能。`,
"label.visualpage.oldsystem":`舊版本`,
"label.icon.94":`書`,
"label.setup.log.desctiption":`您可以下載您組織行為追蹤（Excel.xls文件）。`,
"label.dynamicpage.layout":`動態版面配置`,
"lable.list.queue.objct":`支援的物件`,
"label.customfields.placeholder.tip":`示例文字將顯示在輸入框中，獲取焦點後消失`,
"label.ems.activationtime":`啟用時間`,
"label.detailinfo":`詳細訊息`,
"label.icon.17":`報告`,
"label_emailtocloudcc_button_complete":`完成`,
"label.visualpage.component.n2":`2.注意.  component標籤不能嵌套在<cc>標籤內`,
"label.object.name.one":`物件名1`,
"label.summaryreport.step2":`步驟 2：選擇要彙總的訊息`,
"thisisanew":`新！`,
"label.query.detail.editpartneruser":`編輯合作夥伴使用者`,
"label.tabpage.newview":`建立新視圖`,
"label.partnerCloud.productSet.addNew":`建立選項`,
"label.appupload.upload.new.remark":`此為全新組件。`,
"label.case.ptext":`我們已經將貴公司和網站版入口網頁綁定，複製專屬於貴公司的網站版客戶服務入口網頁位址，在貴公司官網上新增入口進入此一網站。`,
"lable.PowerProcess.name":`權利過程`,
"label_tabpage_choosefilez":`選擇文件`,
"homepage.components.place":`組件位置`,
"lable.Synchronization.failure":`同步失敗`,
"label.dashboard.snapshot.get.data":`獲取您的數據`,
"label.input.invalid.format":`請輸入合法的格式`,
"label.quickbooks.view.openinvoices":`進行中的Invoices`,
"label.weixin.seating":`座位數`,
"label.searchlayout.remark":`允許選擇以下搜尋功能中顯示的標準及自訂欄位：`,
"label.escalation.setup.entrydetail.escalation.assiner":`分配至`,
"vue_label_calendar_availability_view":`日曆-可用性視圖`,
"label.country":`國家`,
"label.campagin.roi.zl":`總覽`,
"lable.currencyManage.advcurrencyEnabled":`進階貨幣管理已啟用`,
"label.projectManagement.project.task":`項目工作`,
"label.appointmentpage.wizard.subtitle3-2":`信箱`,
"label.input.invalid.date":`請輸入合法日期 (ISO)`,
"vue_label_chatter_my_followers":`我的關注者`,
"label.setupdevelop":`新應用開發`,
"label.sendemail.send.checksend":`檢測發送郵件是否能成功`,
"label.eventfield":`事件欄位`,
"label.ccpeak.ccobject.put":`給CCObject賦值直接用put，例如：`,
"label.campaignmember.main.addMemberDesc":`可以搜尋現有商機及聯絡人,添加到這個市場活動中,也可以對現有成員進行管理`,
"label.knowledge.setting.hint.eleven":`輸入數據分類組`,
"label.knowledge.category.button.four":`新增同級分類`,
"label.icon.27":`學習`,
"vue_label_chatter_certification":`確定要{isStatus}"{titleName}"嗎`,
"label.data.downpage.i.title.btn":`進入匯入頁面，開始匯入`,
"label.campaign.channel.step6.pc":`產生電腦版頁面`,
"label.mr.caption.rule":`規則：必須選擇一個或多個查重規則`,
"label.service.gantt.resourcestype":``,
"label.searchfitconditions":`查找符合以下條件的`,
"label.partner.template.name":`範本名稱`,
"setup.mainpage.label.welcome15":`CloudCC 雲平臺工作流規則可以自動化您的銷售、市場等各種物件的支援過程。根據預先定義的一組規則，可以將記錄自動指派給使用者，或從一個使用者轉換到另一個使用者。工作流管理的主要好處是，通過在更新記錄時消除許多不必要的操作來提高工作效率，通過標準化工作方法、減少操作成本來提高業務處理水平，優化控制流程。支援任意物件的無限極審批，同時可以觸發提醒郵件、簡訊提醒、工作、欄位更新等功能。`,
"vue_label_commonobjects_view_chart":`圖表`,
"label.salescloud.teamrole.choose":`請選擇小組角色`,
"lable.outlook.mcto.emailrel":`電子郵件關聯`,
"front-invoice-online-payment-setup-describe":``,
"label.korean.standard.time":`韓國標準時間`,
"label.lord.howe.standard.time":`豪公夏令時`,
"setup_layout_group_button":`按鈕`,
"label.editdefaultshare":`編輯預設共享`,
"label_fiscal_year":`會計年度`,
"label.appointmentdetail.wizard.title2":`所有人`,
"label.email":`電子郵件`,
"label.city":`城市`,
"label.knowledgebase.data.recovery.failed":`{a}條資料恢復失敗`,
"setup_mainpage_label_welcome6":`使用者無需任何程式設計知識、無需代碼開發的情況下，便可在CloudCC 系統的所有物件中都可以建立各種類型的欄位，欄位類型包括：查找關係、單項選擇欄位、雙項選擇、公式、自動編號、URL、電話、傳真、電子郵件、複選框、日期、時間、數字、文本、文本區、選項列表（單選/多選）、幣別等。`,
"label_emailtocloudcc_button_enable":`啟用`,
"label.account.custom":`自訂會計季度`,
"label.custompublish_time":`客戶發佈時間`,
"label.dashboardSetup.selwz":`選擇顯示位置`,
"component_todaytask_label_all":`查看全部`,
"label.service.resource.group.tip":`選擇服務班組建立服務資源，資源類型只能選擇班組。`,
"label.tianyancha.legalpersonname":`法人`,
"component.setup.label.titlefield":`標題欄位`,
"label.email.template.public.mail":`公用郵件範本檔案夾`,
"front-template-V1-DeleteTempalte":`確定刪除“{{currentTelmplateName}}”範本嗎？`,
"pagecreator.layout.label.layoutdesc":`配置描述`,
"vue_label_file_singel_upload":`只能上傳一個文件，如果需要取代文件，請先刪除已上傳的文件`,
"label.view.hierarchy":`查看階層架構`,
"label.file.owner.settings":`擁有者設定`,
"label.sales.dashboard.name":`名字`,
"label.offfer.filer.name":`報價檔案名稱`,
"label.quickbooks.view.recentlypaid":`近期付款`,
"label.step1.select.merge.records":`步驟1:選擇要合併的記錄`,
"message.recordtype.assignprofile.tip":`選取"為設定檔啟用"複選框，使新記錄類型可由該設定檔使用。已分配給此設定檔的使用者將能夠建立此記錄類型的記錄，或將此記錄類型分配給現有記錄。要使新記錄類型成為某個設定檔的預設記錄類型，請選取"設置為預設"複選框。"`,
"label.appointmentdetail.wizard.title9":`路途所用時間`,
"label.group":`組`,
"label.deltorecycle":`刪除到回收桶`,
"label.import.index.numlimit":`1、只支援csv格式的文件。 （最多單次匯入30000條記錄，若需執行觸發器，則最多匯入2000條）超出限制的記錄，系統會自動忽略。若需匯入更多數據，請先拆分為多個文件，分次匯入。`,
"label.file.delete.desc":`刪除文件也會將其從附加的任何記錄或帖子中移出。`,
"UG_activity_04":`Outlook/Gmail信箱 記錄郵件`,
"label.event.all.undealt":`所有未處理事件`,
"label.appupload.upload.install.error":`此應用程式無法安裝。請結束安裝，或修改系統內API後重新安裝！`,
"template.chart.yqydcpsl":`已啟用的產品數量`,
"label.import.index.advancepreparation":`預先準備`,
"label.eowechat.epdeptnamee":`企業微信部門名稱`,
"front-kefu-moudle-please-input-servernum":``,
"label.lookup.autocmp.nodata":`沒有匹配數據`,
"vue_label_pool_assign":`指派`,
"label.knowledge.timing.publish":`定時發布失敗。`,
"label.selected.groups":`已選報價行組`,
"front-epwechat-module-v1-removesele-desc":`刪除後，本應用的全部設定資訊會被清除，是否確認？`,
"label.batchtransfer.type2":`轉移已結束業務機會`,
"label.richtext":`富文本區`,
"label.icon.174":`飛機`,
"vue.please.select.grouping.basis":`請選擇分組依據`,
"label.matrixreport":`矩陣式報表`,
"label.jiandangfenpei.leftlist":`未分配的設定檔`,
"label_chatter_card":`卡片`,
"label.file.enter.title":`請輸入標題`,
"label.the.record.is.locked.and.cannot.be.selected.":`該記錄已鎖定，不可選擇。`,
"label.partner.success":`成功！此域名可用`,
"label.selectreporttype":``,
"report.type.label.productPricebooks":`產品和價格手冊`,
"label.texttemplate.mergefields.tip":`設計簡訊的內容時可向內容中新增合併欄位取代文本。當簡訊被使用時，系統會取代成文本。例如{!Contact.name}，使用簡訊時，正文中會變成聯絡人的姓名`,
"label.publicgroup.detail.showallusers":`查看所有使用者`,
"label.brief.follow":`跟進`,
"label.forecast.settings.qijian.p":`每季度預測`,
"label.sms.url":`網站`,
"setup_layout_group_custompage":`自訂頁面`,
"label.validate.function.funcFormat.BEGINS":`BEGINS(text, compare_text)`,
"label.umeng.chatter.sendmessage":`更多步驟`,
"label.pc.layout":`PC配置`,
"label.currency.v":`輸入以新幣種顯示數據時可以顯示的小數位數（小數點右邊的位數），必須是 0 至 6 之間的整數`,
"label.projectManagement.kanbantask":`看板工作`,
"component_recdetail_label_title":`詳細訊息`,
"label.isremider":`是否提醒`,
"front-epwechat-module-v1-input-home-url":`請輸入主頁URL`,
"label.usefullife":`有效期`,
"label.visualpage.ptype":`普通`,
"label.quote.name":`報價單名稱`,
"vue_label_report_addtocomponent":`確認將{name}添加到組件庫嗎?`,
"label.dashboardSetup.showdw.d1":`億`,
"label.validate.function.funcFormat.OR":`OR(logical1,logical2,...)`,
"label.component.helper.potentialcustom":`今日指派潛在客戶`,
"label.autoRegister.changepwd.setpwd.tip.number":`至少有一個數字`,
"label.data.setok.e.desc3":`下載您匯出的數據。`,
"label.data.downpage.e.title.num4":`4、匯出的文件格式有兩種：CSV格式和壓縮格式。其中壓縮格式分為兩種：一種是自動產生壓縮文件密碼；另一種是手動輸入壓縮文件密碼。`,
"lable.quote.editqtpdt.description":`為此報價選擇價格手冊。您只能從單個價格手冊添加產品。更改已選取價格手冊將從該報價單中刪除全部現有的產品。`,
"front-kefu-moudle-edit-userinfo":``,
"label.please.ChooseMinAndMax":`請最少選擇{0}個產品選項，最多選擇{1}個產品選項。`,
"label.knowledgebase.archive.an.article":`歸檔一篇文章？`,
"label.multilang.customforcast.submit":`是否提交從第{0}會計年度{1} 至 第{2}會計年度{3} 的預測？`,
"label.import.index.filename":`文件名稱`,
"front-console-no-reco-contact":``,
"label.quantity.greater.than0":`數量需大於0`,
"label.codeNorm":`碼標準`,
"label.average":`平均值`,
"label.multilang.page1":`第`,
"label.data.exp.save.ok":`儲存範本成功`,
"message.error.delete.record":`未找到要刪除的記錄！`,
"label.newvaluereplaceoldvalue":`使用此頁面用新值全局取代選項列表中的現有值。確保已在選項列表詳細頁面中建立新值。`,
"label.tabpage.saveviewsuccess":`視圖儲存成功`,
"label.partnerCloud.productSet.parentOptions":`父級選項`,
"label.emailtemplate.availablemergefields":`可用合併欄位`,
"label.data.import.setup":`資料匯入設置`,
"label.escalation.setup.entrydetail.escalation.action":`升級操作`,
"System.TimeField.Description":`允許使用者輸入當地時間。例如，"2:40 PM"、"14:40"和"14:40:00"是此欄位的所有有效時間。`,
"front-additional-products":`增購其它產品`,
"label.appointment.wizard.subtitle4-4-1":`一週`,
"label.chatter.colleagues.list":`同事列表`,
"label.log.invalid.data":`非法的時間！`,
"label.file.preview.unconvert":`未產生預覽訊息,請點擊預覽詳情`,
"label.customer.detailed":`為這個新選項卡選擇頁面並填寫其它詳細訊息`,
"label.sendsms.content":`內容如下：`,
"label.exported_to":`匯出檔案將通過郵件發送至`,
"label.attendance.checkin":`簽到`,
"Dashboard.NoAccessRightToSee.Warning":`您所設定的預設打開儀表板{0}目前您沒有權限查看，您需要重新設定為其他值。`,
"message.choosedelete":`請選擇要刪除的數據`,
"label_tabpage_choosecontent":`請選擇值內容`,
"label.no_responses":`沒有響應`,
"report_type_label_customService":`客戶支援`,
"label.report.select.condition":`選擇條件`,
"label.umeng.activity.distributeevent":`已為您指派事件`,
"label.knowledge.language.portuguese":`葡萄牙語`,
"label.knowledgebase.published":`已發布`,
"UG_opportunity_001":`您如何監控您的銷售?`,
"label.mr.caption.scope":`範圍：如不選擇則查詢全部數據`,
"message.login.mfaverification.to.pclogin":`您的組織已經啟用二次校驗，首次登錄需要綁定移動設備，請使用PC端進行登錄綁定`,
"vue_label_dashboard_pleaseenterthecolorrange":`請輸入顏色範圍`,
"label.emailsync.status.time":`時間`,
"chatter.putup":`張貼一個文件`,
"vue_label_report_drillcondition":`鑽取條件`,
"label.emailobject.list.myemail":`我的郵件`,
"label_tabpage_andz":`與`,
"label.share_link":`分享連結`,
"label.emailtocloudcc.exists2":`此信箱已經設定為Email to Case，請勿重複設定`,
"label.icon.89":`諮詢`,
"front-kefu-moudle-v1-qdygbzx-chat":`確定要關閉線上聊天嗎?`,
"label.approval.selectone":`至少選擇一個操作`,
"chatter.group.groupName":`小組名`,
"label_chatter_relateitem":`相關項`,
"label.file.folder.delete1":`刪除資料夾？`,
"Pagelayout_Setup_003":`Name欄位必須選擇`,
"setup_mainpage_label_welcome2":`自訂資料庫（物件）`,
"pagecreator.systemstyle.label.linkcolor":`連結顏色`,
"label.task.this.week":`本週的任務`,
"message.custom.field.donotdelete.report":`該欄位被報表所引用`,
"pagecreator.layout.button.delete":`刪除配置`,
"label.reportsSubscriptionPage.condition.operator":`邏輯符`,
"label.location.display.type.degrees":`度數、分鐘、秒數`,
"label.appupload.upload.url":`安裝URL`,
"label.logical.relation":`邏輯關係`,
"label.knowledge.publish.article":`發布文章`,
"vue_label_commonobjects_detail_activity_commingtask":`擁有即將進行的工作`,
"vue_label_pool_reason":`{0}原因`,
"front-gantt-module-subtasks-cannot-subtasks":``,
"label_tabpage_filesizez":`文件大小`,
"label.customfields.formula.returntype.monry.tip":`計算美元或其它貨幣金額，並將欄位自動轉換為貨幣金額格式`,
"label.tabpage.allapplications":`全部應用程式`,
"message.duplication.label.matchcontainletters":`包含匹配`,
"maintenanceplan.workorder.type.asset.workorderlineitem":`工作訂單產生方式請選擇“每個資產產生一個工作訂單行項目”`,
"label.preview_post":`預覽帖子`,
"chatter.p.data":`發表日期`,
"label.isnot.right.number":`不是正確的數字`,
"label.contentsource":`內容源`,
"message.groupandsummaryconditionsame":`分組條件不得與彙總條件相同`,
"label.weixin.wdyj.nodata.qin":`親 , {0}沒有數據.`,
"chatter.vote":`票`,
"label_partner_workspace_tab_option":`可選選項卡`,
"chatter.changeVote":`更改投票`,
"label.data.file.i_title.num2":`2.建議在匯入時先匯出，以匯出文檔為資料範本整理匯入資料，然後再匯入。 （匯入的資料中如果含有逗號，請使用‘@’符號代替）`,
"label.relation.list.error":`出錯了`,
"label.validate.function.funcExplain.MILLISECOND":`返回日期/時間欄位中的毫秒數`,
"label.emailobject.emaildetail.button.relateto":`關聯到`,
"label.dashboard.dataSource":`顯示數據來源`,
"label.marketseamemset.lead.title":`商機公海池成員設定`,
"label.appupload.addobj":`添加到軟體包`,
"lable.outlook.mcto.domain":`格式如（gmail.com），添加到排除的網域列表中。`,
"label.input.right.url":`請輸入正確的URL`,
"label.newprocessstep5.tip":`審批頁面時審批者實際批准或拒絕請求的地方。使用下面的選項，選擇要在此頁面上顯示的欄位。`,
"label.schedulejob.setup.schedule.st4":`第四個`,
"label.emailsync.status.user":`使用者`,
"front-kefu-moudle-v1-jymm-reinput":`請輸入12位元大寫字母、小寫字母、數字、字元至少包含兩種組合的密碼`,
"Lead_Scoring_Setting_Rule_Setup_RuleName":`評分規則名稱`,
"label.mr.title.fieldName":`欄位名稱`,
"label.data.deriall":`匯出全部`,
"label.tianyancha.businessverify.step2":`啟用工商數據驗證第二步`,
"label.submissions":``,
"vue_label_calendar_removed_successfully":`移除日曆成功`,
"label.eventrecordtype":`事件記錄類型`,
"lable.outlook.detail.syndire":`同步方向`,
"label.mobile.bind.fail":``,
"label.notification.task2":`您指派給【被指派人】的工作被查看`,
"label.partnerCloud.orderingPlatform.paymentMethod":`支付方式：`,
"label.escalation.setup.newaction.step3":`步驟3：選擇要通知的使用者`,
"label.summaryreport.selectsum":`選擇彙總訊息和彙總類型`,
"label.components.setup":`設置組件`,
"label.taskevent.introduce":`以下是您的任務和事件列表。`,
"label.assignment.setup.detail.conditon":`條件`,
"front-lightning-module-v1-details-page-chart-select-statements":`選擇報表`,
"lable.Song.typeface":`宋體`,
"label.formulassesstrue":`公式評估為真`,
"label_partner_common_setup":`一般設置`,
"label_chatter_dateRange":`日期範圍`,
"label.partner.workspace.tab.mobile.using":`勾選的選單將同時顯示於行動端`,
"message.servicecrew.time.violation1":`派遣成功`,
"report_label_projectcount":`個項目，按報表名稱排序`,
"label.file.uploadfile":`上傳文件`,
"vue_label_commonobjects_detail_correct_email_address":`請輸入正確的信箱地址`,
"lable.account.CurrentandNextCQr":`當前和未來三個日曆季度`,
"setup.layout.label.order":`排序標準`,
"label.service.major.event.independent":`獨立`,
"label.icon.38":`定位`,
"label.knowledge.draft.record":`未找到要刪除的記錄`,
"label_quota_percentage":``,
"label.escalation.setup.entrydetail.escalation.minute":`分鐘`,
"label.knowledgebase.edit.article.category":`編輯文章類別`,
"Homepage_News_003":`暫無客戶數據，無法顯示新聞，您建立客戶之後即可在此顯示客戶新聞`,
"label.mr.descreption.oneGroupNote3":`條記錄。`,
"label.customsetting.touse.getListCustomSetting":`查詢“列表”類型的自訂設置數據,返回對應apiName的全部數據 Map map`,
"message.error.view.cannotbenull":`錯誤： 必須輸入一個值`,
"label.reportsSubscriptionPage.schedulereport.monthly.day.friday":`星期五`,
"message.error.view.badprevilege.qin":`親，您沒有存取{1}的權限，因此無數據。`,
"label.dashboard.distribution":`分佈`,
"label.field.value.save":`此欄位中總是需要一個值來儲存記錄`,
"label_custom_year":`自訂年度`,
"label.code.error":`代碼中含有不被允許的命令及函數，如：`,
"label.appexchange.uninstallpage.message2":`永久刪除您對這些組件所做的全部自訂`,
"label.global.search.obj":`全局搜尋物件設置`,
"label.emailobject.from":`發件人`,
"lable.opppdt.selPdt.byconditions":`按欄位篩選條件`,
"chatter.p.note":`此帖子的註釋`,
"label.hiddenformulaedit":`隱藏公式編輯器`,
"label.editQuotation":`編輯報價單`,
"label.notification.arketsea.collection":`{5}領取了{2}{0}{0}:{1}`,
"label.timzone.tip.info1":`涉及到數據庫儲存(insert和update)java.util.Date類型的數據時，例如TpSysTask task`,
"label_tabpage_transformationsz":`轉換`,
"front-kefu-moudle-IP-phone":``,
"label.emailobject.list.draft":`草稿匣`,
"label.tianyancha.businessverify.readandconfirm":`我已閱讀此使用者許可協議，並同意此協議。`,
"label.win.customers":`已結束/贏得客戶`,
"vue_label_commonobjects_view_switch_display":`您的記錄按照記錄類型分組，可點擊對應的記錄類型名稱，切換展示。`,
"pagecreator_systemstyle_label_textcolor":`文字顏色`,
"label.autosearch.keywords":`自動完成關鍵詞搜尋`,
"label.knowledge.setting.data.six":`您將要刪除{lbmc}分類，是否要繼續？`,
"front-console-sort-field":``,
"label.bangladesh.time":`孟加拉時間`,
"label.dashboardSetup.number":`數值`,
"lable.account.LastbDays":`過去30天`,
"label.layout.searchdialog":`查找對話框`,
"label.newprocessstep4.tip":`選擇電子郵件範本，用來通知審批者批准請求已經分配給他們。請注意，此範本將用於此過程的所有步驟。`,
"label.nousing":`未啟用`,
"vue_label_report_detailline":`詳細訊息行`,
"label.emailobject.template.message3":`您的郵件範本已達上限！`,
"label.c.d":`C 到 D 關係`,
"message.report.error.fail":`加載失敗，請重試`,
"label.edit.ccdocument.content":`修改了附件內容`,
"label.textmessage.exceeded":`你的簡訊範本數量已經超過最大上限`,
"label.saveas":`另存為`,
"label.visualpage.an.inline.style":`為詳細頁面和選項卡頁面內嵌自訂頁面類型`,
"label.pagelayout.remark2":`數據。在建立版面配置之後，單擊“版面配置分配”按鈕，以控制使用者在預設情況下看到哪個版面配置。`,
"label.notification.approval1":`您的【物件】批准請求已通過【審批人】批准`,
"label.h5.chatter.image":`上傳的圖片格式不正確`,
"vue_label_dashboard_displayunit":`請選擇顯示單位`,
"label.knowledge.default.language":`知識庫預設語言`,
"label.chatter.publish":`發表`,
"label.companyprofile.serveraddress":`本次同步僅對當前伺服器進行同步`,
"label.chatter.groups":`群組`,
"label_set_successfully":`設定成功`,
"label.quote.zongjia":`總價`,
"label.project.notice.endingdatelater":`結束日期需晚於或等於開始日期！`,
"label.customfields.fielddependency.info":`使用此頁可以定義欄位之間的相依關係（例如有相依性的選項列表）。`,
"vue_label_lead_successful_conversion":`轉換成功`,
"label.icon.93":`書`,
"shift.serviceresource.illegal":`服務資源不屬於此服務區域成員或輪班的日期範圍不在成員關係範圍內`,
"label.integrations.action.addnewlead":`新增商機`,
"label_display_all_zeros":`顯示全部為零值的行`,
"canlendaryear":`日曆年`,
"label_tabpage_selrecordtypez":`選擇記錄類型`,
"vue_label_commonobjects_view_chart_funnel":`漏斗圖`,
"label.layout3":`配置三`,
"label.logintime.cue":`未指定登入時間`,
"label.service.miniProgram.lastDate":`最後修改日期`,
"label.emailobject.view.fromcrm":``,
"pagecreator.button.mobilepage":`手機端`,
"lable.oppt.jieduan.signcur":`標記為當前階段`,
"label.fullaccess":`完全存取權限`,
"homepage.layout.pagename":`版面配置名稱`,
"label.appointment.wizard.subtitle4-2-3":`3小時`,
"label.knowledgebase.please.check.record":`請至少勾選一條記錄`,
"label.view.sortview.closepage":`關閉此頁`,
"label_forecast_type":`預測類型`,
"all.day":`全天`,
"label.view.sortview.printpage":`列印此頁`,
"message.integration.configure":`集成配置為空！`,
"label.forecast.customforecast.foretype.close":``,
"label_chatter_like":`喜歡`,
"template.report.folder.customer.potential":`商機分析`,
"label.umeng.approval.dlsp.approve":`#approvalname替您批准#actorname請求的#objAPIName#recordname審批申請`,
"vue_label_normal_movedown":`下移`,
"chatter.group.groupAccessPermissions":`小組存取權限`,
"label.visualpage.tip":`你可以在這裡建立屬於你自己的頁面`,
"message.validation.isnotdate":`輸入正確的日期格式`,
"label.icon.173":`帆船`,
"label.icon.124":`打針`,
"label.import.page2.csvfiled":`CSV欄位`,
"setup_layout_component_area":`區域`,
"label.visualpage.workability.standard":`頁面中可使用的標準Class`,
"label_emailtocloudcc_redmessage9":`資料庫錯誤，請聯繫管理員`,
"label_tabpage_contactsz":`聯絡人`,
"label.multilang.workflow.everydayinmonth":`每隔{0}個月的{1}天`,
"APPIntegration.Social.linkedinerror":`必須是一個合法的linkedin.com的URL`,
"button_partner_workspace_manage_memo":`管理您的夥伴雲，配置夥伴雲屬性。`,
"template.chart.bnsrmb":`本年收入目標`,
"chatter.follow.now":`正在追蹤`,
"label.entitlement.process.condition.repeat":`設定重大事件重複`,
"label.relationobject.isdl":`是否代理`,
"label.lasttimemodifieralias":`上次修改人別名`,
"vue_label_commonobjects_detail_task_name":`編輯工作名稱`,
"vue_label_homepage_quarterlyperformance":`季度業績`,
"pagecreator.layout.message.delete":`是否刪除當前所選配置？`,
"component_sendmail_label_cc":`副本`,
"vue_label_email_enable_signature":`啟用簽名`,
"label.partnerCloud.financeSetting.create":`新的合作夥伴啟用時，為符合條件的客戶自動建立帳戶`,
"label.data.file.i.title.num1":`1.匯入的文件必須是CSV格式的文件，CSV文件必須包含標題，沒有標題不能匯入。`,
"label_efine_assessment":`考核週期`,
"message.duplication.label.sectionTitle":`選擇要保留的值`,
"front-electronic-export-buttonExport":``,
"message.submitpage.email":`祝賀您！電子郵件發送請求成功！`,
"after":`晚於`,
"label.version.nonsupport":`不支援`,
"label.icon.105":`日程`,
"label.quickcreate.titledesc":`啟用快速新建後，可以在查找欄位錄入時，在搜尋框中快速建立新的記錄。`,
"label.quote.number":`填寫數量`,
"label.view.sortview.setdefault.prompt":`將此視圖列表設為預設視圖`,
"label.refertime":`提交時間`,
"frame.personinfo.label.minipic":`縮圖`,
"label.mobile.home.page.newopp":`最新潛客`,
"label.address":`地址`,
"front-pay":`付費`,
"label.chat.serviceAppointment":`服務通知`,
"label.umeng.activity.eventviewed":`您指派給#name的事件被查看`,
"label.validate.function.funcExplain.DATE":`通過年、月、日建立日期`,
"label.commiterselectapprover":`允許提交人手動選擇審批者。`,
"label.appointmentconfirmpage.wizard.subtitle3":`地點`,
"vue_label_display_text_field":`顯示文字欄位`,
"label.salescloud.teamrole":`小組角色`,
"maintenanceplan.workorder.generate.limit":`產生的工作訂單應在維護計劃範圍內`,
"label.campaignmember.selectmember.description":`選擇一個視圖，然後選擇成員以添加到市場活動中,成員狀態為`,
"label.ismodify":`是否允許編輯`,
"label.height":`高`,
"label.tabpage.thevalurofz":`的值`,
"label.create_successful":`表單建立成功`,
"front-invoice-online-payment-setup-configure-dialog":``,
"label.customerinfo.smsEid":`簡訊網關EID`,
"label.visualpage.list.no":`無自訂頁面存取權限`,
"look.trigger.in":`查看使用說明`,
"label.setting.disable":`停用`,
"chatter.group.name":`小組`,
"label.solutionadministrator":`解決方案管理員`,
"label.vlidaterule.top":`頁首`,
"pagecreator.layout.message.save.fail":`配置儲存失敗`,
"label.partnerCloud.orderingPlatform.noZero":`數量不能為0`,
"label.customfields.suretodeleteprompt":`確認自訂欄位刪除提示`,
"button_partner_viewdetail":`查看`,
"label.icon.122":`房子`,
"label.customer.tab.step2.introduce":`選擇要在其中使用新自訂選項卡的使用者設定檔。也可以在每個設定檔的詳細訊息和編輯頁上檢查或修改是否顯示某個選項卡。`,
"label.task.delegated":`已委派`,
"vue_label_salesadvance_averageamount":`平均客單價`,
"vue_label_chat_invitedtojoin":`“{invite}”邀請你加入了群聊`,
"label.data.downpage.e_title.num1":`1、選擇要匯出數據的物件，或者選擇匯出全部。`,
"label_display_options":``,
"vue_label_chatter_more_comments":`更多評論`,
"label.ggReleaseRange.publish":`發布清單`,
"label.valuetype.notmate":`行條件錯誤，值類型不匹配！`,
"label.chatter.chatter":`CCChat`,
"label.exchange.sync.state.contact.m1":`上一同步活動：`,
"label.dataimport.duplication.filter":`查重過濾器提示`,
"label.appdownload.uninstall":`移除軟體包`,
"message.error.task.add":`建立工作異常`,
"UG.Account.07":`匯入客戶`,
"label_tabpage_lastone":`至少選擇一條操作`,
"front-console-holdTime":``,
"label.emailobject.schedule":`這裡是我的日程安排，請您選擇一個合適的時間。`,
"label.lookup.locked.data":`該記錄已鎖定，不可選擇`,
"label.assignment.setup.newentries.ifcondtions":`如滿足以下條件，則運行此規則`,
"label.magadan.time":`彼得羅巴甫洛夫斯克時間`,
"message.error.serviceterritorymember":`請在服務預約計劃開始和結束的時間範圍內將選擇的服務資源定義為服務區域成員`,
"label_chatter_delete":`刪除`,
"label.partner.workspace.member.permission":`可選權限集`,
"label.notification.task5":`您的工作已逾期`,
"mary":`五月`,
"label.homepagemodule":`主頁組件`,
"label.compact.layout.frame.error1":`右屏不能沒有內容`,
"chatter.error.refresherror":`刷新失敗，請重試`,
"label.login.rememberPsd":`記住密碼`,
"Lead.Scoring.Setting.Rule.Setup.01":`商機評分規則列表`,
"label.reportsSubscriptionPage.schedulereport.weekly.sunday":`星期日`,
"label.visible":`可視`,
"label.console.new":`新建控制台`,
"label.mr.descreption.reDataList4":`毫秒。 每頁顯示`,
"vue_label_notice_uploadavatar_notice2":`上傳頭像圖片只能是JPG/PNG/GIF格式`,
"label.operation.error":`操作失敗，請重試。`,
"label.sendsms.context":`簡訊內容`,
"label.least.show.line":`（至少顯示4行）`,
"label.tabpage.newWizardz":`新增功能向導`,
"label.tippage.li2":`刪除基於自訂報表類型的所有報表`,
"label.customfields.new.step2.opration.unique":`獨有`,
"label.listofshare.remark":`以下列出的使用者可以看到此記錄的訊息`,
"label.address_information":`位址資訊`,
"label.projectManagement.overdue.tasks":`已逾期的工作`,
"lable.account.PreviousCQ":`上一個日曆季度`,
"label.service.miniProgram.advertising":`廣告名稱只是作為辨別多個廣告項目之用，並不顯示在廣告中`,
"label.integrations.mailchimp.exportlead":`匯出商機至Mailchimp`,
"label.payments.paytip3":`請選擇帳單地址`,
"label.mobile.phone.screen":`篩選`,
"label.h5.tome":`關於我的`,
"label.mobile.side.tab.remark1":`將CloudCC選項卡及物件添加到行動端側滑欄導航選單`,
"vue_label_calendar_choose_a_custom_color":`選擇此日曆的自訂顏色`,
"label.lastname":`姓氏`,
"vue_label_dashboard_selectreport":`請選擇報表`,
"label.lanxin.setting.appid":`AppID`,
"vue_label_report_information":`以在CloudCC中顯示的方式匯出報表，包含報表表頭，分組和篩選訊息。`,
"label_chatter_default":`預設`,
"label.globalSearch.info":`搜尋全部已選物件`,
"label.integrations.mailchimp.massage2":`正在將商機匯出至Mailchimp，稍後您可在Mailchimp列表中查看。`,
"label.tabpage.addresswrongz":`信箱地址格式錯誤,請正確輸入信箱地址！`,
"label.mobile.phone.customer.call":`客戶拜訪`,
"vue_label_email_linkrecordfail":`已取消關聯記錄`,
"lable.account.LastfDays":`過去90天`,
"label.cpq.order.status.delete":`該訂單已啟用，不能刪除`,
"label.ccchat.notmember.active.group":`您不是名稱中含有`,
"label.savepayset.failure":`儲存線上支付設定失敗`,
"label.version.createlimitbyobject":`您當前CloudCC版本是 {0}， 每個物件允許建立 {1} 個{2}，已達到上限！如有需要，請升級CloudCC版本！`,
"approval.process.errore":`儲存過程中出現錯誤，請聯繫系統管理員`,
"label.stdashbord.xsld.business.reportanalysis":`圖表分析`,
"label.login.verification.please.enter":`請輸入您從MFA應用程式中獲取的安全碼`,
"label.tabpage.cue":`訊息提示`,
"vue_label_salesadvance_converserate":`轉化率`,
"label.marketsea.recyclereminddays1":`自動回收前`,
"label.import.page1.update":`更新`,
"label.document.folder":`文檔文件夾`,
"label.h5.similar.opportunity.feature":`此功能使使用者可搜尋與使用者的業務機會共享共用欄位的業務機會。一旦啟用，一個“類似業務機會”相關列表會出現在業務機會記錄中。`,
"label.myanmar.time":`緬甸時間`,
"monday":`星期一`,
"vue_label_account_shareholder":`股東`,
"button.partner.search":`查詢`,
"label.partnerCloud.partnerAccount.topUpAmount":`儲值金額`,
"label.tabpage.refreshz":`重新整理`,
"lable.PowerProcess.complete":`完成重大事件的分鐘`,
"front-kefu-moudle- normal-phone":``,
"label.user.unauthorized.organization":`未經授權的組織，請聯繫管理員！`,
"label.area.canot.save.nulldata":`不能儲存空數據`,
"label.version.role.management":`角色管理`,
"label.recordtype.batchaddattachments.batch.remark":`步驟 1.選擇文件； 步驟 2.單擊“開始上傳”按鈕，上傳文件； 步驟 3.單擊“完成”按鈕，返回上一頁`,
"label_tabpage_contentz":`請輸入內容`,
"label.partner.workspace.member.all":`全部`,
"label.validate.function.funcFormat.LEFT":`LEFT(text, num_chars)`,
"vue_label_SMS_notice_selectatleastone":`請至少選擇一位商機或聯絡人`,
"label.appupload.install.error.choice5":`立即停止安裝，並輸出衝突組件`,
"label.version.lookupmdfield":`主詳欄位`,
"setup.layout.label.desc":`降冪`,
"vue_label_report_addsummaryformula":`添加匯總公式`,
"label.done":`實際`,
"label.input.samevalue":`輸入相同的值`,
"label.SMS.next":`為此簡訊通知選擇物件並單擊下一步"。簡訊通知只能與相同類型的工作流規則和審批流程相關聯。"`,
"label.role.allunselectuser":`所有未指派的使用者`,
"label.loginhistory":`登入歷史`,
"vue_label_report_addpublicreportstofolder":`添加公用報表至此文件夾`,
"label.email.track.no.attachment":`無附件`,
"label_network_connection_failure":`網路連接失敗`,
"vue_label_file_delete_lib_member":`刪除文件庫成員`,
"label_partner_step1":`步驟1：選擇範本`,
"label.password":`密碼`,
"label.select.the.fields.around.code":`選擇顯示在二維碼/條碼周圍的欄位`,
"label.file.share.limit":`超出共享上限，無法添加新的共享！`,
"label.desktop":`桌面`,
"label.sendmail":`發送郵件`,
"label.quote.detail":`報價單明細`,
"label.approvalstep2":`步驟 2：指定步驟條件`,
"label_component_hotdeal_nodata":`無機會相關數據`,
"lable.reset":`重置`,
"label.eventpagelayout":`事件版面配置`,
"label.icon.100":`文具`,
"UG.quota.03":`報價範本`,
"label.calendar.week.view":`周視圖`,
"component_chatter_file_button_save":`發表`,
"label.as":`為`,
"template.chart.yqxypjz":`預期響應平均值`,
"UG.Contract.03":`建立合約`,
"label.projectManagement.gantt":`甘特圖`,
"label.forecast.edit.error0":`錯誤：請至少啟用一種公司幣種!`,
"label.ccpeak.delete.sharetab":`刪除共享表`,
"label.account.contact.goback":`返回客戶`,
"vue_label_email_insert_field":`請選擇插入欄位`,
"setup_object_field_dependency_label_fieldvalueoptions":`可選欄位值`,
"label.salescloud.opportunity.contactrole.optionlist.main":`下面是業務機會聯絡人角色欄位的選項列表值的主列表`,
"label.huanxinconfig.tenantid.lost":`tenantid不能為空`,
"label.mask.show.last_4":`遮罩顯示最後4位`,
"label.targer.name":`目標名稱`,
"vue_label_commonobjects_detail_unlocksuccess":`解除鎖定成功`,
"front-kefu-moudle-length-min":``,
"label.chat.topic.my.favorite":`我收藏的主題`,
"chatter.upload":`上傳`,
"message.cannotapproveit":`無法處理該批准請求`,
"label.weixin..xsld.order.by.jine":`按契合約金額排序`,
"label.projectManagement.wait.test":`等待測試`,
"template.report.customer.contact.list":`客戶聯絡人清單`,
"label.empty.recycle.bin":`清空回收桶`,
"label.detail.approveprocess":`查看審批流程`,
"label.appexchange.uninstallpage.message4":`永久刪除基於此軟體包中的自訂物件的任何報表、試圖和自訂選項卡`,
"label.weixin.linkreport":`關聯→報表`,
"label.tianyancha.orgnumber":`組織機構代碼`,
"Q":`選項列表（多選）`,
"pagecreator_systemstyle_message_save_fail":`樣式儲存失敗`,
"label.partner.new":`夥伴雲：新建`,
"label.ems.accounttype":`帳戶類型（A）`,
"label.weixin.next":`下一步`,
"label.weixin.coach.interpret":`愛馬社保留此微信服務法律範圍內的修改權和最終解釋權`,
"label.some":`個`,
"label.currency.rate":`幣種編輯：兌換率`,
"label.emailobject.template.name":`範本名稱`,
"UG.Campaign.001":`計劃行銷活動`,
"label.mr.descreption.reDataList3":`組，查詢花費時間`,
"label.project.hit.nine":`每天問題提醒`,
"lable.PowerProcess.golist":`<<返回列表：權利過程`,
"label.viewbuttonedit.remark":`選擇要在前台視圖上顯示的標準按鈕及自訂按鈕`,
"label.component.helper":`助理`,
"lable.SalesCommitmentKanBan.contractAndReceipts":`簽約收款`,
"chatter.group.userName":`使用者帳號`,
"label.mobile.phone.business":`商機`,
"label.quickbooks.payments":`付款`,
"label.step6.total7":`第6步，共7步`,
"label.forecast.detailforecast.revenue":`收入預測`,
"vue_label_commonobjects_view_chart_displayas":`顯示為`,
"label.recordeditoption":`記錄可編輯性屬性`,
"label.sendemail.send.sendfailstandby":`信件發送失敗，請聯繫管理員。 (備用發件箱)`,
"label.knowledgebase.reset.filter":`重置篩選器`,
"label.icon.111":`餐飲`,
"label.standard.buttonandlink.firstsetting":`優先設置`,
"front-filter-module-v1-filter-description":`快速篩選器無法儲存，僅適用於目前操作。不會影響視圖，也不會影響其他使用者。`,
"label.showmore":`顯示更多`,
"UG_Lead_001":`如何引入線索?`,
"label.exchange.sync.state.setting.m1":`提供的 Miscrosoft Exchange 服務帳戶：`,
"label.please.enter.channel.name":`請輸入通路名稱`,
"label.emailtocloudcc.edit":`編輯`,
"label.layout.tabdialog":`選項卡`,
"label.Emoji":`表情`,
"template.report.completed.tasks":`已完成的工作`,
"label.tabpage.enterviewname":`第一步：請輸入視圖名稱`,
"label.mobile.phone.not.to.choose":`未選擇`,
"label.datamanage.contact.namenull":`注意：如果沒有給“聯絡人姓名”欄位賦值，聯絡人記錄將不會被匯入！`,
"LT":`地理定位`,
"label.exchange.sync.state.task.m3":`在最後24 小時同步的記錄：`,
"lable.SalesCommitmentKanBan.contractOwner":`合約所有人`,
"vue_label_chatter_write_review":`撰寫評論`,
"label.h5.approval.enter.content":`請輸入審批備註內容`,
"label.location.display.type":`緯度與經度顯示表示法`,
"label.numberscannotnull":`數量不能為空`,
"label.icon.3":`貨幣`,
"setup_object_field_dependency_label_linkedfieldvalue":`相依欄位值`,
"label.task.future":`未來的任務`,
"label.look.more.record":`查看更多記錄`,
"vue_label_account_cases":`轉移客戶擁有者的全部個案`,
"label.emailobject.emaildetail.title.ccaddress":`副本給：`,
"label.setHistoryTrack":`設置歷史追蹤`,
"ObjectDetailed.ViewKeyInformation.Layout":`編輯關鍵訊息`,
"label.layout.editsearchdistribute.tip":`選擇要包括到此搜尋配置中的欄位。請注意，所做的選擇只決定搜尋結果的顯示，而不會影響實際被搜尋的欄位`,
"label.emailtoall":`發送電子郵件給所有人`,
"label_partner_new":`夥伴雲：新建`,
"label.direct.dashboard.me.not.approval":`我的未審批項目`,
"label.platform.customize.customizeui":`自訂UI`,
"label.userinfo.pwderror.againinput":`兩次輸入的密碼不一致，請重新輸入！`,
"label.customsetting.introduce":`使用自訂設置建立並管理組織、設定檔和使用者級的自訂數據。自訂設置數據存儲在應用程式緩存中。這意味著您可以有效地存取它，而不必進行重複的查詢。`,
"label.file.owner":`擁有者`,
"label.icon.7":`人`,
"label.document.query.button":`單擊瀏覽按鈕查找文件`,
"label.tabpage.turnoffsz":``,
"message.error.appid.appsecret.failed":`獲取金鑰失敗！`,
"vue_label_commonobjects_view_to_display_fields":`最多選擇10個展示欄位`,
"label.martrixreport.setlinetitle":`指定行標題`,
"vue_label_chatter_applycertification":`確定同意"{name}"加入小組嗎`,
"front-electronic-export-success":``,
"label.emailsync.status.enable":`啟用關聯`,
"label.c_d":`C 到 D 關係`,
"PageLayout_Search_MultiSearch_003":`您至少選擇一個欄位。`,
"label.tabpage.newInterfacez":`新版介面`,
"label.cutomsummaryfieldedit":`編輯自訂彙總欄位`,
"label.usermanage.view.field.notexist":`視圖對應的欄位不存在`,
"label.list.userinterface.dashboard.setup":`儀表板設置`,
"label.knowledgebase.delete.article":`刪除文章`,
"label.dataimport.type.update":`更新`,
"label.marketsea.new":`建立公海池`,
"label_tabpage_newlybuildz":`新建`,
"vue_label_helpcenter_report1":`1、構建報表<br>????CloudCC銷售管理系統中的Lightning 報表是一款功能強大的數據分析的工具。通過分組、篩選和匯總記錄可以解決很多銷售問題。例如：“上一季度，公司開展的新的商機共創造多少收入？”，在完成數據概覽的基礎上還可添加報表圖表。報表完成後，單擊運行，可查看數據的完整結果。<br>????步驟1：從報表選項卡，單擊“建立報表”； <br>????步驟2：選擇報表數據源，然後單擊“下一步”； <br>????您選擇的報表數據源，可以決定哪兒些記錄或欄位可以在報表中使用。選擇或者搜尋一個物件作為主物件，最多可以選擇4個與主物件具有關聯關係的物件，並且可以選擇物件之間的關係。<br>????步驟3：進入報表編輯頁面，並顯示預覽數據<br>????在編輯模式中，可以自訂報表，將欄位作為列添加到報表、分組行和列、利用篩選器篩選報表數據，直到準確顯示您需要的數據<br>添加、移除列及調整列順序<br>????添加列：在報表編輯模式中，單擊頁面左側“概要”中的“列”輸入框，通過搜尋欄位後選擇或滾動下拉欄位列表後選擇想要的欄位的方式添加報表列。<br>????移除列：<br>????A.在左側“列”列表中找到想要移除的“列”後，單擊欄位框上的“×”。<br>????B.或在右側報表預覽視圖的表頭中找到想要移除的“列”後，單擊“下拉按鈕”，單擊“刪除列”。 <br>????將列從報表中移除不會刪除欄位。如果您移除列，但想要進行恢復，重新添加即可。<br>????調整列順序：通過上下拖曳左側“列”列表中的“列”欄位可以調整“列”的排列順序。<br>添加、移除行分組和列分組<br>????添加行分組：單擊頁面左側“概要”中的“組行”輸入框，通過搜尋欄位後選擇或滾動下拉欄位列表後選擇想要的欄位的方式添加報表行分組欄位，進行數據篩選。<br>????在沒有添加列分組的情況下，最多可添加三個行分組。<br>????添加列分組：在存在行分組的情況下可以添加列分組，單擊頁面左側“概要”中的“組列”輸入框，通過搜尋欄位後選擇或滾動下拉欄位列表後選擇想要的欄位的方式添加報表列分組欄位，進行數據篩選。<br>????最多可添加兩個列分組，在添加列分組的情況下，最多可添加兩個行分組。添加為行分組的欄位不能再添加為列分組。<br>????`,
"label.notification.event1":`【指派人】已為您指派事件`,
"chatter.field":`個欄位`,
"chatter.feed.menutype.feed.newscom":`我正在追蹤的所有內容`,
"label.attendance.range":``,
"vue_label_calendar_deleteconfirm":`確定刪除日曆{name}嗎`,
"label.ems.createTask":`建立{taskName}`,
"label.visualpage.wgd":`未歸檔自訂頁面`,
"label.multilang.product.deleterederect1":`無法完成您對{0}的刪除嘗試,因為它仍與以下記錄相關聯。這種情況下,建議您禁用。`,
"label_emailtocloudcc_filed_servertype":`伺服器類型`,
"label.umeng.insert.approval.dlsp.approvenew":``,
"label.tabpage.queue":`佇列`,
"label.approval.step":`審批步驟`,
"label.approvaldatamove.approvalprocessname":`過程名稱`,
"label.actualapprovedpeople":`實際審批者`,
"label.systemlog.f":`失敗`,
"front-template-V1-addText":`新增文本`,
"label.chat.like":`讚`,
"label.userinfo.oldpwd.notnull":`舊密碼不能為空！`,
"label.service.all.done.major.event":`您已完成所有重大事件`,
"label_chatter_to":`到`,
"message.toomuchlinecannotoutput":`選擇報表列過多，報表無法輸出！`,
"maintenanceasset.assetid.maintenanceplanid.unique":`維護計劃已分配到資產，請勿重複分配`,
"lable.quote.syncing.firstsync.description":`報價單明細 將替代業務機會產品`,
"lable.outlook.mcto.saveemail":`務必儲存電子郵件附件`,
"label.passwordPolicy.setup.pwdremember2":`記住2個密碼`,
"label.project.hit.five":`項目工作更新通知`,
"label.linkedin.setting.appid":`秘鑰`,
"label.dataimport.error.name.notnull":`出現錯誤：name不能為空。`,
"label.knowledge.case.field.selected":`已選個案欄位`,
"label.version.datetime":`{0}個日期時間欄位`,
"Dashboard_NoAccessRightToSee_Warning":`您所設置的預設打開儀表板{0}目前您沒有權限查看，您需要重新設置為其他值。`,
"label.login.access.permission":`授予存取權限`,
"label.operatedata.import.tip":`1.匯入的文件必須是CSV格式的文件，CSV文件必須包含標題，沒有標題不能匯入。 <br/>2.建議在匯入時先匯出，以匯出文件為資料範本整理匯入資料，然後再匯入。 （匯入的資料中如果含有逗號，請使用'@'符號代替）<br/>3.系統會把將要匯入的資料文件預讀到伺服器，然後啟動後台批處理匯入程序，匯入結果將以郵件方式通知使用者，您無需在此操作頁面等待。`,
"workflow.action.tasks.assignortype.rolename":`角色名稱`,
"vue_label_account_quotations":`轉移客戶擁有者的全部報價單`,
"lable.account.CurrentCQ":`當前日曆季度`,
"label.user.database.error":`數據庫錯誤！`,
"label_emailtocloudcc_titel":`Email to CloudCC`,
"label_file_content":`正文內容`,
"label.button.behavior":`模式`,
"message.recordtype.new.tip":`輸入詳細訊息`,
"label.ccchat.message.new.error3":`錯誤：您無法選擇超過9個收件人`,
"vue_label_commonobject_notice_lessthanwords":`文件名稱字數應小於{FILE_NAME_COUNT}個字！`,
"label.stacked.verticalline":`堆疊圖形-垂直列`,
"vue_label_SMS_messagebox":`簡訊箱`,
"label.appexchange.installedpage.message3":`根據已安裝軟體包旁邊的連結，您可以在此頁面中執行不同的操作。要刪除軟體包，單擊<b>移除</b>。要管理軟體包許可證，單擊<b>管理許可證。</b>`,
"label.unusedapproveprocess":`未啟用的審批流程`,
"label.onlywithspecificconditions":`此計算僅應包括符合特定條件的記錄`,
"lable.outlook.mcto.formaterror":`格式錯誤`,
"label.area.parent":`上級區域`,
"vue_label_chat_activesuccess":`開通成功`,
"label.setting.intergrationlist.button.upgrade":`更新`,
"label.page_hidden":`註冊頁面隱藏欄位`,
"label.customsetting.manage.belong":`設置所有者`,
"label.appointment.wizard.subtitle4-2-8":`7天`,
"template.chart.ydywjhxsje":`月度機會銷售金額`,
"label.multilang.currencylist.after":`{0}之後`,
"vue_label_commonobjects_view_chart_countby":`合計依據`,
"label.week":`周`,
"label.emailtemplate.name":`範本名稱`,
"label.umeng.sign":`已經簽到`,
"label.appupload.upload.details":`詳細訊息`,
"label.file.loading":`正在載入`,
"label.newdetail.orgTitle":`聯絡人人脈`,
"label.salescloud.field.addoptionlist":`添加選項列表值`,
"pagecreator.page.funcpath":`/構建器/頁面列表`,
"Account.News.Setting.001":`客戶設定`,
"label.marketsea.getnoconversiondays":`天未轉換（需大於獲取後未跟進天數）`,
"message.error.event.add":`建立事件異常`,
"front-electronic-export-choseChimp":``,
"vue_label_report_personothers":`其他人員`,
"label.hierarchy.diagram":`階層架構圖`,
"label.stdashbord.xsld.business.yqsr":`預期收入`,
"label.chat.topic.max.count":`您已經達到主題的最大數目。`,
"label.sendemail.send.sendfail":`信件發送失敗，請聯繫管理員。`,
"registration.page.body.title":`註冊頁面`,
"label.userphoto.back":`取消`,
"label.service.without.timeslot":`似乎沒有任何時段，現在讓我們添加一些！`,
"label.processsetting.remaining.quantity":`最多輸入255個字元，剩餘數量：`,
"label.sure.delete":`確認刪除`,
"front-epwechat-module-v1-callback":`回調配置`,
"front-email-payment-failed":``,
"label.icon.67":`機器`,
"UG_Forcast_01":`預測`,
"label.escalation.setup.newentries.step3":`步驟3：指定如何設置升級時間`,
"lable.account.NextCY":`下一個日曆年度`,
"report.type.label.quote":`報價`,
"label.area.name":`區功能變數名稱稱`,
"component.setup.label.object":`物件`,
"label.customsetting.type":`設置類型`,
"label.showdetail":`顯示詳細訊息`,
"label.department.prev":`上一頁`,
"label.select.data.source.report":`請選擇數據源報表！`,
"UG_homepage_002":`使用一體化的業務工具來管理您的線索、商機、銷售交易漏斗以及客戶訊息`,
"vue_label_report_notice_exprot1":`僅匯出詳細訊息行。使用此數據，以進行更多計算，或上傳到其他系統。分頁匯出，單頁最多匯出5000條`,
"message.error.task.phonecreate":`電話工作建立異常`,
"label_chatter_day":`天`,
"label.setinitialcommiter":`步驟 6: 指定初始提交人`,
"message.huanxinconfig.notfound":`未找到環信相關配置`,
"label.customfields.file.count.tip":`請輸入此欄位可輸入的文件個數，預設為1`,
"label.weixin.appmanage":`應用管理`,
"label.approverautoconfirm":`審批者的自動確定方式`,
"vue_label_CCChat_followers":`關注者`,
"label.usermanage.notselect":`未選擇使用者`,
"label.item":`條`,
"label.sendemail.chat.linkurl":`連結URL：`,
"label.sendmail.step3.deliveroptions":`交付選項`,
"homepage.components.creationtime":`建立時間`,
"label.pc.ui.2018.ccchat.setting":`CCChat設置`,
"label.knowledge.search.result.highlight":`在搜尋結果中強調突出顯示相關的文章文本`,
"label.data.downpage.e.title.num2":`2、若選擇匯出單個物件的資料，則需要選擇資料匯出方式。資料匯出方式有：自訂匯出，按範本匯出，匯出範本。`,
"label.field.duplicate.error.msg1":`存在重覆數據，請先處理重覆數據再設定獨有屬性。`,
"label.campaign.channel.input.number.error":`數字格式錯誤`,
"label.goto.dashboard":`轉至儀表板`,
"com.cloudcc.login.error.message.invalid.ip":`IP不在登錄範圍內`,
"label.selectnewfieldvalue":`指定新的欄位值`,
"label.appointmentdetail.wizard.title11":``,
"Opportunity_Detailed_Phase_Label_Popup_001":`進入日期`,
"front-dynamiclayout-module-v1-readonly":`{readonly}欄位已被設定為唯讀欄位`,
"vue_label_calendar_start_field":`開始欄位`,
"label.weixin.recalculate.shared.failed":`物件共享規則重新計算失敗`,
"label.sendmail.step3.dealoptions":`處理選項`,
"setup_layout_label_modifypage":`編輯頁面`,
"homepage.components.select.wide":`選擇要顯示的寬式組件`,
"label.import.page1.laststep":`上一步`,
"label.weixin.donot.permission":`您沒有權限執行此操作`,
"message.error.name.null":`name不能為空！`,
"label.salescloud.teamrole.optionlist":`小組角色選項列表值`,
"component_setup_label_titlefield":`標題欄位`,
"vue_label_commonobjects_detail_have_been":`您已為`,
"label.textmessage.vonage.setup":`Vonage設定`,
"label.recordtype.profile.enableit":`為設定檔啟用`,
"UG.product.04":`建立產品`,
"label.knowledge.No.related.articles":``,
"label.chat.muted":`免打擾`,
"registration.page.field.selection":`註冊頁面欄位選擇`,
"label.project.hit.eleven":`問題指派通知`,
"lable.newtabpage.advsearch":`進階搜尋`,
"label.report.share.roleandsub":`角色及內部下屬`,
"component.salesperformance.label.nodata":`添加您的機會，然後返回此處查看業績圖。`,
"label.submitted_on":`送出日期`,
"label.file.create.link":`建立連結`,
"label.contact":`聯絡人`,
"label.tab.message.failtoopenleft":`左側欄打開合併操作失敗`,
"label.replaces":`取代`,
"label.customcomponent.check.tag.startwith":`組件必須以&lt;cc:component&gt;標籤開頭`,
"label.tab.web":`Web 選項卡`,
"message.success.task.add":`儲存建立工作訊息成功`,
"label.chatter.addresser":`發件人`,
"label.mobile.homepage":`首頁`,
"label.data.imp.su.ok":`系統正在匯入`,
"label.knowledge.category.hint.one":`類別組是數據類別的階層架構。例如，一個名為“位置”的類別組可能包含大陸、國家、地區和州的地理階層架構。使用此頁面來管理類別組及其所含的類別。`,
"label.schedulejob.setup.schedule.weekly":`每週`,
"label.tag.manage.description":`與{0}相關聯的所有標籤如下所示。您可以對可用標籤進行重命名或刪除操作。`,
"label.tabcontrol":`選項卡`,
"label.field.duplicate3":`將“ABC”和“abc”視為重覆值（不區分大小寫）`,
"label.customsetting.type.list":`列表`,
"lable.account.ovdate":`會計季度結束日期`,
"label_chatter_pastSevenday":`過去7天`,
"front-kefu-moudle-v1-lxndxsdb-free":`聯繫您的銷售代表，免費開通工作人員功能`,
"label.termsforusage":`使用條款`,
"label.forecast.settings.qijian.m":`每月預測`,
"label_tabpage_viewname":`視圖名稱`,
"label.report.action.addtodashboard1":`添加至儀表板`,
"label_vue_create_edit_obj_create_event_dialog_desc":`您指派的使用者在該時間段內已有待辦事項：`,
"vue_label_report_standardfilter":`標準過濾器`,
"label.umeng.approval.submit":`#applyer提交了#obj待批准`,
"label.tab.mobile.sign":`行動端圖標`,
"vue_label_commonobjects_detail_check_the_content":`存在驗證錯誤，請檢查填寫的內容`,
"UG_Campaign_001":`計劃行銷活動`,
"chatter.group.baseInformation":`基本訊息`,
"label.sendemail.send.noreceiver":`沒有收件人或收件人郵件地址為空`,
"template.chart.yskje":`應收款金額`,
"label.textarea":`文本區`,
"vue_label_statistics_value":`統計值`,
"font-evaluate-module-v1-select-img":``,
"label.totalof":`您共選擇了`,
"label.hangye":`行業`,
"label.partner.common.setup":`一般設置`,
"label.icon.78":`農業`,
"lable.outlook.detail.addemail":`添加電子郵件`,
"label.ServiceCloud.fuwuquyu":`服務區域`,
"label.gb2312encoding":`簡體中文(GB2312)`,
"label.appointment.wizard.subtitle4-3-1":`10分鐘`,
"label_emailtocloudcc_reauthorization":`重新授權`,
"label.approval.message":`審批意見最多輸入1000字`,
"label_component_helper":`助理`,
"label.editRate":`編輯匯率`,
"label.setuptemplate":`自動化範本`,
"label_emailsync_button_cancel":`取消`,
"label.marketseamemset.account.maxuser":`成員最大客戶數`,
"label.someerror":`由於安全原因，您的 CloudCC 會話即將超時。<br><br>您希望作何選擇？`,
"label_person_in_charge":`負責人`,
"label.visualpage.reference.standard.style":`引用平臺標準樣式，customize-自訂樣式`,
"errormessage_email_relatedorreceivermusthaveone_z":`收件人和相關項至少選擇一項`,
"label.insert.field.empty.continue":`存在【{resDataField}】值為空的記錄無法產生碼,是否仍要繼續產生?`,
"component.newrecords.label.title":`最近記錄`,
"template.detail_info_link":`詳細訊息連結`,
"component_setup_tabs_label_default":`預設頁`,
"label.emailobject.template.name.null":`郵件範本名稱不能為空`,
"label.knowledge.field.changed":`已更改{1}`,
"homepage.components.select.narrow":`選擇要顯示的窄式組件`,
"label.mobile.phone.week":`第幾週`,
"component_chatter_button_like":`喜歡`,
"label.brief.won":`成交`,
"label.setup.profile.replaceme":`取代關於我`,
"label.knowledge.setting.enable.lightning":`啟用Lightning知識庫`,
"label.middle":`中`,
"label.icon.109":`人`,
"vue_label_normal_activity_sf":`活動`,
"chatter.poll.option6":`選項6`,
"label.lanxin.setting":`集成藍信H5微應用`,
"label.stdashbord.xsld.business.totals":`業務情況彙總`,
"label.emailobject.emaildetail.promptbutton1":`確定`,
"Opportunity.Detailed.Phase.Label.001":`階段`,
"label.customcomponent.params.info":`如何使用參數`,
"label.emailtocloudcc.button.next":`下一步`,
"front-email-payment-billing-date":``,
"label.ems.with3day":`3天以內`,
"label.project.subtask.date":`子工作日期必須在所屬工作的日期範圍內。`,
"label.role.allunselectanduseduser":`所有未指派且已啟用的使用者`,
"front-kefu-moudle-yes-wantbuy":``,
"label.looking_for":`您找到想要的結果了嗎？`,
"page.404.label.noresource":`很抱歉，您所存取的資源不存在。`,
"vue_label_ccchat_notice_deletecommentcertification":`確定要刪除這條評論嗎？`,
"label.data.setok.e.desc1":`匯出成功後您會收到系統郵件提醒，匯出的數據暫時儲存在伺服器上，系統只為您儲存48小時，請盡快到`,
"label.weixin.confirm.delete":`確認刪除該條數據嗎`,
"A":`文本區（富文本）`,
"template.report.sales.cycle":`銷售週期持續時間`,
"label.service.shift":`輪班`,
"label.visualpage.display.side.bar":`顯示側欄，false-不顯示側欄`,
"label.list.userinterface.chatter.showall":`首頁 CCChat 預設顯示全部微貼`,
"vue_label_systemSettings_set_course":``,
"label.icon.156":`人`,
"label.marketsea.button.move":`轉移`,
"front-email-payment-select-email":``,
"front-electronic-signature-service-provider":``,
"label.h5.add.checkin":`簽到`,
"vue_label_amount_total":`金額總和`,
"label.campaign.channel.new":`市場活動：新建營銷渠道`,
"label.knowledgebase.restore.creates.draft":`還原會從此一版本建立草稿。您將需要發布草稿，以使其可用。`,
"UG_Case_01":`個案`,
"label.validate.function.funcExplain.CONTAINS":`檢查文本是否包含特定字元，如果是則返回TRUE。否則返回FALSE。`,
"label.data.exp.savetemp":`另存為範本`,
"front-project-module-v1-template-newcreate":`從項目範本建立項目`,
"label.field.default.count":`預設行數`,
"page.note.acc":`備註和附件`,
"label.close":`關閉`,
"label.app.detailbeforeedit":`下面是該自訂應用程式的訊息。單擊編輯"可以更改自訂應用程式。"`,
"label.profile.standardfieldsafety":`標準欄位級安全性`,
"vue_label_report_notice_deletefilter":`請先刪除進階篩選條件`,
"label.multilang.datamoveaction.movesuccess":`共有{0}條記錄轉移成功！`,
"label.emailmerge.edittemplate.descirption":`輸入有關您的郵件合併範本的訊息。請注意，備註僅顯示在cloudcc中，不會顯示在Word中。`,
"label.visualpage.at.the.end":`在結束處以標籤`,
"label.exchange.sync.state":`Exchange Sync 狀態`,
"label.newdashboardpage.new":`新增一行`,
"label.querydetailservice.profile.notsetup":`您的賬戶對應的設定檔未設置`,
"label.escalation.setup.detail.description":`建立規則項目以根據其中指定的條件自動升級個案。建立規則項目後，可以從此頁面上進行重新排序。`,
"lable.setup.mobilesetup.isenbaleh5newandedit":`行動端是否啟用H5建立編輯`,
"vue_label_file_upload_tip_msg":`建議上傳文件小於30MB，否則可能導致頁面連線緩慢`,
"label.eowechat.epdeptid":`企業微信部門id`,
"label.adminorapprover":`管理員<strong>或</strong>當前分配的審批者可在審批過程中編輯記錄。`,
"label_emailtocloudcc_email":`電子郵件`,
"setup_main2018_label_norole":`您沒有系統管理欄相關權限`,
"label.onlyone":`唯一`,
"label.sso.saml.idp.config.nameidtype":`物件類型`,
"vue_label_normal_campaign_sf":``,
"label.icon.61":`吊機`,
"label.datatype":`資料類型`,
"label.mobile.home.page.today.work":`我的工作`,
"label.sendemail.chat.praiseFeedcommentsubject":`CloudCC CCChat 喜歡您的留言`,
"chatter.sel.p":`已選擇0人`,
"label.b_c":`B 到 C 關係`,
"label.tabcontrolnameandtaglib":`選項卡名稱和標籤`,
"label.globaloperation.tip":`建立、編輯和查看全局操作，這可用於詳細訊息頁面。`,
"R":`記錄類型`,
"label.initcommiteoperate":`初始提交操作`,
"front-kefu-moudle-v1-Operation-without0-permission":``,
"button_partner_create":`建立`,
"label.document.name.length.cannot.than":`文檔名稱長度不能超過255`,
"label.area.donot.delete":`無法刪除區域，因為當前區域有下級區域`,
"label.currency.activation":`啟動`,
"label.connect":`&串聯`,
"button.partner.viewdetail":`查看`,
"setup_object_field_dependency_label_mustsetup":`請先設置欄位依賴關係，再儲存`,
"label.SalesCommitmentKanBan.task":`任務額`,
"lable.quote.syncing.finishbutton":`完成`,
"label.weixin.group.type":`存取類型`,
"vue_label_commonobjects_detail_relationship":`關係程度`,
"vue_label_email_cc":`密送人`,
"setup.object.field.dependency.label.fieldvalueoptions":`可選欄位值`,
"label.sso.lookAtTheKey":`查看密鑰`,
"UG.opportunity.008":`機會小組`,
"label.customfields.new.step1":`步驟1.選擇欄位類型`,
"lable.qrcodeOrbarcode.rule":`產生二維碼/條碼規則`,
"vue_label_notice_nopermission_delete":`抱歉，您無權刪除該條數據，請聯繫系統管理員。`,
"label.customerobj.tab":`自訂物件選項卡`,
"com.cloudcc.login.error.message.nolicens":`許可不存在`,
"label.sendsms.batch.confirm":`批次發送簡訊：確認`,
"label.forecast.settings.sos":`收入和數量`,
"label.calendar.addevent.notice.opencalendarfirst":`請先開啟我的日曆或其他日曆後再添加事件`,
"message.success.task.phonerecord":`儲存電話記錄工作成功`,
"label.knowledgebase.create.new.subtab":`建立子頁籤`,
"label.knowledge.article.recordid":`知識文章id不能為空`,
"Opportunity.Detailed.Phase.Label.Popup.003":`停留天數`,
"homepage.layout.nowpage":`現有的頁面配置`,
"template.chart.khslph":`客戶數量排行`,
"front-epwechat-module-v1-android-single":`Android單一登入：`,
"serviceresource.assignedresource.islacksr.lack":`因服務資源被指派了服務預約，因此無法刪除服務資源，您可以不啟用此服務資源`,
"label.email.only.display.info":`下框中只顯示已存有電子郵件地址的聯絡人或者同事`,
"label.weixin..xsld.yjhtje":`預計合約金額`,
"label.permission.delete.permsets.error.prompt":`該權限集中有指派的使用者，不能刪除！`,
"label.ccchat.enter.two.choices":`請填寫至少2個選項`,
"label.edit.field.select.style2":`每個選項一行`,
"vue_label_email_please_enter_email_subject":`請輸入郵件主題`,
"batch.sendemail.f":`， 郵件發送失敗。`,
"label.sms.senderr":`簡訊發送失敗`,
"label.batchadd.newbatchpage.save.em":`郵箱格式不正確`,
"label.icon.96":`圓規`,
"message.recordtype.deleterecord.tip":`使用此頁將所有的現有記錄類型取代為新記錄類型。在以下框中選擇取代記錄類型以應用於任何包含所刪除記錄類型的記錄。如果您只是想從現有記錄中刪除該記錄類型而不用新記錄類型取代它，請選擇無"."`,
"label.field.edit.max":`最大評分`,
"label.partnerCloud.orderingPlatform.preferential":`優惠`,
"label.callcenter.login.later":``,
"batch.change.owner":`請選擇所有人`,
"label.version.allow.upload.size":`允許上傳檔最大為`,
"setup.mainpage.label.welcome17":`權限設定`,
"label.tag.sectionname":`標籤訊息`,
"label_partner_workspace_setup":`設置`,
"label.managecontrol":`管理權限`,
"label.timetrigger.condition":`評估條件設置為每次建立或編輯記錄時`,
"label.reportsSubscriptionPage.schedulereport.monthly.week":`星期`,
"front-verkoop-bywerking-error":``,
"label.allowcommittercallback":`允許提交人調回批准請求`,
"vue_label_commonobjects_detail_lead_finishistatus":`將狀態標記為完成`,
"message.error.object.lookupmd":`物件建立了主詳關係`,
"label.stdashbord.xsld.business.img7":`可能性為0%階段的個數/(可能性為100%階段的個數 可能性為0%階段的個數)`,
"label.checkruleofevent":`事件驗證規則`,
"front-epwechat-module-v1-single":`單一登入`,
"label.tabpage.save":`儲存`,
"label_emailtocloudcc_search":`搜尋`,
"label.tianyancha.h5.registeredPlace":`註冊地（簡寫）`,
"label.field.addoptionlist":`添加選項列表值：選項列表`,
"label.schedule_anotherpost":`計劃其他的帖子`,
"label.customfields.searchrelation.tip":`建立一個將此物件連結到另一物件的關係。 關係欄位允許使用者單擊查找圖標，以從彈出列表中選擇值。 另一對像是列表中值的來源。`,
"label.partnerCloud.partnerAccount.prepaidPhone":`帳戶儲值`,
"label.projectManagement.view.details":`是否確定要刪除“{name}”篩選器?`,
"label.sendemail.chat.praiseFeed":`尊敬的#name:\n\n 您好！ #userName對您的微貼點了喜歡。`,
"label.validate.function.category.Text":`文本`,
"component.task.label.newevent":`建立工作`,
"label.data.import.setup.operate":`如果發現現有記錄，您希望採取什麼操作？`,
"label.salescloud.salesdashboard.clear.option":`清除選項`,
"lable.account.PreviousCY":`前兩個日曆年度`,
"label.appointment.wizard.subtitle8":``,
"label_emailsync_status_viewlog":`查看記錄`,
"message.duplication.label.filtertitle":`查重過濾器`,
"label.custom.quarter.description":`此頁允許您定義一個自訂季度記錄。自訂季度的日期將根據您下面所進行的選擇產生。`,
"label_tabpage_filenamez":`文件名稱`,
"lable.currencyAdv.andbefordate":`和 之前的日期`,
"label.version.nonsupport.sharerule":`暫不支援共享規則！`,
"front-epwechat-module-v1-unbound":`解除綁定`,
"label.division":`分部`,
"label.data.import.setup.repeat":`是否要阻止建立重複記錄？`,
"label.callcenter.makesure.Amazon.connect":``,
"label.version.lead.control":`商機管理`,
"label.copying.reward.groups":`複製報價行組`,
"#label.severalorone":`壓縮或單個文件#`,
"label.mailinginfo":`郵寄地址`,
"component.telerecord.label.title":`記錄電話`,
"label.godocumentlist":`返回文檔列表`,
"APPIntegration.Dropbox.setting.01":`啟用`,
"label.tianyancha.website":`網址`,
"label_tabpage_greaterequalz":`大於或等於`,
"vue_label_campaign_influencedopportunity":`影響機會`,
"message.save.param.null":`參數為空，儲存失敗`,
"front-epwechat-module-v1-domain":`可信域名-JS-SDK：`,
"label.allowreport":`允許報表`,
"label.service.major.event":`重大事件`,
"label.import.index.selectobjectandfiles":`選擇物件與文件`,
"label.chatter.task":`工作`,
"label.knowledge.setting.hint.twelve":`輸入數據分類`,
"lable.account.CurrentandPreviousFY":`當前和上一個會計年度`,
"label.martrixreport.step3":`步驟 3：選擇要彙總的訊息`,
"front-console-select-cases":``,
"label.partnerCloud.partnerAccount.backHome":`回到首頁`,
"label.me.assign":`我分配的`,
"label.appointment.wizard.subtitle3":``,
"label.edit_columns":`編輯列`,
"label.partnerCloud.orderingPlatform.useRebates:":`使用回饋金：`,
"label.projectManagement.enter.up.to.10.digits":`最多輸入10位`,
"label.integrations.description.mailchimp":``,
"label.ccchat.person.error.requiredomain":`錯誤：至少需要一個域`,
"label.projectManagement.Pleaseselectitem":`請選擇項目`,
"label.netaccess":`網路存取`,
"vue_label_SMS_searchobject":`搜尋物件`,
"label.role.viewintree":`以樹狀視圖顯示`,
"lable.SalesCommitmentKanBan.accountName":`客戶名稱`,
"label.please.contact.your.administrator":`請聯繫管理員，啟用產生二維碼/條碼的規則`,
"label.sso.saml.sp.idenitysource":`SAML身份位置`,
"label.queue.delete":`刪除`,
"label.service.miniProgram.jumpLink":`跳轉連結`,
"label_set_ forecast_scope":`設定預測範圍`,
"label.weixin.success.sign":`已經成功簽到來現場,請知曉。`,
"front-dialog-module-v1-error-code":`錯誤碼`,
"label.projectManagement.nodata.problem":`太棒了，沒有棘手的問題需要解決`,
"label.myhomepage":`我的首頁`,
"label.exchange.sync.state.task.m1":`上一同步活動：`,
"label.pw.config":`請輸入確認密碼`,
"front-console-new-contact":``,
"label.customfields.fielddependency.editexplain":`<li>雙擊某個單元格，以切換顯示在列標題中的控製欄位值的可視性。 </li><li>要同時更改多個單元格，請選擇多個單元格，然後單擊包括值"或"排除值"按鈕，以同時更改選定的全部單元格的可視性。</ li><li>按住Shift 鍵單擊選擇一系列相鄰的單元格。按住Ctrl 鍵單擊選擇多個不相鄰的單元格。</li><li>使用"預覽"按鈕可對結果進行測試。 </li>"`,
"setup_mainpage_label_welcome7":`操作指導： 點擊本頁左側選單 → 應用程式設定 → 建立 → 物件 → 物件名 → 自訂欄位。`,
"message.validation.sum":`審批版面配置上顯示的欄位選擇過多,最多允許約190個欄位`,
"label.knowledge.attach.case":``,
"front-electronic-signature-custom-field-type":``,
"vue_label_pricebook_activated":`價格手冊已啟用`,
"vue.schedule.pre":`這是我的日程安排，請您`,
"Lead_Tools_BatchScoring":`商機批次評分`,
"front-lightning-module-v1-details-page-chart-screening-based-on":`篩選依據`,
"label.report.no.recently":`無最近記錄.`,
"label.service.gantt.dangerous.sum":`處於危險狀態的服務預約數量`,
"label.main.field":`主欄位`,
"label.weixin.optionfive":`選項五`,
"homepage.wide":`寬欄(右欄)`,
"vue_label_notice_confirmdelatehomepage":`確認刪除主頁？`,
"vue_label_report_exportpages":`匯出頁數：第`,
"label.select_compaign":`選擇一個行銷活動`,
"attachment.button.massdownload":`批次下載`,
"label.chatter.incident":`事件`,
"label_partner_new_step1":`步驟1：選擇您喜歡的範本`,
"button.partner.workspace.saveas.memo":`將當前夥伴雲另存為“範本”。`,
"vue_label_pricebook_edit":`編輯價格手冊`,
"label.weixin.privacy.rights":`隱私相關權限：大概位置(基於網路)；精確(GPS)位置`,
"label.please.codeType":`請選擇碼類型`,
"label.approveorrefuserequest":`批准/拒絕請求`,
"message.error.sharemember":`傳遞的sharemember不能為空，請檢查傳遞的參數！`,
"label.file.folder.edit":`編輯資料夾`,
"label.data.import.setup.repeat.yes":`是-阻止建立重複記錄。注意：如果希望更新現有記錄，必須選擇此選項。`,
"label.approveBeforeTheOperation":`審批前操作`,
"vue_label_file_already_checked_file":`已選擇了 {checkedWork} 個文件，最多單次添加10個文件`,
"vue_label_hidden_record_count":`隱藏記錄計數`,
"UG_product_01":`列出產品/服務`,
"label.tabpage.clearoptionsz":`清除進階選項`,
"label.partnercloud.num.overstep":`超過夥伴雲最大數量`,
"label.tianyancha.businessverify.msg8":`本功能目前僅支援對註冊在中國大陸地址的工商企業進行查詢，並且有適當的延遲。`,
"Lead_Scoring_DetailedPage_Popup_Title":`商機洞察`,
"label.emailtocloudcc.email":`電子郵件`,
"vue_label_pool_highcost":`產品成本高`,
"label.callcenter.enterprise.configuration":``,
"label.view.edit.search.prompt":`請輸入關鍵詞`,
"label.ems.sms":`發簡訊`,
"label.emailobject.list.new":`寫郵件`,
"label.salescloud.forenableteamsales":`啟用小組銷售`,
"pagecreator.systemstyle.funcpath":`/構建器/品牌化樣式庫`,
"label.partnerCloud.basicSetting.domain":`一級網域名不能為空`,
"label.projectManagement.Posttask":`後置工作`,
"label.tianyancha.businessverify":`啟用工商數據驗證`,
"label.tianyancha.h5.info":`基本訊息`,
"september":`九月`,
"chatter.poll.option9":`選項9`,
"label.department.firstpage":`已經是第一頁了`,
"label.reportsSubscriptionPage.condition.button":`添加條件`,
"label.exchange.sync.state.task":`任務`,
"pagecreator.layout.button.splitall":`拆分所有`,
"vue_label_calendar_please_select_the_start":`請選擇開始欄位`,
"label.tab.message.failtogettop":`獲取頂部選項卡失敗`,
"label.sharerule.organizationscopesetshare":`組織範圍內預設共享設置`,
"label.delete.rules":`刪除規則`,
"label.recordtype.tabname.detail":`使用“編輯”按鈕以更改此記錄類型的屬性。使用“選項列表值”相關列表中的“編輯”連結，為此記錄類型的記錄選擇可用的選項列表值`,
"label.knowledge.setting.hint.ten":`不確定事項的組織方式？沒問題，您稍後可執行此操作。`,
"vue_label_norm_undone":`此項操作不可撤回`,
"label.trigger.line":`行：`,
"lable.info.queue.reason":`成為成員的原因`,
"label.validate.function.funcExplain.HOUR":`返回日期/時間欄位中的小時數，是0至11之間的數字`,
"label.update.document.content":`修改了文檔內容`,
"lable.Existing.template":`現有範本`,
"label.summaryreport.step3":`步驟 3：選擇彙總訊息的分組方式`,
"label.emailmerge.list.filetype":`文檔類型`,
"label.customfields.helptext.tip":`當使用者懸停在此欄位旁的訊息圖標上時，此文本將顯示在詳細訊息頁和編輯頁中`,
"label.setting.intergrationlist.description":`通過精確集成，您無需離開CRM即可在業務應用程式之間查看和共用數據。有些集成，如QuickBooks、Zapier需要授予相應權限才能使使用者可以使用。有些集成，如Gmail、Outlook等可以由每個使用者在自己的帳戶上配置。`,
"component_milestones_label_title":`里程碑`,
"label.custom.AntiRevocation":`反撤銷`,
"label.mobile.app.new.task":`行動端是否啟用App版新建任務事件`,
"vue_label_opportunity_related_chooseproduct":`至少選擇一個產品`,
"label.standardguest":`標準來賓`,
"label.icon.125":`儀器`,
"label.skipsomeset":`由於這是跳轉起點嚮導，cloudcc 自動為您選擇一些設置。`,
"label.forecast.shrepage.fmanager":`預測經理`,
"label.mobile.quickcreate.default.work":`辦公`,
"label.projectManagement.nodata.team.members":`沒有找到我的項目成員`,
"label_social_media_account_settings":`社交媒體帳戶設定`,
"UG.quota.05":`與機會雙向同步`,
"label.partner.workspace.tab.selectedoption":`已選選項卡`,
"front-kefu-moudle-v1-clientID-reinput":`請輸入clientID`,
"label.mobile.home.page.contract.value":`預計合約金額`,
"december":`十二月`,
"label.campagin.roi.dcrs":`到場人數`,
"label.currency.edits":`幣種編輯`,
"label.currency.company":`公司幣種`,
"label.customfields.newformula.nogrammererror":`公式中沒有語法錯誤。`,
"label.version.nonsupport.api":`暫不支援接口API！`,
"label.data.file.i.title.num2":`2.建議在匯入時先匯出，以匯出文檔為資料範本整理匯入資料，然後再匯入。（匯入的資料中如果含有逗號，請使用‘@’符號代替）`,
"front-console-conversation-title":``,
"front-kefu-moudle-call":``,
"vue_label_systemSettings_pagefooter":`頁尾設定`,
"label.newRule.successfully.added":`新增規則成功`,
"label.trigger.direction.for.use":`平臺觸發器使用說明[2.0版本]`,
"label.instrumentPanel.maxLabelname":`該值要大於最小值、斷點1值及斷點2值`,
"label.same.month.report":`同環比報表`,
"label.knowledge.language.american":`美式英語`,
"label.paging.totalof":`共{0}條`,
"label.tianyancha.businessverify.enable.error":`獲取是否啟用工商數據驗證失敗，請聯繫系統管理員！`,
"vue_label_commonobjects_detail_email_template":`使用電子郵件模版`,
"message.error.save.failed":`儲存失敗！`,
"advancedoptions":`進階選項`,
"setup_object_layout_message_selectedlayoutandrecordtype":`請選擇配置和記錄類型`,
"label.sendemail.recycle.operatesuccess":`?您執行的清空回收桶操作已成功,共刪除#size條數據!`,
"J":`文本區（長）`,
"message.validation.isnotmail":`輸入正確的電子郵件地址`,
"label.timetrigger.before.lasttime":`早於最後修改時間1小時`,
"label.tabpage.arecordtypez":`可用記錄類型`,
"label.reportoption":`報表選項`,
"pagecreator.button.next":`下一步`,
"assetbom.transferowner.notpermission":`請聯繫管理員，您不具有轉移資產BOM的權限`,
"label.toptitle.lightning":`Lightning選單`,
"label.copy.target":`複製目標值`,
"label.productsales.oppor.approach":`臨近的機會`,
"label.email.template.select":`請選擇郵件範本`,
"label.edit.lower.bound.of.discount.per.tier.is.required.":`編輯折扣每1層的下界為必填項。`,
"label.tabularreport.step3":`步驟 3：確定報表中各列的順序`,
"label.multilang.cchttpservice.signin":`尊敬的{0}您所邀約的{0}活動的客人{0}已經成功簽到來現場,請知悉。`,
"label.appexchange.uninstallpage.message3":`永久刪除為此軟體包中的所有自訂物件建立的所有數據`,
"label_tabpage_ownedz":`共有`,
"label.tabularreport.2018.step2":`步驟2：選擇報表標準`,
"label.object":`物件`,
"template.report.contracted.customers":`簽訂合約的客戶行業分析`,
"label.field.remark3":`請注意，若刪除某自訂欄位，將刪除所有使用此自訂欄位的篩選器。可能還會改變依賴自訂欄位資料的分配或升級規則的結果。`,
"label.eventview.issms":`是否簡訊通知`,
"label.knowledge.language.brazilian":`葡萄牙語（巴西）`,
"vue_label_norm_viewfilter":`視圖篩選`,
"label.forecast.settings.qijian":`預測期間`,
"label.startuploadfile.step.intruduce":`單擊“選擇文件”按鈕查找文件，並將所選擇的文件顯示在下方區域`,
"label.smstemplate":`簡訊模版`,
"vue_label_chatter_no_permission":`您沒有權限查看該文件`,
"label.callcenter.Incorrect.data.filling":``,
"label.tag.search.button":`按標籤篩選`,
"label.multiplyselectoptions":`複選框選項`,
"lable.outlook.detail.mutual":`雙向同步`,
"label.workflow.estimatecondition1":`當建立或編輯記錄且原先未曾達到規則條件時`,
"label.validate.globalvariable.user.profileId":`設定檔 ID`,
"UG.Campaign.003":`建立行銷活動`,
"label.validate.function.funcExplain.ISNULL":`檢查表達式是否為空(空白)，如果是則返回TRUE(真)。如果它包含一個值，則該函數返回FALSE(假)`,
"label.setting.intergrationlist.status0":`集成狀態`,
"label.copy_error":`複製失敗`,
"label.connectOtherNone":`選擇的物件沒有可以進一步關聯的物件。`,
"label.bmap.beijing":`北京`,
"front-kefu-moudle-v1-hxzxybsc-again":`環信工作人員已被刪除，請重新關聯！`,
"label.wei.pollsubject":`投票主題`,
"APPIntegration_Social_twittererror":`必須是一個合法的twitter.com的URL`,
"label.appupload.install.apicannotuse":`api名稱仍不可用`,
"label.returntolist":`返回列表`,
"label.translation.start2":`選擇一個設置組件。`,
"lable.edit.queue.alter":`請選擇佇列支援的物件`,
"label.campaign.channel.step3":`步驟3：營銷渠道註冊頁面欄位選擇`,
"label.data.newtemplate.e.seltype":`選擇資料匯出方式`,
"front-kefu-moudle-hangup":``,
"label.forecast.forecastroleuserpage.shre.managerandother":`管理員和預測經理可以共用該預測`,
"label.knowledgebase.mark.as.new.version":`標記為新版本`,
"label.conditiontag.lookup":`查找`,
"label.import.page3.importsucceed":`匯入成功`,
"label.stdashbord.xsld.condtion":`條件設置`,
"label_emailtocloudcc_redmessage10":`訊息已過期，請重新登錄`,
"label.event.moveup.1hour":`提前 1 小時`,
"label.chat.topic.page.add.favorite":`在同事圈頁面上儲存為收藏夾`,
"label.icon.88":`諮詢`,
"page_404_label_noresource":`很抱歉，您所存取的資源不存在。`,
"label.quickbooks.refresh":`重新整理`,
"front-kefu-moudle-which-getphone-case":``,
"label.objecttab.edit":`編輯物件選項卡`,
"label.data.file.the.trigger":`執行觸發器`,
"frame.personinfo.label.personimage":`設定檔照片`,
"label_tabpage_turnoffsz":`關閉-已轉換`,
"label.sendmail.batch.chose":`批次發送電子郵件：選擇收件人`,
"label.data.downpage.i_title":`匯入數據的步驟:`,
"label.recycle.clearconfirm":`確定要清空嗎？`,
"chatter.using":`到此用了`,
"label.batchadd.newbatchpage.list":`批次新增數據列表`,
"pagecreator.systemstyle.button.new":`建立樣式`,
"label.notification.serviceappointment.changestate":`{1}{0}狀態更改至{2}{3}`,
"label.weixin.weipollname":`微投票名稱`,
"label.tabpage.skip":`跳至`,
"label.edit.field":`編輯欄位`,
"label.edit.new.rule":`編輯產生規則`,
"label.approved.receiveApprovalEmail":`接受電子郵件批准請求`,
"label.dashboard.refreshNow":`立即重新整理`,
"label.lookup.introduce":`可輸入字元進行模糊搜尋`,
"homepage.components.newdes":`請確保以下輸入的HTML代碼有效且格式正確。在組件中寫入不適當的HTML代碼，可能會使整個主頁選項卡無法正確顯示。`,
"label.role.giveuserrole":`為使用者分配角色`,
"lable.opppdt.selPbk.subtitle":`的價格手冊`,
"setup_mainpage_label_welcome19":`操作指導： 點擊本頁左側選單 → 管理設定 → 管理使用者 → 使用者、角色、設定檔`,
"setup.mainpage.label.welcome22":`操作指導： 點擊本頁左側選單 → 管理設定 → 通訊範本 → 電子郵件範本。`,
"label.tianyancha.h5.zipcode":`郵遞區號`,
"label_tabpage_allapplications":`全部應用程式`,
"label.chatter.like":`喜歡`,
"label.licence.noremainder":`許可證剩餘數量不足`,
"lable.outlook.edit.dataset":`數據設置`,
"D":`日期`,
"label.detail":`查看`,
"label.globaloperation.operationtype.custom_page":`自訂頁面`,
"label.addattachment.down":`下載文件`,
"label.data.exportall.all_btn":`匯出全部數據`,
"label.recordtypeselect.current":`當前記錄類型`,
"label.tabpage.entercusnamez":`請輸入客戶名`,
"label.location.valunit.km":`公里`,
"label.mobile.phone.week.plan":`下周計劃`,
"vue_label_report_everyday":`每日`,
"label.weixin.broadcasting":`發送中...`,
"label.input.search.string":`請輸入搜尋的字元串`,
"label.picandreporttype":`圖表類型`,
"label.setmulti":`將多個`,
"label.visualpage.component.t":`使用組件 component`,
"label.knowledge.designate":`只有狀態為草稿的知識文章可以指派`,
"label.enable.barcode.only":`僅啟用條碼`,
"vue_label_commonobjects_detail_a_group_strategy":`該條數據缺少擁有者,無法建立群策`,
"setup.layout.group.button":`按鈕`,
"label.mini.layout.remark":`應用於前台懸停視窗所顯示的配置`,
"setup.mainpage.label.welcome3":`CloudCC 雲平臺中建立表單依靠自訂資料庫（物件）來實現，使用者定義物件是一些資料庫表格，用於儲存貴組織特有的數據。無需任何程式開發的情況下，還可輕鬆建立表與表間的關係。`,
"label.knowledge.draft.status":`知識文章發佈狀態必須為草稿`,
"label.manageAll.sel.one1":`待審批的項目`,
"label.campagin.roi.bhydkhywjh":`贏得客戶業務機會數`,
"label_partner_template_thumbnail":`縮略圖`,
"label.loginip.setup":`登錄Ip範圍`,
"label.data.downpage.e.title.e.btn":`進入匯出頁面，開始匯出`,
"vue_label_appstore_project_management":``,
"assetbom.delete.notpermission":`請聯繫管理員，您不具有刪除資產BOM的權限`,
"vue.dashboard.setdrill.inThe":`中的`,
"label.mobile.more.savephoto":`儲存圖片`,
"label.customerinfo.PageTriggerFag":`自訂類、觸發器、自訂頁面同步`,
"label.commonobjects.Nopermission":`抱歉，您無權編輯此條數據，請聯繫系統管理員`,
"label.searchlayout.opperationtab.xsldfield":`點擊業務機會選項卡下的銷售漏斗連結顯示的視圖欄位。`,
"label.emailsync.form.disconnect":`取消關聯`,
"label.document.nofile.upload":`沒有文件上傳。`,
"label.appointmentpage.wizard.subtitle3-3":`電話號碼`,
"message.custom.field.donotdelete":`欄位被使用不能刪除`,
"chatter.using0":`到此用了{0}ms`,
"label.tabpage.multiple":`多項選擇`,
"label.attendance.setting.sy.alert":`考勤必須選擇適用人員!`,
"label.refuse":`拒絕`,
"label.log.button":`根據用戶名搜尋`,
"component_chatter_link_label_title":`連結`,
"template.report.contract.collection":`合約收款`,
"label.campaignmember.selectmember.step1":`步驟1：選擇市場活動和市場活動成員狀態`,
"label.datamanage.warn.owner":`警告：如果繼續進行本次匯入操作，則會以您作為記錄擁有者匯入所有記錄。`,
"label.a.b":`A 到 B 關係`,
"label.app.step3.homeisfrist":`主頁必須是第一位`,
"UG_Lead_003":`社交`,
"label.partner.workspace.member.choice":`選擇設定檔`,
"lable.outlook.detail.emaping":`事件欄位映射`,
"label.service.appointmentList.gantt.chart.shows":`甘特圖顯示日期`,
"label.mr.caption.account.result":`查重合併：查詢客戶重複數據的結果`,
"vue_label_chatter_approve_members_join":`批准成員加入小組`,
"label.reportsSubscriptionPage.schedulereport.monthly.day":`天`,
"pagecreator.systemstyle.label.modifycolor":`編輯顏色`,
"label.tabpage.yesz":`是`,
"label.fieldtoolongmessage":`欄位超出限制`,
"lable.account.year.name":`會計年度名稱`,
"label.mini.layout":`懸停版面配置`,
"label.icon.97":`教學`,
"vue_label_chat_smart_assistant":`智能小助手`,
"label.marketingmanagementuser":`市場營銷使用者`,
"label_emailtocloudcc_description2":`關聯您的企業信箱`,
"label.campaign.channel.input.name":`1.請輸入營銷渠道名稱:`,
"UG.homepage.007":`從發送跟進郵件到銷售活動自動化，從使用我們的藍圖科技建立工作流到觸發定製的巨集，自動化日常工作，並更專註於建立關係。`,
"label.share":`共享`,
"label.step2.total6":`第2步，共6步`,
"label.sendemail.chat.addComentspraise":`尊敬的#name:\n\n 您好！ #userName回覆了您喜歡的微貼。`,
"label.icon.20":`檔案`,
"label.service.gantt.absenteeism":`缺勤`,
"message.error.color.nagatice":`當前頁數不能為負數`,
"chatter.group.applyToJoin":`申請加入`,
"pagecreator_layout_message_delete":`是否刪除當前所選配置？`,
"label.multilang.viewlist.count":`共{0}條記錄：`,
"message.notdesable.type":`無法禁用此記錄類型，因為以下設定檔使用此記錄類型作為預設值。`,
"label.standard.time":`標準時間`,
"label_chatter_newpost":`最新帖子`,
"front-epwechat-module-v1-binding":`綁定企業微信`,
"label.recent":`最近`,
"label.globaloperation.createfeeditem":`建立摘要項目`,
"label_partner_common_roleNum":`角色數量`,
"front-template-V1-quikSearch":`輸入欄位名，快速搜尋`,
"label_tabpage_haschangedz":`該商機已經轉換`,
"label.service.work.order.line":`工作訂單行項目`,
"label.lead.score.ok":`好的`,
"Account_News_Setting_003":`一般設置`,
"label.event.moveup.15minutes":`提前 15 分鐘`,
"vue_label_all_selected_objects":`全部已選物件`,
"label.visualpage.an.inline.style.relatedlist":`為相關列表內嵌自訂頁面類型`,
"label.umeng.approval.approvaling":`#applyer正在請求批准#obj#objname#owner`,
"lable.SalesCommitmentKanBan.digital":`數字`,
"label.appupload.img.max.size":`上傳圖片過大，圖片最大不應超過20K。請重新上傳。`,
"vue_label_normal_top":`置頂`,
"label.knowledge.language.traditional":`繁體中文`,
"homepage.layout.edit":`編輯主頁配置`,
"label.campagin.qrcode":`市場活動二維碼`,
"label.emailmerge.merge.emailmerge":`郵件合併`,
"label.icon.18":`時鐘`,
"vue_label_homepage_taskview":`工作視圖`,
"label.search.related.record":`沒有找到相關記錄。`,
"label.report.reports":`報表`,
"label.appointment.wizard.subtitle4-3-2":`15分鐘`,
"label.forecast.condition":`預測條件`,
"label.westem.indonesia.time":`西印度尼西亞時間`,
"front-epwechat-module-v1-callback-desc":`需要您將以下資訊複製到企業微信背景`,
"label.version.group":`團隊版`,
"label.allReportType":`所有自訂報表類型`,
"label.trigger.lastmodifydate":`上次修改時間`,
"message.layout.unique.sectionfield":`違反頁面配置中欄位的唯一約束，請確認後重新儲存!`,
"vue_label_systemSettings_mobelbottonsetting":`行動端底部選單設定`,
"label.recordtype.selectonefield":`選擇要新增的欄位,至少選擇一個欄位。`,
"label.notification.group1":`【申請人】正在申請加入您的公用小組`,
"component_todaytask_label_title":`今天的工作`,
"label.assignment.setup.list.description":`使用分配規則可以自動將記錄發送給相應的使用者。分配規則由定義於記錄上的條件和多條規則項目組成。`,
"label.project.resource.data":`此服務資源已指派到服務預約，請勿重複添加`,
"label.emailmerge.newtemplate.file":`文件`,
"label.notification.task1":`【指派人】已為您指派工作`,
"label.ServiceCloud.Overlapping":`重疊顯示派工`,
"label.globalselect.used":`欄位使用位置`,
"setup_layout_button_layoutprop":`配置屬性`,
"label.quickbooks.retrivingdata":`正在獲取數據...`,
"component.button.ok":`確定`,
"message.pleaseinputformula":`請輸入公式`,
"label.h5.whatifollow":`我關注的`,
"label.new.crew.target":`建立人員目標`,
"label_chatter_task":`工作`,
"label.knowledge.setting.data.four":`最多選擇{count}個分類組！`,
"label.rule.not.enabled":``,
"label_in_scope":`在範圍中`,
"label.partnerCloud.orderingPlatform.bundle":`捆綁包`,
"label.emailtocloudcc.redmessage10":`訊息已過期，請重新登錄`,
"label.knowledgebase.data.assignment.succeeded":`{a}條資料指派成功`,
"vue_label_commonobjects_view_nokanban":`暫無已建立的看板視圖`,
"label.knowledgebase.article.cancelled.attaching.case":`文章?{name}已取消附加到個案！`,
"label.brief":`簡報`,
"label.version.sum.app":`個應用程式`,
"label.commoninfo":`一般訊息`,
"vue_label_SMS_nodata":`暫無數據`,
"label.icon.153":`信息`,
"label.conditiontag.lookup.false":`假`,
"label.emailobject.view.unread":`全部未讀`,
"label.staticresource.useful":`用於何處?`,
"label.ems.connect.test":`檢測`,
"vue_label_chat_group_assistant_notification":`群助手通知`,
"label.multipleactivity.total":`總計`,
"vue_label_report_addtocomponentlibrary":`添加到組件庫`,
"font-evaluate-module-v1-following-personnel":``,
"label.setup.mobile.bottombutton.change.fail":`修改失敗`,
"front-epwechat-module-v1-unbound-item5":`並且資料無法找回，請確認是否要解除綁定？`,
"label.customerinfo.smsUid":`簡訊網關UID`,
"label.list.isOpenApprovalQueue":`是否開啟審批佇列(手動選擇審批者狀態下無法使用)`,
"label.leadscore.setup.scorenumber":`次`,
"label.workflow.selectobj.introduce":`選擇該工作流程規則所要應用到的物件`,
"label.visualpage.label.for.example":`頁面標籤如:`,
"label.appointmentdetail.wizard.title17":`週四時間規劃`,
"label.projectManagement.timeFrame":`工作的開始時間和結束時間要在里程碑的時間範圍內`,
"lable.product.pricebooks.list":`價格手冊是具有特別定義的單價和幣種的產品列表.價格手冊可針對多幣種進行設置.在將產品組織放入價格手冊中時,記住業務機會或報價只能包括單個價格手冊中的產品.如果要編輯價格手冊中的產品,請點擊價格手冊名稱。`,
"font-trade-module-v1-delete-invoice":``,
"vue_label_salesadvance_winamount":`贏單總金額`,
"component.salesperformance.label.nopermission":`請聯繫系統管理員查看機會相關數據。`,
"vue_label_report_formatreport_desc":`匯出報表，其中包含報表標頭、分組和篩選設定。`,
"label.enable.qrcode.only":`僅啟用二維碼`,
"label.smstemplate.edit":`編輯簡訊範本`,
"label.qrcodeSetting.detailed.information":`QR碼比普通條碼可以儲存更多資料，也無須像<br?/>普通條碼般在掃描時需要直線對準掃描器。因此其<br?/>應用範圍已經擴充到包括產品追蹤，物品辨別，文<br?/>檔管理，營銷等方面。`,
"label.event.moveup.1week":`提前 1 星期`,
"label.customize.memory.function.sorting.disable":`禁用視圖表頭排序記憶`,
"label.icon.195":`浴缸`,
"label.compact.layout.assign":`關鍵訊息配置指派`,
"label.icon.183":`房子`,
"front-kefu-moudle-v1-jchxzxzi-chat":`整合環信線上工作人員聊天功能以提供更加全面的SaaS服務。`,
"label.mycontact":`我的聯絡人`,
"label.tabularreport.2018.step3":`步驟3：選擇報表標準`,
"chatter.group.uploadGroupPicture":`上傳小組頭像`,
"label.total.forecast.setup":`優先預測並將其設置為`,
"label.weixin.group.description":`備註`,
"label.edit_emailfooter":`編輯郵件頁尾`,
"label.ems.create":`新建`,
"label.weixin.optionseven":`選項七`,
"font-evaluate-module-v1-continue-work":``,
"label.close.multilingual":`禁用多語言`,
"component.chatter.post.button.user":`添加人員`,
"label.use_QRcode":`使用二維碼`,
"label.operatedata.exportsuc":`匯出成功，請登錄您的郵箱查看您的匯出檔下載地址，匯出的檔將會為您儲存48小時，請儘快下載。注意保護您的連結地址，建議您下載完後刪除系統發送給您的郵件`,
"label.page.step2.define.content":`步驟2：定義內容和顯示屬性`,
"label_tabpage_groupingitem":`分組項目`,
"label.customfields.placeholder":`填寫示例`,
"vue_label_commonobjects_detail_enter_subject":`請輸入主題`,
"label.multilang.workflow.everyotherdayinmonth":`每{0}月{1}天`,
"label.knowledgebase.data.archiving.failed":`{a}條資料歸檔失敗`,
"vue_label_notice_nopermission_view":`抱歉，您無權查看該條數據，請聯繫系統管理員`,
"vue_label_calendar_calendar_view":`日曆視圖`,
"lable.outlook.edit.des":`如果某個 Exchange 聯絡人與多個 CloudCC.com 聯絡人匹配，將其與符合下列條件的 CloudCC.com 聯絡人同步`,
"label.custom.NextCQ":`下一個自訂季度`,
"label.emailsync.form.stutas":`啟用狀態`,
"label.nameandintro":`名稱和說明`,
"label.dashboardSetup.showdw":`顯示單位`,
"label.tianyancha.actualcapital":`實收註冊資金`,
"front-kefu-moudle-info-delete-calluser":``,
"label.emailobject.list.all":`全選`,
"label.campaign.channel.step7.send":`選擇需要發送郵件的人員`,
"label.formulafield.type":`公式返回類型`,
"label.reportsSubscriptionPage.schedulereport.weekly.thursday":`星期四`,
"label.chosesubject.eat":`約吃飯`,
"label.back":`返回`,
"label.h5.allcompany":`全部雲帖`,
"label.location.display.type.digital":`數字`,
"label.datamanage.error.csv":`不正確的文件格式，系統只支援通用的CSV格式，請重新操作`,
"label.emailobject.mark":`標記`,
"setup_mainpage_label_welcome9":`使用者無需代碼開發的情況下，通過滑鼠拖曳的方式，便可實現所有頁面元素的分類顯示、配置調整。以及對頁面上欄位的唯讀、必填等屬性的設定。`,
"label.icon.56":`測量儀`,
"label.forecast.edit.fwcd":`範圍長度`,
"vue_label_email_Please_select_related_items_first":`請先選擇相關項`,
"label.icon.87":`書`,
"label.knowledgebase.recovery.was.successful":`恢復成功`,
"label.emailobject.emaildetail.promptcontent":`是否確認刪除此郵件？請註意，此刪除操作不可撤銷`,
"label.delete.role":`刪除角色`,
"label.multiselect":`可多選的選項列表`,
"label.customerinfo.mailisnull":`未設置公司發件電子郵件`,
"label.waitforamoment":`頁面載入中，請稍候...`,
"lable.edit.queue.tip":`輸入發送通知時（例如已將個案放入佇列時）要使用的佇列名和電子郵件地址，電子郵件地址可不填寫，將不通知。若選擇“向成員發送電子郵件”，向佇列指派物件時，將通知佇列成員，不選擇不通知。`,
"lable.custom.y.d":`此頁允許您定義一個自訂年度記錄。自訂年度的日期將根據您下面所進行的選擇產生。`,
"chatter.feed.content.user.searchbutton":`搜尋`,
"label.data.downpage.i.list.desc3":`使用者下載後，可以在文件最後一列查看匯入失敗的具體原因。`,
"label.tag.manage.createdby":`建立人`,
"label.h5.similar.opportunity.last.months3":`最近3個月`,
"chatter.group.members":`位成員`,
"label.knowledgebase.data.translation.failed":`{a}條資料翻譯失敗`,
"label.log.look":`查看設置紀錄線索`,
"label.service.gantt.week.timescale":`週視圖上顯示的時間刻度：`,
"label.userLicence":`使用者許可證`,
"label.file.library.managemembers.permission":`存取權限`,
"label_emailtocloudcc_name":`名稱`,
"label.mr.mrSuccess":`合併成功`,
"vue_label_commonobject_view_notice_selectadd":`請選擇要添加的數據`,
"vue_label_commonobjects_detail_level":`層級`,
"CloudCCCRM_ST_Info_TypeIn_001":`請輸入`,
"label_chatter_list":`列表`,
"label_tabpage_optionsz":`選項`,
"UG_homepage_008":`瞭解目前業務狀態（銷售簡報，排行榜，銷售漏斗等），查看可能存在問題的機會，預測未來業績達成情況，即時受理和分派重要事項，做出明智決策。`,
"label.myselfdashboard":`我的個人儀表板`,
"label.globaloperation.operationtype.record_phone":`記錄電話`,
"label.field.standard":`標準欄位`,
"label.changemydisplay.appedit.check":`覆蓋使用者的個人自訂應用程式自訂設置`,
"label.tianyancha.h5.legalpersonnames":`法人代表`,
"label.tabpage.sorttypez":`排序類型`,
"label.newdashboard.folder":`新建儀表板檔夾`,
"label.campaign.channel.step6":`步驟6：營銷渠道註冊頁面產生`,
"label.ems.composeemail":`發郵件`,
"label.app.step4.tabcanuse":`可用選項卡`,
"label.sendmail.batch":`批次發送電子郵件`,
"label.process.execute.title":`正在進行審批`,
"lable.outlook.detail.lastup":`最後更新`,
"label_emailtocloudcc_delete":`刪除`,
"lable.opppdt.selPdt.leastone":`請至少選擇一條`,
"label.customfields.new.step2.opration.exid":`外部ID`,
"label.assignment.setup.newrule.description":`輸入規則名，然後選取"已啟用"複選框，將此規則用於自動分配。啟用此規則將禁用當前的分配規則。`,
"label.campaign.channel.input.to.isactivity":`7.是否啟用營銷渠道`,
"label.document.return":`返回文檔頁面`,
"label.data.downpage.i_title.num5":`5、請審核資料的準確性。`,
"label.taskinto":`自動將任務分配給使用者時，任務是工作流規則使用的範本。`,
"label.customfields.formula.textexample":`Full Name（全名）`,
"label.appointmentpage.wizard.subtitle1-1":`下一週`,
"label.weixin.radio":`單選`,
"vue_label_file_replace_reason_check":`取代原因（選填）`,
"label.sendemail.recycle.operateexception":`?您執行的清空回收桶操作出現異常，請重試!`,
"label.vlidaterule.formulaerror":`如果“折扣”大於30%，則顯示錯誤`,
"vue_label_campaign_existing_member_status":`保留現有成員狀態`,
"label.service.miniProgram.fillSlideshowName":`請填寫輪播圖名稱`,
"label_partner_workspace_login_headerfooter":`頁首和頁尾`,
"label.quickbooks.viewlist.total2":`共計{0}個估算，共{1}`,
"chatter.viewingResults":`查看結果`,
"label_tabpage_allvisible":``,
"label.quote":`報價單`,
"label.changemydisplay.list.des":`根據需要配置選項卡`,
"label.leadscore.notimes":`評分次數已滿`,
"label.icon.51":`發電`,
"component.assistant.label.title":`助理`,
"label.emailobject.emailsent":`郵件發送成功！`,
"label.group.nofile":`沒有文件發送到該小組。`,
"label.foldervisitlimit2":`所有使用者均不可視此檔夾`,
"label.dataoperate":`資料操作`,
"label.addattachment.size":`大小`,
"label.not.double":`不允許重複值`,
"label.customfields.formula.number.tip":`計算數字值`,
"lable.opppdt.addpdt.table.description":`行描述`,
"label.sms.isactivity":`是否啟用`,
"label.campaign.channel.input.owner":`4.請設置建立此營銷渠道商機的擁有者為：`,
"label.visualpage.notfound.error":`發生未知錯誤，請聯繫管理員處理`,
"label.mr.title.button.group3":`條記錄`,
"label_tabpage_beginz":`開始`,
"label_tabpage_queue":`佇列`,
"label.tabpage.advancedscreening":`進階篩選條件`,
"nogreate":`小於或等於`,
"chatter.fields":`的欄位`,
"button_partner_workspace_manage":`管理`,
"label.partnerCloud.orderingPlatform.search":`搜尋產品`,
"message.password.isnull":`密碼不能為空！`,
"label.fenbeitong.title":`分貝通設定`,
"label.salescloud.contactrole.message.chooseatleastone":`請至少選擇一個聯絡人`,
"label.knowledge.delete.election":`刪除數據分類選擇出錯`,
"front-console-status-hoided":``,
"label.lastmodifydate":`上次修改日期`,
"vue_label_chat_deleting_chat":`刪除後將清空聊天記錄並從群策列表上移除。接收新通知時，會再次出現在群策列表處。`,
"label.timeframe":`時間影格`,
"UG.opportunity.002":`定義您的銷售週期 配置階段`,
"label.templates.merge":`請選擇要合併的範本，最多20個`,
"label.generatepage.c2":`最大長度為30`,
"label.appointment.wizard.subtitle4-1-6":`2小時`,
"label.passwordPolicy.setup.pwdremember3":`記住3個密碼`,
"button.partner.workspace.enable":`啟用夥伴雲`,
"vue_label_pool_nopool_notice":`您暫未加入到任何公海池中，請聯繫管理員建立或加入公海池。`,
"label.layout.required.field.select":`已選必填欄位`,
"label.loginhis.date":`請輸入開始時間和結束時間`,
"vue_label_commonobjects_detail_and_overdue":`即將到來和已逾期`,
"label_tabpage_advancedsearch":`格式`,
"label.custom.field.login.home.query":`請進入系統主頁瀏覽任務詳細訊息！`,
"page":`頁面`,
"label_tabpage_onlymevisible":``,
"label.weixin.optionfour":`選項四`,
"label.confirm.to.remove":`確定移除`,
"label.event.moveup.30minutes":`提前 30 分鐘`,
"label.mail.merge.template.finish":`郵件合併範本已完成`,
"label.multilang.currencylist.before":`{0}之前`,
"label.goback":`返回上一步`,
"label.unknown.prefix":`未知的首碼，請輸入正確的首碼`,
"lable.account.CurrentandPreviousCYt":`當前和前兩個日曆年度`,
"label.product.dent":`輸入關鍵字和篩選條件，然後單擊搜尋開始搜尋。單擊更多篩選器"以使用一個以上的篩選器。搜尋結果包括與所輸入關鍵字和篩選條件匹配的所有記錄。"`,
"label.ems.bcc":`添加密件附本`,
"label.import.index.operation":`操作`,
"label.knowledge.setting.hint.eight":`井井有條！`,
"label.sso.saml.sp.idtype.fid":`聲明包含來自使用者物件的聯盟ID`,
"vue_label_chat_voice":``,
"label.config.pw":`確認新密碼`,
"lable.newtabpage.closesearchresult":``,
"lable.account.NextWeek":`下星期`,
"label.ems.username":`使用者帳號（U）`,
"vue_label_email_emails_from_potential":`您CRM中的商機、聯絡人發來的郵件，以及收件人中包含他們的郵件，都會被歸類到這裡`,
"lable.approval.shared":`審批共享`,
"label.tabpage.allz":`所有`,
"label.file.uploadfiles":`上傳文件`,
"label.emailobject.text":`名稱`,
"label.version.allow.create":`允許建立`,
"label.empty.field":`欄位不能為空`,
"label.emailsync.status.department":`部門`,
"label.pw.str":`5個字元`,
"label.attendance":`考勤`,
"label_mobile_buttom_team":`群策`,
"label.campaignmember.main.addcontactdesc":`一次將所有現有聯絡人添加到這個市場活動`,
"label.search.result":`搜尋結果`,
"label.weixin.activity.account":`活動的客人`,
"label_tabpage_clearoptionsz":`清除進階選項`,
"UG.activity.01":`您如何追蹤記錄與您的客戶/團隊互動?`,
"serviceappointment.new.status.limit":`無法建立狀態為已計劃或已派遣的新的服務預約`,
"label.notice.higher":`是否通知上級`,
"label.passwordPolicy.setup.gletters":`個字元`,
"label.data.exportsf.des":`匯出成功的文件將在伺服器上保留48小時，48小時後將自動刪除。`,
"label.view.onlymecansee":`僅對<b>我</b>可視`,
"UG.Lead.005":`信箱`,
"label.umeng.approval.approvalfail":`提交失敗`,
"label.huanxinconfig.clientid.lost":`clientid不能為空`,
"label.campaignmember.main.updatecontactstatus":`更新狀態-現有聯絡人`,
"component_chatter_button_delete":`刪除`,
"label.weixin.no.pending.projects.qin":`親,目前沒有待審批的項目`,
"front-electronic-signature-auto-fill-field":``,
"message.resetpw":`確定要重新設置密碼？`,
"label.service.ganttBaiduMap.service.resourname":`服務資源名稱`,
"vue_label_pricebook_deleted":`價格手冊已刪除`,
"label.icon.193":`浴缸`,
"label.validate.function.funcFormat.NOT":`NOT(logical)`,
"label.address.city":`市`,
"label.pc.ui.2018.searchs":`請輸入搜尋內容`,
"label.yard":`邀請碼`,
"label.data.downpage.i_title.btn":`進入匯入頁面，開始匯入`,
"label.useablereceivers":`可用接收人`,
"label.cloudccsite.name.length":`站點名稱不能超過255個字元`,
"label.secrecy":`保密`,
"label.campagin.roi.ydkhywjhzz":`贏得客戶業務機會總值`,
"vue_label_report_conditiondesc_one":`除了訂閱外，您可為此報表設定條件。您將在滿足條件時獲得通知。這是可選項。`,
"label.datamanage.select.contactfield":`（選擇匯入聯絡人所對應的欄位）`,
"label.emailtocloudcc.filed.action":`操作`,
"label.smstemplate.new":`建立簡訊範本`,
"label.mobile.side.tab.app":`應用程式`,
"label.icon.118":`時鐘`,
"label.customfields.selectcontainfieldlayout.tip":`該欄位將作為最後一個欄位添加到這些版面配置的前 2 列。如果不選擇配置，該欄位在任何頁面上都不會顯示。 要更改該欄位在頁面上的位置，需要自訂版面配置`,
"Lead_Homepage_Tools_BatchScoring":`批次評分`,
"lable.quote.syncing.quote":`報價單`,
"pagecreator.button.preview":`預覽`,
"label.ccchat.am":`上午`,
"chatter.feed.menutype.user.nullrecent":`無最近記錄`,
"lable.info.queue.showallmember":`查看佇列成員`,
"label.multilang.campaign.selelctmember.desc":`選擇一個視圖,然後選擇成員以添加到行銷活動中,成員狀態為{0}`,
"label.notification.ccchat3":`您的微貼有1條新回覆`,
"UG.product.03":`多幣別支援的價格手冊`,
"label.sso.saml.idp.config.pksize":`密鑰大小`,
"label.defineCustomReportType":`定義自訂報表類型`,
"component.timeline.button.filter":`篩選`,
"label.mr.nextGroup":`跳過該組，前往下一組`,
"label.quote.sprdz":`收票人地址`,
"label.total.refuse.forecast.have.priority":`拒絕所有預測優先`,
"lable.product.peep":`清輸入有效價格`,
"label.file.who.can.access":`誰可以存取`,
"label.page.last":`最後一頁`,
"label.icon.180":`人`,
"font-evaluate-module-v1-enabled-successfully":``,
"label.appointment.wizard.subtitle4-2-2":`2小時`,
"label.passwordPolicy.setup.oneyear":`一年`,
"label.login.bound.mfadevice.title":`啟用虛擬MFA設備`,
"vue_label_dashboard_statisticalvalue":`請選擇統計值`,
"label.ishistory":`的歷史`,
"component.timeline.label.title":`時間軸`,
"label.page.step3.of.step5":`第3步，共5步`,
"label.assignment.setup.detail.section":`規則詳細訊息`,
"label.salescloud.opportunity.nothave.main.contactrole":`沒有主要聯絡人`,
"label.import.page1.limitedcsv":`上傳文件只能是csv格式!`,
"label.icon.187":`錘子`,
"label.emailobject.wizard.desc5":`定制您的簽名，讓郵件看起來更美觀。`,
"vue_label_report_notice_copy_success":`複製報表成功！`,
"label.dupicatecheck.repeatcondition.chooserulemsg":`您還沒有選擇查重的規則.`,
"label.componentEditor.upper.limit":`上限100`,
"label.validate.function.funcExplain.ISNEW":`檢查記錄是否是新的，如果是新的，則返回TRUE 。否則返回 FALSE。`,
"label.postalCode":`郵政編碼`,
"label.dashboard.snapshot.enable.flag":`啟用儀表板快照`,
"vue_label_file_upload_type_size":`只能上傳{fileType}文件，且不超過{size}Mb`,
"label.appointment.wizard.subtitle3-6":`週六`,
"homepage.narrow":`窄欄(左欄)`,
"chatter.addmute.confirm":`是否確定將該帖子免打擾?`,
"label.lookup.account":`查找客戶`,
"message.lostthemanager":`此提交需要使用者的經理審批,此值為空。詳情，請與您的管理員聯繫。`,
"label.exchange.sync.state.contact.m3":`在最後24 小時同步的記錄：`,
"label.version.phone.app":`手機APP版`,
"label_tabpage_search":`搜尋`,
"vue_label_helpcenter_campaign":`在詳細訊息中，點擊行銷活動旁邊的樹狀圖按鈕，可以查看行銷活動階層架構圖，瞭解行銷活動的父子層級關係。<br>通過行銷活動成員相關列表，管理行銷活動涉及到的聯絡人或商機。`,
"front-lightning-module-v1-dashborad-last-year":`去年`,
"label.campaign.channel.value":`值`,
"vue_label_opportunity_contactrole_primarycontact_notice":`若想選擇主要聯絡人，請儲存此步驟後在“管理”中進行選擇。`,
"label.biaoqingfaxian.title":`標情發現`,
"label.approved":`已批准`,
"label.hong.kong.time":`香港時間`,
"label.customfields.file.cannotopen":`無法打開此文件`,
"lable.New.tips":`點選“建立”，以根據標準模版或其中一個模版建立服務報表模版。啟用後即可使用範本`,
"component.setup.tabs.label.add":`新增`,
"label.forecast.forehistory.replacebest":`超常發揮被替代`,
"front-kefu-moudle-v1-jctrrt-call-serve":``,
"label.workflow.configrule":`步驟 2：配置工作流程規則`,
"label.dashboard.snapshot.refresh.frequently":`儀表板快照重新整理太頻繁，請稍後再試`,
"label.ems.editsetting":`編輯郵件設置`,
"message.confirmdeleteAPP":`您將要刪除此應用程式。`,
"label_chatter_activity":`活動`,
"label.editsharerules":`編輯共享權限`,
"label.loginservice.license.notuse.must":`許可證目前不可用，您必須在`,
"label.import.step2.beforeexport":`1、匯入之前，請先確保匯入其相關的所有記錄。例如：如果您當前匯入的物件與聯絡人之間存在查找關係，請先匯入這些聯絡人，然後再匯入您的資料。`,
"label.chat.mute":`免打擾`,
"label.icon.128":`房子`,
"label.give":`&&與`,
"label.hide":`不顯示`,
"label.relationobject.wpr":`委派人`,
"label.summation":`總和`,
"label.layout.availabletab.details":`詳情訊息`,
"label.circle":`圈形`,
"vue_label_opportunity_contactrole_add":`添加聯絡人角色`,
"label.file.library.file2libsuccess":`成功新增檔案到該文件庫！`,
"label.weixin.report.reportgenerated":`已產生報表`,
"label.icon.91":`人`,
"report.label.pleaseinput":`請輸入搜尋內容`,
"label.escalation.setup.newaction.otheremail.tip":`您最多可輸入5個要發送的電子郵件。每個地址間使用逗號分隔`,
"label.area.donot.have.data":`沒有數據`,
"label.customcomponent.btn.reference":`組件引用`,
"label.appointmentdetail.wizard.title7":``,
"label.ccchat.with":`具有`,
"label.file.size":`大小`,
"label.product.sort.beyond":`最多支援設定十級！`,
"label.ccchat.2018":`動態`,
"label.report.select.column":`選擇列`,
"label.appointmentpage.wizard.subtitle1_1":`請選擇日期和具體時間`,
"label.passwordPolicy.setup.uppercasealpandnumsymbol":`必須包含大小寫字母數字及符號`,
"label_chatter_addressee":`收件人`,
"label.profile.remark2":`如果貴組織使用記錄類型，請使用以下“記錄類型設置”部分中的“編輯”連結，使此設定檔的使用者可以使用一個或多個記錄類型`,
"UG_Account_01":`您的客戶是誰?`,
"label.dataimport.error.contact.notnull":`出現錯誤：聯絡人姓名不能為空。`,
"lable.account.CalenderQuarter":`日曆季度`,
"vue_label_commonobjects_detail_empty":`銷售價格不能為空`,
"label.approveassigntemplate":`審批分配電子郵件範本`,
"label.objectRelationshipDescription1":`此報表數據源將產生有關`,
"vue_label_email_insertmergefield":`插入合併欄位`,
"label.mobile.home.page.check.team":`查看團隊`,
"lable.edit.queue.edit":`編輯佇列`,
"label.campagin.roi.query":`查詢市場活動ROI`,
"label.dataimport.field.allow.access.to":`數據欄位不允許存取，請手動刪除對應的記錄後重試`,
"pagecreator.systemstyle.message.canntdelete":`當前樣式不允許刪除`,
"label.searchkey":`請輸入關鍵字`,
"chatter.showall":`顯示全部`,
"show":`顯示`,
"label.quote.choseproduct":`選擇產品`,
"label.report.selected.field":`選中的欄位`,
"label.globaloperation.operationtype.create_data":`建立記錄`,
"label.knowledge.setting.data.seven":`刪除分類組：{flzmc}`,
"chatter.email.mentionOrMessage":`提及或消息`,
"label_tabpage_exclusivez":`不包含`,
"chatter.en.userinfo":`輸入有關您的訊息`,
"label.log.orgid":`機構`,
"label.dataimport.insertdata.error.fieldrepeat.update":`該記錄中的$schemefield_name$欄位在數據庫中的查找不到,無法進行更新操作，該記錄已忽略匯入。`,
"vue_label_chatter_add_link_success":`添加連結成功`,
"label.sender_details":`新增新發件人資訊，建立使用者於您的`,
"label.ccpeak.addwhere.condition":`可加where條件`,
"label.datamove.total":`共有`,
"label.tianyancha.businessverify.warning":`請注意，此驗證僅支援中國大陸註冊的工商企業數據。`,
"label.emailmainbody":`郵件正文`,
"label.justadmin":`僅限管理員`,
"label.data.downpage.e.list.desc1":`此頁面顯示的數據為匯出成功的文件，請您根據郵件中提示的訊息即時下載您匯出的文件。`,
"label.reportsSubscriptionPage.email.value":`可用值`,
"message.error.serviceappointment":`請先在服務預約上填寫已計劃開始時間和已計劃結束時間`,
"label.textMessageObject.selectone":`請至少選擇一條記錄作為簡訊的收件人`,
"label.schedulejob.setup.schedule.plan":`計劃`,
"label.assignment.layout.field.isassigned":`使用有效的分配規則進行分配`,
"label.captcha.error":`驗證碼錯誤！`,
"mobel_web_not_more_data":`暫無更多數據`,
"label.emailsync.form.emailaddress":`信箱地址`,
"label.loginservice.error":`登錄出錯了，請聯繫管理員`,
"label.integrations.description":`將您的CloudCC賬戶連接到企業軟體生態系統中的其他應用程式`,
"vue_label_homepage_notice_selectone":`請選擇至少一位商機或聯絡人`,
"label.chatter.default":`預設`,
"label.tabpage.datefield":`日期欄位等於時可以使用“昨天”，“今天”，“明天”，“上個月”，“本月”，“下個月”，“上星期”，“本星期”，“下星期” 或 “YYYY-MM-DD、MM/DD/YYYY”格式。`,
"front-kefu-moudle-myzdhsc-file":``,
"label.createname":`建立人`,
"label.mobile.phone.enter.plan":`這裡輸入計劃`,
"report.label.highlevelreport":`進階報表可以幫您建立最多4個物件關聯的報表`,
"label.edit.select.label":`編輯方式`,
"label.partnerCloud.financeSetting.deduction":`啟用後，會新增回饋金帳戶、回饋金收入、回饋金支出物件，合作夥伴使用者在下單結算時可以使用回饋金帳戶內的餘額抵扣金額`,
"message.duplication.label.updateoption":`更新時操作`,
"label.custom.CurrentCQ":`當前自訂季度`,
"front-kefu-moudle-wait":``,
"sunday":`星期日`,
"label.service.timezone":`時區`,
"setup.layout.label.selectfield":`欄位選擇`,
"label_emailtocloudcc_filed_action":`操作`,
"label.forecast.customforecast.mycommit":`我的承諾額`,
"label.uploadsuc":`上傳成功`,
"vue_label_commonobjects_view_notice_atleast1field":`最少選擇1個展示欄位`,
"label.dataimport.khmc.length":`出現錯誤：客戶名稱長度過長。`,
"label.isemailnotification":`是否郵件通知`,
"label.addAPPexchange":`添加 AppExchange 應用程式...`,
"label.partnerCloud.orderingPlatform.currency":`幣別：`,
"UG_quota_02":`報價是客戶及供貨商之間關於在指定的時間以指定的價格對指定商品進行交易的法律條款。`,
"label.customer.tab.step2.same.option3":`隱藏選項卡`,
"H":`電話`,
"label_tabpage_searchz":`搜尋`,
"vue_label_homepage_deleted":`已被刪除`,
"label.weixin.recent.view":`最近查看的視圖`,
"template.report.opportunity.sales":`機會銷售量`,
"label.customfields.new.step2.opration.unique.info.v1":`將ABC"和"abc"視為重複值(不區分大小寫)"`,
"savesuccess":`儲存成功`,
"label.partner.workspace.member.memo":`選定的設定檔、權限集的所有使用者都可以存取此夥伴雲。`,
"label.icon.23":`藥品`,
"lable.batchadd.service.cfq.before":`觸發器(Before Insert)`,
"label.instrumentPanel.breakpointTwoLabelname":`該值要大於最小值及斷點1值`,
"message.selectgsummaryinformation":`請選擇彙總訊息`,
"label.tianyancha.businessverify.msg6":`本功能使用第三方服務，可能存在因高耗能導致性能不穩定，服務中斷的情況，CloudCC 對此不承擔任何連帶責任。`,
"vue_label_helpcenter_report3":`3、A.單擊欄位搜尋框，通過搜尋欄位後選擇或滾動下拉欄位列表後選擇想要的欄位，選擇欄位的操作符，輸入或選擇值，單擊應用後欄位篩選器生效。<br>&nbsp;&nbsp;&nbsp;&nbsp;B.單擊欄位搜尋框上方“＋”號，在“篩選條件輸入框”中輸入數字和字母組成的進階篩選條件。如（1 and 2）or3。<br>編輯篩選器<br>&nbsp;&nbsp;&nbsp;&nbsp;想要編輯篩選器，包含標準篩選器，單擊篩選器即可。<br>移除篩選器<br>&nbsp;&nbsp;&nbsp;&nbsp;單擊篩選器上的“×”圖示即可移除篩選器。<br>運行報表<br>&nbsp;&nbsp;&nbsp;&nbsp;單擊編輯頁面右上角“運行”按鈕，即可查看完整的報表結果。<br>儲存報表<br>&nbsp;&nbsp;&nbsp;&nbsp;單擊編輯頁面右上角“儲存”按鈕，填寫報表名稱，選擇報表文件夾後儲存。<br>2、構建報表文件夾<br>&nbsp;&nbsp;&nbsp;&nbsp;在沒有構建報表文件夾前，系統預設產生“我的個人自訂報表文件夾”和“未歸檔公用報表文件夾”。 <br>&nbsp;&nbsp;&nbsp;&nbsp;步驟1：從報表選項卡，單擊建立報表文件夾<br>&nbsp;&nbsp;&nbsp;&nbsp;步驟2：在彈出的建立報表文件夾彈窗中，可以選擇將未歸檔公用報表文件夾中的報表轉移至此文件夾。可以選擇哪兒些使用者可以存取此文件夾以及存取權限。<br>3、查看報表<br>&nbsp;&nbsp;&nbsp;&nbsp;步驟1：從報表選項卡，進入報表列表頁，通過切換“最近查看”、“我建立的”、“全部報表”或報表文件夾找到想要查看的報表。 <br>&nbsp;&nbsp;&nbsp;&nbsp;步驟2：單擊報表名稱，即可查看報表。或單擊報表最右側“下拉按鈕”，選擇“運行”，即可查看報表。<br>&nbsp;&nbsp;&nbsp;&nbsp;如果是管理員設定檔，從報表選項卡，進入報表列表頁，單擊“建立文件夾”按鈕旁邊的“齒輪”圖示，可以選擇每一個文件夾中報表列表的表頭展示的欄位。<br>4、匯出報表<br>&nbsp;&nbsp;&nbsp;&nbsp;步驟1：從報表選項卡，進入報表列表頁，找到您想要匯出的報表，單擊報表最右側“下拉按鈕”。 <br>&nbsp;&nbsp;&nbsp;&nbsp;步驟2：選擇類型<br>&nbsp;&nbsp;&nbsp;&nbsp;格式化報表：包含報表表頭、分組、篩選詳細訊息。<br>&nbsp;&nbsp;&nbsp;&nbsp;僅限詳細訊息報表：未格式化的詳細訊息行。<br>&nbsp;&nbsp;&nbsp;&nbsp;步驟3：單擊“匯出”。其中僅限詳細訊息類型報表需要分頁匯出，每頁最多匯出2000條數據。`,
"label.batchdelete.success":`批次刪除執行成功`,
"label.newprocess5.seq":`順序`,
"label.knowledgebase.data.translated.successfully":`{a}條資料翻譯成功`,
"label_enable_range":`啟用範圍`,
"label.ccchat.and":`和`,
"label.assignment.setup.list.norule":`沒有分配規則`,
"vue_label_report_summaryformulacolumn":`匯總公式列`,
"label.field.edit.change1":`最大評分不能大於100`,
"syntaxerror":`語法錯誤,請檢查您所輸入的條件`,
"label.icon.116":`房子`,
"lable.asset.BOM.according.to.product":`根據產品結構產生資產BOM`,
"chatter.like.post":`喜歡此貼的人`,
"label.trigger.page":`觸發器頁面`,
"vue_label_email_contact_adminstrator":``,
"label.workreport":`工作報告`,
"vue_label_homepage_edit_card_view":`編輯卡片視圖`,
"label_emailsync_status_disabel":`禁用`,
"label.icon.54":`挖掘機`,
"message.error.view.validerr.common":`驗證失敗`,
"label.exchange.sync.account.username":`服務帳戶用戶名(域用戶名或UPN)：`,
"label.dataimport.error.date":`出現錯誤：日期`,
"label.orgname":`組織`,
"label.weixin.group.owner":`擁有者`,
"vue_label_dashboard_colorrange":`顏色範圍`,
"label.forecast.shrepage.tableth":`預測存取`,
"label.related.disabled":`沒有啟用相關列表，請聯繫系統管理員在版面配置上啟用相關列表。`,
"label.version.product.management":`產品管理`,
"label.knowledge.new.article.published":`已將文章發布為新文章`,
"label.sendsms.batch.step4":`步驟4：您已提交簡訊進行處理`,
"vue_label_commonobjects_detail_and_tasks":`恭喜你,沒有未處理的事件和工作啦。`,
"label.salescloud.ci":`個`,
"label.ccpeak.getapi.name.time":`如果要使用CCService類中的方法，需要實例化`,
"label.escalation.setup.detail.conditon":`條件`,
"label.lbs.isUseLbs":`啟用定位服務`,
"front-lightning-module-v1-dashborad-color-depth":`顏色深度`,
"date":`日期`,
"label.select.personnel":`選擇人員`,
"label.appointmentpage.wizard.notif3":`請填寫信箱`,
"label.import.page1.pleaseselectwayofdealdata":`請先選擇處理方式`,
"label.partner.all.memo":`列表顯示貴組織中的全部夥伴雲。單擊URL可將您直接跳轉到登錄頁。`,
"label.appointment.wizard.subtitle4-3-3":`30分鐘`,
"component_telerecord_label_subject":`主題`,
"label.sendsms.batch.finish":`批次發送簡訊：完成`,
"label.login.access.myusername":`我的用戶名`,
"label.weixin.wechatnumber":`微信號`,
"label.eowechat.status":`使用者狀態`,
"Lead_Scoring_Setting_Rule_Setup_Value":`分值`,
"label.appexchange.oldreport.noupload":`舊報表-不會上傳`,
"label.approverfieldediting":`審批者欄位和記錄可編輯性`,
"label_tabpage_customernamez":`客戶名`,
"vue_label_dashboard_linkagesettings":`聯動設定`,
"vue_label_ccchart_notice_deletecomment":`確定要刪除這條評論嗎？`,
"label.allprofile":`所有設定檔`,
"label.campaignmember.main.addMember":`添加成員-搜尋`,
"label.projectManagement.subtask.list":`子工作列表`,
"label.code.some.size":`代碼容量 : 最大支援200KB字元,約200000位元組`,
"front-custom-service":`服務雲為客戶提供高效靈活的定制服務，使用智能工單系統縮短服務解決時間並提高解決率，提高客戶忠誠度，增加複購率。`,
"label.SMS.det":`簡訊通知詳細訊息`,
"setup_layout_label_nobutton":`暫無可選按鈕`,
"vue_label_email_Could_not_save_template":`無法儲存範本`,
"label.imgfield.height":`高度`,
"label.leadscore":`商機評分`,
"setup_object_field_dependency_label_removefromlist":`移除選中值`,
"message.error.code.null":`授權碼不能為空！`,
"label.tianyancha.businessscope":`經營範圍`,
"vue_label_chat_empty_message":`清空通知`,
"label.total":`共`,
"label.delerror.list":`未刪除文件列表`,
"label.selectedreceivers":`所選收件人`,
"label.layout.availablepages":`可用頁面`,
"label.pc.ui.2018.personalinfo":`個人中心`,
"label.chat.topic.edit.detial":`編輯詳細訊息`,
"label.mr.descreption.reDataList1":`在`,
"label.document.value.too.long":`此文件大小已超過5M！`,
"lable.opppdt.addpdt.table.listprice":`定價`,
"label.selectoperate":`選擇操作`,
"label.icon.5":`貨幣`,
"label.icon.126":`病床`,
"label.hiddensearch":`隱藏搜尋`,
"label.view.sortview.exportble":`可匯出`,
"vue_label_homepage_noassignee":`無指派人`,
"label.knowledgebase.close.and.resolve":`關閉並解決`,
"label.licence.used":`許可證已使用數量`,
"label.newprocessstep5":`步驟 5: 選擇要在批准版面配置上顯示的欄位`,
"vue_label_appstore_all_applications":`全部應用程式`,
"label.no.edit.permission":`無所選記錄編輯權限，不可選擇`,
"vue_label_calendar_calendar_added_successfully":`添加日曆成功`,
"report_line":`資料欄位`,
"component.chatter.link.label.name":`連結名稱`,
"label.data.expnode.e_desc1":`1、自訂匯出：使用者可以根據自己的需求選擇要匯出的欄位，以及進行篩選的條件。`,
"label.tabularreport.step4":`步驟 4：選擇報表標準`,
"Opportunity.Detailed.Phase.Change.Text.001":`更改機會階段`,
"label.quickbooks.searchresault.action":`操作`,
"component_timeline_label_today":`今天`,
"label.callboard.remark":`在下面為貴組織輸入公司公告`,
"label.campagin.field.choose":`選擇要包含在市場活動註冊頁面中的欄位`,
"front-gantt-module-rolling-temporary-tasks":``,
"label.file.des":`描述`,
"Dashboard_View_RecentlyView":`最近查看`,
"UG_Account_04":`被動查詢客戶過濾`,
"chatter.refresh":`刷新`,
"label.tianyancha.companyorgtype":`公司類型`,
"label.chatter.dateRange":`日期範圍`,
"label.campagin.step3":`步驟3：產生頁面`,
"label.appointmentdetail.wizard.title14":`週一時間規劃`,
"setup.object.field.dependency.button.setdependency":`設定欄位依賴`,
"serviceterritorymember.serviceterritory.isactive.notactive":`此服務區域未啟用，您僅可以在已啟用的服務區域下添加服務區域成員`,
"template.chart.ygydyj":`員工贏單業績`,
"label.tag.edittags":`編輯標籤`,
"label.clone":`複製`,
"front-electronic-signature-setting-intro1":``,
"label_reach":`達成`,
"label.tabpage.havez":`有`,
"label.email.clearCase":`只清空未關聯個案的郵件`,
"label.customer.tab.all":`所有選項卡`,
"label.direct.dashboard.day.report":`新建工作日報`,
"label_tabpage_exportview":`匯出視圖`,
"label.passwordPolicy.setup.maxFailTimes":`最大失敗嘗試次數`,
"label.processsetting.complete.enable":`完成並啟用`,
"label.marketsea.memberfield":`成員可查看欄位`,
"label.report.export.format.title":`格式化報表`,
"label.recycle.execute.title":`正在清空回收桶`,
"label.file.use.most.user":`使用儲存空間最多的使用者`,
"report_type_label_systemReport":`系統報表`,
"label.customobjects.majorobject":`主物件`,
"label.file.delete.public.link":`刪除公用連結`,
"front-epwechat-module-v1-id":`企業微信ID`,
"label.partner.common.roleNum":`角色數量`,
"label.sendtonextapprover":`發送到下一個審批人`,
"label.notification.tip3":`載入另10條`,
"label.tabpage.placeenterz":`請輸入`,
"label.mobile.phone.cc.people":`寄送附本`,
"component_setup_iframe_label_inputurlmemo":`請輸入要引入的頁面URL地址`,
"label.umeng.activity.statuschange":`您指派給#name的工作狀態被修改為#newstatus`,
"label.step3.restricted.visibility":`步驟3.限制可視性`,
"label.multilang.datadelete.approvedata":`此欄位被{0}處引用：`,
"label.reportsSubscription.save":`儲存`,
"label.emailobject.template.visibility":`可視性`,
"label_partner_step3":`步驟3：基本訊息`,
"label.product.across":`跨越各價格手冊`,
"label.same.analyze.opportunity.name":`業務機會名稱`,
"label.chatter.memotel":`記錄電話`,
"label.recentview.seloption2":`我最近建立的`,
"label.ccchat.message.search.desc1":`我們無法找到具有`,
"label.reportexport":`匯出`,
"label.service.gantt.drop.tip":`權限不足：您沒有足夠的權限進行此一操作，請聯繫管理員`,
"label.australian.westem.standard.time":`西部標準時間（澳大利亞）`,
"label.emailobject.email":`郵件`,
"Homepage_Contract_FieldMissed_DoesntSupport":`合約物件上缺少欄位“qdrq”和"htje"，無法顯示數據。`,
"label.email.cancel.upload.info":`這將取消正在進行的上傳過程`,
"label.page.copy.merged.field.value":`複製合併欄位值`,
"UG.ST.006":`直接進入`,
"label.trigger.service.connot.access":`無法存取的語句`,
"label.projectManagement.new.tasks":`新增工作`,
"lable.SalesCommitmentKanBan.receiptsRate":`收款達成率`,
"label.productsales.oppor.overdue":`逾期的機會`,
"vue_label_pool_convertedbyme":`我轉換的`,
"label.loginip.pagecue.invalidt":`開始Internet地址大於結束Internet地址，或無效的Internet地址`,
"label.campagin.roi.xyzj":`響應總計`,
"label.visualpage.list.title":`已啟用的自訂頁面存取`,
"chatter.feed.searchinitvalue":`鍵入名稱...`,
"label.export_submission":`匯出送出資料`,
"this.season":`本季度`,
"label.forecast.settings.gx":`預測數據共享`,
"label.tag.addtags.tagcolour":`標籤顏色`,
"label.api":`API名稱`,
"label.bulk.delete":`批次刪除(徹底)`,
"label.reportsSubscriptionPage.condition.emailoption":`郵件選項`,
"vue_label_dashboard_newdashboardsuccessfully":`建立儀表板成功`,
"three":`三`,
"label.prompt":`提示`,
"label.same.analyze.contact.phone":`聯絡人手機`,
"label.icon.62":`管道`,
"label.forecast.shrepage.tableth.isnable":`允許提交`,
"label.multilang.polloption.vote":`{0}票`,
"label.customfields.totalsummary.selecttotaltype":`選擇累計類型`,
"lable.SalesCommitmentKanBan.receivingCommitmentRate":`收款承諾率`,
"label.areaAndSub":`區域及下級區域`,
"vue_label_pool_recycle":`回收`,
"lable.outlook.detail.synset":`同步設置`,
"label.quote.detail.introduce":`輸入關鍵字，點擊“搜尋”開始搜尋，搜尋完成後點擊“選擇”，進入下一步`,
"label.profile.customappset":`自訂應用程式設置`,
"label.changemylanguage":`更改語言`,
"message.approval.plzcapppor":`請選擇審批者`,
"vue_label_pool_operatecertification2":`{0}{1}{2}{3}`,
"label.publiccalendarandresource":`公共日曆和資源`,
"label.wtd.changefields.title.desc1":`選擇要在頁面上用到的欄位，輸入返回的URL，點產生按鈕，產生頁面。`,
"label.weixin.voting.not.empty":`投票選項不能為空`,
"label.campaign.channel.equal":`等於`,
"label.emailobject.emaildetail.button.back":`返回`,
"label.ccchat.person.invite.allowemails":`為了安全，請只輸入以下結尾的電子郵件地址`,
"label.notEdit.message":`抱歉，您無權編輯該條數據，請聯繫系統管理員`,
"label.layout.selectedfields.relatedlist":`選取欄位/相關列表`,
"label.weixin.voting.deadline":`投票截止時間`,
"label.document.upload":`要上傳的文件`,
"label.import.page2.notmatchfiled":`文件中共{csvfiledlength}個欄位，剩餘{difflength}個未映射`,
"label.data.exp.selzippwd":`不填預設無壓縮密碼`,
"label.user.step2.select.email.template":`步驟2.選擇電子郵件範本`,
"label.currency.effective":`有效幣種`,
"label.version.control.type":`版本類別`,
"label.projectManagement.Taskorproblem":`工作/問題`,
"label.everyweek":`每週`,
"label.passwordPolicy.setup.pwdremember4":`記住4個密碼`,
"label.emailobject.groupemail":`群發郵件`,
"label.approvepagelayout1":`多人採用相同頁面配置`,
"label.integrations.mailchimp.massage5":``,
"label.icon.22":`添加`,
"Dashboard_View_All":`所有儀表板`,
"label.import.page2.example":`示例`,
"label.send.letter":`發送邀請函`,
"label.mobilesectionpart":`行動端部分`,
"component_setup_tabs_label_title":`Tab分頁`,
"label.knowledgebase.results":`{a}條結果`,
"label.field.remark":`應用於在`,
"vue_label_systemSettings_url":`網域名設定`,
"vue_label_SMS_failed_find_view_list":`查找視圖列表失敗`,
"setup_layout_label_order":`排序標準`,
"label.customsetting.touse":`使用自訂設置 customSetting`,
"label.product.enter":`輸入用來查找匹配產品的關鍵字`,
"label.email.template.private.SMS":`專用簡訊範本檔案夾`,
"vue_label_homepage_chart_deleted":`圖表或儀表板已被刪除`,
"label.conversion_pages":`轉換頁面`,
"label.compact.layout.select":`選擇關鍵訊息配置欄位`,
"report_label_folderandreport":`報表和文件夾`,
"label.product.entry":``,
"label.campaignmember.main.manageMember":`管理成員`,
"front-QBtoCC-changing":``,
"vue_label_pool_abandonreason":`廢棄原因`,
"template.report.customer.contract.statistics":`客戶的合約統計`,
"label.invoice.message.sendsuccessully":`Invoice發送成功`,
"label.addcurrentoperate":`添加現有操作`,
"label.customerinfo.mailpwd":`發件郵箱密碼`,
"batch.nochange.owner":`無權限更改數據擁有者！`,
"label_tabpage_uploadfailez":`上傳失敗，請重新上傳。`,
"vue_label_systemSettings_mobelqrsetting":`行動端掃描設定`,
"label.regular_field":`表單域`,
"label.tabpage.delsuccessz":`刪除成功`,
"label.Days.Before.Horizontal.Date":`水平日期之前天數`,
"label.evaluation.general":``,
"chatter.notlike.p":`停止喜歡此帖子`,
"label.chatter.send":`發送`,
"label.emailsync.button.cancel":`取消`,
"label.notification.task4":`您的工作今天到期`,
"vue_label_helpcenter_detail1.2":`快速更改工作狀態：勾選“已逾期和即將到來”模組中的工作前的複選框，單擊重新整理按鈕即可快速更改工作狀態為“已結束”。 ?<br>未重新整理前，取消勾選則工作狀態不改變。 <br>優先級高的工作在活動時間線中會用“紅旗”圖示標記。 <br>活動時間線的顯示順序<br按照工作的到期日期、記錄電話的到期日期、事件的開始日期、郵件的收發日期、簡訊的收發日期倒序排列。如果以上日期相同時，會按照記錄建立的時間倒序排列。 <br>活動時間線篩選器<br>使用活動時間線中篩選器，以縮小可視事項的範圍、重點關注重要事項並查找目標事項。時間線的篩選器包括日期範圍、要顯示活動、活動類型三種類型的篩選。 <br>要顯示的活動：所有活動、我的活動<br>在活動時間線篩選器中，此選項可以縮小活動的顯示範圍。 <br>我的活動：顯示您參與的活動，不論作為擁有者或參與者。例如，您是發送電子郵件或組織活動的擁有者。例如，在您是電子郵件副本或密件副本欄位的收件人時，即表示您參與活動。 <br>`,
"component_chatter_post_label_title":`張貼`,
"label.data.dataexptemplate.desc":`資料匯出範本是使用者建立的用於匯出資料的範本，用以便捷使用者的匯出操作。`,
"label.helptext":`幫助文本`,
"vue_label_norm_removecomponent_certify":`確認刪除組件`,
"front-template-V1-Click-new-template":`點選”建立”，建立新的範本。啟用後即可使用範本。`,
"label.optional_fields":`選填欄位`,
"label.delete_about":`你要刪除`,
"chatter.feed.initvalue":`您正在處理什麼？`,
"label.mail.configure":`配置您個人同客戶來往的信箱，即可使用CloudCC郵箱主頁進行收發郵件，並且同步歷史來往郵件到商機和聯繫上。`,
"label.project.hit.seven":`項目工作到期提醒`,
"label.button.upgrade":`購買與修改版本`,
"lable.PowerProcess.event.name":`重大事件名稱`,
"label.weixin.confirm":`確認`,
"label.customfields.new.inputformula":`輸入公式`,
"label.standard.buttonandlink.edit":`改寫標準按鈕或連結`,
"workflow.action.tasks.assignortype.createdtype":`建立人類型`,
"front-email-payment-paypal-describe":``,
"label.selectexistingoperate":`選擇現有操作`,
"label.workflow":`工作流程`,
"label.assignment.setup.detail.ruleentries":`規則項目`,
"label.data.file.i.title.num3":`3.系統會把將要匯入的資料文件預讀到伺服器，然後啟動後台批次處理匯入程式，匯入結果將以郵件方式通知使用者，您無需在此操作頁面等待。`,
"label.use.view":`使用現有視圖`,
"label.forecast.settings.moren":`預設產品系列`,
"vue_label_calendar_add_share":`添加共用`,
"label_tabpage_newview":`建立新視圖`,
"label.recycle":`回收桶`,
"UG_solution_03":`建立解決方案`,
"label.customfields.formula.text.tip":`建立文本字元串，例如，通過串聯其他幾個文本欄位`,
"vue_label_file_single_file_size":`單個文件最大支援`,
"label.a.b.least":`每個 A" 記錄必須至少有一個相關 "B" 記錄。"`,
"label.validate.function.addtoformula":`插入所選函數`,
"label_tabpage_pleaseSelectz":`請選擇`,
"label.account.NextFQ":`下一個會計季度`,
"label.project.project.name":`項目名稱不能重複！`,
"label.emailtocloudcc.filed.owner":`記錄擁有者`,
"label.textmessage.template.message2":`當前簡訊正文中插入的欄位與已關聯的記錄不相符，可能會造成取值失敗。`,
"label.icon.92":`書`,
"label.trailerpage":`尾頁`,
"component_event_label_noevent":`看來您已完成今天的工作了。`,
"label.trigger.tip":`關於觸發器`,
"label.knowledge.case.field.usable":`可用個案欄位`,
"label.group.isusing.success":`啟用成功`,
"label.marketsea.nextnotfollowdays":`距上次跟進後`,
"component.todaytask.label.choicestate":`選擇狀態`,
"label.recordtype.main":`--主--`,
"label.sendletter.step1":`步驟1：指定邀請函接受者`,
"label_tabpage_saveviewfailed":`視圖儲存失敗`,
"vue_label_report_notiec_selectone":`每個上級物件記錄必須至少有一個相關此物件記錄`,
"UG_opportunity_003":`蹤您的銷售渠道 建立儀表板`,
"#label.importsourcestep4":`步驟四：匯入您的文件#`,
"front-kefu-moudle-v1-trrt-tip":``,
"UG.Forcast.09":`下一步`,
"label.ggReleaseRange.subordinates":`搜尋角色和下屬`,
"label.log.desctiption":`您可以下載您組織審計追蹤,包含更多的內容.（Excel.csv檔）。`,
"label.submitted":`已提交`,
"label.validate.function.funcExplain.BEGINS":`檢查文本是否以特定字元開頭，如果是則返回TRUE。否則返回FALSE。`,
"label.campaign.channel.code":`市場活動營銷渠道二維碼`,
"chatter.group.theLastActivityDate":`上次活動日期`,
"vue_label_dashboard_pleaseenterabreakpoint2value":`請輸入斷點2值`,
"label.labeltranslation":`標籤翻譯`,
"label.multilang.product.deleterederect":`無法完成您對{0}的刪除,因為它仍與其它價格手冊的記錄相關聯。關聯記錄如下。`,
"lable.currencyManage.manageRate.dis":`要管理您公司其他物件的匯率、添加新幣種、啟用或禁用幣種、或更改公司幣種，請單擊"管理幣種"。`,
"setup.layout.label.modifypage":`編輯頁面`,
"label.import.page2.editforname":`請為欄位?{necessaryName}?編輯映射`,
"label.searchlayout":`搜尋配置`,
"label.chatter.loadmore":`連線更多`,
"label.trigger.folder.all":`所有觸發器文件夾`,
"label.export_submissions":`匯出表單送出數`,
"lable.SalesCommitmentKanBan.allsignedTaskRate":`總簽約任務率`,
"KeyInformationLayout_DefaultLayout_Name":`系統預設`,
"label.h5.chatter.great":`個贊`,
"label.call.center.configuration.enable":`使用下列設置修改貴組織Call Center功能是否啟用`,
"label.overdate":`結束日期`,
"chatter.poll":`投票`,
"label.login.input.verification.code":`請輸入安全碼:`,
"label.file.sharetype.cooperation":`協作者`,
"label.app.step5":`步驟 5. 分配設定檔`,
"front-gantt-module-save-order":``,
"label.globalselect.toallrecord":`將新選項列表值添加到使用此全局值集的所有記錄別型`,
"setup.mainpage.label.welcome24":`CloudCC 雲平臺提供系統內所有物件數據的安全性存取設定，可以通過設定各種規則、條件進行數據共用和存取權限的控制。`,
"homepage.layout.desctiption":`此頁面允許您為主頁選項卡建立不同的選項卡配置。`,
"vue_label_SMS_notice_send_sussess":`簡訊已發送`,
"label.projectManagement.overdue":`已逾期`,
"label.assignment.setup.list.lead.description":`使用商機分配規則可以自動將商機發送給相應的用戶。商機分配規則由定義於商機的條件和多條規則項目組成。`,
"label.list.projectSetting.des":`使用下列設定修改項目下是否發送郵件：`,
"setup.mainpage.label.welcome18":`CloudCC 的企業級權限設定使您在處理數據和模組時可以控制各使用者的使用權限。基於角色的權限設定還包括使用者職位、組、角色、數據共用規則、欄位級安全控制，實現企業不同人員、部門之間的數據共用。`,
"label.ratio":`年增長比與月增長比`,
"label.Xaxis":`X 軸`,
"label.google.map":``,
"Dashboard.SelectBoardToDisplay":`請選擇打開儀表板選項卡顯示的儀表板`,
"label.data.newtemplate.e_conditions":`匯出條件`,
"label.emailtocloudcc.description3":`將您企業的信箱，如sales@company.com, info@company.com, support@company.com添加於此，系統將自動根據所收郵件產生商機或個案記錄，確保即時跟進來信客戶`,
"label.page.select.profile":`選擇要在其中使用新自訂選項卡的使用者設定檔。也可以在每個設定檔的詳細訊息和編輯頁面上檢查或修改是否顯示某個選項卡。`,
"label.chosen.button":`已選按鈕`,
"front-epwechat-module-v1-info":`企業微信背景資訊`,
"label.translation.select":`選擇篩選條件`,
"ten":`十`,
"label.barcode":`條碼`,
"lable.product.nextdel":`繼續並刪除顯示的記錄,或單擊`,
"label.default":`預設`,
"label.chatter.theme":`主題`,
"vue_label_commonobjects_view_split_screen_view":`並列視圖`,
"label.ems.myemails":`我的郵件`,
"label.email.clearPersonalEmail":`按照附加條件篩選服務預約`,
"label.login.access.admin":`您的公司管理員`,
"label.emailobject.wizard.desc":``,
"label.passwordPolicy.setup.minpwdlength":`密碼最小長度`,
"choserow":`請選擇顯示的列`,
"front-epwechat-module-v1-role-binding":`角色綁定`,
"lable.outlook.edit.newdata":`建立日期最早`,
"label.schedulejob.setup.schedule.enddate":`結束日期`,
"label.quickbooks.view":`視圖`,
"font-evaluate-module-v1-not-inform":``,
"chatter.poll.option3":`選項3`,
"setup_layout_label_selectfield":`欄位選擇`,
"label.partner.common.roleSetup":`夥伴雲角色和使用者設置`,
"label_partner_new_step3":`步驟3：輸入名稱和URL`,
"label.transfer":`轉移`,
"label.bmap.myaddress":`我的位置`,
"label_tabpage_individual":`單項選擇`,
"label.autoRegister.changepwd.setpwd.repassword":`請再輸入一次密碼`,
"vue_label_commonobjects_detail_and_before":`更早之前`,
"front-kefu-moudle-v1-single-Login-area":``,
"label.replacedocument":`取代文檔`,
"label.validate.function.category.Logical":`邏輯`,
"label.companyprofile.syncsuccess":`同步成功`,
"template.chart.rwzthyxj":`工作主題和優先級`,
"label.product.clearcondition":`清空條件`,
"component_task_label_person":`*被指派人`,
"label.tabpage.as":`如`,
"message.error.calendar.add":`已添加過該日曆`,
"label.marketsea.isrecycleleadcreatebyself":`是否回收自建商機`,
"label.icon.57":`氣壓表`,
"UG.Lead.010":`或者`,
"setup_object_field_dependency_label_configured":`已配置內容`,
"label.tianyancha.regnumber":`註冊號`,
"front-kefu-moudle-v1-Opened-chats":`開通聊天`,
"label_tabpage_converstatez":`已轉換狀態`,
"label.bmap.beijing.haidianqu":`北京市海淀區上地10街`,
"label.startimport":`開始匯入`,
"label.knowledgebase.application.default.settings":`Lightning應用程式預設設定`,
"lable.account.year.custom":`自訂會計年度`,
"label.event.nextmonth":`下月`,
"label.email.body":`正文`,
"setup.object.field.dependency.label.mustsetup":`請先設定欄位依賴關係，再儲存`,
"label_tabpage_multiple":`多項選擇`,
"label.task.this.month":`本月的任務`,
"label.customfields.formula.moneyexample":`Gross Margin（毛利）`,
"label.tonewemailnotice":``,
"setup.mainpage.label.welcome11":`自訂報表`,
"label.layout.availabletab":`可用選項卡`,
"label.data.importef":`匯入失敗的文件`,
"label.appupload.upload.alert":`在上傳之前請提供有關此軟體包的詳細訊息。這些設置確定安裝此軟體包所必需滿足的要求。`,
"label.sales.accountteam.shared":`客戶小組共享`,
"lable.currency.addexchageRate":`添加匯率`,
"label.page.simplified.chinese":`簡體中文`,
"label.service.dispatchingUnits.search.service.area":`搜尋服務區域`,
"lable.list.queue.name":`佇列名稱`,
"pagecreator.button.save":`儲存`,
"label.ccpeak.support.function":`支援單表各種函數`,
"label.tianyancha.legalpersonid":`法人ID`,
"label.sendemail.chat.addPostmainPage":`尊敬的#name:\n\n 您好！ #userName在您的CCChat主頁上發帖。`,
"batch.no.change":`無權限轉移的數據`,
"label.the.referenced":`處引用`,
"label.input.webtab.information":`填寫有關 Web 選項卡的訊息。`,
"vue_label_systemSettings_subscription":`訂閱類型`,
"label.login.access.title":`授予客戶存取權限`,
"label.schedulejob.setup.schedule.lastday":`最後一天`,
"label.synchronize.department":`同步使用者`,
"label_tabpage_lessequalz":`小於或等於`,
"label.file.library.successmanagemember":`管理成員儲存成功`,
"label.service.major.event.oreder":`序列`,
"label.desktopintegration":`桌面整合`,
"label.a_b":`A 到 B 關係`,
"every":`每`,
"label.tabpage.bar":`條`,
"label.filecontentsnotnull":`文件內容不能為空`,
"label.layout.detailoftestobj":`測試物件詳細訊息`,
"label.summaryreport.2018.step3":`步驟3：選擇報表列`,
"UG.Lead.002":`有很多方法可以為您的產品或服務識別“商機”。`,
"label_partner_workspace_member_selectedprofile":`已選設定檔`,
"label.newdescription":`新建備註`,
"vue_label_normal_moveup":`上移`,
"label.mobile.quickcreate.default.logacall":`通話記錄`,
"userterritory.serviceterritory.user.unique":`此使用者已被指派了此服務區域，請勿重新指派`,
"label.weixin.record":`記錄`,
"front-kefu-moudle-connecting":``,
"label.monitorsys.recent.operation.log":`最近操作日誌`,
"lable.outlook.detail.lmaping":`商機欄位映射`,
"lable.account.year.ovdate":`會計年度結束日期`,
"vue.homepage.auditcard.record":`記錄{recordTotal}條`,
"label.processsetting.delete.process.succeeded":`刪除進程成功！`,
"label.customerinfo.smsPwd":`簡訊網關密碼`,
"label.tolead.object":`匯入物件`,
"label.data.downpage.i.list.desc2":`匯入資料後，您會收到一封郵件，提醒您是否匯入成功。`,
"label.sharerule.ruletype":`規則類型`,
"label.reportsSubscriptionPage.email.toothers":`發送給我和其他使用者`,
"label.emailobject.templates":`選擇範本`,
"vue_label_checkduplicate_":`撞單分析`,
"label.campaign.channel.lookup.example":`查看示例`,
"label.login.verification.please.note":`請注意：`,
"label.version.charge":`收費`,
"label.ccdocument.show.trace":`顯示痕跡`,
"label.sendemail.approval.submit":`您好,#name:\n #actorname於#actordate提交的#objLabel-#recordname正在等待您的審批，請點擊如下連結或者登錄CRM系統，進入審批中心進行審批：\n #path#appPath/query.action?id=#recordid&m=query\n#orgName`,
"setup.mainpage.label.welcome12":`使用者通過點擊滑鼠，無需編程，按照系統提示步驟，便可以完成報表定義。系統有列表式報表、匯總報表、矩陣式報表可供選擇。同時提供所有欄位的顯示選擇。去除不必要的欄位訊息。 同時提供包括、條狀、折線、環狀、漏斗、餅狀等多類圖形顯示。讓使用者一目瞭然。`,
"UG_contact_06":`匯入聯絡人`,
"message.success.event.add":`儲存建立事件訊息成功`,
"report.line":`數據欄位`,
"label.approvepagelayout2":`每人採用不同頁面配置`,
"vue_label_normal_contract_sf":`合約`,
"label.tabpage.tpcustomersz":`轉換商機`,
"label.ccchat.message.new.error5":`錯誤，您的消息不能超過10000個字元。`,
"label.severalorone":`單個檔`,
"pagecreator_systemstyle_label_buttonfontcolor":`按鈕文字`,
"label.customer.tab.step3.introduce":`選擇要在其中使用新自訂選項卡的自訂應用程式。也可以在每個自訂應用程式的詳細訊息頁和編輯頁上檢查或修改是否顯示某個選項卡。`,
"chatter.group.groupEdit":`組編輯`,
"label.partnerCloud.partnerAccount.spending":`回饋金支出`,
"label.slip":`條）`,
"label.field.master.class":`主詳關係層級超出3級`,
"label.sendemail.chat.addComentsmyFeed":`尊敬的#name:\n\n 您好！ #userName對您的微貼進行回覆。`,
"label.service.ganttBaiduMap.selectingDispatchTime":`選擇派遣時段`,
"label.knowledgebase.remove.article":`將文章從歸檔中移除？`,
"label.appupload.notmanaged":`不受管理`,
"label.report.goto.step":`轉至步驟`,
"label.publicgroup.save.mustbeselect":`必須選擇成員`,
"label.data.expnode.e.desc2":`2、按範本匯出：使用者可以選擇範本進行資料匯出。`,
"UG.product.02":`產品參考銷售或採購的產品或服務。`,
"label.sendemailtouser":`確定要給選中的使用者發送電子郵件嗎？`,
"label.knowledge.setting.hint.nine":`如果您未找到Knowledge有什麼好處？將相似文章排序為唯一數據分類，並累積為更為寬泛的數據分類組。現在，添加一個數據分類組。您稍後可添加更多。`,
"front-asset-module-v1-view-asset-bom":`檢視資產BOM`,
"label_partner_all_enable":`啟用`,
"label.processsetting.disable.process.successfully":`禁用進程成功！`,
"label.call.center.enable":`啟用Call Center`,
"message.recordtype.applyitseparatly":`為每個設定檔應用不同的頁面配置`,
"label.weixin.report.customize":`自訂`,
"label.file.mongdb.file.is.not.exist":`文件已不存在`,
"label.chat.edit.topics":`編輯主題`,
"label.knowledge.delete.searchterm":`刪除搜尋性能詞出錯`,
"label_emailtocloudcc_redmessage3":`請輸入伺服器位址`,
"use":`使用`,
"label.batchtransfer.transferfrom":`轉移自`,
"label.recycle.my":`我的回收桶`,
"label_json_string_null":`空`,
"label.version.lookupfield":`查找欄位`,
"lable.tianyancha.h5.searchf":`未搜尋到`,
"label.validate.globalvariable.description":`$User.[欄位API]，例如：$User.id <br>可取到的欄位值有：id,name,roleId,roleName,profileId,profileName,department,title,email`,
"UG.opportunity.006":`機會天才`,
"label.applt.copy":`一鍵複製`,
"chatter.emailMessageOrReply":`發帖或回覆`,
"label.newreport.self":`選中的欄位`,
"label.visualpage.checkpinxie":`請檢查頁面拼寫。`,
"label.knowledgebase.article.attaching.case":`文章?{name}已附加到個案！`,
"label.dialogbox":`對話框`,
"label.summaryreport.step3.new":`步驟 3：選擇要彙總的訊息`,
"label.confirm":`確定`,
"label.mobile.buttom.team":`群策`,
"label.quickbooks.action.link":`關聯`,
"vue_label_commonobjects_view_support_to_datas":`該操作最多支援10條數據`,
"vue_label_helpcenter_homepage":`每個使用者天生都帶兩個主頁，標準主頁和個人主頁，管理員可以根據使用者的設定檔再給使用者指派一個對應的設定檔主頁。註意，Lightning版本的主頁和老版本的主頁不互通。<br>1、標準主頁<br>    標準主頁的內容是統一不可編輯的。包括季度業績組件、最近查看組件、審批中心組件、今日事件組件、工作組件、已逾期的機會組件、最近30天未聯繫的機會組件、臨近的機會組件<br>    季度業績組件：每個人可以設定自己的季度目標<br>    最近查看組件：展示最近查看的10條物件記錄<br>    30天未聯繫的機會組件：展示未聯繫天數大於30天，且可能性不為0和100的5條機會<br>2、個人主頁<br>    每個人都有一張個人主頁，個人主頁上的內容可以自訂的增刪組件、也可以拖曳來調整組件的位置和大小<br>    個人主頁開戶時預設會有簡報組件、審批中心組件、逾期機會組件、臨近機會組件<br>    個人主頁最多15個組件<br>3、設定檔主頁<br>    管理員可以通過自訂主頁來建立/編輯/刪除設定檔主頁，並可以給不同設定檔指派不同的主頁，以達到不同設定檔的使用者可以看到不同的主頁的效果<br>    每張設定檔主頁最多15個組件<br>4、添加組件<br>    個人主頁和設定檔主頁可以自訂添加組件，可以添加儀表板組件、儀表板內圖表組件和卡片視圖組件<br>    儀表板組件：將系統中整張儀表板添加進主頁，儀表板內包含多少個子組件就代表這個儀表板組件占用多少個組件的資源（主頁最多支援15個組件），添加後儀表板組件的數據不會和原儀表板關聯（即刪除了原始儀表板，該儀表板組件依然可以作用）<br>    儀表板內圖表組件：可以將系統中儀表板內具體的某個圖表組件添加進主頁，此時組件的聯動功能將會失效<br>    卡片視圖組件：可以選擇將某個物件的某個視圖作為數據源添加進主頁，欄位和操作項都可以自訂配置。但注意，如果卡片視圖的數據源視圖被刪除了，卡片視圖將無數據`,
"label.usersandlimit":`使用者及權限`,
"label.sendmail.step3.introduce2":`位收件人接收此電子郵件。`,
"label.setupcustomfield":`自訂欄位`,
"label.layout.last.notdel":`配置最後一個不允許刪除`,
"label.emailtocloudcc.redmessage7":`後台配置錯誤，請聯繫管理員`,
"label.includedIn":`包含於{parentproductname}`,
"label.permission.detail.app.pagesetting":`自訂頁面設置`,
"label.addfile.tips":`已選擇了{selectedNum}個文件，單次最多添加{originNum}個文件`,
"label.fieldinformation":`欄位訊息`,
"label.campagin.roi.sjcb":`實際成本`,
"label.email.all.works.company":`公司所有同事`,
"label.currencyDesc":`使用此頁面定義您的組織使用的所有貨幣。應將公司幣別設置為公司總部在收入報告時所使用的幣別。如果指定其它幣別作為公司幣別，則會修改所有兌換率以反映此變化。`,
"label.file.details":`詳細訊息`,
"label.foldervisitlimit3":`只有下列使用者可存取此檔夾：`,
"label.account.next.M":`下月`,
"label.oweralias":`擁有者別名`,
"label.projectManagement.entryname":`項目名稱`,
"label.customcomponent.page.add.title1":`組件訊息`,
"label.projectManagement.PleaseenterCreator":`請輸入建立者`,
"label.multipleactivity.memberselected":`所選成員`,
"label_chatter_memotel":`記錄電話`,
"lable.Confirm.customers":`確認恢復{num}個商機`,
"front-email-payment-Invoice-number":``,
"label.not.appoint.validation":`沒有指定驗證規則對應的物件，請指定`,
"label.peru.time":`秘魯時間`,
"label.setting.intergrationlist.status3":`需要QuickBooks帳號登錄`,
"vue_label_display_number_field":`顯示數字欄位`,
"label_productline_count":`產品系列數量`,
"label.data.downpage.i_title.num2":`2、開始匯入之前，請確保您要匯入文件中的欄位名稱和 CloudCC 系統中物件欄位名稱的匹配。`,
"label.field.duplicate4":`將"ABC"和"abc"視為不同值（區分大小寫）`,
"message.approval.step.validation.invalid.levels":`階層至少為1`,
"label.tianyancha.businessverify.step1":`啟用工商數據驗證第一步`,
"label.hidedetail":`隱藏詳細訊息`,
"UG_Lead_009":`APP通話記錄`,
"label.partnerCloud.newProductSeries":`建立產品系列`,
"label.brief.opportunities":`機會總數`,
"label.user.mfa.unbind.remind":`您即將對選擇的使用者解除MFA綁定，使用者下次登錄之後需要重新綁定MFA設備，請確認。`,
"vue_label_report_grouprow":`組行`,
"setup.layout.label.newarea":`建立區域`,
"label.nostart":`未開始`,
"UG_Lead_010":`或者`,
"label.emailmerge.mergepage.record.requeired":`請選擇要合併的記錄!`,
"label.appointmentpage.wizard.notif1btn1":`確定`,
"UG.Account.02":`有些企業向其它企業提供服務，有些企業直接與終端使用者進行合作，有些則服務於NGO組織。`,
"label.address.country":``,
"label.userinfo.updatepwd":`更改密碼`,
"label.salescloud.teamrole.optionlist.opportunity":`將業務機會小組成員添加到`,
"lable.account.Current.FY":`當前會計年度`,
"chatter.coll.p":`收藏此帖子`,
"label.setupsms":`簡訊`,
"label.atlantic.daylight.time":`大西洋夏令時`,
"label.recordslock":`記錄鎖定`,
"button_partner_search":`查詢`,
"vue_label_salesfunnel_notice4":`可能性為1%-99%的機會總金額`,
"vue_label_report_statistics":`統計`,
"label.ccchat.notmember.active.group0":`您不是名稱中含有{0}的任何活動小組的成員`,
"label.tag.manage.newtag":`新增標籤`,
"label.customfileds.formula.dateandtime.tip":`計算日期/時間，例如，通過在其他日期/時間上加上一定的小時或天數`,
"label.weixin.mobile.fly.ios":`ios移動端分享`,
"vue_label_file_over_file_size":`file.name   '的文件體積超出了系統預設！`,
"label.schedulejob.setup.schedule.last":`最後`,
"label.ccchat.whose.name.contains":`的任何活動小組的成員`,
"label.project.milestone.name":`同一個項目中里程碑不能重名！`,
"message.passwordPolicy.validate.reuse":`錯誤：不能重複使用此密碼`,
"label.stdashbord.xsld.business.img3":`可能性為1%-99%階段的金額*可能性`,
"label.event.view.list":`視圖列表`,
"label.workflow.ruletriggertime":`規則觸發時間`,
"label.campaign.channel":`市場活動營銷渠道`,
"label.appexchange.emailnotice":`工作流程電子郵件通知`,
"label.icon.77":`農業`,
"label.visualpage.display.value":`此處寫要顯示的值，注意前後不能有空格`,
"label.forecast.customforecast.type.user":`按使用者`,
"label_tabpage_lessz":`小於`,
"label.same.analyze.contact.email":`聯絡人郵箱`,
"vue_label_report_range":`範圍`,
"lable.product.pricebooks.nr":`您可通過從以下選項列表選擇來從現有價格手冊複製內容`,
"label_mobile_buttom_team_setUp":`群策設定`,
"label.email.bcc.recipients":`密件副本收件人`,
"vue_label_ccchat_notice_deletepostfail":`刪除帖子失敗`,
"label_file_type":`文件類型`,
"label.multilang.feedtrack.operateupdate":`已更改一條{0}記錄：`,
"label.contractmanager":`合約經理`,
"front-gantt-module-drag-one-task-sorting":``,
"label.partner.step2":`步驟2：確認範本`,
"front-epwechat-module-v1-again-binding":`重新綁定`,
"label.service.miniProgram.imageSize":`上傳圖片大小不能超過2MB!`,
"setup_main2018_label_managesetup":`管理設置`,
"component_salesperformance_label_nopermission":`要查看機會相關的數據，請聯繫您的系統管理員。`,
"lable.account.stadate":`會計季度開始日期`,
"label.service.gantt.and.resourcestype":`和資源類型是`,
"label.ems.attachfiles":`添加附件`,
"label.data.expnode.e.desc1":`1、自訂匯出：使用者可以根據自己的需求選擇要匯出的欄位，以及進行篩選的條件。`,
"vue_label_systemSettings_analyse":``,
"label.project.all.date":`結束日期必須大於等於開始日期！`,
"vue_label_commonobjects_view_summary_basis":`匯總依據`,
"template.chart.yywjhdschd":`有機會的行銷活動`,
"vue_label_pool_notmeet":`不符合客戶要求`,
"label.attendance.manager":`考勤點管理`,
"vue_labenl_normal_current":`當前`,
"label.projectManagement.completed.quantity":`完成數量`,
"label.layout.testfield":`測試欄位`,
"label.customfields.selectcontainrelatelistlayout":`選擇應包含該相關列表的頁面配置`,
"label.fiji.time":`斐濟時間`,
"message.error.domain.already.exists":`域名已經存在`,
"label.accountandcontact":`客戶/聯絡人`,
"label.dashboardSetup.right":`右`,
"label.view.appliedMobile.xgry":`勾選此項，可在相關人員的首頁工作台看到該視圖`,
"label.file.share.all":`您公司中的任何使用者`,
"vue_label_pool_summary":`共{0}條數據,已在{1}重新整理`,
"label.emailtemplate.new":`新建郵件範本`,
"label.tag.manage.button1":`新增標籤`,
"label.data.exp.tempexppage":`資料匯出範本頁面`,
"font-trade-module-v1-invoice-total":``,
"label.folder.sort":`文件夾排序`,
"label.multilang.campaign.countnum":`{0}次`,
"label.homepagelayout":`主頁配置`,
"setup_layout_button_cancel":`取消`,
"lable.Search.in.QuickBook":`在quickbook中搜尋`,
"setup_fielddependency_label_pleaseclick":`請點擊“控制欄位”值進行編輯`,
"setup.fielddependency.label.pleaseclick":`請點擊“控制欄位”值進行編輯`,
"label.version.sum.field":`個自訂欄位`,
"label.form.is.submitted.successful":`表單提交成功提示`,
"label.campaignmember.main.batchaddmember":`批次添加市場活動成員`,
"label.sendemail.activity.newevent":`尊敬的#belongtoidccname您好：\r\n 您的同事#createbyidccname於#createdate給您指派了一個新的事件，內容如下：\r\n 主題：#subject\r\n 開始時間：#begintime\r \n 結束時間：#endtime\r\n 相關項：#relatedstr\r\n 內容：#remark\r\n 具體詳情，請存取此連結：\r\n #path\r\n #orgNameCRM系統`,
"label.knowledgebase.select.target":`請選擇目標`,
"setup.layout.label.buttonlist":`按鈕選擇`,
"pagecreator.page.label.pagedesc":`頁面描述`,
"label.version.professional":`專業版`,
"UG.Forcast.10":`完成`,
"template.chart.schdyqsr":`行銷活動預期收入`,
"front-filter-module-v1-quick-filter":`快速篩選器`,
"label.notification.group2":`您已成功加入公用小組`,
"label.ServiceCloud.statistics.by.serviceArea":`按照水平日期篩選服務預約`,
"label.validate.function.funcExplain.TIMENOW":`返回當前時間（時分秒）`,
"label.brief.lastmonth":`上月`,
"label.weixin.member.states":`會員狀態`,
"template.chart.ljxsje":`累計銷售金額`,
"label.eidt.queue.label.hasused2":`該佇列名稱已經被使用`,
"label.textmessage.nophonenumber":`此聯絡人沒有記錄的手機訊息`,
"label.task.new":`新建任務`,
"label.tabpage.grid":`網格顯示`,
"label.workbanch.setup.viewname":`視圖名稱`,
"front-gantt-module-temporary-tasks":``,
"label.reportTypeDescripe":`根據自訂報表類型，使用者能夠根據預定義物件、物件關係及指定的欄位建立報表。`,
"setup_layout_label_fieldlist":`可用欄位`,
"label.ggReleaseRange.searchforRole":`搜尋合作夥伴角色`,
"label.datamanage.account.field":`客戶欄位`,
"label_tabpage_groupingemptyz":`分組項目不能為空`,
"label.permission.edit.insertinfo":`輸入權限集訊息`,
"label.back_forms":``,
"vue_label_calendar_step_2":`第二步：選擇標準或自訂物件建立日曆`,
"lable.outlook.mcto.out":`排除的域`,
"label.workflow.accessnext":`如果滿足以下條件，則進入此步驟`,
"label.data.exp.temppage":`資料匯出及範本製作頁面`,
"label_tabpage_printview":`列印視圖`,
"vue_label_report_preview":`要查看最新編輯,重新整理預覽。`,
"frame_personinfo_label_personimage":`設定檔照片`,
"component.chatter.button.like":`喜歡`,
"label.ems.drafts":`草稿箱`,
"front-lightning-module-v1-details-page-chart-report-name":`報表名稱`,
"label.partner.workspace.login":`登錄頁面`,
"include":`包括`,
"label_length_20":`長度在20個字元以內`,
"component_event_button_save":`儲存`,
"label.weixin.recalculate.shared.success":`物件共享規則重新計算成功`,
"message.duplication.errorinscript.lessthan2":`必須選擇至少兩條要合併的記錄!`,
"label_my_forecast":``,
"label.ems.to":`收件人`,
"label_mobile_buttom_team_init":`群策使用者初始化`,
"label.sendemail.send.codeerror":`編碼轉換失敗，請使用正確的編碼`,
"lable.quote.syncing.and":`和`,
"label.campaignmember.selectmember.step1oftotal":`第1步，共2步`,
"label.ems.step3":`步驟3`,
"lable.PowerProcess.detail.message":`權利過程詳細訊息`,
"chatter.poll.option2":`選項2`,
"front-view-module-v12-verify-number":`數字格式錯誤，請檢查輸入的資料`,
"label.setup.mobile.homepageshortcuts.savesuccess":`行動端主頁快捷功能設定儲存成功`,
"lable.outlook.edit.zdyoutfi":`自訂 Exchange欄位名`,
"label.assignment.setup.newentries.inputentries":`輸入規則項目`,
"label.customfields.money.tip":`允許用戶輸入美元或其他貨幣金額，並將欄位自動轉換為貨幣金額格式。此功能在將資料匯出到 Excel 或其他電子表格時非常有用。`,
"label.service.appointmentList.cancelThePlan":`取消計劃`,
"label.chat.topic.suggest.add.topic":`無建議，添加您自己的主題`,
"vue_label_commonobjects_detail_tips":`小提示`,
"message.error.view.nameexists":`錯誤： 視圖唯一名稱已存在`,
"label_emailtocloudcc_step2_name":`配置郵件歸屬`,
"label.field.validation.apiname":`必須以字母開頭，只能包含大小寫字母，數字，底線，最大長度50，最小2位，且不能是資料庫的關鍵字`,
"page.field.masterinput.remark2":`例如：新建銷售訂單時，要在同一頁面內同時也錄入銷售訂單明細項，那麼就需要啟用此功能；（此功能非常適合主詳關係的物件使用）`,
"label.rule.enabled.successfully":`規則啟用成功`,
"label.role.createrolelist.tip":`以下是貴組織的角色列表。單擊角色連結可查看更詳盡的訊息。`,
"label.multilang.datamanage.dataimport.redundantmsg":`標題的長度是&nbsp;{0}&nbsp;,但是數據的長度是&nbsp;{1}&nbsp;,系統無法確定多了哪&nbsp;{2}&nbsp;個欄位。`,
"label.visualpage.staticresource":`引入靜態資源`,
"chatter.group.members01":`成員`,
"label.planned.workname":`作業名稱`,
"label.service.dispatchingUnits.gantt.data":`相符甘特表日期`,
"label.data.newtemplate.t.conditions":`範本條件`,
"label.accmarketsea.edit.title":`客戶公海池編輯`,
"label_chatter_priority":`優先級`,
"label_mobile_buttom_team_open":`啟用PC和APP群策`,
"front-gantt-module-no-tasks-available":``,
"component.newrecords.label.type":`儲存類別`,
"label.version.ccdocument.and.remark":`附件及備註`,
"label.martrixreport.step2":`步驟 2：選擇用於計算彙總訊息的分組方式`,
"label.projectManagement.Scheduleinformation":`時間表訊息`,
"label.emailmerge.mergeFolder.description":`在此頁中，您可以產生一個 Microsoft Word 文檔，包含您的聯絡人數據。請選擇郵件合併範本，最多可選20個。`,
"label.autoRegister.changepwd.setpwd.tip":`設置的密碼需要滿足以下幾個條件`,
"label.partnerCloud.orderingPlatform.shoppingEmpty":`購物車為空，請點選新增產品按鈕進行新增`,
"label.marketcloud_seminar":`市場雲研討會`,
"label.knowledgebase.no.results.knowledge.search":`Knowledge 中沒有"{a}"的結果`,
"label.createdate":`建立時間`,
"vue_label_systemSettings_bazaar":`市場`,
"report_type_label_contractPayment":`合約和收款`,
"label.myemailset":`我的電子郵件設置`,
"label.emailtype":`郵件類別`,
"label.appexchange.uninstallpage.message5":`永久刪除與此軟體包中自訂物件相關聯的任何關係和相關列表`,
"label.customerinfo.applicationlicencenum":``,
"label.product":`產品`,
"lable.opppdt.selPdt.subtitle":`產品選擇用於`,
"label_emailtocloudcc_step1_lead1":`Email to Lead`,
"label.multilang.recentview.query":`查看您最新的{0}`,
"label.cumstom":`自訂`,
"lable.product.pep":`請輸入價格`,
"label.suggestion":`意見`,
"vue_label_email_sentto":`已為`,
"label.email.cancel":`取消關聯後，將無法使用該信箱收發郵件，確認取消？`,
"component_timeline_label_1monthahead":`前1個月`,
"setup_mainpage_label_welcome31":`操作指導： 點擊本頁左側選單 → 管理設定 → 建立 → 應用程式`,
"label.weixin.settlement.rate":`收款達成率`,
"front-lightning-module-v1-details-page-chart-add-report":`· 最多新增4個報表圖表`,
"label_related_list_types":`lightning版本相關列表類型`,
"label.tabpage.converstatez":`已轉換狀態`,
"label.chatter.ok":`確認`,
"lable.SalesCommitmentKanBan.contractRate":`簽約達成率`,
"component.setup.label.setupsavefail":`組件設定儲存失敗`,
"label.email.form.text2":`【切換為"HTML"】`,
"UG.Lead.009":`APP通話記錄`,
"label.escalation.setup.newrule.title":`個案升級規則`,
"label.field.available.value":`可取到的欄位值有`,
"label.cannotuseaddtimetrigger":`<b>  添加時間觸發器按钮</b>在以下情况下不可用:<br/><ol><li>  規則條件設置為每次建立或編輯記錄時</li><li>  規則已啟用</li></ol>`,
"vue_label_chat_activefail":`開通失敗`,
"label.dashboard.show.total.percent":`顯示總數與顯示%請至少選一項`,
"label.schedulejob.setup.schedule.jobprg":`作業程式`,
"label.select.email.type":`請選擇郵件類型！`,
"chatter.group.allTheMembers":`所有成員`,
"label.webtab.validation.apiname":`必須以字母開頭，只能包含大小寫字母，數字，底線，最大長度20，最小2位`,
"label_partner_new_step3_name":`名稱`,
"vue_label_chatter_remove_member":`移除成員`,
"label.customobjects.majorobject.tip":`如果選擇非主詳關係物件，則匯總數據不走權限`,
"label.forecast.edit.kjjd":`會計季度`,
"label.reportsSubscriptionPage.schedulereport.monthly.week.three":`第三個星期`,
"label.weixin.senderror":`發送失敗`,
"label.visiturl":`連接URL`,
"label.apply.img.error":`圖中字元輸入不正確。`,
"label.been.detained":`重置折扣`,
"vue_label_helpcenter_dashboard2":`建立的儀表板內需要優先添加組件，選擇報表數據源或者列表視圖數據源。然後確定使用的圖表類型並選擇相應的分組和統計數據來製作圖表<br>&nbsp;&nbsp;&nbsp;&nbsp;添加完組件後，可以點擊儀表板的“重新排序”按鈕來將調整組件位置和大小。<br>&nbsp;&nbsp;&nbsp;&nbsp;如果需要給某些組件設定時間篩選的條件，即可點擊“篩選條件設定”來選擇組件設定該組件需要用於篩選的時間欄位，設定好後，即可通過儀表板的時間篩選，選擇對應的時間範圍來更新選中數據。<br>&nbsp;&nbsp;&nbsp;&nbsp;注意：一張儀表板最多支援10個組件。<br>2、組件的穿透與聯動<br>&nbsp;&nbsp;&nbsp;&nbsp;同一個儀表板內，組件A可以設定與它來自同一數據源的組件B和組件C作為它的聯動物件。設定完成後，點擊組件A的某一數據區，組件B和組件C會同時根據組件A的數據區條件進行數據的重新統計。<br>&nbsp;&nbsp;&nbsp;&nbsp;注意，點擊組件B或者組件C的數據區，並不會讓組件A進行數據的重新統計。如果需要達到這樣的效果，需要在組件B/C上設定組件A為它的聯動物件。<br>&nbsp;&nbsp;&nbsp;&nbsp;每一個儀表板內的圖表組件，數據都來自視圖或者報表。所以提供了一個穿透功能，即點擊組件的數據區可以跳轉到對應的報表和列表視圖。注意，如果原本的數據源失效，組件將無數據，穿透功能也將失效。<br>&nbsp;&nbsp;&nbsp;&nbsp;由於穿透和聯動都是點擊組件的數據區，所以二者不能同時生效，組件如果同時設定了穿透和聯動功能，那組件只能同時有一個功能生效，通過切換聯動和穿透狀態來更改生效的功能是哪個。`,
"vue_label_commonobject_view_notice_delete_false":`記錄{0}刪除失敗，原因為{1};`,
"label.weixin.newspaper.coverage.information":`保險單訊息`,
"label.you.do.not.have.permission.to.operate.":`您沒有權限進行操作。`,
"label.checkfield.match":`匹配`,
"message.custom.field.donotdelete.ref":`該欄位被其它欄位所引用`,
"label.version.maxsum":`，已達到上限！`,
"System.ChangeUser.Info.001":`更改擁有者成功，您沒有查看此記錄的權限，點擊後返回到上一個頁面。`,
"label.target":`目標`,
"template.dashboard.behavior.analysis":`行為分析`,
"label.login.verification.enter.prompt":`請輸入6位數字安全碼`,
"label.am":`上午`,
"chatter.emailSetUp.remark":`應用於CCChat頁面對人員的追蹤及對帖子的各種操作，選擇是否發送郵件的設置`,
"label.accmarketsea.grouplist.title":`客戶公海池分組設定`,
"label.stdashbord.xsld.business.danwei":`單位:萬元`,
"label.app.step1.error.namenull":`公用小組名稱不能為空`,
"label.login.button.verification":`提交驗證`,
"label_tabpage_newWizardz":`新增功能嚮導`,
"label.addattachment.step1.intruduce":`輸入文件路徑或點擊按鈕查找文件`,
"pagecreator.layout.funcpath":`/構建器/配置庫`,
"fourth":`第四個`,
"label.timetrigger.after.lasttime":`晚於最後修改時間1天`,
"vue_label_report_showme":`向我顯示`,
"label.h5.similar.opportunity.end.date.in":`結束日期在以下時間內`,
"label.turntonextstep":`轉到下一步`,
"label.icon.106":`日程`,
"label.user.receivenewsbulletin":`接收  新聞簡報`,
"label.mask.card.number":`信用卡號`,
"setup.object.layout.label.profileoptions":`可指派設定檔`,
"vue_label_systemSettings_obj":`物件及欄位`,
"label.call.center.history.open":`自動打開通話記錄頁面`,
"label.attendance.cityname":`請輸入城市名`,
"label.newemailnotice.tip":`建立一個電子郵件通知 以關聯一個或多個工作流程規則、審批流程。 如果更改電子郵件通知 ，任何修改都將應用到與之相關聯的所有規則、審批。`,
"label.app.step1.error.labelnull":`錯誤：標籤不能為空`,
"front-kefu-moudle-connect-free-account":``,
"label.biaoqingfaxian.description":`勾選了啟用標情發現，可在前端增加標情發現的選單，使用者可查看相關行業的標情訊息，並可將標情數據轉化為系統內的商機。`,
"label.filter":``,
"label.data.downpage.e.title.num1":`1、選擇要匯出數據的物件，或者選擇匯出全部。`,
"label.h5.similar.opportunity.last.months12":`最近9-12個月`,
"label.chatter.name":`名稱`,
"vue_label_helpcenter_email":`1、發送郵件<br>離開系統去您的信箱與聯絡人進行郵件往來已成為過去。在CloudCC上，關聯您的個人信箱，可以直接從CloudCC發送郵件，當您在收件人輸入信箱地址或名稱時，可為您模糊相符您的聯絡人或商機記錄。您還可以將郵件記錄關聯到已經配置好的相關記錄上，在記錄詳情頁會同步您發送的郵件。<br>2、發郵件時的4個常用功能<br>您在發郵件時可以使用郵件正文下方的4個功能，以此來輔助您的工作。<br>郵件追蹤<br>當您開啟郵件追蹤時，我們會幫您監聽此郵件被打開的次數以及最後被打開的時間，您可以將滑鼠懸浮在寄件匣列表“眼睛”圖示上查看。<br>上傳附件<br>點擊上傳附件，可以選擇已經上傳到系統中的文件，也可以選擇上傳文件。可以選擇多個附件，只要附件的大小小於20M。<br>插入合併欄位<br>當郵件關聯了某條物件記錄後，您可以單擊插入合併欄位，選擇關聯的物件，選擇您想插入的欄位，在合併欄位中逗號後邊輸入取代文本，例如{!Contact.FirstName,Sir or Madam}。儲存範本時，合併欄位將顯示於範本的電子郵件正文中。使用合併欄位個性化設計電子郵件的內容。可向任何合併欄位中添加取代文本。僅當合併記錄不包含該欄位的數據時，才顯示取代文本。<br>編輯並啟用簽名<br>當您在發送工作郵件時，一個能代表自己身份的簽名將有利於提高您的工作專業性。單擊“編輯簽名”按鈕，您可以編輯您的基本訊息，而且支援您插入圖片。如果您勾選“啟用簽名”，在每次寫郵件時郵件正文都會帶上您的簽名，您隨時可關閉簽名。<br>3、篩選收件箱<br>您可以在收件箱中篩選所有未讀的郵件，方便您處理工作。當您想通過郵件下載文件時，您可以在收件箱中篩選所有含有附件的郵件，這樣您能很快定位到您需要的郵件。除此之外，您可以通過篩選含有未關閉的機會的郵件或者篩選發件人來自於商機或聯絡人的郵件，快速瞭解您通過郵件來追蹤的系統內客戶的記錄。<br>4、群發郵件<br>在商機、聯絡人列表右上角有群發郵件的按鈕，您可以批次給含有信箱地址的商機或聯絡人記錄發送郵件。當您有行銷活動記錄時，您可以給行銷活動成員批次發送郵件，方便您發送活動邀請函。`,
"front-kefu-moudle-auto-callphone":``,
"label.fiscal.FQ":`會計季度`,
"label_tabpage_groupsVisiblez":``,
"UG.product.01":`列出產品/服務`,
"vue_label_commonobjects_view_members":`可選成員`,
"label.organization.id":`組織ID`,
"label.tyle_preview":`樣式預覽`,
"label.campaign.channel.input.to.owner":`6. 請設置成員簽到是否通知擁有者`,
"label.appointmentconfirmpage.wizard.notif1":`預約已經被取消`,
"lable.tianyancha.maping":`欄位映射`,
"front-kefu-moudle-v1-noadd-online-chats":`未新增線上座席`,
"vue_label_commonobjects_detail_group_strategy":`確定進入該客戶群策嗎？`,
"vue_label_report_deletegrouprow":`刪除組行`,
"lable.account.y.d":`此頁允許您定義一個自訂會計年度記錄。自訂會計年度的日期將根據您下面所進行的選擇產生。`,
"label.visualpage.lllegal.definitions":`非法的定義`,
"label.tabpage.enterrecordnamez":`請輸入記錄擁有者`,
"vue_label_report_howmuchlines":`{length}行`,
"homepage.components.custom":`自訂組件`,
"label.campaign.channel.upload.img":`上傳圖片`,
"UG_Case_03":`個案自動升級`,
"label.approved.receiveApprovalEmail.option4":`從不`,
"System.Data.Import.Warning.MaxCount":`您的組織每次只能匯入數據{0}條，現在已經超出，請調整後再次匯入。`,
"label.sent.sms":`發送一封簡訊`,
"vue_label_dashboard_statistictype":`統計類型`,
"label_report_last_year_same":`去年同期`,
"lable.Examle":`示例`,
"label.customerinfo.PageTriggerFagTitle":`兩小時才能同步一次`,
"label.mobile.phone.read":`批閱`,
"label.product.gopage":`跳轉到`,
"label.a_b_without":`A" 記錄可能有或沒有相關 "B" 記錄。"`,
"front-kefu-moudle-callin-missphone":``,
"label.sso.saml.sp.idsource.attrname":`屬性名稱`,
"label.h5.chatter.colleagues2":`同事`,
"label.approveprocess":`審批流程`,
"label.dataimport.error.name.null":`出現錯誤：name為空。`,
"label.paging.countitems":`{0}條`,
"vue_label_report_notice_filter":`不啟用進階篩選時，不同篩選，各個條件之間是“與”，也就是滿足1與2的共同特徵的記錄顯示到報表，例如：1為金額大於100萬的機會，2為預計簽約日期等於本月，則報表結果是本月大於100萬的機會。`,
"front-lightning-module-v1-dashborad-export-picture":`匯出圖檔`,
"label.activity.disabled":`沒有啟用活動，請聯繫系統管理員在版面配置上啟用活動歷史和未處理活動。`,
"message_chooseatleastonefield":`請至少選擇一個要顯示的欄位`,
"label.case.text":`通過網站送出的服務請求單可在系統內產生個案記錄，請選擇使用者作為個案記錄的建立人，選擇的使用者需要對個案物件具有建立權限。網頁適用於電腦和手機。`,
"label.sendmail.step3.dealoption1":`將每封郵件以密件形式副本給我`,
"label.forecast.settings.title.remark":`為使用者預計估測獲得收入的最佳估計值，這些預測可以為使用者提供一個完整的業務視圖`,
"label.apply.youxiaotime.finish.opperation":`有效時間5分鐘，請您儘快完成操作。如非本人操作，請忽略本簡訊。`,
"label.user":`使用者`,
"pagecreator.page.button.copy":`複製`,
"label.userinfo.pwdupdate.or.reset":`您的密碼上次更改或重置於`,
"label.fieldupdata":`欄位更新`,
"label.sendemail.chat.followsubject":`CloudCC CCChat 有人追蹤`,
"component_task_label_enddate":`到期時間`,
"label.campaign.channel.step6.remark5":`您可以通過商機分配規則進行重新分配，關於分配規則`,
"label.mr.title.mobilePhone":`手機`,
"label.notice":`提醒`,
"message.serviceappo.time.violation":`服務預約允許時間違規:服務預約的已計劃開始時間小於最早允許開始時間`,
"label.account":`客戶`,
"front-kefu-moudle-callcenter-user":``,
"label.usermanage.query.notexist":`查詢的使用者不存在`,
"label.forecast.userinfo.isnable":`允許預測`,
"label_partner_workspace_member":`成員`,
"vue_label_dashboard_penetrationsetting":`穿透設定`,
"chatter.fieldtrack.operatecreate":`已建立一條`,
"label_tabpage_tpcustomersz":`轉換商機`,
"label.emailtocloudcc.redmessage6":`IMAP/SMTP認證失敗，請檢查電子郵件地址與密碼是否正確`,
"label.customfields.file.upload":`上傳`,
"label.forecast.isforecast":`沒有啟用收入預測`,
"label_benchmark":`基準`,
"label.exchange.sync.state.system":`系統同步狀態`,
"UG.opportunity.003":`追蹤您的銷售通路 建立儀表板`,
"label.campaign.matchway.select.error":`要更新數據，請選擇匹配的方式`,
"vue_label_dashboard_located":`儀表板所在文件夾`,
"front-electronic-signature-enter-object":``,
"vue_label_systemSettings_mobelquick":`移動應用程式快速設定`,
"lable.outlook.list":`Exchange Sync配置`,
"label.sendemail.approval.dlsp":`您好,#dlspr：\n #actorname於#actordate提交的#objAPIName-#recordname因原審批人#spr設置您為代理審批人，正在等待您的審批，\n請點擊如下連結或者登錄CRM系統，進入審批中心進行審批：\n#url\n感謝！ \n#orgName`,
"label.service.deleteCustomView.wanttoremove.filter":`是否開啟`,
"component_task_label_newevent":`*狀態`,
"vue_label_commonobjects_view_chart_groupby":`分組依據`,
"front-kefu-moudle-v1-edit-chats":`編輯工作人員`,
"pagecreator_page_message_delete_fail":`頁面刪除失敗`,
"label.file.search":`搜尋文件`,
"label.projectManagement.Addpredecessors":`添加前置工作`,
"label_tabpage_norecordtypez":`不可用記錄類型別`,
"label.come.recycle.bin":`進入回收桶`,
"label.reportsSubscriptionPage.schedulereport.monthly.time.relative":`相對`,
"label.customfields.address.tip":`允許使用者選擇省、市、縣欄位，並且輸入具體地址訊息，可用於計算經緯度。`,
"label.weixin.optioneight":`選項八`,
"label.recordtypeselect.modify":`編輯記錄類型`,
"label.forecast.settings.future3":`未來3個週期`,
"label.rename":`重命名`,
"label.emailtocloudcc.button.complete":`完成`,
"chatter.new.at":`最新活動`,
"component.setup.label.milestonesfield":`里程碑欄位`,
"vue_label_commonobjects_detail_email_newaddress":`收件人郵件地址`,
"lable.PowerProcess.big.event":`重大事件：`,
"label.appexchange.uninstallpage.confirm":`是，我要移除此軟體，並永久刪除所關聯的組件`,
"label_mobile_buttom_homepage":`首頁`,
"label.sso.saml.idp.config.logouturl":`單一登出URL`,
"lable.quote.pdf.button.savetoquote":`儲存到報價單`,
"label.page.select.application":`選擇要在其中使用新自訂選項卡的自訂應用程式。也可以在每個自訂應用程式的詳細訊息和編輯頁面上檢查或修改是否顯示某個選項卡。`,
"chatter.down":`下載`,
"label.tabpage.searchz":`搜尋`,
"label.emailsync.form.action":`操作`,
"label.campaignmember.setup.campaignmember.field":`行銷活動成員欄位`,
"label.version.remark":`備註：免費版僅限5個使用者，可新建2000條記錄，不支援數據匯入與匯出。`,
"label.selectoperateobject":`選擇將要操作的物件`,
"label.appointmentdetail.wizard.title12":``,
"label.submitforapproval":`提交待審批`,
"label.the.lower.bound.of.each.layer.of.editing.discount.must.be.equal.to.the.upper.bound.of.the.upper.level.":`編輯折扣每1層的下界必須等於上1層的上界。`,
"label.appupload.install.component.view":`查看組件`,
"label.profile.customobjcontrol":`自訂物件權限`,
"label.customfields.configprofilefieldsafety.tip":`選擇希望通過欄位級安全性在其中賦予對此欄位擁有編輯存取權限的設定檔。如果您不將該欄位添加到欄位級安全性中，它將不在任何設定檔中顯示`,
"label.service.gantt.service.resources":`服務資源`,
"label.input.right.emailaddress":`請輸入正確的Email地址`,
"label.ccdocument.folder.notedit":`該文件夾不可編輯！`,
"label.data.choses.i.desc":`根據您的需要，選擇匯入單個物件的資料。`,
"label.icon.75":`汽車`,
"label.summaryreport.step4":`步驟 4：選擇報表列`,
"label.appupload.upload.install":`安裝`,
"label.reportlist.newfolder":`新建報表文件夾`,
"label.projectManagement.myproject":`我的項目`,
"label.true":`真`,
"label.tabpage.reallproplez":`記錄擁有者`,
"label.change.lead.share.error":`無編輯客戶權限`,
"F":`日期/時間`,
"lable.account.CurrentandNextCQ":`當前和下一個日曆季度`,
"UG.activity.06":`想跟進客戶`,
"UG.contact.03":`在一個地方追蹤聯絡人 銷售訊號`,
"label.field.duplicate.error.msg2":`獨有屬性設定失敗`,
"label.sales.dashboard.reality":`實際收款`,
"lable.PowerProcess.type":`權利過程類型`,
"batch.selected.data":`選中的數據條數`,
"#label.importsourcefilestep2":`步驟二：壓縮您的檔(可選)#`,
"label.emailtemplate.select":`請選擇您要使用的郵件範本`,
"chatter.most.w":`最多可以輸入500個字元!`,
"vue_label_calendar_new_object_calendar":`建立物件日曆`,
"label.aggregated_formsdata":`匯總表單資料`,
"label.knowledge.language.french":`法語`,
"label.customfields.enc.tip":`允許使用者輸入任何字母和數字組合,並將他們以加密格式存儲,不可搜尋。`,
"label.icon.158":`雲`,
"font-evaluate-module-v1-bad-review ":``,
"UG_quota_03":`報價範本`,
"label.eidt.queue.label.hasused":`該標籤已經被使用`,
"label.lookupfilter":`查找篩選器`,
"label.callcenter.Instance.name":``,
"label.commitertype":`提交人類型`,
"vue_label_checkduplicate_any_one":`滿足任意一條`,
"label.campaign.channel.input.img":`請從本地計算機選擇圖片做為感謝頁面`,
"vue_label_dashboard_pleaseenterafoldername":`請輸入文件夾名稱`,
"label.tianyancha.look":`查看`,
"label.tabpage.lastone":`至少選擇一條操作`,
"label.sendemail.approval.submit.title":`{!objLabel} - {!recordName} 等待您的審批`,
"label.chat.topic.delete.prompt1":`刪除主題需要花費時間，直到過程完成，主題將繼續在帖子和記錄中保留。`,
"component_setup_label_displaybutton":`顯示按鈕`,
"label.partnerCloud.backgroundImage":`背景圖檔`,
"label.mobile.phone.time.range":`時間範圍`,
"label.page.url.address.remark":`在“連結URL”欄位中輸入網頁地址。可以簡單的輸入URL地址，如同在瀏覽器中顯示的樣式；也可使用一個或多個合併欄位將組織的特定數據從CloudCC插入URL參數中。由於瀏覽器安全設置，或者因為站點阻止顯示在框架中，一些站點可能在Web選項卡中無效。`,
"label.h5.copyemail":`郵箱已複製`,
"label.view.step3":`步驟3.選擇要顯示的欄位`,
"label.quickbooks.view.moneyreceived":`收款`,
"label.emailobject.attachment.preview":`預覽`,
"label.selectapprover":`選擇審批者`,
"vue_label_normal_opportunity_sf":`機會`,
"label_emailtocloudcc_filed_port":`埠`,
"mesage.errorinsaving":`儲存過程中出現錯誤,請聯繫管理員`,
"label.partnerCloud.partnerCloudName":`請輸入夥伴雲名稱`,
"lable.edit.queue.checkemail":`錯誤：電子郵件地址無效。`,
"label_builder":`頁面構建器`,
"component_setup_label_setupsavefail":`組件設置儲存失敗`,
"label.icon.76":`汽車`,
"label.reportsSubscriptionPage.schedulereport.monthly":`每月`,
"message.nopermession":`權限不足`,
"label.view.groupscansee":`某些<b>使用者組</b>可視`,
"label.leadscore.rule.new":`商機評分：新建規則`,
"label.new.ccpeakfolder.time":`定時類：新建檔夾`,
"label.record":`記錄`,
"message.error.flabel":`欄位標籤不允許含有英文單引號和雙引號`,
"label.emailobject.emaildetail.promptbutton2":`取消`,
"label.h5.phone":`電話`,
"label.visualpage.error.deal.with":`發生錯誤，請聯繫管理員處理`,
"label.button.step1.select.field":`步驟1：選擇欄位`,
"label.setsharerule.step1":`第一步：選擇將要設置的規則類型`,
"component.chatter.file.label.title":`文件上傳`,
"front-epwechat-module-v1-appname":`應用名稱：`,
"chatter.error.notsel":`錯誤:請先選擇要上傳的圖片!`,
"label.updatevalue":`要更改的確切值`,
"label.chatter.sendEmailToGroupMember.subject.D":`{0}在小組{1}發布了全員檔案`,
"label_tabpage_grid":`網格顯示`,
"homepage.components.standard":`標準組件`,
"label.movable":`活動`,
"label.report.selected.field.cannot":`選中欄位不能超過50個`,
"label.projectManagement.distribution.by.excess":`按超過指派`,
"addrow":`添加行`,
"label.approvaldatamove.p":`使用下面的選項管理多個等待批准的請求。要想開始，篩選批准請求記錄，然後單擊“查找”。顯示結果列表時，指定要執行的操作。`,
"label.passwordPolicy.setup.title":`密碼策略`,
"label.appointmentpage.wizard.title1":`{0}（{1}）邀請你`,
"label.tippage.li1":`永久刪除自訂報表類型`,
"label.campagin.roi.dcl":`到場率`,
"label.h5.new.errorbody":`請填寫全部帶有*標記的的必填欄位`,
"label.cy.enable":`幣種啟用`,
"label.currency.rate.e":`編輯貴組織使用的幣種之間的兌換率。`,
"or":`或`,
"lable.custom.Previous.CYt":`前兩個自訂年度`,
"front-epwechat-module-v1-unbound-desc":`解除綁定之後，綁定帳號將被清空，確定解除綁定嗎？`,
"pagecreator_button_publish":`發佈`,
"font-evaluate-module-v1-case-owners":``,
"label.pw.new":`請輸入新密碼`,
"message.tabsearch.nokeywords":`請輸入至少一個字元長度的關鍵字`,
"label.sendemail.send.erroruser":`錯誤的使用者`,
"label.personalinfo":`我的個人訊息`,
"label.case":`個案`,
"lable.product.pricebooks.now":`現有價格手冊`,
"label.ccpeak.take.notice":`注意：ID，自動編號，建立人，建立時間等系統欄位不需要賦值！`,
"label.page.first":`第一頁`,
"label.icon.168":`景點`,
"label.choices":`选择`,
"label.is.delete.document":`是否刪除該文檔？`,
"homepage.layout.custom":`自訂設定`,
"label.emailobject.template.insert.field":`插入欄位`,
"label.ccpeak.folder.all":`所有類文件夾`,
"front-console-conversation-btn3":``,
"label.ems.port":`埠號`,
"label.app.introduce":`應用程式"是指作為一個單位提供功能的一組選項卡。使用者可以在每個頁面右上角下拉選擇應用程式，選單會在不同的應用程式直接切換"`,
"label.file.library.managemembers.admin":`文檔庫管理者`,
"vue_label_salesadvance_win":`贏單`,
"label.email.click.complete.info":`單擊"完成"按鈕，返回上一頁`,
"label.umeng.activity.event.willbegin":`您的事件#event即將在#time後開始`,
"label.mobile.phone.week.summary":`本週總結`,
"label.quickbooks.fieldlabel.terms":`條款`,
"lable.currencyManage.advcurrencyEnabled.dis":`您可以將貨幣兌換率匯率對應到特定的日期範圍內的過期匯率。過期匯率用於機會、產品和這兩個物件相關的報表。`,
"label.weixin.data.save.failed":`資料儲存時失敗`,
"label.service.gantt.filter.logic":`篩選器邏輯：`,
"vue_label_pool_adopt":`領取`,
"label.emailobject.markasunread":`未讀`,
"label_please_select_a_member":`請選擇成員`,
"label.salescloud.unit.ci":`單位（個）`,
"vue_label_pool_obsolete":`已廢棄`,
"label.cancelall":`取消全選`,
"label.exchange.sync.state.setting.m2":`已啟用 CloudCC Exchange 配置中的使用者：`,
"vue_label_pool_claimtime":`認領時間`,
"label.forecast.forehistory.history":`的預測歷史`,
"label.knowledge.article.record":`知識文章不符合要求`,
"label.setting.intergrationlist.button.uninstall":`移除集成`,
"label_tabpage_gotit":`知道了`,
"label.data.exp.csvform":`只針對匯出資料有效`,
"UG.Forcast.06":`請選擇允許預測的使用者`,
"vue_label_report_savereport":`儲存報表`,
"setup.object.field.dependency.label.mustone":`請至少設定一個相依欄位的值`,
"label.batchadd.newbatchpage.des1":`記錄的name欄位為必填項，若未填寫，則該條數據預設不被儲存`,
"lable.custom.CurrentandPreviousCYt":`當前和前兩個自訂年度`,
"label.versiontype.Professional":`專業版`,
"label.customfields.configprofilefieldsafety":`配置設定檔欄位的安全性`,
"label.ccpeak.wgd.time":`未歸檔的定時類`,
"component.telerecord.label.subject":`主題`,
"label_year":`年度`,
"pagecreator_layout_label_modifylayout":`配置編輯器`,
"label.compact.layout.frame.splitline":`----左右並列線----`,
"lable.PowerProcess.enter.the.process":`{describeName}進入過程`,
"label.emailobject.cc":`副 本：`,
"front-electronic-export-choseCount":``,
"label.setup.mobile.bottombutton.recovery.default.success":`恢復預設成功`,
"label.datamanage.import.accountfield":`在下表中，選擇匯入文件中應匯入到每個客戶的欄位。完成操作後，點擊下一步：`,
"vue_label_opportunity_related_list":`添加到相關列表`,
"label.group.recent":`最近查看小組`,
"vue_label_pool_finalclaimtime":`最後認領時間`,
"vue_label_homepage_30daysnocontact":`30天未聯繫的機會`,
"label.tianyancha.field.error":`未找到天眼查欄位，請聯繫系統管理員先執行初始化操作`,
"label.product.go":`轉至報表`,
"label.customsetting.manage.introduce":`如果自訂設置是列表，單擊"新建"添加一組新數據。例如，如果應用程式具有國家代碼設置，則每組可能包括國家的名稱和電話代碼。`,
"label.task.dateadd":`加`,
"label.email.recipients.select":`請選擇收件人`,
"chatter.emailListMyChat":`對我的微貼或回覆點喜歡時`,
"label.batchadd.newbatchpage.save.name":`如果名稱為空，系統將預設不添加此條記錄，請確保您的名稱不為空再儲存`,
"UG_Lead_011":`建立一個線索`,
"vue_label_salesfunnel_notice2":`進行中機會總數量`,
"APPIntegration_Social_linkedinerror":`必須是一個合法的linkedin.com的URL`,
"label.industrialandcommercialverification.enablestatus2":`客戶名稱即時查詢`,
"label.stdashbord.xsld.business.ajssx":`角色篩選`,
"lable.info.queue.showalluser":`查看所有使用者`,
"label.generatepage.c1":`必須以字母開頭，只能包含大小寫字母，數字，底線`,
"label.thenset":`然後按`,
"label.salescloud.salescloud.defaultteam":`?使用者的預設機會小組`,
"label_partner_workspace_tab_selectedoption":`已選選項卡`,
"label.tippage.li":`刪除自訂報表類型將會：`,
"lable.quote.syncingfrom.syncingto":`業務機會產品已同步到報價單明細。`,
"label.emailobject.delete":`刪除`,
"label.data.selectimportobject":`選擇需要匯入的物件`,
"label.knowledge.language.dutch":`荷蘭語`,
"message.campaign.page.overtime":`該頁面已過期`,
"label.ccchat.message.search.desc4":`檢查搜尋詞的拼寫。`,
"label.login.forgetPsd":`忘記密碼`,
"vue_label_title_order":`訂購`,
"template.report.contract.follow.status":`合約的跟進狀態`,
"label.forecast.edit.kjnd":`會計年度`,
"front-electronic-export-listTitle":``,
"label.dataimport.error.khmc.notnull":`出現錯誤：客戶名稱不能為空。`,
"label.testobject":`測試物件`,
"label_chatter_nextStep":`後續步驟`,
"label.file.public.link.share":`公用連結共享`,
"label.weixin.organization.name":`組織名稱`,
"label.quote.email":`電子郵件`,
"label.reg_field":`常用欄位`,
"font-evaluate-module-v1-response":``,
"label.chatter.sendmail":`發送電子郵件`,
"label.weixin.start.incorrect":`開始日期格式不正確`,
"component_chatter_link_label_url":`連結URL`,
"vue_label_pool_operatecertification1":`{0}{1}{2}`,
"lable.currencyManage.Enabledadvcurrency.agree":`是的，我要啟用進階貨幣管理。`,
"label.east.africa.time":`東非時間`,
"label.product.proof.Three":`請在{0}處，最少選擇{1}個產品選項，最多選擇{2}個產品選項。`,
"label_emailtocloudcc_filed_password":`信箱密碼`,
"component.task.label.person":`*被指派人`,
"pagecreator_systemstyle_label_buttonareacolor":`操作區顏色`,
"label.clearrule":`清空規則`,
"lable.customer.access":`客戶存取權限`,
"label.finish.wait":`已處理您的請求，需要等待系統處理完成，請隨時注意查看您的電子郵件。`,
"label.weixin.appr.auditor":`審批人`,
"label.tabpage.systemz":`個系統`,
"label.file.nocan.process.desc":`無法處理請求 我們無法處理內容傳遞`,
"label.relationobject.name":`相關物件名稱`,
"setup.layout.group.relatedlist":`相關列表`,
"label.generatepage.title":`Web To Cloudcc 頁面`,
"label.page.step3.input.url.information":`步驟3：輸入URL詳細訊息`,
"label.change.to":`更改市場活動成員狀態至`,
"label.validate.function.funcFormat.TIMEVALUE":`TIMEVALUE(date)`,
"label.partnerCloud.seriesSettings":`產品系列設定`,
"component.timeline.label.1monthahead":`前1個月`,
"label.batchadd.senumberpage.selnum":`選擇要添加記錄數目`,
"label.downloadapp":`下載App`,
"label.dashboardSetup.showmainpage":`首頁顯示`,
"label.h5.nophoneprompt":`該同事沒有輸入聯繫電話`,
"label.service.deleteCustomView.wanttoremove.theFilter":`是否置頂`,
"label.appupload.state1":`已上傳`,
"component_timeline_button_filter":`篩選`,
"label.passwordPolicy.setup.subtitle":`設置應用於所有使用者的密碼限制和登入鎖定策略`,
"vue_label_normal_quote_sf":`報價單`,
"label.productsales.today.noevttskaddall":`今天沒有未處理的事件或者到期的工作，您也可以點擊右上角的“ ”添加工作或者事件！`,
"label.projectManagement.no.end.date":`暫無結束日期`,
"label.sendmail.batch.chosetemplate":`批次發送電子郵件：選擇範本`,
"serviceterritorymember.serviceresource.isactive.notactive":`此服務資源未啟用，您可以將服務區域指派到已啟用的服務資源上`,
"label.notification.event.overlapEvent.continue":`繼續建立`,
"label.appupload.component.type.obj":`自訂物件`,
"label.partnerCloud.financeSetting.basicConfiguration":`獲取路徑：公眾平台-開發-基本配置`,
"lable.outlook.detail.info":`Exchange Sync配置詳細訊息`,
"vue_label_commonobjects_detail_activity_commingevents":`擁有即將進行的事件`,
"coderules.nullvalue2":`產生失敗,請給產生規則中使用的【{0}】,【{1}】錄入值`,
"label.version.sum.workflowrule":`個工作流程規則`,
"label.sso.saml.idp.config.enable":`啟用身分識別提供者`,
"label.temp.exp.conf":`確認要匯出範本嗎？`,
"label.department":`部門`,
"label.trigger.operation.email.template":`獲取郵件範本訊息`,
"label.page.content.frame.height":`內容幀高度（像素）`,
"label.ServiceCloud.jinengyaoqiu":`技能要求`,
"PageLayout.Search.MultiSearch.001":`您最多只能選擇不超過3個欄位。`,
"label.error500":`哎呀！出錯了...<br />快去找系統管理員吧...`,
"label.appexchange.download.stop":`遇到衝突，停止安裝`,
"label.service.dispatchingUnits.left.right.totalAll":`當前{left}-{right}條數據，共{totalCount}條數據`,
"label.tabpage.haschangedz":`該商機已經轉換`,
"label.industrialandcommercialverification.button.cancel":`取消`,
"label.edit.role":`修改角色`,
"label.mr.descreption.condition2":`規則-按前幾個字元：請輸入數字，按輸入數字的前幾個相同字元查詢重複數據。`,
"label.testgrammer":`檢查語法`,
"label.age":`年齡`,
"lable.real.time.chat":`即時聊天由環信提供技術支援，您可以直接在環信中配置進階設定。`,
"vue_label_opportunity_selected":`已選擇{sum}個`,
"label.weixin.optionone":`選項一`,
"label.file.delete.public.link.desc":`刪除公用連結表示沒有人可以存取帶有該URL的文件。如果您建立新公用連結，將成為不同的URL。`,
"label_tabpage_cancel":`取消`,
"template.report.opportunity.analysis":`機會階段分析`,
"label.escalation.setup.newrule.inputrule":`輸入規則名`,
"label.ccpeak.getapi.name":`取記錄值的時候直接get欄位的API名稱：`,
"second":`第二個`,
"label_tabpage_uploadsz":`上傳`,
"label.description":`備註`,
"label.ccchat.person.invite.notsamepwd":`密碼不一致`,
"label.mobile.app.isEnableAblumWatermark":`簽到時從手機相簿選擇的照片增加浮水印`,
"vue_label_allsearch_searchable_items":`可搜尋項`,
"lable.outlook.detail.react":`最近的活動`,
"label.sales.team":`銷售小組`,
"label.guif.standard.time":`波斯灣標準時間`,
"label.emailobject.emaildetail.button.forward":`轉發`,
"label.refused":`已拒絕`,
"homepage.components.one":`步驟1：填寫自訂組件名稱`,
"day":`日`,
"label.dataimport.error.number":`出現錯誤：數字`,
"label.customer.tab.step2.same.option2":`預設關閉`,
"component_button_ok":`確定`,
"label.allrecordmeetprocess":`所有記錄都應進入此步驟`,
"label.version.onefile.size":`單個附件上傳大小`,
"label.partnerCloud.orderingPlatform.allProducts":`全部產品`,
"pagecreator.page.message.publish.success":`頁面發佈成功`,
"lable.currencyAdv.exchagecurrency.rate.pro":`上一個範圍`,
"label.attendance.persons":`適用人員`,
"label.send.an.email":`發送電子郵件`,
"registration.page.browser.title":`行銷活動營銷通路註冊`,
"label.importfilestep3":`步驟二：選擇並上傳您的文件`,
"lable.currencyAdv.exchagecurrency.rate.next":`下一個範圍`,
"label.ems.no.sync.msg":`您還沒有配置郵件同步訊息.`,
"label.total_views":`表單送出概覽`,
"label.knowledge.article.notnull":`選擇至少一篇文章。`,
"message.error.view.lastview.delete":`不能刪除最後一個公共列表視圖</br>您不能刪除所有使用者皆可視的最後一個列表視圖<br><br>`,
"label.integrations.second.half":``,
"vue_label_systemSettings_mobelparams":`行動端參數設定`,
"message.choose.maximum":`共享訊息最多選擇150，現已選擇`,
"vue_label_homepage_won&unprocessed":`已贏單 未處理`,
"UG.contact.01":`如何充分利用您的聯絡人?`,
"label.data.import.setup.remark":`系統管理員可以對資料匯入時執行的規則進行設置，包括是否執行驗證規則、觸發器、查重過濾器`,
"pagecreator_layout_message_delete_success":`配置刪除成功`,
"lable.account.name":`會計季度名稱`,
"label.userinfo.must.updatepwd":`基於安全原因，您現在必須更改密碼。`,
"label.mobile.phone.subordinate.setup":`不可設置是否包含下屬，請選擇擁有者並設置他允許預測`,
"label.monitorsys.delete.date":`日期`,
"label_emailsync_form_emailaddress":`信箱地址`,
"label.projectManagement.cancelled":`已取消`,
"label.partnerCloud.partnerAccount.rechargeAmount":`儲值金額要在0.1到100000000之間`,
"label.select.relatedlist.approval.layout":`選擇要在批准頁面配置上顯示的相關列表`,
"label.userphoto.thumbnail":`縮圖`,
"label.assignment.setup.list.rulename":`規則名稱`,
"label.emailtemplate.usemergefields":`郵件範本中使用合併欄位`,
"label.tabpage.enabletomobile":`是否啟用到行動端`,
"setup_layout_label_desc":`降序`,
"vue_label_pool_abandonreasondiscription":`廢棄原因描述`,
"label.ems.outputmails":`發送郵件伺服器（SMTP）`,
"font-evaluate-module-v1-evall":``,
"front-epwechat-module-v1-unbound-tips":`解除綁定後您的以下資料都會被清除：`,
"label.weixin.number.data":`條數據`,
"front-objectTemplate-V1-UseObject":`適用物件`,
"label.call.center.configuration":`Call Center 設置`,
"vue_label_systemSettings_website":`網站版客戶服務入口網頁`,
"lable.currencyAdv.foreverdate":`永久日期`,
"label.globalselect.view":`查看選項列表值集`,
"component_newrecords_label_title":`最近記錄`,
"component_assistant_label_title":`助理`,
"label.equals.deletebut.bulk.delete":`包括刪除按鈕，批次刪除(回收桶)`,
"label.field.duplicate.error.msg4":`錯誤：無效數據。`,
"label.input.right.date":`請按正確的日期格式輸入`,
"file.error.notsel":`錯誤:請選擇要上傳的文件`,
"label.customcomponent.page.add.title":`新建自訂組件`,
"message.chooseatleastthreefield":`至少選擇三個欄位`,
"label.dataimport.system.unnecessary":`，系統無法確定多出了哪`,
"message.login.wrong":`用戶名或密碼不正確！`,
"label.appupload.install.recheck":`重新檢查`,
"label.ems.option":`選項`,
"label.wei.subject.img":`主題圖標`,
"chatter.emailReceiveOrNotAccept":`勾選接收CCChat提醒，取消勾選不接收。`,
"label.icon.46":`爐`,
"label.newpw":`新密碼`,
"font-evaluate-module-v1-praise":``,
"label.help.user":`使用者指南`,
"label.callcenter.no.searchs":`沒有相關查詢到訊息`,
"UG_homepage_007":`從發送跟進郵件到銷售活動自動化，從使用我們的藍圖科技建立工作流到觸發定製的巨集，自動化日常工作，並更專註於建立關系。`,
"label.saveandnew":`儲存並新建`,
"component_salesperformance_label_70finish":`已結束-未處理（>70%）`,
"lable.account.dp":`此頁允許您定義自訂會計年度。`,
"label.notification.serviceappointment.injeopardy":`}處於危險狀態，請盡快處理`,
"label.workflow.edit.esimaterule":`錯誤：當該規則還具有關聯的時間觸發器時，您不能將評估條件更改為“每次建立或編輯記錄時”。`,
"label.partnerCloud.basicSetting.feature":`功能設定`,
"label.sms.companyname.gm.infor":`創明網路簡訊接口訊息`,
"vue_label_homepage_components":`請選擇組件`,
"label_chatter_allactivity":`所有活動`,
"label.quickcreate.title":`快速新建配置`,
"label.tabpage.exclusivez":`不包含`,
"front-service-cloud-transfer-desc":``,
"label.data.downpage.i.list.desc1":`在匯入的過程中，因為資料格式不正確，或者因為觸發器或驗證規則校驗失敗，而未成功匯入的資料，都會產生csv文件顯示在當前頁面。而成功匯入的資料，則不會在當前頁面顯示。`,
"template.report.individual.case.status":`個案狀態`,
"label.report.export.file.format":`格式：Excel 格式.csv`,
"vue_label_filternotice1":`即同時滿足每個篩選條件，例如：1為金額大於100萬的機會，2為預計簽約日期等於本月的機會，則篩選結果顯示本月大於100萬的機會；當<spanstyle="color:red">啟用進階篩選</span>時，需要手動篩選條件寫入進階篩選框中`,
"label.lead.score.confirm1":`評分過程可能需要花費較長的時間，一旦評分完成，您會收到一份確認郵件。`,
"label.scores":`分`,
"label.dashboard.message.mainnoset":`主頁儀表板沒有配置`,
"label.customfields.optionlist.fieldvaluelist":`在下面為選項列表欄位輸入一列值，每個值應單獨占一行`,
"label.autosearch.title":`自動完成標題搜尋`,
"label.knowledge.setting.hint.seventeen":`建立一些文章`,
"label_tabpage_closez":`關閉`,
"label.partnerCloud.orderingPlatform.shoppingCart":`購物車`,
"label.recalculate":`重新計算`,
"label.umeng.approval.approvalmes4obj":`#obj物件裡有#numsucc條審批成功，#numfailed條審批失敗，`,
"label.appointment.wizard.subtitle2-2":`至`,
"label.validate.function.funcExplain.AND":`檢查是否所有參數均為真，如果所有參數均為真則返回TRUE`,
"label.recordtype.batchaddattachments.remark":`步驟 1.選擇文件； 步驟 2.是否歸檔文件； 步驟 3.單擊“開始上傳”按鈕，上傳文件； 步驟 4.單擊“完成”按鈕，返回上一頁`,
"label.reportlist.findreport":`查找報表`,
"label.partnerCloud.financeSetting.enterAppsecret":`請輸入Appsecret`,
"label.campagin.roi.query2":`查詢市場活動營銷渠道ROI`,
"label.sendmail.notice.immediately":`立即發送郵件通知`,
"label.file.library.managemembers1":`管理成員`,
"label.forecast.customforecast.foredis.yclb":`預測類別`,
"label.no.target.model.available.":`無可用目標模型。請先建立目標模型，也可聯繫系統管理員。`,
"label.quote.contactname":`聯絡人姓名`,
"label.customer.tab.step2.same":`將選項卡的可視性應用到所有設定檔`,
"UG_product_03":`多幣別支援的價格手冊`,
"label.pc.system.prompt":`系統提示`,
"homepage.components.description":`組件描述`,
"front-email-payment-safety-code":``,
"label.the.extra.reward.group.describes":`添加報價行組描述`,
"label.isEnableVisualpage.new.rightlist":`已啟用的自訂頁面`,
"label.icon.84":`變壓器`,
"label.chat.message.to":`收件人`,
"lable.product.pricebooks.edit":`價格手冊編輯`,
"label.partner.workspace.member.belong":`屬於`,
"pagecreator_systemstyle_message_delete_success":`樣式刪除成功`,
"label.salescloud.teamrole.message.chooseatleastone":`請至少選擇一個使用者`,
"label.knowledgebase.self.window":`同一視窗`,
"label.product.cost":`銷售底價`,
"label.imgfield.remove":`清除圖片`,
"label.event.lastweek":`上週`,
"template.report.today.statistics":`本日銷售統計`,
"label.emailobject.recipients":`收件人 （{0}）：`,
"vue_label_commonobjects_view_successfully":`設定預設視圖成功`,
"label.uploadfail.typeerror":`上傳失敗,圖片格式錯誤!`,
"vue_label_lead_required_fields":`請填寫必填項`,
"front-console-reopen":``,
"message.layout.unique.relatedlist":`違反頁面配置中相關列表的唯一約束，請確認後重新儲存!`,
"label.emailobject.emaildetail.nextactivity":`接下來的活動`,
"label.publicgroup.save.error":`錯誤：下麵的某個小組已是此小組的父級`,
"label.editdefaultshare.tip":`在下面編輯您整個組織範圍內的共享預設設置。更改這些預設設置將導致重新計算所有共享規則。根據貴組織中的數據量，這可能需要耗用大量系統資源和時間。`,
"label.icon.53":`車`,
"label.exchange.sync.state.setting.m3":`帶有已連結 Microsoft Exchange 和 CloudCC 電子郵件地址的使用者：`,
"label.currency.enable":`幣種：啟用幣種`,
"component.timeline.label.past":`過去活動`,
"workflow.action.tasks.assignortype.user":`使用者`,
"setup_layout_label_relatedlistsetup":`相關列表設置`,
"label.systemadmin":`系統管理員`,
"label_tabpage_allz":`所有`,
"label.ems.subject":`主題`,
"message.recordtype.selectlayout.tip":`選擇具有此設定檔使用者將看到的此記錄類型的記錄採用的頁面配置。儲存後，選擇此記錄類型的可用選項列表值。`,
"label.current.version":`當前程序版本`,
"label.sourceoffile":`未翻譯的語言檔：未翻譯的語言檔`,
"label.file.versionerror":`請在新版介面中使用文件選項卡功能`,
"label.validate.function.funcExplain.MINUTE":`返回日期/時間欄位中的分鐘數`,
"abel.setup.mobile.bottombutton.profile.setting":`定制設定檔底部選單`,
"label.recycle.dis.tip3":`從下拉列表中選擇我的回收桶能查看您刪除的數據。管理員使用者可以選擇查看全部回收桶。`,
"message.selectnothing":`未選取任何內容`,
"label.develop":`開發`,
"label.tab.lightningpage":`Lightning 版本頁面`,
"label.chat.micropost.share.info":`共享`,
"label.block.pricing.editor":`分塊定價編輯器`,
"label.ccchat.file.unavailable":`剛剛`,
"label_component_helper_businesschange_0UntreatActivity":`無未處理活動的機會`,
"label.search.setup.obj":`最多可設置100個物件`,
"component.setup.button.cancel":`取消`,
"message.longtextareamaxlength":`長度不能超過32000`,
"vue_label_chat_removedby":`你被“管理員”移出了群聊`,
"label.autoRegister.changepwd.setpwd.tip.morechar":`不能少於8個字元`,
"label.informassigner":`通知被分配人`,
"font-evaluate-module-v1-not-received":``,
"label.trigger.triggertime":`觸發時間`,
"label.attendance.cannot.make":`無法標註`,
"label.shouldallrecords":`此計算應包括所有的記錄`,
"label.eidt.queue.alter1":`請選擇佇列成員`,
"L":`選項列表`,
"label_emailtocloudcc_filed_email":`信箱`,
"label.productsales.contract.badversion":`您當前的版本不支援合約物件無法查看合約業績`,
"label.tabpage.operation":`操作`,
"label.file.copy.public.link":`已複製該公用連結`,
"label.all.SMS":`全部簡訊通知`,
"UG_opportunity_008":`機會小組`,
"UG.Campaign.002":`規劃、執行並監控行銷活動的效果。`,
"label.jiandangfenpei.title":`設定檔分配`,
"pagecreator.systemstyle.message.delete":`是否刪除當前所選樣式？`,
"lable.outlook.mcto.repeat":`如果找到重複記錄，則將電子郵件關聯到`,
"label.user.field":`使用者欄位`,
"vue_label_commonobjects_detail_market_hierarchy":`市場層級結構`,
"label.ems.emails":`信件`,
"label.tabpage.deleteviewfailed":`視圖刪除失敗`,
"label.data.exp.new.expobjtemp":`製作匯出物件範本`,
"label.useformulassetval":`使用公式設置新值`,
"label.service.newBuildDialog.six.fields":`最多選擇六個欄位`,
"error":`錯誤`,
"template.chart.sdyyfx":`掉單原因分析`,
"label.icon.191":`鬍子`,
"label.app.step3.tabused":`選定的選項卡`,
"label.user.level":`使用者級別`,
"label.custombutton.querydata.notexist":`查詢的數據不存在`,
"label.executestate.calculating":`計算中...`,
"label.visualpage.folder.notdel2":`1、當前文件夾中含有文件，無法刪除！ 2、當前文件夾中含有隱藏文件，無法刪除！隱藏文件是根據邏輯刪除物件（設置-建立-物件下已刪除的物件）建立的文件，因該物件未真正刪除所以隱藏此文件。`,
"vue_label_report_conditiondesc_three":`您將在滿足所有條件時獲得通知`,
"approval.request.email.subect":`審批請求`,
"label.log.user.value":`請輸入查詢用戶名!`,
"label.isCompanyCurrency":`公司`,
"label.related.2018":`相關列表`,
"label.tonga.time":`東加時間`,
"message.actionfailed":`操作失敗`,
"label.’s":`的`,
"label.custombutton.queryobj.notnull":`查詢的物件ID不能為空`,
"label.list.userinterface.setup":`使用者界面設置`,
"front-kefu-moudle-v1-yxgsbzq-reinput":`信箱格式不正確，請重新輸入`,
"label.chatter.content":`內容`,
"label.projectManagement.Addnotes":`添加備註`,
"label.service.newBuildDialog.reservation":`顯示預約`,
"label.ccchat.pm":`下午`,
"vue_label_chat_cannot_invite_users":`非群主不能邀請使用者加入群聊`,
"label_partner_workspace_member_belong":`屬於`,
"label.task.modify":`編輯任務`,
"label.tabpage.transformationsz":`轉換`,
"label.new.password.no.indexof":`新密碼不能包含中文和空格`,
"label.ji.quarter":`第{a}季度`,
"label.sso.isActiveNo":`否`,
"label.mobile.phone.week.report":`週報`,
"label.email.template.please.select.folder":`請選擇檔案夾`,
"label.pc.ui.2018.tab.groups":`選單組`,
"label.h5.approval.status":`審批狀態`,
"setup.mainpage.label.welcome27":`CloudCC 雲平臺提供系統內所有物件數據的匯入、匯出、數據批次刪除、批次轉移等功能。`,
"vue_label_systemSettings_setHomePage":``,
"label.select.button":`可選按鈕`,
"label_emailsync_status_enable":`啟用關聯`,
"label.trigger.triggerVersion.detail":`此欄位不可編輯，觸發器目前有兩個版本1.0和2.0版，新建的觸發器全部為最高版本2.0，1.0版本已禁止建立`,
"pagecreator_layout_message_save_fail":`配置儲存失敗`,
"label.salescloud.salesdashboard.10big":`未來3個月前10大業務機會`,
"label.file.share.size":`每個文件最大共享和公用連結數量為`,
"label.page.simple":`簡單`,
"pagecreator.page.message.delete":`是否刪除當前所選頁面？`,
"label.weixin.newspaper.coverage.detailinfo":`保險單詳細訊息`,
"label.list.userinterface.chattersetup":`CCChat 設置`,
"lable.opppdt.addpdt.table.quantity":`數量`,
"label.product.description":`產品描述`,
"button_partner_back":`返回`,
"label.user.current.loginuser.sessionid":`當前登錄使用者SessionID是：`,
"label.otherreport":`其它報表`,
"pagecreator_button_mobilepage":`手機端`,
"label.mobile.phone.state":`批閲狀態`,
"lable.currencyManage.unenableCurrencyAdv":`禁用進階貨幣管理`,
"lable.product.addp":`添加價格`,
"label.field.validate.notpass":`驗證通過，沒有發現語法錯誤`,
"label.app.global.search.obj":`應用於全局搜尋中搜尋的物件，最多可設置10個物件。`,
"label.group.archived":`歸檔`,
"vue_label_approve_to_submit":`待提交`,
"showfrom":`顯示第`,
"chatter.emailNotification":`電子郵件通知`,
"label.callcenter.pleaseenter.enterprise.number":``,
"label.forecast.customforecast.forecastnumber":`預測數字`,
"label.vlidaterule.messagelocation":`錯誤位置`,
"label.h5.similar.opportunity.step3.conment":`將會始終顯示表示匹配欄位數量的相關性列`,
"label.ccchat.group.gd.setting.info":`修改 CCChat小組設置`,
"label.knowledgebase.delete.article.succeeded":`刪除文章成功`,
"message.layout.edit":`頁面配置管理為單獨增值功能，如您的組織確認已經採購了該功能模組，向系統管理員詢問使用密碼。更多問題可聯繫CloudCC.com進行支援。`,
"label.case.create":`個案({0})已建立`,
"label.icon.170":`購物`,
"message.error.contact.null":`聯絡人不能為空`,
"label.appupload.install.error.hasinstalled":`此軟體包已在貴組織中安裝。在安裝新版本之前，你需要先移除已安裝版本。`,
"label.service.miniProgram.imageType":`圖片支援類型PNG、JPG、JPEG，建議大小750*349像素。滑鼠懸浮在圖片上可重新上傳或刪除圖片。`,
"label.leadscore.rule.edit":`商機評分：編輯規則`,
"vue_label_commonobject_anytime":`任意時間點`,
"label.clearing.conditions":`清除條件`,
"label.campagin.roi.ydkhjhze":`贏得客戶機會總額`,
"Lead_Auto_Scoring_Setting_001":`商機在儲存或者編輯時自動評分。 （不包括批次匯入與接口建立）`,
"pagecreator.systemstyle.label.buttonareacolor":`操作區顏色`,
"label.batchregist.huanxinuser.finish":`批次註冊使用者已完成`,
"UG_opportunity_006":`機會天才`,
"message.serviceappo.violation":`派遣時間違規:在此時段與缺勤記錄衝突`,
"label.recordtypeselect.selectnew":`選擇新記錄類型`,
"Lead.Tools.BatchScoring":`商機批次評分`,
"label.partnerCloud.financeSetting.enterWechat":`請輸入微信支付商戶號`,
"label.philippine.time":`菲律賓時間`,
"five":`五`,
"label_average_value":`平均值`,
"message.realdelete":`確定要徹底刪除嗎？`,
"label.currency.note":`輸入新幣種的訊息。請注意，啟用幣種之後就不能再將其刪除。`,
"label.projectManagement.delete.prompt":`刪除提示`,
"label.approval.present":`（當前）`,
"label.escalation.setup.newrule.name":`規則名`,
"label.edit.list":`可編輯數據列表`,
"label.partnerCloud.financeSetting.informationOne":`1.連接支付寶商家中心（b.alipay.com），用簽約支付寶帳戶登入。`,
"label.customfields.numberText":`2.輸入數字的長度與小數位數之和不能超出18位`,
"label.biaoqing.businessverify.relation.tip":``,
"label.icon.149":`機器人`,
"System.btn.SaveAndCommit":`儲存並提交`,
"label.calendar.many":`多人`,
"label.ccchat.create.email":`已建立電子郵件`,
"template.report.income.marketing.activities":`行銷活動收入報表`,
"label.ccchat.person.invite.needemail":`輸入一個電子郵件地址。`,
"template.report.open.amount":`未關單金額`,
"label.currentoperate":`已存在的操作`,
"label.finalapprove":`最終批准`,
"label.emailmerge.mergepage.step2":`2.選擇要合併的範本最多20個:`,
"label_tabpage_sorttypez":`排序類型`,
"label.workbanch":`我的工作台`,
"font-evaluate-module-v1-disable":``,
"label.ServiceCloud.distributionMap":`分佈圖`,
"lable.Confirm.potential.customers":`確認領取{num}個商機`,
"label.mobile.quickcreate.default.nearby":`附近`,
"label.isremider.noremider":`不提醒`,
"label.approval.select.step":`選擇要返回的審批步驟`,
"chatter.error.pm":`錯誤: 上傳圖片文件過大!`,
"UG_activity_08":`預約一個日程`,
"label.marketsea.notwinopportunitydays":`天未成交天數（需大於未建立機會天數）`,
"label.selectpage":`選擇一個現有頁面`,
"label.dashboard.dispalyOnTheHomePage":`顯示的主頁`,
"front-lightning-module-v1-details-page-chart-set-report":`設定報表`,
"vue_label_pool_mydeal":`我成交的`,
"vue_label_report_lastone":`最後一個`,
"label.tabpage.potentialcustomersz":`商機`,
"font-evaluate-module-v1-more-satisfied":``,
"label.trigger.instructions":`<font color`,
"lable.SalesCommitmentKanBan.commitmentToCompletionRate":`承諾完成率`,
"label.umeng.approval.dlsp.approvenew":`代理審批：#actorname正在請求批准#objAPIName#recordname`,
"label.edit.visualpagefolder":`自訂頁面：編輯文件夾`,
"label.pc.flash.teach":`影片教學`,
"label.showsearch":`顯示搜尋`,
"label.reportsSubscriptionPage.condition.title1":`你會在所有條件都被滿足之後收到通知`,
"label.h5.search.result":`結果`,
"vue_label_commonobjects_view_chart_pie":`餅圖`,
"label_please_enter_currency":`請輸入幣別`,
"chatter.share.to.profile":`您的設定檔`,
"label.mykeeptouchset":`我的保持聯繫設置`,
"label.profile.mustcopyaprofile":`您必須選擇一個要複製的現有設定檔。`,
"label.managereport":`管理報表`,
"label.total.choice":`個文件，共選擇了`,
"label_emailtocloudcc_help":`請輸入正確的電子信箱密碼或授權碼。如果您的電子信箱伺服端需要開啟IMAP/SMTP服務才可由第三方客戶端登錄，您必須先登錄電子信箱進入設定確保此服務已開啟，並複製相應授權碼輸入至此密碼框。`,
"label.trigger.sel":`此文件夾中的觸發器`,
"label.dashboardLookUp":`查看儀表板`,
"label.batchadd.newbatchpage.save.emptytext":`存在必填項目未填寫，請檢查`,
"setup.mainpage.label.welcome16":`操作指導： 點擊本頁左側選單 → 應用程式設定 → 建立 → 工作流、批准過程、工作、電子郵件通知、欄位更新等。`,
"vue_label_email_mark as":`標記為`,
"label.customobjdel.cannot.delete.try":`無法完成物件的刪除嘗試，因為它與同其他物件的以下關係相關聯。`,
"label.customsetting.visible.public":`公用`,
"label.log.bit":`位數`,
"label.data.exportall.all.desc":`匯出當前使用者所有有權查看的物件的資料。`,
"message.login.mfadevice.already.bound":`使用者已經綁定MFA設備`,
"label.campaign.channel.please.img":`請上傳圖片`,
"assetbom.manage.notpermission":`請聯繫管理員，開啟管理資產BOM權限`,
"schedstarttime.schedendtime.time.illegal":`服務預約的已計劃開始時間應小於等於已計劃結束時間。`,
"label.referperson":`擁有者`,
"front-email-payment-area":``,
"label.c.d.least":`每個 C" 記錄必須至少有一個相關 "D" 記錄。"`,
"label.weixin.longitude.isnull":`經緯度為空或者無效`,
"setup.layout.button.ok":`確定`,
"vue_label_fiter_component_date_customdate":`自訂日期`,
"label.enable.case.createarticle":`允許使用者從個案中建立文章`,
"label.event.moveup.8hour":`提前 8 小時`,
"label.input.most.string":`請輸入至多 {0} 個字元`,
"lable.SalesCommitmentKanBan.contractEndDate":`合約結束日期`,
"label.visualpage.function.name":`方法名命名為:`,
"label_emailtocloudcc_redmessage1":`請輸入正確的電子信箱地址`,
"message.aliasnameinput":`錯誤： 唯一名稱只能包含字母數字字元，必須以字母開頭，並且必須是唯一的`,
"label.data.exp.selectedtemp":`選擇資料匯出所需範本`,
"label.import.page1.suitedwayoflinkman":`相符聯絡人方式`,
"label.customsetting":`自訂設置`,
"label.versiontype.Free":`免費版`,
"setup.layout.label.norelatedlist":`暫無相關列表`,
"label.forecast.edittotal.de.leiji":`的累計`,
"label.customfields.file.max":`上傳的文件過大,請不要超過5M。`,
"label_partner_all_workspace":`工作區`,
"label.searchrelation":`查找關係`,
"label.icon.185":`諮詢`,
"label.service.gantt.effective":`有效`,
"label.newreportstp1":`步驟 1：選擇報表格式`,
"label.category.9":`生產製造`,
"label.zuowei":`作為`,
"front-quotation-v1-select-quota":`選擇報價單`,
"label.dashboard.refresh":`重新整理`,
"label.weixin.saveandnew.log":`儲存並新建日誌`,
"label.report.list":`報表列表`,
"FL":`文件`,
"label.h5.followingcolleagues":`關注的同事`,
"template.report.conversions.number":`商機轉換數（按擁有者統計）`,
"label.validate.function.funcFormat.MONTH":`MONTH(date)`,
"front-kefu-moudle-v1-tenant-ID":`租戶ID`,
"label.reportsSubscriptionPage.schedulereport.monthly.time":`時間`,
"label.multilang.workflow.everyotherday":`每隔{0}天`,
"label.chat.message.send.message":`發送消息`,
"label.knowledgebase.fast.operation.error":`快速操作錯誤`,
"label.multilang.dupicatecheck.dumplicatedata":`在{0}條記錄中共查詢到{1}條符合條件的重複數據,查詢時間耗時{2}毫秒。每頁顯示{3}條數據。：`,
"vue_label_report_addFile_detail_Information":`僅匯出2000條詳細訊息行。使用此數據，以進行更多計算，或上傳到其他系統。`,
"label.ccchat.message.search.desc3":`搜尋提示`,
"message.deletereport.prompt":`無法刪除此報表`,
"pagecreator.page.message.save.success":`頁面儲存成功`,
"vue_label_rise":`上升`,
"label.appupload.install.error.choicehead":`如果系統中已存在的組件與要安裝的組件衝突該如何處理？`,
"message.dispatch.violation":`派遣時間違規:此時段與其他服務預約衝突`,
"label.tool":`工具`,
"label.sso.saml.idp.downloadcert":`下載證書`,
"label.chatter.detailinfo":`詳細訊息`,
"label.area.tree":`區域階層架構樹`,
"label.partnerCloud.priceOfManual.notEnabled":`不啟用`,
"label.chosesubject.call":`打電話`,
"label.leadscore.rule.detail":`商機評分：規則詳情`,
"front-welcome-to-try":`歡迎試用`,
"label.umeng.activity.event.willbegin1":`事件#event即將在#time後開始`,
"component.event.label.noevent":`看來您已完成今天的工作了。`,
"label.document.templatesetof.folder":`範本套紅文件夾`,
"label.quickbooks.none":`無相符數據，請手動搜尋或新建`,
"label.assignment.setup.newrule.inputrule":`輸入分配規則名`,
"label.appointmentdetail.wizard.title4":`公司名稱`,
"label.malaysia.time":`馬來西亞時間`,
"label.partnerCloud.partnerAccount.way":`儲值方式`,
"label.roleoflinkman":`聯絡人角色`,
"mesage.error.role.delate.user":`無法刪除角色，因為當前為角色分配了使用者。`,
"chatter.warning":`警告：如果你選擇其它物件，您剛剛所做的更改將不會儲存，是否確定執行此操作?`,
"label.service.gantt.violations.sum":`違規的服務預約數量`,
"label.permission.objectpermission.recordfenpei1":`分配的記錄類型`,
"label.mobile.phone.required.plan":`計劃為必填項`,
"label.after_leaving":`離開後，目前資料將不被儲存`,
"label.cpq.opportunity.mainquote.trasnfer.order":`機會下已經有主報價單，且已經轉化成訂單`,
"component.setup.iframe.label.title":`自訂頁面`,
"visit.dispatchplatform.nopermission":`權限不足：您沒有足夠的權限存取派工平台，請聯繫管理員。`,
"label.validate.function.funcExplain.RIGHT":`返回從文本字元串右邊算起的執行數量的字元`,
"component.chatter.link.button.save":`發表`,
"label.knowledge.selection":`每個知識下最多可以有8個資料分組選擇`,
"chatter.email.homePage":`在我的CCChat主頁上發帖時`,
"vue_label_commonobjects_view_copy_view":`複製視圖`,
"label.documentmessage":`文檔詳細訊息`,
"label.emailtocloudcc.step1":`步驟1`,
"label.user.mfa.unbind":`給選中的使用者解除MFA綁定`,
"label.stdashbord.xsld.business.sdzje":`失單總金額`,
"vue.please.select.the.total.method":`請選擇合計方式`,
"label.stdashbord.xsld.business.img1":`可能性為1%-99%階段的個數`,
"label.reportsSubscriptionPage.condition.title":`除去訂閱功能之外，你還可以在報表結果上設定條件。在條件滿足之後你會收到通知。非必填`,
"chatter.sel.field":`選擇超過了20個欄位。`,
"label.login.access.year":`年`,
"label.dashboard.all":`全部儀表板`,
"label.approver":`審批者`,
"Lead.Homepage.Tools.BatchScoring":`批次評分`,
"lable.opppdt.selPdt.lesscondtions":`較少篩選器`,
"label.integrations.action.export":`立即匯出`,
"label.datamanage.lookupandsure":`（查看和確認）`,
"label.email.attach.to.mail":`附加到電子郵件`,
"message.nodataordeleted":`數據不存在或已刪除`,
"component_newrecords_label_all":`查看全部`,
"lable.currencyAdv.startdate.rate":`顯示開始日期定義在以下範圍中的所有匯率`,
"label.callbackoperate":`調回操作`,
"label.knowledge.setting.hint.eighteen":`開始為知識庫建立文章`,
"label.user.step4.submit.email":`步驟4.已提交您的電子郵件發送請求。`,
"label.appointment.wizard.subtitle4-1":``,
"component.assistant.button.newtask":`建立工作`,
"label.icon.129":`卡片`,
"label.relatedlist":`相關列表`,
"label.report.recently":`最近查看`,
"label.batchadd":`批次新增`,
"front-template-V1-Delete-succeeded":`“{{currentTelmplateName}}”範本刪除成功`,
"label.appupload.upload.otherdetail":`其他詳細訊息`,
"label.emailobject.link":`連結`,
"label.quickbooks.createcustomer":`在QuickBooks上建立新客戶`,
"report.label.projectcount":`個項目，按報表名稱排序`,
"vue_label_normal_contact_sf":`聯絡人`,
"chatter.group.groupActivities":`全部組`,
"label_tabpage_addoptionsz":`添加選項`,
"label.knowledgebase.submit.for.translation":`送出進行翻譯`,
"vue_label_pool_notallowed":`企業性質不允許`,
"label.icon.80":`造紙`,
"label.readonlys":`唯讀`,
"label.recordsediting":`記錄可編輯性`,
"label.mr.title.email":`電子郵件`,
"label.partner.all.enable":`啟用`,
"label.customsetting.manage.errmessage":`請先維護自訂欄位，然後再管理數據`,
"label.cloudccclass.list.cls":`類`,
"label.weixin.click.loadall":`點擊加載全部`,
"label.weixin.appr.initialtime":`發起時間`,
"UG_ST_002":`確定`,
"setup_mainpage_label_welcome17":`權限設定`,
"label.appupload.state0":`未上傳`,
"label.icon.115":`房子`,
"setup_mainpage_label_welcome5":`自訂欄位`,
"lable.custom.year.ovdate":`自訂年度結束日期`,
"label_tabpage_findz":`查找`,
"label.appupload.uploading":`正在上傳軟體包...`,
"setup.mainpage.label.welcome1":`需要相應權限`,
"label.file.folder.delete2":`刪除文件庫？`,
"2018UI_Homepage_DataNoAccess_Info":`此條記錄您沒有權限存取，點擊返回上一步。`,
"label.ems.google":`Google`,
"label.hawaii.aleutian.standard.time":`夏威夷標準時間`,
"template.report.unfinished.tasks":`未完成的工作`,
"vue_label_calendar_add_calendar":`添加日曆`,
"label.button.sel.useremail":`給選中使用者發送電子郵件`,
"user.email.template":`親愛的{username}：<br>您的行銷活動[{Campaign.name}]的邀約碼如下：<br>{Campaign.ColleagueInvitationLetter}<br>相對應的URL為：<br>{Campaign.ColleagueInvitationLetterLink} <br>當前行銷活動支援二維碼註冊和URL連結註冊！感謝您的支援<br>行銷活動專員:{Campaign.Owner}`,
"label.forecast.settings.shouru":`預測收入`,
"label.casesensitive":`將ABC"和"abc"視為不同值（區分大小寫）"`,
"message.pleaseinputrightdistanceweek":`請填寫正確的間隔星期`,
"label.linellae-group":`線條-分組`,
"label.showdefault_times":`顯示預設發佈時間`,
"label.smstemplate.finishmessagedetailinfo":`完成簡訊範本的詳細訊息`,
"label.service.miniProgram.backgroundImage":`秒`,
"label.recentview.news":`最新記錄`,
"label.reportType.chose.and.form":`選擇報表數據源及報表格式`,
"setup.layout.button.additem":`添加選中項`,
"front-epwechat-module-v1-auto-mate":`自動相符`,
"vue_label_helpcenter_contract&plan":`合約是各方之間的書面協議。許多公司使用合約定義與其他公司從事業務往來的條款。使用 Cloud CC建立您與您的客戶和機會已有的合約，並為其提供文檔。通過批准流程，追蹤合約。<br>通過收款計劃，協助合約功能，管理您的交易。`,
"label_mobile_version_nonsupport_feature":`此版本不支援該功能，請更新到最新版本`,
"label.icon.44":`火`,
"label.data.downpage.i.title.num3":`3、匯入之前，請先確保匯入其相關的所有記錄。例如：如果您當前匯入的物件與聯絡人之間存在查找關係，請先匯入這些聯絡人，然後再匯入您的資料。`,
"label.mr.object.customer":`客戶`,
"label.social.user.null":`Social社交使用者資訊不能為空`,
"front-epwechat-module-v1-unbound-item2":`#NAME?`,
"label.partnerCloud.partnerAccount.noempty":`儲值金額不能為空`,
"label.weixin.myapproval":`我的審批`,
"label.data.setok.e_desc1":`匯出成功後您會收到系統郵件提醒，匯出的數據暫時儲存在伺服器上，系統只為您儲存48小時，請儘快到`,
"lable.batchadd.service.cfq.after":`觸發器 (After Insert)`,
"label.umeng.activity.youhaveanevent":`您有1個新事件`,
"label_emailsync_status_connectaccounts":`關聯信箱帳號`,
"label.multilang.shenpi.count":`共{0}條記錄：`,
"pagecreator.page.message.delete.fail":`頁面刪除失敗`,
"label.version.sum.lookupmdfield":`個主詳關係欄位`,
"vue_label_pool_clueduplication":`線索重複`,
"label.system.setup.log":`系統行為日誌`,
"label.globaloperation.operationtype.send.e-mail":`發送電子郵件`,
"vue_label_pricebook_entry":`建立價格手冊項目`,
"label.forecast.forehistory.submit.date":`提交日期時間`,
"chatter.handle":`您正在處理什麼?`,
"lable.SalesCommitmentKanBan.complete":`完成額`,
"label.weixin.upload.pictures":`上傳圖片`,
"label.create.document":`新增文檔`,
"vue_label_commonobjects_detail_unlockconfirm":`確認解除鎖定？`,
"label.customer.page":`自訂頁面選項卡`,
"button.partner.workspace.saveas":`另存為`,
"setup.layout.label.asc":`升冪`,
"label.ccpeak.folder.time":`未歸檔定時類檔夾`,
"label_tabpage_includez":`包含`,
"label.custom.button":`自訂按鈕`,
"label.weixin.binding":`綁定`,
"P":`百分比`,
"chatter.stop.n":`停止追蹤該記錄`,
"label.reportsSubscriptionPage.schedulereport.monthly.day.wednesday":`星期三`,
"template.report.revenue.marketing.activities":`行銷活動收入`,
"lable.SalesCommitmentKanBan.theActualReceipts":`實際收款額`,
"vue_label_popularresults":`熱門結果`,
"label.log.belongs":`所屬部分`,
"label.profile.remark":`此設定檔的使用者具有下列權限和版面配置。管理員通過編輯使用者的個人訊息即可更改其設定檔`,
"label.appupload.component.type.button":`按鈕`,
"label.partner.all.operate":`操作`,
"vue_label_notice_modify_fail":`修改失敗`,
"label.icon.137":`地球`,
"front-dialog-module-v1-nosupport-copy":`不支援複製`,
"label.integrations.mailchimp.massage3":`已取消授權`,
"UG.opportunity.010":`建立一個交易`,
"front-lightning-module-v1-details-page-chart-selecting-reports":`· 選擇報表時，只能選擇公用報表，即所有使用者均可連接的報表檔案夾中的報表，與未歸檔公用報表中的報表；`,
"System_btn_SaveAndCommit":`儲存並提交`,
"vue_label_dashboard_statisticaltype":`請選擇統計類型`,
"label.mr.object.opportunity":`業務機會`,
"label.area.detail.remark":`預覽區域下的使用者`,
"label.view.sortview.index":`順序號`,
"label.mobile.quickcreate.default.events":`事件`,
"label.product.price":`銷售價格`,
"label.leadmarketsea.edit.title":`商機公海池編輯`,
"pagecreator.layout.button.edit":`編輯配置`,
"label.addressee":`收件人`,
"label.movablesearchlayout":`活動搜尋配置`,
"label.ems.confirm":`確定`,
"vue_label_file_save_to_file":`儲存到文件`,
"component_chatter_button_more":`查看更多詳細訊息`,
"label.ccdocument.hidden.trace":`隱藏痕跡`,
"label.partnerCloud.maximumTwo":`檔案最大為2M`,
"label.event.moveup.4hour":`提前 4 小時`,
"label.batchadd.save":`添加共用失敗`,
"label.passwordPolicy.setup.expireDate":`使用者密碼有效期`,
"label.workflowrule":`工作流程規則`,
"vue_label_notice_pleaseselecview":`請選擇視圖`,
"label.h5.chatter.colleagues":`關於同事`,
"lable.opppdt.addpdt.subtitle":`將產品添加到`,
"label.data.import.setup.repeat.no":`否-將所有記錄插入我的匯入文件中。`,
"label.changeCorporate":`更改公司幣別`,
"label.customfields.dateandtime.tip":`允許使用者輸入日期和時間，或從彈出式日曆中選擇日期。當使用者單擊彈出式日曆中的某個日期後，該日期和當前時間將輸入到日期/時間"欄位。"`,
"label.integrations.mailchimp.massage1":`請選擇至少1條需要匯出的記錄`,
"lable.PowerProcess.custom":`基於自訂條件`,
"label.service.editDialog.displays.service.appointmentsFordays":`顯示水平日期之前{before}天和水平日期之後{after}天的服務預約`,
"label.Receivables.ActualMoneyTime":`實際收款時間`,
"label.matrixreport.intro":`矩陣式報表以網格形式顯示按水準和垂直方向的條件計算出來的彙總數據`,
"message.validation.isnotnumber":`輸入正確的數字`,
"label.partner.workspace.member.search":`搜尋`,
"label.customfields.deletewill":`刪除該自訂欄位將會`,
"label.content":`內容`,
"component.setup.button.weburl":`外部URL`,
"setup.mainpage.label.welcome28":`操作指導： 點擊本頁左側選單 → 管理設定 → 數據管理 → 數據匯入匯出、批次轉移、批次刪除。`,
"label.related.setup":`工作事件相關項配置`,
"label.weixin.sign":`親，您已經簽到，無須再簽`,
"label.norecord":`沒有記錄`,
"label.emailmerge.detail.emailtempldatemerge":`郵件合併範本`,
"label_emailsync_status_role":`角色`,
"label.mobileapp.modelsetting2":`根據實際使用場景選擇符合業務需求的模組<br>啟用：勾選後模組將顯示在行動端“更多”-“推薦功能”<br>禁用：勾選後模組將不再顯示在行動端“更多”-“推薦功能”`,
"component.sendmail.label.title":`發送郵件`,
"component_assistant_button_newevent":`新建事件`,
"label.chatter.input":`請輸入相關內容`,
"message.error.view.operate.rtnlink":`單擊<a href`,
"lable.new.profile":`新建設定檔`,
"label.custom.field.null":`無可用`,
"label.reportsSubscriptionPage.schedulereport.weekly.saturday":`星期六`,
"label.stdashbord.xsld.business.img4":`可能性為100%階段的總金額`,
"pagecreator_layout_button_splitall":`拆分所有`,
"label.mobile.phone.total.amount":`總金額(萬元)`,
"label.ratifyhistory":`審批歷史`,
"label.projectManagement.Antecedents":`前置工作`,
"label.projectManagement.Newserviceappointment":`建立服務預約`,
"label.delete.record.is.approval":`您要刪除的記錄為審批中的記錄，確認要刪除嗎？`,
"front-gantt-module-no-tasks-describe":``,
"vue_label_visualize_data":`已回填天眼查資料，請儲存。`,
"UG.activity.02":`指派工作`,
"label.field.duplicate2":`不允許重覆值`,
"label.cloudccclass.list.tip":`允許開發人員在Cloudcc.com平台上開發類,這些類可以用於自訂頁面及觸發器`,
"before":`早於`,
"UG.ST.001":`提示`,
"label_tabpage_userGuidez":`使用者指南`,
"vue_label_account_looking_for":`請輸入您所要查詢的內容`,
"vue_label_calendar_notice_timecantmove":`該物件日曆的時間不可拖拽更改`,
"label.mobile.phone.enter.summary":`這裡輸入總結`,
"label.object.api.existed":`物件api已存在，請更改api名稱`,
"label.weixin..xsld.order.by.time":`按預計簽約日期排序`,
"label.h5.chatter.whether":`是否`,
"label.file.delete.success":`文件刪除成功`,
"label.imgfield.type.url.tip1":`使用者可輸入引用圖片的連結，通過在圖片連結後添加&cimgSize`,
"label.tomanyrecords":`表中項目超過 5,000 條。`,
"label.save.partnercloud":`儲存夥伴雲錯誤`,
"vue_label_homepage_fliteritems":`篩選配置項`,
"pagecreator_page_button_new":`新建頁面`,
"label.sharerule.baseofcondition":`基於條件`,
"label.dashboard.snapshot":`儀表板快照`,
"label.appointmentpage.wizard.subtitle1.1":`請選擇日期和具體時間`,
"label.reportsSubscriptionPage.condition.emailsummary":`只發送報表`,
"chatter.group.showAll":`顯示全部`,
"label.tabpage.helpNavigationz":`幫助和導覽`,
"label.emailtocloudcc.button.back":`取消`,
"approval_request_email_subect":`審批請求`,
"label.lookup.error":`查找時發生錯誤`,
"label.publicgroup.save.groupisnull":`儲存過程中出現小組數據為空，請嘗試重新儲存，如果還是存在問題，請聯繫系統管理員`,
"label.pie":`圓餅圖`,
"chatter.feed.is":``,
"label.customfields.file.max5m":`最大文件大小為5M`,
"com.cloudcc.login.error.message.vaildauthfail":`無效的登錄認證`,
"label.profile.appsetuppermission":`應用程式設定管理權限`,
"label.customfields.file.totalmax":`上傳的文件過大,請不要超過500M。`,
"label.sms.list":`簡訊接口訊息列表`,
"message.error.referencedcolumnIdnotexist":`報表引用欄位已刪除,無法正常顯示,請聯繫系統管理員獲取幫助。`,
"front-lightning-module-v1-details-page-chart-setting-chart":`設定報表圖表`,
"label.recordtype.profile.enables":`當前可用記錄類型`,
"chatter.this.n":`這個記錄`,
"label.only.upload.file":`只能上傳jpg/png文件，且不超過500kb`,
"vue_label_lead_conversion_failed":`轉換失敗`,
"label.file.share.file.success":`成功共享文件！`,
"label.processsetting.delete.process":`確認刪除該進程？`,
"message.uniquenamevalidate":`必須以字母開頭，僅使用字母數字字元和底線`,
"label.group.archived.desc.info":`此小組已歸檔，因此您不可以建立新帖子或與此小組共享文件。啟用小組可啟用所有功能。`,
"label.customer.maincontact":`主要聯絡人`,
"label.appointment.wizard.subtitle1-9":`4小時`,
"label_productline_income":`產品系列收入`,
"label.dashboardSetup.tz.ybb":`跳轉到儀表板`,
"label.recordowner":`記錄擁有者`,
"message.approval.othersdoing":`其他人正在操作此流程，請刷新獲取最新的訊息！`,
"Opportunity_Detailed_Phase_Label_002":`當前狀態已停留{0}天`,
"label.field.validating.rule.isnot.passed":`驗證規則編譯未通過，請檢查語法`,
"label.textmessage.fieldskong":`部分插入的欄位值為零，請重新編輯並發送`,
"com.cloudcc.login.error.message.islocked":`使用者被鎖定`,
"label.forecast.customforecast.foredis.debfb":`定額百分比`,
"lable.opppdt.selPbk.changepbk.worning":`修改此業務機會的價格手冊，與此業務機會相關的業務機會產品將被刪除。是否繼續?`,
"label.mr.backLookReData":`返回，查看重複數據列表`,
"label.quickbooks.searchqb":`搜尋 QuickBooks`,
"label.service.gantt.searchSkills":`搜尋技能`,
"label.account.Current.and.NexttFQ":`當前和未來三個會計季度`,
"customer.notopen.chat":``,
"vue_label_commonobjects_view_sum":`共{total}條數據`,
"label.partnerCloud.orderingPlatform.adjust":`調整訂單產品`,
"label.emailmerge.mergeFolder.tips":`此一頁面中，您可以產生一個Microsoft Word文檔，包含您的聯絡人資料。請選擇郵件合併範本，最多可選20個。`,
"vue_label_ccchat_notice_deletecommentfail":`刪除評論失敗`,
"label.emailsync.status":`使用者信箱狀態統計`,
"label.forecast.forecastroleuserpage.desc":`為此角色分配預測經理。下屬的預測將彙總到其經理的預測中。`,
"label.step1.total4":`第1步，共4步`,
"front-kefu-moudle-confirm-fjcase":``,
"label.icon.60":`吊車`,
"label.appointmentpage.wizard.subtitle3":`請輸入您的訊息`,
"label.loginservice.license.exceed.time":`許可證已經過期`,
"label.customcomponent.check.tag.lastrow":`最後一行必須是`,
"label.product.code":`產品代碼`,
"label.salescloud.salesdashboard.phone":`電話`,
"label_please_input_price_list_price":`請輸入價目表價格`,
"label.multilang.page3":`頁`,
"label.file.lastmodifydate":``,
"label.icon.121":`電腦`,
"message.error.system.service.unknow":`未知的服務，聯繫系統管理員！`,
"label.thesecond":`第二列`,
"vue_label_report_conditiondesc_two":`將條件添加到此報表`,
"label.exchange.serverUrl":`伺服器地址`,
"RL":`引用`,
"label.emailobject.emailsend.sendindividuallyprompt":`“分別發送”會對多個人一對一發送。每個人將受到單獨發給他/她的郵件。確定進行“分別發送”？`,
"label.appointmentconfirmpage.wizard.subtitle4":`參與人`,
"message.save.opportunity.team.save.failed":`機會小組失敗`,
"vue_labenl_normal_notice_share_success":`共用成功`,
"label.triggerfolder":`觸發器文件夾`,
"label.more":`更多`,
"label.file.num":`數量`,
"label.dashboard.list.sortBy":`個消息`,
"c":`累計彙總`,
"label.weixin.detail.edit":`編輯`,
"label.escalation.setup.newentries.step2":`步驟2：選擇此規則項目的條件`,
"label.report.error.prompt":`配置失敗。只支援使用包含群組資料列的串聯報表，並確保為公用報表且未被刪除！`,
"label.notification.new":`新通知`,
"label_tabpage_releaseTourz":`發佈導覽`,
"label.icon.41":`定位`,
"label.sendsms.hello.new":`您好：您有一個新的`,
"label.custom.combination":`組合`,
"label.project.hit.fifteen":`里程碑指派通知`,
"label.campaign.channel.step6.mobile":`產生行動版頁面`,
"label.goback.N.step":`返回第N步`,
"label_partner_all_name":`夥伴雲名稱`,
"label.usermanage.loginusername.exist":`登錄用戶名已經存在！`,
"template.chart.cpxse":`產品銷售額`,
"chatter.feed.deletecomments":`是否確定刪除此註釋?`,
"label.list.userinterface.show.newrcords.enable":`禁用最新記錄`,
"label.sso.saml.idp.config.enablelogout":`啟用單一登出`,
"label.file.library.create":`新增文件庫`,
"label.event.moveup.half.day":`提前 0.5 天`,
"label.stdashbord.xsld.business.jhzje":`機會總金額`,
"label.partnerCloud.orderingPlatform.unitPrice":`單價`,
"label.recordtype.edit.attribute":`一般屬性`,
"front-template-V1-TemplatePreview":`範本預覽`,
"label.tabpage.personalCenterz":`個人中心`,
"label.setuplookuplayout":`查找配置`,
"label.no.merge.records":`沒有可合併的記錄`,
"label.attachementNew.set2":`步驟  2.是否歸檔文件`,
"label.publicgroup.detail.showmembers":`查看小組成員`,
"UG.Forcast.03":`啟動規劃並執行業務策略。<br> 祝您預測愉快！`,
"label.h5.manageprompt":`勾選某個選項卡添加到主頁，或者直接點擊選項卡圖標打開選項卡`,
"label.icon.145":`關聯`,
"label.select":`選擇`,
"label.publicgroup":`公用小組`,
"label.customcomponent.usewhere.title":`使用此組件的位置:`,
"label.custom.page.button.name":`按鈕名稱`,
"pagecreator_layout_button_vertical":`縱向拆分`,
"label.marketsea.autorecyclerule":`自動回收規則`,
"label.reportsSubscription.entrance.attachment":`Excel 格式.xlsx`,
"component_chatter_button_collect":`收藏`,
"label.page.step2.of.step5":`第2步，共5步`,
"label.reportsSubscription.addfile.helptext":`在此處可以設定是否在訂閱郵件中添加報表的附件，以及附件報表的格式`,
"label.oldpw":`舊密碼`,
"lable.SalesCommitmentKanBan.contractAmount":`簽約額`,
"lable.Bundle":`所屬捆綁包`,
"label.weixin.unit.million":`單位（萬元）`,
"label.app.choseprofile":`分配設定檔`,
"label_tabpage_editz":`編輯`,
"label.email.attachement.size.info":`文件不能大於`,
"label.chatter.pastSevenday":`過去7天`,
"label.weixin.end.later.start":`結束日期必須大於等於開始日期`,
"label.passwordPolicy.setup.lockoutPeriod":`鎖定時間`,
"pagecreator_page_funcpath":`/構建器/頁面列表`,
"label.emailobject.apperror":`沒有可用的郵件服務，請聯繫管理員。`,
"label.custom.page.button.broadband":`按鈕寬度（像素）`,
"label.weixin.contract.rate":`合約達成率`,
"label.brief.payments":`收款金額`,
"lable.approvaldatamove.transfermsg":`向新使用者批次傳送未完成的批准請求`,
"label.datamanage.account.namenull":`注意：如果沒有給“客戶名稱”欄位賦值，客戶記錄將不會被匯入！`,
"lable.SalesCommitmentKanBan.allTotalPaymentAmount":`總累計收款額`,
"Opportunity_Detailed_Phase_Label_001":`階段`,
"vue_label_helpcenter_calendar2":`<br>物件日曆：您用物件建立的日曆會在日期欄位中將記錄數據作為日曆項目在日曆視圖上顯示。您可以編輯、刪除物件日曆，並且可以為每一個物件日曆自訂顏色。<br>建立事件<br>您可以通過以下兩種方式在日曆視圖中建立事件。<br>（1）單擊日曆視圖右上角“建立事件”按鈕，即可進行建立事件。在建立事件中您可以在“相關項”和“名稱”欄位中選擇其他物件，從而將事件與其他物件，如機會，進行關聯。關聯了其他物件的事件記錄，會在其他物件詳情頁“活動”模組同步記錄。<br>（2）或者您可以通過單擊日曆網格建立事件。<br>建立物件日曆<br>步驟1：單擊導航選單日曆選項卡進入日曆視圖頁面。<br>步驟2：在視圖右側找到我的日曆，單擊我的日曆旁邊的圖示，在彈出的“建立物件日曆”的彈窗中進行操作。<br>步驟3：先為建立的物件日曆命名。選擇作為日曆基礎的物件，選擇決定日曆顯示內容的欄位，“開始欄位”、“視圖篩選器”、“顯示欄位”。開始欄位決定顯示數據的時間範圍，您可以通過視圖篩選器過濾數據，顯示欄位決定日曆項目上顯示的內容。<br>其他日曆<br>其他日曆包含添加的其他使用者的日曆。可以添加您下級和共用給您日曆的人員日曆。<br>共用我的事件日曆<br>步驟1：單擊導航選單日曆選項卡進入日曆視圖頁面。<br>步驟2：在日曆視圖右側我的日曆下方找到“我的事件”，點擊“我的事件”右側的“下拉按鈕”，選擇共用日曆。<br>步驟3：在彈出的“共用日曆”彈窗中選擇您想要共用日曆的使用者及存取權限。除此之外，您還可以通過單擊“目前誰有存取權限”查看您共用日曆的記錄，單擊共用記錄右側“×”圖示，即可移除共用記錄。<br>共用日曆後，您的下級同事即可添加您的事件日曆到其他日曆後即可查看您的事件日曆。<br>添加日曆<br>步驟1：單擊導航選單日曆選項卡進入日曆視圖頁面。<br>步驟2：單擊日曆視圖右側其他日曆的“下拉按鈕”，選擇添加日曆。<br>步驟3：在彈出的“共用日曆”彈窗中選擇您想要添加的人員的事件日曆。您可以選擇您下級的事件日曆以及共用給您的事件日曆。單擊添加即添加成功。<br>移除添加的日曆<br>單擊其他日曆下方的您想要移除日曆右側的“下拉按鈕”，選擇“移除”。`,
"label.callcenter.Seat.number":``,
"vue_label_commonobjects_view_change_all_selected_records":`更改全部已選記錄`,
"label.user.notinuse":`使用者未啟用，請聯繫管理員`,
"label.usermanage.hasbeen.reached":`已達到許可使用者數的最大數量，請聯繫服務提供商以獲取更多數量的許可！`,
"vue_label_help_list":`列表視圖`,
"label.infomation.edit":`編輯基本訊息`,
"label.ccchat.person.setting.info":``,
"label.sso.isDelete":`是否刪除`,
"label.unique.identification.number":`唯一辨別碼`,
"label.weixin.no.pending.projects":`暫無待審批的項目`,
"label.projectManagement.Pleaseenteramember":`請輸入成員`,
"label.salescloud.salesdashboard.visit":`存取`,
"label.weixin.user.registered":`使用者註冊`,
"message.loginhistory.downloadcsv":`下載最近六個月的登入歷史.(Excel.csv 文件)`,
"label.icon.37":`定位`,
"template.chart.schdyqyx":`行銷活動預期響應`,
"label.tel.ten":`您最多可輸入10個要發送通知的手機號碼，每個手機號碼之間用;"相隔。"`,
"label.data.exp.objdata":`您將按以下條件匯出此物件的數據`,
"label.loginservice.after.use":`後，才可以使用。`,
"pagecreator_systemstyle_message_delete":`是否刪除當前所選樣式？`,
"label.globalselect.deleteerror":`由於該選項列表值集被以下欄位使用，暫時不能刪除。`,
"label.department.add":`添加部門`,
"label.attendance.dingwei":`定位`,
"label.workflow.editrule":`編輯規則`,
"lable.product.pecm":`請輸入正確的金額!`,
"label.icon.182":`公文包`,
"label.help.release.notes":`發佈導覽`,
"UG.product.05":`匯入產品`,
"label.email2":`郵箱`,
"label.weekrepeat":`星期重複`,
"label.mr.descreption.oneGroupReData2":`組`,
"chatter.at.d":`活躍程度`,
"label.mr.descreption.oneGroupReData1":`查重合併進度：共`,
"label.weixin.mobile.fly.android":`Android移動端分享`,
"label.brackets.right":`)右括號`,
"message.recordtype.applytoAllProfiles":`將一個版面配置應用到所有設定檔`,
"label.customcomponent.page.index.tip":`與功能在程式語言中的工作方式類似，自訂組件允許您封裝常見設計模式，然後在一個或多個自訂頁面中重新使用那些模式。`,
"lable.List.properties":`清單屬性`,
"label.fieldinfo":`欄位訊息`,
"label.ems.error.fail":`加載失敗，請重試或聯繫系統管理員進行處理`,
"label_emailsync_form_email":`信箱`,
"lable.currencyManage.button.manageRate":`管理貨幣`,
"component_salesperformance_label_100finish":`已結束`,
"label.knowledgebase.data.assignment.failed":`{a}條資料指派失敗`,
"label.custom.buttonandlink.remark":`選擇模式：現有視窗/新視窗（現有視窗：在當前視窗下打開；新視窗：重新另打開一個新的視窗）`,
"label.list.userinterface.watermark.setup":`浮水印設定`,
"component_timeline_label_7daysahead":`前7天`,
"label.sendemail.chat.replyinchat":`微貼留言：`,
"component.salesperformance.label.title":`銷售績效`,
"label.data.downpage.e.list.desc2":`匯出數據成功後，您會收到一封郵件，提醒您匯出數據成功。`,
"vue_label_campaign_fromclosedopprotunities":`來源{sjcb}個贏單的機會`,
"label.umeng.activity.taskviewed":`您指派給#name的工作被查看`,
"vue_label_salesadvance_retentions":`滯留數`,
"label.fieldtag":`欄位標籤`,
"label.quickbooks.button.searchinquickbooks":`在QuickBooks上搜尋`,
"label.quickbooks.viewlist.action":`操作`,
"label.weixin.sysapp":`系統應用`,
"label.approval.examine.level":`按使用者階層逐級審批，最大的使用者級別至`,
"label.appupload.upload.error":`此應用程式無法安裝。請結束安裝，或修改系統內API後重新安裝！`,
"label.emailtemplate":`郵件範本`,
"front-email-payment-Invoice-amount":``,
"label.viewselectedproducts":`查看已選擇的產品`,
"label.tianyancha.businessverify.openfirst":`請先啟用工商數據驗證`,
"lable.SalesCommitmentKanBan.returnAList":`返回人員列表`,
"label.knowledgebase.nopublished.draft.translations":`沒有已發布或草稿翻譯版本`,
"vue_label_calendar_day_view":`日曆-日視圖`,
"label.globalselect.remark":`全局選項列表值集讓您在物件之間共享值。`,
"label.orderby":`排序方式`,
"lable.weixin.LastaDaysFinished":`過去7天已完成`,
"lable.currencyManage.Enabledadvcurrency.discripation":`您可以將貨幣兌換率匯率對應到特定的日期範圍內的過期匯率。 過期匯率用於機會、產品和這兩個物件相關的報表。過期匯率不可用於其它物件的欄位或其它類型的報表。 例如，1 月 1 日的匯率是 1 USD 等於 6.68 CNY，但 2 月 6 日的匯率更改為 1 USD 等於 6.70 CNY。結束日期在 1 月 1 日到 2 月 6 日期間的業務機會使用的是第一種匯率 (1 = 6.70)。`,
"label.reportsSubscriptionPage.schedulereport.monthly.week.one":`第一個星期`,
"label.leadtoobjectfield":`商機自訂欄位映射`,
"label.dashboardSetup.shujuyuan":`數據源`,
"label.tabpage.userz":`使用者`,
"label.sms.companyname.dsf":`東時方簡訊接口`,
"label.step2.total3":`第2步，共3步`,
"front-gantt-module-Drag-dropt- reorder-tasks":``,
"label.dashboard.snapshot.no.enabled":`未啟用儀表板快照功能`,
"label.dashboard.unit3":`單位：整數單位`,
"label.forecast.shrepage.desc2":`具有共享存取的使用者、角色及區域。`,
"label.commonobjects.new":`建立{eventName}`,
"label.view.nameonlyone":`視圖唯一名稱`,
"label.assignment.setup.newentries.user":`使用者`,
"label.otheremails":`其它電子郵件`,
"component_sendmail_button_send":`發送`,
"vue_label_accountpool":`客戶公海池`,
"label.h5.approval.actortime":`發起時間`,
"message.approval.cannotsubmit":`無法提交待審批`,
"vue_label_pool_createdbyme":`我自建的`,
"label.change.event":`切換到事件視圖`,
"vue_label_homepage_personalpage":`個人主頁`,
"label.new.collect.target":`建立匯總目標`,
"label.ServiceCloud.zichanxuhao":`資產序號`,
"label.product.userl":`用於所有使用者的列`,
"label.syslog":`系統日誌`,
"label.reportcreatestatus":`報表產生狀態`,
"label.datamanage.account.novalue":`注意：本次匯入操作沒有給“客戶名稱”欄位賦值，客戶記錄將不會被匯入！`,
"label.letter.body":`邀請函正文`,
"label.select.please":`請選擇`,
"label.escalation.setup.entrydetail.description":`1.單擊編輯"以更改規則項目屬性<br/>2.單擊"新建"添加升級操作。"`,
"label.component.salesDashboard.nodata":`添加您正在使用的機會，然後返回此處以查看業績。`,
"vue_label_helpcenter_account":`在詳細訊息中，點擊客戶旁邊的樹狀圖按鈕，可以查看客戶階層架構圖，瞭解相關客戶的子母級關係，並查看每個客戶的部分欄位訊息。<br>更改客戶的擁有者時，可以選擇同時更改該客戶相關的機會、個案等訊息的擁有者。`,
"front-kefu-moudle-v1-awshjzx-intelligent":``,
"label.productby":`產生者`,
"label.operation.date":`操作時間`,
"label.name.donot.delete":`名稱不能被移除`,
"label.validate.function.funcFormat.DATETIMEVALUE":`DATETIMEVALUE(date)`,
"label.escalation.setup.entrydetail.howescalationtime":`如何設置升級時間`,
"label.view.step2":`步驟2.指定過濾條件`,
"lable.outlook.edit.notnull":`欄位名不能為空`,
"label.knowledgebase.createnewbrowser":`建立瀏覽器標籤頁`,
"label.partner.all.name":`夥伴雲名稱`,
"chatter.group.groupSetUp":`組設置`,
"label.reportlist.findfolder":`查找文件夾`,
"component.setup.tabs.label.title":`Tab分頁`,
"label.passwordPolicy.setup.pswComplexReq":`密碼複雜性要求`,
"label.emaildocument":`以電子郵件形式發送文檔`,
"message.selectgsummaryconditon":`請選擇匯總條件`,
"component_todaytask_label_notask":`今天沒有到期工作-趁有時間，去喝杯咖啡吧。`,
"label.user.organization.notexists":`組織不存在！`,
"label.isEnableVisualpage.new.leftlist":`可用的自訂頁面`,
"label.mobile.phone.write.week.report":`寫週報`,
"label.emailmerge.edittemplate.edit":`郵件合併範本編輯`,
"template.dashboard.folder.sales.manage":`銷售管理`,
"label.confirm.order.productsToassets":`確定將訂單產品轉資產？`,
"label.service.dispatchingUnits.leftRight.total":`當前{{ left }}-{{ right }}條數據，共{{ totalCount }}條數據`,
"label.import.step1.chooseidorother":`2、可以選擇使用id或名稱相符記錄與填寫查找欄位。若需獲取對應記錄id等訊息，可建立報表，並將記錄名稱與記錄id設定為群組資料欄，再將報表匯出。`,
"label_tabpage_completez":`將選中 狀態標記為完成`,
"chatter.c.adr":`聯繫地址`,
"label.account.d":`此頁允許您定義一個自訂會計季度記錄。自訂會計季度的日期將根據您下面所進行的選擇產生。`,
"label.tag.more50":`最多建立50個標籤`,
"setup.layout.label.areashow":`區功能變數名稱稱顯示位置`,
"label.partnerCloud.basicSetting.rebate":`啟用回饋金`,
"label.tabpage.greaterequalz":`大於或等於`,
"vue.please.select.the.aggregate.basis":`請選擇合計依據`,
"label.form":`表單`,
"label.chatter.colleagues.list.beizhu":`啟用`,
"label.priority":`優先級`,
"vue_label_checkduplicate_set_repeat_rules":`設定重複規則`,
"label.share_form":`分享表單`,
"label_relation_shareholder":`股東與子公司不可以相同`,
"label.project.hit.sixteen":`問題到期提醒`,
"label.service.miniProgram.imageFormat":`上傳圖片只能是 PNG、JPG、JPEG 格式!`,
"label.summary.mode":`匯總方式`,
"vue_label_beforeverification":`驗證前`,
"label.data.newtemplate.desc":`將使用者選中的欄位和條件儲存成範本，若使用者多次重複操作可以直接通過範本匯出。`,
"lable.evaluation.badreview":``,
"label.total.tabs":`共有{0}個{1}`,
"label.emailmerge.mergeFolder.foldertemplate":`此檔夾中的範本`,
"vue_label_normal_notice_repeated":`請勿重複添加`,
"label.icon.140":`數據`,
"label.fromonetoanother":`從一個使用者轉移到另一個使用者`,
"label.user.list":`使用者列表`,
"label.file.prevent.share.operate":`防止其他人員共享和取消共享`,
"label.app.detail":`查看應用程式`,
"label.h5.similar.opportunity.correlation":`相關性`,
"label_emailtocloudcc_filed_username":`信箱使用者名稱`,
"vue_labe_account_shareholdingratio":`客戶服務門戶`,
"label.data.dataexpalltype.all_desc3":`3、匯出成功的數據將產生一個壓縮文件，使用者可以根據郵件中的文件訊息，在匯出成功的文件列表頁面下載您匯出的文件。`,
"label.callcenter.please.select .seatID":``,
"label.remark.length.cannot.than":`描述長度不能超過255`,
"label.batchtransfer.dateandtimetype.tip":`對於日期/時間欄位，採用如下格式輸入值：`,
"label.component.helper.businesschange.0UntreatActivity":`無未處理活動的機會`,
"front-project-module-v1-plase-input-start-time":`請輸入開始日期`,
"label.event.moveup.6hour":`提前 6 小時`,
"label.data.exp.tempexp":`按範本匯出`,
"label.schedulejob.setup.schedule.afternoon":`下午`,
"label.ems.format":`個地理定位欄位`,
"label.objectHasBeenDeleted":`已刪除的物件`,
"label.ServiceCloud.chaxunchenggong":`查詢成功`,
"label.campaign.channel.input.notice.owner":`通知擁有者`,
"label.bajisitan.time":`巴基斯坦時間`,
"label.warnMes":`物件被引用，刪除失敗！`,
"lable.Up.to.ten.fields":`選擇一個物件並新增它的最多10個欄位到表格中。上移或下移箭頭作為列標題出現的欄位。`,
"label.approverule":`審批規則`,
"message.error.specific":`返回具體的錯誤提示`,
"front-template-V1-saveUse":`儲存並預覽`,
"label.uploadfile.success":`成功上傳了`,
"label.tabname.donot.database.key":`選項卡名不能是數據庫關鍵字！`,
"message.recordtype.selectlayout.select":`--選擇版面配置--`,
"front-detail-module-v1-list-cardview":`清單/卡片視圖`,
"label.product.maintenance":`維護`,
"vue_label_helpcenter_approve":`1、待審批項目<br>列出了所有需要您審批的項目。您可以通過審批記錄的開始日期、結束日期、提交人、記錄類型和相關項來搜尋待審批記錄。<br>處理單條記錄：點擊每條記錄的左側按鈕。<br>A.進行審批<br>步驟1: 點擊“進行審批”，打開批准請求頁面<br>步驟2: 點擊“批准”或“拒絕”，完成審批操作。<br>如果審批流程配置中下一個審批步驟需要手動選擇審批人，則“批准”後執行步驟3。<br>步驟3: 選擇下一個審批人，完成審批操作。<br>如果審批流程配置中審批拒絕後需要選擇返回步驟，則“拒絕”後執行步驟4。<br>步驟4: 選擇要返回的審批步驟，完成審批操作。<br>B.重新指派<br>步驟1: 點擊“重新指派”<br>步驟2: 查找重新指派人<br>步驟3: 點擊“重新指派批准請求”，完成重新指派審批人操作。<br>註：如果您是某條記錄的代理審批人，則不能進行重新指派操作。<br>批次處理多條記錄：選擇多條待審批項目後，點擊列表上方的操作按鈕。<br>C.進行審批<br>步驟1: 選擇多條待審批記錄<br>步驟2: 點擊“進行批准”<br>步驟3: 點擊“批准”或“拒絕”，完成審批操作。<br>如果審批流程配置中審批拒絕後需要選擇返回步驟，則“拒絕”後執行步驟4。<br>步驟4: 選擇要返回的審批步驟，完成審批操作。<br>D.重新指派<br>步驟1: 選擇多條待審批記錄<br>步驟2: 點擊“重新指派”<br>步驟3: 查找重新指派人<br>步驟4: 點擊“重新指派批准請求”，完成重新指派審批人操作。<br>2、我提交的項目<br>列出了所有的您提交過的審批項目。可以通過審批記錄的開始日期、結束日期、提交人、記錄類型、相關項和審批狀態來快速搜尋到您要查看到記錄。<br>3、我批准的項目<br>列出了所有的您批准過的審批項目。可以通過審批記錄的開始日期、結束日期、提交人、記錄類型、相關項和審批狀態來快速搜尋到您要查看到記錄。<br>4、我拒絕的項目<br>列出了所有的您審批拒絕過的審批項目。可以通過審批記錄的開始日期、結束日期、提交人、記錄類型、相關項和審批狀態來快速搜尋到您要查看到記錄.`,
"label.knowledgebase.knowledge.article":`知識文章`,
"march":`三月`,
"label.accraditation":`審批`,
"vue_label_pool_cantreach":`聯繫不上客戶`,
"label.service.appointmentList.startOf.maturityPeriod":`到期時段開始`,
"message.huanxin.closed":`聊天功能未啟用`,
"label.implementation.time.operation":`執行定時作業`,
"label.setting.intergrationlist.permissions":`集成權限`,
"label.translation.norecord":`暫無記錄`,
"label.lack.expression":`缺失表達式`,
"setup.layout.message.relatedlistfield":`選擇在相關列表上顯示的欄位，您也可以對選定欄位重新排序。`,
"label.group.file":`小組文件`,
"message.error.id.null":`無此id訊息`,
"label.a_b_least":`每個 A" 記錄必須至少有一個相關 "B" 記錄。"`,
"label.addattachment.step3":`步驟 4.單擊“完成”按鈕，返回上一頁`,
"label.data.exportsf":`匯出成功的文件`,
"label.callcenter.call.out":``,
"front-electronic-export-exportIntro":``,
"label.custombutton.deletedata.notnull":`刪除的數據不能為空`,
"UG.homepage.002":`使用一體化的業務工具來管理您的線索、商機、銷售交易漏斗以及客戶訊息`,
"label.globaloperation":`全局操作`,
"label.icon.58":`工人`,
"vue_label_salesadvance_lostrate":`流失率`,
"chatter.from":`從`,
"front-epwechat-module-v1-account-binding":`帳號綁定`,
"label.list.userinterface.old.page.setup":`舊版介面`,
"label.forecast.settings.periods":`個週期`,
"label.file.share.email.content":`#sharedBy已在#orgname上與您共享了文件`,
"label.knowledge.category.hint.five":`數據分類設定`,
"setup.layout.label.selectedfield":`選擇欄位`,
"label_business_income":`機會收入`,
"vue_label_display_options_field":`顯示選項列表欄位`,
"label.emailtocloudcc.set":`設定信箱訊息`,
"label.knowledge.setting.data.five":`刪除分類：{lbmc}`,
"front-epwechat-module-v1-bound-enterprise":`已綁定企業`,
"label.ccpeak.delete.recycle":`記錄將被刪除到回收桶。`,
"label.leadconvers.tip":`商機無法轉換為客戶、聯絡人、業務機會以及後續任務，只有在確認商機有價值後才能轉換該商機。`,
"label.rsa.key.invalid":`請再次登錄。`,
"label.mobile.bind.success":``,
"label.emailtocloudcc.filed.servertype":`伺服器類型`,
"label.user.new":`新建使用者`,
"label.setup.mobile.homepageshortcuts.remark":`各組織可根據業務場景設定組織級的主頁頂部區域快捷功能配置。`,
"label_emailtocloudcc_select2":`請選擇顯示類型`,
"page.send.email":`發送電子郵件`,
"label.service.newBuildDialog.field.display":`要顯示的欄位`,
"vue_label_homepage_card_impending":`臨近機會`,
"label.message.contactispartner.delete":`有合作夥伴使用者關聯到此聯絡人，無法刪除`,
"label.attendance.checkout":`簽退`,
"label.emailmerge.newtemplate.description":`輸入有關您的郵件合併範本的訊息。請注意，備註僅顯示在cloudcc中，不會顯示在Word中。`,
"laebe.data.exp.success":`匯出成功後您會收到系統郵件提醒，匯出的數據暫時儲存在伺服器上，系統只為您儲存48小時，請儘快到匯出數據列表頁面下載您匯出的數據。`,
"lable.Maximum.number":`模版名稱最長允許50個字元`,
"label.projectManagement.drag.and.drop.existing.tasks":`將一個現有的工作拖放到這個類別`,
"label.forecast.tree.desc":`預測階層架構決定在貴組織中如何累計預測值，以及誰可以查看和調整它們。它根據您的角色階層架構自動產生，但您可能需要添加或編輯經理，銷售代表或者其他使用者。您還可以為個別預測使用者啟用預測共享。`,
"vue_label_chatter_upload_file_type":`已選擇上傳文件類型帖子`,
"front-lightning-module-v1-dashborad-analysis-dimension":`分析維度`,
"vue_label_homepage_custom_homepage":`自訂首頁`,
"label.icon.39":`定位`,
"label.appointmentpage.wizard.notif1":`請先選擇時間`,
"vue_label_report_filterby":`按照{screenCondition}篩選`,
"label.argentina.time":`阿根廷時間`,
"label.role.assign.notremove":`不允許將<b>已選中使用者</b>列表中的使用者移除給<b>所有未指派且已啟用的使用者</b>和<b>所有未指派的使用者</b>兩個選項。`,
"label.sharerule.detailsetshare":`詳細共享規則`,
"label.file.publicview.error1":`文件已刪除或公用連結失效`,
"label.data.downpage.e_title.num4":`4、匯出的文件格式有兩種：CSV格式和壓縮格式。其中壓縮格式分為兩種：一種是自動產生壓縮文件密碼；另一種是手動輸入壓縮文件密碼。`,
"label.knowledge.case.article":``,
"label.data.newtemplate.e.conditions":`匯出條件`,
"front-object-change-owner":``,
"label.newdashboardpage.edittitle":``,
"label.datamove.end.query.no.record":`查詢結束，沒有符合條件的記錄！`,
"lable.SalesCommitmentKanBan.receiptsTarget":`收款目標`,
"label.orderagain":`重新排序`,
"vue_report_dashboard_transfer":`轉移文件夾`,
"label.view.sortview.default":`預設視圖`,
"label.brasilia.time":`巴西利亞時間`,
"label.industrialandcommercialverification.instructions":`啟用工商數據驗證，使用者輸入企業客戶資料時，可協助使用者輸入正確的客戶工商註冊訊息。請註意，此功能當前階段僅支援查詢中國大陸註冊的工商企業數據。`,
"label.chatter":`雲貼`,
"label.sso.goBackToList":`返回列表：密鑰管理`,
"label.mobile.side.tab.state":`啟動自訂側滑欄`,
"label.weixin.addbus":`添加車輛`,
"label.dropbox.description":`連接您的DropBox帳號，以便在CloudCC中使用它。`,
"label.service.newBuildDialog.available.tousers":`使此篩選器對所有使用者可用`,
"label.knowledge.language.thai":`泰語`,
"label.passwordPolicy.setup.foreverlock":`永久(需管理員解鎖)`,
"label.bmap.unreported.location":`您沒有上傳地理位置訊息。請在微信公眾號裡面設置。`,
"label.tag.field":`標籤`,
"label.addyourlanguage":`單擊“添加”可添加您的組織支援的語言。`,
"label.chat.topic.my.use":`我使用的主題`,
"UG.contact.06":`匯入聯絡人`,
"label.embed_code":`嵌入代碼`,
"label.campaign.channel.input.chenben":`3.實際成本:`,
"label.quickbooks.estimates":`估算`,
"label.report.items.i.created":`我建立的報表`,
"label.forecast.edit.fwqd":`範圍起點`,
"label.validate.function.funcExplain.DATEVALUE":`根據輸入的日期/時間欄位（包含年，月，日以及GMT時間），返回一個日期欄位（包含年、月、日）`,
"vue_label_helpcenter_calendar1.1":`事件是確保始終瞭解客戶關係和達成交易的強大工具。您可以將事件與機會、商機、客戶和聯絡人相關聯。日曆視圖主要顯示即事件記錄。<br>1、日曆視圖和列表視圖<br>查看日曆<br>單擊導航選單日曆選項卡即可存取日曆頁面。<br>日曆視圖<br>日曆視圖的分類：日曆視圖分為月視圖、週視圖、日視圖和可用性視圖。通過不同的網格樣式可以分別顯示不同時間範圍的記錄數據。其中可用性視圖顯示包括我的日曆和其他日曆在內的以每一個日曆為維度的日記錄數據。單擊日曆頁面右上方的“日曆按鈕”圖示，即可切換視圖。<br>日曆視圖可查看的內容：日曆包括我的日曆和其他日曆。在日曆視圖上可以查看我的日曆，包括我的事件日曆和物件日曆所有的記錄數據。我們將這些記錄稱為“日曆項目”。 <br>您可以通過日曆視圖查看您擁有的全部事件。您用物件建立的日曆會在日期欄位中將數據作為日曆項目在日曆視圖上顯示。在日曆視圖上還可以查看其他日曆即您可以查看任何您已經添加到視圖的您同事共用的日曆項目。<br>日曆項目顯示規則：日曆項目會顯示在日曆網格中，日曆項目所在的格子區域代表著此條記錄所處的時間範圍。日、週、可用性視圖中會在時間刻度頂部顯示跨度超過24小時的日曆項目。月視圖中一個網格中如果有多個日曆項目，可以點擊“ 更多”查看。日曆項目左或右側邊呈半圓，代表所在格子的前一天或後一天都沒有此記錄。日曆項目左或右側邊呈直角圓，代表所在格子的前一天或後一天還有此記錄。<br>快速定位日曆視圖的日期：您可以通過選擇日曆頁面右側的小日曆上的時間去定位左側日曆視圖顯示的日期範圍。您也可以單擊日曆頁面右上方“<”和“>”圖示快速切換日期。如果您的日曆視圖所處的時間不是當前時間，您可以單擊日曆頁面右上方“今天”圖示快速切換回今天。<br>列表視圖<br>從日曆視圖切換至列表視圖：單擊日曆視圖右上方“日曆”圖示，選擇“表格”，即可切換至事件列表視圖。<br>列表視圖的使用：要同時查看特定事件或多個事件，打開表視圖。列表視圖中有預設的列表視圖，單擊列表視圖左上角“下拉按鈕”圖示，即可展示所有您具有存取權限的列表視圖。您還可以通過自訂事件列表視圖，以滿足您的需求。<br>2、我的日曆和其他日曆<br>我的日曆<br>我的日曆包含我的事件日曆和物件日曆。<br>我的事件日曆：在日曆視圖上顯示被指派人是您的所有事件記錄。我的事件日曆不能移除、編輯或更改顏色。您可以將“我的事件日曆”共用給您的同事。`,
"label.tabpage.rowsz":`刪除行`,
"label.file.library.managemembers.memberlist":`當前成員`,
"label.report.action.addtodashboard4":`添加到現有儀表板`,
"label.chat.send.voice":`發送一個語音`,
"label.home.dashboard.add":`添加主頁儀表板`,
"front-dialog-module-v1-copied-requestid":`已複製請求ID`,
"label.customfields.exportdata":`資料匯出""`,
"label.emailobject.signature":`編輯簽名`,
"label.hide.source":`隱藏原始程式碼`,
"label.icon.71":`維修`,
"vue_label_help_whatslightning":`什麼是Lightning`,
"report.type.label.systemReport":`系統報表`,
"front-kefu-moudle-v1-input-email":`請輸入電子信箱`,
"label.event.moveup.5minutes":`提前 5 分鐘`,
"message.error.postsid.null":``,
"UG.Account.05":`聯絡人架構圖`,
"label_emailtocloudcc_description3":`將您企業的信箱，如sales@company.com, info@company.com, support@company.com添加於此，系統將自動根據所收郵件產生商機或個案記錄，確保及時跟進來信客戶`,
"report.label.searchresult":`搜尋結果`,
"vue_label_report_detailsonly_desc":`僅匯出詳細訊息行。使用此數據，以進行更多計算，或上傳到其他系統。`,
"label.partnerCloud.partnerAccount.payment":`付款金額：`,
"vue_label_commonobjects_view_select_member":`選擇成員`,
"label.emailtocloudcc.step1.lead1":`Email to Lead`,
"label.forecast.settings.current":`當前週期`,
"label.canceluploadfile":`取消上傳`,
"label.manual.shared":`手動共用`,
"label.document.uniquename.length.cannot.than":`文檔唯一名稱長度不能超過255`,
"vue_label_lead_notcreateopportunity":`不建立機會`,
"APPIntegration.Social.twittererror":`必須是一個合法的twitter.com的URL`,
"message.duplication.label.errormessage":`錯誤消息`,
"label.file.img":`圖片`,
"label.tabpage.sum":`共計`,
"label.permission.systempermission.fenpei":`系統權限分配`,
"template.dashboard.folder.data":`資料分析`,
"label.sms.account":`使用者帳號`,
"label.product.filter":`產品篩選器`,
"label.file.content":`正文內容`,
"label.percent":`百分比`,
"label.single.attachment":`單個`,
"label.processsetting.failed.enable.process":`啟用進程失敗！`,
"label.view.modify":`編輯視圖`,
"label.knowledgebase.enter.keywords.filter":`輸入關鍵字進行過濾`,
"label.tabpage.uploadfailez":`上傳失敗，請重新上傳。`,
"label.please.enter.the.target.model.name":`請輸入目標模型名稱`,
"label.layout.availabletab.related":`相關`,
"label.label":`標籤`,
"label.reportsSubscriptionPage.schedulereport.monthly.day.saturday":`星期六`,
"label.addattachment.unit":`位元組`,
"vue_label_commonobjects_view_selected":``,
"label.view.sortview.printble":`可列印`,
"label.umeng.insert.approval.approvaling":``,
"label.forecast.customforecast.tztotal":`調整後總額`,
"label.ccchat.failtoset":`ccchat設定錯誤`,
"label.ccchat.message.new.error2":`的Chat使用者`,
"label.validate.function.category.Advanced":`進階`,
"label.projectManagement.team.members":`團隊成員`,
"vue_label_report_clickcrosstofliter":`單擊上表中的交叉點，以篩選詳細訊息`,
"lable.opppdt.selPdt.leasttwenty":`請至多選擇二十五條`,
"label.campaign.channel.download":`下載高清二維碼`,
"component_event_label_person":`被指派人`,
"vue_label_homepage_new_homepage":`建立主頁`,
"label.version.sum.vlidaterule":`個驗證規則`,
"vue_label_chat_click_for_details":`點擊查看詳情`,
"label.fold":`摺疊`,
"label.readonly":`唯讀`,
"label.h5.similar.opportunity.result":`類似業務機會結果列`,
"label.yourimportsuc":`已處理您的匯入請求，請查看您的電子郵件。`,
"label.report.line.yixuan":`已選報表列`,
"setup_layout_label_areaname":`區域名稱`,
"label.forecast.edit.title":`目標`,
"label.chatter.allweather":`全天候`,
"label.service.ganttBaiduMap.scheduled.endtime":`計劃結束時間`,
"lable.create.new.list":`建立清單`,
"label.emailobject.groupemail.msg3":`{0}個收件人`,
"lable.opppdt.selPdt.description":`輸入關鍵字和篩選條件，然後單擊搜尋"以開始搜尋。單擊"更多篩選器"以使用一個以上的篩選器。搜尋結果包括與所輸入關鍵字和篩選條件匹配的所有記錄。"`,
"label.file.versionerror1":`您可以點擊下面的連結直接切換到新版界面文件選項卡，也可以在手動切換到新版介面後再使用文件選項卡功能`,
"label.under.approve.record":`正在審批的記錄`,
"front-epwechat-module-v1-open":`開啟`,
"label.projectManagement.delete.task":``,
"label.reportforms":`報表`,
"label.tabpage.onlymevisible":``,
"label.customer.tab.please.name":`請輸入選項卡名`,
"label_emailsync_form_stutas":`啟用狀態`,
"message.recordtype.nolist":`未定義記錄類型`,
"label.version.forecasting.sales":`銷售預測`,
"chatter.sel.mostfield":`您可以選擇最多`,
"label.data.derived":`資料匯出`,
"label.component.helper.businesschange.expiredtask":`機會包含逾期工作`,
"label.cycle":`週期`,
"lable.product.standp":`標準價格`,
"label.sendemail.batchapproval":`批次審批操作`,
"message.organization.not.open.mffverification":`所在組織未開啟二次認證`,
"label.icon.131":`雨傘`,
"UG.activity.08":`預約一個日程`,
"label_partner_workspace_member_choicepermission":`選擇權限集`,
"label.reportTypeCategory":`報表類型`,
"label.exporttwotype":`你可以匯出兩種文本`,
"message.oppdt.selectpricebook":`請先選擇價格手冊`,
"vue_label_dashboard_generatefromlistview":`從列表視圖產生`,
"label.quote.title":`標題`,
"label.tianyancha.businessverify.cancel.sure":`取消啟用工商數據驗證後，無法在新建/編輯客戶的時候回填工商註冊訊息，是否確認？`,
"label.save":`儲存`,
"label.mobile.quickcreate.default.appstore":`應用市場`,
"label.partnerCloud.orderingPlatform.configure":`目前還有{a}產品未配置，請配置後再儲存`,
"front-epwechat-module-v1-unbound-role":`未綁定角色`,
"label.partnerCloud.financeSetting.enterAlipay":`請輸入支付寶企業帳戶`,
"label.validate.function.funcExplain.TODAY":`返回當前日期`,
"label.visualpage.parameter.values":`將參數值直接顯示在頁面上：`,
"label.version.task.and.activity":`任務和活動追蹤`,
"label.audit.history":`待審批`,
"setup.object.field.dependency.label.addtolist":`添加選中值`,
"vue_label_report_exportquantity":`匯出數量：`,
"label_tabpage_havez":`有`,
"label.partnerCloud.partnerAccount.amountOfRebate":`可用回饋金金額`,
"label.createralias":`建立人別名`,
"label.created_followup":`建立跟進郵件`,
"label_chatter_mygroups":`我的小組`,
"label.chat.topic.no.display":`沒有可顯示的主題`,
"vue_label_calendar_month_view":`日曆-月視圖`,
"label.service.gantt.resources.assigned.work":`被指派工作的資源`,
"UG_activity_07":`建立一個工作`,
"label.quote.xsjg":`銷售價格`,
"message.toomanyrows":`查詢記錄過多！`,
"label.importsourcestep1":`步驟一：準備好翻譯的文件`,
"vue_label_normal_appointment_sf":`日程預約`,
"lable.list.queue.message":`由於存在屬於佇列的物件記錄，不能刪除該佇列`,
"label.service.major.event.desc":`重大事件表示支援過程中依賴於時間的步驟，可以將重大事件添加到權利過程開始。然後，您可以將過程應用到客戶權利，並從中建立個案或工作訂單。`,
"label.ems.hostorport.null":`伺服器位址與埠號都不能為空`,
"chatter.group.private":`專用`,
"label.icon.192":`肥皂`,
"vue_label_systemSettings_list":`相關列表展示設定`,
"label.activity.saveobj.notnull":`儲存的物件不能為空`,
"vue_label_chatter_current_no_people_approval":`當前沒有需要審批的人員`,
"label.tianyancha.reglocation":`註冊地址`,
"UG_ST_005":`我知道了，不用再顯示此頁面，下次直接進入。`,
"label.vlidaterule.example.truetodisplay":`此消息將在“錯誤條件”公式為<b>真</b>時顯示`,
"label.icon.99":`筆記`,
"label.whenselectmoreapprover":`當選擇多個審批者時`,
"label.forecast.customforecast.directorbest":`直接下屬的超常發揮`,
"label.customsetting.view.introduce":`為您的自訂設置建立欄位。這些欄位中的數據由應用程式放入緩存。`,
"label.there.are.no.unenabled.rules":`還沒有未啟用規則`,
"front-project-module-v1-plase-selectemplat":`請選擇項目範本`,
"label.campaignmember.selectmember.from":`從`,
"setup_layout_button_quicksave":`快速儲存`,
"label.setup.service.report":`服務報告範本設定`,
"label.visualpage.direction.for.use":`平台自訂頁面使用說明[2.0版本]`,
"message.modify":`確定要修改嗎?`,
"label.sms.inside":`內部`,
"label.category.3":`教育`,
"label.login.mfadevice.verification.title":`MFA 設備驗證`,
"UG_Forcast_08":`上一步`,
"label.projectManagement.unable.to.complete":`無法完成`,
"front-kefu-moudle-all-missphone":``,
"font-evaluate-module-v1-emergency":``,
"label.sso.saml.sp.idsource.attr":`身份在屬性元素中`,
"chatter.not.meg":`不能發送空消息`,
"label.chatter.startDate":`開始日期`,
"label.emailobject.track.times":`打開{0}次`,
"label.customsetting.fieldhasbeendeleted":`已刪除的欄位`,
"label.knowledge.setting.hint.thirteen":`添加其他數據分類`,
"message.duplication.label.newfiltertitle":`新建查重過濾器`,
"setup_object_field_dependency_label_selectedfieldvalue":`已選欄位值`,
"vue_label_calendar_who_currently_has_access":`目前誰擁有存取權限`,
"message.passwordPolicy.validate.minlengthe":`個字元`,
"label.emailsync.status.disconnect":`取消關聯`,
"label.applt.down.one":`一鍵下載`,
"label.manageAll.sel.one2":`我提交的項目`,
"message.error.SQLTimeout":`系統繁忙，請稍後重試！`,
"label.global.search.obj.setup":`全局搜尋物件設置`,
"vue_label_commonobjects_view_chat":`群策`,
"vue_label_systemSettings_startSet":`開始設定`,
"label.quickbooks.viewlist.balance":`餘額`,
"message.error.fieldid.null":`fieldid不能為空！文件內容id`,
"label.replaceallnullvalue":`取代所有空值`,
"label.georgia.time":`喬治亞時間`,
"label.hastransfer":`包含已轉換`,
"label.partner.all.description":`描述`,
"font-evaluate-module-v1-following-peopple":``,
"label_business_count":`機會數量`,
"vue_label_ccchat_closedetail":`收起原帖`,
"label.partner.all.disable":`禁用`,
"label.view.relationship":`物件關係`,
"label.noless":`>`,
"label.sendsms.batch.step2":`步驟 2：選擇簡訊範本或自訂簡訊內容`,
"label.stdashbord.xsld.business.jieduan":`階段名稱`,
"label.appupload.component.type.trigger":`觸發器`,
"label.knowledge.setting.data.two":`類別名稱必填`,
"label.color.display.of.completion.rate":`完成率顏色展示`,
"label.loginhis.default":`預設列出最近的200條歷史`,
"vue_label_pricebook_book":`當前價格手冊`,
"label.knowledgebase.data.deletion.failed":`{a}條資料刪除失敗`,
"label_partner_workspace_member_permission":`可選權限集`,
"label.list.userinterface.approval.setup":`審批設置`,
"label.weixin.binding.effect":`binding失效，請重新登錄獲取`,
"label.appupload.install.newapicannotnull":`新的api名稱不能為空`,
"chatter.feed.menutype.feed.company":`所有微貼`,
"label.assignment.setup.detail.email":`電子郵件`,
"label_tabpage_selectcontentz":`請選擇內容`,
"template.report.converted.leads.campaign":`行銷活動中已轉換的商機`,
"label.forecast.season":`本季`,
"label.post":`帖子`,
"label.knowledge.setting.hint.fifteen":`基礎已奠定。現在，您和您的團隊可以撰寫和組織 Knowledge 文章。`,
"front-kefu-moudle-v1-Seats-name":`工作人員暱稱`,
"label.weixin.leadname":`商機名稱`,
"label.account.quarter":``,
"label.detail.field":`查看欄位`,
"label.icon.189":`化妝品`,
"label.appointment.disable.reappointment":``,
"label.appointmentconfirmpage.wizard.subtitle1":`事件名稱`,
"label.campaign.channel.step6.remark3":`系統將為員工產生唯一邀約碼，員工可使用此碼進行邀約，並可計入個人績效`,
"System.AddressFieldType.Post":`郵遞區號`,
"label_partner_new_step2":`步驟2：確認範本`,
"vue_label_helpcenter_file":`查看與管理您的文件<br>使用新版本的文件物件，查看與管理由您所有的，或是他人共用的文件。可以線上預覽部分格式的文件。<br>文件庫<br>使用文件庫功能，建立團隊知識庫，設立不同管理員與成員，便捷管理；利用文件夾功能，將文件進行歸納分類。`,
"label.locateddowncurrentvalue":`位於當前值的下方的值`,
"label.tianyancha.businessverify.msg5":`二：服務可靠性：`,
"label.setup.mobile.bottombutton.change.success":`修改成功`,
"label.appointmentconfirmail.wizard.subtitle2":`時間`,
"label.email.address.lookup":`查找電子郵件地址`,
"setup.mainpage.label.welcome":`歡迎進入 CloudCC PaaS 平臺，平臺主體功能如下。`,
"label.icon.55":`推土機`,
"label_tabpage_enterrecordnamez":`請輸入記錄擁有者`,
"label.tabpage.andz":`與`,
"label.selectfiletoimport":`選擇將要匯入的文件`,
"label.version.sum.trigger":`個觸發器`,
"label.multi.layout":`行式配置`,
"pagecreator.button.back":`上一步`,
"label.imgfield.truetype":`請上傳正確的圖片類型`,
"front-kefu-moudle-v1-publicKey":``,
"label.data.exp.newtemp":`範本製作`,
"label.martrixreport.2018.step4.new":`步驟4：選擇報表列`,
"label.sendemail.chat.addComentsatsubject":`CloudCC CCChat 留言裡提及我`,
"vue_label_applauncher_description_leadpool":`使用商機公海池，便捷管理組織內的商機跟進狀態，激勵人員完成成交。`,
"label.knowledgebase.archive.published.articles.without.drafts":`您僅可以歸檔沒有草稿的已發布文章。`,
"label.projectManagement.bar.chart":`長條圖`,
"label.ccpeak.condition.return.sort":`按條件返回並排序。`,
"label.salescloud.opportunity.contactrole":`?機會聯絡人角色`,
"label.language":`語言`,
"message.error.view.badprevilege":`對不起，您沒有被授權此服務，請聯繫系統管理員！`,
"label.textmessage.managetemplates":`管理範本`,
"message.error.type.null":`類型不能為空！`,
"setup.mainpage.label.welcome9":`使用者無需代碼開發的情況下，通過滑鼠拖曳的方式，便可實現所有頁面元素的分類顯示、配置調整。以及對頁面上欄位的唯讀、必填等屬性的設定。`,
"label.appupload.component.type.page":`自訂頁面`,
"label.textmessage.bookschedule":`請點擊下方連結查看並預約我的行程：`,
"component_chatter_post_button_save":`發表`,
"lable.oppt.jieduan.signcomplete":`將階段標記為完成`,
"label.help.notes":`幫助和導覽`,
"label_tabpage_reallproplez":`記錄擁有者`,
"label.obtain.authorization.failure":`授權碼獲取失敗，請重新授權`,
"label.account.FiscalQuarter":`會計季度`,
"label.customsetting.savecustomvalue":`已存在針對該位置的數據，請修改後重新儲存`,
"label.maximum":`最大值`,
"component_chatter_file_label_maxsize":`文件最大為20M`,
"c218":``,
"c875":``,
"c183":``,
"c366":``,
"c91":``,
"c184":``,
"c750":``,
"c1016":``,
"c619":``,
"c69":``,
"c675":``,
"c533":``,
"c167":``,
"c682":``,
"c960":``,
"c1033":``,
"c850":``,
"c343":``,
"c1007":``,
"c8":``,
"c157":``,
"c1039":``,
"c397":``,
"c556":``,
"c563":``,
"c179":``,
"c147":``,
"c303":``,
"c885":``,
"c1012":``,
"c808":``,
"c718":``,
"c414":``,
"c9":``,
"c15":``,
"c59":``,
"c504":``,
"c836":``,
"c187":``,
"c208":``,
"c952":``,
"c104":``,
"c346":``,
"c913":``,
"c571":``,
"c44":``,
"label.social.posts.content.null":``,
"c852":``,
"c561":``,
"obtain.contract.envelopeid.fail":``,
"c465":``,
"c982":``,
"c350":``,
"c352":``,
"c670":``,
"front-electronic-signature-given":``,
"c542":``,
"c314":``,
"c148":``,
"c47":``,
"c754":``,
"c326":``,
"c289":``,
"c196":``,
"c63":``,
"c769":``,
"c216":``,
"c842":``,
"c389":``,
"c7":``,
"c981":``,
"c143":``,
"c930":``,
"c515":``,
"c393":``,
"c357":``,
"c597":``,
"front-electronic-signature-cancelIntro1":``,
"c271":``,
"label.gaode.map.cannot.work.normally.please.check.whether.the.secret.key.is.correct":``,
"c424":``,
"c995":``,
"c711":``,
"c197":``,
"front-electronic-signature-save-success":``,
"c765":``,
"c286":``,
"c145":``,
"c264":``,
"label.china":``,
"label.no.bind.mobile":``,
"c95":``,
"front-electronic-signature-open-signInfo1":``,
"c391":``,
"c106":``,
"c519":``,
"c528":``,
"c1000":``,
"c78":``,
"c983":``,
"c41":``,
"c517":``,
"c774":``,
"c296":``,
"c996":``,
"c757":``,
"front-electronic-signature-confirmintro":``,
"c1006":``,
"c446":``,
"c238":``,
"c980":``,
"c802":``,
"c387":``,
"c965":``,
"c480":``,
"c937":``,
"c632":``,
"c131":``,
"c680":``,
"c806":``,
"c649":``,
"c797":``,
"c616":``,
"c987":``,
"c169":``,
"c21":``,
"c231":``,
"c1009":``,
"c555":``,
"c583":``,
"front-electronic-signature-open-signInfo2":``,
"c822":``,
"c600":``,
"c442":``,
"c762":``,
"label.user.not.permission":``,
"c35":``,
"c921":``,
"c305":``,
"c730":``,
"c525":``,
"c942":``,
"c780":``,
"c447":``,
"c369":``,
"c702":``,
"c22":``,
"c79":``,
"c785":``,
"label.insert.approval.reassign.error":``,
"c998":``,
"c273":``,
"c3":``,
"c448":``,
"c495":``,
"c429":``,
"c16":``,
"c128":``,
"c955":``,
"c716":``,
"c638":``,
"c746":``,
"c534":``,
"c948":``,
"c317":``,
"c426":``,
"c457":``,
"c263":``,
"c372":``,
"c907":``,
"c771":``,
"c408":``,
"c12":``,
"c379":``,
"c410":``,
"c510":``,
"c701":``,
"c617":``,
"c213":``,
"c473":``,
"c975":``,
"c168":``,
"c121":``,
"label.send.invoice":``,
"c792":``,
"c686":``,
"c652":``,
"c136":``,
"c662":``,
"label.invoice.customer.is.error":``,
"c580":``,
"c894":``,
"c570":``,
"c133":``,
"c564":``,
"c854":``,
"c775":``,
"c105":``,
"c729":``,
"c491":``,
"c609":``,
"c611":``,
"c843":``,
"c933":``,
"c383":``,
"c186":``,
"c608":``,
"c149":``,
"c1028":``,
"c486":``,
"c598":``,
"c726":``,
"c645":``,
"label.verificationCode.is.invalid":``,
"c904":``,
"c594":``,
"c103":``,
"c188":``,
"c891":``,
"c902":``,
"c484":``,
"c421":``,
"c406":``,
"c739":``,
"c329":``,
"c1011":``,
"c351":``,
"c622":``,
"2":``,
"c463":``,
"c268":``,
"label.mobile.no.letter.blankcharacter":``,
"c438":``,
"c581":``,
"c953":``,
"c90":``,
"c2":``,
"c897":``,
"c444":``,
"c242":``,
"c135":``,
"c659":``,
"c773":``,
"c11":``,
"c799":``,
"c1014":``,
"c880":``,
"c890":``,
"c846":``,
"front-electronic-signature-sucessSign":``,
"c472":``,
"c963":``,
"c390":``,
"c248":``,
"c646":``,
"c308":``,
"c858":``,
"c152":``,
"c316":``,
"c435":``,
"c1053":``,
"c362":``,
"c800":``,
"c415":``,
"c735":``,
"c903":``,
"c1023":``,
"label.insert.approval.massreassign.error":``,
"c354":``,
"c409":``,
"c651":``,
"c582":``,
"c994":``,
"c826":``,
"c781":``,
"c873":``,
"c837":``,
"label.diedirect.sale":``,
"c798":``,
"c368":``,
"c770":``,
"c882":``,
"front-setting-dialog-title-two":``,
"c535":``,
"front-electronic-signature-look-account":``,
"c19":``,
"c52":``,
"c388":``,
"c18":``,
"c820":``,
"c285":``,
"c478":``,
"c164":``,
"label.tip.excess.quota":``,
"c318":``,
"c698":``,
"c312":``,
"c110":``,
"c549":``,
"c845":``,
"c282":``,
"c270":``,
"c288":``,
"c878":``,
"c324":``,
"c129":``,
"c339":``,
"c405":``,
"c848":``,
"c345":``,
"c591":``,
"c180":``,
"c126":``,
"c311":``,
"c587":``,
"c37":``,
"c840":``,
"c241":``,
"c141":``,
"obtain.contract.fail":``,
"c945":``,
"c454":``,
"c34":``,
"c243":``,
"c548":``,
"c807":``,
"c590":``,
"c831":``,
"c198":``,
"c977":``,
"c66":``,
"label.twitter.title.setting":``,
"c922":``,
"front-email-payment-Invoice-Tips":``,
"c605":``,
"c403":``,
"c156":``,
"c635":``,
"c753":``,
"c1042":``,
"c1036":``,
"c647":``,
"c295":``,
"c915":``,
"front-electronic-signature-signStatus":``,
"c568":``,
"c1051":``,
"c744":``,
"c464":``,
"c385":``,
"c392":``,
"c418":``,
"c256":``,
"c690":``,
"c261":``,
"c62":``,
"c892":``,
"c909":``,
"c883":``,
"c134":``,
"c896":``,
"c974":``,
"c209":``,
"c185":``,
"c796":``,
"c60":``,
"c991":``,
"c866":``,
"c666":``,
"c219":``,
"c732":``,
"c1048":``,
"c155":``,
"c511":``,
"c240":``,
"c1024":``,
"c468":``,
"c961":``,
"c404":``,
"c586":``,
"c694":``,
"c1025":``,
"c297":``,
"c860":``,
"c58":``,
"c920":``,
"c27":``,
"c94":``,
"c1":``,
"c557":``,
"c294":``,
"c970":``,
"c565":``,
"c668":``,
"c972":``,
"c660":``,
"c433":``,
"c443":``,
"c275":``,
"c691":``,
"c956":``,
"c910":``,
"c692":``,
"c355":``,
"c122":``,
"c395":``,
"c689":``,
"c344":``,
"c656":``,
"c943":``,
"front-electronic-signature-outerSinger":``,
"front-generate-v1-invoiceDetail":``,
"front-electronic-signature-open-vertify":``,
"c291":``,
"front-setting-phone-message":``,
"c559":``,
"c990":``,
"label.google.map.cannot.work.normally.please.check.whether.the.secret.key.is.correct":``,
"c259":``,
"c488":``,
"c6":``,
"front-electronic-signature-signerInfo":``,
"c512":``,
"c507":``,
"c760":``,
"c756":``,
"c321":``,
"c817":``,
"c949":``,
"label.biaoqing.field.relation.tip":``,
"c382":``,
"c265":``,
"c417":``,
"c847":``,
"c494":``,
"c86":``,
"c776":``,
"c709":``,
"label.mobile.orVerificationCode.is.error":``,
"c579":``,
"c1037":``,
"c413":``,
"c950":``,
"c573":``,
"label.choose.is.tax":``,
"c768":``,
"c604":``,
"c160":``,
"c239":``,
"c988":``,
"c834":``,
"c113":``,
"c146":``,
"c313":``,
"c140":``,
"c298":``,
"c681":``,
"c870":``,
"c551":``,
"c88":``,
"c175":``,
"c64":``,
"c319":``,
"label.pay.online":``,
"c941":``,
"c550":``,
"c365":``,
"c908":``,
"c260":``,
"c50":``,
"c869":``,
"c93":``,
"c280":``,
"c23":``,
"front-console-v1-see-contacts":``,
"c607":``,
"c229":``,
"front-filter-v1-filter-by-name":``,
"c125":``,
"c513":``,
"c80":``,
"c648":``,
"c521":``,
"c560":``,
"c973":``,
"c509":``,
"c685":``,
"c178":``,
"c1003":``,
"c436":``,
"front-electronic-signature-prepareTemplate":``,
"c749":``,
"c114":``,
"c898":``,
"c279":``,
"c232":``,
"c911":``,
"c901":``,
"c663":``,
"c541":``,
"c536":``,
"front-project-v1-batch-deletion-confirmation-information":``,
"c893":``,
"c623":``,
"c493":``,
"c327":``,
"c747":``,
"c728":``,
"front-reportlist-v1-optimizedReport":``,
"c741":``,
"c643":``,
"c537":``,
"front-electronic-signature-add-field":``,
"c626":``,
"c199":``,
"c917":``,
"c159":``,
"c640":``,
"c1001":``,
"c192":``,
"c978":``,
"c969":``,
"c871":``,
"c814":``,
"c235":``,
"c215":``,
"c425":``,
"c182":``,
"c194":``,
"c657":``,
"c855":``,
"c333":``,
"c1043":``,
"c338":``,
"c431":``,
"c374":``,
"c506":``,
"font-trade-module-invoice-totalMoney":``,
"c203":``,
"c962":``,
"c786":``,
"c469":``,
"c137":``,
"c993":``,
"c483":``,
"c947":``,
"c190":``,
"c386":``,
"c803":``,
"c759":``,
"c823":``,
"c422":``,
"c782":``,
"c416":``,
"c758":``,
"c407":``,
"c51":``,
"c844":``,
"c361":``,
"c602":``,
"c191":``,
"c299":``,
"c432":``,
"c650":``,
"c1038":``,
"c531":``,
"c13":``,
"c162":``,
"c1045":``,
"c992":``,
"c171":``,
"c230":``,
"c470":``,
"c367":``,
"c26":``,
"c989":``,
"c705":``,
"c613":``,
"front-electronic-signature-openSign":``,
"c349":``,
"c683":``,
"c679":``,
"c914":``,
"c224":``,
"c220":``,
"c498":``,
"c566":``,
"front-electronic-signature-ContractTemplate":``,
"c540":``,
"c793":``,
"c293":``,
"front-invoice-online-pay-again":``,
"front-electronic-signature-open-password":``,
"front-v1-partner-background-tooltip":``,
"c449":``,
"c30":``,
"c245":``,
"c923":``,
"c24":``,
"c872":``,
"c886":``,
"c485":``,
"c101":``,
"c816":``,
"c445":``,
"c1046":``,
"c1004":``,
"c1035":``,
"c853":``,
"c398":``,
"c522":``,
"c287":``,
"c578":``,
"c40":``,
"c631":``,
"c489":``,
"c819":``,
"c935":``,
"c625":``,
"c471":``,
"front-electronic-signature-writen":``,
"c1015":``,
"c889":``,
"c201":``,
"c467":``,
"label.mobile.no.null":``,
"c307":``,
"c1019":``,
"front-kefu-moudle-wait-calling":``,
"c784":``,
"c490":``,
"c790":``,
"c336":``,
"c453":``,
"c1013":``,
"c530":``,
"c610":``,
"c359":``,
"c193":``,
"label.mobile.verificationCode.exceeded.times":``,
"c138":``,
"c821":``,
"c381":``,
"c761":``,
"c964":``,
"c585":``,
"c500":``,
"c214":``,
"c714":``,
"c1044":``,
"c552":``,
"c684":``,
"c54":``,
"c320":``,
"c1008":``,
"c236":``,
"c123":``,
"c654":``,
"c335":``,
"c267":``,
"c226":``,
"c102":``,
"c637":``,
"c633":``,
"c777":``,
"c223":``,
"c592":``,
"c315":``,
"c89":``,
"c108":``,
"c402":``,
"c748":``,
"c501":``,
"c269":``,
"front-electronic-signature-open-confirm":``,
"c584":``,
"c437":``,
"c738":``,
"c274":``,
"c83":``,
"c206":``,
"c309":``,
"c539":``,
"c304":``,
"c151":``,
"c639":``,
"c720":``,
"c801":``,
"c900":``,
"c695":``,
"c864":``,
"c881":``,
"c794":``,
"c543":``,
"c466":``,
"c867":``,
"c529":``,
"c742":``,
"c430":``,
"c553":``,
"c575":``,
"c124":``,
"c629":``,
"c554":``,
"c547":``,
"c599":``,
"c588":``,
"c703":``,
"c1031":``,
"c713":``,
"c142":``,
"c153":``,
"c253":``,
"c612":``,
"c400":``,
"c671":``,
"c20":``,
"c514":``,
"c946":``,
"c717":``,
"c174":``,
"c940":``,
"c743":``,
"c441":``,
"c423":``,
"c723":``,
"c664":``,
"c859":``,
"c356":``,
"c221":``,
"front-email-payment-Invoice-Tips1":``,
"c99":``,
"c278":``,
"c364":``,
"c572":``,
"c310":``,
"c247":``,
"c158":``,
"c325":``,
"c985":``,
"c877":``,
"front-filter-v1-press":``,
"c505":``,
"c523":``,
"c727":``,
"front-electronic-signature-sended":``,
"c150":``,
"c700":``,
"c824":``,
"c710":``,
"c358":``,
"c544":``,
"c212":``,
"c165":``,
"c932":``,
"c888":``,
"c838":``,
"c98":``,
"c830":``,
"c661":``,
"c818":``,
"c861":``,
"c736":``,
"c204":``,
"c1049":``,
"c839":``,
"c456":``,
"c341":``,
"c724":``,
"c1017":``,
"c865":``,
"c332":``,
"c520":``,
"c906":``,
"c482":``,
"c49":``,
"c725":``,
"c76":``,
"c558":``,
"c876":``,
"front-invoices-v1-nofilles-tocreate":``,
"c779":``,
"c603":``,
"c455":``,
"c428":``,
"c55":``,
"c899":``,
"label.facebook.title":``,
"c487":``,
"label.social.posts.info":``,
"c704":``,
"c1005":``,
"c673":``,
"front-electronic-signature-singed":``,
"c722":``,
"c595":``,
"c120":``,
"c68":``,
"c479":``,
"front-electronic-signature-explain-mainTitle":``,
"c5":``,
"c1022":``,
"c976":``,
"c812":``,
"c532":``,
"c330":``,
"c249":``,
"c630":``,
"c958":``,
"c170":``,
"c810":``,
"c783":``,
"c968":``,
"c752":``,
"c1040":``,
"c439":``,
"c1002":``,
"c67":``,
"front-generate-v1-invoice":``,
"c477":``,
"c966":``,
"c764":``,
"c301":``,
"c1027":``,
"c61":``,
"c815":``,
"c827":``,
"c688":``,
"c33":``,
"c217":``,
"c721":``,
"c284":``,
"c939":``,
"c503":``,
"c492":``,
"c73":``,
"label.the.peoples.republic.of.china":``,
"c828":``,
"c36":``,
"c954":``,
"front-electronic-signature-innerSinger":``,
"c508":``,
"c833":``,
"c207":``,
"c31":``,
"c71":``,
"c373":``,
"c545":``,
"c77":``,
"label.lastcompiledate":``,
"c119":``,
"c1047":``,
"c281":``,
"c715":``,
"c127":``,
"c283":``,
"c919":``,
"c82":``,
"front-file-delete-intro":``,
"c606":``,
"c905":``,
"c644":``,
"c75":``,
"c1026":``,
"c884":``,
"c538":``,
"c322":``,
"c461":``,
"c825":``,
"c56":``,
"c931":``,
"c276":``,
"c334":``,
"c733":``,
"c384":``,
"c139":``,
"c957":``,
"front-electronic-signature-nosign":``,
"c1050":``,
"c419":``,
"c934":``,
"c1020":``,
"c677":``,
"c593":``,
"c272":``,
"c811":``,
"c451":``,
"c277":``,
"c244":``,
"c627":``,
"c601":``,
"c251":``,
"c202":``,
"font-social-prohibit-create":``,
"c394":``,
"c323":``,
"front-setting-dialog-title-one":``,
"front-electronic-signature-cancelIntro2":``,
"c353":``,
"c621":``,
"front-v1-partner-image-tooltip":``,
"c772":``,
"c1018":``,
"c734":``,
"c380":``,
"c979":``,
"c233":``,
"c458":``,
"c697":``,
"c476":``,
"c634":``,
"c144":``,
"c1032":``,
"c474":``,
"c371":``,
"c420":``,
"c620":``,
"c708":``,
"c100":``,
"c576":``,
"c751":``,
"c252":``,
"c699":``,
"c74":``,
"c805":``,
"c452":``,
"c740":``,
"c596":``,
"c832":``,
"c971":``,
"c262":``,
"c363":``,
"label.singleSignOn.is.invalid":``,
"c72":``,
"c292":``,
"c499":``,
"c574":``,
"c618":``,
"front-setting-phone-format":``,
"c460":``,
"c189":``,
"label.exe.supported.request.rejected":``,
"c835":``,
"c655":``,
"c45":``,
"c43":``,
"c481":``,
"c674":``,
"c266":``,
"c967":``,
"c1010":``,
"c154":``,
"c841":``,
"c615":``,
"c84":``,
"c401":``,
"c290":``,
"c205":``,
"c928":``,
"c195":``,
"1":``,
"c46":``,
"c459":``,
"c250":``,
"c399":``,
"c1034":``,
"c518":``,
"c396":``,
"c300":``,
"c789":``,
"c874":``,
"c38":``,
"c228":``,
"c342":``,
"c879":``,
"c173":``,
"c778":``,
"c211":``,
"c496":``,
"c427":``,
"c851":``,
"c32":``,
"c28":``,
"c163":``,
"c225":``,
"c569":``,
"c92":``,
"c412":``,
"c81":``,
"c999":``,
"c653":``,
"c516":``,
"c918":``,
"c809":``,
"c181":``,
"c745":``,
"c669":``,
"c929":``,
"c117":``,
"c938":``,
"c112":``,
"c347":``,
"c795":``,
"c17":``,
"c787":``,
"c829":``,
"c1041":``,
"c161":``,
"c65":``,
"c665":``,
"c767":``,
"c87":``,
"c589":``,
"front-electronic-signature-newTime":``,
"c813":``,
"c85":``,
"c951":``,
"c29":``,
"c210":``,
"c39":``,
"c672":``,
"c97":``,
"c687":``,
"c916":``,
"c475":``,
"c628":``,
"c788":``,
"c1030":``,
"c177":``,
"c856":``,
"c70":``,
"c546":``,
"c331":``,
"label.order.paidamount.greater.than.total":``,
"c524":``,
"c246":``,
"c986":``,
"label.parameter.is.incorrect":``,
"c667":``,
"c737":``,
"c48":``,
"c111":``,
"c755":``,
"c526":``,
"c450":``,
"front-electronic-export-reChoseChimp":``,
"label.invoice.paidamount.greater.than.total":``,
"c222":``,
"c849":``,
"c678":``,
"c502":``,
"c1052":``,
"c497":``,
"c200":``,
"c658":``,
"c434":``,
"c641":``,
"c944":``,
"c411":``,
"c624":``,
"label.twitter.title":``,
"c791":``,
"c306":``,
"c14":``,
"c176":``,
"c997":``,
"c166":``,
"c731":``,
"c237":``,
"c887":``,
"c227":``,
"c257":``,
"c712":``,
"c107":``,
"c370":``,
"c895":``,
"c1029":``,
"c693":``,
"c763":``,
"c302":``,
"c577":``,
"c258":``,
"c676":``,
"c868":``,
"c53":``,
"c527":``,
"c984":``,
"c1021":``,
"label.facebook.title.setting":``,
"c340":``,
"c706":``,
"label.mobile.used":``,
"c328":``,
"c337":``,
"c642":``
}